var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var style = "";
/**
 * @license
 * Copyright 2010-2021 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = "129";
const MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const FlatShading = 1;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const UVMapping$1 = 300;
const CubeReflectionMapping$1 = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const CubeUVRefractionMapping = 307;
const RepeatWrapping$1 = 1e3;
const ClampToEdgeWrapping$1 = 1001;
const MirroredRepeatWrapping$1 = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const LinearFilter$1 = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipmapLinearFilter$1 = 1008;
const UnsignedByteType$1 = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedShort565Type = 1019;
const UnsignedInt248Type = 1020;
const AlphaFormat = 1021;
const RGBFormat$1 = 1022;
const RGBAFormat$1 = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBIntegerFormat = 1032;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const SRGB8_ALPHA8_ASTC_4x4_Format = 37840;
const SRGB8_ALPHA8_ASTC_5x4_Format = 37841;
const SRGB8_ALPHA8_ASTC_5x5_Format = 37842;
const SRGB8_ALPHA8_ASTC_6x5_Format = 37843;
const SRGB8_ALPHA8_ASTC_6x6_Format = 37844;
const SRGB8_ALPHA8_ASTC_8x5_Format = 37845;
const SRGB8_ALPHA8_ASTC_8x6_Format = 37846;
const SRGB8_ALPHA8_ASTC_8x8_Format = 37847;
const SRGB8_ALPHA8_ASTC_10x5_Format = 37848;
const SRGB8_ALPHA8_ASTC_10x6_Format = 37849;
const SRGB8_ALPHA8_ASTC_10x8_Format = 37850;
const SRGB8_ALPHA8_ASTC_10x10_Format = 37851;
const SRGB8_ALPHA8_ASTC_12x10_Format = 37852;
const SRGB8_ALPHA8_ASTC_12x12_Format = 37853;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const LinearEncoding$1 = 3e3;
const sRGBEncoding = 3001;
const GammaEncoding = 3007;
const RGBEEncoding = 3002;
const LogLuvEncoding = 3003;
const RGBM7Encoding = 3004;
const RGBM16Encoding = 3005;
const RGBDEncoding = 3006;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const KeepStencilOp = 7680;
const AlwaysStencilFunc = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const GLSL3 = "300 es";
class EventDispatcher$1 {
  addEventListener(type, listener) {
    if (this._listeners === void 0)
      this._listeners = {};
    const listeners = this._listeners;
    if (listeners[type] === void 0) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }
  hasEventListener(type, listener) {
    if (this._listeners === void 0)
      return false;
    const listeners = this._listeners;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  removeEventListener(type, listener) {
    if (this._listeners === void 0)
      return;
    const listeners = this._listeners;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index = listenerArray.indexOf(listener);
      if (index !== -1) {
        listenerArray.splice(index, 1);
      }
    }
  }
  dispatchEvent(event) {
    if (this._listeners === void 0)
      return;
    const listeners = this._listeners;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i = 0, l = array.length; i < l; i++) {
        array[i].call(this, event);
      }
      event.target = null;
    }
  }
}
const _lut$1 = [];
for (let i = 0; i < 256; i++) {
  _lut$1[i] = (i < 16 ? "0" : "") + i.toString(16);
}
let _seed = 1234567;
const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
function generateUUID$1() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut$1[d0 & 255] + _lut$1[d0 >> 8 & 255] + _lut$1[d0 >> 16 & 255] + _lut$1[d0 >> 24 & 255] + "-" + _lut$1[d1 & 255] + _lut$1[d1 >> 8 & 255] + "-" + _lut$1[d1 >> 16 & 15 | 64] + _lut$1[d1 >> 24 & 255] + "-" + _lut$1[d2 & 63 | 128] + _lut$1[d2 >> 8 & 255] + "-" + _lut$1[d2 >> 16 & 255] + _lut$1[d2 >> 24 & 255] + _lut$1[d3 & 255] + _lut$1[d3 >> 8 & 255] + _lut$1[d3 >> 16 & 255] + _lut$1[d3 >> 24 & 255];
  return uuid.toUpperCase();
}
function clamp$1(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function euclideanModulo(n, m) {
  return (n % m + m) % m;
}
function mapLinear(x, a1, a2, b1, b2) {
  return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
function inverseLerp(x, y, value) {
  if (x !== y) {
    return (value - x) / (y - x);
  } else {
    return 0;
  }
}
function lerp$1(x, y, t) {
  return (1 - t) * x + t * y;
}
function damp(x, y, lambda, dt) {
  return lerp$1(x, y, 1 - Math.exp(-lambda * dt));
}
function pingpong(x, length = 1) {
  return length - Math.abs(euclideanModulo(x, length * 2) - length);
}
function smoothstep(x, min, max) {
  if (x <= min)
    return 0;
  if (x >= max)
    return 1;
  x = (x - min) / (max - min);
  return x * x * (3 - 2 * x);
}
function smootherstep(x, min, max) {
  if (x <= min)
    return 0;
  if (x >= max)
    return 1;
  x = (x - min) / (max - min);
  return x * x * x * (x * (x * 6 - 15) + 10);
}
function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
}
function randFloat(low, high) {
  return low + Math.random() * (high - low);
}
function randFloatSpread(range) {
  return range * (0.5 - Math.random());
}
function seededRandom(s) {
  if (s !== void 0)
    _seed = s % 2147483647;
  _seed = _seed * 16807 % 2147483647;
  return (_seed - 1) / 2147483646;
}
function degToRad(degrees) {
  return degrees * DEG2RAD;
}
function radToDeg(radians) {
  return radians * RAD2DEG;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function setQuaternionFromProperEuler(q, a, b, c, order) {
  const cos = Math.cos;
  const sin = Math.sin;
  const c2 = cos(b / 2);
  const s2 = sin(b / 2);
  const c13 = cos((a + c) / 2);
  const s13 = sin((a + c) / 2);
  const c1_3 = cos((a - c) / 2);
  const s1_3 = sin((a - c) / 2);
  const c3_1 = cos((c - a) / 2);
  const s3_1 = sin((c - a) / 2);
  switch (order) {
    case "XYX":
      q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
      break;
    case "YZY":
      q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
      break;
    case "ZXZ":
      q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
      break;
    case "XZX":
      q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
      break;
    case "YXY":
      q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
      break;
    case "ZYZ":
      q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
  }
}
var MathUtils = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DEG2RAD,
  RAD2DEG,
  generateUUID: generateUUID$1,
  clamp: clamp$1,
  euclideanModulo,
  mapLinear,
  inverseLerp,
  lerp: lerp$1,
  damp,
  pingpong,
  smoothstep,
  smootherstep,
  randInt,
  randFloat,
  randFloatSpread,
  seededRandom,
  degToRad,
  radToDeg,
  isPowerOfTwo,
  ceilPowerOfTwo,
  floorPowerOfTwo,
  setQuaternionFromProperEuler
});
class Vector2$1 {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  set(x, y) {
    this.x = x;
    this.y = y;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    return this;
  }
  addScalar(s) {
    this.x += s;
    this.y += s;
    return this;
  }
  addVectors(a, b) {
    this.x = a.x + b.x;
    this.y = a.y + b.y;
    return this;
  }
  addScaledVector(v, s) {
    this.x += v.x * s;
    this.y += v.y * s;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    return this;
  }
  subScalar(s) {
    this.x -= s;
    this.y -= s;
    return this;
  }
  subVectors(a, b) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y;
    const e = m.elements;
    this.x = e[0] * x + e[3] * y + e[6];
    this.y = e[1] * x + e[4] * y + e[7];
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    return this;
  }
  clamp(min, max) {
    this.x = Math.max(min.x, Math.min(max.x, this.x));
    this.y = Math.max(min.y, Math.min(max.y, this.y));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    return this;
  }
  clampLength(min, max) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y;
  }
  cross(v) {
    return this.x * v.y - this.y * v.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    const angle = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle;
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y;
    return dx * dx + dy * dy;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    return array;
  }
  fromBufferAttribute(attribute, index, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    return this;
  }
  rotateAround(center, angle) {
    const c = Math.cos(angle), s = Math.sin(angle);
    const x = this.x - center.x;
    const y = this.y - center.y;
    this.x = x * c - y * s + center.x;
    this.y = x * s + y * c + center.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
}
Vector2$1.prototype.isVector2 = true;
class Matrix3$1 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te = this.elements;
    te[0] = n11;
    te[1] = n21;
    te[2] = n31;
    te[3] = n12;
    te[4] = n22;
    te[5] = n32;
    te[6] = n13;
    te[7] = n23;
    te[8] = n33;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  copy(m) {
    const te = this.elements;
    const me = m.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a, b) {
    const ae = a.elements;
    const be = b.elements;
    const te = this.elements;
    const a11 = ae[0], a12 = ae[3], a13 = ae[6];
    const a21 = ae[1], a22 = ae[4], a23 = ae[7];
    const a31 = ae[2], a32 = ae[5], a33 = ae[8];
    const b11 = be[0], b12 = be[3], b13 = be[6];
    const b21 = be[1], b22 = be[4], b23 = be[7];
    const b31 = be[2], b32 = be[5], b33 = be[8];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  multiplyScalar(s) {
    const te = this.elements;
    te[0] *= s;
    te[3] *= s;
    te[6] *= s;
    te[1] *= s;
    te[4] *= s;
    te[7] *= s;
    te[2] *= s;
    te[5] *= s;
    te[8] *= s;
    return this;
  }
  determinant() {
    const te = this.elements;
    const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
    return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te[0] = t11 * detInv;
    te[1] = (n31 * n23 - n33 * n21) * detInv;
    te[2] = (n32 * n21 - n31 * n22) * detInv;
    te[3] = t12 * detInv;
    te[4] = (n33 * n11 - n31 * n13) * detInv;
    te[5] = (n31 * n12 - n32 * n11) * detInv;
    te[6] = t13 * detInv;
    te[7] = (n21 * n13 - n23 * n11) * detInv;
    te[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  transpose() {
    let tmp2;
    const m = this.elements;
    tmp2 = m[1];
    m[1] = m[3];
    m[3] = tmp2;
    tmp2 = m[2];
    m[2] = m[6];
    m[6] = tmp2;
    tmp2 = m[5];
    m[5] = m[7];
    m[7] = tmp2;
    return this;
  }
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  transposeIntoArray(r) {
    const m = this.elements;
    r[0] = m[0];
    r[1] = m[3];
    r[2] = m[6];
    r[3] = m[1];
    r[4] = m[4];
    r[5] = m[7];
    r[6] = m[2];
    r[7] = m[5];
    r[8] = m[8];
    return this;
  }
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c = Math.cos(rotation);
    const s = Math.sin(rotation);
    this.set(
      sx * c,
      sx * s,
      -sx * (c * cx + s * cy) + cx + tx,
      -sy * s,
      sy * c,
      -sy * (-s * cx + c * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  scale(sx, sy) {
    const te = this.elements;
    te[0] *= sx;
    te[3] *= sx;
    te[6] *= sx;
    te[1] *= sy;
    te[4] *= sy;
    te[7] *= sy;
    return this;
  }
  rotate(theta) {
    const c = Math.cos(theta);
    const s = Math.sin(theta);
    const te = this.elements;
    const a11 = te[0], a12 = te[3], a13 = te[6];
    const a21 = te[1], a22 = te[4], a23 = te[7];
    te[0] = c * a11 + s * a21;
    te[3] = c * a12 + s * a22;
    te[6] = c * a13 + s * a23;
    te[1] = -s * a11 + c * a21;
    te[4] = -s * a12 + c * a22;
    te[7] = -s * a13 + c * a23;
    return this;
  }
  translate(tx, ty) {
    const te = this.elements;
    te[0] += tx * te[2];
    te[3] += tx * te[5];
    te[6] += tx * te[8];
    te[1] += ty * te[2];
    te[4] += ty * te[5];
    te[7] += ty * te[8];
    return this;
  }
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i = 0; i < 9; i++) {
      if (te[i] !== me[i])
        return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i = 0; i < 9; i++) {
      this.elements[i] = array[i + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te = this.elements;
    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];
    array[offset + 3] = te[3];
    array[offset + 4] = te[4];
    array[offset + 5] = te[5];
    array[offset + 6] = te[6];
    array[offset + 7] = te[7];
    array[offset + 8] = te[8];
    return array;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
Matrix3$1.prototype.isMatrix3 = true;
let _canvas$1;
class ImageUtils$1 {
  static getDataURL(image) {
    if (/^data:/i.test(image.src)) {
      return image.src;
    }
    if (typeof HTMLCanvasElement == "undefined") {
      return image.src;
    }
    let canvas;
    if (image instanceof HTMLCanvasElement) {
      canvas = image;
    } else {
      if (_canvas$1 === void 0)
        _canvas$1 = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
      _canvas$1.width = image.width;
      _canvas$1.height = image.height;
      const context = _canvas$1.getContext("2d");
      if (image instanceof ImageData) {
        context.putImageData(image, 0, 0);
      } else {
        context.drawImage(image, 0, 0, image.width, image.height);
      }
      canvas = _canvas$1;
    }
    if (canvas.width > 2048 || canvas.height > 2048) {
      console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
      return canvas.toDataURL("image/jpeg", 0.6);
    } else {
      return canvas.toDataURL("image/png");
    }
  }
}
let textureId$1 = 0;
class Texture$1 extends EventDispatcher$1 {
  constructor(image = Texture$1.DEFAULT_IMAGE, mapping = Texture$1.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping$1, wrapT = ClampToEdgeWrapping$1, magFilter = LinearFilter$1, minFilter = LinearMipmapLinearFilter$1, format = RGBAFormat$1, type = UnsignedByteType$1, anisotropy = 1, encoding = LinearEncoding$1) {
    super();
    Object.defineProperty(this, "id", { value: textureId$1++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.image = image;
    this.mipmaps = [];
    this.mapping = mapping;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2$1(0, 0);
    this.repeat = new Vector2$1(1, 1);
    this.center = new Vector2$1(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3$1();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.encoding = encoding;
    this.version = 0;
    this.onUpdate = null;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.image = source.image;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.encoding = source.encoding;
    return this;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.textures[this.uuid] !== void 0) {
      return meta.textures[this.uuid];
    }
    const output = {
      metadata: {
        version: 4.5,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      mapping: this.mapping,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      type: this.type,
      encoding: this.encoding,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (this.image !== void 0) {
      const image = this.image;
      if (image.uuid === void 0) {
        image.uuid = generateUUID$1();
      }
      if (!isRootObject && meta.images[image.uuid] === void 0) {
        let url2;
        if (Array.isArray(image)) {
          url2 = [];
          for (let i = 0, l = image.length; i < l; i++) {
            if (image[i].isDataTexture) {
              url2.push(serializeImage$1(image[i].image));
            } else {
              url2.push(serializeImage$1(image[i]));
            }
          }
        } else {
          url2 = serializeImage$1(image);
        }
        meta.images[image.uuid] = {
          uuid: image.uuid,
          url: url2
        };
      }
      output.image = image.uuid;
    }
    if (!isRootObject) {
      meta.textures[this.uuid] = output;
    }
    return output;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(uv) {
    if (this.mapping !== UVMapping$1)
      return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping$1:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping$1:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping$1:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping$1:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping$1:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping$1:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
}
Texture$1.DEFAULT_IMAGE = void 0;
Texture$1.DEFAULT_MAPPING = UVMapping$1;
Texture$1.prototype.isTexture = true;
function serializeImage$1(image) {
  if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return ImageUtils$1.getDataURL(image);
  } else {
    if (image.data) {
      return {
        data: Array.prototype.slice.call(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
class Vector4 {
  constructor(x = 0, y = 0, z = 0, w = 1) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;
  }
  get width() {
    return this.z;
  }
  set width(value) {
    this.z = value;
  }
  get height() {
    return this.w;
  }
  set height(value) {
    this.w = value;
  }
  set(x, y, z, w) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    this.w = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setZ(z) {
    this.z = z;
    return this;
  }
  setW(w) {
    this.w = w;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      case 3:
        this.w = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    this.w = v.w !== void 0 ? v.w : 1;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    this.w += v.w;
    return this;
  }
  addScalar(s) {
    this.x += s;
    this.y += s;
    this.z += s;
    this.w += s;
    return this;
  }
  addVectors(a, b) {
    this.x = a.x + b.x;
    this.y = a.y + b.y;
    this.z = a.z + b.z;
    this.w = a.w + b.w;
    return this;
  }
  addScaledVector(v, s) {
    this.x += v.x * s;
    this.y += v.y * s;
    this.z += v.z * s;
    this.w += v.w * s;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    this.w -= v.w;
    return this;
  }
  subScalar(s) {
    this.x -= s;
    this.y -= s;
    this.z -= s;
    this.w -= s;
    return this;
  }
  subVectors(a, b) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;
    this.z = a.z - b.z;
    this.w = a.w - b.w;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    this.w *= v.w;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    this.w *= scalar;
    return this;
  }
  applyMatrix4(m) {
    const x = this.x, y = this.y, z = this.z, w = this.w;
    const e = m.elements;
    this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
    this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
    this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
    this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  setAxisAngleFromQuaternion(q) {
    this.w = 2 * Math.acos(q.w);
    const s = Math.sqrt(1 - q.w * q.w);
    if (s < 1e-4) {
      this.x = 1;
      this.y = 0;
      this.z = 0;
    } else {
      this.x = q.x / s;
      this.y = q.y / s;
      this.z = q.z / s;
    }
    return this;
  }
  setAxisAngleFromRotationMatrix(m) {
    let angle, x, y, z;
    const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
    if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
      if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
        this.set(1, 0, 0, 0);
        return this;
      }
      angle = Math.PI;
      const xx = (m11 + 1) / 2;
      const yy = (m22 + 1) / 2;
      const zz = (m33 + 1) / 2;
      const xy = (m12 + m21) / 4;
      const xz = (m13 + m31) / 4;
      const yz = (m23 + m32) / 4;
      if (xx > yy && xx > zz) {
        if (xx < epsilon) {
          x = 0;
          y = 0.707106781;
          z = 0.707106781;
        } else {
          x = Math.sqrt(xx);
          y = xy / x;
          z = xz / x;
        }
      } else if (yy > zz) {
        if (yy < epsilon) {
          x = 0.707106781;
          y = 0;
          z = 0.707106781;
        } else {
          y = Math.sqrt(yy);
          x = xy / y;
          z = yz / y;
        }
      } else {
        if (zz < epsilon) {
          x = 0.707106781;
          y = 0.707106781;
          z = 0;
        } else {
          z = Math.sqrt(zz);
          x = xz / z;
          y = yz / z;
        }
      }
      this.set(x, y, z, angle);
      return this;
    }
    let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
    if (Math.abs(s) < 1e-3)
      s = 1;
    this.x = (m32 - m23) / s;
    this.y = (m13 - m31) / s;
    this.z = (m21 - m12) / s;
    this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    this.w = Math.min(this.w, v.w);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    this.w = Math.max(this.w, v.w);
    return this;
  }
  clamp(min, max) {
    this.x = Math.max(min.x, Math.min(max.x, this.x));
    this.y = Math.max(min.y, Math.min(max.y, this.y));
    this.z = Math.max(min.z, Math.min(max.z, this.z));
    this.w = Math.max(min.w, Math.min(max.w, this.w));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    this.z = Math.max(minVal, Math.min(maxVal, this.z));
    this.w = Math.max(minVal, Math.min(maxVal, this.w));
    return this;
  }
  clampLength(min, max) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    this.w += (v.w - this.w) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    this.w = v1.w + (v2.w - v1.w) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    this.w = array[offset + 3];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    array[offset + 3] = this.w;
    return array;
  }
  fromBufferAttribute(attribute, index, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    this.z = attribute.getZ(index);
    this.w = attribute.getW(index);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    this.w = Math.random();
    return this;
  }
}
Vector4.prototype.isVector4 = true;
class WebGLRenderTarget extends EventDispatcher$1 {
  constructor(width, height, options) {
    super();
    this.width = width;
    this.height = height;
    this.depth = 1;
    this.scissor = new Vector4(0, 0, width, height);
    this.scissorTest = false;
    this.viewport = new Vector4(0, 0, width, height);
    options = options || {};
    this.texture = new Texture$1(void 0, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    this.texture.image = {};
    this.texture.image.width = width;
    this.texture.image.height = height;
    this.texture.image.depth = 1;
    this.texture.generateMipmaps = options.generateMipmaps !== void 0 ? options.generateMipmaps : false;
    this.texture.minFilter = options.minFilter !== void 0 ? options.minFilter : LinearFilter$1;
    this.depthBuffer = options.depthBuffer !== void 0 ? options.depthBuffer : true;
    this.stencilBuffer = options.stencilBuffer !== void 0 ? options.stencilBuffer : false;
    this.depthTexture = options.depthTexture !== void 0 ? options.depthTexture : null;
  }
  setTexture(texture) {
    texture.image = {
      width: this.width,
      height: this.height,
      depth: this.depth
    };
    this.texture = texture;
  }
  setSize(width, height, depth = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth) {
      this.width = width;
      this.height = height;
      this.depth = depth;
      this.texture.image.width = width;
      this.texture.image.height = height;
      this.texture.image.depth = depth;
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.viewport.copy(source.viewport);
    this.texture = source.texture.clone();
    this.texture.image = { ...this.texture.image };
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.depthTexture = source.depthTexture;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
WebGLRenderTarget.prototype.isWebGLRenderTarget = true;
class WebGLMultipleRenderTargets extends WebGLRenderTarget {
  constructor(width, height, count) {
    super(width, height);
    const texture = this.texture;
    this.texture = [];
    for (let i = 0; i < count; i++) {
      this.texture[i] = texture.clone();
    }
  }
  setSize(width, height, depth = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth) {
      this.width = width;
      this.height = height;
      this.depth = depth;
      for (let i = 0, il = this.texture.length; i < il; i++) {
        this.texture[i].image.width = width;
        this.texture[i].image.height = height;
        this.texture[i].image.depth = depth;
      }
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
    return this;
  }
  copy(source) {
    this.dispose();
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.viewport.set(0, 0, this.width, this.height);
    this.scissor.set(0, 0, this.width, this.height);
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.depthTexture = source.depthTexture;
    this.texture.length = 0;
    for (let i = 0, il = source.texture.length; i < il; i++) {
      this.texture[i] = source.texture[i].clone();
    }
    return this;
  }
}
WebGLMultipleRenderTargets.prototype.isWebGLMultipleRenderTargets = true;
class WebGLMultisampleRenderTarget extends WebGLRenderTarget {
  constructor(width, height, options) {
    super(width, height, options);
    this.samples = 4;
  }
  copy(source) {
    super.copy.call(this, source);
    this.samples = source.samples;
    return this;
  }
}
WebGLMultisampleRenderTarget.prototype.isWebGLMultisampleRenderTarget = true;
class Quaternion {
  constructor(x = 0, y = 0, z = 0, w = 1) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
  }
  static slerp(qa, qb, qm, t) {
    console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
    return qm.slerpQuaternions(qa, qb, t);
  }
  static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
    let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
    if (t === 0) {
      dst[dstOffset + 0] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
      return;
    }
    if (t === 1) {
      dst[dstOffset + 0] = x1;
      dst[dstOffset + 1] = y1;
      dst[dstOffset + 2] = z1;
      dst[dstOffset + 3] = w1;
      return;
    }
    if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
      let s = 1 - t;
      const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
      if (sqrSin > Number.EPSILON) {
        const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
        s = Math.sin(s * len) / sin;
        t = Math.sin(t * len) / sin;
      }
      const tDir = t * dir;
      x0 = x0 * s + x1 * tDir;
      y0 = y0 * s + y1 * tDir;
      z0 = z0 * s + z1 * tDir;
      w0 = w0 * s + w1 * tDir;
      if (s === 1 - t) {
        const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
        x0 *= f;
        y0 *= f;
        z0 *= f;
        w0 *= f;
      }
    }
    dst[dstOffset] = x0;
    dst[dstOffset + 1] = y0;
    dst[dstOffset + 2] = z0;
    dst[dstOffset + 3] = w0;
  }
  static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
    const x0 = src0[srcOffset0];
    const y0 = src0[srcOffset0 + 1];
    const z0 = src0[srcOffset0 + 2];
    const w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1];
    const y1 = src1[srcOffset1 + 1];
    const z1 = src1[srcOffset1 + 2];
    const w1 = src1[srcOffset1 + 3];
    dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
    dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
    dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
    dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
    return dst;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(value) {
    this._w = value;
    this._onChangeCallback();
  }
  set(x, y, z, w) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(quaternion) {
    this._x = quaternion.x;
    this._y = quaternion.y;
    this._z = quaternion.z;
    this._w = quaternion.w;
    this._onChangeCallback();
    return this;
  }
  setFromEuler(euler, update) {
    if (!(euler && euler.isEuler)) {
      throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
    }
    const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
    const cos = Math.cos;
    const sin = Math.sin;
    const c1 = cos(x / 2);
    const c2 = cos(y / 2);
    const c3 = cos(z / 2);
    const s1 = sin(x / 2);
    const s2 = sin(y / 2);
    const s3 = sin(z / 2);
    switch (order) {
      case "XYZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "YXZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "ZXY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "ZYX":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "YZX":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "XZY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
    }
    if (update !== false)
      this._onChangeCallback();
    return this;
  }
  setFromAxisAngle(axis, angle) {
    const halfAngle = angle / 2, s = Math.sin(halfAngle);
    this._x = axis.x * s;
    this._y = axis.y * s;
    this._z = axis.z * s;
    this._w = Math.cos(halfAngle);
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m) {
    const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
    if (trace > 0) {
      const s = 0.5 / Math.sqrt(trace + 1);
      this._w = 0.25 / s;
      this._x = (m32 - m23) * s;
      this._y = (m13 - m31) * s;
      this._z = (m21 - m12) * s;
    } else if (m11 > m22 && m11 > m33) {
      const s = 2 * Math.sqrt(1 + m11 - m22 - m33);
      this._w = (m32 - m23) / s;
      this._x = 0.25 * s;
      this._y = (m12 + m21) / s;
      this._z = (m13 + m31) / s;
    } else if (m22 > m33) {
      const s = 2 * Math.sqrt(1 + m22 - m11 - m33);
      this._w = (m13 - m31) / s;
      this._x = (m12 + m21) / s;
      this._y = 0.25 * s;
      this._z = (m23 + m32) / s;
    } else {
      const s = 2 * Math.sqrt(1 + m33 - m11 - m22);
      this._w = (m21 - m12) / s;
      this._x = (m13 + m31) / s;
      this._y = (m23 + m32) / s;
      this._z = 0.25 * s;
    }
    this._onChangeCallback();
    return this;
  }
  setFromUnitVectors(vFrom, vTo) {
    let r = vFrom.dot(vTo) + 1;
    if (r < Number.EPSILON) {
      r = 0;
      if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
        this._x = -vFrom.y;
        this._y = vFrom.x;
        this._z = 0;
        this._w = r;
      } else {
        this._x = 0;
        this._y = -vFrom.z;
        this._z = vFrom.y;
        this._w = r;
      }
    } else {
      this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
      this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
      this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
      this._w = r;
    }
    return this.normalize();
  }
  angleTo(q) {
    return 2 * Math.acos(Math.abs(clamp$1(this.dot(q), -1, 1)));
  }
  rotateTowards(q, step) {
    const angle = this.angleTo(q);
    if (angle === 0)
      return this;
    const t = Math.min(1, step / angle);
    this.slerp(q, t);
    return this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  dot(v) {
    return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let l = this.length();
    if (l === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      l = 1 / l;
      this._x = this._x * l;
      this._y = this._y * l;
      this._z = this._z * l;
      this._w = this._w * l;
    }
    this._onChangeCallback();
    return this;
  }
  multiply(q, p) {
    if (p !== void 0) {
      console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
      return this.multiplyQuaternions(q, p);
    }
    return this.multiplyQuaternions(this, q);
  }
  premultiply(q) {
    return this.multiplyQuaternions(q, this);
  }
  multiplyQuaternions(a, b) {
    const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
    const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
    this._onChangeCallback();
    return this;
  }
  slerp(qb, t) {
    if (t === 0)
      return this;
    if (t === 1)
      return this.copy(qb);
    const x = this._x, y = this._y, z = this._z, w = this._w;
    let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
    if (cosHalfTheta < 0) {
      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;
      cosHalfTheta = -cosHalfTheta;
    } else {
      this.copy(qb);
    }
    if (cosHalfTheta >= 1) {
      this._w = w;
      this._x = x;
      this._y = y;
      this._z = z;
      return this;
    }
    const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
      const s = 1 - t;
      this._w = s * w + t * this._w;
      this._x = s * x + t * this._x;
      this._y = s * y + t * this._y;
      this._z = s * z + t * this._z;
      this.normalize();
      this._onChangeCallback();
      return this;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
    this._w = w * ratioA + this._w * ratioB;
    this._x = x * ratioA + this._x * ratioB;
    this._y = y * ratioA + this._y * ratioB;
    this._z = z * ratioA + this._z * ratioB;
    this._onChangeCallback();
    return this;
  }
  slerpQuaternions(qa, qb, t) {
    this.copy(qa).slerp(qb, t);
  }
  equals(quaternion) {
    return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
  }
  fromArray(array, offset = 0) {
    this._x = array[offset];
    this._y = array[offset + 1];
    this._z = array[offset + 2];
    this._w = array[offset + 3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._w;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this._x = attribute.getX(index);
    this._y = attribute.getY(index);
    this._z = attribute.getZ(index);
    this._w = attribute.getW(index);
    return this;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
}
Quaternion.prototype.isQuaternion = true;
class Vector3$1 {
  constructor(x = 0, y = 0, z = 0) {
    this.x = x;
    this.y = y;
    this.z = z;
  }
  set(x, y, z) {
    if (z === void 0)
      z = this.z;
    this.x = x;
    this.y = y;
    this.z = z;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setZ(z) {
    this.z = z;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    return this;
  }
  addScalar(s) {
    this.x += s;
    this.y += s;
    this.z += s;
    return this;
  }
  addVectors(a, b) {
    this.x = a.x + b.x;
    this.y = a.y + b.y;
    this.z = a.z + b.z;
    return this;
  }
  addScaledVector(v, s) {
    this.x += v.x * s;
    this.y += v.y * s;
    this.z += v.z * s;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    return this;
  }
  subScalar(s) {
    this.x -= s;
    this.y -= s;
    this.z -= s;
    return this;
  }
  subVectors(a, b) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;
    this.z = a.z - b.z;
    return this;
  }
  multiply(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
      return this.multiplyVectors(v, w);
    }
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    return this;
  }
  multiplyVectors(a, b) {
    this.x = a.x * b.x;
    this.y = a.y * b.y;
    this.z = a.z * b.z;
    return this;
  }
  applyEuler(euler) {
    if (!(euler && euler.isEuler)) {
      console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
    }
    return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
  }
  applyAxisAngle(axis, angle) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y, z = this.z;
    const e = m.elements;
    this.x = e[0] * x + e[3] * y + e[6] * z;
    this.y = e[1] * x + e[4] * y + e[7] * z;
    this.z = e[2] * x + e[5] * y + e[8] * z;
    return this;
  }
  applyNormalMatrix(m) {
    return this.applyMatrix3(m).normalize();
  }
  applyMatrix4(m) {
    const x = this.x, y = this.y, z = this.z;
    const e = m.elements;
    const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
    this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
    this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
    this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
    return this;
  }
  applyQuaternion(q) {
    const x = this.x, y = this.y, z = this.z;
    const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
    const ix = qw * x + qy * z - qz * y;
    const iy = qw * y + qz * x - qx * z;
    const iz = qw * z + qx * y - qy * x;
    const iw = -qx * x - qy * y - qz * z;
    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return this;
  }
  project(camera) {
    return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
  }
  unproject(camera) {
    return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
  }
  transformDirection(m) {
    const x = this.x, y = this.y, z = this.z;
    const e = m.elements;
    this.x = e[0] * x + e[4] * y + e[8] * z;
    this.y = e[1] * x + e[5] * y + e[9] * z;
    this.z = e[2] * x + e[6] * y + e[10] * z;
    return this.normalize();
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    this.z /= v.z;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    return this;
  }
  clamp(min, max) {
    this.x = Math.max(min.x, Math.min(max.x, this.x));
    this.y = Math.max(min.y, Math.min(max.y, this.y));
    this.z = Math.max(min.z, Math.min(max.z, this.z));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    this.z = Math.max(minVal, Math.min(maxVal, this.z));
    return this;
  }
  clampLength(min, max) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    return this;
  }
  cross(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
      return this.crossVectors(v, w);
    }
    return this.crossVectors(this, v);
  }
  crossVectors(a, b) {
    const ax = a.x, ay = a.y, az = a.z;
    const bx = b.x, by = b.y, bz = b.z;
    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;
    return this;
  }
  projectOnVector(v) {
    const denominator = v.lengthSq();
    if (denominator === 0)
      return this.set(0, 0, 0);
    const scalar = v.dot(this) / denominator;
    return this.copy(v).multiplyScalar(scalar);
  }
  projectOnPlane(planeNormal) {
    _vector$c.copy(this).projectOnVector(planeNormal);
    return this.sub(_vector$c);
  }
  reflect(normal) {
    return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
  }
  angleTo(v) {
    const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
    if (denominator === 0)
      return Math.PI / 2;
    const theta = this.dot(v) / denominator;
    return Math.acos(clamp$1(theta, -1, 1));
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
    return dx * dx + dy * dy + dz * dz;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
  }
  setFromSpherical(s) {
    return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
  }
  setFromSphericalCoords(radius, phi, theta) {
    const sinPhiRadius = Math.sin(phi) * radius;
    this.x = sinPhiRadius * Math.sin(theta);
    this.y = Math.cos(phi) * radius;
    this.z = sinPhiRadius * Math.cos(theta);
    return this;
  }
  setFromCylindrical(c) {
    return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
  }
  setFromCylindricalCoords(radius, theta, y) {
    this.x = radius * Math.sin(theta);
    this.y = y;
    this.z = radius * Math.cos(theta);
    return this;
  }
  setFromMatrixPosition(m) {
    const e = m.elements;
    this.x = e[12];
    this.y = e[13];
    this.z = e[14];
    return this;
  }
  setFromMatrixScale(m) {
    const sx = this.setFromMatrixColumn(m, 0).length();
    const sy = this.setFromMatrixColumn(m, 1).length();
    const sz = this.setFromMatrixColumn(m, 2).length();
    this.x = sx;
    this.y = sy;
    this.z = sz;
    return this;
  }
  setFromMatrixColumn(m, index) {
    return this.fromArray(m.elements, index * 4);
  }
  setFromMatrix3Column(m, index) {
    return this.fromArray(m.elements, index * 3);
  }
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    return array;
  }
  fromBufferAttribute(attribute, index, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    this.z = attribute.getZ(index);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
}
Vector3$1.prototype.isVector3 = true;
const _vector$c = /* @__PURE__ */ new Vector3$1();
const _quaternion$4 = /* @__PURE__ */ new Quaternion();
class Box3 {
  constructor(min = new Vector3$1(Infinity, Infinity, Infinity), max = new Vector3$1(-Infinity, -Infinity, -Infinity)) {
    this.min = min;
    this.max = max;
  }
  set(min, max) {
    this.min.copy(min);
    this.max.copy(max);
    return this;
  }
  setFromArray(array) {
    let minX = Infinity;
    let minY = Infinity;
    let minZ = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let maxZ = -Infinity;
    for (let i = 0, l = array.length; i < l; i += 3) {
      const x = array[i];
      const y = array[i + 1];
      const z = array[i + 2];
      if (x < minX)
        minX = x;
      if (y < minY)
        minY = y;
      if (z < minZ)
        minZ = z;
      if (x > maxX)
        maxX = x;
      if (y > maxY)
        maxY = y;
      if (z > maxZ)
        maxZ = z;
    }
    this.min.set(minX, minY, minZ);
    this.max.set(maxX, maxY, maxZ);
    return this;
  }
  setFromBufferAttribute(attribute) {
    let minX = Infinity;
    let minY = Infinity;
    let minZ = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let maxZ = -Infinity;
    for (let i = 0, l = attribute.count; i < l; i++) {
      const x = attribute.getX(i);
      const y = attribute.getY(i);
      const z = attribute.getZ(i);
      if (x < minX)
        minX = x;
      if (y < minY)
        minY = y;
      if (z < minZ)
        minZ = z;
      if (x > maxX)
        maxX = x;
      if (y > maxY)
        maxY = y;
      if (z > maxZ)
        maxZ = z;
    }
    this.min.set(minX, minY, minZ);
    this.max.set(maxX, maxY, maxZ);
    return this;
  }
  setFromPoints(points) {
    this.makeEmpty();
    for (let i = 0, il = points.length; i < il; i++) {
      this.expandByPoint(points[i]);
    }
    return this;
  }
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  setFromObject(object) {
    this.makeEmpty();
    return this.expandByObject(object);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(target) {
    if (target === void 0) {
      console.warn("THREE.Box3: .getCenter() target is now required");
      target = new Vector3$1();
    }
    return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    if (target === void 0) {
      console.warn("THREE.Box3: .getSize() target is now required");
      target = new Vector3$1();
    }
    return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point) {
    this.min.min(point);
    this.max.max(point);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  expandByObject(object) {
    object.updateWorldMatrix(false, false);
    const geometry = object.geometry;
    if (geometry !== void 0) {
      if (geometry.boundingBox === null) {
        geometry.computeBoundingBox();
      }
      _box$3.copy(geometry.boundingBox);
      _box$3.applyMatrix4(object.matrixWorld);
      this.union(_box$3);
    }
    const children = object.children;
    for (let i = 0, l = children.length; i < l; i++) {
      this.expandByObject(children[i]);
    }
    return this;
  }
  containsPoint(point) {
    return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
  }
  getParameter(point, target) {
    if (target === void 0) {
      console.warn("THREE.Box3: .getParameter() target is now required");
      target = new Vector3$1();
    }
    return target.set(
      (point.x - this.min.x) / (this.max.x - this.min.x),
      (point.y - this.min.y) / (this.max.y - this.min.y),
      (point.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(box) {
    return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
  }
  intersectsSphere(sphere) {
    this.clampPoint(sphere.center, _vector$b);
    return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
  }
  intersectsPlane(plane) {
    let min, max;
    if (plane.normal.x > 0) {
      min = plane.normal.x * this.min.x;
      max = plane.normal.x * this.max.x;
    } else {
      min = plane.normal.x * this.max.x;
      max = plane.normal.x * this.min.x;
    }
    if (plane.normal.y > 0) {
      min += plane.normal.y * this.min.y;
      max += plane.normal.y * this.max.y;
    } else {
      min += plane.normal.y * this.max.y;
      max += plane.normal.y * this.min.y;
    }
    if (plane.normal.z > 0) {
      min += plane.normal.z * this.min.z;
      max += plane.normal.z * this.max.z;
    } else {
      min += plane.normal.z * this.max.z;
      max += plane.normal.z * this.min.z;
    }
    return min <= -plane.constant && max >= -plane.constant;
  }
  intersectsTriangle(triangle) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(_center);
    _extents.subVectors(this.max, _center);
    _v0$2.subVectors(triangle.a, _center);
    _v1$7.subVectors(triangle.b, _center);
    _v2$3.subVectors(triangle.c, _center);
    _f0.subVectors(_v1$7, _v0$2);
    _f1.subVectors(_v2$3, _v1$7);
    _f2.subVectors(_v0$2, _v2$3);
    let axes = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
      return false;
    }
    axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
      return false;
    }
    _triangleNormal.crossVectors(_f0, _f1);
    axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
    return satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents);
  }
  clampPoint(point, target) {
    if (target === void 0) {
      console.warn("THREE.Box3: .clampPoint() target is now required");
      target = new Vector3$1();
    }
    return target.copy(point).clamp(this.min, this.max);
  }
  distanceToPoint(point) {
    const clampedPoint = _vector$b.copy(point).clamp(this.min, this.max);
    return clampedPoint.sub(point).length();
  }
  getBoundingSphere(target) {
    if (target === void 0) {
      console.error("THREE.Box3: .getBoundingSphere() target is now required");
    }
    this.getCenter(target.center);
    target.radius = this.getSize(_vector$b).length() * 0.5;
    return target;
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty())
      this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  applyMatrix4(matrix) {
    if (this.isEmpty())
      return this;
    _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix);
    _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix);
    _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix);
    _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix);
    _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix);
    _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix);
    _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix);
    _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix);
    this.setFromPoints(_points);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
Box3.prototype.isBox3 = true;
const _points = [
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1()
];
const _vector$b = /* @__PURE__ */ new Vector3$1();
const _box$3 = /* @__PURE__ */ new Box3();
const _v0$2 = /* @__PURE__ */ new Vector3$1();
const _v1$7 = /* @__PURE__ */ new Vector3$1();
const _v2$3 = /* @__PURE__ */ new Vector3$1();
const _f0 = /* @__PURE__ */ new Vector3$1();
const _f1 = /* @__PURE__ */ new Vector3$1();
const _f2 = /* @__PURE__ */ new Vector3$1();
const _center = /* @__PURE__ */ new Vector3$1();
const _extents = /* @__PURE__ */ new Vector3$1();
const _triangleNormal = /* @__PURE__ */ new Vector3$1();
const _testAxis = /* @__PURE__ */ new Vector3$1();
function satForAxes(axes, v0, v1, v2, extents) {
  for (let i = 0, j = axes.length - 3; i <= j; i += 3) {
    _testAxis.fromArray(axes, i);
    const r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
    const p0 = v0.dot(_testAxis);
    const p1 = v1.dot(_testAxis);
    const p2 = v2.dot(_testAxis);
    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) {
      return false;
    }
  }
  return true;
}
const _box$2 = /* @__PURE__ */ new Box3();
const _v1$6 = /* @__PURE__ */ new Vector3$1();
const _toFarthestPoint = /* @__PURE__ */ new Vector3$1();
const _toPoint = /* @__PURE__ */ new Vector3$1();
class Sphere {
  constructor(center = new Vector3$1(), radius = -1) {
    this.center = center;
    this.radius = radius;
  }
  set(center, radius) {
    this.center.copy(center);
    this.radius = radius;
    return this;
  }
  setFromPoints(points, optionalCenter) {
    const center = this.center;
    if (optionalCenter !== void 0) {
      center.copy(optionalCenter);
    } else {
      _box$2.setFromPoints(points).getCenter(center);
    }
    let maxRadiusSq = 0;
    for (let i = 0, il = points.length; i < il; i++) {
      maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
    }
    this.radius = Math.sqrt(maxRadiusSq);
    return this;
  }
  copy(sphere) {
    this.center.copy(sphere.center);
    this.radius = sphere.radius;
    return this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    this.center.set(0, 0, 0);
    this.radius = -1;
    return this;
  }
  containsPoint(point) {
    return point.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(point) {
    return point.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(sphere) {
    const radiusSum = this.radius + sphere.radius;
    return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
  }
  intersectsBox(box) {
    return box.intersectsSphere(this);
  }
  intersectsPlane(plane) {
    return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(point, target) {
    const deltaLengthSq = this.center.distanceToSquared(point);
    if (target === void 0) {
      console.warn("THREE.Sphere: .clampPoint() target is now required");
      target = new Vector3$1();
    }
    target.copy(point);
    if (deltaLengthSq > this.radius * this.radius) {
      target.sub(this.center).normalize();
      target.multiplyScalar(this.radius).add(this.center);
    }
    return target;
  }
  getBoundingBox(target) {
    if (target === void 0) {
      console.warn("THREE.Sphere: .getBoundingBox() target is now required");
      target = new Box3();
    }
    if (this.isEmpty()) {
      target.makeEmpty();
      return target;
    }
    target.set(this.center, this.center);
    target.expandByScalar(this.radius);
    return target;
  }
  applyMatrix4(matrix) {
    this.center.applyMatrix4(matrix);
    this.radius = this.radius * matrix.getMaxScaleOnAxis();
    return this;
  }
  translate(offset) {
    this.center.add(offset);
    return this;
  }
  expandByPoint(point) {
    _toPoint.subVectors(point, this.center);
    const lengthSq = _toPoint.lengthSq();
    if (lengthSq > this.radius * this.radius) {
      const length = Math.sqrt(lengthSq);
      const missingRadiusHalf = (length - this.radius) * 0.5;
      this.center.add(_toPoint.multiplyScalar(missingRadiusHalf / length));
      this.radius += missingRadiusHalf;
    }
    return this;
  }
  union(sphere) {
    _toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
    this.expandByPoint(_v1$6.copy(sphere.center).add(_toFarthestPoint));
    this.expandByPoint(_v1$6.copy(sphere.center).sub(_toFarthestPoint));
    return this;
  }
  equals(sphere) {
    return sphere.center.equals(this.center) && sphere.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$a = /* @__PURE__ */ new Vector3$1();
const _segCenter = /* @__PURE__ */ new Vector3$1();
const _segDir = /* @__PURE__ */ new Vector3$1();
const _diff = /* @__PURE__ */ new Vector3$1();
const _edge1 = /* @__PURE__ */ new Vector3$1();
const _edge2 = /* @__PURE__ */ new Vector3$1();
const _normal$1 = /* @__PURE__ */ new Vector3$1();
class Ray {
  constructor(origin = new Vector3$1(), direction = new Vector3$1(0, 0, -1)) {
    this.origin = origin;
    this.direction = direction;
  }
  set(origin, direction) {
    this.origin.copy(origin);
    this.direction.copy(direction);
    return this;
  }
  copy(ray) {
    this.origin.copy(ray.origin);
    this.direction.copy(ray.direction);
    return this;
  }
  at(t, target) {
    if (target === void 0) {
      console.warn("THREE.Ray: .at() target is now required");
      target = new Vector3$1();
    }
    return target.copy(this.direction).multiplyScalar(t).add(this.origin);
  }
  lookAt(v) {
    this.direction.copy(v).sub(this.origin).normalize();
    return this;
  }
  recast(t) {
    this.origin.copy(this.at(t, _vector$a));
    return this;
  }
  closestPointToPoint(point, target) {
    if (target === void 0) {
      console.warn("THREE.Ray: .closestPointToPoint() target is now required");
      target = new Vector3$1();
    }
    target.subVectors(point, this.origin);
    const directionDistance = target.dot(this.direction);
    if (directionDistance < 0) {
      return target.copy(this.origin);
    }
    return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
  }
  distanceToPoint(point) {
    return Math.sqrt(this.distanceSqToPoint(point));
  }
  distanceSqToPoint(point) {
    const directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction);
    if (directionDistance < 0) {
      return this.origin.distanceToSquared(point);
    }
    _vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    return _vector$a.distanceToSquared(point);
  }
  distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
    _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
    _segDir.copy(v1).sub(v0).normalize();
    _diff.copy(this.origin).sub(_segCenter);
    const segExtent = v0.distanceTo(v1) * 0.5;
    const a01 = -this.direction.dot(_segDir);
    const b0 = _diff.dot(this.direction);
    const b1 = -_diff.dot(_segDir);
    const c = _diff.lengthSq();
    const det = Math.abs(1 - a01 * a01);
    let s0, s1, sqrDist, extDet;
    if (det > 0) {
      s0 = a01 * b1 - b0;
      s1 = a01 * b0 - b1;
      extDet = segExtent * det;
      if (s0 >= 0) {
        if (s1 >= -extDet) {
          if (s1 <= extDet) {
            const invDet = 1 / det;
            s0 *= invDet;
            s1 *= invDet;
            sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
          } else {
            s1 = segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
          }
        } else {
          s1 = -segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
      } else {
        if (s1 <= -extDet) {
          s0 = Math.max(0, -(-a01 * segExtent + b0));
          s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        } else if (s1 <= extDet) {
          s0 = 0;
          s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = s1 * (s1 + 2 * b1) + c;
        } else {
          s0 = Math.max(0, -(a01 * segExtent + b0));
          s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
      }
    } else {
      s1 = a01 > 0 ? -segExtent : segExtent;
      s0 = Math.max(0, -(a01 * s1 + b0));
      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
    }
    if (optionalPointOnRay) {
      optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
    }
    if (optionalPointOnSegment) {
      optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
    }
    return sqrDist;
  }
  intersectSphere(sphere, target) {
    _vector$a.subVectors(sphere.center, this.origin);
    const tca = _vector$a.dot(this.direction);
    const d2 = _vector$a.dot(_vector$a) - tca * tca;
    const radius2 = sphere.radius * sphere.radius;
    if (d2 > radius2)
      return null;
    const thc = Math.sqrt(radius2 - d2);
    const t0 = tca - thc;
    const t1 = tca + thc;
    if (t0 < 0 && t1 < 0)
      return null;
    if (t0 < 0)
      return this.at(t1, target);
    return this.at(t0, target);
  }
  intersectsSphere(sphere) {
    return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
  }
  distanceToPlane(plane) {
    const denominator = plane.normal.dot(this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
    return t >= 0 ? t : null;
  }
  intersectPlane(plane, target) {
    const t = this.distanceToPlane(plane);
    if (t === null) {
      return null;
    }
    return this.at(t, target);
  }
  intersectsPlane(plane) {
    const distToPoint = plane.distanceToPoint(this.origin);
    if (distToPoint === 0) {
      return true;
    }
    const denominator = plane.normal.dot(this.direction);
    if (denominator * distToPoint < 0) {
      return true;
    }
    return false;
  }
  intersectBox(box, target) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
    const origin = this.origin;
    if (invdirx >= 0) {
      tmin = (box.min.x - origin.x) * invdirx;
      tmax = (box.max.x - origin.x) * invdirx;
    } else {
      tmin = (box.max.x - origin.x) * invdirx;
      tmax = (box.min.x - origin.x) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box.min.y - origin.y) * invdiry;
      tymax = (box.max.y - origin.y) * invdiry;
    } else {
      tymin = (box.max.y - origin.y) * invdiry;
      tymax = (box.min.y - origin.y) * invdiry;
    }
    if (tmin > tymax || tymin > tmax)
      return null;
    if (tymin > tmin || tmin !== tmin)
      tmin = tymin;
    if (tymax < tmax || tmax !== tmax)
      tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box.min.z - origin.z) * invdirz;
      tzmax = (box.max.z - origin.z) * invdirz;
    } else {
      tzmin = (box.max.z - origin.z) * invdirz;
      tzmax = (box.min.z - origin.z) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax)
      return null;
    if (tzmin > tmin || tmin !== tmin)
      tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax)
      tmax = tzmax;
    if (tmax < 0)
      return null;
    return this.at(tmin >= 0 ? tmin : tmax, target);
  }
  intersectsBox(box) {
    return this.intersectBox(box, _vector$a) !== null;
  }
  intersectTriangle(a, b, c, backfaceCulling, target) {
    _edge1.subVectors(b, a);
    _edge2.subVectors(c, a);
    _normal$1.crossVectors(_edge1, _edge2);
    let DdN = this.direction.dot(_normal$1);
    let sign2;
    if (DdN > 0) {
      if (backfaceCulling)
        return null;
      sign2 = 1;
    } else if (DdN < 0) {
      sign2 = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    _diff.subVectors(this.origin, a);
    const DdQxE2 = sign2 * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (DdQxE2 < 0) {
      return null;
    }
    const DdE1xQ = sign2 * this.direction.dot(_edge1.cross(_diff));
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    const QdN = -sign2 * _diff.dot(_normal$1);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target);
  }
  applyMatrix4(matrix4) {
    this.origin.applyMatrix4(matrix4);
    this.direction.transformDirection(matrix4);
    return this;
  }
  equals(ray) {
    return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix4 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    const te = this.elements;
    te[0] = n11;
    te[4] = n12;
    te[8] = n13;
    te[12] = n14;
    te[1] = n21;
    te[5] = n22;
    te[9] = n23;
    te[13] = n24;
    te[2] = n31;
    te[6] = n32;
    te[10] = n33;
    te[14] = n34;
    te[3] = n41;
    te[7] = n42;
    te[11] = n43;
    te[15] = n44;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  clone() {
    return new Matrix4().fromArray(this.elements);
  }
  copy(m) {
    const te = this.elements;
    const me = m.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    te[9] = me[9];
    te[10] = me[10];
    te[11] = me[11];
    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];
    te[15] = me[15];
    return this;
  }
  copyPosition(m) {
    const te = this.elements, me = m.elements;
    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];
    return this;
  }
  setFromMatrix3(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[3],
      me[6],
      0,
      me[1],
      me[4],
      me[7],
      0,
      me[2],
      me[5],
      me[8],
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrixColumn(this, 0);
    yAxis.setFromMatrixColumn(this, 1);
    zAxis.setFromMatrixColumn(this, 2);
    return this;
  }
  makeBasis(xAxis, yAxis, zAxis) {
    this.set(
      xAxis.x,
      yAxis.x,
      zAxis.x,
      0,
      xAxis.y,
      yAxis.y,
      zAxis.y,
      0,
      xAxis.z,
      yAxis.z,
      zAxis.z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractRotation(m) {
    const te = this.elements;
    const me = m.elements;
    const scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
    const scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
    const scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
    te[0] = me[0] * scaleX;
    te[1] = me[1] * scaleX;
    te[2] = me[2] * scaleX;
    te[3] = 0;
    te[4] = me[4] * scaleY;
    te[5] = me[5] * scaleY;
    te[6] = me[6] * scaleY;
    te[7] = 0;
    te[8] = me[8] * scaleZ;
    te[9] = me[9] * scaleZ;
    te[10] = me[10] * scaleZ;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return this;
  }
  makeRotationFromEuler(euler) {
    if (!(euler && euler.isEuler)) {
      console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
    }
    const te = this.elements;
    const x = euler.x, y = euler.y, z = euler.z;
    const a = Math.cos(x), b = Math.sin(x);
    const c = Math.cos(y), d = Math.sin(y);
    const e = Math.cos(z), f = Math.sin(z);
    if (euler.order === "XYZ") {
      const ae = a * e, af = a * f, be = b * e, bf = b * f;
      te[0] = c * e;
      te[4] = -c * f;
      te[8] = d;
      te[1] = af + be * d;
      te[5] = ae - bf * d;
      te[9] = -b * c;
      te[2] = bf - ae * d;
      te[6] = be + af * d;
      te[10] = a * c;
    } else if (euler.order === "YXZ") {
      const ce = c * e, cf = c * f, de = d * e, df = d * f;
      te[0] = ce + df * b;
      te[4] = de * b - cf;
      te[8] = a * d;
      te[1] = a * f;
      te[5] = a * e;
      te[9] = -b;
      te[2] = cf * b - de;
      te[6] = df + ce * b;
      te[10] = a * c;
    } else if (euler.order === "ZXY") {
      const ce = c * e, cf = c * f, de = d * e, df = d * f;
      te[0] = ce - df * b;
      te[4] = -a * f;
      te[8] = de + cf * b;
      te[1] = cf + de * b;
      te[5] = a * e;
      te[9] = df - ce * b;
      te[2] = -a * d;
      te[6] = b;
      te[10] = a * c;
    } else if (euler.order === "ZYX") {
      const ae = a * e, af = a * f, be = b * e, bf = b * f;
      te[0] = c * e;
      te[4] = be * d - af;
      te[8] = ae * d + bf;
      te[1] = c * f;
      te[5] = bf * d + ae;
      te[9] = af * d - be;
      te[2] = -d;
      te[6] = b * c;
      te[10] = a * c;
    } else if (euler.order === "YZX") {
      const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
      te[0] = c * e;
      te[4] = bd - ac * f;
      te[8] = bc * f + ad;
      te[1] = f;
      te[5] = a * e;
      te[9] = -b * e;
      te[2] = -d * e;
      te[6] = ad * f + bc;
      te[10] = ac - bd * f;
    } else if (euler.order === "XZY") {
      const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
      te[0] = c * e;
      te[4] = -f;
      te[8] = d * e;
      te[1] = ac * f + bd;
      te[5] = a * e;
      te[9] = ad * f - bc;
      te[2] = bc * f - ad;
      te[6] = b * e;
      te[10] = bd * f + ac;
    }
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return this;
  }
  makeRotationFromQuaternion(q) {
    return this.compose(_zero, q, _one);
  }
  lookAt(eye2, target, up) {
    const te = this.elements;
    _z.subVectors(eye2, target);
    if (_z.lengthSq() === 0) {
      _z.z = 1;
    }
    _z.normalize();
    _x.crossVectors(up, _z);
    if (_x.lengthSq() === 0) {
      if (Math.abs(up.z) === 1) {
        _z.x += 1e-4;
      } else {
        _z.z += 1e-4;
      }
      _z.normalize();
      _x.crossVectors(up, _z);
    }
    _x.normalize();
    _y.crossVectors(_z, _x);
    te[0] = _x.x;
    te[4] = _y.x;
    te[8] = _z.x;
    te[1] = _x.y;
    te[5] = _y.y;
    te[9] = _z.y;
    te[2] = _x.z;
    te[6] = _y.z;
    te[10] = _z.z;
    return this;
  }
  multiply(m, n) {
    if (n !== void 0) {
      console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
      return this.multiplyMatrices(m, n);
    }
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a, b) {
    const ae = a.elements;
    const be = b.elements;
    const te = this.elements;
    const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
    const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
    const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
    const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
    const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
    const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
    const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
    const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
    return this;
  }
  multiplyScalar(s) {
    const te = this.elements;
    te[0] *= s;
    te[4] *= s;
    te[8] *= s;
    te[12] *= s;
    te[1] *= s;
    te[5] *= s;
    te[9] *= s;
    te[13] *= s;
    te[2] *= s;
    te[6] *= s;
    te[10] *= s;
    te[14] *= s;
    te[3] *= s;
    te[7] *= s;
    te[11] *= s;
    te[15] *= s;
    return this;
  }
  determinant() {
    const te = this.elements;
    const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
    const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
    const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
    const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
    return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
  }
  transpose() {
    const te = this.elements;
    let tmp2;
    tmp2 = te[1];
    te[1] = te[4];
    te[4] = tmp2;
    tmp2 = te[2];
    te[2] = te[8];
    te[8] = tmp2;
    tmp2 = te[6];
    te[6] = te[9];
    te[9] = tmp2;
    tmp2 = te[3];
    te[3] = te[12];
    te[12] = tmp2;
    tmp2 = te[7];
    te[7] = te[13];
    te[13] = tmp2;
    tmp2 = te[11];
    te[11] = te[14];
    te[14] = tmp2;
    return this;
  }
  setPosition(x, y, z) {
    const te = this.elements;
    if (x.isVector3) {
      te[12] = x.x;
      te[13] = x.y;
      te[14] = x.z;
    } else {
      te[12] = x;
      te[13] = y;
      te[14] = z;
    }
    return this;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
    if (det === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te[0] = t11 * detInv;
    te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
    te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
    te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
    te[4] = t12 * detInv;
    te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
    te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
    te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
    te[8] = t13 * detInv;
    te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
    te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
    te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
    te[12] = t14 * detInv;
    te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
    te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
    te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
    return this;
  }
  scale(v) {
    const te = this.elements;
    const x = v.x, y = v.y, z = v.z;
    te[0] *= x;
    te[4] *= y;
    te[8] *= z;
    te[1] *= x;
    te[5] *= y;
    te[9] *= z;
    te[2] *= x;
    te[6] *= y;
    te[10] *= z;
    te[3] *= x;
    te[7] *= y;
    te[11] *= z;
    return this;
  }
  getMaxScaleOnAxis() {
    const te = this.elements;
    const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
    const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
    const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
  }
  makeTranslation(x, y, z) {
    this.set(
      1,
      0,
      0,
      x,
      0,
      1,
      0,
      y,
      0,
      0,
      1,
      z,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationX(theta) {
    const c = Math.cos(theta), s = Math.sin(theta);
    this.set(
      1,
      0,
      0,
      0,
      0,
      c,
      -s,
      0,
      0,
      s,
      c,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationY(theta) {
    const c = Math.cos(theta), s = Math.sin(theta);
    this.set(
      c,
      0,
      s,
      0,
      0,
      1,
      0,
      0,
      -s,
      0,
      c,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationZ(theta) {
    const c = Math.cos(theta), s = Math.sin(theta);
    this.set(
      c,
      -s,
      0,
      0,
      s,
      c,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationAxis(axis, angle) {
    const c = Math.cos(angle);
    const s = Math.sin(angle);
    const t = 1 - c;
    const x = axis.x, y = axis.y, z = axis.z;
    const tx = t * x, ty = t * y;
    this.set(
      tx * x + c,
      tx * y - s * z,
      tx * z + s * y,
      0,
      tx * y + s * z,
      ty * y + c,
      ty * z - s * x,
      0,
      tx * z - s * y,
      ty * z + s * x,
      t * z * z + c,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x, y, z) {
    this.set(
      x,
      0,
      0,
      0,
      0,
      y,
      0,
      0,
      0,
      0,
      z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeShear(xy, xz, yx, yz, zx, zy) {
    this.set(
      1,
      yx,
      zx,
      0,
      xy,
      1,
      zy,
      0,
      xz,
      yz,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  compose(position, quaternion, scale) {
    const te = this.elements;
    const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
    const x2 = x + x, y2 = y + y, z2 = z + z;
    const xx = x * x2, xy = x * y2, xz = x * z2;
    const yy = y * y2, yz = y * z2, zz = z * z2;
    const wx = w * x2, wy = w * y2, wz = w * z2;
    const sx = scale.x, sy = scale.y, sz = scale.z;
    te[0] = (1 - (yy + zz)) * sx;
    te[1] = (xy + wz) * sx;
    te[2] = (xz - wy) * sx;
    te[3] = 0;
    te[4] = (xy - wz) * sy;
    te[5] = (1 - (xx + zz)) * sy;
    te[6] = (yz + wx) * sy;
    te[7] = 0;
    te[8] = (xz + wy) * sz;
    te[9] = (yz - wx) * sz;
    te[10] = (1 - (xx + yy)) * sz;
    te[11] = 0;
    te[12] = position.x;
    te[13] = position.y;
    te[14] = position.z;
    te[15] = 1;
    return this;
  }
  decompose(position, quaternion, scale) {
    const te = this.elements;
    let sx = _v1$5.set(te[0], te[1], te[2]).length();
    const sy = _v1$5.set(te[4], te[5], te[6]).length();
    const sz = _v1$5.set(te[8], te[9], te[10]).length();
    const det = this.determinant();
    if (det < 0)
      sx = -sx;
    position.x = te[12];
    position.y = te[13];
    position.z = te[14];
    _m1$2.copy(this);
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1$2.elements[0] *= invSX;
    _m1$2.elements[1] *= invSX;
    _m1$2.elements[2] *= invSX;
    _m1$2.elements[4] *= invSY;
    _m1$2.elements[5] *= invSY;
    _m1$2.elements[6] *= invSY;
    _m1$2.elements[8] *= invSZ;
    _m1$2.elements[9] *= invSZ;
    _m1$2.elements[10] *= invSZ;
    quaternion.setFromRotationMatrix(_m1$2);
    scale.x = sx;
    scale.y = sy;
    scale.z = sz;
    return this;
  }
  makePerspective(left, right, top, bottom, near, far) {
    if (far === void 0) {
      console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
    }
    const te = this.elements;
    const x = 2 * near / (right - left);
    const y = 2 * near / (top - bottom);
    const a = (right + left) / (right - left);
    const b = (top + bottom) / (top - bottom);
    const c = -(far + near) / (far - near);
    const d = -2 * far * near / (far - near);
    te[0] = x;
    te[4] = 0;
    te[8] = a;
    te[12] = 0;
    te[1] = 0;
    te[5] = y;
    te[9] = b;
    te[13] = 0;
    te[2] = 0;
    te[6] = 0;
    te[10] = c;
    te[14] = d;
    te[3] = 0;
    te[7] = 0;
    te[11] = -1;
    te[15] = 0;
    return this;
  }
  makeOrthographic(left, right, top, bottom, near, far) {
    const te = this.elements;
    const w = 1 / (right - left);
    const h = 1 / (top - bottom);
    const p = 1 / (far - near);
    const x = (right + left) * w;
    const y = (top + bottom) * h;
    const z = (far + near) * p;
    te[0] = 2 * w;
    te[4] = 0;
    te[8] = 0;
    te[12] = -x;
    te[1] = 0;
    te[5] = 2 * h;
    te[9] = 0;
    te[13] = -y;
    te[2] = 0;
    te[6] = 0;
    te[10] = -2 * p;
    te[14] = -z;
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[15] = 1;
    return this;
  }
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i = 0; i < 16; i++) {
      if (te[i] !== me[i])
        return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i = 0; i < 16; i++) {
      this.elements[i] = array[i + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te = this.elements;
    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];
    array[offset + 3] = te[3];
    array[offset + 4] = te[4];
    array[offset + 5] = te[5];
    array[offset + 6] = te[6];
    array[offset + 7] = te[7];
    array[offset + 8] = te[8];
    array[offset + 9] = te[9];
    array[offset + 10] = te[10];
    array[offset + 11] = te[11];
    array[offset + 12] = te[12];
    array[offset + 13] = te[13];
    array[offset + 14] = te[14];
    array[offset + 15] = te[15];
    return array;
  }
}
Matrix4.prototype.isMatrix4 = true;
const _v1$5 = /* @__PURE__ */ new Vector3$1();
const _m1$2 = /* @__PURE__ */ new Matrix4();
const _zero = /* @__PURE__ */ new Vector3$1(0, 0, 0);
const _one = /* @__PURE__ */ new Vector3$1(1, 1, 1);
const _x = /* @__PURE__ */ new Vector3$1();
const _y = /* @__PURE__ */ new Vector3$1();
const _z = /* @__PURE__ */ new Vector3$1();
const _matrix$1 = /* @__PURE__ */ new Matrix4();
const _quaternion$3 = /* @__PURE__ */ new Quaternion();
class Euler {
  constructor(x = 0, y = 0, z = 0, order = Euler.DefaultOrder) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._order = order;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(value) {
    this._order = value;
    this._onChangeCallback();
  }
  set(x, y, z, order) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._order = order || this._order;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(euler) {
    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m, order, update) {
    const te = m.elements;
    const m11 = te[0], m12 = te[4], m13 = te[8];
    const m21 = te[1], m22 = te[5], m23 = te[9];
    const m31 = te[2], m32 = te[6], m33 = te[10];
    order = order || this._order;
    switch (order) {
      case "XYZ":
        this._y = Math.asin(clamp$1(m13, -1, 1));
        if (Math.abs(m13) < 0.9999999) {
          this._x = Math.atan2(-m23, m33);
          this._z = Math.atan2(-m12, m11);
        } else {
          this._x = Math.atan2(m32, m22);
          this._z = 0;
        }
        break;
      case "YXZ":
        this._x = Math.asin(-clamp$1(m23, -1, 1));
        if (Math.abs(m23) < 0.9999999) {
          this._y = Math.atan2(m13, m33);
          this._z = Math.atan2(m21, m22);
        } else {
          this._y = Math.atan2(-m31, m11);
          this._z = 0;
        }
        break;
      case "ZXY":
        this._x = Math.asin(clamp$1(m32, -1, 1));
        if (Math.abs(m32) < 0.9999999) {
          this._y = Math.atan2(-m31, m33);
          this._z = Math.atan2(-m12, m22);
        } else {
          this._y = 0;
          this._z = Math.atan2(m21, m11);
        }
        break;
      case "ZYX":
        this._y = Math.asin(-clamp$1(m31, -1, 1));
        if (Math.abs(m31) < 0.9999999) {
          this._x = Math.atan2(m32, m33);
          this._z = Math.atan2(m21, m11);
        } else {
          this._x = 0;
          this._z = Math.atan2(-m12, m22);
        }
        break;
      case "YZX":
        this._z = Math.asin(clamp$1(m21, -1, 1));
        if (Math.abs(m21) < 0.9999999) {
          this._x = Math.atan2(-m23, m22);
          this._y = Math.atan2(-m31, m11);
        } else {
          this._x = 0;
          this._y = Math.atan2(m13, m33);
        }
        break;
      case "XZY":
        this._z = Math.asin(-clamp$1(m12, -1, 1));
        if (Math.abs(m12) < 0.9999999) {
          this._x = Math.atan2(m32, m22);
          this._y = Math.atan2(m13, m11);
        } else {
          this._x = Math.atan2(-m23, m33);
          this._y = 0;
        }
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
    }
    this._order = order;
    if (update !== false)
      this._onChangeCallback();
    return this;
  }
  setFromQuaternion(q, order, update) {
    _matrix$1.makeRotationFromQuaternion(q);
    return this.setFromRotationMatrix(_matrix$1, order, update);
  }
  setFromVector3(v, order) {
    return this.set(v.x, v.y, v.z, order || this._order);
  }
  reorder(newOrder) {
    _quaternion$3.setFromEuler(this);
    return this.setFromQuaternion(_quaternion$3, newOrder);
  }
  equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  fromArray(array) {
    this._x = array[0];
    this._y = array[1];
    this._z = array[2];
    if (array[3] !== void 0)
      this._order = array[3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._order;
    return array;
  }
  toVector3(optionalResult) {
    if (optionalResult) {
      return optionalResult.set(this._x, this._y, this._z);
    } else {
      return new Vector3$1(this._x, this._y, this._z);
    }
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
}
Euler.prototype.isEuler = true;
Euler.DefaultOrder = "XYZ";
Euler.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];
class Layers {
  constructor() {
    this.mask = 1 | 0;
  }
  set(channel) {
    this.mask = 1 << channel | 0;
  }
  enable(channel) {
    this.mask |= 1 << channel | 0;
  }
  enableAll() {
    this.mask = 4294967295 | 0;
  }
  toggle(channel) {
    this.mask ^= 1 << channel | 0;
  }
  disable(channel) {
    this.mask &= ~(1 << channel | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(layers2) {
    return (this.mask & layers2.mask) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector3$1();
const _q1 = /* @__PURE__ */ new Quaternion();
const _m1$1 = /* @__PURE__ */ new Matrix4();
const _target = /* @__PURE__ */ new Vector3$1();
const _position$3 = /* @__PURE__ */ new Vector3$1();
const _scale$2 = /* @__PURE__ */ new Vector3$1();
const _quaternion$2 = /* @__PURE__ */ new Quaternion();
const _xAxis = /* @__PURE__ */ new Vector3$1(1, 0, 0);
const _yAxis = /* @__PURE__ */ new Vector3$1(0, 1, 0);
const _zAxis = /* @__PURE__ */ new Vector3$1(0, 0, 1);
const _addedEvent = { type: "added" };
const _removedEvent = { type: "removed" };
class Object3D extends EventDispatcher$1 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: _object3DId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "Object3D";
    this.parent = null;
    this.children = [];
    this.up = Object3D.DefaultUp.clone();
    const position = new Vector3$1();
    const rotation = new Euler();
    const quaternion = new Quaternion();
    const scale = new Vector3$1(1, 1, 1);
    function onRotationChange() {
      quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion, void 0, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
      position: {
        configurable: true,
        enumerable: true,
        value: position
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: scale
      },
      modelViewMatrix: {
        value: new Matrix4()
      },
      normalMatrix: {
        value: new Matrix3$1()
      }
    });
    this.matrix = new Matrix4();
    this.matrixWorld = new Matrix4();
    this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(matrix) {
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    this.matrix.premultiply(matrix);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(q) {
    this.quaternion.premultiply(q);
    return this;
  }
  setRotationFromAxisAngle(axis, angle) {
    this.quaternion.setFromAxisAngle(axis, angle);
  }
  setRotationFromEuler(euler) {
    this.quaternion.setFromEuler(euler, true);
  }
  setRotationFromMatrix(m) {
    this.quaternion.setFromRotationMatrix(m);
  }
  setRotationFromQuaternion(q) {
    this.quaternion.copy(q);
  }
  rotateOnAxis(axis, angle) {
    _q1.setFromAxisAngle(axis, angle);
    this.quaternion.multiply(_q1);
    return this;
  }
  rotateOnWorldAxis(axis, angle) {
    _q1.setFromAxisAngle(axis, angle);
    this.quaternion.premultiply(_q1);
    return this;
  }
  rotateX(angle) {
    return this.rotateOnAxis(_xAxis, angle);
  }
  rotateY(angle) {
    return this.rotateOnAxis(_yAxis, angle);
  }
  rotateZ(angle) {
    return this.rotateOnAxis(_zAxis, angle);
  }
  translateOnAxis(axis, distance) {
    _v1$4.copy(axis).applyQuaternion(this.quaternion);
    this.position.add(_v1$4.multiplyScalar(distance));
    return this;
  }
  translateX(distance) {
    return this.translateOnAxis(_xAxis, distance);
  }
  translateY(distance) {
    return this.translateOnAxis(_yAxis, distance);
  }
  translateZ(distance) {
    return this.translateOnAxis(_zAxis, distance);
  }
  localToWorld(vector) {
    return vector.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(vector) {
    return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
  }
  lookAt(x, y, z) {
    if (x.isVector3) {
      _target.copy(x);
    } else {
      _target.set(x, y, z);
    }
    const parent = this.parent;
    this.updateWorldMatrix(true, false);
    _position$3.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      _m1$1.lookAt(_position$3, _target, this.up);
    } else {
      _m1$1.lookAt(_target, _position$3, this.up);
    }
    this.quaternion.setFromRotationMatrix(_m1$1);
    if (parent) {
      _m1$1.extractRotation(parent.matrixWorld);
      _q1.setFromRotationMatrix(_m1$1);
      this.quaternion.premultiply(_q1.invert());
    }
  }
  add(object) {
    if (arguments.length > 1) {
      for (let i = 0; i < arguments.length; i++) {
        this.add(arguments[i]);
      }
      return this;
    }
    if (object === this) {
      console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
      return this;
    }
    if (object && object.isObject3D) {
      if (object.parent !== null) {
        object.parent.remove(object);
      }
      object.parent = this;
      this.children.push(object);
      object.dispatchEvent(_addedEvent);
    } else {
      console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
    }
    return this;
  }
  remove(object) {
    if (arguments.length > 1) {
      for (let i = 0; i < arguments.length; i++) {
        this.remove(arguments[i]);
      }
      return this;
    }
    const index = this.children.indexOf(object);
    if (index !== -1) {
      object.parent = null;
      this.children.splice(index, 1);
      object.dispatchEvent(_removedEvent);
    }
    return this;
  }
  removeFromParent() {
    const parent = this.parent;
    if (parent !== null) {
      parent.remove(this);
    }
    return this;
  }
  clear() {
    for (let i = 0; i < this.children.length; i++) {
      const object = this.children[i];
      object.parent = null;
      object.dispatchEvent(_removedEvent);
    }
    this.children.length = 0;
    return this;
  }
  attach(object) {
    this.updateWorldMatrix(true, false);
    _m1$1.copy(this.matrixWorld).invert();
    if (object.parent !== null) {
      object.parent.updateWorldMatrix(true, false);
      _m1$1.multiply(object.parent.matrixWorld);
    }
    object.applyMatrix4(_m1$1);
    this.add(object);
    object.updateWorldMatrix(false, true);
    return this;
  }
  getObjectById(id) {
    return this.getObjectByProperty("id", id);
  }
  getObjectByName(name) {
    return this.getObjectByProperty("name", name);
  }
  getObjectByProperty(name, value) {
    if (this[name] === value)
      return this;
    for (let i = 0, l = this.children.length; i < l; i++) {
      const child = this.children[i];
      const object = child.getObjectByProperty(name, value);
      if (object !== void 0) {
        return object;
      }
    }
    return void 0;
  }
  getWorldPosition(target) {
    if (target === void 0) {
      console.warn("THREE.Object3D: .getWorldPosition() target is now required");
      target = new Vector3$1();
    }
    this.updateWorldMatrix(true, false);
    return target.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(target) {
    if (target === void 0) {
      console.warn("THREE.Object3D: .getWorldQuaternion() target is now required");
      target = new Quaternion();
    }
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, target, _scale$2);
    return target;
  }
  getWorldScale(target) {
    if (target === void 0) {
      console.warn("THREE.Object3D: .getWorldScale() target is now required");
      target = new Vector3$1();
    }
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, _quaternion$2, target);
    return target;
  }
  getWorldDirection(target) {
    if (target === void 0) {
      console.warn("THREE.Object3D: .getWorldDirection() target is now required");
      target = new Vector3$1();
    }
    this.updateWorldMatrix(true, false);
    const e = this.matrixWorld.elements;
    return target.set(e[8], e[9], e[10]).normalize();
  }
  raycast() {
  }
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i = 0, l = children.length; i < l; i++) {
      children[i].traverse(callback);
    }
  }
  traverseVisible(callback) {
    if (this.visible === false)
      return;
    callback(this);
    const children = this.children;
    for (let i = 0, l = children.length; i < l; i++) {
      children[i].traverseVisible(callback);
    }
  }
  traverseAncestors(callback) {
    const parent = this.parent;
    if (parent !== null) {
      callback(parent);
      parent.traverseAncestors(callback);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    this.matrixWorldNeedsUpdate = true;
  }
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    if (this.matrixWorldNeedsUpdate || force) {
      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      }
      this.matrixWorldNeedsUpdate = false;
      force = true;
    }
    const children = this.children;
    for (let i = 0, l = children.length; i < l; i++) {
      children[i].updateMatrixWorld(force);
    }
  }
  updateWorldMatrix(updateParents, updateChildren) {
    const parent = this.parent;
    if (updateParents === true && parent !== null) {
      parent.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    if (this.parent === null) {
      this.matrixWorld.copy(this.matrix);
    } else {
      this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
    }
    if (updateChildren === true) {
      const children = this.children;
      for (let i = 0, l = children.length; i < l; i++) {
        children[i].updateWorldMatrix(false, true);
      }
    }
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    const output = {};
    if (isRootObject) {
      meta = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {}
      };
      output.metadata = {
        version: 4.5,
        type: "Object",
        generator: "Object3D.toJSON"
      };
    }
    const object = {};
    object.uuid = this.uuid;
    object.type = this.type;
    if (this.name !== "")
      object.name = this.name;
    if (this.castShadow === true)
      object.castShadow = true;
    if (this.receiveShadow === true)
      object.receiveShadow = true;
    if (this.visible === false)
      object.visible = false;
    if (this.frustumCulled === false)
      object.frustumCulled = false;
    if (this.renderOrder !== 0)
      object.renderOrder = this.renderOrder;
    if (JSON.stringify(this.userData) !== "{}")
      object.userData = this.userData;
    object.layers = this.layers.mask;
    object.matrix = this.matrix.toArray();
    if (this.matrixAutoUpdate === false)
      object.matrixAutoUpdate = false;
    if (this.isInstancedMesh) {
      object.type = "InstancedMesh";
      object.count = this.count;
      object.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null)
        object.instanceColor = this.instanceColor.toJSON();
    }
    function serialize(library, element) {
      if (library[element.uuid] === void 0) {
        library[element.uuid] = element.toJSON(meta);
      }
      return element.uuid;
    }
    if (this.isMesh || this.isLine || this.isPoints) {
      object.geometry = serialize(meta.geometries, this.geometry);
      const parameters = this.geometry.parameters;
      if (parameters !== void 0 && parameters.shapes !== void 0) {
        const shapes = parameters.shapes;
        if (Array.isArray(shapes)) {
          for (let i = 0, l = shapes.length; i < l; i++) {
            const shape = shapes[i];
            serialize(meta.shapes, shape);
          }
        } else {
          serialize(meta.shapes, shapes);
        }
      }
    }
    if (this.isSkinnedMesh) {
      object.bindMode = this.bindMode;
      object.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== void 0) {
        serialize(meta.skeletons, this.skeleton);
        object.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== void 0) {
      if (Array.isArray(this.material)) {
        const uuids = [];
        for (let i = 0, l = this.material.length; i < l; i++) {
          uuids.push(serialize(meta.materials, this.material[i]));
        }
        object.material = uuids;
      } else {
        object.material = serialize(meta.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      object.children = [];
      for (let i = 0; i < this.children.length; i++) {
        object.children.push(this.children[i].toJSON(meta).object);
      }
    }
    if (this.animations.length > 0) {
      object.animations = [];
      for (let i = 0; i < this.animations.length; i++) {
        const animation = this.animations[i];
        object.animations.push(serialize(meta.animations, animation));
      }
    }
    if (isRootObject) {
      const geometries = extractFromCache(meta.geometries);
      const materials = extractFromCache(meta.materials);
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      const shapes = extractFromCache(meta.shapes);
      const skeletons = extractFromCache(meta.skeletons);
      const animations = extractFromCache(meta.animations);
      if (geometries.length > 0)
        output.geometries = geometries;
      if (materials.length > 0)
        output.materials = materials;
      if (textures.length > 0)
        output.textures = textures;
      if (images.length > 0)
        output.images = images;
      if (shapes.length > 0)
        output.shapes = shapes;
      if (skeletons.length > 0)
        output.skeletons = skeletons;
      if (animations.length > 0)
        output.animations = animations;
    }
    output.object = object;
    return output;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data = cache[key];
        delete data.metadata;
        values.push(data);
      }
      return values;
    }
  }
  clone(recursive) {
    return new this.constructor().copy(this, recursive);
  }
  copy(source, recursive = true) {
    this.name = source.name;
    this.up.copy(source.up);
    this.position.copy(source.position);
    this.rotation.order = source.rotation.order;
    this.quaternion.copy(source.quaternion);
    this.scale.copy(source.scale);
    this.matrix.copy(source.matrix);
    this.matrixWorld.copy(source.matrixWorld);
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
    this.layers.mask = source.layers.mask;
    this.visible = source.visible;
    this.castShadow = source.castShadow;
    this.receiveShadow = source.receiveShadow;
    this.frustumCulled = source.frustumCulled;
    this.renderOrder = source.renderOrder;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    if (recursive === true) {
      for (let i = 0; i < source.children.length; i++) {
        const child = source.children[i];
        this.add(child.clone());
      }
    }
    return this;
  }
}
Object3D.DefaultUp = new Vector3$1(0, 1, 0);
Object3D.DefaultMatrixAutoUpdate = true;
Object3D.prototype.isObject3D = true;
const _vector1 = /* @__PURE__ */ new Vector3$1();
const _vector2$1 = /* @__PURE__ */ new Vector3$1();
const _normalMatrix = /* @__PURE__ */ new Matrix3$1();
class Plane {
  constructor(normal = new Vector3$1(1, 0, 0), constant = 0) {
    this.normal = normal;
    this.constant = constant;
  }
  set(normal, constant) {
    this.normal.copy(normal);
    this.constant = constant;
    return this;
  }
  setComponents(x, y, z, w) {
    this.normal.set(x, y, z);
    this.constant = w;
    return this;
  }
  setFromNormalAndCoplanarPoint(normal, point) {
    this.normal.copy(normal);
    this.constant = -point.dot(this.normal);
    return this;
  }
  setFromCoplanarPoints(a, b, c) {
    const normal = _vector1.subVectors(c, b).cross(_vector2$1.subVectors(a, b)).normalize();
    this.setFromNormalAndCoplanarPoint(normal, a);
    return this;
  }
  copy(plane) {
    this.normal.copy(plane.normal);
    this.constant = plane.constant;
    return this;
  }
  normalize() {
    const inverseNormalLength = 1 / this.normal.length();
    this.normal.multiplyScalar(inverseNormalLength);
    this.constant *= inverseNormalLength;
    return this;
  }
  negate() {
    this.constant *= -1;
    this.normal.negate();
    return this;
  }
  distanceToPoint(point) {
    return this.normal.dot(point) + this.constant;
  }
  distanceToSphere(sphere) {
    return this.distanceToPoint(sphere.center) - sphere.radius;
  }
  projectPoint(point, target) {
    if (target === void 0) {
      console.warn("THREE.Plane: .projectPoint() target is now required");
      target = new Vector3$1();
    }
    return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
  }
  intersectLine(line, target) {
    if (target === void 0) {
      console.warn("THREE.Plane: .intersectLine() target is now required");
      target = new Vector3$1();
    }
    const direction = line.delta(_vector1);
    const denominator = this.normal.dot(direction);
    if (denominator === 0) {
      if (this.distanceToPoint(line.start) === 0) {
        return target.copy(line.start);
      }
      return null;
    }
    const t = -(line.start.dot(this.normal) + this.constant) / denominator;
    if (t < 0 || t > 1) {
      return null;
    }
    return target.copy(direction).multiplyScalar(t).add(line.start);
  }
  intersectsLine(line) {
    const startSign = this.distanceToPoint(line.start);
    const endSign = this.distanceToPoint(line.end);
    return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
  }
  intersectsBox(box) {
    return box.intersectsPlane(this);
  }
  intersectsSphere(sphere) {
    return sphere.intersectsPlane(this);
  }
  coplanarPoint(target) {
    if (target === void 0) {
      console.warn("THREE.Plane: .coplanarPoint() target is now required");
      target = new Vector3$1();
    }
    return target.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(matrix, optionalNormalMatrix) {
    const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
    const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
    const normal = this.normal.applyMatrix3(normalMatrix).normalize();
    this.constant = -referencePoint.dot(normal);
    return this;
  }
  translate(offset) {
    this.constant -= offset.dot(this.normal);
    return this;
  }
  equals(plane) {
    return plane.normal.equals(this.normal) && plane.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
Plane.prototype.isPlane = true;
const _v0$1 = /* @__PURE__ */ new Vector3$1();
const _v1$3 = /* @__PURE__ */ new Vector3$1();
const _v2$2 = /* @__PURE__ */ new Vector3$1();
const _v3$1 = /* @__PURE__ */ new Vector3$1();
const _vab = /* @__PURE__ */ new Vector3$1();
const _vac = /* @__PURE__ */ new Vector3$1();
const _vbc = /* @__PURE__ */ new Vector3$1();
const _vap = /* @__PURE__ */ new Vector3$1();
const _vbp = /* @__PURE__ */ new Vector3$1();
const _vcp = /* @__PURE__ */ new Vector3$1();
class Triangle {
  constructor(a = new Vector3$1(), b = new Vector3$1(), c = new Vector3$1()) {
    this.a = a;
    this.b = b;
    this.c = c;
  }
  static getNormal(a, b, c, target) {
    if (target === void 0) {
      console.warn("THREE.Triangle: .getNormal() target is now required");
      target = new Vector3$1();
    }
    target.subVectors(c, b);
    _v0$1.subVectors(a, b);
    target.cross(_v0$1);
    const targetLengthSq = target.lengthSq();
    if (targetLengthSq > 0) {
      return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
    }
    return target.set(0, 0, 0);
  }
  static getBarycoord(point, a, b, c, target) {
    _v0$1.subVectors(c, a);
    _v1$3.subVectors(b, a);
    _v2$2.subVectors(point, a);
    const dot00 = _v0$1.dot(_v0$1);
    const dot01 = _v0$1.dot(_v1$3);
    const dot02 = _v0$1.dot(_v2$2);
    const dot11 = _v1$3.dot(_v1$3);
    const dot12 = _v1$3.dot(_v2$2);
    const denom = dot00 * dot11 - dot01 * dot01;
    if (target === void 0) {
      console.warn("THREE.Triangle: .getBarycoord() target is now required");
      target = new Vector3$1();
    }
    if (denom === 0) {
      return target.set(-2, -1, -1);
    }
    const invDenom = 1 / denom;
    const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    return target.set(1 - u - v, v, u);
  }
  static containsPoint(point, a, b, c) {
    this.getBarycoord(point, a, b, c, _v3$1);
    return _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
  }
  static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
    this.getBarycoord(point, p1, p2, p3, _v3$1);
    target.set(0, 0);
    target.addScaledVector(uv1, _v3$1.x);
    target.addScaledVector(uv2, _v3$1.y);
    target.addScaledVector(uv3, _v3$1.z);
    return target;
  }
  static isFrontFacing(a, b, c, direction) {
    _v0$1.subVectors(c, b);
    _v1$3.subVectors(a, b);
    return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
  }
  set(a, b, c) {
    this.a.copy(a);
    this.b.copy(b);
    this.c.copy(c);
    return this;
  }
  setFromPointsAndIndices(points, i0, i1, i2) {
    this.a.copy(points[i0]);
    this.b.copy(points[i1]);
    this.c.copy(points[i2]);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(triangle) {
    this.a.copy(triangle.a);
    this.b.copy(triangle.b);
    this.c.copy(triangle.c);
    return this;
  }
  getArea() {
    _v0$1.subVectors(this.c, this.b);
    _v1$3.subVectors(this.a, this.b);
    return _v0$1.cross(_v1$3).length() * 0.5;
  }
  getMidpoint(target) {
    if (target === void 0) {
      console.warn("THREE.Triangle: .getMidpoint() target is now required");
      target = new Vector3$1();
    }
    return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(target) {
    return Triangle.getNormal(this.a, this.b, this.c, target);
  }
  getPlane(target) {
    if (target === void 0) {
      console.warn("THREE.Triangle: .getPlane() target is now required");
      target = new Plane();
    }
    return target.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(point, target) {
    return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
  }
  getUV(point, uv1, uv2, uv3, target) {
    return Triangle.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
  }
  containsPoint(point) {
    return Triangle.containsPoint(point, this.a, this.b, this.c);
  }
  isFrontFacing(direction) {
    return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
  }
  intersectsBox(box) {
    return box.intersectsTriangle(this);
  }
  closestPointToPoint(p, target) {
    if (target === void 0) {
      console.warn("THREE.Triangle: .closestPointToPoint() target is now required");
      target = new Vector3$1();
    }
    const a = this.a, b = this.b, c = this.c;
    let v, w;
    _vab.subVectors(b, a);
    _vac.subVectors(c, a);
    _vap.subVectors(p, a);
    const d1 = _vab.dot(_vap);
    const d2 = _vac.dot(_vap);
    if (d1 <= 0 && d2 <= 0) {
      return target.copy(a);
    }
    _vbp.subVectors(p, b);
    const d3 = _vab.dot(_vbp);
    const d4 = _vac.dot(_vbp);
    if (d3 >= 0 && d4 <= d3) {
      return target.copy(b);
    }
    const vc = d1 * d4 - d3 * d2;
    if (vc <= 0 && d1 >= 0 && d3 <= 0) {
      v = d1 / (d1 - d3);
      return target.copy(a).addScaledVector(_vab, v);
    }
    _vcp.subVectors(p, c);
    const d5 = _vab.dot(_vcp);
    const d6 = _vac.dot(_vcp);
    if (d6 >= 0 && d5 <= d6) {
      return target.copy(c);
    }
    const vb = d5 * d2 - d1 * d6;
    if (vb <= 0 && d2 >= 0 && d6 <= 0) {
      w = d2 / (d2 - d6);
      return target.copy(a).addScaledVector(_vac, w);
    }
    const va = d3 * d6 - d5 * d4;
    if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
      _vbc.subVectors(c, b);
      w = (d4 - d3) / (d4 - d3 + (d5 - d6));
      return target.copy(b).addScaledVector(_vbc, w);
    }
    const denom = 1 / (va + vb + vc);
    v = vb * denom;
    w = vc * denom;
    return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
  }
  equals(triangle) {
    return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
  }
}
let materialId = 0;
class Material extends EventDispatcher$1 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: materialId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "Material";
    this.fog = true;
    this.blending = NormalBlending;
    this.side = FrontSide;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.blendSrc = SrcAlphaFactor;
    this.blendDst = OneMinusSrcAlphaFactor;
    this.blendEquation = AddEquation;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.depthFunc = LessEqualDepth;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 255;
    this.stencilFunc = AlwaysStencilFunc;
    this.stencilRef = 0;
    this.stencilFuncMask = 255;
    this.stencilFail = KeepStencilOp;
    this.stencilZFail = KeepStencilOp;
    this.stencilZPass = KeepStencilOp;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null;
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaTest = 0;
    this.alphaToCoverage = false;
    this.premultipliedAlpha = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
  }
  onBuild() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(values) {
    if (values === void 0)
      return;
    for (const key in values) {
      const newValue = values[key];
      if (newValue === void 0) {
        console.warn("THREE.Material: '" + key + "' parameter is undefined.");
        continue;
      }
      if (key === "shading") {
        console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        this.flatShading = newValue === FlatShading ? true : false;
        continue;
      }
      const currentValue = this[key];
      if (currentValue === void 0) {
        console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
        continue;
      }
      if (currentValue && currentValue.isColor) {
        currentValue.set(newValue);
      } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
        currentValue.copy(newValue);
      } else {
        this[key] = newValue;
      }
    }
  }
  toJSON(meta) {
    const isRoot = meta === void 0 || typeof meta === "string";
    if (isRoot) {
      meta = {
        textures: {},
        images: {}
      };
    }
    const data = {
      metadata: {
        version: 4.5,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "")
      data.name = this.name;
    if (this.color && this.color.isColor)
      data.color = this.color.getHex();
    if (this.roughness !== void 0)
      data.roughness = this.roughness;
    if (this.metalness !== void 0)
      data.metalness = this.metalness;
    if (this.sheen && this.sheen.isColor)
      data.sheen = this.sheen.getHex();
    if (this.emissive && this.emissive.isColor)
      data.emissive = this.emissive.getHex();
    if (this.emissiveIntensity && this.emissiveIntensity !== 1)
      data.emissiveIntensity = this.emissiveIntensity;
    if (this.specular && this.specular.isColor)
      data.specular = this.specular.getHex();
    if (this.shininess !== void 0)
      data.shininess = this.shininess;
    if (this.clearcoat !== void 0)
      data.clearcoat = this.clearcoat;
    if (this.clearcoatRoughness !== void 0)
      data.clearcoatRoughness = this.clearcoatRoughness;
    if (this.clearcoatMap && this.clearcoatMap.isTexture) {
      data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
    }
    if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
      data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
    }
    if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
      data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
      data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
    }
    if (this.map && this.map.isTexture)
      data.map = this.map.toJSON(meta).uuid;
    if (this.matcap && this.matcap.isTexture)
      data.matcap = this.matcap.toJSON(meta).uuid;
    if (this.alphaMap && this.alphaMap.isTexture)
      data.alphaMap = this.alphaMap.toJSON(meta).uuid;
    if (this.lightMap && this.lightMap.isTexture) {
      data.lightMap = this.lightMap.toJSON(meta).uuid;
      data.lightMapIntensity = this.lightMapIntensity;
    }
    if (this.aoMap && this.aoMap.isTexture) {
      data.aoMap = this.aoMap.toJSON(meta).uuid;
      data.aoMapIntensity = this.aoMapIntensity;
    }
    if (this.bumpMap && this.bumpMap.isTexture) {
      data.bumpMap = this.bumpMap.toJSON(meta).uuid;
      data.bumpScale = this.bumpScale;
    }
    if (this.normalMap && this.normalMap.isTexture) {
      data.normalMap = this.normalMap.toJSON(meta).uuid;
      data.normalMapType = this.normalMapType;
      data.normalScale = this.normalScale.toArray();
    }
    if (this.displacementMap && this.displacementMap.isTexture) {
      data.displacementMap = this.displacementMap.toJSON(meta).uuid;
      data.displacementScale = this.displacementScale;
      data.displacementBias = this.displacementBias;
    }
    if (this.roughnessMap && this.roughnessMap.isTexture)
      data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
    if (this.metalnessMap && this.metalnessMap.isTexture)
      data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
    if (this.emissiveMap && this.emissiveMap.isTexture)
      data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
    if (this.specularMap && this.specularMap.isTexture)
      data.specularMap = this.specularMap.toJSON(meta).uuid;
    if (this.envMap && this.envMap.isTexture) {
      data.envMap = this.envMap.toJSON(meta).uuid;
      if (this.combine !== void 0)
        data.combine = this.combine;
    }
    if (this.envMapIntensity !== void 0)
      data.envMapIntensity = this.envMapIntensity;
    if (this.reflectivity !== void 0)
      data.reflectivity = this.reflectivity;
    if (this.refractionRatio !== void 0)
      data.refractionRatio = this.refractionRatio;
    if (this.gradientMap && this.gradientMap.isTexture) {
      data.gradientMap = this.gradientMap.toJSON(meta).uuid;
    }
    if (this.transmission !== void 0)
      data.transmission = this.transmission;
    if (this.transmissionMap && this.transmissionMap.isTexture)
      data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
    if (this.thickness !== void 0)
      data.thickness = this.thickness;
    if (this.thicknessMap && this.thicknessMap.isTexture)
      data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
    if (this.attenuationDistance !== void 0)
      data.attenuationDistance = this.attenuationDistance;
    if (this.attenuationColor !== void 0)
      data.attenuationColor = this.attenuationColor.getHex();
    if (this.size !== void 0)
      data.size = this.size;
    if (this.shadowSide !== null)
      data.shadowSide = this.shadowSide;
    if (this.sizeAttenuation !== void 0)
      data.sizeAttenuation = this.sizeAttenuation;
    if (this.blending !== NormalBlending)
      data.blending = this.blending;
    if (this.side !== FrontSide)
      data.side = this.side;
    if (this.vertexColors)
      data.vertexColors = true;
    if (this.opacity < 1)
      data.opacity = this.opacity;
    if (this.transparent === true)
      data.transparent = this.transparent;
    data.depthFunc = this.depthFunc;
    data.depthTest = this.depthTest;
    data.depthWrite = this.depthWrite;
    data.colorWrite = this.colorWrite;
    data.stencilWrite = this.stencilWrite;
    data.stencilWriteMask = this.stencilWriteMask;
    data.stencilFunc = this.stencilFunc;
    data.stencilRef = this.stencilRef;
    data.stencilFuncMask = this.stencilFuncMask;
    data.stencilFail = this.stencilFail;
    data.stencilZFail = this.stencilZFail;
    data.stencilZPass = this.stencilZPass;
    if (this.rotation && this.rotation !== 0)
      data.rotation = this.rotation;
    if (this.polygonOffset === true)
      data.polygonOffset = true;
    if (this.polygonOffsetFactor !== 0)
      data.polygonOffsetFactor = this.polygonOffsetFactor;
    if (this.polygonOffsetUnits !== 0)
      data.polygonOffsetUnits = this.polygonOffsetUnits;
    if (this.linewidth && this.linewidth !== 1)
      data.linewidth = this.linewidth;
    if (this.dashSize !== void 0)
      data.dashSize = this.dashSize;
    if (this.gapSize !== void 0)
      data.gapSize = this.gapSize;
    if (this.scale !== void 0)
      data.scale = this.scale;
    if (this.dithering === true)
      data.dithering = true;
    if (this.alphaTest > 0)
      data.alphaTest = this.alphaTest;
    if (this.alphaToCoverage === true)
      data.alphaToCoverage = this.alphaToCoverage;
    if (this.premultipliedAlpha === true)
      data.premultipliedAlpha = this.premultipliedAlpha;
    if (this.wireframe === true)
      data.wireframe = this.wireframe;
    if (this.wireframeLinewidth > 1)
      data.wireframeLinewidth = this.wireframeLinewidth;
    if (this.wireframeLinecap !== "round")
      data.wireframeLinecap = this.wireframeLinecap;
    if (this.wireframeLinejoin !== "round")
      data.wireframeLinejoin = this.wireframeLinejoin;
    if (this.morphTargets === true)
      data.morphTargets = true;
    if (this.morphNormals === true)
      data.morphNormals = true;
    if (this.flatShading === true)
      data.flatShading = this.flatShading;
    if (this.visible === false)
      data.visible = false;
    if (this.toneMapped === false)
      data.toneMapped = false;
    if (JSON.stringify(this.userData) !== "{}")
      data.userData = this.userData;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data2 = cache[key];
        delete data2.metadata;
        values.push(data2);
      }
      return values;
    }
    if (isRoot) {
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      if (textures.length > 0)
        data.textures = textures;
      if (images.length > 0)
        data.images = images;
    }
    return data;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.fog = source.fog;
    this.blending = source.blending;
    this.side = source.side;
    this.vertexColors = source.vertexColors;
    this.opacity = source.opacity;
    this.transparent = source.transparent;
    this.blendSrc = source.blendSrc;
    this.blendDst = source.blendDst;
    this.blendEquation = source.blendEquation;
    this.blendSrcAlpha = source.blendSrcAlpha;
    this.blendDstAlpha = source.blendDstAlpha;
    this.blendEquationAlpha = source.blendEquationAlpha;
    this.depthFunc = source.depthFunc;
    this.depthTest = source.depthTest;
    this.depthWrite = source.depthWrite;
    this.stencilWriteMask = source.stencilWriteMask;
    this.stencilFunc = source.stencilFunc;
    this.stencilRef = source.stencilRef;
    this.stencilFuncMask = source.stencilFuncMask;
    this.stencilFail = source.stencilFail;
    this.stencilZFail = source.stencilZFail;
    this.stencilZPass = source.stencilZPass;
    this.stencilWrite = source.stencilWrite;
    const srcPlanes = source.clippingPlanes;
    let dstPlanes = null;
    if (srcPlanes !== null) {
      const n = srcPlanes.length;
      dstPlanes = new Array(n);
      for (let i = 0; i !== n; ++i) {
        dstPlanes[i] = srcPlanes[i].clone();
      }
    }
    this.clippingPlanes = dstPlanes;
    this.clipIntersection = source.clipIntersection;
    this.clipShadows = source.clipShadows;
    this.shadowSide = source.shadowSide;
    this.colorWrite = source.colorWrite;
    this.precision = source.precision;
    this.polygonOffset = source.polygonOffset;
    this.polygonOffsetFactor = source.polygonOffsetFactor;
    this.polygonOffsetUnits = source.polygonOffsetUnits;
    this.dithering = source.dithering;
    this.alphaTest = source.alphaTest;
    this.alphaToCoverage = source.alphaToCoverage;
    this.premultipliedAlpha = source.premultipliedAlpha;
    this.visible = source.visible;
    this.toneMapped = source.toneMapped;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
}
Material.prototype.isMaterial = true;
const _colorKeywords = {
  "aliceblue": 15792383,
  "antiquewhite": 16444375,
  "aqua": 65535,
  "aquamarine": 8388564,
  "azure": 15794175,
  "beige": 16119260,
  "bisque": 16770244,
  "black": 0,
  "blanchedalmond": 16772045,
  "blue": 255,
  "blueviolet": 9055202,
  "brown": 10824234,
  "burlywood": 14596231,
  "cadetblue": 6266528,
  "chartreuse": 8388352,
  "chocolate": 13789470,
  "coral": 16744272,
  "cornflowerblue": 6591981,
  "cornsilk": 16775388,
  "crimson": 14423100,
  "cyan": 65535,
  "darkblue": 139,
  "darkcyan": 35723,
  "darkgoldenrod": 12092939,
  "darkgray": 11119017,
  "darkgreen": 25600,
  "darkgrey": 11119017,
  "darkkhaki": 12433259,
  "darkmagenta": 9109643,
  "darkolivegreen": 5597999,
  "darkorange": 16747520,
  "darkorchid": 10040012,
  "darkred": 9109504,
  "darksalmon": 15308410,
  "darkseagreen": 9419919,
  "darkslateblue": 4734347,
  "darkslategray": 3100495,
  "darkslategrey": 3100495,
  "darkturquoise": 52945,
  "darkviolet": 9699539,
  "deeppink": 16716947,
  "deepskyblue": 49151,
  "dimgray": 6908265,
  "dimgrey": 6908265,
  "dodgerblue": 2003199,
  "firebrick": 11674146,
  "floralwhite": 16775920,
  "forestgreen": 2263842,
  "fuchsia": 16711935,
  "gainsboro": 14474460,
  "ghostwhite": 16316671,
  "gold": 16766720,
  "goldenrod": 14329120,
  "gray": 8421504,
  "green": 32768,
  "greenyellow": 11403055,
  "grey": 8421504,
  "honeydew": 15794160,
  "hotpink": 16738740,
  "indianred": 13458524,
  "indigo": 4915330,
  "ivory": 16777200,
  "khaki": 15787660,
  "lavender": 15132410,
  "lavenderblush": 16773365,
  "lawngreen": 8190976,
  "lemonchiffon": 16775885,
  "lightblue": 11393254,
  "lightcoral": 15761536,
  "lightcyan": 14745599,
  "lightgoldenrodyellow": 16448210,
  "lightgray": 13882323,
  "lightgreen": 9498256,
  "lightgrey": 13882323,
  "lightpink": 16758465,
  "lightsalmon": 16752762,
  "lightseagreen": 2142890,
  "lightskyblue": 8900346,
  "lightslategray": 7833753,
  "lightslategrey": 7833753,
  "lightsteelblue": 11584734,
  "lightyellow": 16777184,
  "lime": 65280,
  "limegreen": 3329330,
  "linen": 16445670,
  "magenta": 16711935,
  "maroon": 8388608,
  "mediumaquamarine": 6737322,
  "mediumblue": 205,
  "mediumorchid": 12211667,
  "mediumpurple": 9662683,
  "mediumseagreen": 3978097,
  "mediumslateblue": 8087790,
  "mediumspringgreen": 64154,
  "mediumturquoise": 4772300,
  "mediumvioletred": 13047173,
  "midnightblue": 1644912,
  "mintcream": 16121850,
  "mistyrose": 16770273,
  "moccasin": 16770229,
  "navajowhite": 16768685,
  "navy": 128,
  "oldlace": 16643558,
  "olive": 8421376,
  "olivedrab": 7048739,
  "orange": 16753920,
  "orangered": 16729344,
  "orchid": 14315734,
  "palegoldenrod": 15657130,
  "palegreen": 10025880,
  "paleturquoise": 11529966,
  "palevioletred": 14381203,
  "papayawhip": 16773077,
  "peachpuff": 16767673,
  "peru": 13468991,
  "pink": 16761035,
  "plum": 14524637,
  "powderblue": 11591910,
  "purple": 8388736,
  "rebeccapurple": 6697881,
  "red": 16711680,
  "rosybrown": 12357519,
  "royalblue": 4286945,
  "saddlebrown": 9127187,
  "salmon": 16416882,
  "sandybrown": 16032864,
  "seagreen": 3050327,
  "seashell": 16774638,
  "sienna": 10506797,
  "silver": 12632256,
  "skyblue": 8900331,
  "slateblue": 6970061,
  "slategray": 7372944,
  "slategrey": 7372944,
  "snow": 16775930,
  "springgreen": 65407,
  "steelblue": 4620980,
  "tan": 13808780,
  "teal": 32896,
  "thistle": 14204888,
  "tomato": 16737095,
  "turquoise": 4251856,
  "violet": 15631086,
  "wheat": 16113331,
  "white": 16777215,
  "whitesmoke": 16119285,
  "yellow": 16776960,
  "yellowgreen": 10145074
};
const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * 6 * (2 / 3 - t);
  return p;
}
function SRGBToLinear(c) {
  return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c) {
  return c < 31308e-7 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class Color {
  constructor(r, g, b) {
    if (g === void 0 && b === void 0) {
      return this.set(r);
    }
    return this.setRGB(r, g, b);
  }
  set(value) {
    if (value && value.isColor) {
      this.copy(value);
    } else if (typeof value === "number") {
      this.setHex(value);
    } else if (typeof value === "string") {
      this.setStyle(value);
    }
    return this;
  }
  setScalar(scalar) {
    this.r = scalar;
    this.g = scalar;
    this.b = scalar;
    return this;
  }
  setHex(hex) {
    hex = Math.floor(hex);
    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;
    return this;
  }
  setRGB(r, g, b) {
    this.r = r;
    this.g = g;
    this.b = b;
    return this;
  }
  setHSL(h, s, l) {
    h = euclideanModulo(h, 1);
    s = clamp$1(s, 0, 1);
    l = clamp$1(l, 0, 1);
    if (s === 0) {
      this.r = this.g = this.b = l;
    } else {
      const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
      const q = 2 * l - p;
      this.r = hue2rgb(q, p, h + 1 / 3);
      this.g = hue2rgb(q, p, h);
      this.b = hue2rgb(q, p, h - 1 / 3);
    }
    return this;
  }
  setStyle(style2) {
    function handleAlpha(string) {
      if (string === void 0)
        return;
      if (parseFloat(string) < 1) {
        console.warn("THREE.Color: Alpha component of " + style2 + " will be ignored.");
      }
    }
    let m;
    if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style2)) {
      let color;
      const name = m[1];
      const components = m[2];
      switch (name) {
        case "rgb":
        case "rgba":
          if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            this.r = Math.min(255, parseInt(color[1], 10)) / 255;
            this.g = Math.min(255, parseInt(color[2], 10)) / 255;
            this.b = Math.min(255, parseInt(color[3], 10)) / 255;
            handleAlpha(color[4]);
            return this;
          }
          if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            this.r = Math.min(100, parseInt(color[1], 10)) / 100;
            this.g = Math.min(100, parseInt(color[2], 10)) / 100;
            this.b = Math.min(100, parseInt(color[3], 10)) / 100;
            handleAlpha(color[4]);
            return this;
          }
          break;
        case "hsl":
        case "hsla":
          if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            const h = parseFloat(color[1]) / 360;
            const s = parseInt(color[2], 10) / 100;
            const l = parseInt(color[3], 10) / 100;
            handleAlpha(color[4]);
            return this.setHSL(h, s, l);
          }
          break;
      }
    } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style2)) {
      const hex = m[1];
      const size = hex.length;
      if (size === 3) {
        this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
        this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
        this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
        return this;
      } else if (size === 6) {
        this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
        this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
        this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
        return this;
      }
    }
    if (style2 && style2.length > 0) {
      return this.setColorName(style2);
    }
    return this;
  }
  setColorName(style2) {
    const hex = _colorKeywords[style2.toLowerCase()];
    if (hex !== void 0) {
      this.setHex(hex);
    } else {
      console.warn("THREE.Color: Unknown color " + style2);
    }
    return this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(color) {
    this.r = color.r;
    this.g = color.g;
    this.b = color.b;
    return this;
  }
  copyGammaToLinear(color, gammaFactor = 2) {
    this.r = Math.pow(color.r, gammaFactor);
    this.g = Math.pow(color.g, gammaFactor);
    this.b = Math.pow(color.b, gammaFactor);
    return this;
  }
  copyLinearToGamma(color, gammaFactor = 2) {
    const safeInverse = gammaFactor > 0 ? 1 / gammaFactor : 1;
    this.r = Math.pow(color.r, safeInverse);
    this.g = Math.pow(color.g, safeInverse);
    this.b = Math.pow(color.b, safeInverse);
    return this;
  }
  convertGammaToLinear(gammaFactor) {
    this.copyGammaToLinear(this, gammaFactor);
    return this;
  }
  convertLinearToGamma(gammaFactor) {
    this.copyLinearToGamma(this, gammaFactor);
    return this;
  }
  copySRGBToLinear(color) {
    this.r = SRGBToLinear(color.r);
    this.g = SRGBToLinear(color.g);
    this.b = SRGBToLinear(color.b);
    return this;
  }
  copyLinearToSRGB(color) {
    this.r = LinearToSRGB(color.r);
    this.g = LinearToSRGB(color.g);
    this.b = LinearToSRGB(color.b);
    return this;
  }
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  getHex() {
    return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
  }
  getHexString() {
    return ("000000" + this.getHex().toString(16)).slice(-6);
  }
  getHSL(target) {
    if (target === void 0) {
      console.warn("THREE.Color: .getHSL() target is now required");
      target = { h: 0, s: 0, l: 0 };
    }
    const r = this.r, g = this.g, b = this.b;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let hue, saturation;
    const lightness = (min + max) / 2;
    if (min === max) {
      hue = 0;
      saturation = 0;
    } else {
      const delta = max - min;
      saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
      switch (max) {
        case r:
          hue = (g - b) / delta + (g < b ? 6 : 0);
          break;
        case g:
          hue = (b - r) / delta + 2;
          break;
        case b:
          hue = (r - g) / delta + 4;
          break;
      }
      hue /= 6;
    }
    target.h = hue;
    target.s = saturation;
    target.l = lightness;
    return target;
  }
  getStyle() {
    return "rgb(" + (this.r * 255 | 0) + "," + (this.g * 255 | 0) + "," + (this.b * 255 | 0) + ")";
  }
  offsetHSL(h, s, l) {
    this.getHSL(_hslA);
    _hslA.h += h;
    _hslA.s += s;
    _hslA.l += l;
    this.setHSL(_hslA.h, _hslA.s, _hslA.l);
    return this;
  }
  add(color) {
    this.r += color.r;
    this.g += color.g;
    this.b += color.b;
    return this;
  }
  addColors(color1, color2) {
    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;
    return this;
  }
  addScalar(s) {
    this.r += s;
    this.g += s;
    this.b += s;
    return this;
  }
  sub(color) {
    this.r = Math.max(0, this.r - color.r);
    this.g = Math.max(0, this.g - color.g);
    this.b = Math.max(0, this.b - color.b);
    return this;
  }
  multiply(color) {
    this.r *= color.r;
    this.g *= color.g;
    this.b *= color.b;
    return this;
  }
  multiplyScalar(s) {
    this.r *= s;
    this.g *= s;
    this.b *= s;
    return this;
  }
  lerp(color, alpha) {
    this.r += (color.r - this.r) * alpha;
    this.g += (color.g - this.g) * alpha;
    this.b += (color.b - this.b) * alpha;
    return this;
  }
  lerpColors(color1, color2, alpha) {
    this.r = color1.r + (color2.r - color1.r) * alpha;
    this.g = color1.g + (color2.g - color1.g) * alpha;
    this.b = color1.b + (color2.b - color1.b) * alpha;
    return this;
  }
  lerpHSL(color, alpha) {
    this.getHSL(_hslA);
    color.getHSL(_hslB);
    const h = lerp$1(_hslA.h, _hslB.h, alpha);
    const s = lerp$1(_hslA.s, _hslB.s, alpha);
    const l = lerp$1(_hslA.l, _hslB.l, alpha);
    this.setHSL(h, s, l);
    return this;
  }
  equals(c) {
    return c.r === this.r && c.g === this.g && c.b === this.b;
  }
  fromArray(array, offset = 0) {
    this.r = array[offset];
    this.g = array[offset + 1];
    this.b = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.r;
    array[offset + 1] = this.g;
    array[offset + 2] = this.b;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this.r = attribute.getX(index);
    this.g = attribute.getY(index);
    this.b = attribute.getZ(index);
    if (attribute.normalized === true) {
      this.r /= 255;
      this.g /= 255;
      this.b /= 255;
    }
    return this;
  }
  toJSON() {
    return this.getHex();
  }
}
Color.NAMES = _colorKeywords;
Color.prototype.isColor = true;
Color.prototype.r = 1;
Color.prototype.g = 1;
Color.prototype.b = 1;
class MeshBasicMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "MeshBasicMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.morphTargets = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.morphTargets = source.morphTargets;
    return this;
  }
}
MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
const _vector$9 = /* @__PURE__ */ new Vector3$1();
const _vector2 = /* @__PURE__ */ new Vector2$1();
class BufferAttribute {
  constructor(array, itemSize, normalized) {
    if (Array.isArray(array)) {
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    }
    this.name = "";
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== void 0 ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = { offset: 0, count: -1 };
    this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  copy(source) {
    this.name = source.name;
    this.array = new source.array.constructor(source.array);
    this.itemSize = source.itemSize;
    this.count = source.count;
    this.normalized = source.normalized;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.itemSize;
    index2 *= attribute.itemSize;
    for (let i = 0, l = this.itemSize; i < l; i++) {
      this.array[index1 + i] = attribute.array[index2 + i];
    }
    return this;
  }
  copyArray(array) {
    this.array.set(array);
    return this;
  }
  copyColorsArray(colors) {
    const array = this.array;
    let offset = 0;
    for (let i = 0, l = colors.length; i < l; i++) {
      let color = colors[i];
      if (color === void 0) {
        console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i);
        color = new Color();
      }
      array[offset++] = color.r;
      array[offset++] = color.g;
      array[offset++] = color.b;
    }
    return this;
  }
  copyVector2sArray(vectors) {
    const array = this.array;
    let offset = 0;
    for (let i = 0, l = vectors.length; i < l; i++) {
      let vector = vectors[i];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i);
        vector = new Vector2$1();
      }
      array[offset++] = vector.x;
      array[offset++] = vector.y;
    }
    return this;
  }
  copyVector3sArray(vectors) {
    const array = this.array;
    let offset = 0;
    for (let i = 0, l = vectors.length; i < l; i++) {
      let vector = vectors[i];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i);
        vector = new Vector3$1();
      }
      array[offset++] = vector.x;
      array[offset++] = vector.y;
      array[offset++] = vector.z;
    }
    return this;
  }
  copyVector4sArray(vectors) {
    const array = this.array;
    let offset = 0;
    for (let i = 0, l = vectors.length; i < l; i++) {
      let vector = vectors[i];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i);
        vector = new Vector4();
      }
      array[offset++] = vector.x;
      array[offset++] = vector.y;
      array[offset++] = vector.z;
      array[offset++] = vector.w;
    }
    return this;
  }
  applyMatrix3(m) {
    if (this.itemSize === 2) {
      for (let i = 0, l = this.count; i < l; i++) {
        _vector2.fromBufferAttribute(this, i);
        _vector2.applyMatrix3(m);
        this.setXY(i, _vector2.x, _vector2.y);
      }
    } else if (this.itemSize === 3) {
      for (let i = 0, l = this.count; i < l; i++) {
        _vector$9.fromBufferAttribute(this, i);
        _vector$9.applyMatrix3(m);
        this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
      }
    }
    return this;
  }
  applyMatrix4(m) {
    for (let i = 0, l = this.count; i < l; i++) {
      _vector$9.x = this.getX(i);
      _vector$9.y = this.getY(i);
      _vector$9.z = this.getZ(i);
      _vector$9.applyMatrix4(m);
      this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  applyNormalMatrix(m) {
    for (let i = 0, l = this.count; i < l; i++) {
      _vector$9.x = this.getX(i);
      _vector$9.y = this.getY(i);
      _vector$9.z = this.getZ(i);
      _vector$9.applyNormalMatrix(m);
      this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  transformDirection(m) {
    for (let i = 0, l = this.count; i < l; i++) {
      _vector$9.x = this.getX(i);
      _vector$9.y = this.getY(i);
      _vector$9.z = this.getZ(i);
      _vector$9.transformDirection(m);
      this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  getX(index) {
    return this.array[index * this.itemSize];
  }
  setX(index, x) {
    this.array[index * this.itemSize] = x;
    return this;
  }
  getY(index) {
    return this.array[index * this.itemSize + 1];
  }
  setY(index, y) {
    this.array[index * this.itemSize + 1] = y;
    return this;
  }
  getZ(index) {
    return this.array[index * this.itemSize + 2];
  }
  setZ(index, z) {
    this.array[index * this.itemSize + 2] = z;
    return this;
  }
  getW(index) {
    return this.array[index * this.itemSize + 3];
  }
  setW(index, w) {
    this.array[index * this.itemSize + 3] = w;
    return this;
  }
  setXY(index, x, y) {
    index *= this.itemSize;
    this.array[index + 0] = x;
    this.array[index + 1] = y;
    return this;
  }
  setXYZ(index, x, y, z) {
    index *= this.itemSize;
    this.array[index + 0] = x;
    this.array[index + 1] = y;
    this.array[index + 2] = z;
    return this;
  }
  setXYZW(index, x, y, z, w) {
    index *= this.itemSize;
    this.array[index + 0] = x;
    this.array[index + 1] = y;
    this.array[index + 2] = z;
    this.array[index + 3] = w;
    return this;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const data = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.prototype.slice.call(this.array),
      normalized: this.normalized
    };
    if (this.name !== "")
      data.name = this.name;
    if (this.usage !== StaticDrawUsage)
      data.usage = this.usage;
    if (this.updateRange.offset !== 0 || this.updateRange.count !== -1)
      data.updateRange = this.updateRange;
    return data;
  }
}
BufferAttribute.prototype.isBufferAttribute = true;
class Uint16BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
  }
}
class Uint32BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint32Array(array), itemSize, normalized);
  }
}
class Float16BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
  }
}
Float16BufferAttribute.prototype.isFloat16BufferAttribute = true;
class Float32BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Float32Array(array), itemSize, normalized);
  }
}
function arrayMax(array) {
  if (array.length === 0)
    return -Infinity;
  let max = array[0];
  for (let i = 1, l = array.length; i < l; ++i) {
    if (array[i] > max)
      max = array[i];
  }
  return max;
}
let _id = 0;
const _m1 = /* @__PURE__ */ new Matrix4();
const _obj = /* @__PURE__ */ new Object3D();
const _offset = /* @__PURE__ */ new Vector3$1();
const _box$1 = /* @__PURE__ */ new Box3();
const _boxMorphTargets = /* @__PURE__ */ new Box3();
const _vector$8 = /* @__PURE__ */ new Vector3$1();
class BufferGeometry extends EventDispatcher$1 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: _id++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "BufferGeometry";
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = { start: 0, count: Infinity };
    this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(index) {
    if (Array.isArray(index)) {
      this.index = new (arrayMax(index) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
    } else {
      this.index = index;
    }
    return this;
  }
  getAttribute(name) {
    return this.attributes[name];
  }
  setAttribute(name, attribute) {
    this.attributes[name] = attribute;
    return this;
  }
  deleteAttribute(name) {
    delete this.attributes[name];
    return this;
  }
  hasAttribute(name) {
    return this.attributes[name] !== void 0;
  }
  addGroup(start, count, materialIndex = 0) {
    this.groups.push({
      start,
      count,
      materialIndex
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(start, count) {
    this.drawRange.start = start;
    this.drawRange.count = count;
  }
  applyMatrix4(matrix) {
    const position = this.attributes.position;
    if (position !== void 0) {
      position.applyMatrix4(matrix);
      position.needsUpdate = true;
    }
    const normal = this.attributes.normal;
    if (normal !== void 0) {
      const normalMatrix = new Matrix3$1().getNormalMatrix(matrix);
      normal.applyNormalMatrix(normalMatrix);
      normal.needsUpdate = true;
    }
    const tangent = this.attributes.tangent;
    if (tangent !== void 0) {
      tangent.transformDirection(matrix);
      tangent.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    return this;
  }
  applyQuaternion(q) {
    _m1.makeRotationFromQuaternion(q);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateX(angle) {
    _m1.makeRotationX(angle);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateY(angle) {
    _m1.makeRotationY(angle);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateZ(angle) {
    _m1.makeRotationZ(angle);
    this.applyMatrix4(_m1);
    return this;
  }
  translate(x, y, z) {
    _m1.makeTranslation(x, y, z);
    this.applyMatrix4(_m1);
    return this;
  }
  scale(x, y, z) {
    _m1.makeScale(x, y, z);
    this.applyMatrix4(_m1);
    return this;
  }
  lookAt(vector) {
    _obj.lookAt(vector);
    _obj.updateMatrix();
    this.applyMatrix4(_obj.matrix);
    return this;
  }
  center() {
    this.computeBoundingBox();
    this.boundingBox.getCenter(_offset).negate();
    this.translate(_offset.x, _offset.y, _offset.z);
    return this;
  }
  setFromPoints(points) {
    const position = [];
    for (let i = 0, l = points.length; i < l; i++) {
      const point = points[i];
      position.push(point.x, point.y, point.z || 0);
    }
    this.setAttribute("position", new Float32BufferAttribute(position, 3));
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }
    const position = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position && position.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
      this.boundingBox.set(
        new Vector3$1(-Infinity, -Infinity, -Infinity),
        new Vector3$1(Infinity, Infinity, Infinity)
      );
      return;
    }
    if (position !== void 0) {
      this.boundingBox.setFromBufferAttribute(position);
      if (morphAttributesPosition) {
        for (let i = 0, il = morphAttributesPosition.length; i < il; i++) {
          const morphAttribute = morphAttributesPosition[i];
          _box$1.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(this.boundingBox.min, _box$1.min);
            this.boundingBox.expandByPoint(_vector$8);
            _vector$8.addVectors(this.boundingBox.max, _box$1.max);
            this.boundingBox.expandByPoint(_vector$8);
          } else {
            this.boundingBox.expandByPoint(_box$1.min);
            this.boundingBox.expandByPoint(_box$1.max);
          }
        }
      }
    } else {
      this.boundingBox.makeEmpty();
    }
    if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere();
    }
    const position = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position && position.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
      this.boundingSphere.set(new Vector3$1(), Infinity);
      return;
    }
    if (position) {
      const center = this.boundingSphere.center;
      _box$1.setFromBufferAttribute(position);
      if (morphAttributesPosition) {
        for (let i = 0, il = morphAttributesPosition.length; i < il; i++) {
          const morphAttribute = morphAttributesPosition[i];
          _boxMorphTargets.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(_box$1.min, _boxMorphTargets.min);
            _box$1.expandByPoint(_vector$8);
            _vector$8.addVectors(_box$1.max, _boxMorphTargets.max);
            _box$1.expandByPoint(_vector$8);
          } else {
            _box$1.expandByPoint(_boxMorphTargets.min);
            _box$1.expandByPoint(_boxMorphTargets.max);
          }
        }
      }
      _box$1.getCenter(center);
      let maxRadiusSq = 0;
      for (let i = 0, il = position.count; i < il; i++) {
        _vector$8.fromBufferAttribute(position, i);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
      }
      if (morphAttributesPosition) {
        for (let i = 0, il = morphAttributesPosition.length; i < il; i++) {
          const morphAttribute = morphAttributesPosition[i];
          const morphTargetsRelative = this.morphTargetsRelative;
          for (let j = 0, jl = morphAttribute.count; j < jl; j++) {
            _vector$8.fromBufferAttribute(morphAttribute, j);
            if (morphTargetsRelative) {
              _offset.fromBufferAttribute(position, j);
              _vector$8.add(_offset);
            }
            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
          }
        }
      }
      this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
      if (isNaN(this.boundingSphere.radius)) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }
  computeFaceNormals() {
  }
  computeTangents() {
    const index = this.index;
    const attributes = this.attributes;
    if (index === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const indices = index.array;
    const positions = attributes.position.array;
    const normals = attributes.normal.array;
    const uvs = attributes.uv.array;
    const nVertices = positions.length / 3;
    if (attributes.tangent === void 0) {
      this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * nVertices), 4));
    }
    const tangents = attributes.tangent.array;
    const tan1 = [], tan2 = [];
    for (let i = 0; i < nVertices; i++) {
      tan1[i] = new Vector3$1();
      tan2[i] = new Vector3$1();
    }
    const vA = new Vector3$1(), vB = new Vector3$1(), vC = new Vector3$1(), uvA = new Vector2$1(), uvB = new Vector2$1(), uvC = new Vector2$1(), sdir = new Vector3$1(), tdir = new Vector3$1();
    function handleTriangle(a, b, c) {
      vA.fromArray(positions, a * 3);
      vB.fromArray(positions, b * 3);
      vC.fromArray(positions, c * 3);
      uvA.fromArray(uvs, a * 2);
      uvB.fromArray(uvs, b * 2);
      uvC.fromArray(uvs, c * 2);
      vB.sub(vA);
      vC.sub(vA);
      uvB.sub(uvA);
      uvC.sub(uvA);
      const r = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
      if (!isFinite(r))
        return;
      sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
      tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
      tan1[a].add(sdir);
      tan1[b].add(sdir);
      tan1[c].add(sdir);
      tan2[a].add(tdir);
      tan2[b].add(tdir);
      tan2[c].add(tdir);
    }
    let groups = this.groups;
    if (groups.length === 0) {
      groups = [{
        start: 0,
        count: indices.length
      }];
    }
    for (let i = 0, il = groups.length; i < il; ++i) {
      const group = groups[i];
      const start = group.start;
      const count = group.count;
      for (let j = start, jl = start + count; j < jl; j += 3) {
        handleTriangle(
          indices[j + 0],
          indices[j + 1],
          indices[j + 2]
        );
      }
    }
    const tmp2 = new Vector3$1(), tmp22 = new Vector3$1();
    const n = new Vector3$1(), n2 = new Vector3$1();
    function handleVertex(v) {
      n.fromArray(normals, v * 3);
      n2.copy(n);
      const t = tan1[v];
      tmp2.copy(t);
      tmp2.sub(n.multiplyScalar(n.dot(t))).normalize();
      tmp22.crossVectors(n2, t);
      const test = tmp22.dot(tan2[v]);
      const w = test < 0 ? -1 : 1;
      tangents[v * 4] = tmp2.x;
      tangents[v * 4 + 1] = tmp2.y;
      tangents[v * 4 + 2] = tmp2.z;
      tangents[v * 4 + 3] = w;
    }
    for (let i = 0, il = groups.length; i < il; ++i) {
      const group = groups[i];
      const start = group.start;
      const count = group.count;
      for (let j = start, jl = start + count; j < jl; j += 3) {
        handleVertex(indices[j + 0]);
        handleVertex(indices[j + 1]);
        handleVertex(indices[j + 2]);
      }
    }
  }
  computeVertexNormals() {
    const index = this.index;
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute !== void 0) {
      let normalAttribute = this.getAttribute("normal");
      if (normalAttribute === void 0) {
        normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
        this.setAttribute("normal", normalAttribute);
      } else {
        for (let i = 0, il = normalAttribute.count; i < il; i++) {
          normalAttribute.setXYZ(i, 0, 0, 0);
        }
      }
      const pA = new Vector3$1(), pB = new Vector3$1(), pC = new Vector3$1();
      const nA = new Vector3$1(), nB = new Vector3$1(), nC = new Vector3$1();
      const cb = new Vector3$1(), ab = new Vector3$1();
      if (index) {
        for (let i = 0, il = index.count; i < il; i += 3) {
          const vA = index.getX(i + 0);
          const vB = index.getX(i + 1);
          const vC = index.getX(i + 2);
          pA.fromBufferAttribute(positionAttribute, vA);
          pB.fromBufferAttribute(positionAttribute, vB);
          pC.fromBufferAttribute(positionAttribute, vC);
          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);
          nA.fromBufferAttribute(normalAttribute, vA);
          nB.fromBufferAttribute(normalAttribute, vB);
          nC.fromBufferAttribute(normalAttribute, vC);
          nA.add(cb);
          nB.add(cb);
          nC.add(cb);
          normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
          normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
          normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
        }
      } else {
        for (let i = 0, il = positionAttribute.count; i < il; i += 3) {
          pA.fromBufferAttribute(positionAttribute, i + 0);
          pB.fromBufferAttribute(positionAttribute, i + 1);
          pC.fromBufferAttribute(positionAttribute, i + 2);
          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);
          normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
        }
      }
      this.normalizeNormals();
      normalAttribute.needsUpdate = true;
    }
  }
  merge(geometry, offset) {
    if (!(geometry && geometry.isBufferGeometry)) {
      console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry);
      return;
    }
    if (offset === void 0) {
      offset = 0;
      console.warn(
        "THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."
      );
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      if (geometry.attributes[key] === void 0)
        continue;
      const attribute1 = attributes[key];
      const attributeArray1 = attribute1.array;
      const attribute2 = geometry.attributes[key];
      const attributeArray2 = attribute2.array;
      const attributeOffset = attribute2.itemSize * offset;
      const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
      for (let i = 0, j = attributeOffset; i < length; i++, j++) {
        attributeArray1[j] = attributeArray2[i];
      }
    }
    return this;
  }
  normalizeNormals() {
    const normals = this.attributes.normal;
    for (let i = 0, il = normals.count; i < il; i++) {
      _vector$8.fromBufferAttribute(normals, i);
      _vector$8.normalize();
      normals.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
    }
  }
  toNonIndexed() {
    function convertBufferAttribute(attribute, indices2) {
      const array = attribute.array;
      const itemSize = attribute.itemSize;
      const normalized = attribute.normalized;
      const array2 = new array.constructor(indices2.length * itemSize);
      let index = 0, index2 = 0;
      for (let i = 0, l = indices2.length; i < l; i++) {
        index = indices2[i] * itemSize;
        for (let j = 0; j < itemSize; j++) {
          array2[index2++] = array[index++];
        }
      }
      return new BufferAttribute(array2, itemSize, normalized);
    }
    if (this.index === null) {
      console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
      return this;
    }
    const geometry2 = new BufferGeometry();
    const indices = this.index.array;
    const attributes = this.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      const newAttribute = convertBufferAttribute(attribute, indices);
      geometry2.setAttribute(name, newAttribute);
    }
    const morphAttributes = this.morphAttributes;
    for (const name in morphAttributes) {
      const morphArray = [];
      const morphAttribute = morphAttributes[name];
      for (let i = 0, il = morphAttribute.length; i < il; i++) {
        const attribute = morphAttribute[i];
        const newAttribute = convertBufferAttribute(attribute, indices);
        morphArray.push(newAttribute);
      }
      geometry2.morphAttributes[name] = morphArray;
    }
    geometry2.morphTargetsRelative = this.morphTargetsRelative;
    const groups = this.groups;
    for (let i = 0, l = groups.length; i < l; i++) {
      const group = groups[i];
      geometry2.addGroup(group.start, group.count, group.materialIndex);
    }
    return geometry2;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.5,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "")
      data.name = this.name;
    if (Object.keys(this.userData).length > 0)
      data.userData = this.userData;
    if (this.parameters !== void 0) {
      const parameters = this.parameters;
      for (const key in parameters) {
        if (parameters[key] !== void 0)
          data[key] = parameters[key];
      }
      return data;
    }
    data.data = { attributes: {} };
    const index = this.index;
    if (index !== null) {
      data.data.index = {
        type: index.array.constructor.name,
        array: Array.prototype.slice.call(index.array)
      };
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      data.data.attributes[key] = attribute.toJSON(data.data);
    }
    const morphAttributes = {};
    let hasMorphAttributes = false;
    for (const key in this.morphAttributes) {
      const attributeArray = this.morphAttributes[key];
      const array = [];
      for (let i = 0, il = attributeArray.length; i < il; i++) {
        const attribute = attributeArray[i];
        array.push(attribute.toJSON(data.data));
      }
      if (array.length > 0) {
        morphAttributes[key] = array;
        hasMorphAttributes = true;
      }
    }
    if (hasMorphAttributes) {
      data.data.morphAttributes = morphAttributes;
      data.data.morphTargetsRelative = this.morphTargetsRelative;
    }
    const groups = this.groups;
    if (groups.length > 0) {
      data.data.groups = JSON.parse(JSON.stringify(groups));
    }
    const boundingSphere = this.boundingSphere;
    if (boundingSphere !== null) {
      data.data.boundingSphere = {
        center: boundingSphere.center.toArray(),
        radius: boundingSphere.radius
      };
    }
    return data;
  }
  clone() {
    return new BufferGeometry().copy(this);
  }
  copy(source) {
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    const data = {};
    this.name = source.name;
    const index = source.index;
    if (index !== null) {
      this.setIndex(index.clone(data));
    }
    const attributes = source.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      this.setAttribute(name, attribute.clone(data));
    }
    const morphAttributes = source.morphAttributes;
    for (const name in morphAttributes) {
      const array = [];
      const morphAttribute = morphAttributes[name];
      for (let i = 0, l = morphAttribute.length; i < l; i++) {
        array.push(morphAttribute[i].clone(data));
      }
      this.morphAttributes[name] = array;
    }
    this.morphTargetsRelative = source.morphTargetsRelative;
    const groups = source.groups;
    for (let i = 0, l = groups.length; i < l; i++) {
      const group = groups[i];
      this.addGroup(group.start, group.count, group.materialIndex);
    }
    const boundingBox = source.boundingBox;
    if (boundingBox !== null) {
      this.boundingBox = boundingBox.clone();
    }
    const boundingSphere = source.boundingSphere;
    if (boundingSphere !== null) {
      this.boundingSphere = boundingSphere.clone();
    }
    this.drawRange.start = source.drawRange.start;
    this.drawRange.count = source.drawRange.count;
    this.userData = source.userData;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
BufferGeometry.prototype.isBufferGeometry = true;
const _inverseMatrix$2 = /* @__PURE__ */ new Matrix4();
const _ray$2 = /* @__PURE__ */ new Ray();
const _sphere$3 = /* @__PURE__ */ new Sphere();
const _vA$1 = /* @__PURE__ */ new Vector3$1();
const _vB$1 = /* @__PURE__ */ new Vector3$1();
const _vC$1 = /* @__PURE__ */ new Vector3$1();
const _tempA = /* @__PURE__ */ new Vector3$1();
const _tempB = /* @__PURE__ */ new Vector3$1();
const _tempC = /* @__PURE__ */ new Vector3$1();
const _morphA = /* @__PURE__ */ new Vector3$1();
const _morphB = /* @__PURE__ */ new Vector3$1();
const _morphC = /* @__PURE__ */ new Vector3$1();
const _uvA$1 = /* @__PURE__ */ new Vector2$1();
const _uvB$1 = /* @__PURE__ */ new Vector2$1();
const _uvC$1 = /* @__PURE__ */ new Vector2$1();
const _intersectionPoint = /* @__PURE__ */ new Vector3$1();
const _intersectionPointWorld = /* @__PURE__ */ new Vector3$1();
class Mesh extends Object3D {
  constructor(geometry = new BufferGeometry(), material = new MeshBasicMaterial()) {
    super();
    this.type = "Mesh";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    if (source.morphTargetInfluences !== void 0) {
      this.morphTargetInfluences = source.morphTargetInfluences.slice();
    }
    if (source.morphTargetDictionary !== void 0) {
      this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
    }
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    } else {
      const morphTargets = geometry.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0)
      return;
    if (geometry.boundingSphere === null)
      geometry.computeBoundingSphere();
    _sphere$3.copy(geometry.boundingSphere);
    _sphere$3.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$3) === false)
      return;
    _inverseMatrix$2.copy(matrixWorld).invert();
    _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
    if (geometry.boundingBox !== null) {
      if (_ray$2.intersectsBox(geometry.boundingBox) === false)
        return;
    }
    let intersection;
    if (geometry.isBufferGeometry) {
      const index = geometry.index;
      const position = geometry.attributes.position;
      const morphPosition = geometry.morphAttributes.position;
      const morphTargetsRelative = geometry.morphTargetsRelative;
      const uv = geometry.attributes.uv;
      const uv2 = geometry.attributes.uv2;
      const groups = geometry.groups;
      const drawRange = geometry.drawRange;
      if (index !== null) {
        if (Array.isArray(material)) {
          for (let i = 0, il = groups.length; i < il; i++) {
            const group = groups[i];
            const groupMaterial = material[group.materialIndex];
            const start = Math.max(group.start, drawRange.start);
            const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for (let j = start, jl = end; j < jl; j += 3) {
              const a = index.getX(j);
              const b = index.getX(j + 1);
              const c = index.getX(j + 2);
              intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
              if (intersection) {
                intersection.faceIndex = Math.floor(j / 3);
                intersection.face.materialIndex = group.materialIndex;
                intersects2.push(intersection);
              }
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(index.count, drawRange.start + drawRange.count);
          for (let i = start, il = end; i < il; i += 3) {
            const a = index.getX(i);
            const b = index.getX(i + 1);
            const c = index.getX(i + 2);
            intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
            if (intersection) {
              intersection.faceIndex = Math.floor(i / 3);
              intersects2.push(intersection);
            }
          }
        }
      } else if (position !== void 0) {
        if (Array.isArray(material)) {
          for (let i = 0, il = groups.length; i < il; i++) {
            const group = groups[i];
            const groupMaterial = material[group.materialIndex];
            const start = Math.max(group.start, drawRange.start);
            const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for (let j = start, jl = end; j < jl; j += 3) {
              const a = j;
              const b = j + 1;
              const c = j + 2;
              intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
              if (intersection) {
                intersection.faceIndex = Math.floor(j / 3);
                intersection.face.materialIndex = group.materialIndex;
                intersects2.push(intersection);
              }
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(position.count, drawRange.start + drawRange.count);
          for (let i = start, il = end; i < il; i += 3) {
            const a = i;
            const b = i + 1;
            const c = i + 2;
            intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
            if (intersection) {
              intersection.faceIndex = Math.floor(i / 3);
              intersects2.push(intersection);
            }
          }
        }
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
}
Mesh.prototype.isMesh = true;
function checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
  let intersect;
  if (material.side === BackSide) {
    intersect = ray.intersectTriangle(pC, pB, pA, true, point);
  } else {
    intersect = ray.intersectTriangle(pA, pB, pC, material.side !== DoubleSide, point);
  }
  if (intersect === null)
    return null;
  _intersectionPointWorld.copy(point);
  _intersectionPointWorld.applyMatrix4(object.matrixWorld);
  const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
  if (distance < raycaster.near || distance > raycaster.far)
    return null;
  return {
    distance,
    point: _intersectionPointWorld.clone(),
    object
  };
}
function checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
  _vA$1.fromBufferAttribute(position, a);
  _vB$1.fromBufferAttribute(position, b);
  _vC$1.fromBufferAttribute(position, c);
  const morphInfluences = object.morphTargetInfluences;
  if (material.morphTargets && morphPosition && morphInfluences) {
    _morphA.set(0, 0, 0);
    _morphB.set(0, 0, 0);
    _morphC.set(0, 0, 0);
    for (let i = 0, il = morphPosition.length; i < il; i++) {
      const influence = morphInfluences[i];
      const morphAttribute = morphPosition[i];
      if (influence === 0)
        continue;
      _tempA.fromBufferAttribute(morphAttribute, a);
      _tempB.fromBufferAttribute(morphAttribute, b);
      _tempC.fromBufferAttribute(morphAttribute, c);
      if (morphTargetsRelative) {
        _morphA.addScaledVector(_tempA, influence);
        _morphB.addScaledVector(_tempB, influence);
        _morphC.addScaledVector(_tempC, influence);
      } else {
        _morphA.addScaledVector(_tempA.sub(_vA$1), influence);
        _morphB.addScaledVector(_tempB.sub(_vB$1), influence);
        _morphC.addScaledVector(_tempC.sub(_vC$1), influence);
      }
    }
    _vA$1.add(_morphA);
    _vB$1.add(_morphB);
    _vC$1.add(_morphC);
  }
  if (object.isSkinnedMesh) {
    object.boneTransform(a, _vA$1);
    object.boneTransform(b, _vB$1);
    object.boneTransform(c, _vC$1);
  }
  const intersection = checkIntersection(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
  if (intersection) {
    if (uv) {
      _uvA$1.fromBufferAttribute(uv, a);
      _uvB$1.fromBufferAttribute(uv, b);
      _uvC$1.fromBufferAttribute(uv, c);
      intersection.uv = Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2$1());
    }
    if (uv2) {
      _uvA$1.fromBufferAttribute(uv2, a);
      _uvB$1.fromBufferAttribute(uv2, b);
      _uvC$1.fromBufferAttribute(uv2, c);
      intersection.uv2 = Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2$1());
    }
    const face = {
      a,
      b,
      c,
      normal: new Vector3$1(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
    intersection.face = face;
  }
  return intersection;
}
class BoxGeometry extends BufferGeometry {
  constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
    super();
    this.type = "BoxGeometry";
    this.parameters = {
      width,
      height,
      depth,
      widthSegments,
      heightSegments,
      depthSegments
    };
    const scope = this;
    widthSegments = Math.floor(widthSegments);
    heightSegments = Math.floor(heightSegments);
    depthSegments = Math.floor(depthSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let numberOfVertices = 0;
    let groupStart = 0;
    buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0);
    buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1);
    buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2);
    buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3);
    buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4);
    buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5);
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function buildPlane(u, v, w, udir, vdir, width2, height2, depth2, gridX, gridY, materialIndex) {
      const segmentWidth = width2 / gridX;
      const segmentHeight = height2 / gridY;
      const widthHalf = width2 / 2;
      const heightHalf = height2 / 2;
      const depthHalf = depth2 / 2;
      const gridX1 = gridX + 1;
      const gridY1 = gridY + 1;
      let vertexCounter = 0;
      let groupCount = 0;
      const vector = new Vector3$1();
      for (let iy = 0; iy < gridY1; iy++) {
        const y = iy * segmentHeight - heightHalf;
        for (let ix = 0; ix < gridX1; ix++) {
          const x = ix * segmentWidth - widthHalf;
          vector[u] = x * udir;
          vector[v] = y * vdir;
          vector[w] = depthHalf;
          vertices.push(vector.x, vector.y, vector.z);
          vector[u] = 0;
          vector[v] = 0;
          vector[w] = depth2 > 0 ? 1 : -1;
          normals.push(vector.x, vector.y, vector.z);
          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY);
          vertexCounter += 1;
        }
      }
      for (let iy = 0; iy < gridY; iy++) {
        for (let ix = 0; ix < gridX; ix++) {
          const a = numberOfVertices + ix + gridX1 * iy;
          const b = numberOfVertices + ix + gridX1 * (iy + 1);
          const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
          const d = numberOfVertices + (ix + 1) + gridX1 * iy;
          indices.push(a, b, d);
          indices.push(b, c, d);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, materialIndex);
      groupStart += groupCount;
      numberOfVertices += vertexCounter;
    }
  }
}
function cloneUniforms(src) {
  const dst = {};
  for (const u in src) {
    dst[u] = {};
    for (const p in src[u]) {
      const property = src[u][p];
      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        dst[u][p] = property.clone();
      } else if (Array.isArray(property)) {
        dst[u][p] = property.slice();
      } else {
        dst[u][p] = property;
      }
    }
  }
  return dst;
}
function mergeUniforms(uniforms) {
  const merged = {};
  for (let u = 0; u < uniforms.length; u++) {
    const tmp2 = cloneUniforms(uniforms[u]);
    for (const p in tmp2) {
      merged[p] = tmp2[p];
    }
  }
  return merged;
}
const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
var default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class ShaderMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "ShaderMaterial";
    this.defines = {};
    this.uniforms = {};
    this.vertexShader = default_vertex;
    this.fragmentShader = default_fragment;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.lights = false;
    this.clipping = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.extensions = {
      derivatives: false,
      fragDepth: false,
      drawBuffers: false,
      shaderTextureLOD: false
    };
    this.defaultAttributeValues = {
      "color": [1, 1, 1],
      "uv": [0, 0],
      "uv2": [0, 0]
    };
    this.index0AttributeName = void 0;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== void 0) {
      if (parameters.attributes !== void 0) {
        console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
      }
      this.setValues(parameters);
    }
  }
  copy(source) {
    super.copy(source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms(source.uniforms);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.glslVersion = this.glslVersion;
    data.uniforms = {};
    for (const name in this.uniforms) {
      const uniform = this.uniforms[name];
      const value = uniform.value;
      if (value && value.isTexture) {
        data.uniforms[name] = {
          type: "t",
          value: value.toJSON(meta).uuid
        };
      } else if (value && value.isColor) {
        data.uniforms[name] = {
          type: "c",
          value: value.getHex()
        };
      } else if (value && value.isVector2) {
        data.uniforms[name] = {
          type: "v2",
          value: value.toArray()
        };
      } else if (value && value.isVector3) {
        data.uniforms[name] = {
          type: "v3",
          value: value.toArray()
        };
      } else if (value && value.isVector4) {
        data.uniforms[name] = {
          type: "v4",
          value: value.toArray()
        };
      } else if (value && value.isMatrix3) {
        data.uniforms[name] = {
          type: "m3",
          value: value.toArray()
        };
      } else if (value && value.isMatrix4) {
        data.uniforms[name] = {
          type: "m4",
          value: value.toArray()
        };
      } else {
        data.uniforms[name] = {
          value
        };
      }
    }
    if (Object.keys(this.defines).length > 0)
      data.defines = this.defines;
    data.vertexShader = this.vertexShader;
    data.fragmentShader = this.fragmentShader;
    const extensions = {};
    for (const key in this.extensions) {
      if (this.extensions[key] === true)
        extensions[key] = true;
    }
    if (Object.keys(extensions).length > 0)
      data.extensions = extensions;
    return data;
  }
}
ShaderMaterial.prototype.isShaderMaterial = true;
class Camera$1 extends Object3D {
  constructor() {
    super();
    this.type = "Camera";
    this.matrixWorldInverse = new Matrix4();
    this.projectionMatrix = new Matrix4();
    this.projectionMatrixInverse = new Matrix4();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.matrixWorldInverse.copy(source.matrixWorldInverse);
    this.projectionMatrix.copy(source.projectionMatrix);
    this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
    return this;
  }
  getWorldDirection(target) {
    if (target === void 0) {
      console.warn("THREE.Camera: .getWorldDirection() target is now required");
      target = new Vector3$1();
    }
    this.updateWorldMatrix(true, false);
    const e = this.matrixWorld.elements;
    return target.set(-e[8], -e[9], -e[10]).normalize();
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(updateParents, updateChildren) {
    super.updateWorldMatrix(updateParents, updateChildren);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
Camera$1.prototype.isCamera = true;
class PerspectiveCamera extends Camera$1 {
  constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
    super();
    this.type = "PerspectiveCamera";
    this.fov = fov2;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect2;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.fov = source.fov;
    this.zoom = source.zoom;
    this.near = source.near;
    this.far = source.far;
    this.focus = source.focus;
    this.aspect = source.aspect;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    this.filmGauge = source.filmGauge;
    this.filmOffset = source.filmOffset;
    return this;
  }
  setFocalLength(focalLength) {
    const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
    this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
    this.updateProjectionMatrix();
  }
  getFocalLength() {
    const vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / vExtentSlope;
  }
  getEffectiveFOV() {
    return RAD2DEG * 2 * Math.atan(
      Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  setViewOffset(fullWidth, fullHeight, x, y, width, height) {
    this.aspect = fullWidth / fullHeight;
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x;
    this.view.offsetY = y;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const near = this.near;
    let top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
    let height = 2 * top;
    let width = this.aspect * height;
    let left = -0.5 * width;
    const view = this.view;
    if (this.view !== null && this.view.enabled) {
      const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
      left += view.offsetX * width / fullWidth;
      top -= view.offsetY * height / fullHeight;
      width *= view.width / fullWidth;
      height *= view.height / fullHeight;
    }
    const skew = this.filmOffset;
    if (skew !== 0)
      left += near * skew / this.getFilmWidth();
    this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.fov = this.fov;
    data.object.zoom = this.zoom;
    data.object.near = this.near;
    data.object.far = this.far;
    data.object.focus = this.focus;
    data.object.aspect = this.aspect;
    if (this.view !== null)
      data.object.view = Object.assign({}, this.view);
    data.object.filmGauge = this.filmGauge;
    data.object.filmOffset = this.filmOffset;
    return data;
  }
}
PerspectiveCamera.prototype.isPerspectiveCamera = true;
const fov = 90, aspect = 1;
class CubeCamera extends Object3D {
  constructor(near, far, renderTarget) {
    super();
    this.type = "CubeCamera";
    if (renderTarget.isWebGLCubeRenderTarget !== true) {
      console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
      return;
    }
    this.renderTarget = renderTarget;
    const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
    cameraPX.layers = this.layers;
    cameraPX.up.set(0, -1, 0);
    cameraPX.lookAt(new Vector3$1(1, 0, 0));
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
    cameraNX.layers = this.layers;
    cameraNX.up.set(0, -1, 0);
    cameraNX.lookAt(new Vector3$1(-1, 0, 0));
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
    cameraPY.layers = this.layers;
    cameraPY.up.set(0, 0, 1);
    cameraPY.lookAt(new Vector3$1(0, 1, 0));
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
    cameraNY.layers = this.layers;
    cameraNY.up.set(0, 0, -1);
    cameraNY.lookAt(new Vector3$1(0, -1, 0));
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraPZ.layers = this.layers;
    cameraPZ.up.set(0, -1, 0);
    cameraPZ.lookAt(new Vector3$1(0, 0, 1));
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraNZ.layers = this.layers;
    cameraNZ.up.set(0, -1, 0);
    cameraNZ.lookAt(new Vector3$1(0, 0, -1));
    this.add(cameraNZ);
  }
  update(renderer, scene) {
    if (this.parent === null)
      this.updateMatrixWorld();
    const renderTarget = this.renderTarget;
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
    const currentXrEnabled = renderer.xr.enabled;
    const currentRenderTarget = renderer.getRenderTarget();
    renderer.xr.enabled = false;
    const generateMipmaps = renderTarget.texture.generateMipmaps;
    renderTarget.texture.generateMipmaps = false;
    renderer.setRenderTarget(renderTarget, 0);
    renderer.render(scene, cameraPX);
    renderer.setRenderTarget(renderTarget, 1);
    renderer.render(scene, cameraNX);
    renderer.setRenderTarget(renderTarget, 2);
    renderer.render(scene, cameraPY);
    renderer.setRenderTarget(renderTarget, 3);
    renderer.render(scene, cameraNY);
    renderer.setRenderTarget(renderTarget, 4);
    renderer.render(scene, cameraPZ);
    renderTarget.texture.generateMipmaps = generateMipmaps;
    renderer.setRenderTarget(renderTarget, 5);
    renderer.render(scene, cameraNZ);
    renderer.setRenderTarget(currentRenderTarget);
    renderer.xr.enabled = currentXrEnabled;
  }
}
class CubeTexture$1 extends Texture$1 {
  constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    images = images !== void 0 ? images : [];
    mapping = mapping !== void 0 ? mapping : CubeReflectionMapping$1;
    format = format !== void 0 ? format : RGBFormat$1;
    super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this._needsFlipEnvMap = true;
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(value) {
    this.image = value;
  }
}
CubeTexture$1.prototype.isCubeTexture = true;
class WebGLCubeRenderTarget extends WebGLRenderTarget {
  constructor(size, options, dummy) {
    if (Number.isInteger(options)) {
      console.warn("THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )");
      options = dummy;
    }
    super(size, size, options);
    options = options || {};
    this.texture = new CubeTexture$1(void 0, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    this.texture.generateMipmaps = options.generateMipmaps !== void 0 ? options.generateMipmaps : false;
    this.texture.minFilter = options.minFilter !== void 0 ? options.minFilter : LinearFilter$1;
    this.texture._needsFlipEnvMap = false;
  }
  fromEquirectangularTexture(renderer, texture) {
    this.texture.type = texture.type;
    this.texture.format = RGBAFormat$1;
    this.texture.encoding = texture.encoding;
    this.texture.generateMipmaps = texture.generateMipmaps;
    this.texture.minFilter = texture.minFilter;
    this.texture.magFilter = texture.magFilter;
    const shader = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
      fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
    };
    const geometry = new BoxGeometry(5, 5, 5);
    const material = new ShaderMaterial({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms(shader.uniforms),
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader,
      side: BackSide,
      blending: NoBlending
    });
    material.uniforms.tEquirect.value = texture;
    const mesh = new Mesh(geometry, material);
    const currentMinFilter = texture.minFilter;
    if (texture.minFilter === LinearMipmapLinearFilter$1)
      texture.minFilter = LinearFilter$1;
    const camera = new CubeCamera(1, 10, this);
    camera.update(renderer, mesh);
    texture.minFilter = currentMinFilter;
    mesh.geometry.dispose();
    mesh.material.dispose();
    return this;
  }
  clear(renderer, color, depth, stencil) {
    const currentRenderTarget = renderer.getRenderTarget();
    for (let i = 0; i < 6; i++) {
      renderer.setRenderTarget(this, i);
      renderer.clear(color, depth, stencil);
    }
    renderer.setRenderTarget(currentRenderTarget);
  }
}
WebGLCubeRenderTarget.prototype.isWebGLCubeRenderTarget = true;
const _sphere$2 = /* @__PURE__ */ new Sphere();
const _vector$7 = /* @__PURE__ */ new Vector3$1();
class Frustum {
  constructor(p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane()) {
    this.planes = [p0, p1, p2, p3, p4, p5];
  }
  set(p0, p1, p2, p3, p4, p5) {
    const planes = this.planes;
    planes[0].copy(p0);
    planes[1].copy(p1);
    planes[2].copy(p2);
    planes[3].copy(p3);
    planes[4].copy(p4);
    planes[5].copy(p5);
    return this;
  }
  copy(frustum) {
    const planes = this.planes;
    for (let i = 0; i < 6; i++) {
      planes[i].copy(frustum.planes[i]);
    }
    return this;
  }
  setFromProjectionMatrix(m) {
    const planes = this.planes;
    const me = m.elements;
    const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
    planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
    planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
    planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
    planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
    planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
    return this;
  }
  intersectsObject(object) {
    const geometry = object.geometry;
    if (geometry.boundingSphere === null)
      geometry.computeBoundingSphere();
    _sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
    return this.intersectsSphere(_sphere$2);
  }
  intersectsSprite(sprite) {
    _sphere$2.center.set(0, 0, 0);
    _sphere$2.radius = 0.7071067811865476;
    _sphere$2.applyMatrix4(sprite.matrixWorld);
    return this.intersectsSphere(_sphere$2);
  }
  intersectsSphere(sphere) {
    const planes = this.planes;
    const center = sphere.center;
    const negRadius = -sphere.radius;
    for (let i = 0; i < 6; i++) {
      const distance = planes[i].distanceToPoint(center);
      if (distance < negRadius) {
        return false;
      }
    }
    return true;
  }
  intersectsBox(box) {
    const planes = this.planes;
    for (let i = 0; i < 6; i++) {
      const plane = planes[i];
      _vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
      _vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
      _vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
      if (plane.distanceToPoint(_vector$7) < 0) {
        return false;
      }
    }
    return true;
  }
  containsPoint(point) {
    const planes = this.planes;
    for (let i = 0; i < 6; i++) {
      if (planes[i].distanceToPoint(point) < 0) {
        return false;
      }
    }
    return true;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function WebGLAnimation() {
  let context = null;
  let isAnimating = false;
  let animationLoop = null;
  let requestId = null;
  function onAnimationFrame(time, frame) {
    animationLoop(time, frame);
    requestId = context.requestAnimationFrame(onAnimationFrame);
  }
  return {
    start: function() {
      if (isAnimating === true)
        return;
      if (animationLoop === null)
        return;
      requestId = context.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function() {
      context.cancelAnimationFrame(requestId);
      isAnimating = false;
    },
    setAnimationLoop: function(callback) {
      animationLoop = callback;
    },
    setContext: function(value) {
      context = value;
    }
  };
}
function WebGLAttributes(gl, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  const buffers = /* @__PURE__ */ new WeakMap();
  function createBuffer(attribute, bufferType) {
    const array = attribute.array;
    const usage = attribute.usage;
    const buffer = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer);
    gl.bufferData(bufferType, array, usage);
    attribute.onUploadCallback();
    let type = 5126;
    if (array instanceof Float32Array) {
      type = 5126;
    } else if (array instanceof Float64Array) {
      console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.");
    } else if (array instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        if (isWebGL2) {
          type = 5131;
        } else {
          console.warn("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
        }
      } else {
        type = 5123;
      }
    } else if (array instanceof Int16Array) {
      type = 5122;
    } else if (array instanceof Uint32Array) {
      type = 5125;
    } else if (array instanceof Int32Array) {
      type = 5124;
    } else if (array instanceof Int8Array) {
      type = 5120;
    } else if (array instanceof Uint8Array) {
      type = 5121;
    } else if (array instanceof Uint8ClampedArray) {
      type = 5121;
    }
    return {
      buffer,
      type,
      bytesPerElement: array.BYTES_PER_ELEMENT,
      version: attribute.version
    };
  }
  function updateBuffer(buffer, attribute, bufferType) {
    const array = attribute.array;
    const updateRange = attribute.updateRange;
    gl.bindBuffer(bufferType, buffer);
    if (updateRange.count === -1) {
      gl.bufferSubData(bufferType, 0, array);
    } else {
      if (isWebGL2) {
        gl.bufferSubData(
          bufferType,
          updateRange.offset * array.BYTES_PER_ELEMENT,
          array,
          updateRange.offset,
          updateRange.count
        );
      } else {
        gl.bufferSubData(
          bufferType,
          updateRange.offset * array.BYTES_PER_ELEMENT,
          array.subarray(updateRange.offset, updateRange.offset + updateRange.count)
        );
      }
      updateRange.count = -1;
    }
  }
  function get(attribute) {
    if (attribute.isInterleavedBufferAttribute)
      attribute = attribute.data;
    return buffers.get(attribute);
  }
  function remove(attribute) {
    if (attribute.isInterleavedBufferAttribute)
      attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data) {
      gl.deleteBuffer(data.buffer);
      buffers.delete(attribute);
    }
  }
  function update(attribute, bufferType) {
    if (attribute.isGLBufferAttribute) {
      const cached = buffers.get(attribute);
      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }
      return;
    }
    if (attribute.isInterleavedBufferAttribute)
      attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data === void 0) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data.version < attribute.version) {
      updateBuffer(data.buffer, attribute, bufferType);
      data.version = attribute.version;
    }
  }
  return {
    get,
    remove,
    update
  };
}
class PlaneGeometry extends BufferGeometry {
  constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
    super();
    this.type = "PlaneGeometry";
    this.parameters = {
      width,
      height,
      widthSegments,
      heightSegments
    };
    const width_half = width / 2;
    const height_half = height / 2;
    const gridX = Math.floor(widthSegments);
    const gridY = Math.floor(heightSegments);
    const gridX1 = gridX + 1;
    const gridY1 = gridY + 1;
    const segment_width = width / gridX;
    const segment_height = height / gridY;
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy < gridY1; iy++) {
      const y = iy * segment_height - height_half;
      for (let ix = 0; ix < gridX1; ix++) {
        const x = ix * segment_width - width_half;
        vertices.push(x, -y, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }
    for (let iy = 0; iy < gridY; iy++) {
      for (let ix = 0; ix < gridX; ix++) {
        const a = ix + gridX1 * iy;
        const b = ix + gridX1 * (iy + 1);
        const c = ix + 1 + gridX1 * (iy + 1);
        const d = ix + 1 + gridX1 * iy;
        indices.push(a, b, d);
        indices.push(b, c, d);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
}
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef ALPHATEST\n	if ( diffuseColor.a < ALPHATEST ) discard;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n	#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	return vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n#else\n	if( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n		return pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n	}\n	return 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n	float fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n	return ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n	float fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n	vec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n	return Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	float gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	return 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( incidentLight.direction + viewDir );\n	float dotNL = saturate( dot( normal, incidentLight.direction ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n	vec3 F = F_Schlick( specularColor, dotLH );\n	float G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n	return specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n	float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n	vec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n	vec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n	vec3 FssEss = F * brdf.x + brdf.y;\n	float Ess = brdf.x + brdf.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n	float dotNH = saturate( dot( geometry.normal, halfDir ) );\n	float dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n	vec3 F = F_Schlick( specularColor, dotLH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n	return ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n	return sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n	float invAlpha = 1.0 / roughness;\n	float cos2h = NoH * NoH;\n	float sin2h = max(1.0 - cos2h, 0.0078125);	return (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n	return saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n	vec3 N = geometry.normal;\n	vec3 V = geometry.viewDir;\n	vec3 H = normalize( V + L );\n	float dotNH = saturate( dot( N, H ) );\n	return specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	float distance = dot( planeNormal, point - pointOnPlane );\n	return - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	return sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	return lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_maxMipLevel 8.0\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_maxTileSize 256.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		float texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n		vec2 f = fract( uv );\n		uv += 0.5 - f;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		if ( mipInt < cubeUV_maxMipLevel ) {\n			uv.y += 2.0 * cubeUV_maxTileSize;\n		}\n		uv.y += filterInt * 2.0 * cubeUV_minTileSize;\n		uv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n		uv *= texelSize;\n		vec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.x += texelSize;\n		vec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.y += texelSize;\n		vec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.x -= texelSize;\n		vec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		vec3 tm = mix( tl, tr, f.x );\n		vec3 bm = mix( bl, br, f.x );\n		return mix( tm, bm, f.y );\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	emissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n	return vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n	return vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n	return vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n	float maxComponent = max( max( value.r, value.g ), value.b );\n	float fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n	return vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n	return vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n	float maxRGB = max( value.r, max( value.g, value.b ) );\n	float M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n	M = ceil( M * 255.0 ) / 255.0;\n	return vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n	return vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n	float maxRGB = max( value.r, max( value.g, value.b ) );\n	float D = max( maxRange / maxRGB, 1.0 );\n	D = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n	return vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n	vec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n	Xp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n	vec4 vResult;\n	vResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n	float Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n	vResult.w = fract( Le );\n	vResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n	return vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n	float Le = value.z * 255.0 + value.w;\n	vec3 Xp_Y_XYZp;\n	Xp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n	Xp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n	Xp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n	vec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n	return vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifndef ENVMAP_TYPE_CUBE_UV\n		envColor = envMapTexelToLinear( envColor );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform int maxMipLevel;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n	fogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n	varying float fogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float fogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return texture2D( gradientMap, coord ).rgb;\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n	reflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = PI * directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = PI * directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = PI * directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n	vec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	return irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n		directLight.color = directionalLight.color;\n		directLight.direction = directionalLight.direction;\n		directLight.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		directLight.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		directLight.color = pointLight.color;\n		directLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n		directLight.visible = ( directLight.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		directLight.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		float angleCos = dot( directLight.direction, spotLight.direction );\n		if ( angleCos > spotLight.coneCos ) {\n			float spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n			directLight.color = spotLight.color;\n			directLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n			directLight.visible = true;\n		} else {\n			directLight.color = vec3( 0.0 );\n			directLight.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n		float dotNL = dot( geometry.normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			irradiance *= PI;\n		#endif\n		return irradiance;\n	}\n#endif";
var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	#ifdef ENVMAP_MODE_REFRACTION\n		uniform float refractionRatio;\n	#endif\n	vec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n		vec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n		#ifdef ENVMAP_TYPE_CUBE\n			vec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n			#ifdef TEXTURE_LOD_EXT\n				vec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n			#else\n				vec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n			#endif\n			envMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n		#elif defined( ENVMAP_TYPE_CUBE_UV )\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n		#else\n			vec4 envMapColor = vec4( 0.0 );\n		#endif\n		return PI * envMapColor.rgb * envMapIntensity;\n	}\n	float getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n		float maxMIPLevelScalar = float( maxMIPLevel );\n		float sigma = PI * roughness * roughness / ( 1.0 + roughness );\n		float desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n		return clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n	}\n	vec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( -viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n		#else\n			vec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n		#endif\n		reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n		float specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n		#ifdef ENVMAP_TYPE_CUBE\n			vec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n			#ifdef TEXTURE_LOD_EXT\n				vec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n			#else\n				vec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n			#endif\n			envMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n		#elif defined( ENVMAP_TYPE_CUBE_UV )\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n		#endif\n		return envMapColor.rgb * envMapIntensity;\n	}\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	reflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	reflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n	material.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), rawDiffuseColor, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), rawDiffuseColor, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheen;\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float specularRoughness;\n	vec3 specularColor;\n#ifdef CLEARCOAT\n	float clearcoat;\n	float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	vec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n	return DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.specularRoughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	#ifdef CLEARCOAT\n		float ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = ccDotNL * directLight.color;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			ccIrradiance *= PI;\n		#endif\n		float clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n		reflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n	#else\n		float clearcoatDHR = 0.0;\n	#endif\n	#ifdef USE_SHEEN\n		reflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n			material.specularRoughness,\n			directLight.direction,\n			geometry,\n			material.sheenColor\n		);\n	#else\n		reflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n	#endif\n	reflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef CLEARCOAT\n		float ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n		float ccDotNL = ccDotNV;\n		float clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n	#else\n		float clearcoatDHR = 0.0;\n	#endif\n	float clearcoatInv = 1.0 - clearcoatDHR;\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	BRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n	vec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n	reflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointDirectLightIrradiance( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotDirectLightIrradiance( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			lightMapIrradiance *= PI;\n		#endif\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n	#ifdef CLEARCOAT\n		clearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n	#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var map_fragment = "#ifdef USE_MAP\n	vec4 texelColor = texture2D( map, vUv );\n	texelColor = mapTexelToLinear( texelColor );\n	diffuseColor *= texelColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	vec4 mapTexel = texture2D( map, uv );\n	diffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n	objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n	objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n	objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifndef USE_MORPHNORMALS\n		uniform float morphTargetInfluences[ 8 ];\n	#else\n		uniform float morphTargetInfluences[ 4 ];\n	#endif\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n	transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n	transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n	transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n	#ifndef USE_MORPHNORMALS\n		transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n		transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n		transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n		transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n	#endif\n#endif";
var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	#ifdef BONE_TEXTURE\n		uniform highp sampler2D boneTexture;\n		uniform int boneTextureSize;\n		mat4 getBoneMatrix( const in float i ) {\n			float j = i * 4.0;\n			float x = mod( j, float( boneTextureSize ) );\n			float y = floor( j / float( boneTextureSize ) );\n			float dx = 1.0 / float( boneTextureSize );\n			float dy = 1.0 / float( boneTextureSize );\n			y = dy * ( y + 0.5 );\n			vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n			vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n			vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n			vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n			mat4 bone = mat4( v1, v2, v3, v4 );\n			return bone;\n		}\n	#else\n		uniform mat4 boneMatrices[ MAX_BONES ];\n		mat4 getBoneMatrix( const in float i ) {\n			mat4 bone = boneMatrices[ int(i) ];\n			return bone;\n		}\n	#endif\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment = "#ifdef USE_TRANSMISSION\n	#ifdef USE_TRANSMISSIONMAP\n		totalTransmission *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSNMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition.xyz / vWorldPosition.w;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n	float ior = ( 1.0 + 0.4 * reflectivity ) / ( 1.0 - 0.4 * reflectivity );\n	vec3 f0 = vec3( pow( ior - 1.0, 2.0 ) / pow( ior + 1.0, 2.0 ) );\n	vec3 f90 = vec3( 1.0 );\n	vec3 f_transmission = totalTransmission * getIBLVolumeRefraction(\n		normal, v, viewDir, roughnessFactor, diffuseColor.rgb, f0, f90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationColor, attenuationDistance);\n	diffuseColor.rgb = mix( diffuseColor.rgb, f_transmission, totalTransmission );\n#endif";
var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec4 vWorldPosition;\n	vec3 getVolumeTransmissionRay(vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix) {\n		vec3 refractionVector = refract(-v, normalize(n), 1.0 / ior);\n		vec3 modelScale;\n		modelScale.x = length(vec3(modelMatrix[0].xyz));\n		modelScale.y = length(vec3(modelMatrix[1].xyz));\n		modelScale.z = length(vec3(modelMatrix[2].xyz));\n		return normalize(refractionVector) * thickness * modelScale;\n	}\n	float applyIorToRoughness(float roughness, float ior) {\n		return roughness * clamp(ior * 2.0 - 2.0, 0.0, 1.0);\n	}\n	vec3 getTransmissionSample(vec2 fragCoord, float roughness, float ior) {\n		float framebufferLod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness, ior);\n		return texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod).rgb;\n	}\n	vec3 applyVolumeAttenuation(vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance) {\n		if (attenuationDistance == 0.0) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log(attenuationColor) / attenuationDistance;\n			vec3 transmittance = exp(-attenuationCoefficient * transmissionDistance);			return transmittance * radiance;\n		}\n	}\n	vec3 getIBLVolumeRefraction(vec3 n, vec3 v, vec3 viewDir, float perceptualRoughness, vec3 baseColor, vec3 f0, vec3 f90,\n		vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness, vec3 attenuationColor, float attenuationDistance) {\n		vec3 transmissionRay = getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4(refractedRayExit, 1.0);\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec3 transmittedLight = getTransmissionSample(refractionCoords, perceptualRoughness, ior);\n		vec3 attenuatedColor = applyVolumeAttenuation(transmittedLight, length(transmissionRay), attenuationColor, attenuationDistance);\n		float NdotV = saturate(dot(n, viewDir));\n		vec2 brdf = integrateSpecularBRDF(NdotV, perceptualRoughness);\n		vec3 specularColor = f0 * brdf.x + f90 * brdf.y;\n		return (1.0 - specularColor) * attenuatedColor * baseColor;\n	}\n#endif";
var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
var background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	gl_FragColor = mapTexelToLinear( texColor );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
var depth_frag = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	vec4 texColor = texture2D( tEquirect, sampleUV );\n	gl_FragColor = mapTexelToLinear( texColor );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n	\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_ENVMAP\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n		matcapColor = matcapTexelToLinear( matcapColor );\n	#else\n		vec4 matcapColor = vec4( 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#ifndef FLAT_SHADED\n		vNormal = normalize( transformedNormal );\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
var meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n	#define REFLECTIVITY\n	#define CLEARCOAT\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform vec3 attenuationColor;\n	uniform float attenuationDistance;\n#endif\n#ifdef REFLECTIVITY\n	uniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <transmission_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#ifdef USE_TRANSMISSION\n		float totalTransmission = transmission;\n		float thicknessFactor = thickness;\n	#endif\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	vec3 rawDiffuseColor = diffuseColor.rgb;\n	#include <transmission_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#ifdef USE_TRANSMISSION\n	varying vec4 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition;\n#endif\n}";
var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
var shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <begin_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
var sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const ShaderChunk = {
  alphamap_fragment,
  alphamap_pars_fragment,
  alphatest_fragment,
  aomap_fragment,
  aomap_pars_fragment,
  begin_vertex,
  beginnormal_vertex,
  bsdfs,
  bumpmap_pars_fragment,
  clipping_planes_fragment,
  clipping_planes_pars_fragment,
  clipping_planes_pars_vertex,
  clipping_planes_vertex,
  color_fragment,
  color_pars_fragment,
  color_pars_vertex,
  color_vertex,
  common,
  cube_uv_reflection_fragment,
  defaultnormal_vertex,
  displacementmap_pars_vertex,
  displacementmap_vertex,
  emissivemap_fragment,
  emissivemap_pars_fragment,
  encodings_fragment,
  encodings_pars_fragment,
  envmap_fragment,
  envmap_common_pars_fragment,
  envmap_pars_fragment,
  envmap_pars_vertex,
  envmap_physical_pars_fragment,
  envmap_vertex,
  fog_vertex,
  fog_pars_vertex,
  fog_fragment,
  fog_pars_fragment,
  gradientmap_pars_fragment,
  lightmap_fragment,
  lightmap_pars_fragment,
  lights_lambert_vertex,
  lights_pars_begin,
  lights_toon_fragment,
  lights_toon_pars_fragment,
  lights_phong_fragment,
  lights_phong_pars_fragment,
  lights_physical_fragment,
  lights_physical_pars_fragment,
  lights_fragment_begin,
  lights_fragment_maps,
  lights_fragment_end,
  logdepthbuf_fragment,
  logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex,
  logdepthbuf_vertex,
  map_fragment,
  map_pars_fragment,
  map_particle_fragment,
  map_particle_pars_fragment,
  metalnessmap_fragment,
  metalnessmap_pars_fragment,
  morphnormal_vertex,
  morphtarget_pars_vertex,
  morphtarget_vertex,
  normal_fragment_begin,
  normal_fragment_maps,
  normalmap_pars_fragment,
  clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment,
  packing,
  premultiplied_alpha_fragment,
  project_vertex,
  dithering_fragment,
  dithering_pars_fragment,
  roughnessmap_fragment,
  roughnessmap_pars_fragment,
  shadowmap_pars_fragment,
  shadowmap_pars_vertex,
  shadowmap_vertex,
  shadowmask_pars_fragment,
  skinbase_vertex,
  skinning_pars_vertex,
  skinning_vertex,
  skinnormal_vertex,
  specularmap_fragment,
  specularmap_pars_fragment,
  tonemapping_fragment,
  tonemapping_pars_fragment,
  transmission_fragment,
  transmission_pars_fragment,
  uv_pars_fragment,
  uv_pars_vertex,
  uv_vertex,
  uv2_pars_fragment,
  uv2_pars_vertex,
  uv2_vertex,
  worldpos_vertex,
  background_frag,
  background_vert,
  cube_frag,
  cube_vert,
  depth_frag,
  depth_vert,
  distanceRGBA_frag,
  distanceRGBA_vert,
  equirect_frag,
  equirect_vert,
  linedashed_frag,
  linedashed_vert,
  meshbasic_frag,
  meshbasic_vert,
  meshlambert_frag,
  meshlambert_vert,
  meshmatcap_frag,
  meshmatcap_vert,
  meshtoon_frag,
  meshtoon_vert,
  meshphong_frag,
  meshphong_vert,
  meshphysical_frag,
  meshphysical_vert,
  normal_frag,
  normal_vert,
  points_frag,
  points_vert,
  shadow_frag,
  shadow_vert,
  sprite_frag,
  sprite_vert
};
const UniformsLib = {
  common: {
    diffuse: { value: new Color(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    uvTransform: { value: new Matrix3$1() },
    uv2Transform: { value: new Matrix3$1() },
    alphaMap: { value: null }
  },
  specularmap: {
    specularMap: { value: null }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    refractionRatio: { value: 0.98 },
    maxMipLevel: { value: 0 }
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 }
  },
  emissivemap: {
    emissiveMap: { value: null }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalScale: { value: new Vector2$1(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  roughnessmap: {
    roughnessMap: { value: null }
  },
  metalnessmap: {
    metalnessMap: { value: null }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: new Color(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotShadowMap: { value: [] },
    spotShadowMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: new Color(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    uvTransform: { value: new Matrix3$1() }
  },
  sprite: {
    diffuse: { value: new Color(16777215) },
    opacity: { value: 1 },
    center: { value: new Vector2$1(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    alphaMap: { value: null },
    uvTransform: { value: new Matrix3$1() }
  }
};
const ShaderLib = {
  basic: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) },
        specular: { value: new Color(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.roughnessmap,
      UniformsLib.metalnessmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.gradientmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: mergeUniforms([
      UniformsLib.points,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap
    ]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.normal_vert,
    fragmentShader: ShaderChunk.normal_frag
  },
  sprite: {
    uniforms: mergeUniforms([
      UniformsLib.sprite,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: new Matrix3$1() },
      t2D: { value: null }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },
  cube: {
    uniforms: mergeUniforms([
      UniformsLib.envmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap,
      {
        referencePosition: { value: new Vector3$1() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: mergeUniforms([
      UniformsLib.lights,
      UniformsLib.fog,
      {
        color: { value: new Color(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: mergeUniforms([
    ShaderLib.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatNormalScale: { value: new Vector2$1(1, 1) },
      clearcoatNormalMap: { value: null },
      sheen: { value: new Color(0) },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionSamplerSize: { value: new Vector2$1() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: new Color(0) }
    }
  ]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};
function WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
  const clearColor = new Color(0);
  let clearAlpha = 0;
  let planeMesh;
  let boxMesh;
  let currentBackground = null;
  let currentBackgroundVersion = 0;
  let currentTonemapping = null;
  function render(renderList, scene) {
    let forceClear = false;
    let background = scene.isScene === true ? scene.background : null;
    if (background && background.isTexture) {
      background = cubemaps.get(background);
    }
    const xr = renderer.xr;
    const session = xr.getSession && xr.getSession();
    if (session && session.environmentBlendMode === "additive") {
      background = null;
    }
    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }
    if (renderer.autoClear || forceClear) {
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
      if (boxMesh === void 0) {
        boxMesh = new Mesh(
          new BoxGeometry(1, 1, 1),
          new ShaderMaterial({
            name: "BackgroundCubeMaterial",
            uniforms: cloneUniforms(ShaderLib.cube.uniforms),
            vertexShader: ShaderLib.cube.vertexShader,
            fragmentShader: ShaderLib.cube.fragmentShader,
            side: BackSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        boxMesh.geometry.deleteAttribute("normal");
        boxMesh.geometry.deleteAttribute("uv");
        boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        };
        Object.defineProperty(boxMesh.material, "envMap", {
          get: function() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }
      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background._needsFlipEnvMap ? -1 : 1;
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === void 0) {
        planeMesh = new Mesh(
          new PlaneGeometry(2, 2),
          new ShaderMaterial({
            name: "BackgroundMaterial",
            uniforms: cloneUniforms(ShaderLib.background.uniforms),
            vertexShader: ShaderLib.background.vertexShader,
            fragmentShader: ShaderLib.background.fragmentShader,
            side: FrontSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        planeMesh.geometry.deleteAttribute("normal");
        Object.defineProperty(planeMesh.material, "map", {
          get: function() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }
      planeMesh.material.uniforms.t2D.value = background;
      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }
      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }
  function setClear(color, alpha) {
    state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
  }
  return {
    getClearColor: function() {
      return clearColor;
    },
    setClearColor: function(color, alpha = 1) {
      clearColor.set(color);
      clearAlpha = alpha;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function() {
      return clearAlpha;
    },
    setClearAlpha: function(alpha) {
      clearAlpha = alpha;
      setClear(clearColor, clearAlpha);
    },
    render
  };
}
function WebGLBindingStates(gl, extensions, attributes, capabilities) {
  const maxVertexAttributes = gl.getParameter(34921);
  const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
  const vaoAvailable = capabilities.isWebGL2 || extension !== null;
  const bindingStates = {};
  const defaultState = createBindingState(null);
  let currentState = defaultState;
  function setup(object, material, program, geometry, index) {
    let updateBuffers = false;
    if (vaoAvailable) {
      const state = getBindingState(geometry, program, material);
      if (currentState !== state) {
        currentState = state;
        bindVertexArrayObject(currentState.object);
      }
      updateBuffers = needsUpdate(geometry, index);
      if (updateBuffers)
        saveCache(geometry, index);
    } else {
      const wireframe = material.wireframe === true;
      if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
        currentState.geometry = geometry.id;
        currentState.program = program.id;
        currentState.wireframe = wireframe;
        updateBuffers = true;
      }
    }
    if (object.isInstancedMesh === true) {
      updateBuffers = true;
    }
    if (index !== null) {
      attributes.update(index, 34963);
    }
    if (updateBuffers) {
      setupVertexAttributes(object, material, program, geometry);
      if (index !== null) {
        gl.bindBuffer(34963, attributes.get(index).buffer);
      }
    }
  }
  function createVertexArrayObject() {
    if (capabilities.isWebGL2)
      return gl.createVertexArray();
    return extension.createVertexArrayOES();
  }
  function bindVertexArrayObject(vao) {
    if (capabilities.isWebGL2)
      return gl.bindVertexArray(vao);
    return extension.bindVertexArrayOES(vao);
  }
  function deleteVertexArrayObject(vao) {
    if (capabilities.isWebGL2)
      return gl.deleteVertexArray(vao);
    return extension.deleteVertexArrayOES(vao);
  }
  function getBindingState(geometry, program, material) {
    const wireframe = material.wireframe === true;
    let programMap = bindingStates[geometry.id];
    if (programMap === void 0) {
      programMap = {};
      bindingStates[geometry.id] = programMap;
    }
    let stateMap = programMap[program.id];
    if (stateMap === void 0) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }
    let state = stateMap[wireframe];
    if (state === void 0) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }
    return state;
  }
  function createBindingState(vao) {
    const newAttributes = [];
    const enabledAttributes = [];
    const attributeDivisors = [];
    for (let i = 0; i < maxVertexAttributes; i++) {
      newAttributes[i] = 0;
      enabledAttributes[i] = 0;
      attributeDivisors[i] = 0;
    }
    return {
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes,
      enabledAttributes,
      attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }
  function needsUpdate(geometry, index) {
    const cachedAttributes = currentState.attributes;
    const geometryAttributes = geometry.attributes;
    let attributesNum = 0;
    for (const key in geometryAttributes) {
      const cachedAttribute = cachedAttributes[key];
      const geometryAttribute = geometryAttributes[key];
      if (cachedAttribute === void 0)
        return true;
      if (cachedAttribute.attribute !== geometryAttribute)
        return true;
      if (cachedAttribute.data !== geometryAttribute.data)
        return true;
      attributesNum++;
    }
    if (currentState.attributesNum !== attributesNum)
      return true;
    if (currentState.index !== index)
      return true;
    return false;
  }
  function saveCache(geometry, index) {
    const cache = {};
    const attributes2 = geometry.attributes;
    let attributesNum = 0;
    for (const key in attributes2) {
      const attribute = attributes2[key];
      const data = {};
      data.attribute = attribute;
      if (attribute.data) {
        data.data = attribute.data;
      }
      cache[key] = data;
      attributesNum++;
    }
    currentState.attributes = cache;
    currentState.attributesNum = attributesNum;
    currentState.index = index;
  }
  function initAttributes() {
    const newAttributes = currentState.newAttributes;
    for (let i = 0, il = newAttributes.length; i < il; i++) {
      newAttributes[i] = 0;
    }
  }
  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }
  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    const attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;
    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
    if (attributeDivisors[attribute] !== meshPerAttribute) {
      const extension2 = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
      extension2[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
      attributeDivisors[attribute] = meshPerAttribute;
    }
  }
  function disableUnusedAttributes() {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    for (let i = 0, il = enabledAttributes.length; i < il; i++) {
      if (enabledAttributes[i] !== newAttributes[i]) {
        gl.disableVertexAttribArray(i);
        enabledAttributes[i] = 0;
      }
    }
  }
  function vertexAttribPointer(index, size, type, normalized, stride, offset) {
    if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) {
      gl.vertexAttribIPointer(index, size, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
  }
  function setupVertexAttributes(object, material, program, geometry) {
    if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
      if (extensions.get("ANGLE_instanced_arrays") === null)
        return;
    }
    initAttributes();
    const geometryAttributes = geometry.attributes;
    const programAttributes = program.getAttributes();
    const materialDefaultAttributeValues = material.defaultAttributeValues;
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute >= 0) {
        const geometryAttribute = geometryAttributes[name];
        if (geometryAttribute !== void 0) {
          const normalized = geometryAttribute.normalized;
          const size = geometryAttribute.itemSize;
          const attribute = attributes.get(geometryAttribute);
          if (attribute === void 0)
            continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          const bytesPerElement = attribute.bytesPerElement;
          if (geometryAttribute.isInterleavedBufferAttribute) {
            const data = geometryAttribute.data;
            const stride = data.stride;
            const offset = geometryAttribute.offset;
            if (data && data.isInstancedInterleavedBuffer) {
              enableAttributeAndDivisor(programAttribute, data.meshPerAttribute);
              if (geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = data.meshPerAttribute * data.count;
              }
            } else {
              enableAttribute(programAttribute);
            }
            gl.bindBuffer(34962, buffer);
            vertexAttribPointer(programAttribute, size, type, normalized, stride * bytesPerElement, offset * bytesPerElement);
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              enableAttributeAndDivisor(programAttribute, geometryAttribute.meshPerAttribute);
              if (geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              enableAttribute(programAttribute);
            }
            gl.bindBuffer(34962, buffer);
            vertexAttribPointer(programAttribute, size, type, normalized, 0, 0);
          }
        } else if (name === "instanceMatrix") {
          const attribute = attributes.get(object.instanceMatrix);
          if (attribute === void 0)
            continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          enableAttributeAndDivisor(programAttribute + 0, 1);
          enableAttributeAndDivisor(programAttribute + 1, 1);
          enableAttributeAndDivisor(programAttribute + 2, 1);
          enableAttributeAndDivisor(programAttribute + 3, 1);
          gl.bindBuffer(34962, buffer);
          gl.vertexAttribPointer(programAttribute + 0, 4, type, false, 64, 0);
          gl.vertexAttribPointer(programAttribute + 1, 4, type, false, 64, 16);
          gl.vertexAttribPointer(programAttribute + 2, 4, type, false, 64, 32);
          gl.vertexAttribPointer(programAttribute + 3, 4, type, false, 64, 48);
        } else if (name === "instanceColor") {
          const attribute = attributes.get(object.instanceColor);
          if (attribute === void 0)
            continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          enableAttributeAndDivisor(programAttribute, 1);
          gl.bindBuffer(34962, buffer);
          gl.vertexAttribPointer(programAttribute, 3, type, false, 12, 0);
        } else if (materialDefaultAttributeValues !== void 0) {
          const value = materialDefaultAttributeValues[name];
          if (value !== void 0) {
            switch (value.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute, value);
                break;
              case 3:
                gl.vertexAttrib3fv(programAttribute, value);
                break;
              case 4:
                gl.vertexAttrib4fv(programAttribute, value);
                break;
              default:
                gl.vertexAttrib1fv(programAttribute, value);
            }
          }
        }
      }
    }
    disableUnusedAttributes();
  }
  function dispose2() {
    reset();
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometryId];
    }
  }
  function releaseStatesOfGeometry(geometry) {
    if (bindingStates[geometry.id] === void 0)
      return;
    const programMap = bindingStates[geometry.id];
    for (const programId in programMap) {
      const stateMap = programMap[programId];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[programId];
    }
    delete bindingStates[geometry.id];
  }
  function releaseStatesOfProgram(program) {
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      if (programMap[program.id] === void 0)
        continue;
      const stateMap = programMap[program.id];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[program.id];
    }
  }
  function reset() {
    resetDefaultState();
    if (currentState === defaultState)
      return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  }
  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }
  return {
    setup,
    reset,
    resetDefaultState,
    dispose: dispose2,
    releaseStatesOfGeometry,
    releaseStatesOfProgram,
    initAttributes,
    enableAttribute,
    disableUnusedAttributes
  };
}
function WebGLBufferRenderer(gl, extensions, info, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  let mode;
  function setMode(value) {
    mode = value;
  }
  function render(start, count) {
    gl.drawArrays(mode, start, count);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0)
      return;
    let extension, methodName;
    if (isWebGL2) {
      extension = gl;
      methodName = "drawArraysInstanced";
    } else {
      extension = extensions.get("ANGLE_instanced_arrays");
      methodName = "drawArraysInstancedANGLE";
      if (extension === null) {
        console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        return;
      }
    }
    extension[methodName](mode, start, count, primcount);
    info.update(count, mode, primcount);
  }
  this.setMode = setMode;
  this.render = render;
  this.renderInstances = renderInstances;
}
function WebGLCapabilities(gl, extensions, parameters) {
  let maxAnisotropy;
  function getMaxAnisotropy() {
    if (maxAnisotropy !== void 0)
      return maxAnisotropy;
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }
    return maxAnisotropy;
  }
  function getMaxPrecision(precision2) {
    if (precision2 === "highp") {
      if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) {
        return "highp";
      }
      precision2 = "mediump";
    }
    if (precision2 === "mediump") {
      if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) {
        return "mediump";
      }
    }
    return "lowp";
  }
  const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
  let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
  const maxPrecision = getMaxPrecision(precision);
  if (maxPrecision !== precision) {
    console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
    precision = maxPrecision;
  }
  const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
  const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  const maxTextures = gl.getParameter(34930);
  const maxVertexTextures = gl.getParameter(35660);
  const maxTextureSize = gl.getParameter(3379);
  const maxCubemapSize = gl.getParameter(34076);
  const maxAttributes = gl.getParameter(34921);
  const maxVertexUniforms = gl.getParameter(36347);
  const maxVaryings = gl.getParameter(36348);
  const maxFragmentUniforms = gl.getParameter(36349);
  const vertexTextures = maxVertexTextures > 0;
  const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
  const floatVertexTextures = vertexTextures && floatFragmentTextures;
  const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
  return {
    isWebGL2,
    drawBuffers,
    getMaxAnisotropy,
    getMaxPrecision,
    precision,
    logarithmicDepthBuffer,
    maxTextures,
    maxVertexTextures,
    maxTextureSize,
    maxCubemapSize,
    maxAttributes,
    maxVertexUniforms,
    maxVaryings,
    maxFragmentUniforms,
    vertexTextures,
    floatFragmentTextures,
    floatVertexTextures,
    maxSamples
  };
}
function WebGLClipping(properties) {
  const scope = this;
  let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
  const plane = new Plane(), viewNormalMatrix = new Matrix3$1(), uniform = { value: null, needsUpdate: false };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function(planes, enableLocalClipping, camera) {
    const enabled = planes.length !== 0 || enableLocalClipping || numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    globalState = projectPlanes(planes, camera, 0);
    numGlobalPlanes = planes.length;
    return enabled;
  };
  this.beginShadows = function() {
    renderingShadows = true;
    projectPlanes(null);
  };
  this.endShadows = function() {
    renderingShadows = false;
    resetGlobalState();
  };
  this.setState = function(material, camera, useCache) {
    const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
    const materialProperties = properties.get(material);
    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      if (renderingShadows) {
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
      let dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray;
      dstArray = projectPlanes(planes, camera, lGlobal, useCache);
      for (let i = 0; i !== lGlobal; ++i) {
        dstArray[i] = globalState[i];
      }
      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };
  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }
    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }
  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    const nPlanes = planes !== null ? planes.length : 0;
    let dstArray = null;
    if (nPlanes !== 0) {
      dstArray = uniform.value;
      if (skipTransform !== true || dstArray === null) {
        const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);
        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }
        for (let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4) {
          plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }
      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }
    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}
function WebGLCubeMaps(renderer) {
  let cubemaps = /* @__PURE__ */ new WeakMap();
  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping) {
      texture.mapping = CubeReflectionMapping$1;
    } else if (mapping === EquirectangularRefractionMapping) {
      texture.mapping = CubeRefractionMapping;
    }
    return texture;
  }
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
        if (cubemaps.has(texture)) {
          const cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          const image = texture.image;
          if (image && image.height > 0) {
            const currentRenderTarget = renderer.getRenderTarget();
            const renderTarget = new WebGLCubeRenderTarget(image.height / 2);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            renderer.setRenderTarget(currentRenderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemap = cubemaps.get(texture);
    if (cubemap !== void 0) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }
  function dispose2() {
    cubemaps = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose: dispose2
  };
}
function WebGLExtensions(gl) {
  const extensions = {};
  function getExtension(name) {
    if (extensions[name] !== void 0) {
      return extensions[name];
    }
    let extension;
    switch (name) {
      case "WEBGL_depth_texture":
        extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        extension = gl.getExtension(name);
    }
    extensions[name] = extension;
    return extension;
  }
  return {
    has: function(name) {
      return getExtension(name) !== null;
    },
    init: function(capabilities) {
      if (capabilities.isWebGL2) {
        getExtension("EXT_color_buffer_float");
      } else {
        getExtension("WEBGL_depth_texture");
        getExtension("OES_texture_float");
        getExtension("OES_texture_half_float");
        getExtension("OES_texture_half_float_linear");
        getExtension("OES_standard_derivatives");
        getExtension("OES_element_index_uint");
        getExtension("OES_vertex_array_object");
        getExtension("ANGLE_instanced_arrays");
      }
      getExtension("OES_texture_float_linear");
      getExtension("EXT_color_buffer_half_float");
    },
    get: function(name) {
      const extension = getExtension(name);
      if (extension === null) {
        console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
      }
      return extension;
    }
  };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
  const geometries = {};
  const wireframeAttributes = /* @__PURE__ */ new WeakMap();
  function onGeometryDispose(event) {
    const geometry = event.target;
    if (geometry.index !== null) {
      attributes.remove(geometry.index);
    }
    for (const name in geometry.attributes) {
      attributes.remove(geometry.attributes[name]);
    }
    geometry.removeEventListener("dispose", onGeometryDispose);
    delete geometries[geometry.id];
    const attribute = wireframeAttributes.get(geometry);
    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry);
    }
    bindingStates.releaseStatesOfGeometry(geometry);
    if (geometry.isInstancedBufferGeometry === true) {
      delete geometry._maxInstanceCount;
    }
    info.memory.geometries--;
  }
  function get(object, geometry) {
    if (geometries[geometry.id] === true)
      return geometry;
    geometry.addEventListener("dispose", onGeometryDispose);
    geometries[geometry.id] = true;
    info.memory.geometries++;
    return geometry;
  }
  function update(geometry) {
    const geometryAttributes = geometry.attributes;
    for (const name in geometryAttributes) {
      attributes.update(geometryAttributes[name], 34962);
    }
    const morphAttributes = geometry.morphAttributes;
    for (const name in morphAttributes) {
      const array = morphAttributes[name];
      for (let i = 0, l = array.length; i < l; i++) {
        attributes.update(array[i], 34962);
      }
    }
  }
  function updateWireframeAttribute(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    let version = 0;
    if (geometryIndex !== null) {
      const array = geometryIndex.array;
      version = geometryIndex.version;
      for (let i = 0, l = array.length; i < l; i += 3) {
        const a = array[i + 0];
        const b = array[i + 1];
        const c = array[i + 2];
        indices.push(a, b, b, c, c, a);
      }
    } else {
      const array = geometryPosition.array;
      version = geometryPosition.version;
      for (let i = 0, l = array.length / 3 - 1; i < l; i += 3) {
        const a = i + 0;
        const b = i + 1;
        const c = i + 2;
        indices.push(a, b, b, c, c, a);
      }
    }
    const attribute = new (arrayMax(indices) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
    attribute.version = version;
    const previousAttribute = wireframeAttributes.get(geometry);
    if (previousAttribute)
      attributes.remove(previousAttribute);
    wireframeAttributes.set(geometry, attribute);
  }
  function getWireframeAttribute(geometry) {
    const currentAttribute = wireframeAttributes.get(geometry);
    if (currentAttribute) {
      const geometryIndex = geometry.index;
      if (geometryIndex !== null) {
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry);
        }
      }
    } else {
      updateWireframeAttribute(geometry);
    }
    return wireframeAttributes.get(geometry);
  }
  return {
    get,
    update,
    getWireframeAttribute
  };
}
function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  let mode;
  function setMode(value) {
    mode = value;
  }
  let type, bytesPerElement;
  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }
  function render(start, count) {
    gl.drawElements(mode, count, type, start * bytesPerElement);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0)
      return;
    let extension, methodName;
    if (isWebGL2) {
      extension = gl;
      methodName = "drawElementsInstanced";
    } else {
      extension = extensions.get("ANGLE_instanced_arrays");
      methodName = "drawElementsInstancedANGLE";
      if (extension === null) {
        console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        return;
      }
    }
    extension[methodName](mode, count, type, start * bytesPerElement, primcount);
    info.update(count, mode, primcount);
  }
  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render;
  this.renderInstances = renderInstances;
}
function WebGLInfo(gl) {
  const memory = {
    geometries: 0,
    textures: 0
  };
  const render = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function update(count, mode, instanceCount) {
    render.calls++;
    switch (mode) {
      case 4:
        render.triangles += instanceCount * (count / 3);
        break;
      case 1:
        render.lines += instanceCount * (count / 2);
        break;
      case 3:
        render.lines += instanceCount * (count - 1);
        break;
      case 2:
        render.lines += instanceCount * count;
        break;
      case 0:
        render.points += instanceCount * count;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
        break;
    }
  }
  function reset() {
    render.frame++;
    render.calls = 0;
    render.triangles = 0;
    render.points = 0;
    render.lines = 0;
  }
  return {
    memory,
    render,
    programs: null,
    autoReset: true,
    reset,
    update
  };
}
function numericalSort(a, b) {
  return a[0] - b[0];
}
function absNumericalSort(a, b) {
  return Math.abs(b[1]) - Math.abs(a[1]);
}
function WebGLMorphtargets(gl) {
  const influencesList = {};
  const morphInfluences = new Float32Array(8);
  const workInfluences = [];
  for (let i = 0; i < 8; i++) {
    workInfluences[i] = [i, 0];
  }
  function update(object, geometry, material, program) {
    const objectInfluences = object.morphTargetInfluences;
    const length = objectInfluences === void 0 ? 0 : objectInfluences.length;
    let influences = influencesList[geometry.id];
    if (influences === void 0) {
      influences = [];
      for (let i = 0; i < length; i++) {
        influences[i] = [i, 0];
      }
      influencesList[geometry.id] = influences;
    }
    for (let i = 0; i < length; i++) {
      const influence = influences[i];
      influence[0] = i;
      influence[1] = objectInfluences[i];
    }
    influences.sort(absNumericalSort);
    for (let i = 0; i < 8; i++) {
      if (i < length && influences[i][1]) {
        workInfluences[i][0] = influences[i][0];
        workInfluences[i][1] = influences[i][1];
      } else {
        workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
        workInfluences[i][1] = 0;
      }
    }
    workInfluences.sort(numericalSort);
    const morphTargets = material.morphTargets && geometry.morphAttributes.position;
    const morphNormals = material.morphNormals && geometry.morphAttributes.normal;
    let morphInfluencesSum = 0;
    for (let i = 0; i < 8; i++) {
      const influence = workInfluences[i];
      const index = influence[0];
      const value = influence[1];
      if (index !== Number.MAX_SAFE_INTEGER && value) {
        if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) {
          geometry.setAttribute("morphTarget" + i, morphTargets[index]);
        }
        if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) {
          geometry.setAttribute("morphNormal" + i, morphNormals[index]);
        }
        morphInfluences[i] = value;
        morphInfluencesSum += value;
      } else {
        if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) {
          geometry.deleteAttribute("morphTarget" + i);
        }
        if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) {
          geometry.deleteAttribute("morphNormal" + i);
        }
        morphInfluences[i] = 0;
      }
    }
    const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
    program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
    program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
  }
  return {
    update
  };
}
function WebGLObjects(gl, geometries, attributes, info) {
  let updateMap = /* @__PURE__ */ new WeakMap();
  function update(object) {
    const frame = info.render.frame;
    const geometry = object.geometry;
    const buffergeometry = geometries.get(object, geometry);
    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }
    if (object.isInstancedMesh) {
      if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) {
        object.addEventListener("dispose", onInstancedMeshDispose);
      }
      attributes.update(object.instanceMatrix, 34962);
      if (object.instanceColor !== null) {
        attributes.update(object.instanceColor, 34962);
      }
    }
    return buffergeometry;
  }
  function dispose2() {
    updateMap = /* @__PURE__ */ new WeakMap();
  }
  function onInstancedMeshDispose(event) {
    const instancedMesh = event.target;
    instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null)
      attributes.remove(instancedMesh.instanceColor);
  }
  return {
    update,
    dispose: dispose2
  };
}
class DataTexture2DArray extends Texture$1 {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping$1;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
  }
}
DataTexture2DArray.prototype.isDataTexture2DArray = true;
class DataTexture3D extends Texture$1 {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping$1;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
  }
}
DataTexture3D.prototype.isDataTexture3D = true;
const emptyTexture = new Texture$1();
const emptyTexture2dArray = new DataTexture2DArray();
const emptyTexture3d = new DataTexture3D();
const emptyCubeTexture = new CubeTexture$1();
const arrayCacheF32 = [];
const arrayCacheI32 = [];
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
function flatten(array, nBlocks, blockSize) {
  const firstElem = array[0];
  if (firstElem <= 0 || firstElem > 0)
    return array;
  const n = nBlocks * blockSize;
  let r = arrayCacheF32[n];
  if (r === void 0) {
    r = new Float32Array(n);
    arrayCacheF32[n] = r;
  }
  if (nBlocks !== 0) {
    firstElem.toArray(r, 0);
    for (let i = 1, offset = 0; i !== nBlocks; ++i) {
      offset += blockSize;
      array[i].toArray(r, offset);
    }
  }
  return r;
}
function arraysEqual(a, b) {
  if (a.length !== b.length)
    return false;
  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i])
      return false;
  }
  return true;
}
function copyArray(a, b) {
  for (let i = 0, l = b.length; i < l; i++) {
    a[i] = b[i];
  }
}
function allocTexUnits(textures, n) {
  let r = arrayCacheI32[n];
  if (r === void 0) {
    r = new Int32Array(n);
    arrayCacheI32[n] = r;
  }
  for (let i = 0; i !== n; ++i) {
    r[i] = textures.allocateTextureUnit();
  }
  return r;
}
function setValueV1f(gl, v) {
  const cache = this.cache;
  if (cache[0] === v)
    return;
  gl.uniform1f(this.addr, v);
  cache[0] = v;
}
function setValueV2f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2f(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual(cache, v))
      return;
    gl.uniform2fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV3f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3f(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else if (v.r !== void 0) {
    if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
      gl.uniform3f(this.addr, v.r, v.g, v.b);
      cache[0] = v.r;
      cache[1] = v.g;
      cache[2] = v.b;
    }
  } else {
    if (arraysEqual(cache, v))
      return;
    gl.uniform3fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV4f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual(cache, v))
      return;
    gl.uniform4fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueM2(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v))
      return;
    gl.uniformMatrix2fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements))
      return;
    mat2array.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array);
    copyArray(cache, elements);
  }
}
function setValueM3(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v))
      return;
    gl.uniformMatrix3fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements))
      return;
    mat3array.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array);
    copyArray(cache, elements);
  }
}
function setValueM4(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v))
      return;
    gl.uniformMatrix4fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements))
      return;
    mat4array.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array);
    copyArray(cache, elements);
  }
}
function setValueV1i(gl, v) {
  const cache = this.cache;
  if (cache[0] === v)
    return;
  gl.uniform1i(this.addr, v);
  cache[0] = v;
}
function setValueV2i(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v))
    return;
  gl.uniform2iv(this.addr, v);
  copyArray(cache, v);
}
function setValueV3i(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v))
    return;
  gl.uniform3iv(this.addr, v);
  copyArray(cache, v);
}
function setValueV4i(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v))
    return;
  gl.uniform4iv(this.addr, v);
  copyArray(cache, v);
}
function setValueV1ui(gl, v) {
  const cache = this.cache;
  if (cache[0] === v)
    return;
  gl.uniform1ui(this.addr, v);
  cache[0] = v;
}
function setValueV2ui(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v))
    return;
  gl.uniform2uiv(this.addr, v);
  copyArray(cache, v);
}
function setValueV3ui(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v))
    return;
  gl.uniform3uiv(this.addr, v);
  copyArray(cache, v);
}
function setValueV4ui(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v))
    return;
  gl.uniform4uiv(this.addr, v);
  copyArray(cache, v);
}
function setValueT1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.safeSetTexture2D(v || emptyTexture, unit);
}
function setValueT3D1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture3D(v || emptyTexture3d, unit);
}
function setValueT6(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.safeSetTextureCube(v || emptyCubeTexture, unit);
}
function setValueT2DArray1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture2DArray(v || emptyTexture2dArray, unit);
}
function getSingularSetter(type) {
  switch (type) {
    case 5126:
      return setValueV1f;
    case 35664:
      return setValueV2f;
    case 35665:
      return setValueV3f;
    case 35666:
      return setValueV4f;
    case 35674:
      return setValueM2;
    case 35675:
      return setValueM3;
    case 35676:
      return setValueM4;
    case 5124:
    case 35670:
      return setValueV1i;
    case 35667:
    case 35671:
      return setValueV2i;
    case 35668:
    case 35672:
      return setValueV3i;
    case 35669:
    case 35673:
      return setValueV4i;
    case 5125:
      return setValueV1ui;
    case 36294:
      return setValueV2ui;
    case 36295:
      return setValueV3ui;
    case 36296:
      return setValueV4ui;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3D1;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(gl, v) {
  gl.uniform1fv(this.addr, v);
}
function setValueV2fArray(gl, v) {
  const data = flatten(v, this.size, 2);
  gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v) {
  const data = flatten(v, this.size, 3);
  gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v) {
  const data = flatten(v, this.size, 4);
  gl.uniform4fv(this.addr, data);
}
function setValueM2Array(gl, v) {
  const data = flatten(v, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v) {
  const data = flatten(v, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v) {
  const data = flatten(v, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data);
}
function setValueV1iArray(gl, v) {
  gl.uniform1iv(this.addr, v);
}
function setValueV2iArray(gl, v) {
  gl.uniform2iv(this.addr, v);
}
function setValueV3iArray(gl, v) {
  gl.uniform3iv(this.addr, v);
}
function setValueV4iArray(gl, v) {
  gl.uniform4iv(this.addr, v);
}
function setValueV1uiArray(gl, v) {
  gl.uniform1uiv(this.addr, v);
}
function setValueV2uiArray(gl, v) {
  gl.uniform2uiv(this.addr, v);
}
function setValueV3uiArray(gl, v) {
  gl.uniform3uiv(this.addr, v);
}
function setValueV4uiArray(gl, v) {
  gl.uniform4uiv(this.addr, v);
}
function setValueT1Array(gl, v, textures) {
  const n = v.length;
  const units = allocTexUnits(textures, n);
  gl.uniform1iv(this.addr, units);
  for (let i = 0; i !== n; ++i) {
    textures.safeSetTexture2D(v[i] || emptyTexture, units[i]);
  }
}
function setValueT6Array(gl, v, textures) {
  const n = v.length;
  const units = allocTexUnits(textures, n);
  gl.uniform1iv(this.addr, units);
  for (let i = 0; i !== n; ++i) {
    textures.safeSetTextureCube(v[i] || emptyCubeTexture, units[i]);
  }
}
function getPureArraySetter(type) {
  switch (type) {
    case 5126:
      return setValueV1fArray;
    case 35664:
      return setValueV2fArray;
    case 35665:
      return setValueV3fArray;
    case 35666:
      return setValueV4fArray;
    case 35674:
      return setValueM2Array;
    case 35675:
      return setValueM3Array;
    case 35676:
      return setValueM4Array;
    case 5124:
    case 35670:
      return setValueV1iArray;
    case 35667:
    case 35671:
      return setValueV2iArray;
    case 35668:
    case 35672:
      return setValueV3iArray;
    case 35669:
    case 35673:
      return setValueV4iArray;
    case 5125:
      return setValueV1uiArray;
    case 36294:
      return setValueV2uiArray;
    case 36295:
      return setValueV3uiArray;
    case 36296:
      return setValueV4uiArray;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1Array;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6Array;
  }
}
function SingleUniform(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.setValue = getSingularSetter(activeInfo.type);
}
function PureArrayUniform(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.size = activeInfo.size;
  this.setValue = getPureArraySetter(activeInfo.type);
}
PureArrayUniform.prototype.updateCache = function(data) {
  const cache = this.cache;
  if (data instanceof Float32Array && cache.length !== data.length) {
    this.cache = new Float32Array(data.length);
  }
  copyArray(cache, data);
};
function StructuredUniform(id) {
  this.id = id;
  this.seq = [];
  this.map = {};
}
StructuredUniform.prototype.setValue = function(gl, value, textures) {
  const seq = this.seq;
  for (let i = 0, n = seq.length; i !== n; ++i) {
    const u = seq[i];
    u.setValue(gl, value[u.id], textures);
  }
};
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
function addUniform(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
  const path = activeInfo.name, pathLength = path.length;
  RePathPart.lastIndex = 0;
  while (true) {
    const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
    let id = match[1];
    const idIsIndex = match[2] === "]", subscript = match[3];
    if (idIsIndex)
      id = id | 0;
    if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
      addUniform(container, subscript === void 0 ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
      break;
    } else {
      const map = container.map;
      let next2 = map[id];
      if (next2 === void 0) {
        next2 = new StructuredUniform(id);
        addUniform(container, next2);
      }
      container = next2;
    }
  }
}
function WebGLUniforms(gl, program) {
  this.seq = [];
  this.map = {};
  const n = gl.getProgramParameter(program, 35718);
  for (let i = 0; i < n; ++i) {
    const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
    parseUniform(info, addr, this);
  }
}
WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
  const u = this.map[name];
  if (u !== void 0)
    u.setValue(gl, value, textures);
};
WebGLUniforms.prototype.setOptional = function(gl, object, name) {
  const v = object[name];
  if (v !== void 0)
    this.setValue(gl, name, v);
};
WebGLUniforms.upload = function(gl, seq, values, textures) {
  for (let i = 0, n = seq.length; i !== n; ++i) {
    const u = seq[i], v = values[u.id];
    if (v.needsUpdate !== false) {
      u.setValue(gl, v.value, textures);
    }
  }
};
WebGLUniforms.seqWithValue = function(seq, values) {
  const r = [];
  for (let i = 0, n = seq.length; i !== n; ++i) {
    const u = seq[i];
    if (u.id in values)
      r.push(u);
  }
  return r;
};
function WebGLShader(gl, type, string) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, string);
  gl.compileShader(shader);
  return shader;
}
let programIdCount = 0;
function addLineNumbers(string) {
  const lines = string.split("\n");
  for (let i = 0; i < lines.length; i++) {
    lines[i] = i + 1 + ": " + lines[i];
  }
  return lines.join("\n");
}
function getEncodingComponents(encoding) {
  switch (encoding) {
    case LinearEncoding$1:
      return ["Linear", "( value )"];
    case sRGBEncoding:
      return ["sRGB", "( value )"];
    case RGBEEncoding:
      return ["RGBE", "( value )"];
    case RGBM7Encoding:
      return ["RGBM", "( value, 7.0 )"];
    case RGBM16Encoding:
      return ["RGBM", "( value, 16.0 )"];
    case RGBDEncoding:
      return ["RGBD", "( value, 256.0 )"];
    case GammaEncoding:
      return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];
    case LogLuvEncoding:
      return ["LogLuv", "( value )"];
    default:
      console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
      return ["Linear", "( value )"];
  }
}
function getShaderErrors(gl, shader, type) {
  const status = gl.getShaderParameter(shader, 35713);
  const log = gl.getShaderInfoLog(shader).trim();
  if (status && log === "")
    return "";
  const source = gl.getShaderSource(shader);
  return "THREE.WebGLShader: gl.getShaderInfoLog() " + type + "\n" + log + addLineNumbers(source);
}
function getTexelDecodingFunction(functionName, encoding) {
  const components = getEncodingComponents(encoding);
  return "vec4 " + functionName + "( vec4 value ) { return " + components[0] + "ToLinear" + components[1] + "; }";
}
function getTexelEncodingFunction(functionName, encoding) {
  const components = getEncodingComponents(encoding);
  return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function getToneMappingFunction(functionName, toneMapping) {
  let toneMappingName;
  switch (toneMapping) {
    case LinearToneMapping:
      toneMappingName = "Linear";
      break;
    case ReinhardToneMapping:
      toneMappingName = "Reinhard";
      break;
    case CineonToneMapping:
      toneMappingName = "OptimizedCineon";
      break;
    case ACESFilmicToneMapping:
      toneMappingName = "ACESFilmic";
      break;
    case CustomToneMapping:
      toneMappingName = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
      toneMappingName = "Linear";
  }
  return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function generateExtensions(parameters) {
  const chunks = [
    parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission > 0) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ];
  return chunks.filter(filterEmptyLine).join("\n");
}
function generateDefines(defines) {
  const chunks = [];
  for (const name in defines) {
    const value = defines[name];
    if (value === false)
      continue;
    chunks.push("#define " + name + " " + value);
  }
  return chunks.join("\n");
}
function fetchAttributeLocations(gl, program) {
  const attributes = {};
  const n = gl.getProgramParameter(program, 35721);
  for (let i = 0; i < n; i++) {
    const info = gl.getActiveAttrib(program, i);
    const name = info.name;
    attributes[name] = gl.getAttribLocation(program, name);
  }
  return attributes;
}
function filterEmptyLine(string) {
  return string !== "";
}
function replaceLightNums(string, parameters) {
  return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
  return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string) {
  return string.replace(includePattern, includeReplacer);
}
function includeReplacer(match, include) {
  const string = ShaderChunk[include];
  if (string === void 0) {
    throw new Error("Can not resolve #include <" + include + ">");
  }
  return resolveIncludes(string);
}
const deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string) {
  return string.replace(unrollLoopPattern, loopReplacer).replace(deprecatedUnrollLoopPattern, deprecatedLoopReplacer);
}
function deprecatedLoopReplacer(match, start, end, snippet) {
  console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
  return loopReplacer(match, start, end, snippet);
}
function loopReplacer(match, start, end, snippet) {
  let string = "";
  for (let i = parseInt(start); i < parseInt(end); i++) {
    string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
  }
  return string;
}
function generatePrecision(parameters) {
  let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
  if (parameters.precision === "highp") {
    precisionstring += "\n#define HIGH_PRECISION";
  } else if (parameters.precision === "mediump") {
    precisionstring += "\n#define MEDIUM_PRECISION";
  } else if (parameters.precision === "lowp") {
    precisionstring += "\n#define LOW_PRECISION";
  }
  return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
  let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
  if (parameters.shadowMapType === PCFShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
  } else if (parameters.shadowMapType === PCFSoftShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
  } else if (parameters.shadowMapType === VSMShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
  }
  return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
  let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping$1:
      case CubeRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
      case CubeUVRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  }
  return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
  let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping:
      case CubeUVRefractionMapping:
        envMapModeDefine = "ENVMAP_MODE_REFRACTION";
        break;
    }
  }
  return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
  let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
        break;
    }
  }
  return envMapBlendingDefine;
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
  const gl = renderer.getContext();
  const defines = parameters.defines;
  let vertexShader = parameters.vertexShader;
  let fragmentShader = parameters.fragmentShader;
  const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
  const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
  const envMapModeDefine = generateEnvMapModeDefine(parameters);
  const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
  const gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1;
  const customExtensions = parameters.isWebGL2 ? "" : generateExtensions(parameters);
  const customDefines = generateDefines(defines);
  const program = gl.createProgram();
  let prefixVertex, prefixFragment;
  let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
  if (parameters.isRawShaderMaterial) {
    prefixVertex = [
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixVertex.length > 0) {
      prefixVertex += "\n";
    }
    prefixFragment = [
      customExtensions,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixFragment.length > 0) {
      prefixFragment += "\n";
    }
  } else {
    prefixVertex = [
      generatePrecision(parameters),
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.instancing ? "#define USE_INSTANCING" : "",
      parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
      parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
      "#define GAMMA_FACTOR " + gammaFactorDefine,
      "#define MAX_BONES " + parameters.maxBones,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
      parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents ? "#define USE_TANGENT" : "",
      parameters.vertexColors ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUvs ? "#define USE_UV" : "",
      parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.skinning ? "#define USE_SKINNING" : "",
      parameters.useVertexTexture ? "#define BONE_TEXTURE" : "",
      parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
      parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
      "uniform mat4 modelMatrix;",
      "uniform mat4 modelViewMatrix;",
      "uniform mat4 projectionMatrix;",
      "uniform mat4 viewMatrix;",
      "uniform mat3 normalMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      "#ifdef USE_INSTANCING",
      "	attribute mat4 instanceMatrix;",
      "#endif",
      "#ifdef USE_INSTANCING_COLOR",
      "	attribute vec3 instanceColor;",
      "#endif",
      "attribute vec3 position;",
      "attribute vec3 normal;",
      "attribute vec2 uv;",
      "#ifdef USE_TANGENT",
      "	attribute vec4 tangent;",
      "#endif",
      "#if defined( USE_COLOR_ALPHA )",
      "	attribute vec4 color;",
      "#elif defined( USE_COLOR )",
      "	attribute vec3 color;",
      "#endif",
      "#ifdef USE_MORPHTARGETS",
      "	attribute vec3 morphTarget0;",
      "	attribute vec3 morphTarget1;",
      "	attribute vec3 morphTarget2;",
      "	attribute vec3 morphTarget3;",
      "	#ifdef USE_MORPHNORMALS",
      "		attribute vec3 morphNormal0;",
      "		attribute vec3 morphNormal1;",
      "		attribute vec3 morphNormal2;",
      "		attribute vec3 morphNormal3;",
      "	#else",
      "		attribute vec3 morphTarget4;",
      "		attribute vec3 morphTarget5;",
      "		attribute vec3 morphTarget6;",
      "		attribute vec3 morphTarget7;",
      "	#endif",
      "#endif",
      "#ifdef USE_SKINNING",
      "	attribute vec4 skinIndex;",
      "	attribute vec4 skinWeight;",
      "#endif",
      "\n"
    ].filter(filterEmptyLine).join("\n");
    prefixFragment = [
      customExtensions,
      generatePrecision(parameters),
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.alphaTest ? "#define ALPHATEST " + parameters.alphaTest + (parameters.alphaTest % 1 ? "" : ".0") : "",
      "#define GAMMA_FACTOR " + gammaFactorDefine,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.matcap ? "#define USE_MATCAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapTypeDefine : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.envMap ? "#define " + envMapBlendingDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
      parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.sheen ? "#define USE_SHEEN" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents ? "#define USE_TANGENT" : "",
      parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUvs ? "#define USE_UV" : "",
      parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
      parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
      parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
      (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? "#define TEXTURE_LOD_EXT" : "",
      "uniform mat4 viewMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      parameters.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
      parameters.toneMapping !== NoToneMapping ? ShaderChunk["tonemapping_pars_fragment"] : "",
      parameters.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
      parameters.dithering ? "#define DITHERING" : "",
      ShaderChunk["encodings_pars_fragment"],
      parameters.map ? getTexelDecodingFunction("mapTexelToLinear", parameters.mapEncoding) : "",
      parameters.matcap ? getTexelDecodingFunction("matcapTexelToLinear", parameters.matcapEncoding) : "",
      parameters.envMap ? getTexelDecodingFunction("envMapTexelToLinear", parameters.envMapEncoding) : "",
      parameters.emissiveMap ? getTexelDecodingFunction("emissiveMapTexelToLinear", parameters.emissiveMapEncoding) : "",
      parameters.lightMap ? getTexelDecodingFunction("lightMapTexelToLinear", parameters.lightMapEncoding) : "",
      getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
      parameters.depthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
      "\n"
    ].filter(filterEmptyLine).join("\n");
  }
  vertexShader = resolveIncludes(vertexShader);
  vertexShader = replaceLightNums(vertexShader, parameters);
  vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
  fragmentShader = resolveIncludes(fragmentShader);
  fragmentShader = replaceLightNums(fragmentShader, parameters);
  fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
  vertexShader = unrollLoops(vertexShader);
  fragmentShader = unrollLoops(fragmentShader);
  if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
    versionString = "#version 300 es\n";
    prefixVertex = [
      "#define attribute in",
      "#define varying out",
      "#define texture2D texture"
    ].join("\n") + "\n" + prefixVertex;
    prefixFragment = [
      "#define varying in",
      parameters.glslVersion === GLSL3 ? "" : "out highp vec4 pc_fragColor;",
      parameters.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
      "#define gl_FragDepthEXT gl_FragDepth",
      "#define texture2D texture",
      "#define textureCube texture",
      "#define texture2DProj textureProj",
      "#define texture2DLodEXT textureLod",
      "#define texture2DProjLodEXT textureProjLod",
      "#define textureCubeLodEXT textureLod",
      "#define texture2DGradEXT textureGrad",
      "#define texture2DProjGradEXT textureProjGrad",
      "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + prefixFragment;
  }
  const vertexGlsl = versionString + prefixVertex + vertexShader;
  const fragmentGlsl = versionString + prefixFragment + fragmentShader;
  const glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
  const glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader);
  if (parameters.index0AttributeName !== void 0) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    gl.bindAttribLocation(program, 0, "position");
  }
  gl.linkProgram(program);
  if (renderer.debug.checkShaderErrors) {
    const programLog = gl.getProgramInfoLog(program).trim();
    const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
    const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
    let runnable = true;
    let haveDiagnostics = true;
    if (gl.getProgramParameter(program, 35714) === false) {
      runnable = false;
      const vertexErrors = getShaderErrors(gl, glVertexShader, "vertex");
      const fragmentErrors = getShaderErrors(gl, glFragmentShader, "fragment");
      console.error("THREE.WebGLProgram: shader error: ", gl.getError(), "35715", gl.getProgramParameter(program, 35715), "gl.getProgramInfoLog", programLog, vertexErrors, fragmentErrors);
    } else if (programLog !== "") {
      console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", programLog);
    } else if (vertexLog === "" || fragmentLog === "") {
      haveDiagnostics = false;
    }
    if (haveDiagnostics) {
      this.diagnostics = {
        runnable,
        programLog,
        vertexShader: {
          log: vertexLog,
          prefix: prefixVertex
        },
        fragmentShader: {
          log: fragmentLog,
          prefix: prefixFragment
        }
      };
    }
  }
  gl.deleteShader(glVertexShader);
  gl.deleteShader(glFragmentShader);
  let cachedUniforms;
  this.getUniforms = function() {
    if (cachedUniforms === void 0) {
      cachedUniforms = new WebGLUniforms(gl, program);
    }
    return cachedUniforms;
  };
  let cachedAttributes;
  this.getAttributes = function() {
    if (cachedAttributes === void 0) {
      cachedAttributes = fetchAttributeLocations(gl, program);
    }
    return cachedAttributes;
  };
  this.destroy = function() {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = void 0;
  };
  this.name = parameters.shaderName;
  this.id = programIdCount++;
  this.cacheKey = cacheKey;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}
function WebGLPrograms(renderer, cubemaps, extensions, capabilities, bindingStates, clipping) {
  const programs = [];
  const isWebGL2 = capabilities.isWebGL2;
  const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  const floatVertexTextures = capabilities.floatVertexTextures;
  const maxVertexUniforms = capabilities.maxVertexUniforms;
  const vertexTextures = capabilities.vertexTextures;
  let precision = capabilities.precision;
  const shaderIDs = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  const parameterNames = [
    "precision",
    "isWebGL2",
    "supportsVertexTextures",
    "outputEncoding",
    "instancing",
    "instancingColor",
    "map",
    "mapEncoding",
    "matcap",
    "matcapEncoding",
    "envMap",
    "envMapMode",
    "envMapEncoding",
    "envMapCubeUV",
    "lightMap",
    "lightMapEncoding",
    "aoMap",
    "emissiveMap",
    "emissiveMapEncoding",
    "bumpMap",
    "normalMap",
    "objectSpaceNormalMap",
    "tangentSpaceNormalMap",
    "clearcoatMap",
    "clearcoatRoughnessMap",
    "clearcoatNormalMap",
    "displacementMap",
    "specularMap",
    "roughnessMap",
    "metalnessMap",
    "gradientMap",
    "alphaMap",
    "combine",
    "vertexColors",
    "vertexAlphas",
    "vertexTangents",
    "vertexUvs",
    "uvsVertexOnly",
    "fog",
    "useFog",
    "fogExp2",
    "flatShading",
    "sizeAttenuation",
    "logarithmicDepthBuffer",
    "skinning",
    "maxBones",
    "useVertexTexture",
    "morphTargets",
    "morphNormals",
    "premultipliedAlpha",
    "numDirLights",
    "numPointLights",
    "numSpotLights",
    "numHemiLights",
    "numRectAreaLights",
    "numDirLightShadows",
    "numPointLightShadows",
    "numSpotLightShadows",
    "shadowMapEnabled",
    "shadowMapType",
    "toneMapping",
    "physicallyCorrectLights",
    "alphaTest",
    "doubleSided",
    "flipSided",
    "numClippingPlanes",
    "numClipIntersection",
    "depthPacking",
    "dithering",
    "sheen",
    "transmission",
    "transmissionMap",
    "thicknessMap"
  ];
  function getMaxBones(object) {
    const skeleton = object.skeleton;
    const bones = skeleton.bones;
    if (floatVertexTextures) {
      return 1024;
    } else {
      const nVertexUniforms = maxVertexUniforms;
      const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
      const maxBones = Math.min(nVertexMatrices, bones.length);
      if (maxBones < bones.length) {
        console.warn("THREE.WebGLRenderer: Skeleton has " + bones.length + " bones. This GPU supports " + maxBones + ".");
        return 0;
      }
      return maxBones;
    }
  }
  function getTextureEncodingFromMap(map) {
    let encoding;
    if (map && map.isTexture) {
      encoding = map.encoding;
    } else if (map && map.isWebGLRenderTarget) {
      console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead.");
      encoding = map.texture.encoding;
    } else {
      encoding = LinearEncoding$1;
    }
    return encoding;
  }
  function getParameters(material, lights, shadows, scene, object) {
    const fog = scene.fog;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const envMap = cubemaps.get(material.envMap || environment);
    const shaderID = shaderIDs[material.type];
    const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);
      if (precision !== material.precision) {
        console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
      }
    }
    let vertexShader, fragmentShader;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      vertexShader = shader.vertexShader;
      fragmentShader = shader.fragmentShader;
    } else {
      vertexShader = material.vertexShader;
      fragmentShader = material.fragmentShader;
    }
    const currentRenderTarget = renderer.getRenderTarget();
    const parameters = {
      isWebGL2,
      shaderID,
      shaderName: material.type,
      vertexShader,
      fragmentShader,
      defines: material.defines,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision,
      instancing: object.isInstancedMesh === true,
      instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
      supportsVertexTextures: vertexTextures,
      outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
      map: !!material.map,
      mapEncoding: getTextureEncodingFromMap(material.map),
      matcap: !!material.matcap,
      matcapEncoding: getTextureEncodingFromMap(material.matcap),
      envMap: !!envMap,
      envMapMode: envMap && envMap.mapping,
      envMapEncoding: getTextureEncodingFromMap(envMap),
      envMapCubeUV: !!envMap && (envMap.mapping === CubeUVReflectionMapping || envMap.mapping === CubeUVRefractionMapping),
      lightMap: !!material.lightMap,
      lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
      aoMap: !!material.aoMap,
      emissiveMap: !!material.emissiveMap,
      emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
      bumpMap: !!material.bumpMap,
      normalMap: !!material.normalMap,
      objectSpaceNormalMap: material.normalMapType === ObjectSpaceNormalMap,
      tangentSpaceNormalMap: material.normalMapType === TangentSpaceNormalMap,
      clearcoatMap: !!material.clearcoatMap,
      clearcoatRoughnessMap: !!material.clearcoatRoughnessMap,
      clearcoatNormalMap: !!material.clearcoatNormalMap,
      displacementMap: !!material.displacementMap,
      roughnessMap: !!material.roughnessMap,
      metalnessMap: !!material.metalnessMap,
      specularMap: !!material.specularMap,
      alphaMap: !!material.alphaMap,
      gradientMap: !!material.gradientMap,
      sheen: !!material.sheen,
      transmission: !!material.transmission,
      transmissionMap: !!material.transmissionMap,
      thicknessMap: !!material.thicknessMap,
      combine: material.combine,
      vertexTangents: material.normalMap && material.vertexTangents,
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
      vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmission || !!material.transmissionMap || !!material.thicknessMap,
      uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.transmission || !!material.transmissionMap || !!material.thicknessMap) && !!material.displacementMap,
      fog: !!fog,
      useFog: material.fog,
      fogExp2: fog && fog.isFogExp2,
      flatShading: !!material.flatShading,
      sizeAttenuation: material.sizeAttenuation,
      logarithmicDepthBuffer,
      skinning: object.isSkinnedMesh === true && maxBones > 0,
      maxBones,
      useVertexTexture: floatVertexTextures,
      morphTargets: material.morphTargets,
      morphNormals: material.morphNormals,
      numDirLights: lights.directional.length,
      numPointLights: lights.point.length,
      numSpotLights: lights.spot.length,
      numRectAreaLights: lights.rectArea.length,
      numHemiLights: lights.hemi.length,
      numDirLightShadows: lights.directionalShadowMap.length,
      numPointLightShadows: lights.pointShadowMap.length,
      numSpotLightShadows: lights.spotShadowMap.length,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
      physicallyCorrectLights: renderer.physicallyCorrectLights,
      premultipliedAlpha: material.premultipliedAlpha,
      alphaTest: material.alphaTest,
      doubleSided: material.side === DoubleSide,
      flipSided: material.side === BackSide,
      depthPacking: material.depthPacking !== void 0 ? material.depthPacking : false,
      index0AttributeName: material.index0AttributeName,
      extensionDerivatives: material.extensions && material.extensions.derivatives,
      extensionFragDepth: material.extensions && material.extensions.fragDepth,
      extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
      extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    return parameters;
  }
  function getProgramCacheKey(parameters) {
    const array = [];
    if (parameters.shaderID) {
      array.push(parameters.shaderID);
    } else {
      array.push(parameters.fragmentShader);
      array.push(parameters.vertexShader);
    }
    if (parameters.defines !== void 0) {
      for (const name in parameters.defines) {
        array.push(name);
        array.push(parameters.defines[name]);
      }
    }
    if (parameters.isRawShaderMaterial === false) {
      for (let i = 0; i < parameterNames.length; i++) {
        array.push(parameters[parameterNames[i]]);
      }
      array.push(renderer.outputEncoding);
      array.push(renderer.gammaFactor);
    }
    array.push(parameters.customProgramCacheKey);
    return array.join();
  }
  function getUniforms(material) {
    const shaderID = shaderIDs[material.type];
    let uniforms;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      uniforms = UniformsUtils.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }
    return uniforms;
  }
  function acquireProgram(parameters, cacheKey) {
    let program;
    for (let p = 0, pl = programs.length; p < pl; p++) {
      const preexistingProgram = programs[p];
      if (preexistingProgram.cacheKey === cacheKey) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }
    if (program === void 0) {
      program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
      programs.push(program);
    }
    return program;
  }
  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      const i = programs.indexOf(program);
      programs[i] = programs[programs.length - 1];
      programs.pop();
      program.destroy();
    }
  }
  return {
    getParameters,
    getProgramCacheKey,
    getUniforms,
    acquireProgram,
    releaseProgram,
    programs
  };
}
function WebGLProperties() {
  let properties = /* @__PURE__ */ new WeakMap();
  function get(object) {
    let map = properties.get(object);
    if (map === void 0) {
      map = {};
      properties.set(object, map);
    }
    return map;
  }
  function remove(object) {
    properties.delete(object);
  }
  function update(object, key, value) {
    properties.get(object)[key] = value;
  }
  function dispose2() {
    properties = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    remove,
    update,
    dispose: dispose2
  };
}
function painterSortStable(a, b) {
  if (a.groupOrder !== b.groupOrder) {
    return a.groupOrder - b.groupOrder;
  } else if (a.renderOrder !== b.renderOrder) {
    return a.renderOrder - b.renderOrder;
  } else if (a.program !== b.program) {
    return a.program.id - b.program.id;
  } else if (a.material.id !== b.material.id) {
    return a.material.id - b.material.id;
  } else if (a.z !== b.z) {
    return a.z - b.z;
  } else {
    return a.id - b.id;
  }
}
function reversePainterSortStable(a, b) {
  if (a.groupOrder !== b.groupOrder) {
    return a.groupOrder - b.groupOrder;
  } else if (a.renderOrder !== b.renderOrder) {
    return a.renderOrder - b.renderOrder;
  } else if (a.z !== b.z) {
    return b.z - a.z;
  } else {
    return a.id - b.id;
  }
}
function WebGLRenderList(properties) {
  const renderItems = [];
  let renderItemsIndex = 0;
  const opaque = [];
  const transmissive = [];
  const transparent = [];
  const defaultProgram = { id: -1 };
  function init() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }
  function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
    let renderItem = renderItems[renderItemsIndex];
    const materialProperties = properties.get(material);
    if (renderItem === void 0) {
      renderItem = {
        id: object.id,
        object,
        geometry,
        material,
        program: materialProperties.program || defaultProgram,
        groupOrder,
        renderOrder: object.renderOrder,
        z,
        group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object.id;
      renderItem.object = object;
      renderItem.geometry = geometry;
      renderItem.material = material;
      renderItem.program = materialProperties.program || defaultProgram;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object.renderOrder;
      renderItem.z = z;
      renderItem.group = group;
    }
    renderItemsIndex++;
    return renderItem;
  }
  function push(object, geometry, material, groupOrder, z, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
    if (material.transmission > 0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }
  function unshift(object, geometry, material, groupOrder, z, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
    if (material.transmission > 0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }
  function sort(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1)
      opaque.sort(customOpaqueSort || painterSortStable);
    if (transmissive.length > 1)
      transmissive.sort(customTransparentSort || reversePainterSortStable);
    if (transparent.length > 1)
      transparent.sort(customTransparentSort || reversePainterSortStable);
  }
  function finish() {
    for (let i = renderItemsIndex, il = renderItems.length; i < il; i++) {
      const renderItem = renderItems[i];
      if (renderItem.id === null)
        break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.program = null;
      renderItem.group = null;
    }
  }
  return {
    opaque,
    transmissive,
    transparent,
    init,
    push,
    unshift,
    finish,
    sort
  };
}
function WebGLRenderLists(properties) {
  let lists = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth) {
    let list;
    if (lists.has(scene) === false) {
      list = new WebGLRenderList(properties);
      lists.set(scene, [list]);
    } else {
      if (renderCallDepth >= lists.get(scene).length) {
        list = new WebGLRenderList(properties);
        lists.get(scene).push(list);
      } else {
        list = lists.get(scene)[renderCallDepth];
      }
    }
    return list;
  }
  function dispose2() {
    lists = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose: dispose2
  };
}
function UniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            direction: new Vector3$1(),
            color: new Color()
          };
          break;
        case "SpotLight":
          uniforms = {
            position: new Vector3$1(),
            direction: new Vector3$1(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          uniforms = {
            position: new Vector3$1(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          uniforms = {
            direction: new Vector3$1(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;
        case "RectAreaLight":
          uniforms = {
            color: new Color(),
            position: new Vector3$1(),
            halfWidth: new Vector3$1(),
            halfHeight: new Vector3$1()
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
function ShadowUniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1()
          };
          break;
        case "SpotLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1()
          };
          break;
        case "PointLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
let nextVersion = 0;
function shadowCastingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function WebGLLights(extensions, capabilities) {
  const cache = new UniformsCache();
  const shadowCache = ShadowUniformsCache();
  const state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };
  for (let i = 0; i < 9; i++)
    state.probe.push(new Vector3$1());
  const vector3 = new Vector3$1();
  const matrix4 = new Matrix4();
  const matrix42 = new Matrix4();
  function setup(lights) {
    let r = 0, g = 0, b = 0;
    for (let i = 0; i < 9; i++)
      state.probe[i].set(0, 0, 0);
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    let numDirectionalShadows = 0;
    let numPointShadows = 0;
    let numSpotShadows = 0;
    lights.sort(shadowCastingLightsFirst);
    for (let i = 0, l = lights.length; i < l; i++) {
      const light = lights[i];
      const color = light.color;
      const intensity = light.intensity;
      const distance = light.distance;
      const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
      if (light.isAmbientLight) {
        r += color.r * intensity;
        g += color.g * intensity;
        b += color.b * intensity;
      } else if (light.isLightProbe) {
        for (let j = 0; j < 9; j++) {
          state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
        }
      } else if (light.isDirectionalLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }
        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = cache.get(light);
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.distance = distance;
        uniforms.coneCos = Math.cos(light.angle);
        uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.spotShadow[spotLength] = shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          state.spotShadowMatrix[spotLength] = light.shadow.matrix;
          numSpotShadows++;
        }
        state.spot[spotLength] = uniforms;
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        state.rectArea[rectAreaLength] = uniforms;
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        uniforms.distance = light.distance;
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          shadowUniforms.shadowCameraNear = shadow.camera.near;
          shadowUniforms.shadowCameraFar = shadow.camera.far;
          state.pointShadow[pointLength] = shadowUniforms;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }
        state.point[pointLength] = uniforms;
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = cache.get(light);
        uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
        uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
        state.hemi[hemiLength] = uniforms;
        hemiLength++;
      }
    }
    if (rectAreaLength > 0) {
      if (capabilities.isWebGL2) {
        state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
      } else {
        if (extensions.has("OES_texture_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
          state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
        } else if (extensions.has("OES_texture_half_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
          state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
        } else {
          console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
        }
      }
    }
    state.ambient[0] = r;
    state.ambient[1] = g;
    state.ambient[2] = b;
    const hash = state.hash;
    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotShadowMatrix.length = numSpotShadows;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      state.version = nextVersion++;
    }
  }
  function setupView(lights, camera) {
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    const viewMatrix = camera.matrixWorldInverse;
    for (let i = 0, l = lights.length; i < l; i++) {
      const light = lights[i];
      if (light.isDirectionalLight) {
        const uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = state.spot[spotLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = state.rectArea[rectAreaLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        uniforms.halfWidth.applyMatrix4(matrix42);
        uniforms.halfHeight.applyMatrix4(matrix42);
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = state.point[pointLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = state.hemi[hemiLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        uniforms.direction.transformDirection(viewMatrix);
        uniforms.direction.normalize();
        hemiLength++;
      }
    }
  }
  return {
    setup,
    setupView,
    state
  };
}
function WebGLRenderState(extensions, capabilities) {
  const lights = new WebGLLights(extensions, capabilities);
  const lightsArray = [];
  const shadowsArray = [];
  function init() {
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }
  function pushLight(light) {
    lightsArray.push(light);
  }
  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }
  function setupLights() {
    lights.setup(lightsArray);
  }
  function setupLightsView(camera) {
    lights.setupView(lightsArray, camera);
  }
  const state = {
    lightsArray,
    shadowsArray,
    lights
  };
  return {
    init,
    state,
    setupLights,
    setupLightsView,
    pushLight,
    pushShadow
  };
}
function WebGLRenderStates(extensions, capabilities) {
  let renderStates = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth = 0) {
    let renderState;
    if (renderStates.has(scene) === false) {
      renderState = new WebGLRenderState(extensions, capabilities);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStates.get(scene).length) {
        renderState = new WebGLRenderState(extensions, capabilities);
        renderStates.get(scene).push(renderState);
      } else {
        renderState = renderStates.get(scene)[renderCallDepth];
      }
    }
    return renderState;
  }
  function dispose2() {
    renderStates = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose: dispose2
  };
}
class MeshDepthMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "MeshDepthMaterial";
    this.depthPacking = BasicDepthPacking;
    this.morphTargets = false;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.depthPacking = source.depthPacking;
    this.morphTargets = source.morphTargets;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
  }
}
MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
class MeshDistanceMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "MeshDistanceMaterial";
    this.referencePosition = new Vector3$1();
    this.nearDistance = 1;
    this.farDistance = 1e3;
    this.morphTargets = false;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.fog = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.referencePosition.copy(source.referencePosition);
    this.nearDistance = source.nearDistance;
    this.farDistance = source.farDistance;
    this.morphTargets = source.morphTargets;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
  }
}
MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
var vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n	for ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean * HALF_SAMPLE_RATE;\n	squared_mean = squared_mean * HALF_SAMPLE_RATE;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var vsm_vert = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
function WebGLShadowMap(_renderer, _objects, _capabilities) {
  let _frustum = new Frustum();
  const _shadowMapSize = new Vector2$1(), _viewportSize = new Vector2$1(), _viewport = new Vector4(), _depthMaterials = [], _distanceMaterials = [], _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
  const shadowSide = { 0: BackSide, 1: FrontSide, 2: DoubleSide };
  const shadowMaterialVertical = new ShaderMaterial({
    defines: {
      SAMPLE_RATE: 2 / 8,
      HALF_SAMPLE_RATE: 1 / 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2$1() },
      radius: { value: 4 }
    },
    vertexShader: vsm_vert,
    fragmentShader: vsm_frag
  });
  const shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  const fullScreenTri = new BufferGeometry();
  fullScreenTri.setAttribute(
    "position",
    new BufferAttribute(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
  const scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap;
  this.render = function(lights, scene, camera) {
    if (scope.enabled === false)
      return;
    if (scope.autoUpdate === false && scope.needsUpdate === false)
      return;
    if (lights.length === 0)
      return;
    const currentRenderTarget = _renderer.getRenderTarget();
    const activeCubeFace = _renderer.getActiveCubeFace();
    const activeMipmapLevel = _renderer.getActiveMipmapLevel();
    const _state = _renderer.state;
    _state.setBlending(NoBlending);
    _state.buffers.color.setClear(1, 1, 1, 1);
    _state.buffers.depth.setTest(true);
    _state.setScissorTest(false);
    for (let i = 0, il = lights.length; i < il; i++) {
      const light = lights[i];
      const shadow = light.shadow;
      if (shadow === void 0) {
        console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
        continue;
      }
      if (shadow.autoUpdate === false && shadow.needsUpdate === false)
        continue;
      _shadowMapSize.copy(shadow.mapSize);
      const shadowFrameExtents = shadow.getFrameExtents();
      _shadowMapSize.multiply(shadowFrameExtents);
      _viewportSize.copy(shadow.mapSize);
      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow.mapSize.x = _viewportSize.x;
        }
        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow.mapSize.y = _viewportSize.y;
        }
      }
      if (shadow.map === null && !shadow.isPointLightShadow && this.type === VSMShadowMap) {
        const pars = { minFilter: LinearFilter$1, magFilter: LinearFilter$1, format: RGBAFormat$1 };
        shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.camera.updateProjectionMatrix();
      }
      if (shadow.map === null) {
        const pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat$1 };
        shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.camera.updateProjectionMatrix();
      }
      _renderer.setRenderTarget(shadow.map);
      _renderer.clear();
      const viewportCount = shadow.getViewportCount();
      for (let vp = 0; vp < viewportCount; vp++) {
        const viewport = shadow.getViewport(vp);
        _viewport.set(
          _viewportSize.x * viewport.x,
          _viewportSize.y * viewport.y,
          _viewportSize.x * viewport.z,
          _viewportSize.y * viewport.w
        );
        _state.viewport(_viewport);
        shadow.updateMatrices(light, vp);
        _frustum = shadow.getFrustum();
        renderObject(scene, camera, shadow.camera, light, this.type);
      }
      if (!shadow.isPointLightShadow && this.type === VSMShadowMap) {
        VSMPass(shadow, camera);
      }
      shadow.needsUpdate = false;
    }
    scope.needsUpdate = false;
    _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };
  function VSMPass(shadow, camera) {
    const geometry = _objects.update(fullScreenMesh);
    shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow.radius;
    _renderer.setRenderTarget(shadow.mapPass);
    _renderer.clear();
    _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
    _renderer.setRenderTarget(shadow.map);
    _renderer.clear();
    _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
  }
  function getDepthMaterialVariant(useMorphing) {
    const index = useMorphing << 0;
    let material = _depthMaterials[index];
    if (material === void 0) {
      material = new MeshDepthMaterial({
        depthPacking: RGBADepthPacking,
        morphTargets: useMorphing
      });
      _depthMaterials[index] = material;
    }
    return material;
  }
  function getDistanceMaterialVariant(useMorphing) {
    const index = useMorphing << 0;
    let material = _distanceMaterials[index];
    if (material === void 0) {
      material = new MeshDistanceMaterial({
        morphTargets: useMorphing
      });
      _distanceMaterials[index] = material;
    }
    return material;
  }
  function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
    let result = null;
    let getMaterialVariant = getDepthMaterialVariant;
    let customMaterial = object.customDepthMaterial;
    if (light.isPointLight === true) {
      getMaterialVariant = getDistanceMaterialVariant;
      customMaterial = object.customDistanceMaterial;
    }
    if (customMaterial === void 0) {
      let useMorphing = false;
      if (material.morphTargets === true) {
        useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
      }
      result = getMaterialVariant(useMorphing);
    } else {
      result = customMaterial;
    }
    if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0) {
      const keyA = result.uuid, keyB = material.uuid;
      let materialsForVariant = _materialCache[keyA];
      if (materialsForVariant === void 0) {
        materialsForVariant = {};
        _materialCache[keyA] = materialsForVariant;
      }
      let cachedMaterial = materialsForVariant[keyB];
      if (cachedMaterial === void 0) {
        cachedMaterial = result.clone();
        materialsForVariant[keyB] = cachedMaterial;
      }
      result = cachedMaterial;
    }
    result.visible = material.visible;
    result.wireframe = material.wireframe;
    if (type === VSMShadowMap) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;
    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      result.referencePosition.setFromMatrixPosition(light.matrixWorld);
      result.nearDistance = shadowCameraNear;
      result.farDistance = shadowCameraFar;
    }
    return result;
  }
  function renderObject(object, camera, shadowCamera, light, type) {
    if (object.visible === false)
      return;
    const visible = object.layers.test(camera.layers);
    if (visible && (object.isMesh || object.isLine || object.isPoints)) {
      if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
        object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
        const geometry = _objects.update(object);
        const material = object.material;
        if (Array.isArray(material)) {
          const groups = geometry.groups;
          for (let k = 0, kl = groups.length; k < kl; k++) {
            const group = groups[k];
            const groupMaterial = material[group.materialIndex];
            if (groupMaterial && groupMaterial.visible) {
              const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
              _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
            }
          }
        } else if (material.visible) {
          const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
          _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
        }
      }
    }
    const children = object.children;
    for (let i = 0, l = children.length; i < l; i++) {
      renderObject(children[i], camera, shadowCamera, light, type);
    }
  }
}
function WebGLState(gl, extensions, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  function ColorBuffer() {
    let locked = false;
    const color = new Vector4();
    let currentColorMask = null;
    const currentColorClear = new Vector4(0, 0, 0, 0);
    return {
      setMask: function(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(r, g, b, a, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r *= a;
          g *= a;
          b *= a;
        }
        color.set(r, g, b, a);
        if (currentColorClear.equals(color) === false) {
          gl.clearColor(r, g, b, a);
          currentColorClear.copy(color);
        }
      },
      reset: function() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0);
      }
    };
  }
  function DepthBuffer() {
    let locked = false;
    let currentDepthMask = null;
    let currentDepthFunc = null;
    let currentDepthClear = null;
    return {
      setTest: function(depthTest) {
        if (depthTest) {
          enable(2929);
        } else {
          disable(2929);
        }
      },
      setMask: function(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function(depthFunc) {
        if (currentDepthFunc !== depthFunc) {
          if (depthFunc) {
            switch (depthFunc) {
              case NeverDepth:
                gl.depthFunc(512);
                break;
              case AlwaysDepth:
                gl.depthFunc(519);
                break;
              case LessDepth:
                gl.depthFunc(513);
                break;
              case LessEqualDepth:
                gl.depthFunc(515);
                break;
              case EqualDepth:
                gl.depthFunc(514);
                break;
              case GreaterEqualDepth:
                gl.depthFunc(518);
                break;
              case GreaterDepth:
                gl.depthFunc(516);
                break;
              case NotEqualDepth:
                gl.depthFunc(517);
                break;
              default:
                gl.depthFunc(515);
            }
          } else {
            gl.depthFunc(515);
          }
          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(depth) {
        if (currentDepthClear !== depth) {
          gl.clearDepth(depth);
          currentDepthClear = depth;
        }
      },
      reset: function() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
      }
    };
  }
  function StencilBuffer() {
    let locked = false;
    let currentStencilMask = null;
    let currentStencilFunc = null;
    let currentStencilRef = null;
    let currentStencilFuncMask = null;
    let currentStencilFail = null;
    let currentStencilZFail = null;
    let currentStencilZPass = null;
    let currentStencilClear = null;
    return {
      setTest: function(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable(2960);
          } else {
            disable(2960);
          }
        }
      },
      setMask: function(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  }
  const colorBuffer = new ColorBuffer();
  const depthBuffer = new DepthBuffer();
  const stencilBuffer = new StencilBuffer();
  let enabledCapabilities = {};
  let xrFramebuffer = null;
  let currentBoundFramebuffers = {};
  let currentProgram = null;
  let currentBlendingEnabled = false;
  let currentBlending = null;
  let currentBlendEquation = null;
  let currentBlendSrc = null;
  let currentBlendDst = null;
  let currentBlendEquationAlpha = null;
  let currentBlendSrcAlpha = null;
  let currentBlendDstAlpha = null;
  let currentPremultipledAlpha = false;
  let currentFlipSided = null;
  let currentCullFace = null;
  let currentLineWidth = null;
  let currentPolygonOffsetFactor = null;
  let currentPolygonOffsetUnits = null;
  const maxTextures = gl.getParameter(35661);
  let lineWidthAvailable = false;
  let version = 0;
  const glVersion = gl.getParameter(7938);
  if (glVersion.indexOf("WebGL") !== -1) {
    version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 1;
  } else if (glVersion.indexOf("OpenGL ES") !== -1) {
    version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 2;
  }
  let currentTextureSlot = null;
  let currentBoundTextures = {};
  const scissorParam = gl.getParameter(3088);
  const viewportParam = gl.getParameter(2978);
  const currentScissor = new Vector4().fromArray(scissorParam);
  const currentViewport = new Vector4().fromArray(viewportParam);
  function createTexture(type, target, count) {
    const data = new Uint8Array(4);
    const texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, 10241, 9728);
    gl.texParameteri(type, 10240, 9728);
    for (let i = 0; i < count; i++) {
      gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
    }
    return texture;
  }
  const emptyTextures = {};
  emptyTextures[3553] = createTexture(3553, 3553, 1);
  emptyTextures[34067] = createTexture(34067, 34069, 6);
  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable(2929);
  depthBuffer.setFunc(LessEqualDepth);
  setFlipSided(false);
  setCullFace(CullFaceBack);
  enable(2884);
  setBlending(NoBlending);
  function enable(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }
  function disable(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }
  function bindXRFramebuffer(framebuffer) {
    if (framebuffer !== xrFramebuffer) {
      gl.bindFramebuffer(36160, framebuffer);
      xrFramebuffer = framebuffer;
    }
  }
  function bindFramebuffer(target, framebuffer) {
    if (framebuffer === null && xrFramebuffer !== null)
      framebuffer = xrFramebuffer;
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;
      if (isWebGL2) {
        if (target === 36009) {
          currentBoundFramebuffers[36160] = framebuffer;
        }
        if (target === 36160) {
          currentBoundFramebuffers[36009] = framebuffer;
        }
      }
      return true;
    }
    return false;
  }
  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }
    return false;
  }
  const equationToGL = {
    [AddEquation]: 32774,
    [SubtractEquation]: 32778,
    [ReverseSubtractEquation]: 32779
  };
  if (isWebGL2) {
    equationToGL[MinEquation] = 32775;
    equationToGL[MaxEquation] = 32776;
  } else {
    const extension = extensions.get("EXT_blend_minmax");
    if (extension !== null) {
      equationToGL[MinEquation] = extension.MIN_EXT;
      equationToGL[MaxEquation] = extension.MAX_EXT;
    }
  }
  const factorToGL = {
    [ZeroFactor]: 0,
    [OneFactor]: 1,
    [SrcColorFactor]: 768,
    [SrcAlphaFactor]: 770,
    [SrcAlphaSaturateFactor]: 776,
    [DstColorFactor]: 774,
    [DstAlphaFactor]: 772,
    [OneMinusSrcColorFactor]: 769,
    [OneMinusSrcAlphaFactor]: 771,
    [OneMinusDstColorFactor]: 775,
    [OneMinusDstAlphaFactor]: 773
  };
  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
    if (blending === NoBlending) {
      if (currentBlendingEnabled === true) {
        disable(3042);
        currentBlendingEnabled = false;
      }
      return;
    }
    if (currentBlendingEnabled === false) {
      enable(3042);
      currentBlendingEnabled = true;
    }
    if (blending !== CustomBlending) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
          gl.blendEquation(32774);
          currentBlendEquation = AddEquation;
          currentBlendEquationAlpha = AddEquation;
        }
        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(1, 771, 1, 771);
              break;
            case AdditiveBlending:
              gl.blendFunc(1, 1);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(0, 0, 769, 771);
              break;
            case MultiplyBlending:
              gl.blendFuncSeparate(0, 768, 0, 770);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(770, 771, 1, 771);
              break;
            case AdditiveBlending:
              gl.blendFunc(770, 1);
              break;
            case SubtractiveBlending:
              gl.blendFunc(0, 769);
              break;
            case MultiplyBlending:
              gl.blendFunc(0, 768);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        }
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }
      return;
    }
    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;
    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }
    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }
    currentBlending = blending;
    currentPremultipledAlpha = null;
  }
  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide ? disable(2884) : enable(2884);
    let flipSided = material.side === BackSide;
    if (frontFaceCW)
      flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    const stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);
    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }
    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable(32926) : disable(32926);
  }
  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(2304);
      } else {
        gl.frontFace(2305);
      }
      currentFlipSided = flipSided;
    }
  }
  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone) {
      enable(2884);
      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack) {
          gl.cullFace(1029);
        } else if (cullFace === CullFaceFront) {
          gl.cullFace(1028);
        } else {
          gl.cullFace(1032);
        }
      }
    } else {
      disable(2884);
    }
    currentCullFace = cullFace;
  }
  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable)
        gl.lineWidth(width);
      currentLineWidth = width;
    }
  }
  function setPolygonOffset(polygonOffset, factor, units) {
    if (polygonOffset) {
      enable(32823);
      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
        gl.polygonOffset(factor, units);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units;
      }
    } else {
      disable(32823);
    }
  }
  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable(3089);
    } else {
      disable(3089);
    }
  }
  function activeTexture(webglSlot) {
    if (webglSlot === void 0)
      webglSlot = 33984 + maxTextures - 1;
    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }
  function bindTexture(webglType, webglTexture) {
    if (currentTextureSlot === null) {
      activeTexture();
    }
    let boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture === void 0) {
      boundTexture = { type: void 0, texture: void 0 };
      currentBoundTextures[currentTextureSlot] = boundTexture;
    }
    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }
  function unbindTexture() {
    const boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture !== void 0 && boundTexture.type !== void 0) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = void 0;
      boundTexture.texture = void 0;
    }
  }
  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage2D() {
    try {
      gl.texImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage3D() {
    try {
      gl.texImage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function scissor(scissor2) {
    if (currentScissor.equals(scissor2) === false) {
      gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
      currentScissor.copy(scissor2);
    }
  }
  function viewport(viewport2) {
    if (currentViewport.equals(viewport2) === false) {
      gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
      currentViewport.copy(viewport2);
    }
  }
  function reset() {
    gl.disable(3042);
    gl.disable(2884);
    gl.disable(2929);
    gl.disable(32823);
    gl.disable(3089);
    gl.disable(2960);
    gl.disable(32926);
    gl.blendEquation(32774);
    gl.blendFunc(1, 0);
    gl.blendFuncSeparate(1, 0, 1, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(513);
    gl.clearDepth(1);
    gl.stencilMask(4294967295);
    gl.stencilFunc(519, 0, 4294967295);
    gl.stencilOp(7680, 7680, 7680);
    gl.clearStencil(0);
    gl.cullFace(1029);
    gl.frontFace(2305);
    gl.polygonOffset(0, 0);
    gl.activeTexture(33984);
    gl.bindFramebuffer(36160, null);
    if (isWebGL2 === true) {
      gl.bindFramebuffer(36009, null);
      gl.bindFramebuffer(36008, null);
    }
    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    xrFramebuffer = null;
    currentBoundFramebuffers = {};
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }
  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable,
    disable,
    bindFramebuffer,
    bindXRFramebuffer,
    useProgram,
    setBlending,
    setMaterial,
    setFlipSided,
    setCullFace,
    setLineWidth,
    setPolygonOffset,
    setScissorTest,
    activeTexture,
    bindTexture,
    unbindTexture,
    compressedTexImage2D,
    texImage2D,
    texImage3D,
    scissor,
    viewport,
    reset
  };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
  const isWebGL2 = capabilities.isWebGL2;
  const maxTextures = capabilities.maxTextures;
  const maxCubemapSize = capabilities.maxCubemapSize;
  const maxTextureSize = capabilities.maxTextureSize;
  const maxSamples = capabilities.maxSamples;
  const _videoTextures = /* @__PURE__ */ new WeakMap();
  let _canvas2;
  let useOffscreenCanvas = false;
  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch (err) {
  }
  function createCanvas(width, height) {
    return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
  }
  function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
    let scale = 1;
    if (image.width > maxSize || image.height > maxSize) {
      scale = maxSize / Math.max(image.width, image.height);
    }
    if (scale < 1 || needsPowerOfTwo === true) {
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
        const floor2 = needsPowerOfTwo ? floorPowerOfTwo : Math.floor;
        const width = floor2(scale * image.width);
        const height = floor2(scale * image.height);
        if (_canvas2 === void 0)
          _canvas2 = createCanvas(width, height);
        const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas2;
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, width, height);
        console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
        return canvas;
      } else {
        if ("data" in image) {
          console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
        }
        return image;
      }
    }
    return image;
  }
  function isPowerOfTwo$1(image) {
    return isPowerOfTwo(image.width) && isPowerOfTwo(image.height);
  }
  function textureNeedsPowerOfTwo(texture) {
    if (isWebGL2)
      return false;
    return texture.wrapS !== ClampToEdgeWrapping$1 || texture.wrapT !== ClampToEdgeWrapping$1 || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter$1;
  }
  function textureNeedsGenerateMipmaps(texture, supportsMips) {
    return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter$1;
  }
  function generateMipmap(target, texture, width, height) {
    _gl.generateMipmap(target);
    const textureProperties = properties.get(texture);
    textureProperties.__maxMipLevel = Math.log2(Math.max(width, height));
  }
  function getInternalFormat(internalFormatName, glFormat, glType) {
    if (isWebGL2 === false)
      return glFormat;
    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== void 0)
        return _gl[internalFormatName];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
    }
    let internalFormat = glFormat;
    if (glFormat === 6403) {
      if (glType === 5126)
        internalFormat = 33326;
      if (glType === 5131)
        internalFormat = 33325;
      if (glType === 5121)
        internalFormat = 33321;
    }
    if (glFormat === 6407) {
      if (glType === 5126)
        internalFormat = 34837;
      if (glType === 5131)
        internalFormat = 34843;
      if (glType === 5121)
        internalFormat = 32849;
    }
    if (glFormat === 6408) {
      if (glType === 5126)
        internalFormat = 34836;
      if (glType === 5131)
        internalFormat = 34842;
      if (glType === 5121)
        internalFormat = 32856;
    }
    if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) {
      extensions.get("EXT_color_buffer_float");
    }
    return internalFormat;
  }
  function filterFallback(f) {
    if (f === NearestFilter || f === NearestMipmapNearestFilter || f === NearestMipmapLinearFilter) {
      return 9728;
    }
    return 9729;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    deallocateTexture(texture);
    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
    info.memory.textures--;
  }
  function onRenderTargetDispose(event) {
    const renderTarget = event.target;
    renderTarget.removeEventListener("dispose", onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  }
  function deallocateTexture(texture) {
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === void 0)
      return;
    _gl.deleteTexture(textureProperties.__webglTexture);
    properties.remove(texture);
  }
  function deallocateRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    if (!renderTarget)
      return;
    if (textureProperties.__webglTexture !== void 0) {
      _gl.deleteTexture(textureProperties.__webglTexture);
      info.memory.textures--;
    }
    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
    }
    if (renderTarget.isWebGLCubeRenderTarget) {
      for (let i = 0; i < 6; i++) {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
        if (renderTargetProperties.__webglDepthbuffer)
          _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
      }
    } else {
      _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
      if (renderTargetProperties.__webglDepthbuffer)
        _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer)
        _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer)
        _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
      if (renderTargetProperties.__webglDepthRenderbuffer)
        _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }
    if (renderTarget.isWebGLMultipleRenderTargets) {
      for (let i = 0, il = texture.length; i < il; i++) {
        const attachmentProperties = properties.get(texture[i]);
        if (attachmentProperties.__webglTexture) {
          _gl.deleteTexture(attachmentProperties.__webglTexture);
          info.memory.textures--;
        }
        properties.remove(texture[i]);
      }
    }
    properties.remove(texture);
    properties.remove(renderTarget);
  }
  let textureUnits = 0;
  function resetTextureUnits() {
    textureUnits = 0;
  }
  function allocateTextureUnit() {
    const textureUnit = textureUnits;
    if (textureUnit >= maxTextures) {
      console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
    }
    textureUnits += 1;
    return textureUnit;
  }
  function setTexture2D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isVideoTexture)
      updateVideoTexture(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      const image = texture.image;
      if (image === void 0) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");
      } else if (image.complete === false) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(3553, textureProperties.__webglTexture);
  }
  function setTexture2DArray(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(35866, textureProperties.__webglTexture);
  }
  function setTexture3D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(32879, textureProperties.__webglTexture);
  }
  function setTextureCube(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
  }
  const wrappingToGL = {
    [RepeatWrapping$1]: 10497,
    [ClampToEdgeWrapping$1]: 33071,
    [MirroredRepeatWrapping$1]: 33648
  };
  const filterToGL = {
    [NearestFilter]: 9728,
    [NearestMipmapNearestFilter]: 9984,
    [NearestMipmapLinearFilter]: 9986,
    [LinearFilter$1]: 9729,
    [LinearMipmapNearestFilter]: 9985,
    [LinearMipmapLinearFilter$1]: 9987
  };
  function setTextureParameters(textureType, texture, supportsMips) {
    if (supportsMips) {
      _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
      _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
      }
      _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
      _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
    } else {
      _gl.texParameteri(textureType, 10242, 33071);
      _gl.texParameteri(textureType, 10243, 33071);
      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, 33071);
      }
      if (texture.wrapS !== ClampToEdgeWrapping$1 || texture.wrapT !== ClampToEdgeWrapping$1) {
        console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
      }
      _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
      _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
      if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter$1) {
        console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
      }
    }
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false)
        return;
      if (isWebGL2 === false && (texture.type === HalfFloatType && extensions.has("OES_texture_half_float_linear") === false))
        return;
      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }
  function initTexture(textureProperties, texture) {
    if (textureProperties.__webglInit === void 0) {
      textureProperties.__webglInit = true;
      texture.addEventListener("dispose", onTextureDispose);
      textureProperties.__webglTexture = _gl.createTexture();
      info.memory.textures++;
    }
  }
  function uploadTexture(textureProperties, texture, slot) {
    let textureType = 3553;
    if (texture.isDataTexture2DArray)
      textureType = 35866;
    if (texture.isDataTexture3D)
      textureType = 32879;
    initTexture(textureProperties, texture);
    state.activeTexture(33984 + slot);
    state.bindTexture(textureType, textureProperties.__webglTexture);
    _gl.pixelStorei(37440, texture.flipY);
    _gl.pixelStorei(37441, texture.premultiplyAlpha);
    _gl.pixelStorei(3317, texture.unpackAlignment);
    _gl.pixelStorei(37443, 0);
    const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
    const image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
    const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format);
    let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
    setTextureParameters(textureType, texture, supportsMips);
    let mipmap;
    const mipmaps = texture.mipmaps;
    if (texture.isDepthTexture) {
      glInternalFormat = 6402;
      if (isWebGL2) {
        if (texture.type === FloatType) {
          glInternalFormat = 36012;
        } else if (texture.type === UnsignedIntType) {
          glInternalFormat = 33190;
        } else if (texture.type === UnsignedInt248Type) {
          glInternalFormat = 35056;
        } else {
          glInternalFormat = 33189;
        }
      } else {
        if (texture.type === FloatType) {
          console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
        }
      }
      if (texture.format === DepthFormat && glInternalFormat === 6402) {
        if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {
          console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
          texture.type = UnsignedShortType;
          glType = utils.convert(texture.type);
        }
      }
      if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {
        glInternalFormat = 34041;
        if (texture.type !== UnsignedInt248Type) {
          console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
          texture.type = UnsignedInt248Type;
          glType = utils.convert(texture.type);
        }
      }
      state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
    } else if (texture.isDataTexture) {
      if (mipmaps.length > 0 && supportsMips) {
        for (let i = 0, il = mipmaps.length; i < il; i++) {
          mipmap = mipmaps[i];
          state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
        }
        texture.generateMipmaps = false;
        textureProperties.__maxMipLevel = mipmaps.length - 1;
      } else {
        state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
        textureProperties.__maxMipLevel = 0;
      }
    } else if (texture.isCompressedTexture) {
      for (let i = 0, il = mipmaps.length; i < il; i++) {
        mipmap = mipmaps[i];
        if (texture.format !== RGBAFormat$1 && texture.format !== RGBFormat$1) {
          if (glFormat !== null) {
            state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
          } else {
            console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
          }
        } else {
          state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
        }
      }
      textureProperties.__maxMipLevel = mipmaps.length - 1;
    } else if (texture.isDataTexture2DArray) {
      state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
      textureProperties.__maxMipLevel = 0;
    } else if (texture.isDataTexture3D) {
      state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
      textureProperties.__maxMipLevel = 0;
    } else {
      if (mipmaps.length > 0 && supportsMips) {
        for (let i = 0, il = mipmaps.length; i < il; i++) {
          mipmap = mipmaps[i];
          state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
        }
        texture.generateMipmaps = false;
        textureProperties.__maxMipLevel = mipmaps.length - 1;
      } else {
        state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
        textureProperties.__maxMipLevel = 0;
      }
    }
    if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
      generateMipmap(textureType, texture, image.width, image.height);
    }
    textureProperties.__version = texture.version;
    if (texture.onUpdate)
      texture.onUpdate(texture);
  }
  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6)
      return;
    initTexture(textureProperties, texture);
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
    _gl.pixelStorei(37440, texture.flipY);
    _gl.pixelStorei(37441, texture.premultiplyAlpha);
    _gl.pixelStorei(3317, texture.unpackAlignment);
    _gl.pixelStorei(37443, 0);
    const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
    const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
    const cubeImage = [];
    for (let i = 0; i < 6; i++) {
      if (!isCompressed && !isDataTexture) {
        cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
      } else {
        cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
      }
    }
    const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
    setTextureParameters(34067, texture, supportsMips);
    let mipmaps;
    if (isCompressed) {
      for (let i = 0; i < 6; i++) {
        mipmaps = cubeImage[i].mipmaps;
        for (let j = 0; j < mipmaps.length; j++) {
          const mipmap = mipmaps[j];
          if (texture.format !== RGBAFormat$1 && texture.format !== RGBFormat$1) {
            if (glFormat !== null) {
              state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
            } else {
              console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
            }
          } else {
            state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
          }
        }
      }
      textureProperties.__maxMipLevel = mipmaps.length - 1;
    } else {
      mipmaps = texture.mipmaps;
      for (let i = 0; i < 6; i++) {
        if (isDataTexture) {
          state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
          for (let j = 0; j < mipmaps.length; j++) {
            const mipmap = mipmaps[j];
            const mipmapImage = mipmap.image[i].image;
            state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
          }
        } else {
          state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
          for (let j = 0; j < mipmaps.length; j++) {
            const mipmap = mipmaps[j];
            state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
          }
        }
      }
      textureProperties.__maxMipLevel = mipmaps.length;
    }
    if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
      generateMipmap(34067, texture, image.width, image.height);
    }
    textureProperties.__version = texture.version;
    if (texture.onUpdate)
      texture.onUpdate(texture);
  }
  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
    const glFormat = utils.convert(texture.format);
    const glType = utils.convert(texture.type);
    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
    if (textureTarget === 32879 || textureTarget === 35866) {
      state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
    } else {
      state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
    }
    state.bindFramebuffer(36160, framebuffer);
    _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
    state.bindFramebuffer(36160, null);
  }
  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(36161, renderbuffer);
    if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
      let glInternalFormat = 33189;
      if (isMultisample) {
        const depthTexture = renderTarget.depthTexture;
        if (depthTexture && depthTexture.isDepthTexture) {
          if (depthTexture.type === FloatType) {
            glInternalFormat = 36012;
          } else if (depthTexture.type === UnsignedIntType) {
            glInternalFormat = 33190;
          }
        }
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
    } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
      if (isMultisample) {
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
    } else {
      const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
      const glFormat = utils.convert(texture.format);
      const glType = utils.convert(texture.type);
      const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
      if (isMultisample) {
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }
    }
    _gl.bindRenderbuffer(36161, null);
  }
  function setupDepthTexture(framebuffer, renderTarget) {
    const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube)
      throw new Error("Depth Texture with cube render targets is not supported");
    state.bindFramebuffer(36160, framebuffer);
    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    }
    if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }
    setTexture2D(renderTarget.depthTexture, 0);
    const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
    if (renderTarget.depthTexture.format === DepthFormat) {
      _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
    } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
      _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
    } else {
      throw new Error("Unknown depthTexture format");
    }
  }
  function setupDepthRenderbuffer(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    if (renderTarget.depthTexture) {
      if (isCube)
        throw new Error("target.depthTexture not supported in Cube render targets");
      setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];
        for (let i = 0; i < 6; i++) {
          state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
          renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
        }
      } else {
        state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
        renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
        setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
      }
    }
    state.bindFramebuffer(36160, null);
  }
  function setupRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    renderTarget.addEventListener("dispose", onRenderTargetDispose);
    if (renderTarget.isWebGLMultipleRenderTargets !== true) {
      textureProperties.__webglTexture = _gl.createTexture();
      textureProperties.__version = texture.version;
      info.memory.textures++;
    }
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
    const isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
    const isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
    const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
    if (isWebGL2 && texture.format === RGBFormat$1 && (texture.type === FloatType || texture.type === HalfFloatType)) {
      texture.format = RGBAFormat$1;
      console.warn("THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.");
    }
    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];
      for (let i = 0; i < 6; i++) {
        renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
      }
    } else {
      renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
      if (isMultipleRenderTargets) {
        if (capabilities.drawBuffers) {
          const textures = renderTarget.texture;
          for (let i = 0, il = textures.length; i < il; i++) {
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture === void 0) {
              attachmentProperties.__webglTexture = _gl.createTexture();
              info.memory.textures++;
            }
          }
        } else {
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
        }
      } else if (isMultisample) {
        if (isWebGL2) {
          renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
          renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
          _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
          const glFormat = utils.convert(texture.format);
          const glType = utils.convert(texture.type);
          const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
          const samples = getRenderTargetSamples(renderTarget);
          _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
          _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
          _gl.bindRenderbuffer(36161, null);
          if (renderTarget.depthBuffer) {
            renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
          }
          state.bindFramebuffer(36160, null);
        } else {
          console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
        }
      }
    }
    if (isCube) {
      state.bindTexture(34067, textureProperties.__webglTexture);
      setTextureParameters(34067, texture, supportsMips);
      for (let i = 0; i < 6; i++) {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
      }
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(34067, texture, renderTarget.width, renderTarget.height);
      }
      state.bindTexture(34067, null);
    } else if (isMultipleRenderTargets) {
      const textures = renderTarget.texture;
      for (let i = 0, il = textures.length; i < il; i++) {
        const attachment = textures[i];
        const attachmentProperties = properties.get(attachment);
        state.bindTexture(3553, attachmentProperties.__webglTexture);
        setTextureParameters(3553, attachment, supportsMips);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
        if (textureNeedsGenerateMipmaps(attachment, supportsMips)) {
          generateMipmap(3553, attachment, renderTarget.width, renderTarget.height);
        }
      }
      state.bindTexture(3553, null);
    } else {
      let glTextureType = 3553;
      if (isRenderTarget3D) {
        if (isWebGL2) {
          const isTexture3D = texture.isDataTexture3D;
          glTextureType = isTexture3D ? 32879 : 35866;
        } else {
          console.warn("THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.");
        }
      }
      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture, supportsMips);
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(3553, texture, renderTarget.width, renderTarget.height);
      }
      state.bindTexture(3553, null);
    }
    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function updateRenderTargetMipmap(renderTarget) {
    const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
    const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];
    for (let i = 0, il = textures.length; i < il; i++) {
      const texture = textures[i];
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
        const webglTexture = properties.get(texture).__webglTexture;
        state.bindTexture(target, webglTexture);
        generateMipmap(target, texture, renderTarget.width, renderTarget.height);
        state.bindTexture(target, null);
      }
    }
  }
  function updateMultisampleRenderTarget(renderTarget) {
    if (renderTarget.isWebGLMultisampleRenderTarget) {
      if (isWebGL2) {
        const width = renderTarget.width;
        const height = renderTarget.height;
        let mask = 16384;
        if (renderTarget.depthBuffer)
          mask |= 256;
        if (renderTarget.stencilBuffer)
          mask |= 1024;
        const renderTargetProperties = properties.get(renderTarget);
        state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
        state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
        _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
        state.bindFramebuffer(36008, null);
        state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
      } else {
        console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
      }
    }
  }
  function getRenderTargetSamples(renderTarget) {
    return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
  }
  function updateVideoTexture(texture) {
    const frame = info.render.frame;
    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);
      texture.update();
    }
  }
  let warnedTexture2D = false;
  let warnedTextureCube = false;
  function safeSetTexture2D(texture, slot) {
    if (texture && texture.isWebGLRenderTarget) {
      if (warnedTexture2D === false) {
        console.warn("THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead.");
        warnedTexture2D = true;
      }
      texture = texture.texture;
    }
    setTexture2D(texture, slot);
  }
  function safeSetTextureCube(texture, slot) {
    if (texture && texture.isWebGLCubeRenderTarget) {
      if (warnedTextureCube === false) {
        console.warn("THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead.");
        warnedTextureCube = true;
      }
      texture = texture.texture;
    }
    setTextureCube(texture, slot);
  }
  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.safeSetTexture2D = safeSetTexture2D;
  this.safeSetTextureCube = safeSetTextureCube;
}
function WebGLUtils(gl, extensions, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  function convert(p) {
    let extension;
    if (p === UnsignedByteType$1)
      return 5121;
    if (p === UnsignedShort4444Type)
      return 32819;
    if (p === UnsignedShort5551Type)
      return 32820;
    if (p === UnsignedShort565Type)
      return 33635;
    if (p === ByteType)
      return 5120;
    if (p === ShortType)
      return 5122;
    if (p === UnsignedShortType)
      return 5123;
    if (p === IntType)
      return 5124;
    if (p === UnsignedIntType)
      return 5125;
    if (p === FloatType)
      return 5126;
    if (p === HalfFloatType) {
      if (isWebGL2)
        return 5131;
      extension = extensions.get("OES_texture_half_float");
      if (extension !== null) {
        return extension.HALF_FLOAT_OES;
      } else {
        return null;
      }
    }
    if (p === AlphaFormat)
      return 6406;
    if (p === RGBFormat$1)
      return 6407;
    if (p === RGBAFormat$1)
      return 6408;
    if (p === LuminanceFormat)
      return 6409;
    if (p === LuminanceAlphaFormat)
      return 6410;
    if (p === DepthFormat)
      return 6402;
    if (p === DepthStencilFormat)
      return 34041;
    if (p === RedFormat)
      return 6403;
    if (p === RedIntegerFormat)
      return 36244;
    if (p === RGFormat)
      return 33319;
    if (p === RGIntegerFormat)
      return 33320;
    if (p === RGBIntegerFormat)
      return 36248;
    if (p === RGBAIntegerFormat)
      return 36249;
    if (p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format) {
      extension = extensions.get("WEBGL_compressed_texture_s3tc");
      if (extension !== null) {
        if (p === RGB_S3TC_DXT1_Format)
          return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (p === RGBA_S3TC_DXT1_Format)
          return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (p === RGBA_S3TC_DXT3_Format)
          return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (p === RGBA_S3TC_DXT5_Format)
          return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else {
        return null;
      }
    }
    if (p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_pvrtc");
      if (extension !== null) {
        if (p === RGB_PVRTC_4BPPV1_Format)
          return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p === RGB_PVRTC_2BPPV1_Format)
          return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p === RGBA_PVRTC_4BPPV1_Format)
          return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p === RGBA_PVRTC_2BPPV1_Format)
          return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    }
    if (p === RGB_ETC1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc1");
      if (extension !== null) {
        return extension.COMPRESSED_RGB_ETC1_WEBGL;
      } else {
        return null;
      }
    }
    if (p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc");
      if (extension !== null) {
        if (p === RGB_ETC2_Format)
          return extension.COMPRESSED_RGB8_ETC2;
        if (p === RGBA_ETC2_EAC_Format)
          return extension.COMPRESSED_RGBA8_ETC2_EAC;
      }
    }
    if (p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format || p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format || p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format || p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format || p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format || p === SRGB8_ALPHA8_ASTC_4x4_Format || p === SRGB8_ALPHA8_ASTC_5x4_Format || p === SRGB8_ALPHA8_ASTC_5x5_Format || p === SRGB8_ALPHA8_ASTC_6x5_Format || p === SRGB8_ALPHA8_ASTC_6x6_Format || p === SRGB8_ALPHA8_ASTC_8x5_Format || p === SRGB8_ALPHA8_ASTC_8x6_Format || p === SRGB8_ALPHA8_ASTC_8x8_Format || p === SRGB8_ALPHA8_ASTC_10x5_Format || p === SRGB8_ALPHA8_ASTC_10x6_Format || p === SRGB8_ALPHA8_ASTC_10x8_Format || p === SRGB8_ALPHA8_ASTC_10x10_Format || p === SRGB8_ALPHA8_ASTC_12x10_Format || p === SRGB8_ALPHA8_ASTC_12x12_Format) {
      extension = extensions.get("WEBGL_compressed_texture_astc");
      if (extension !== null) {
        return p;
      } else {
        return null;
      }
    }
    if (p === RGBA_BPTC_Format) {
      extension = extensions.get("EXT_texture_compression_bptc");
      if (extension !== null) {
        return p;
      } else {
        return null;
      }
    }
    if (p === UnsignedInt248Type) {
      if (isWebGL2)
        return 34042;
      extension = extensions.get("WEBGL_depth_texture");
      if (extension !== null) {
        return extension.UNSIGNED_INT_24_8_WEBGL;
      } else {
        return null;
      }
    }
  }
  return { convert };
}
class ArrayCamera extends PerspectiveCamera {
  constructor(array = []) {
    super();
    this.cameras = array;
  }
}
ArrayCamera.prototype.isArrayCamera = true;
class Group extends Object3D {
  constructor() {
    super();
    this.type = "Group";
  }
}
Group.prototype.isGroup = true;
const _moveEvent = { type: "move" };
class WebXRController {
  constructor() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }
  getHandSpace() {
    if (this._hand === null) {
      this._hand = new Group();
      this._hand.matrixAutoUpdate = false;
      this._hand.visible = false;
      this._hand.joints = {};
      this._hand.inputState = { pinching: false };
    }
    return this._hand;
  }
  getTargetRaySpace() {
    if (this._targetRay === null) {
      this._targetRay = new Group();
      this._targetRay.matrixAutoUpdate = false;
      this._targetRay.visible = false;
      this._targetRay.hasLinearVelocity = false;
      this._targetRay.linearVelocity = new Vector3$1();
      this._targetRay.hasAngularVelocity = false;
      this._targetRay.angularVelocity = new Vector3$1();
    }
    return this._targetRay;
  }
  getGripSpace() {
    if (this._grip === null) {
      this._grip = new Group();
      this._grip.matrixAutoUpdate = false;
      this._grip.visible = false;
      this._grip.hasLinearVelocity = false;
      this._grip.linearVelocity = new Vector3$1();
      this._grip.hasAngularVelocity = false;
      this._grip.angularVelocity = new Vector3$1();
    }
    return this._grip;
  }
  dispatchEvent(event) {
    if (this._targetRay !== null) {
      this._targetRay.dispatchEvent(event);
    }
    if (this._grip !== null) {
      this._grip.dispatchEvent(event);
    }
    if (this._hand !== null) {
      this._hand.dispatchEvent(event);
    }
    return this;
  }
  disconnect(inputSource) {
    this.dispatchEvent({ type: "disconnected", data: inputSource });
    if (this._targetRay !== null) {
      this._targetRay.visible = false;
    }
    if (this._grip !== null) {
      this._grip.visible = false;
    }
    if (this._hand !== null) {
      this._hand.visible = false;
    }
    return this;
  }
  update(inputSource, frame, referenceSpace) {
    let inputPose = null;
    let gripPose = null;
    let handPose = null;
    const targetRay = this._targetRay;
    const grip = this._grip;
    const hand = this._hand;
    if (inputSource && frame.session.visibilityState !== "visible-blurred") {
      if (targetRay !== null) {
        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
        if (inputPose !== null) {
          targetRay.matrix.fromArray(inputPose.transform.matrix);
          targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
          if (inputPose.linearVelocity) {
            targetRay.hasLinearVelocity = true;
            targetRay.linearVelocity.copy(inputPose.linearVelocity);
          } else {
            targetRay.hasLinearVelocity = false;
          }
          if (inputPose.angularVelocity) {
            targetRay.hasAngularVelocity = true;
            targetRay.angularVelocity.copy(inputPose.angularVelocity);
          } else {
            targetRay.hasAngularVelocity = false;
          }
          this.dispatchEvent(_moveEvent);
        }
      }
      if (hand && inputSource.hand) {
        handPose = true;
        for (const inputjoint of inputSource.hand.values()) {
          const jointPose = frame.getJointPose(inputjoint, referenceSpace);
          if (hand.joints[inputjoint.jointName] === void 0) {
            const joint2 = new Group();
            joint2.matrixAutoUpdate = false;
            joint2.visible = false;
            hand.joints[inputjoint.jointName] = joint2;
            hand.add(joint2);
          }
          const joint = hand.joints[inputjoint.jointName];
          if (jointPose !== null) {
            joint.matrix.fromArray(jointPose.transform.matrix);
            joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
            joint.jointRadius = jointPose.radius;
          }
          joint.visible = jointPose !== null;
        }
        const indexTip = hand.joints["index-finger-tip"];
        const thumbTip = hand.joints["thumb-tip"];
        const distance = indexTip.position.distanceTo(thumbTip.position);
        const distanceToPinch = 0.02;
        const threshold = 5e-3;
        if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
          hand.inputState.pinching = false;
          this.dispatchEvent({
            type: "pinchend",
            handedness: inputSource.handedness,
            target: this
          });
        } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
          hand.inputState.pinching = true;
          this.dispatchEvent({
            type: "pinchstart",
            handedness: inputSource.handedness,
            target: this
          });
        }
      } else {
        if (grip !== null && inputSource.gripSpace) {
          gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
          if (gripPose !== null) {
            grip.matrix.fromArray(gripPose.transform.matrix);
            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
            if (gripPose.linearVelocity) {
              grip.hasLinearVelocity = true;
              grip.linearVelocity.copy(gripPose.linearVelocity);
            } else {
              grip.hasLinearVelocity = false;
            }
            if (gripPose.angularVelocity) {
              grip.hasAngularVelocity = true;
              grip.angularVelocity.copy(gripPose.angularVelocity);
            } else {
              grip.hasAngularVelocity = false;
            }
          }
        }
      }
    }
    if (targetRay !== null) {
      targetRay.visible = inputPose !== null;
    }
    if (grip !== null) {
      grip.visible = gripPose !== null;
    }
    if (hand !== null) {
      hand.visible = handPose !== null;
    }
    return this;
  }
}
class WebXRManager extends EventDispatcher$1 {
  constructor(renderer, gl) {
    super();
    const scope = this;
    const state = renderer.state;
    let session = null;
    let framebufferScaleFactor = 1;
    let referenceSpace = null;
    let referenceSpaceType = "local-floor";
    let pose = null;
    const controllers = [];
    const inputSourcesMap = /* @__PURE__ */ new Map();
    const cameraL = new PerspectiveCamera();
    cameraL.layers.enable(1);
    cameraL.viewport = new Vector4();
    const cameraR = new PerspectiveCamera();
    cameraR.layers.enable(2);
    cameraR.viewport = new Vector4();
    const cameras = [cameraL, cameraR];
    const cameraVR = new ArrayCamera();
    cameraVR.layers.enable(1);
    cameraVR.layers.enable(2);
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    this.cameraAutoUpdate = true;
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index) {
      let controller = controllers[index];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index] = controller;
      }
      return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index) {
      let controller = controllers[index];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index] = controller;
      }
      return controller.getGripSpace();
    };
    this.getHand = function(index) {
      let controller = controllers[index];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index] = controller;
      }
      return controller.getHandSpace();
    };
    function onSessionEvent(event) {
      const controller = inputSourcesMap.get(event.inputSource);
      if (controller) {
        controller.dispatchEvent({ type: event.type, data: event.inputSource });
      }
    }
    function onSessionEnd() {
      inputSourcesMap.forEach(function(controller, inputSource) {
        controller.disconnect(inputSource);
      });
      inputSourcesMap.clear();
      _currentDepthNear = null;
      _currentDepthFar = null;
      state.bindXRFramebuffer(null);
      renderer.setRenderTarget(renderer.getRenderTarget());
      animation.stop();
      scope.isPresenting = false;
      scope.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(value) {
      framebufferScaleFactor = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }
    };
    this.setReferenceSpaceType = function(value) {
      referenceSpaceType = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
      }
    };
    this.getReferenceSpace = function() {
      return referenceSpace;
    };
    this.getSession = function() {
      return session;
    };
    this.setSession = async function(value) {
      session = value;
      if (session !== null) {
        session.addEventListener("select", onSessionEvent);
        session.addEventListener("selectstart", onSessionEvent);
        session.addEventListener("selectend", onSessionEvent);
        session.addEventListener("squeeze", onSessionEvent);
        session.addEventListener("squeezestart", onSessionEvent);
        session.addEventListener("squeezeend", onSessionEvent);
        session.addEventListener("end", onSessionEnd);
        session.addEventListener("inputsourceschange", onInputSourcesChange);
        const attributes = gl.getContextAttributes();
        if (attributes.xrCompatible !== true) {
          await gl.makeXRCompatible();
        }
        const layerInit = {
          antialias: attributes.antialias,
          alpha: attributes.alpha,
          depth: attributes.depth,
          stencil: attributes.stencil,
          framebufferScaleFactor
        };
        const baseLayer = new XRWebGLLayer(session, gl, layerInit);
        session.updateRenderState({ baseLayer });
        referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
        animation.setContext(session);
        animation.start();
        scope.isPresenting = true;
        scope.dispatchEvent({ type: "sessionstart" });
      }
    };
    function onInputSourcesChange(event) {
      const inputSources = session.inputSources;
      for (let i = 0; i < controllers.length; i++) {
        inputSourcesMap.set(inputSources[i], controllers[i]);
      }
      for (let i = 0; i < event.removed.length; i++) {
        const inputSource = event.removed[i];
        const controller = inputSourcesMap.get(inputSource);
        if (controller) {
          controller.dispatchEvent({ type: "disconnected", data: inputSource });
          inputSourcesMap.delete(inputSource);
        }
      }
      for (let i = 0; i < event.added.length; i++) {
        const inputSource = event.added[i];
        const controller = inputSourcesMap.get(inputSource);
        if (controller) {
          controller.dispatchEvent({ type: "connected", data: inputSource });
        }
      }
    }
    const cameraLPos = new Vector3$1();
    const cameraRPos = new Vector3$1();
    function setProjectionFromUnion(camera, cameraL2, cameraR2) {
      cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
      cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
      const ipd = cameraLPos.distanceTo(cameraRPos);
      const projL = cameraL2.projectionMatrix.elements;
      const projR = cameraR2.projectionMatrix.elements;
      const near = projL[14] / (projL[10] - 1);
      const far = projL[14] / (projL[10] + 1);
      const topFov = (projL[9] + 1) / projL[5];
      const bottomFov = (projL[9] - 1) / projL[5];
      const leftFov = (projL[8] - 1) / projL[0];
      const rightFov = (projR[8] + 1) / projR[0];
      const left = near * leftFov;
      const right = near * rightFov;
      const zOffset = ipd / (-leftFov + rightFov);
      const xOffset = zOffset * -leftFov;
      cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
      camera.translateX(xOffset);
      camera.translateZ(zOffset);
      camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
      const near2 = near + zOffset;
      const far2 = far + zOffset;
      const left2 = left - xOffset;
      const right2 = right + (ipd - xOffset);
      const top2 = topFov * far / far2 * near2;
      const bottom2 = bottomFov * far / far2 * near2;
      camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
    }
    function updateCamera(camera, parent) {
      if (parent === null) {
        camera.matrixWorld.copy(camera.matrix);
      } else {
        camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
      }
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.updateCamera = function(camera) {
      if (session === null)
        return;
      cameraVR.near = cameraR.near = cameraL.near = camera.near;
      cameraVR.far = cameraR.far = cameraL.far = camera.far;
      if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
        session.updateRenderState({
          depthNear: cameraVR.near,
          depthFar: cameraVR.far
        });
        _currentDepthNear = cameraVR.near;
        _currentDepthFar = cameraVR.far;
      }
      const parent = camera.parent;
      const cameras2 = cameraVR.cameras;
      updateCamera(cameraVR, parent);
      for (let i = 0; i < cameras2.length; i++) {
        updateCamera(cameras2[i], parent);
      }
      camera.matrixWorld.copy(cameraVR.matrixWorld);
      camera.matrix.copy(cameraVR.matrix);
      camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
      const children = camera.children;
      for (let i = 0, l = children.length; i < l; i++) {
        children[i].updateMatrixWorld(true);
      }
      if (cameras2.length === 2) {
        setProjectionFromUnion(cameraVR, cameraL, cameraR);
      } else {
        cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
      }
    };
    this.getCamera = function() {
      return cameraVR;
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time, frame) {
      pose = frame.getViewerPose(referenceSpace);
      if (pose !== null) {
        const views = pose.views;
        const baseLayer = session.renderState.baseLayer;
        state.bindXRFramebuffer(baseLayer.framebuffer);
        let cameraVRNeedsUpdate = false;
        if (views.length !== cameraVR.cameras.length) {
          cameraVR.cameras.length = 0;
          cameraVRNeedsUpdate = true;
        }
        for (let i = 0; i < views.length; i++) {
          const view = views[i];
          const viewport = baseLayer.getViewport(view);
          const camera = cameras[i];
          camera.matrix.fromArray(view.transform.matrix);
          camera.projectionMatrix.fromArray(view.projectionMatrix);
          camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
          if (i === 0) {
            cameraVR.matrix.copy(camera.matrix);
          }
          if (cameraVRNeedsUpdate === true) {
            cameraVR.cameras.push(camera);
          }
        }
      }
      const inputSources = session.inputSources;
      for (let i = 0; i < controllers.length; i++) {
        const controller = controllers[i];
        const inputSource = inputSources[i];
        controller.update(inputSource, frame, referenceSpace);
      }
      if (onAnimationFrameCallback)
        onAnimationFrameCallback(time, frame);
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
    };
    this.dispose = function() {
    };
  }
}
function WebGLMaterials(properties) {
  function refreshFogUniforms(uniforms, fog) {
    uniforms.fogColor.value.copy(fog.color);
    if (fog.isFog) {
      uniforms.fogNear.value = fog.near;
      uniforms.fogFar.value = fog.far;
    } else if (fog.isFogExp2) {
      uniforms.fogDensity.value = fog.density;
    }
  }
  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsLambert(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      } else {
        refreshUniformsStandard(uniforms, material);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDepth(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsNormal(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);
      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false;
    }
  }
  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;
    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }
    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
    }
    const envMap = properties.get(material).envMap;
    if (envMap) {
      uniforms.envMap.value = envMap;
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap._needsFlipEnvMap ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.refractionRatio.value = material.refractionRatio;
      const maxMipLevel = properties.get(envMap).__maxMipLevel;
      if (maxMipLevel !== void 0) {
        uniforms.maxMipLevel.value = maxMipLevel;
      }
    }
    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap;
      uniforms.lightMapIntensity.value = material.lightMapIntensity;
    }
    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.specularMap) {
      uvScaleMap = material.specularMap;
    } else if (material.displacementMap) {
      uvScaleMap = material.displacementMap;
    } else if (material.normalMap) {
      uvScaleMap = material.normalMap;
    } else if (material.bumpMap) {
      uvScaleMap = material.bumpMap;
    } else if (material.roughnessMap) {
      uvScaleMap = material.roughnessMap;
    } else if (material.metalnessMap) {
      uvScaleMap = material.metalnessMap;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    } else if (material.emissiveMap) {
      uvScaleMap = material.emissiveMap;
    } else if (material.clearcoatMap) {
      uvScaleMap = material.clearcoatMap;
    } else if (material.clearcoatNormalMap) {
      uvScaleMap = material.clearcoatNormalMap;
    } else if (material.clearcoatRoughnessMap) {
      uvScaleMap = material.clearcoatRoughnessMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.isWebGLRenderTarget) {
        uvScaleMap = uvScaleMap.texture;
      }
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
    let uv2ScaleMap;
    if (material.aoMap) {
      uv2ScaleMap = material.aoMap;
    } else if (material.lightMap) {
      uv2ScaleMap = material.lightMap;
    }
    if (uv2ScaleMap !== void 0) {
      if (uv2ScaleMap.isWebGLRenderTarget) {
        uv2ScaleMap = uv2ScaleMap.texture;
      }
      if (uv2ScaleMap.matrixAutoUpdate === true) {
        uv2ScaleMap.updateMatrix();
      }
      uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
    }
  }
  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
  }
  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }
  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }
  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }
  function refreshUniformsLambert(uniforms, material) {
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
  }
  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4);
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide)
        uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide)
        uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide)
        uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide)
        uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsStandard(uniforms, material) {
    uniforms.roughness.value = material.roughness;
    uniforms.metalness.value = material.metalness;
    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
    }
    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide)
        uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide)
        uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    const envMap = properties.get(material).envMap;
    if (envMap) {
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }
  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    refreshUniformsStandard(uniforms, material);
    uniforms.reflectivity.value = material.reflectivity;
    uniforms.clearcoat.value = material.clearcoat;
    uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
    if (material.sheen)
      uniforms.sheen.value.copy(material.sheen);
    if (material.clearcoatMap) {
      uniforms.clearcoatMap.value = material.clearcoatMap;
    }
    if (material.clearcoatRoughnessMap) {
      uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
    }
    if (material.clearcoatNormalMap) {
      uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
      uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
      if (material.side === BackSide) {
        uniforms.clearcoatNormalScale.value.negate();
      }
    }
    uniforms.transmission.value = material.transmission;
    if (material.transmissionMap) {
      uniforms.transmissionMap.value = material.transmissionMap;
    }
    if (material.transmission > 0) {
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
    }
    uniforms.thickness.value = material.thickness;
    if (material.thicknessMap) {
      uniforms.thicknessMap.value = material.thicknessMap;
    }
    uniforms.attenuationDistance.value = material.attenuationDistance;
    uniforms.attenuationColor.value.copy(material.attenuationColor);
  }
  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide)
        uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide)
        uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsDepth(uniforms, material) {
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsDistance(uniforms, material) {
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    uniforms.referencePosition.value.copy(material.referencePosition);
    uniforms.nearDistance.value = material.nearDistance;
    uniforms.farDistance.value = material.farDistance;
  }
  function refreshUniformsNormal(uniforms, material) {
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide)
        uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide)
        uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  return {
    refreshFogUniforms,
    refreshMaterialUniforms
  };
}
function createCanvasElement() {
  const canvas = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
  canvas.style.display = "block";
  return canvas;
}
function WebGLRenderer(parameters) {
  parameters = parameters || {};
  const _canvas2 = parameters.canvas !== void 0 ? parameters.canvas : createCanvasElement(), _context2 = parameters.context !== void 0 ? parameters.context : null, _alpha = parameters.alpha !== void 0 ? parameters.alpha : false, _depth = parameters.depth !== void 0 ? parameters.depth : true, _stencil = parameters.stencil !== void 0 ? parameters.stencil : true, _antialias = parameters.antialias !== void 0 ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== void 0 ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== void 0 ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== void 0 ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== void 0 ? parameters.failIfMajorPerformanceCaveat : false;
  let currentRenderList = null;
  let currentRenderState = null;
  const renderListStack = [];
  const renderStateStack = [];
  this.domElement = _canvas2;
  this.debug = {
    checkShaderErrors: true
  };
  this.autoClear = true;
  this.autoClearColor = true;
  this.autoClearDepth = true;
  this.autoClearStencil = true;
  this.sortObjects = true;
  this.clippingPlanes = [];
  this.localClippingEnabled = false;
  this.gammaFactor = 2;
  this.outputEncoding = LinearEncoding$1;
  this.physicallyCorrectLights = false;
  this.toneMapping = NoToneMapping;
  this.toneMappingExposure = 1;
  const _this = this;
  let _isContextLost = false;
  let _currentActiveCubeFace = 0;
  let _currentActiveMipmapLevel = 0;
  let _currentRenderTarget = null;
  let _currentMaterialId = -1;
  let _currentCamera = null;
  const _currentViewport = new Vector4();
  const _currentScissor = new Vector4();
  let _currentScissorTest = null;
  let _width = _canvas2.width;
  let _height = _canvas2.height;
  let _pixelRatio = 1;
  let _opaqueSort = null;
  let _transparentSort = null;
  const _viewport = new Vector4(0, 0, _width, _height);
  const _scissor = new Vector4(0, 0, _width, _height);
  let _scissorTest = false;
  const _currentDrawBuffers = [];
  const _frustum = new Frustum();
  let _clippingEnabled = false;
  let _localClippingEnabled = false;
  let _transmissionRenderTarget = null;
  const _projScreenMatrix2 = new Matrix4();
  const _vector3 = new Vector3$1();
  const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
  function getTargetPixelRatio() {
    return _currentRenderTarget === null ? _pixelRatio : 1;
  }
  let _gl = _context2;
  function getContext(contextNames, contextAttributes) {
    for (let i = 0; i < contextNames.length; i++) {
      const contextName = contextNames[i];
      const context = _canvas2.getContext(contextName, contextAttributes);
      if (context !== null)
        return context;
    }
    return null;
  }
  try {
    const contextAttributes = {
      alpha: _alpha,
      depth: _depth,
      stencil: _stencil,
      antialias: _antialias,
      premultipliedAlpha: _premultipliedAlpha,
      preserveDrawingBuffer: _preserveDrawingBuffer,
      powerPreference: _powerPreference,
      failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
    };
    _canvas2.addEventListener("webglcontextlost", onContextLost, false);
    _canvas2.addEventListener("webglcontextrestored", onContextRestore, false);
    if (_gl === null) {
      const contextNames = ["webgl2", "webgl", "experimental-webgl"];
      if (_this.isWebGL1Renderer === true) {
        contextNames.shift();
      }
      _gl = getContext(contextNames, contextAttributes);
      if (_gl === null) {
        if (getContext(contextNames)) {
          throw new Error("Error creating WebGL context with your selected attributes.");
        } else {
          throw new Error("Error creating WebGL context.");
        }
      }
    }
    if (_gl.getShaderPrecisionFormat === void 0) {
      _gl.getShaderPrecisionFormat = function() {
        return { "rangeMin": 1, "rangeMax": 1, "precision": 1 };
      };
    }
  } catch (error) {
    console.error("THREE.WebGLRenderer: " + error.message);
    throw error;
  }
  let extensions, capabilities, state, info;
  let properties, textures, cubemaps, attributes, geometries, objects;
  let programCache, materials, renderLists, renderStates, clipping, shadowMap;
  let background, morphtargets, bufferRenderer, indexedBufferRenderer;
  let utils, bindingStates;
  function initGLContext() {
    extensions = new WebGLExtensions(_gl);
    capabilities = new WebGLCapabilities(_gl, extensions, parameters);
    extensions.init(capabilities);
    utils = new WebGLUtils(_gl, extensions, capabilities);
    state = new WebGLState(_gl, extensions, capabilities);
    _currentDrawBuffers[0] = 1029;
    info = new WebGLInfo();
    properties = new WebGLProperties();
    textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
    cubemaps = new WebGLCubeMaps(_this);
    attributes = new WebGLAttributes(_gl, capabilities);
    bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
    geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
    objects = new WebGLObjects(_gl, geometries, attributes, info);
    morphtargets = new WebGLMorphtargets(_gl);
    clipping = new WebGLClipping(properties);
    programCache = new WebGLPrograms(_this, cubemaps, extensions, capabilities, bindingStates, clipping);
    materials = new WebGLMaterials(properties);
    renderLists = new WebGLRenderLists(properties);
    renderStates = new WebGLRenderStates(extensions, capabilities);
    background = new WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
    shadowMap = new WebGLShadowMap(_this, objects, capabilities);
    bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
    indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
    info.programs = programCache.programs;
    _this.capabilities = capabilities;
    _this.extensions = extensions;
    _this.properties = properties;
    _this.renderLists = renderLists;
    _this.shadowMap = shadowMap;
    _this.state = state;
    _this.info = info;
  }
  initGLContext();
  const xr = new WebXRManager(_this, _gl);
  this.xr = xr;
  this.getContext = function() {
    return _gl;
  };
  this.getContextAttributes = function() {
    return _gl.getContextAttributes();
  };
  this.forceContextLoss = function() {
    const extension = extensions.get("WEBGL_lose_context");
    if (extension)
      extension.loseContext();
  };
  this.forceContextRestore = function() {
    const extension = extensions.get("WEBGL_lose_context");
    if (extension)
      extension.restoreContext();
  };
  this.getPixelRatio = function() {
    return _pixelRatio;
  };
  this.setPixelRatio = function(value) {
    if (value === void 0)
      return;
    _pixelRatio = value;
    this.setSize(_width, _height, false);
  };
  this.getSize = function(target) {
    if (target === void 0) {
      console.warn("WebGLRenderer: .getsize() now requires a Vector2 as an argument");
      target = new Vector2$1();
    }
    return target.set(_width, _height);
  };
  this.setSize = function(width, height, updateStyle) {
    if (xr.isPresenting) {
      console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
      return;
    }
    _width = width;
    _height = height;
    _canvas2.width = Math.floor(width * _pixelRatio);
    _canvas2.height = Math.floor(height * _pixelRatio);
    if (updateStyle !== false) {
      _canvas2.style.width = width + "px";
      _canvas2.style.height = height + "px";
    }
    this.setViewport(0, 0, width, height);
  };
  this.getDrawingBufferSize = function(target) {
    if (target === void 0) {
      console.warn("WebGLRenderer: .getdrawingBufferSize() now requires a Vector2 as an argument");
      target = new Vector2$1();
    }
    return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
  };
  this.setDrawingBufferSize = function(width, height, pixelRatio) {
    _width = width;
    _height = height;
    _pixelRatio = pixelRatio;
    _canvas2.width = Math.floor(width * pixelRatio);
    _canvas2.height = Math.floor(height * pixelRatio);
    this.setViewport(0, 0, width, height);
  };
  this.getCurrentViewport = function(target) {
    if (target === void 0) {
      console.warn("WebGLRenderer: .getCurrentViewport() now requires a Vector4 as an argument");
      target = new Vector4();
    }
    return target.copy(_currentViewport);
  };
  this.getViewport = function(target) {
    return target.copy(_viewport);
  };
  this.setViewport = function(x, y, width, height) {
    if (x.isVector4) {
      _viewport.set(x.x, x.y, x.z, x.w);
    } else {
      _viewport.set(x, y, width, height);
    }
    state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
  };
  this.getScissor = function(target) {
    return target.copy(_scissor);
  };
  this.setScissor = function(x, y, width, height) {
    if (x.isVector4) {
      _scissor.set(x.x, x.y, x.z, x.w);
    } else {
      _scissor.set(x, y, width, height);
    }
    state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
  };
  this.getScissorTest = function() {
    return _scissorTest;
  };
  this.setScissorTest = function(boolean) {
    state.setScissorTest(_scissorTest = boolean);
  };
  this.setOpaqueSort = function(method) {
    _opaqueSort = method;
  };
  this.setTransparentSort = function(method) {
    _transparentSort = method;
  };
  this.getClearColor = function(target) {
    if (target === void 0) {
      console.warn("WebGLRenderer: .getClearColor() now requires a Color as an argument");
      target = new Color();
    }
    return target.copy(background.getClearColor());
  };
  this.setClearColor = function() {
    background.setClearColor.apply(background, arguments);
  };
  this.getClearAlpha = function() {
    return background.getClearAlpha();
  };
  this.setClearAlpha = function() {
    background.setClearAlpha.apply(background, arguments);
  };
  this.clear = function(color, depth, stencil) {
    let bits = 0;
    if (color === void 0 || color)
      bits |= 16384;
    if (depth === void 0 || depth)
      bits |= 256;
    if (stencil === void 0 || stencil)
      bits |= 1024;
    _gl.clear(bits);
  };
  this.clearColor = function() {
    this.clear(true, false, false);
  };
  this.clearDepth = function() {
    this.clear(false, true, false);
  };
  this.clearStencil = function() {
    this.clear(false, false, true);
  };
  this.dispose = function() {
    _canvas2.removeEventListener("webglcontextlost", onContextLost, false);
    _canvas2.removeEventListener("webglcontextrestored", onContextRestore, false);
    renderLists.dispose();
    renderStates.dispose();
    properties.dispose();
    cubemaps.dispose();
    objects.dispose();
    bindingStates.dispose();
    xr.dispose();
    xr.removeEventListener("sessionstart", onXRSessionStart);
    xr.removeEventListener("sessionend", onXRSessionEnd);
    if (_transmissionRenderTarget) {
      _transmissionRenderTarget.dispose();
      _transmissionRenderTarget = null;
    }
    animation.stop();
  };
  function onContextLost(event) {
    event.preventDefault();
    console.log("THREE.WebGLRenderer: Context Lost.");
    _isContextLost = true;
  }
  function onContextRestore() {
    console.log("THREE.WebGLRenderer: Context Restored.");
    _isContextLost = false;
    const infoAutoReset = info.autoReset;
    const shadowMapEnabled = shadowMap.enabled;
    const shadowMapAutoUpdate = shadowMap.autoUpdate;
    const shadowMapNeedsUpdate = shadowMap.needsUpdate;
    const shadowMapType = shadowMap.type;
    initGLContext();
    info.autoReset = infoAutoReset;
    shadowMap.enabled = shadowMapEnabled;
    shadowMap.autoUpdate = shadowMapAutoUpdate;
    shadowMap.needsUpdate = shadowMapNeedsUpdate;
    shadowMap.type = shadowMapType;
  }
  function onMaterialDispose(event) {
    const material = event.target;
    material.removeEventListener("dispose", onMaterialDispose);
    deallocateMaterial(material);
  }
  function deallocateMaterial(material) {
    releaseMaterialProgramReferences(material);
    properties.remove(material);
  }
  function releaseMaterialProgramReferences(material) {
    const programs = properties.get(material).programs;
    if (programs !== void 0) {
      programs.forEach(function(program) {
        programCache.releaseProgram(program);
      });
    }
  }
  function renderObjectImmediate(object, program) {
    object.render(function(object2) {
      _this.renderBufferImmediate(object2, program);
    });
  }
  this.renderBufferImmediate = function(object, program) {
    bindingStates.initAttributes();
    const buffers = properties.get(object);
    if (object.hasPositions && !buffers.position)
      buffers.position = _gl.createBuffer();
    if (object.hasNormals && !buffers.normal)
      buffers.normal = _gl.createBuffer();
    if (object.hasUvs && !buffers.uv)
      buffers.uv = _gl.createBuffer();
    if (object.hasColors && !buffers.color)
      buffers.color = _gl.createBuffer();
    const programAttributes = program.getAttributes();
    if (object.hasPositions) {
      _gl.bindBuffer(34962, buffers.position);
      _gl.bufferData(34962, object.positionArray, 35048);
      bindingStates.enableAttribute(programAttributes.position);
      _gl.vertexAttribPointer(programAttributes.position, 3, 5126, false, 0, 0);
    }
    if (object.hasNormals) {
      _gl.bindBuffer(34962, buffers.normal);
      _gl.bufferData(34962, object.normalArray, 35048);
      bindingStates.enableAttribute(programAttributes.normal);
      _gl.vertexAttribPointer(programAttributes.normal, 3, 5126, false, 0, 0);
    }
    if (object.hasUvs) {
      _gl.bindBuffer(34962, buffers.uv);
      _gl.bufferData(34962, object.uvArray, 35048);
      bindingStates.enableAttribute(programAttributes.uv);
      _gl.vertexAttribPointer(programAttributes.uv, 2, 5126, false, 0, 0);
    }
    if (object.hasColors) {
      _gl.bindBuffer(34962, buffers.color);
      _gl.bufferData(34962, object.colorArray, 35048);
      bindingStates.enableAttribute(programAttributes.color);
      _gl.vertexAttribPointer(programAttributes.color, 3, 5126, false, 0, 0);
    }
    bindingStates.disableUnusedAttributes();
    _gl.drawArrays(4, 0, object.count);
    object.count = 0;
  };
  this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
    if (scene === null)
      scene = _emptyScene;
    const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
    const program = setProgram(camera, scene, material, object);
    state.setMaterial(material, frontFaceCW);
    let index = geometry.index;
    const position = geometry.attributes.position;
    if (index === null) {
      if (position === void 0 || position.count === 0)
        return;
    } else if (index.count === 0) {
      return;
    }
    let rangeFactor = 1;
    if (material.wireframe === true) {
      index = geometries.getWireframeAttribute(geometry);
      rangeFactor = 2;
    }
    if (material.morphTargets || material.morphNormals) {
      morphtargets.update(object, geometry, material, program);
    }
    bindingStates.setup(object, material, program, geometry, index);
    let attribute;
    let renderer = bufferRenderer;
    if (index !== null) {
      attribute = attributes.get(index);
      renderer = indexedBufferRenderer;
      renderer.setIndex(attribute);
    }
    const dataCount = index !== null ? index.count : position.count;
    const rangeStart = geometry.drawRange.start * rangeFactor;
    const rangeCount = geometry.drawRange.count * rangeFactor;
    const groupStart = group !== null ? group.start * rangeFactor : 0;
    const groupCount = group !== null ? group.count * rangeFactor : Infinity;
    const drawStart = Math.max(rangeStart, groupStart);
    const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
    const drawCount = Math.max(0, drawEnd - drawStart + 1);
    if (drawCount === 0)
      return;
    if (object.isMesh) {
      if (material.wireframe === true) {
        state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
        renderer.setMode(1);
      } else {
        renderer.setMode(4);
      }
    } else if (object.isLine) {
      let lineWidth = material.linewidth;
      if (lineWidth === void 0)
        lineWidth = 1;
      state.setLineWidth(lineWidth * getTargetPixelRatio());
      if (object.isLineSegments) {
        renderer.setMode(1);
      } else if (object.isLineLoop) {
        renderer.setMode(2);
      } else {
        renderer.setMode(3);
      }
    } else if (object.isPoints) {
      renderer.setMode(0);
    } else if (object.isSprite) {
      renderer.setMode(4);
    }
    if (object.isInstancedMesh) {
      renderer.renderInstances(drawStart, drawCount, object.count);
    } else if (geometry.isInstancedBufferGeometry) {
      const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
      renderer.renderInstances(drawStart, drawCount, instanceCount);
    } else {
      renderer.render(drawStart, drawCount);
    }
  };
  this.compile = function(scene, camera) {
    currentRenderState = renderStates.get(scene);
    currentRenderState.init();
    scene.traverseVisible(function(object) {
      if (object.isLight && object.layers.test(camera.layers)) {
        currentRenderState.pushLight(object);
        if (object.castShadow) {
          currentRenderState.pushShadow(object);
        }
      }
    });
    currentRenderState.setupLights();
    scene.traverse(function(object) {
      const material = object.material;
      if (material) {
        if (Array.isArray(material)) {
          for (let i = 0; i < material.length; i++) {
            const material2 = material[i];
            getProgram(material2, scene, object);
          }
        } else {
          getProgram(material, scene, object);
        }
      }
    });
  };
  let onAnimationFrameCallback = null;
  function onAnimationFrame(time) {
    if (onAnimationFrameCallback)
      onAnimationFrameCallback(time);
  }
  function onXRSessionStart() {
    animation.stop();
  }
  function onXRSessionEnd() {
    animation.start();
  }
  const animation = new WebGLAnimation();
  animation.setAnimationLoop(onAnimationFrame);
  if (typeof window !== "undefined")
    animation.setContext(window);
  this.setAnimationLoop = function(callback) {
    onAnimationFrameCallback = callback;
    xr.setAnimationLoop(callback);
    callback === null ? animation.stop() : animation.start();
  };
  xr.addEventListener("sessionstart", onXRSessionStart);
  xr.addEventListener("sessionend", onXRSessionEnd);
  this.render = function(scene, camera) {
    if (camera !== void 0 && camera.isCamera !== true) {
      console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      return;
    }
    if (_isContextLost === true)
      return;
    if (scene.autoUpdate === true)
      scene.updateMatrixWorld();
    if (camera.parent === null)
      camera.updateMatrixWorld();
    if (xr.enabled === true && xr.isPresenting === true) {
      if (xr.cameraAutoUpdate === true)
        xr.updateCamera(camera);
      camera = xr.getCamera();
    }
    if (scene.isScene === true)
      scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
    currentRenderState = renderStates.get(scene, renderStateStack.length);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);
    _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    _frustum.setFromProjectionMatrix(_projScreenMatrix2);
    _localClippingEnabled = this.localClippingEnabled;
    _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
    currentRenderList = renderLists.get(scene, renderListStack.length);
    currentRenderList.init();
    renderListStack.push(currentRenderList);
    projectObject(scene, camera, 0, _this.sortObjects);
    currentRenderList.finish();
    if (_this.sortObjects === true) {
      currentRenderList.sort(_opaqueSort, _transparentSort);
    }
    if (_clippingEnabled === true)
      clipping.beginShadows();
    const shadowsArray = currentRenderState.state.shadowsArray;
    shadowMap.render(shadowsArray, scene, camera);
    currentRenderState.setupLights();
    currentRenderState.setupLightsView(camera);
    if (_clippingEnabled === true)
      clipping.endShadows();
    if (this.info.autoReset === true)
      this.info.reset();
    background.render(currentRenderList, scene);
    const opaqueObjects = currentRenderList.opaque;
    const transmissiveObjects = currentRenderList.transmissive;
    const transparentObjects = currentRenderList.transparent;
    if (opaqueObjects.length > 0)
      renderObjects(opaqueObjects, scene, camera);
    if (transmissiveObjects.length > 0)
      renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera);
    if (transparentObjects.length > 0)
      renderObjects(transparentObjects, scene, camera);
    if (_currentRenderTarget !== null) {
      textures.updateRenderTargetMipmap(_currentRenderTarget);
      textures.updateMultisampleRenderTarget(_currentRenderTarget);
    }
    if (scene.isScene === true)
      scene.onAfterRender(_this, scene, camera);
    state.buffers.depth.setTest(true);
    state.buffers.depth.setMask(true);
    state.buffers.color.setMask(true);
    state.setPolygonOffset(false);
    bindingStates.resetDefaultState();
    _currentMaterialId = -1;
    _currentCamera = null;
    renderStateStack.pop();
    if (renderStateStack.length > 0) {
      currentRenderState = renderStateStack[renderStateStack.length - 1];
    } else {
      currentRenderState = null;
    }
    renderListStack.pop();
    if (renderListStack.length > 0) {
      currentRenderList = renderListStack[renderListStack.length - 1];
    } else {
      currentRenderList = null;
    }
  };
  function projectObject(object, camera, groupOrder, sortObjects) {
    if (object.visible === false)
      return;
    const visible = object.layers.test(camera.layers);
    if (visible) {
      if (object.isGroup) {
        groupOrder = object.renderOrder;
      } else if (object.isLOD) {
        if (object.autoUpdate === true)
          object.update(camera);
      } else if (object.isLight) {
        currentRenderState.pushLight(object);
        if (object.castShadow) {
          currentRenderState.pushShadow(object);
        }
      } else if (object.isSprite) {
        if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
          if (sortObjects) {
            _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
          }
          const geometry = objects.update(object);
          const material = object.material;
          if (material.visible) {
            currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
          }
        }
      } else if (object.isImmediateRenderObject) {
        if (sortObjects) {
          _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
        }
        currentRenderList.push(object, null, object.material, groupOrder, _vector3.z, null);
      } else if (object.isMesh || object.isLine || object.isPoints) {
        if (object.isSkinnedMesh) {
          if (object.skeleton.frame !== info.render.frame) {
            object.skeleton.update();
            object.skeleton.frame = info.render.frame;
          }
        }
        if (!object.frustumCulled || _frustum.intersectsObject(object)) {
          if (sortObjects) {
            _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
          }
          const geometry = objects.update(object);
          const material = object.material;
          if (Array.isArray(material)) {
            const groups = geometry.groups;
            for (let i = 0, l = groups.length; i < l; i++) {
              const group = groups[i];
              const groupMaterial = material[group.materialIndex];
              if (groupMaterial && groupMaterial.visible) {
                currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
              }
            }
          } else if (material.visible) {
            currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
          }
        }
      }
    }
    const children = object.children;
    for (let i = 0, l = children.length; i < l; i++) {
      projectObject(children[i], camera, groupOrder, sortObjects);
    }
  }
  function renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera) {
    if (_transmissionRenderTarget === null) {
      _transmissionRenderTarget = new WebGLRenderTarget(1024, 1024, {
        generateMipmaps: true,
        minFilter: LinearMipmapLinearFilter$1,
        magFilter: NearestFilter,
        wrapS: ClampToEdgeWrapping$1,
        wrapT: ClampToEdgeWrapping$1
      });
    }
    const currentRenderTarget = _this.getRenderTarget();
    _this.setRenderTarget(_transmissionRenderTarget);
    _this.clear();
    renderObjects(opaqueObjects, scene, camera);
    textures.updateRenderTargetMipmap(_transmissionRenderTarget);
    _this.setRenderTarget(currentRenderTarget);
    renderObjects(transmissiveObjects, scene, camera);
  }
  function renderObjects(renderList, scene, camera) {
    const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
    for (let i = 0, l = renderList.length; i < l; i++) {
      const renderItem = renderList[i];
      const object = renderItem.object;
      const geometry = renderItem.geometry;
      const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
      const group = renderItem.group;
      if (camera.isArrayCamera) {
        const cameras = camera.cameras;
        for (let j = 0, jl = cameras.length; j < jl; j++) {
          const camera2 = cameras[j];
          if (object.layers.test(camera2.layers)) {
            state.viewport(_currentViewport.copy(camera2.viewport));
            currentRenderState.setupLightsView(camera2);
            renderObject(object, scene, camera2, geometry, material, group);
          }
        }
      } else {
        renderObject(object, scene, camera, geometry, material, group);
      }
    }
  }
  function renderObject(object, scene, camera, geometry, material, group) {
    object.onBeforeRender(_this, scene, camera, geometry, material, group);
    object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
    object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
    if (object.isImmediateRenderObject) {
      const program = setProgram(camera, scene, material, object);
      state.setMaterial(material);
      bindingStates.reset();
      renderObjectImmediate(object, program);
    } else {
      _this.renderBufferDirect(camera, scene, geometry, material, object, group);
    }
    object.onAfterRender(_this, scene, camera, geometry, material, group);
  }
  function getProgram(material, scene, object) {
    if (scene.isScene !== true)
      scene = _emptyScene;
    const materialProperties = properties.get(material);
    const lights = currentRenderState.state.lights;
    const shadowsArray = currentRenderState.state.shadowsArray;
    const lightsStateVersion = lights.state.version;
    const parameters2 = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
    const programCacheKey = programCache.getProgramCacheKey(parameters2);
    let programs = materialProperties.programs;
    materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
    materialProperties.fog = scene.fog;
    materialProperties.envMap = cubemaps.get(material.envMap || materialProperties.environment);
    if (programs === void 0) {
      material.addEventListener("dispose", onMaterialDispose);
      programs = /* @__PURE__ */ new Map();
      materialProperties.programs = programs;
    }
    let program = programs.get(programCacheKey);
    if (program !== void 0) {
      if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
        updateCommonMaterialProperties(material, parameters2);
        return program;
      }
    } else {
      parameters2.uniforms = programCache.getUniforms(material);
      material.onBuild(parameters2, _this);
      material.onBeforeCompile(parameters2, _this);
      program = programCache.acquireProgram(parameters2, programCacheKey);
      programs.set(programCacheKey, program);
      materialProperties.uniforms = parameters2.uniforms;
    }
    const uniforms = materialProperties.uniforms;
    if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
      uniforms.clippingPlanes = clipping.uniform;
    }
    updateCommonMaterialProperties(material, parameters2);
    materialProperties.needsLights = materialNeedsLights(material);
    materialProperties.lightsStateVersion = lightsStateVersion;
    if (materialProperties.needsLights) {
      uniforms.ambientLightColor.value = lights.state.ambient;
      uniforms.lightProbe.value = lights.state.probe;
      uniforms.directionalLights.value = lights.state.directional;
      uniforms.directionalLightShadows.value = lights.state.directionalShadow;
      uniforms.spotLights.value = lights.state.spot;
      uniforms.spotLightShadows.value = lights.state.spotShadow;
      uniforms.rectAreaLights.value = lights.state.rectArea;
      uniforms.ltc_1.value = lights.state.rectAreaLTC1;
      uniforms.ltc_2.value = lights.state.rectAreaLTC2;
      uniforms.pointLights.value = lights.state.point;
      uniforms.pointLightShadows.value = lights.state.pointShadow;
      uniforms.hemisphereLights.value = lights.state.hemi;
      uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
      uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
      uniforms.spotShadowMap.value = lights.state.spotShadowMap;
      uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
      uniforms.pointShadowMap.value = lights.state.pointShadowMap;
      uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
    }
    const progUniforms = program.getUniforms();
    const uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
    materialProperties.currentProgram = program;
    materialProperties.uniformsList = uniformsList;
    return program;
  }
  function updateCommonMaterialProperties(material, parameters2) {
    const materialProperties = properties.get(material);
    materialProperties.outputEncoding = parameters2.outputEncoding;
    materialProperties.instancing = parameters2.instancing;
    materialProperties.skinning = parameters2.skinning;
    materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
    materialProperties.numIntersection = parameters2.numClipIntersection;
    materialProperties.vertexAlphas = parameters2.vertexAlphas;
  }
  function setProgram(camera, scene, material, object) {
    if (scene.isScene !== true)
      scene = _emptyScene;
    textures.resetTextureUnits();
    const fog = scene.fog;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
    const envMap = cubemaps.get(material.envMap || environment);
    const vertexAlphas = material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4;
    const materialProperties = properties.get(material);
    const lights = currentRenderState.state.lights;
    if (_clippingEnabled === true) {
      if (_localClippingEnabled === true || camera !== _currentCamera) {
        const useCache = camera === _currentCamera && material.id === _currentMaterialId;
        clipping.setState(material, camera, useCache);
      }
    }
    let needsProgramChange = false;
    if (material.version === materialProperties.__version) {
      if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
        needsProgramChange = true;
      } else if (materialProperties.outputEncoding !== encoding) {
        needsProgramChange = true;
      } else if (object.isInstancedMesh && materialProperties.instancing === false) {
        needsProgramChange = true;
      } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
        needsProgramChange = true;
      } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
        needsProgramChange = true;
      } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
        needsProgramChange = true;
      } else if (materialProperties.envMap !== envMap) {
        needsProgramChange = true;
      } else if (material.fog && materialProperties.fog !== fog) {
        needsProgramChange = true;
      } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
        needsProgramChange = true;
      } else if (materialProperties.vertexAlphas !== vertexAlphas) {
        needsProgramChange = true;
      }
    } else {
      needsProgramChange = true;
      materialProperties.__version = material.version;
    }
    let program = materialProperties.currentProgram;
    if (needsProgramChange === true) {
      program = getProgram(material, scene, object);
    }
    let refreshProgram = false;
    let refreshMaterial = false;
    let refreshLights = false;
    const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
    if (state.useProgram(program.program)) {
      refreshProgram = true;
      refreshMaterial = true;
      refreshLights = true;
    }
    if (material.id !== _currentMaterialId) {
      _currentMaterialId = material.id;
      refreshMaterial = true;
    }
    if (refreshProgram || _currentCamera !== camera) {
      p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
      if (capabilities.logarithmicDepthBuffer) {
        p_uniforms.setValue(
          _gl,
          "logDepthBufFC",
          2 / (Math.log(camera.far + 1) / Math.LN2)
        );
      }
      if (_currentCamera !== camera) {
        _currentCamera = camera;
        refreshMaterial = true;
        refreshLights = true;
      }
      if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
        const uCamPos = p_uniforms.map.cameraPosition;
        if (uCamPos !== void 0) {
          uCamPos.setValue(
            _gl,
            _vector3.setFromMatrixPosition(camera.matrixWorld)
          );
        }
      }
      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
        p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
      }
      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) {
        p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
      }
    }
    if (object.isSkinnedMesh) {
      p_uniforms.setOptional(_gl, object, "bindMatrix");
      p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
      const skeleton = object.skeleton;
      if (skeleton) {
        if (capabilities.floatVertexTextures) {
          if (skeleton.boneTexture === null)
            skeleton.computeBoneTexture();
          p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
          p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
        } else {
          p_uniforms.setOptional(_gl, skeleton, "boneMatrices");
        }
      }
    }
    if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
      materialProperties.receiveShadow = object.receiveShadow;
      p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
    }
    if (refreshMaterial) {
      p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
      if (materialProperties.needsLights) {
        markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
      }
      if (fog && material.fog) {
        materials.refreshFogUniforms(m_uniforms, fog);
      }
      materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
      WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
    }
    if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
      WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
      material.uniformsNeedUpdate = false;
    }
    if (material.isSpriteMaterial) {
      p_uniforms.setValue(_gl, "center", object.center);
    }
    p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
    p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
    p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
    return program;
  }
  function markUniformsLightsNeedsUpdate(uniforms, value) {
    uniforms.ambientLightColor.needsUpdate = value;
    uniforms.lightProbe.needsUpdate = value;
    uniforms.directionalLights.needsUpdate = value;
    uniforms.directionalLightShadows.needsUpdate = value;
    uniforms.pointLights.needsUpdate = value;
    uniforms.pointLightShadows.needsUpdate = value;
    uniforms.spotLights.needsUpdate = value;
    uniforms.spotLightShadows.needsUpdate = value;
    uniforms.rectAreaLights.needsUpdate = value;
    uniforms.hemisphereLights.needsUpdate = value;
  }
  function materialNeedsLights(material) {
    return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
  }
  this.getActiveCubeFace = function() {
    return _currentActiveCubeFace;
  };
  this.getActiveMipmapLevel = function() {
    return _currentActiveMipmapLevel;
  };
  this.getRenderTarget = function() {
    return _currentRenderTarget;
  };
  this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
    _currentRenderTarget = renderTarget;
    _currentActiveCubeFace = activeCubeFace;
    _currentActiveMipmapLevel = activeMipmapLevel;
    if (renderTarget && properties.get(renderTarget).__webglFramebuffer === void 0) {
      textures.setupRenderTarget(renderTarget);
    }
    let framebuffer = null;
    let isCube = false;
    let isRenderTarget3D = false;
    if (renderTarget) {
      const texture = renderTarget.texture;
      if (texture.isDataTexture3D || texture.isDataTexture2DArray) {
        isRenderTarget3D = true;
      }
      const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget) {
        framebuffer = __webglFramebuffer[activeCubeFace];
        isCube = true;
      } else if (renderTarget.isWebGLMultisampleRenderTarget) {
        framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
      } else {
        framebuffer = __webglFramebuffer;
      }
      _currentViewport.copy(renderTarget.viewport);
      _currentScissor.copy(renderTarget.scissor);
      _currentScissorTest = renderTarget.scissorTest;
    } else {
      _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
      _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
      _currentScissorTest = _scissorTest;
    }
    const framebufferBound = state.bindFramebuffer(36160, framebuffer);
    if (framebufferBound && capabilities.drawBuffers) {
      let needsUpdate = false;
      if (renderTarget) {
        if (renderTarget.isWebGLMultipleRenderTargets) {
          const textures2 = renderTarget.texture;
          if (_currentDrawBuffers.length !== textures2.length || _currentDrawBuffers[0] !== 36064) {
            for (let i = 0, il = textures2.length; i < il; i++) {
              _currentDrawBuffers[i] = 36064 + i;
            }
            _currentDrawBuffers.length = textures2.length;
            needsUpdate = true;
          }
        } else {
          if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 36064) {
            _currentDrawBuffers[0] = 36064;
            _currentDrawBuffers.length = 1;
            needsUpdate = true;
          }
        }
      } else {
        if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 1029) {
          _currentDrawBuffers[0] = 1029;
          _currentDrawBuffers.length = 1;
          needsUpdate = true;
        }
      }
      if (needsUpdate) {
        if (capabilities.isWebGL2) {
          _gl.drawBuffers(_currentDrawBuffers);
        } else {
          extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(_currentDrawBuffers);
        }
      }
    }
    state.viewport(_currentViewport);
    state.scissor(_currentScissor);
    state.setScissorTest(_currentScissorTest);
    if (isCube) {
      const textureProperties = properties.get(renderTarget.texture);
      _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
    } else if (isRenderTarget3D) {
      const textureProperties = properties.get(renderTarget.texture);
      const layer = activeCubeFace || 0;
      _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
    }
  };
  this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
    if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
      console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      return;
    }
    let framebuffer = properties.get(renderTarget).__webglFramebuffer;
    if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
      framebuffer = framebuffer[activeCubeFaceIndex];
    }
    if (framebuffer) {
      state.bindFramebuffer(36160, framebuffer);
      try {
        const texture = renderTarget.texture;
        const textureFormat = texture.format;
        const textureType = texture.type;
        if (textureFormat !== RGBAFormat$1 && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
          return;
        }
        const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
        if (textureType !== UnsignedByteType$1 && utils.convert(textureType) !== _gl.getParameter(35738) && !(textureType === FloatType && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && !halfFloatSupportedByExt) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          return;
        }
        if (_gl.checkFramebufferStatus(36160) === 36053) {
          if (x >= 0 && x <= renderTarget.width - width && (y >= 0 && y <= renderTarget.height - height)) {
            _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
          }
        } else {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
        }
      } finally {
        const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
        state.bindFramebuffer(36160, framebuffer2);
      }
    }
  };
  this.copyFramebufferToTexture = function(position, texture, level = 0) {
    const levelScale = Math.pow(2, -level);
    const width = Math.floor(texture.image.width * levelScale);
    const height = Math.floor(texture.image.height * levelScale);
    let glFormat = utils.convert(texture.format);
    if (capabilities.isWebGL2) {
      if (glFormat === 6407)
        glFormat = 32849;
      if (glFormat === 6408)
        glFormat = 32856;
    }
    textures.setTexture2D(texture, 0);
    _gl.copyTexImage2D(3553, level, glFormat, position.x, position.y, width, height, 0);
    state.unbindTexture();
  };
  this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
    const width = srcTexture.image.width;
    const height = srcTexture.image.height;
    const glFormat = utils.convert(dstTexture.format);
    const glType = utils.convert(dstTexture.type);
    textures.setTexture2D(dstTexture, 0);
    _gl.pixelStorei(37440, dstTexture.flipY);
    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
    _gl.pixelStorei(3317, dstTexture.unpackAlignment);
    if (srcTexture.isDataTexture) {
      _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
      } else {
        _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
      }
    }
    if (level === 0 && dstTexture.generateMipmaps)
      _gl.generateMipmap(3553);
    state.unbindTexture();
  };
  this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
    if (_this.isWebGL1Renderer) {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      return;
    }
    const { width, height, data } = srcTexture.image;
    const glFormat = utils.convert(dstTexture.format);
    const glType = utils.convert(dstTexture.type);
    let glTarget;
    if (dstTexture.isDataTexture3D) {
      textures.setTexture3D(dstTexture, 0);
      glTarget = 32879;
    } else if (dstTexture.isDataTexture2DArray) {
      textures.setTexture2DArray(dstTexture, 0);
      glTarget = 35866;
    } else {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      return;
    }
    _gl.pixelStorei(37440, dstTexture.flipY);
    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
    _gl.pixelStorei(3317, dstTexture.unpackAlignment);
    const unpackRowLen = _gl.getParameter(3314);
    const unpackImageHeight = _gl.getParameter(32878);
    const unpackSkipPixels = _gl.getParameter(3316);
    const unpackSkipRows = _gl.getParameter(3315);
    const unpackSkipImages = _gl.getParameter(32877);
    _gl.pixelStorei(3314, width);
    _gl.pixelStorei(32878, height);
    _gl.pixelStorei(3316, sourceBox.min.x);
    _gl.pixelStorei(3315, sourceBox.min.y);
    _gl.pixelStorei(32877, sourceBox.min.z);
    _gl.texSubImage3D(
      glTarget,
      level,
      position.x,
      position.y,
      position.z,
      sourceBox.max.x - sourceBox.min.x + 1,
      sourceBox.max.y - sourceBox.min.y + 1,
      sourceBox.max.z - sourceBox.min.z + 1,
      glFormat,
      glType,
      data
    );
    _gl.pixelStorei(3314, unpackRowLen);
    _gl.pixelStorei(32878, unpackImageHeight);
    _gl.pixelStorei(3316, unpackSkipPixels);
    _gl.pixelStorei(3315, unpackSkipRows);
    _gl.pixelStorei(32877, unpackSkipImages);
    if (level === 0 && dstTexture.generateMipmaps)
      _gl.generateMipmap(glTarget);
    state.unbindTexture();
  };
  this.initTexture = function(texture) {
    textures.setTexture2D(texture, 0);
    state.unbindTexture();
  };
  this.resetState = function() {
    _currentActiveCubeFace = 0;
    _currentActiveMipmapLevel = 0;
    _currentRenderTarget = null;
    state.reset();
    bindingStates.reset();
  };
  if (typeof __THREE_DEVTOOLS__ !== "undefined") {
    __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
}
class WebGL1Renderer extends WebGLRenderer {
}
WebGL1Renderer.prototype.isWebGL1Renderer = true;
class Scene$1 extends Object3D {
  constructor() {
    super();
    this.type = "Scene";
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.overrideMaterial = null;
    this.autoUpdate = true;
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.background !== null)
      this.background = source.background.clone();
    if (source.environment !== null)
      this.environment = source.environment.clone();
    if (source.fog !== null)
      this.fog = source.fog.clone();
    if (source.overrideMaterial !== null)
      this.overrideMaterial = source.overrideMaterial.clone();
    this.autoUpdate = source.autoUpdate;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.background !== null)
      data.object.background = this.background.toJSON(meta);
    if (this.environment !== null)
      data.object.environment = this.environment.toJSON(meta);
    if (this.fog !== null)
      data.object.fog = this.fog.toJSON();
    return data;
  }
}
Scene$1.prototype.isScene = true;
class InterleavedBuffer {
  constructor(array, stride) {
    this.array = array;
    this.stride = stride;
    this.count = array !== void 0 ? array.length / stride : 0;
    this.usage = StaticDrawUsage;
    this.updateRange = { offset: 0, count: -1 };
    this.version = 0;
    this.uuid = generateUUID$1();
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  copy(source) {
    this.array = new source.array.constructor(source.array);
    this.count = source.count;
    this.stride = source.stride;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.stride;
    index2 *= attribute.stride;
    for (let i = 0, l = this.stride; i < l; i++) {
      this.array[index1 + i] = attribute.array[index2 + i];
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  clone(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID$1();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
    }
    const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
    const ib = new this.constructor(array, this.stride);
    ib.setUsage(this.usage);
    return ib;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  toJSON(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID$1();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
    }
    return {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
InterleavedBuffer.prototype.isInterleavedBuffer = true;
const _vector$6 = /* @__PURE__ */ new Vector3$1();
class InterleavedBufferAttribute {
  constructor(interleavedBuffer, itemSize, offset, normalized) {
    this.name = "";
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized === true;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(value) {
    this.data.needsUpdate = value;
  }
  applyMatrix4(m) {
    for (let i = 0, l = this.data.count; i < l; i++) {
      _vector$6.x = this.getX(i);
      _vector$6.y = this.getY(i);
      _vector$6.z = this.getZ(i);
      _vector$6.applyMatrix4(m);
      this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  applyNormalMatrix(m) {
    for (let i = 0, l = this.count; i < l; i++) {
      _vector$6.x = this.getX(i);
      _vector$6.y = this.getY(i);
      _vector$6.z = this.getZ(i);
      _vector$6.applyNormalMatrix(m);
      this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  transformDirection(m) {
    for (let i = 0, l = this.count; i < l; i++) {
      _vector$6.x = this.getX(i);
      _vector$6.y = this.getY(i);
      _vector$6.z = this.getZ(i);
      _vector$6.transformDirection(m);
      this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  setX(index, x) {
    this.data.array[index * this.data.stride + this.offset] = x;
    return this;
  }
  setY(index, y) {
    this.data.array[index * this.data.stride + this.offset + 1] = y;
    return this;
  }
  setZ(index, z) {
    this.data.array[index * this.data.stride + this.offset + 2] = z;
    return this;
  }
  setW(index, w) {
    this.data.array[index * this.data.stride + this.offset + 3] = w;
    return this;
  }
  getX(index) {
    return this.data.array[index * this.data.stride + this.offset];
  }
  getY(index) {
    return this.data.array[index * this.data.stride + this.offset + 1];
  }
  getZ(index) {
    return this.data.array[index * this.data.stride + this.offset + 2];
  }
  getW(index) {
    return this.data.array[index * this.data.stride + this.offset + 3];
  }
  setXY(index, x, y) {
    index = index * this.data.stride + this.offset;
    this.data.array[index + 0] = x;
    this.data.array[index + 1] = y;
    return this;
  }
  setXYZ(index, x, y, z) {
    index = index * this.data.stride + this.offset;
    this.data.array[index + 0] = x;
    this.data.array[index + 1] = y;
    this.data.array[index + 2] = z;
    return this;
  }
  setXYZW(index, x, y, z, w) {
    index = index * this.data.stride + this.offset;
    this.data.array[index + 0] = x;
    this.data.array[index + 1] = y;
    this.data.array[index + 2] = z;
    this.data.array[index + 3] = w;
    return this;
  }
  clone(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
      const array = [];
      for (let i = 0; i < this.count; i++) {
        const index = i * this.data.stride + this.offset;
        for (let j = 0; j < this.itemSize; j++) {
          array.push(this.data.array[index + j]);
        }
      }
      return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
      }
      return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }
  toJSON(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
      const array = [];
      for (let i = 0; i < this.count; i++) {
        const index = i * this.data.stride + this.offset;
        for (let j = 0; j < this.itemSize; j++) {
          array.push(this.data.array[index + j]);
        }
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array,
        normalized: this.normalized
      };
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
      }
      return {
        isInterleavedBufferAttribute: true,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }
}
InterleavedBufferAttribute.prototype.isInterleavedBufferAttribute = true;
class SpriteMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "SpriteMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
  }
}
SpriteMaterial.prototype.isSpriteMaterial = true;
let _geometry;
const _intersectPoint = /* @__PURE__ */ new Vector3$1();
const _worldScale = /* @__PURE__ */ new Vector3$1();
const _mvPosition = /* @__PURE__ */ new Vector3$1();
const _alignedPosition = /* @__PURE__ */ new Vector2$1();
const _rotatedPosition = /* @__PURE__ */ new Vector2$1();
const _viewWorldMatrix = /* @__PURE__ */ new Matrix4();
const _vA = /* @__PURE__ */ new Vector3$1();
const _vB = /* @__PURE__ */ new Vector3$1();
const _vC = /* @__PURE__ */ new Vector3$1();
const _uvA = /* @__PURE__ */ new Vector2$1();
const _uvB = /* @__PURE__ */ new Vector2$1();
const _uvC = /* @__PURE__ */ new Vector2$1();
class Sprite extends Object3D {
  constructor(material) {
    super();
    this.type = "Sprite";
    if (_geometry === void 0) {
      _geometry = new BufferGeometry();
      const float32Array = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]);
      const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
      _geometry.setIndex([0, 1, 2, 0, 2, 3]);
      _geometry.setAttribute("position", new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
      _geometry.setAttribute("uv", new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry;
    this.material = material !== void 0 ? material : new SpriteMaterial();
    this.center = new Vector2$1(0.5, 0.5);
  }
  raycast(raycaster, intersects2) {
    if (raycaster.camera === null) {
      console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
    }
    _worldScale.setFromMatrixScale(this.matrixWorld);
    _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
    this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
    _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
    if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
      _worldScale.multiplyScalar(-_mvPosition.z);
    }
    const rotation = this.material.rotation;
    let sin, cos;
    if (rotation !== 0) {
      cos = Math.cos(rotation);
      sin = Math.sin(rotation);
    }
    const center = this.center;
    transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
    transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
    transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
    _uvA.set(0, 0);
    _uvB.set(1, 0);
    _uvC.set(1, 1);
    let intersect = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);
    if (intersect === null) {
      transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
      _uvB.set(0, 1);
      intersect = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
      if (intersect === null) {
        return;
      }
    }
    const distance = raycaster.ray.origin.distanceTo(_intersectPoint);
    if (distance < raycaster.near || distance > raycaster.far)
      return;
    intersects2.push({
      distance,
      point: _intersectPoint.clone(),
      uv: Triangle.getUV(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2$1()),
      face: null,
      object: this
    });
  }
  copy(source) {
    super.copy(source);
    if (source.center !== void 0)
      this.center.copy(source.center);
    this.material = source.material;
    return this;
  }
}
Sprite.prototype.isSprite = true;
function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
  _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
  if (sin !== void 0) {
    _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
    _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
  } else {
    _rotatedPosition.copy(_alignedPosition);
  }
  vertexPosition.copy(mvPosition);
  vertexPosition.x += _rotatedPosition.x;
  vertexPosition.y += _rotatedPosition.y;
  vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _basePosition = /* @__PURE__ */ new Vector3$1();
const _skinIndex = /* @__PURE__ */ new Vector4();
const _skinWeight = /* @__PURE__ */ new Vector4();
const _vector$5 = /* @__PURE__ */ new Vector3$1();
const _matrix = /* @__PURE__ */ new Matrix4();
class SkinnedMesh extends Mesh {
  constructor(geometry, material) {
    super(geometry, material);
    this.type = "SkinnedMesh";
    this.bindMode = "attached";
    this.bindMatrix = new Matrix4();
    this.bindMatrixInverse = new Matrix4();
  }
  copy(source) {
    super.copy(source);
    this.bindMode = source.bindMode;
    this.bindMatrix.copy(source.bindMatrix);
    this.bindMatrixInverse.copy(source.bindMatrixInverse);
    this.skeleton = source.skeleton;
    return this;
  }
  bind(skeleton, bindMatrix) {
    this.skeleton = skeleton;
    if (bindMatrix === void 0) {
      this.updateMatrixWorld(true);
      this.skeleton.calculateInverses();
      bindMatrix = this.matrixWorld;
    }
    this.bindMatrix.copy(bindMatrix);
    this.bindMatrixInverse.copy(bindMatrix).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const vector = new Vector4();
    const skinWeight = this.geometry.attributes.skinWeight;
    for (let i = 0, l = skinWeight.count; i < l; i++) {
      vector.x = skinWeight.getX(i);
      vector.y = skinWeight.getY(i);
      vector.z = skinWeight.getZ(i);
      vector.w = skinWeight.getW(i);
      const scale = 1 / vector.manhattanLength();
      if (scale !== Infinity) {
        vector.multiplyScalar(scale);
      } else {
        vector.set(1, 0, 0, 0);
      }
      skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
    }
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.bindMode === "attached") {
      this.bindMatrixInverse.copy(this.matrixWorld).invert();
    } else if (this.bindMode === "detached") {
      this.bindMatrixInverse.copy(this.bindMatrix).invert();
    } else {
      console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }
  boneTransform(index, target) {
    const skeleton = this.skeleton;
    const geometry = this.geometry;
    _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
    _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
    _basePosition.fromBufferAttribute(geometry.attributes.position, index).applyMatrix4(this.bindMatrix);
    target.set(0, 0, 0);
    for (let i = 0; i < 4; i++) {
      const weight = _skinWeight.getComponent(i);
      if (weight !== 0) {
        const boneIndex = _skinIndex.getComponent(i);
        _matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
        target.addScaledVector(_vector$5.copy(_basePosition).applyMatrix4(_matrix), weight);
      }
    }
    return target.applyMatrix4(this.bindMatrixInverse);
  }
}
SkinnedMesh.prototype.isSkinnedMesh = true;
class Bone extends Object3D {
  constructor() {
    super();
    this.type = "Bone";
  }
}
Bone.prototype.isBone = true;
class DataTexture extends Texture$1 {
  constructor(data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = { data: data || null, width: width || 1, height: height || 1 };
    this.magFilter = magFilter !== void 0 ? magFilter : NearestFilter;
    this.minFilter = minFilter !== void 0 ? minFilter : NearestFilter;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
  }
}
DataTexture.prototype.isDataTexture = true;
const _offsetMatrix = /* @__PURE__ */ new Matrix4();
const _identityMatrix = /* @__PURE__ */ new Matrix4();
class Skeleton {
  constructor(bones = [], boneInverses = []) {
    this.uuid = generateUUID$1();
    this.bones = bones.slice(0);
    this.boneInverses = boneInverses;
    this.boneMatrices = null;
    this.boneTexture = null;
    this.boneTextureSize = 0;
    this.frame = -1;
    this.init();
  }
  init() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    this.boneMatrices = new Float32Array(bones.length * 16);
    if (boneInverses.length === 0) {
      this.calculateInverses();
    } else {
      if (bones.length !== boneInverses.length) {
        console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
        this.boneInverses = [];
        for (let i = 0, il = this.bones.length; i < il; i++) {
          this.boneInverses.push(new Matrix4());
        }
      }
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let i = 0, il = this.bones.length; i < il; i++) {
      const inverse = new Matrix4();
      if (this.bones[i]) {
        inverse.copy(this.bones[i].matrixWorld).invert();
      }
      this.boneInverses.push(inverse);
    }
  }
  pose() {
    for (let i = 0, il = this.bones.length; i < il; i++) {
      const bone = this.bones[i];
      if (bone) {
        bone.matrixWorld.copy(this.boneInverses[i]).invert();
      }
    }
    for (let i = 0, il = this.bones.length; i < il; i++) {
      const bone = this.bones[i];
      if (bone) {
        if (bone.parent && bone.parent.isBone) {
          bone.matrix.copy(bone.parent.matrixWorld).invert();
          bone.matrix.multiply(bone.matrixWorld);
        } else {
          bone.matrix.copy(bone.matrixWorld);
        }
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
      }
    }
  }
  update() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    const boneMatrices = this.boneMatrices;
    const boneTexture = this.boneTexture;
    for (let i = 0, il = bones.length; i < il; i++) {
      const matrix = bones[i] ? bones[i].matrixWorld : _identityMatrix;
      _offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
      _offsetMatrix.toArray(boneMatrices, i * 16);
    }
    if (boneTexture !== null) {
      boneTexture.needsUpdate = true;
    }
  }
  clone() {
    return new Skeleton(this.bones, this.boneInverses);
  }
  computeBoneTexture() {
    let size = Math.sqrt(this.bones.length * 4);
    size = ceilPowerOfTwo(size);
    size = Math.max(size, 4);
    const boneMatrices = new Float32Array(size * size * 4);
    boneMatrices.set(this.boneMatrices);
    const boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat$1, FloatType);
    this.boneMatrices = boneMatrices;
    this.boneTexture = boneTexture;
    this.boneTextureSize = size;
    return this;
  }
  getBoneByName(name) {
    for (let i = 0, il = this.bones.length; i < il; i++) {
      const bone = this.bones[i];
      if (bone.name === name) {
        return bone;
      }
    }
    return void 0;
  }
  dispose() {
    if (this.boneTexture !== null) {
      this.boneTexture.dispose();
      this.boneTexture = null;
    }
  }
  fromJSON(json, bones) {
    this.uuid = json.uuid;
    for (let i = 0, l = json.bones.length; i < l; i++) {
      const uuid = json.bones[i];
      let bone = bones[uuid];
      if (bone === void 0) {
        console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
        bone = new Bone();
      }
      this.bones.push(bone);
      this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i]));
    }
    this.init();
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.5,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    data.uuid = this.uuid;
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    for (let i = 0, l = bones.length; i < l; i++) {
      const bone = bones[i];
      data.bones.push(bone.uuid);
      const boneInverse = boneInverses[i];
      data.boneInverses.push(boneInverse.toArray());
    }
    return data;
  }
}
const _instanceLocalMatrix = /* @__PURE__ */ new Matrix4();
const _instanceWorldMatrix = /* @__PURE__ */ new Matrix4();
const _instanceIntersects = [];
const _mesh = /* @__PURE__ */ new Mesh();
class InstancedMesh extends Mesh {
  constructor(geometry, material, count) {
    super(geometry, material);
    this.instanceMatrix = new BufferAttribute(new Float32Array(count * 16), 16);
    this.instanceColor = null;
    this.count = count;
    this.frustumCulled = false;
  }
  copy(source) {
    super.copy(source);
    this.instanceMatrix.copy(source.instanceMatrix);
    if (source.instanceColor !== null)
      this.instanceColor = source.instanceColor.clone();
    this.count = source.count;
    return this;
  }
  getColorAt(index, color) {
    color.fromArray(this.instanceColor.array, index * 3);
  }
  getMatrixAt(index, matrix) {
    matrix.fromArray(this.instanceMatrix.array, index * 16);
  }
  raycast(raycaster, intersects2) {
    const matrixWorld = this.matrixWorld;
    const raycastTimes = this.count;
    _mesh.geometry = this.geometry;
    _mesh.material = this.material;
    if (_mesh.material === void 0)
      return;
    for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
      this.getMatrixAt(instanceId, _instanceLocalMatrix);
      _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
      _mesh.matrixWorld = _instanceWorldMatrix;
      _mesh.raycast(raycaster, _instanceIntersects);
      for (let i = 0, l = _instanceIntersects.length; i < l; i++) {
        const intersect = _instanceIntersects[i];
        intersect.instanceId = instanceId;
        intersect.object = this;
        intersects2.push(intersect);
      }
      _instanceIntersects.length = 0;
    }
  }
  setColorAt(index, color) {
    if (this.instanceColor === null) {
      this.instanceColor = new BufferAttribute(new Float32Array(this.count * 3), 3);
    }
    color.toArray(this.instanceColor.array, index * 3);
  }
  setMatrixAt(index, matrix) {
    matrix.toArray(this.instanceMatrix.array, index * 16);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
InstancedMesh.prototype.isInstancedMesh = true;
class LineBasicMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "LineBasicMaterial";
    this.color = new Color(16777215);
    this.linewidth = 1;
    this.linecap = "round";
    this.linejoin = "round";
    this.morphTargets = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    this.morphTargets = source.morphTargets;
    return this;
  }
}
LineBasicMaterial.prototype.isLineBasicMaterial = true;
const _start$1 = /* @__PURE__ */ new Vector3$1();
const _end$1 = /* @__PURE__ */ new Vector3$1();
const _inverseMatrix$1 = /* @__PURE__ */ new Matrix4();
const _ray$1 = /* @__PURE__ */ new Ray();
const _sphere$1 = /* @__PURE__ */ new Sphere();
class Line extends Object3D {
  constructor(geometry = new BufferGeometry(), material = new LineBasicMaterial()) {
    super();
    this.type = "Line";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      if (geometry.index === null) {
        const positionAttribute = geometry.attributes.position;
        const lineDistances = [0];
        for (let i = 1, l = positionAttribute.count; i < l; i++) {
          _start$1.fromBufferAttribute(positionAttribute, i - 1);
          _end$1.fromBufferAttribute(positionAttribute, i);
          lineDistances[i] = lineDistances[i - 1];
          lineDistances[i] += _start$1.distanceTo(_end$1);
        }
        geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
      } else {
        console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Line.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null)
      geometry.computeBoundingSphere();
    _sphere$1.copy(geometry.boundingSphere);
    _sphere$1.applyMatrix4(matrixWorld);
    _sphere$1.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$1) === false)
      return;
    _inverseMatrix$1.copy(matrixWorld).invert();
    _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const vStart = new Vector3$1();
    const vEnd = new Vector3$1();
    const interSegment = new Vector3$1();
    const interRay = new Vector3$1();
    const step = this.isLineSegments ? 2 : 1;
    if (geometry.isBufferGeometry) {
      const index = geometry.index;
      const attributes = geometry.attributes;
      const positionAttribute = attributes.position;
      if (index !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index.count, drawRange.start + drawRange.count);
        for (let i = start, l = end - 1; i < l; i += step) {
          const a = index.getX(i);
          const b = index.getX(i + 1);
          vStart.fromBufferAttribute(positionAttribute, a);
          vEnd.fromBufferAttribute(positionAttribute, b);
          const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
          if (distSq > localThresholdSq)
            continue;
          interRay.applyMatrix4(this.matrixWorld);
          const distance = raycaster.ray.origin.distanceTo(interRay);
          if (distance < raycaster.near || distance > raycaster.far)
            continue;
          intersects2.push({
            distance,
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i = start, l = end - 1; i < l; i += step) {
          vStart.fromBufferAttribute(positionAttribute, i);
          vEnd.fromBufferAttribute(positionAttribute, i + 1);
          const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
          if (distSq > localThresholdSq)
            continue;
          interRay.applyMatrix4(this.matrixWorld);
          const distance = raycaster.ray.origin.distanceTo(interRay);
          if (distance < raycaster.near || distance > raycaster.far)
            continue;
          intersects2.push({
            distance,
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    } else {
      const morphTargets = geometry.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
}
Line.prototype.isLine = true;
const _start = /* @__PURE__ */ new Vector3$1();
const _end = /* @__PURE__ */ new Vector3$1();
class LineSegments extends Line {
  constructor(geometry, material) {
    super(geometry, material);
    this.type = "LineSegments";
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      if (geometry.index === null) {
        const positionAttribute = geometry.attributes.position;
        const lineDistances = [];
        for (let i = 0, l = positionAttribute.count; i < l; i += 2) {
          _start.fromBufferAttribute(positionAttribute, i);
          _end.fromBufferAttribute(positionAttribute, i + 1);
          lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
          lineDistances[i + 1] = lineDistances[i] + _start.distanceTo(_end);
        }
        geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
      } else {
        console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    return this;
  }
}
LineSegments.prototype.isLineSegments = true;
class LineLoop extends Line {
  constructor(geometry, material) {
    super(geometry, material);
    this.type = "LineLoop";
  }
}
LineLoop.prototype.isLineLoop = true;
class PointsMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "PointsMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.morphTargets = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    this.morphTargets = source.morphTargets;
    return this;
  }
}
PointsMaterial.prototype.isPointsMaterial = true;
const _inverseMatrix = /* @__PURE__ */ new Matrix4();
const _ray = /* @__PURE__ */ new Ray();
const _sphere = /* @__PURE__ */ new Sphere();
const _position$2 = /* @__PURE__ */ new Vector3$1();
class Points extends Object3D {
  constructor(geometry = new BufferGeometry(), material = new PointsMaterial()) {
    super();
    this.type = "Points";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Points.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null)
      geometry.computeBoundingSphere();
    _sphere.copy(geometry.boundingSphere);
    _sphere.applyMatrix4(matrixWorld);
    _sphere.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere) === false)
      return;
    _inverseMatrix.copy(matrixWorld).invert();
    _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    if (geometry.isBufferGeometry) {
      const index = geometry.index;
      const attributes = geometry.attributes;
      const positionAttribute = attributes.position;
      if (index !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index.count, drawRange.start + drawRange.count);
        for (let i = start, il = end; i < il; i++) {
          const a = index.getX(i);
          _position$2.fromBufferAttribute(positionAttribute, a);
          testPoint(_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects2, this);
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i = start, l = end; i < l; i++) {
          _position$2.fromBufferAttribute(positionAttribute, i);
          testPoint(_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects2, this);
        }
      }
    } else {
      console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    } else {
      const morphTargets = geometry.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
}
Points.prototype.isPoints = true;
function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects2, object) {
  const rayPointDistanceSq = _ray.distanceSqToPoint(point);
  if (rayPointDistanceSq < localThresholdSq) {
    const intersectPoint = new Vector3$1();
    _ray.closestPointToPoint(point, intersectPoint);
    intersectPoint.applyMatrix4(matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(intersectPoint);
    if (distance < raycaster.near || distance > raycaster.far)
      return;
    intersects2.push({
      distance,
      distanceToRay: Math.sqrt(rayPointDistanceSq),
      point: intersectPoint,
      index,
      face: null,
      object
    });
  }
}
class VideoTexture extends Texture$1 {
  constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.format = format !== void 0 ? format : RGBFormat$1;
    this.minFilter = minFilter !== void 0 ? minFilter : LinearFilter$1;
    this.magFilter = magFilter !== void 0 ? magFilter : LinearFilter$1;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
      scope.needsUpdate = true;
      video.requestVideoFrameCallback(updateVideo);
    }
    if ("requestVideoFrameCallback" in video) {
      video.requestVideoFrameCallback(updateVideo);
    }
  }
  clone() {
    return new this.constructor(this.image).copy(this);
  }
  update() {
    const video = this.image;
    const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
    if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
      this.needsUpdate = true;
    }
  }
}
VideoTexture.prototype.isVideoTexture = true;
class CompressedTexture extends Texture$1 {
  constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = { width, height };
    this.mipmaps = mipmaps;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
CompressedTexture.prototype.isCompressedTexture = true;
class CanvasTexture extends Texture$1 {
  constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.needsUpdate = true;
  }
}
CanvasTexture.prototype.isCanvasTexture = true;
class DepthTexture extends Texture$1 {
  constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
    format = format !== void 0 ? format : DepthFormat;
    if (format !== DepthFormat && format !== DepthStencilFormat) {
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    }
    if (type === void 0 && format === DepthFormat)
      type = UnsignedShortType;
    if (type === void 0 && format === DepthStencilFormat)
      type = UnsignedInt248Type;
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.image = { width, height };
    this.magFilter = magFilter !== void 0 ? magFilter : NearestFilter;
    this.minFilter = minFilter !== void 0 ? minFilter : NearestFilter;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
DepthTexture.prototype.isDepthTexture = true;
class CylinderGeometry extends BufferGeometry {
  constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CylinderGeometry";
    this.parameters = {
      radiusTop,
      radiusBottom,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
    const scope = this;
    radialSegments = Math.floor(radialSegments);
    heightSegments = Math.floor(heightSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let index = 0;
    const indexArray = [];
    const halfHeight = height / 2;
    let groupStart = 0;
    generateTorso();
    if (openEnded === false) {
      if (radiusTop > 0)
        generateCap(true);
      if (radiusBottom > 0)
        generateCap(false);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function generateTorso() {
      const normal = new Vector3$1();
      const vertex = new Vector3$1();
      let groupCount = 0;
      const slope = (radiusBottom - radiusTop) / height;
      for (let y = 0; y <= heightSegments; y++) {
        const indexRow = [];
        const v = y / heightSegments;
        const radius = v * (radiusBottom - radiusTop) + radiusTop;
        for (let x = 0; x <= radialSegments; x++) {
          const u = x / radialSegments;
          const theta = u * thetaLength + thetaStart;
          const sinTheta = Math.sin(theta);
          const cosTheta = Math.cos(theta);
          vertex.x = radius * sinTheta;
          vertex.y = -v * height + halfHeight;
          vertex.z = radius * cosTheta;
          vertices.push(vertex.x, vertex.y, vertex.z);
          normal.set(sinTheta, slope, cosTheta).normalize();
          normals.push(normal.x, normal.y, normal.z);
          uvs.push(u, 1 - v);
          indexRow.push(index++);
        }
        indexArray.push(indexRow);
      }
      for (let x = 0; x < radialSegments; x++) {
        for (let y = 0; y < heightSegments; y++) {
          const a = indexArray[y][x];
          const b = indexArray[y + 1][x];
          const c = indexArray[y + 1][x + 1];
          const d = indexArray[y][x + 1];
          indices.push(a, b, d);
          indices.push(b, c, d);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, 0);
      groupStart += groupCount;
    }
    function generateCap(top) {
      const centerIndexStart = index;
      const uv = new Vector2$1();
      const vertex = new Vector3$1();
      let groupCount = 0;
      const radius = top === true ? radiusTop : radiusBottom;
      const sign2 = top === true ? 1 : -1;
      for (let x = 1; x <= radialSegments; x++) {
        vertices.push(0, halfHeight * sign2, 0);
        normals.push(0, sign2, 0);
        uvs.push(0.5, 0.5);
        index++;
      }
      const centerIndexEnd = index;
      for (let x = 0; x <= radialSegments; x++) {
        const u = x / radialSegments;
        const theta = u * thetaLength + thetaStart;
        const cosTheta = Math.cos(theta);
        const sinTheta = Math.sin(theta);
        vertex.x = radius * sinTheta;
        vertex.y = halfHeight * sign2;
        vertex.z = radius * cosTheta;
        vertices.push(vertex.x, vertex.y, vertex.z);
        normals.push(0, sign2, 0);
        uv.x = cosTheta * 0.5 + 0.5;
        uv.y = sinTheta * 0.5 * sign2 + 0.5;
        uvs.push(uv.x, uv.y);
        index++;
      }
      for (let x = 0; x < radialSegments; x++) {
        const c = centerIndexStart + x;
        const i = centerIndexEnd + x;
        if (top === true) {
          indices.push(i, i + 1, c);
        } else {
          indices.push(i + 1, i, c);
        }
        groupCount += 3;
      }
      scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
      groupStart += groupCount;
    }
  }
}
class PolyhedronGeometry extends BufferGeometry {
  constructor(vertices, indices, radius = 1, detail = 0) {
    super();
    this.type = "PolyhedronGeometry";
    this.parameters = {
      vertices,
      indices,
      radius,
      detail
    };
    const vertexBuffer = [];
    const uvBuffer = [];
    subdivide(detail);
    applyRadius(radius);
    generateUVs();
    this.setAttribute("position", new Float32BufferAttribute(vertexBuffer, 3));
    this.setAttribute("normal", new Float32BufferAttribute(vertexBuffer.slice(), 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvBuffer, 2));
    if (detail === 0) {
      this.computeVertexNormals();
    } else {
      this.normalizeNormals();
    }
    function subdivide(detail2) {
      const a = new Vector3$1();
      const b = new Vector3$1();
      const c = new Vector3$1();
      for (let i = 0; i < indices.length; i += 3) {
        getVertexByIndex(indices[i + 0], a);
        getVertexByIndex(indices[i + 1], b);
        getVertexByIndex(indices[i + 2], c);
        subdivideFace(a, b, c, detail2);
      }
    }
    function subdivideFace(a, b, c, detail2) {
      const cols = detail2 + 1;
      const v = [];
      for (let i = 0; i <= cols; i++) {
        v[i] = [];
        const aj = a.clone().lerp(c, i / cols);
        const bj = b.clone().lerp(c, i / cols);
        const rows = cols - i;
        for (let j = 0; j <= rows; j++) {
          if (j === 0 && i === cols) {
            v[i][j] = aj;
          } else {
            v[i][j] = aj.clone().lerp(bj, j / rows);
          }
        }
      }
      for (let i = 0; i < cols; i++) {
        for (let j = 0; j < 2 * (cols - i) - 1; j++) {
          const k = Math.floor(j / 2);
          if (j % 2 === 0) {
            pushVertex(v[i][k + 1]);
            pushVertex(v[i + 1][k]);
            pushVertex(v[i][k]);
          } else {
            pushVertex(v[i][k + 1]);
            pushVertex(v[i + 1][k + 1]);
            pushVertex(v[i + 1][k]);
          }
        }
      }
    }
    function applyRadius(radius2) {
      const vertex = new Vector3$1();
      for (let i = 0; i < vertexBuffer.length; i += 3) {
        vertex.x = vertexBuffer[i + 0];
        vertex.y = vertexBuffer[i + 1];
        vertex.z = vertexBuffer[i + 2];
        vertex.normalize().multiplyScalar(radius2);
        vertexBuffer[i + 0] = vertex.x;
        vertexBuffer[i + 1] = vertex.y;
        vertexBuffer[i + 2] = vertex.z;
      }
    }
    function generateUVs() {
      const vertex = new Vector3$1();
      for (let i = 0; i < vertexBuffer.length; i += 3) {
        vertex.x = vertexBuffer[i + 0];
        vertex.y = vertexBuffer[i + 1];
        vertex.z = vertexBuffer[i + 2];
        const u = azimuth(vertex) / 2 / Math.PI + 0.5;
        const v = inclination(vertex) / Math.PI + 0.5;
        uvBuffer.push(u, 1 - v);
      }
      correctUVs();
      correctSeam();
    }
    function correctSeam() {
      for (let i = 0; i < uvBuffer.length; i += 6) {
        const x0 = uvBuffer[i + 0];
        const x1 = uvBuffer[i + 2];
        const x2 = uvBuffer[i + 4];
        const max = Math.max(x0, x1, x2);
        const min = Math.min(x0, x1, x2);
        if (max > 0.9 && min < 0.1) {
          if (x0 < 0.2)
            uvBuffer[i + 0] += 1;
          if (x1 < 0.2)
            uvBuffer[i + 2] += 1;
          if (x2 < 0.2)
            uvBuffer[i + 4] += 1;
        }
      }
    }
    function pushVertex(vertex) {
      vertexBuffer.push(vertex.x, vertex.y, vertex.z);
    }
    function getVertexByIndex(index, vertex) {
      const stride = index * 3;
      vertex.x = vertices[stride + 0];
      vertex.y = vertices[stride + 1];
      vertex.z = vertices[stride + 2];
    }
    function correctUVs() {
      const a = new Vector3$1();
      const b = new Vector3$1();
      const c = new Vector3$1();
      const centroid = new Vector3$1();
      const uvA = new Vector2$1();
      const uvB = new Vector2$1();
      const uvC = new Vector2$1();
      for (let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6) {
        a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
        b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
        c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
        uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
        uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
        uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
        centroid.copy(a).add(b).add(c).divideScalar(3);
        const azi = azimuth(centroid);
        correctUV(uvA, j + 0, a, azi);
        correctUV(uvB, j + 2, b, azi);
        correctUV(uvC, j + 4, c, azi);
      }
    }
    function correctUV(uv, stride, vector, azimuth2) {
      if (azimuth2 < 0 && uv.x === 1) {
        uvBuffer[stride] = uv.x - 1;
      }
      if (vector.x === 0 && vector.z === 0) {
        uvBuffer[stride] = azimuth2 / 2 / Math.PI + 0.5;
      }
    }
    function azimuth(vector) {
      return Math.atan2(vector.z, -vector.x);
    }
    function inclination(vector) {
      return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
    }
  }
}
new Vector3$1();
new Vector3$1();
new Vector3$1();
new Triangle();
const Earcut = {
  triangulate: function(data, holeIndices, dim) {
    dim = dim || 2;
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev)
      return triangles;
    let minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles)
      outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    if (data.length > 80 * dim) {
      minX = maxX = data[0];
      minY = maxY = data[1];
      for (let i = dim; i < outerLen; i += dim) {
        x = data[i];
        y = data[i + 1];
        if (x < minX)
          minX = x;
        if (y < minY)
          minY = y;
        if (x > maxX)
          maxX = x;
        if (y > maxY)
          maxY = y;
      }
      invSize = Math.max(maxX - minX, maxY - minY);
      invSize = invSize !== 0 ? 1 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
    return triangles;
  }
};
function linkedList(data, start, end, dim, clockwise) {
  let i, last;
  if (clockwise === signedArea(data, start, end, dim) > 0) {
    for (i = start; i < end; i += dim)
      last = insertNode(i, data[i], data[i + 1], last);
  } else {
    for (i = end - dim; i >= start; i -= dim)
      last = insertNode(i, data[i], data[i + 1], last);
  }
  if (last && equals(last, last.next)) {
    removeNode(last);
    last = last.next;
  }
  return last;
}
function filterPoints(start, end) {
  if (!start)
    return start;
  if (!end)
    end = start;
  let p = start, again;
  do {
    again = false;
    if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
      removeNode(p);
      p = end = p.prev;
      if (p === p.next)
        break;
      again = true;
    } else {
      p = p.next;
    }
  } while (again || p !== end);
  return end;
}
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
  if (!ear)
    return;
  if (!pass && invSize)
    indexCurve(ear, minX, minY, invSize);
  let stop = ear, prev, next2;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next2 = ear.next;
    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
      triangles.push(prev.i / dim);
      triangles.push(ear.i / dim);
      triangles.push(next2.i / dim);
      removeNode(ear);
      ear = next2.next;
      stop = next2.next;
      continue;
    }
    ear = next2;
    if (ear === stop) {
      if (!pass) {
        earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
      } else if (pass === 1) {
        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
        earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
      } else if (pass === 2) {
        splitEarcut(ear, triangles, dim, minX, minY, invSize);
      }
      break;
    }
  }
}
function isEar(ear) {
  const a = ear.prev, b = ear, c = ear.next;
  if (area(a, b, c) >= 0)
    return false;
  let p = ear.next.next;
  while (p !== ear.prev) {
    if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0)
      return false;
    p = p.next;
  }
  return true;
}
function isEarHashed(ear, minX, minY, invSize) {
  const a = ear.prev, b = ear, c = ear.next;
  if (area(a, b, c) >= 0)
    return false;
  const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
  const minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
  let p = ear.prevZ, n = ear.nextZ;
  while (p && p.z >= minZ && n && n.z <= maxZ) {
    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0)
      return false;
    p = p.prevZ;
    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0)
      return false;
    n = n.nextZ;
  }
  while (p && p.z >= minZ) {
    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0)
      return false;
    p = p.prevZ;
  }
  while (n && n.z <= maxZ) {
    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0)
      return false;
    n = n.nextZ;
  }
  return true;
}
function cureLocalIntersections(start, triangles, dim) {
  let p = start;
  do {
    const a = p.prev, b = p.next.next;
    if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
      triangles.push(a.i / dim);
      triangles.push(p.i / dim);
      triangles.push(b.i / dim);
      removeNode(p);
      removeNode(p.next);
      p = start = b;
    }
    p = p.next;
  } while (p !== start);
  return filterPoints(p);
}
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
  let a = start;
  do {
    let b = a.next.next;
    while (b !== a.prev) {
      if (a.i !== b.i && isValidDiagonal(a, b)) {
        let c = splitPolygon(a, b);
        a = filterPoints(a, a.next);
        c = filterPoints(c, c.next);
        earcutLinked(a, triangles, dim, minX, minY, invSize);
        earcutLinked(c, triangles, dim, minX, minY, invSize);
        return;
      }
      b = b.next;
    }
    a = a.next;
  } while (a !== start);
}
function eliminateHoles(data, holeIndices, outerNode, dim) {
  const queue = [];
  let i, len, start, end, list;
  for (i = 0, len = holeIndices.length; i < len; i++) {
    start = holeIndices[i] * dim;
    end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
    list = linkedList(data, start, end, dim, false);
    if (list === list.next)
      list.steiner = true;
    queue.push(getLeftmost(list));
  }
  queue.sort(compareX);
  for (i = 0; i < queue.length; i++) {
    eliminateHole(queue[i], outerNode);
    outerNode = filterPoints(outerNode, outerNode.next);
  }
  return outerNode;
}
function compareX(a, b) {
  return a.x - b.x;
}
function eliminateHole(hole, outerNode) {
  outerNode = findHoleBridge(hole, outerNode);
  if (outerNode) {
    const b = splitPolygon(outerNode, hole);
    filterPoints(outerNode, outerNode.next);
    filterPoints(b, b.next);
  }
}
function findHoleBridge(hole, outerNode) {
  let p = outerNode;
  const hx = hole.x;
  const hy = hole.y;
  let qx = -Infinity, m;
  do {
    if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
      const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
      if (x <= hx && x > qx) {
        qx = x;
        if (x === hx) {
          if (hy === p.y)
            return p;
          if (hy === p.next.y)
            return p.next;
        }
        m = p.x < p.next.x ? p : p.next;
      }
    }
    p = p.next;
  } while (p !== outerNode);
  if (!m)
    return null;
  if (hx === qx)
    return m;
  const stop = m, mx = m.x, my = m.y;
  let tanMin = Infinity, tan;
  p = m;
  do {
    if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
      tan = Math.abs(hy - p.y) / (hx - p.x);
      if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
        m = p;
        tanMin = tan;
      }
    }
    p = p.next;
  } while (p !== stop);
  return m;
}
function sectorContainsSector(m, p) {
  return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
function indexCurve(start, minX, minY, invSize) {
  let p = start;
  do {
    if (p.z === null)
      p.z = zOrder(p.x, p.y, minX, minY, invSize);
    p.prevZ = p.prev;
    p.nextZ = p.next;
    p = p.next;
  } while (p !== start);
  p.prevZ.nextZ = null;
  p.prevZ = null;
  sortLinked(p);
}
function sortLinked(list) {
  let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p = list;
    list = null;
    tail = null;
    numMerges = 0;
    while (p) {
      numMerges++;
      q = p;
      pSize = 0;
      for (i = 0; i < inSize; i++) {
        pSize++;
        q = q.nextZ;
        if (!q)
          break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q) {
        if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
          e = p;
          p = p.nextZ;
          pSize--;
        } else {
          e = q;
          q = q.nextZ;
          qSize--;
        }
        if (tail)
          tail.nextZ = e;
        else
          list = e;
        e.prevZ = tail;
        tail = e;
      }
      p = q;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list;
}
function zOrder(x, y, minX, minY, invSize) {
  x = 32767 * (x - minX) * invSize;
  y = 32767 * (y - minY) * invSize;
  x = (x | x << 8) & 16711935;
  x = (x | x << 4) & 252645135;
  x = (x | x << 2) & 858993459;
  x = (x | x << 1) & 1431655765;
  y = (y | y << 8) & 16711935;
  y = (y | y << 4) & 252645135;
  y = (y | y << 2) & 858993459;
  y = (y | y << 1) & 1431655765;
  return x | y << 1;
}
function getLeftmost(start) {
  let p = start, leftmost = start;
  do {
    if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y)
      leftmost = p;
    p = p.next;
  } while (p !== start);
  return leftmost;
}
function pointInTriangle(ax, ay, bx, by, cx, cy, px2, py2) {
  return (cx - px2) * (ay - py2) - (ax - px2) * (cy - py2) >= 0 && (ax - px2) * (by - py2) - (bx - px2) * (ay - py2) >= 0 && (bx - px2) * (cy - py2) - (cx - px2) * (by - py2) >= 0;
}
function isValidDiagonal(a, b) {
  return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && (area(a.prev, a, b.prev) || area(a, b.prev, b)) || equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0);
}
function area(p, q, r) {
  return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
function equals(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects(p1, q1, p2, q2) {
  const o1 = sign(area(p1, q1, p2));
  const o2 = sign(area(p1, q1, q2));
  const o3 = sign(area(p2, q2, p1));
  const o4 = sign(area(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4)
    return true;
  if (o1 === 0 && onSegment(p1, p2, q1))
    return true;
  if (o2 === 0 && onSegment(p1, q2, q1))
    return true;
  if (o3 === 0 && onSegment(p2, p1, q2))
    return true;
  if (o4 === 0 && onSegment(p2, q1, q2))
    return true;
  return false;
}
function onSegment(p, q, r) {
  return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon(a, b) {
  let p = a;
  do {
    if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b))
      return true;
    p = p.next;
  } while (p !== a);
  return false;
}
function locallyInside(a, b) {
  return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
function middleInside(a, b) {
  let p = a, inside = false;
  const px2 = (a.x + b.x) / 2, py2 = (a.y + b.y) / 2;
  do {
    if (p.y > py2 !== p.next.y > py2 && p.next.y !== p.y && px2 < (p.next.x - p.x) * (py2 - p.y) / (p.next.y - p.y) + p.x)
      inside = !inside;
    p = p.next;
  } while (p !== a);
  return inside;
}
function splitPolygon(a, b) {
  const a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
  a.next = b;
  b.prev = a;
  a2.next = an;
  an.prev = a2;
  b2.next = a2;
  a2.prev = b2;
  bp.next = b2;
  b2.prev = bp;
  return b2;
}
function insertNode(i, x, y, last) {
  const p = new Node(i, x, y);
  if (!last) {
    p.prev = p;
    p.next = p;
  } else {
    p.next = last.next;
    p.prev = last;
    last.next.prev = p;
    last.next = p;
  }
  return p;
}
function removeNode(p) {
  p.next.prev = p.prev;
  p.prev.next = p.next;
  if (p.prevZ)
    p.prevZ.nextZ = p.nextZ;
  if (p.nextZ)
    p.nextZ.prevZ = p.prevZ;
}
function Node(i, x, y) {
  this.i = i;
  this.x = x;
  this.y = y;
  this.prev = null;
  this.next = null;
  this.z = null;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
function signedArea(data, start, end, dim) {
  let sum = 0;
  for (let i = start, j = end - dim; i < end; i += dim) {
    sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
    j = i;
  }
  return sum;
}
class ShapeUtils {
  static area(contour) {
    const n = contour.length;
    let a = 0;
    for (let p = n - 1, q = 0; q < n; p = q++) {
      a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
    }
    return a * 0.5;
  }
  static isClockWise(pts) {
    return ShapeUtils.area(pts) < 0;
  }
  static triangulateShape(contour, holes) {
    const vertices = [];
    const holeIndices = [];
    const faces = [];
    removeDupEndPts(contour);
    addContour(vertices, contour);
    let holeIndex = contour.length;
    holes.forEach(removeDupEndPts);
    for (let i = 0; i < holes.length; i++) {
      holeIndices.push(holeIndex);
      holeIndex += holes[i].length;
      addContour(vertices, holes[i]);
    }
    const triangles = Earcut.triangulate(vertices, holeIndices);
    for (let i = 0; i < triangles.length; i += 3) {
      faces.push(triangles.slice(i, i + 3));
    }
    return faces;
  }
}
function removeDupEndPts(points) {
  const l = points.length;
  if (l > 2 && points[l - 1].equals(points[0])) {
    points.pop();
  }
}
function addContour(vertices, contour) {
  for (let i = 0; i < contour.length; i++) {
    vertices.push(contour[i].x);
    vertices.push(contour[i].y);
  }
}
class ExtrudeGeometry extends BufferGeometry {
  constructor(shapes, options) {
    super();
    this.type = "ExtrudeGeometry";
    this.parameters = {
      shapes,
      options
    };
    shapes = Array.isArray(shapes) ? shapes : [shapes];
    const scope = this;
    const verticesArray = [];
    const uvArray = [];
    for (let i = 0, l = shapes.length; i < l; i++) {
      const shape = shapes[i];
      addShape(shape);
    }
    this.setAttribute("position", new Float32BufferAttribute(verticesArray, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvArray, 2));
    this.computeVertexNormals();
    function addShape(shape) {
      const placeholder = [];
      const curveSegments = options.curveSegments !== void 0 ? options.curveSegments : 12;
      const steps = options.steps !== void 0 ? options.steps : 1;
      let depth = options.depth !== void 0 ? options.depth : 100;
      let bevelEnabled = options.bevelEnabled !== void 0 ? options.bevelEnabled : true;
      let bevelThickness = options.bevelThickness !== void 0 ? options.bevelThickness : 6;
      let bevelSize = options.bevelSize !== void 0 ? options.bevelSize : bevelThickness - 2;
      let bevelOffset = options.bevelOffset !== void 0 ? options.bevelOffset : 0;
      let bevelSegments = options.bevelSegments !== void 0 ? options.bevelSegments : 3;
      const extrudePath = options.extrudePath;
      const uvgen = options.UVGenerator !== void 0 ? options.UVGenerator : WorldUVGenerator;
      if (options.amount !== void 0) {
        console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
        depth = options.amount;
      }
      let extrudePts, extrudeByPath = false;
      let splineTube, binormal, normal, position2;
      if (extrudePath) {
        extrudePts = extrudePath.getSpacedPoints(steps);
        extrudeByPath = true;
        bevelEnabled = false;
        splineTube = extrudePath.computeFrenetFrames(steps, false);
        binormal = new Vector3$1();
        normal = new Vector3$1();
        position2 = new Vector3$1();
      }
      if (!bevelEnabled) {
        bevelSegments = 0;
        bevelThickness = 0;
        bevelSize = 0;
        bevelOffset = 0;
      }
      const shapePoints = shape.extractPoints(curveSegments);
      let vertices = shapePoints.shape;
      const holes = shapePoints.holes;
      const reverse = !ShapeUtils.isClockWise(vertices);
      if (reverse) {
        vertices = vertices.reverse();
        for (let h = 0, hl = holes.length; h < hl; h++) {
          const ahole = holes[h];
          if (ShapeUtils.isClockWise(ahole)) {
            holes[h] = ahole.reverse();
          }
        }
      }
      const faces = ShapeUtils.triangulateShape(vertices, holes);
      const contour = vertices;
      for (let h = 0, hl = holes.length; h < hl; h++) {
        const ahole = holes[h];
        vertices = vertices.concat(ahole);
      }
      function scalePt2(pt, vec, size) {
        if (!vec)
          console.error("THREE.ExtrudeGeometry: vec does not exist");
        return vec.clone().multiplyScalar(size).add(pt);
      }
      const vlen = vertices.length, flen = faces.length;
      function getBevelVec(inPt, inPrev, inNext) {
        let v_trans_x, v_trans_y, shrink_by;
        const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
        const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
        const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
        const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
        if (Math.abs(collinear0) > Number.EPSILON) {
          const v_prev_len = Math.sqrt(v_prev_lensq);
          const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
          const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
          const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
          const ptNextShift_x = inNext.x - v_next_y / v_next_len;
          const ptNextShift_y = inNext.y + v_next_x / v_next_len;
          const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
          v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
          v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
          const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
          if (v_trans_lensq <= 2) {
            return new Vector2$1(v_trans_x, v_trans_y);
          } else {
            shrink_by = Math.sqrt(v_trans_lensq / 2);
          }
        } else {
          let direction_eq = false;
          if (v_prev_x > Number.EPSILON) {
            if (v_next_x > Number.EPSILON) {
              direction_eq = true;
            }
          } else {
            if (v_prev_x < -Number.EPSILON) {
              if (v_next_x < -Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                direction_eq = true;
              }
            }
          }
          if (direction_eq) {
            v_trans_x = -v_prev_y;
            v_trans_y = v_prev_x;
            shrink_by = Math.sqrt(v_prev_lensq);
          } else {
            v_trans_x = v_prev_x;
            v_trans_y = v_prev_y;
            shrink_by = Math.sqrt(v_prev_lensq / 2);
          }
        }
        return new Vector2$1(v_trans_x / shrink_by, v_trans_y / shrink_by);
      }
      const contourMovements = [];
      for (let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++) {
        if (j === il)
          j = 0;
        if (k === il)
          k = 0;
        contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
      }
      const holesMovements = [];
      let oneHoleMovements, verticesMovements = contourMovements.concat();
      for (let h = 0, hl = holes.length; h < hl; h++) {
        const ahole = holes[h];
        oneHoleMovements = [];
        for (let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++) {
          if (j === il)
            j = 0;
          if (k === il)
            k = 0;
          oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
        }
        holesMovements.push(oneHoleMovements);
        verticesMovements = verticesMovements.concat(oneHoleMovements);
      }
      for (let b = 0; b < bevelSegments; b++) {
        const t = b / bevelSegments;
        const z = bevelThickness * Math.cos(t * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
        for (let i = 0, il = contour.length; i < il; i++) {
          const vert = scalePt2(contour[i], contourMovements[i], bs2);
          v(vert.x, vert.y, -z);
        }
        for (let h = 0, hl = holes.length; h < hl; h++) {
          const ahole = holes[h];
          oneHoleMovements = holesMovements[h];
          for (let i = 0, il = ahole.length; i < il; i++) {
            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs2);
            v(vert.x, vert.y, -z);
          }
        }
      }
      const bs = bevelSize + bevelOffset;
      for (let i = 0; i < vlen; i++) {
        const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
        if (!extrudeByPath) {
          v(vert.x, vert.y, 0);
        } else {
          normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
          binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
          position2.copy(extrudePts[0]).add(normal).add(binormal);
          v(position2.x, position2.y, position2.z);
        }
      }
      for (let s = 1; s <= steps; s++) {
        for (let i = 0; i < vlen; i++) {
          const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
          if (!extrudeByPath) {
            v(vert.x, vert.y, depth / steps * s);
          } else {
            normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
            binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
            position2.copy(extrudePts[s]).add(normal).add(binormal);
            v(position2.x, position2.y, position2.z);
          }
        }
      }
      for (let b = bevelSegments - 1; b >= 0; b--) {
        const t = b / bevelSegments;
        const z = bevelThickness * Math.cos(t * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
        for (let i = 0, il = contour.length; i < il; i++) {
          const vert = scalePt2(contour[i], contourMovements[i], bs2);
          v(vert.x, vert.y, depth + z);
        }
        for (let h = 0, hl = holes.length; h < hl; h++) {
          const ahole = holes[h];
          oneHoleMovements = holesMovements[h];
          for (let i = 0, il = ahole.length; i < il; i++) {
            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs2);
            if (!extrudeByPath) {
              v(vert.x, vert.y, depth + z);
            } else {
              v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
            }
          }
        }
      }
      buildLidFaces();
      buildSideFaces();
      function buildLidFaces() {
        const start = verticesArray.length / 3;
        if (bevelEnabled) {
          let layer = 0;
          let offset = vlen * layer;
          for (let i = 0; i < flen; i++) {
            const face = faces[i];
            f3(face[2] + offset, face[1] + offset, face[0] + offset);
          }
          layer = steps + bevelSegments * 2;
          offset = vlen * layer;
          for (let i = 0; i < flen; i++) {
            const face = faces[i];
            f3(face[0] + offset, face[1] + offset, face[2] + offset);
          }
        } else {
          for (let i = 0; i < flen; i++) {
            const face = faces[i];
            f3(face[2], face[1], face[0]);
          }
          for (let i = 0; i < flen; i++) {
            const face = faces[i];
            f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
          }
        }
        scope.addGroup(start, verticesArray.length / 3 - start, 0);
      }
      function buildSideFaces() {
        const start = verticesArray.length / 3;
        let layeroffset = 0;
        sidewalls(contour, layeroffset);
        layeroffset += contour.length;
        for (let h = 0, hl = holes.length; h < hl; h++) {
          const ahole = holes[h];
          sidewalls(ahole, layeroffset);
          layeroffset += ahole.length;
        }
        scope.addGroup(start, verticesArray.length / 3 - start, 1);
      }
      function sidewalls(contour2, layeroffset) {
        let i = contour2.length;
        while (--i >= 0) {
          const j = i;
          let k = i - 1;
          if (k < 0)
            k = contour2.length - 1;
          for (let s = 0, sl = steps + bevelSegments * 2; s < sl; s++) {
            const slen1 = vlen * s;
            const slen2 = vlen * (s + 1);
            const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
            f4(a, b, c, d);
          }
        }
      }
      function v(x, y, z) {
        placeholder.push(x);
        placeholder.push(y);
        placeholder.push(z);
      }
      function f3(a, b, c) {
        addVertex(a);
        addVertex(b);
        addVertex(c);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[2]);
      }
      function f4(a, b, c, d) {
        addVertex(a);
        addVertex(b);
        addVertex(d);
        addVertex(b);
        addVertex(c);
        addVertex(d);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[3]);
        addUV(uvs[1]);
        addUV(uvs[2]);
        addUV(uvs[3]);
      }
      function addVertex(index) {
        verticesArray.push(placeholder[index * 3 + 0]);
        verticesArray.push(placeholder[index * 3 + 1]);
        verticesArray.push(placeholder[index * 3 + 2]);
      }
      function addUV(vector2) {
        uvArray.push(vector2.x);
        uvArray.push(vector2.y);
      }
    }
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    const options = this.parameters.options;
    return toJSON$1(shapes, options, data);
  }
}
const WorldUVGenerator = {
  generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    return [
      new Vector2$1(a_x, a_y),
      new Vector2$1(b_x, b_y),
      new Vector2$1(c_x, c_y)
    ];
  },
  generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const a_z = vertices[indexA * 3 + 2];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const b_z = vertices[indexB * 3 + 2];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    const c_z = vertices[indexC * 3 + 2];
    const d_x = vertices[indexD * 3];
    const d_y = vertices[indexD * 3 + 1];
    const d_z = vertices[indexD * 3 + 2];
    if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
      return [
        new Vector2$1(a_x, 1 - a_z),
        new Vector2$1(b_x, 1 - b_z),
        new Vector2$1(c_x, 1 - c_z),
        new Vector2$1(d_x, 1 - d_z)
      ];
    } else {
      return [
        new Vector2$1(a_y, 1 - a_z),
        new Vector2$1(b_y, 1 - b_z),
        new Vector2$1(c_y, 1 - c_z),
        new Vector2$1(d_y, 1 - d_z)
      ];
    }
  }
};
function toJSON$1(shapes, options, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i = 0, l = shapes.length; i < l; i++) {
      const shape = shapes[i];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  if (options.extrudePath !== void 0)
    data.options.extrudePath = options.extrudePath.toJSON();
  return data;
}
class OctahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1
    ];
    const indices = [
      0,
      2,
      4,
      0,
      4,
      3,
      0,
      3,
      5,
      0,
      5,
      2,
      1,
      2,
      5,
      1,
      5,
      3,
      1,
      3,
      4,
      1,
      4,
      2
    ];
    super(vertices, indices, radius, detail);
    this.type = "OctahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
}
class ShapeGeometry extends BufferGeometry {
  constructor(shapes, curveSegments = 12) {
    super();
    this.type = "ShapeGeometry";
    this.parameters = {
      shapes,
      curveSegments
    };
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let groupStart = 0;
    let groupCount = 0;
    if (Array.isArray(shapes) === false) {
      addShape(shapes);
    } else {
      for (let i = 0; i < shapes.length; i++) {
        addShape(shapes[i]);
        this.addGroup(groupStart, groupCount, i);
        groupStart += groupCount;
        groupCount = 0;
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function addShape(shape) {
      const indexOffset = vertices.length / 3;
      const points = shape.extractPoints(curveSegments);
      let shapeVertices = points.shape;
      const shapeHoles = points.holes;
      if (ShapeUtils.isClockWise(shapeVertices) === false) {
        shapeVertices = shapeVertices.reverse();
      }
      for (let i = 0, l = shapeHoles.length; i < l; i++) {
        const shapeHole = shapeHoles[i];
        if (ShapeUtils.isClockWise(shapeHole) === true) {
          shapeHoles[i] = shapeHole.reverse();
        }
      }
      const faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);
      for (let i = 0, l = shapeHoles.length; i < l; i++) {
        const shapeHole = shapeHoles[i];
        shapeVertices = shapeVertices.concat(shapeHole);
      }
      for (let i = 0, l = shapeVertices.length; i < l; i++) {
        const vertex = shapeVertices[i];
        vertices.push(vertex.x, vertex.y, 0);
        normals.push(0, 0, 1);
        uvs.push(vertex.x, vertex.y);
      }
      for (let i = 0, l = faces.length; i < l; i++) {
        const face = faces[i];
        const a = face[0] + indexOffset;
        const b = face[1] + indexOffset;
        const c = face[2] + indexOffset;
        indices.push(a, b, c);
        groupCount += 3;
      }
    }
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    return toJSON(shapes, data);
  }
}
function toJSON(shapes, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i = 0, l = shapes.length; i < l; i++) {
      const shape = shapes[i];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  return data;
}
class SphereGeometry extends BufferGeometry {
  constructor(radius = 1, widthSegments = 8, heightSegments = 6, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI) {
    super();
    this.type = "SphereGeometry";
    this.parameters = {
      radius,
      widthSegments,
      heightSegments,
      phiStart,
      phiLength,
      thetaStart,
      thetaLength
    };
    widthSegments = Math.max(3, Math.floor(widthSegments));
    heightSegments = Math.max(2, Math.floor(heightSegments));
    const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
    let index = 0;
    const grid = [];
    const vertex = new Vector3$1();
    const normal = new Vector3$1();
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy <= heightSegments; iy++) {
      const verticesRow = [];
      const v = iy / heightSegments;
      let uOffset = 0;
      if (iy == 0 && thetaStart == 0) {
        uOffset = 0.5 / widthSegments;
      } else if (iy == heightSegments && thetaEnd == Math.PI) {
        uOffset = -0.5 / widthSegments;
      }
      for (let ix = 0; ix <= widthSegments; ix++) {
        const u = ix / widthSegments;
        vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
        vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
        vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
        vertices.push(vertex.x, vertex.y, vertex.z);
        normal.copy(vertex).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(u + uOffset, 1 - v);
        verticesRow.push(index++);
      }
      grid.push(verticesRow);
    }
    for (let iy = 0; iy < heightSegments; iy++) {
      for (let ix = 0; ix < widthSegments; ix++) {
        const a = grid[iy][ix + 1];
        const b = grid[iy][ix];
        const c = grid[iy + 1][ix];
        const d = grid[iy + 1][ix + 1];
        if (iy !== 0 || thetaStart > 0)
          indices.push(a, b, d);
        if (iy !== heightSegments - 1 || thetaEnd < Math.PI)
          indices.push(b, c, d);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
}
class TorusGeometry extends BufferGeometry {
  constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2) {
    super();
    this.type = "TorusGeometry";
    this.parameters = {
      radius,
      tube,
      radialSegments,
      tubularSegments,
      arc
    };
    radialSegments = Math.floor(radialSegments);
    tubularSegments = Math.floor(tubularSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const center = new Vector3$1();
    const vertex = new Vector3$1();
    const normal = new Vector3$1();
    for (let j = 0; j <= radialSegments; j++) {
      for (let i = 0; i <= tubularSegments; i++) {
        const u = i / tubularSegments * arc;
        const v = j / radialSegments * Math.PI * 2;
        vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
        vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
        vertex.z = tube * Math.sin(v);
        vertices.push(vertex.x, vertex.y, vertex.z);
        center.x = radius * Math.cos(u);
        center.y = radius * Math.sin(u);
        normal.subVectors(vertex, center).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i / tubularSegments);
        uvs.push(j / radialSegments);
      }
    }
    for (let j = 1; j <= radialSegments; j++) {
      for (let i = 1; i <= tubularSegments; i++) {
        const a = (tubularSegments + 1) * j + i - 1;
        const b = (tubularSegments + 1) * (j - 1) + i - 1;
        const c = (tubularSegments + 1) * (j - 1) + i;
        const d = (tubularSegments + 1) * j + i;
        indices.push(a, b, d);
        indices.push(b, c, d);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
}
class ShadowMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "ShadowMaterial";
    this.color = new Color(0);
    this.transparent = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    return this;
  }
}
ShadowMaterial.prototype.isShadowMaterial = true;
class RawShaderMaterial extends ShaderMaterial {
  constructor(parameters) {
    super(parameters);
    this.type = "RawShaderMaterial";
  }
}
RawShaderMaterial.prototype.isRawShaderMaterial = true;
class MeshStandardMaterial extends Material {
  constructor(parameters) {
    super();
    this.defines = { "STANDARD": "" };
    this.type = "MeshStandardMaterial";
    this.color = new Color(16777215);
    this.roughness = 1;
    this.metalness = 0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapIntensity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.morphTargets = false;
    this.morphNormals = false;
    this.flatShading = false;
    this.vertexTangents = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "STANDARD": "" };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapIntensity = source.envMapIntensity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.flatShading = source.flatShading;
    this.vertexTangents = source.vertexTangents;
    return this;
  }
}
MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
class MeshPhysicalMaterial extends MeshStandardMaterial {
  constructor(parameters) {
    super();
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.type = "MeshPhysicalMaterial";
    this.clearcoat = 0;
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector2$1(1, 1);
    this.clearcoatNormalMap = null;
    this.reflectivity = 0.5;
    Object.defineProperty(this, "ior", {
      get: function() {
        return (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity);
      },
      set: function(ior) {
        this.reflectivity = clamp$1(2.5 * (ior - 1) / (ior + 1), 0, 1);
      }
    });
    this.sheen = null;
    this.transmission = 0;
    this.transmissionMap = null;
    this.thickness = 0.01;
    this.thicknessMap = null;
    this.attenuationDistance = 0;
    this.attenuationColor = new Color(1, 1, 1);
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.reflectivity = source.reflectivity;
    if (source.sheen) {
      this.sheen = (this.sheen || new Color()).copy(source.sheen);
    } else {
      this.sheen = null;
    }
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    this.thickness = source.thickness;
    this.thicknessMap = source.thicknessMap;
    this.attenuationDistance = source.attenuationDistance;
    this.attenuationColor.copy(source.attenuationColor);
    return this;
  }
}
MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
class MeshPhongMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "MeshPhongMaterial";
    this.color = new Color(16777215);
    this.specular = new Color(1118481);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.morphTargets = false;
    this.morphNormals = false;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
class MeshToonMaterial extends Material {
  constructor(parameters) {
    super();
    this.defines = { "TOON": "" };
    this.type = "MeshToonMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
  }
}
MeshToonMaterial.prototype.isMeshToonMaterial = true;
class MeshNormalMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "MeshNormalMaterial";
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
class MeshLambertMaterial extends Material {
  constructor(parameters) {
    super();
    this.type = "MeshLambertMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
  }
}
MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
class MeshMatcapMaterial extends Material {
  constructor(parameters) {
    super();
    this.defines = { "MATCAP": "" };
    this.type = "MeshMatcapMaterial";
    this.color = new Color(16777215);
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.morphTargets = false;
    this.morphNormals = false;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "MATCAP": "" };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshMatcapMaterial.prototype.isMeshMatcapMaterial = true;
class LineDashedMaterial extends LineBasicMaterial {
  constructor(parameters) {
    super();
    this.type = "LineDashedMaterial";
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
  }
}
LineDashedMaterial.prototype.isLineDashedMaterial = true;
const AnimationUtils = {
  arraySlice: function(array, from, to) {
    if (AnimationUtils.isTypedArray(array)) {
      return new array.constructor(array.subarray(from, to !== void 0 ? to : array.length));
    }
    return array.slice(from, to);
  },
  convertArray: function(array, type, forceClone) {
    if (!array || !forceClone && array.constructor === type)
      return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") {
      return new type(array);
    }
    return Array.prototype.slice.call(array);
  },
  isTypedArray: function(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
  },
  getKeyframeOrder: function(times) {
    function compareTime(i, j) {
      return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for (let i = 0; i !== n; ++i)
      result[i] = i;
    result.sort(compareTime);
    return result;
  },
  sortedArray: function(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for (let i = 0, dstOffset = 0; dstOffset !== nValues; ++i) {
      const srcOffset = order[i] * stride;
      for (let j = 0; j !== stride; ++j) {
        result[dstOffset++] = values[srcOffset + j];
      }
    }
    return result;
  },
  flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while (key !== void 0 && key[valuePropertyName] === void 0) {
      key = jsonKeys[i++];
    }
    if (key === void 0)
      return;
    let value = key[valuePropertyName];
    if (value === void 0)
      return;
    if (Array.isArray(value)) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          values.push.apply(values, value);
        }
        key = jsonKeys[i++];
      } while (key !== void 0);
    } else if (value.toArray !== void 0) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
      } while (key !== void 0);
    } else {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          values.push(value);
        }
        key = jsonKeys[i++];
      } while (key !== void 0);
    }
  },
  subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for (let i = 0; i < clip.tracks.length; ++i) {
      const track = clip.tracks[i];
      const valueSize = track.getValueSize();
      const times = [];
      const values = [];
      for (let j = 0; j < track.times.length; ++j) {
        const frame = track.times[j] * fps;
        if (frame < startFrame || frame >= endFrame)
          continue;
        times.push(track.times[j]);
        for (let k = 0; k < valueSize; ++k) {
          values.push(track.values[j * valueSize + k]);
        }
      }
      if (times.length === 0)
        continue;
      track.times = AnimationUtils.convertArray(times, track.times.constructor);
      track.values = AnimationUtils.convertArray(values, track.values.constructor);
      tracks.push(track);
    }
    clip.tracks = tracks;
    let minStartTime = Infinity;
    for (let i = 0; i < clip.tracks.length; ++i) {
      if (minStartTime > clip.tracks[i].times[0]) {
        minStartTime = clip.tracks[i].times[0];
      }
    }
    for (let i = 0; i < clip.tracks.length; ++i) {
      clip.tracks[i].shift(-1 * minStartTime);
    }
    clip.resetDuration();
    return clip;
  },
  makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0)
      fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    for (let i = 0; i < numTracks; ++i) {
      const referenceTrack = referenceClip.tracks[i];
      const referenceTrackType = referenceTrack.ValueTypeName;
      if (referenceTrackType === "bool" || referenceTrackType === "string")
        continue;
      const targetTrack = targetClip.tracks.find(function(track) {
        return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
      });
      if (targetTrack === void 0)
        continue;
      let referenceOffset = 0;
      const referenceValueSize = referenceTrack.getValueSize();
      if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
        referenceOffset = referenceValueSize / 3;
      }
      let targetOffset = 0;
      const targetValueSize = targetTrack.getValueSize();
      if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
        targetOffset = targetValueSize / 3;
      }
      const lastIndex = referenceTrack.times.length - 1;
      let referenceValue;
      if (referenceTime <= referenceTrack.times[0]) {
        const startIndex = referenceOffset;
        const endIndex = referenceValueSize - referenceOffset;
        referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
      } else if (referenceTime >= referenceTrack.times[lastIndex]) {
        const startIndex = lastIndex * referenceValueSize + referenceOffset;
        const endIndex = startIndex + referenceValueSize - referenceOffset;
        referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
      } else {
        const interpolant = referenceTrack.createInterpolant();
        const startIndex = referenceOffset;
        const endIndex = referenceValueSize - referenceOffset;
        interpolant.evaluate(referenceTime);
        referenceValue = AnimationUtils.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
      }
      if (referenceTrackType === "quaternion") {
        const referenceQuat = new Quaternion().fromArray(referenceValue).normalize().conjugate();
        referenceQuat.toArray(referenceValue);
      }
      const numTimes = targetTrack.times.length;
      for (let j = 0; j < numTimes; ++j) {
        const valueStart = j * targetValueSize + targetOffset;
        if (referenceTrackType === "quaternion") {
          Quaternion.multiplyQuaternionsFlat(
            targetTrack.values,
            valueStart,
            referenceValue,
            0,
            targetTrack.values,
            valueStart
          );
        } else {
          const valueEnd = targetValueSize - targetOffset * 2;
          for (let k = 0; k < valueEnd; ++k) {
            targetTrack.values[valueStart + k] -= referenceValue[k];
          }
        }
      }
    }
    targetClip.blendMode = AdditiveAnimationBlendMode;
    return targetClip;
  }
};
class Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  evaluate(t) {
    const pp = this.parameterPositions;
    let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
    validate_interval: {
      seek: {
        let right;
        linear_scan: {
          forward_scan:
            if (!(t < t1)) {
              for (let giveUpAt = i1 + 2; ; ) {
                if (t1 === void 0) {
                  if (t < t0)
                    break forward_scan;
                  i1 = pp.length;
                  this._cachedIndex = i1;
                  return this.afterEnd_(i1 - 1, t, t0);
                }
                if (i1 === giveUpAt)
                  break;
                t0 = t1;
                t1 = pp[++i1];
                if (t < t1) {
                  break seek;
                }
              }
              right = pp.length;
              break linear_scan;
            }
          if (!(t >= t0)) {
            const t1global = pp[1];
            if (t < t1global) {
              i1 = 2;
              t0 = t1global;
            }
            for (let giveUpAt = i1 - 2; ; ) {
              if (t0 === void 0) {
                this._cachedIndex = 0;
                return this.beforeStart_(0, t, t1);
              }
              if (i1 === giveUpAt)
                break;
              t1 = t0;
              t0 = pp[--i1 - 1];
              if (t >= t0) {
                break seek;
              }
            }
            right = i1;
            i1 = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (i1 < right) {
          const mid = i1 + right >>> 1;
          if (t < pp[mid]) {
            right = mid;
          } else {
            i1 = mid + 1;
          }
        }
        t1 = pp[i1];
        t0 = pp[i1 - 1];
        if (t0 === void 0) {
          this._cachedIndex = 0;
          return this.beforeStart_(0, t, t1);
        }
        if (t1 === void 0) {
          i1 = pp.length;
          this._cachedIndex = i1;
          return this.afterEnd_(i1 - 1, t0, t);
        }
      }
      this._cachedIndex = i1;
      this.intervalChanged_(i1, t0, t1);
    }
    return this.interpolate_(i1, t0, t, t1);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(index) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
    for (let i = 0; i !== stride; ++i) {
      result[i] = values[offset + i];
    }
    return result;
  }
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
}
Interpolant.prototype.beforeStart_ = Interpolant.prototype.copySampleValue_;
Interpolant.prototype.afterEnd_ = Interpolant.prototype.copySampleValue_;
class CubicInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
  }
  intervalChanged_(i1, t0, t1) {
    const pp = this.parameterPositions;
    let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
    if (tPrev === void 0) {
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding:
          iPrev = i1;
          tPrev = 2 * t0 - t1;
          break;
        case WrapAroundEnding:
          iPrev = pp.length - 2;
          tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
          break;
        default:
          iPrev = i1;
          tPrev = t1;
      }
    }
    if (tNext === void 0) {
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding:
          iNext = i1;
          tNext = 2 * t1 - t0;
          break;
        case WrapAroundEnding:
          iNext = 1;
          tNext = t1 + pp[1] - pp[0];
          break;
        default:
          iNext = i1 - 1;
          tNext = t0;
      }
    }
    const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
    this._weightPrev = halfDt / (t0 - tPrev);
    this._weightNext = halfDt / (tNext - t1);
    this._offsetPrev = iPrev * stride;
    this._offsetNext = iNext * stride;
  }
  interpolate_(i1, t0, t, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
    const sP = -wP * ppp + 2 * wP * pp - wP * p;
    const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
    const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
    const sN = wN * ppp - wN * pp;
    for (let i = 0; i !== stride; ++i) {
      result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
    }
    return result;
  }
}
class LinearInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
    for (let i = 0; i !== stride; ++i) {
      result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
    }
    return result;
  }
}
class DiscreteInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1) {
    return this.copySampleValue_(i1 - 1);
  }
}
class KeyframeTrack {
  constructor(name, times, values, interpolation) {
    if (name === void 0)
      throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (times === void 0 || times.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
    this.name = name;
    this.times = AnimationUtils.convertArray(times, this.TimeBufferType);
    this.values = AnimationUtils.convertArray(values, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
  }
  static toJSON(track) {
    const trackType = track.constructor;
    let json;
    if (trackType.toJSON !== this.toJSON) {
      json = trackType.toJSON(track);
    } else {
      json = {
        "name": track.name,
        "times": AnimationUtils.convertArray(track.times, Array),
        "values": AnimationUtils.convertArray(track.values, Array)
      };
      const interpolation = track.getInterpolation();
      if (interpolation !== track.DefaultInterpolation) {
        json.interpolation = interpolation;
      }
    }
    json.type = track.ValueTypeName;
    return json;
  }
  InterpolantFactoryMethodDiscrete(result) {
    return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodLinear(result) {
    return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodSmooth(result) {
    return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  setInterpolation(interpolation) {
    let factoryMethod;
    switch (interpolation) {
      case InterpolateDiscrete:
        factoryMethod = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear:
        factoryMethod = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth:
        factoryMethod = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (factoryMethod === void 0) {
      const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0) {
        if (interpolation !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw new Error(message);
        }
      }
      console.warn("THREE.KeyframeTrack:", message);
      return this;
    }
    this.createInterpolant = factoryMethod;
    return this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  shift(timeOffset) {
    if (timeOffset !== 0) {
      const times = this.times;
      for (let i = 0, n = times.length; i !== n; ++i) {
        times[i] += timeOffset;
      }
    }
    return this;
  }
  scale(timeScale) {
    if (timeScale !== 1) {
      const times = this.times;
      for (let i = 0, n = times.length; i !== n; ++i) {
        times[i] *= timeScale;
      }
    }
    return this;
  }
  trim(startTime, endTime) {
    const times = this.times, nKeys = times.length;
    let from = 0, to = nKeys - 1;
    while (from !== nKeys && times[from] < startTime) {
      ++from;
    }
    while (to !== -1 && times[to] > endTime) {
      --to;
    }
    ++to;
    if (from !== 0 || to !== nKeys) {
      if (from >= to) {
        to = Math.max(to, 1);
        from = to - 1;
      }
      const stride = this.getValueSize();
      this.times = AnimationUtils.arraySlice(times, from, to);
      this.values = AnimationUtils.arraySlice(this.values, from * stride, to * stride);
    }
    return this;
  }
  validate() {
    let valid = true;
    const valueSize = this.getValueSize();
    if (valueSize - Math.floor(valueSize) !== 0) {
      console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
      valid = false;
    }
    const times = this.times, values = this.values, nKeys = times.length;
    if (nKeys === 0) {
      console.error("THREE.KeyframeTrack: Track is empty.", this);
      valid = false;
    }
    let prevTime = null;
    for (let i = 0; i !== nKeys; i++) {
      const currTime = times[i];
      if (typeof currTime === "number" && isNaN(currTime)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
        valid = false;
        break;
      }
      if (prevTime !== null && prevTime > currTime) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
        valid = false;
        break;
      }
      prevTime = currTime;
    }
    if (values !== void 0) {
      if (AnimationUtils.isTypedArray(values)) {
        for (let i = 0, n = values.length; i !== n; ++i) {
          const value = values[i];
          if (isNaN(value)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }
  optimize() {
    const times = AnimationUtils.arraySlice(this.times), values = AnimationUtils.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
    let writeIndex = 1;
    for (let i = 1; i < lastIndex; ++i) {
      let keep = false;
      const time = times[i];
      const timeNext = times[i + 1];
      if (time !== timeNext && (i !== 1 || time !== times[0])) {
        if (!smoothInterpolation) {
          const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
          for (let j = 0; j !== stride; ++j) {
            const value = values[offset + j];
            if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
              keep = true;
              break;
            }
          }
        } else {
          keep = true;
        }
      }
      if (keep) {
        if (i !== writeIndex) {
          times[writeIndex] = times[i];
          const readOffset = i * stride, writeOffset = writeIndex * stride;
          for (let j = 0; j !== stride; ++j) {
            values[writeOffset + j] = values[readOffset + j];
          }
        }
        ++writeIndex;
      }
    }
    if (lastIndex > 0) {
      times[writeIndex] = times[lastIndex];
      for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j) {
        values[writeOffset + j] = values[readOffset + j];
      }
      ++writeIndex;
    }
    if (writeIndex !== times.length) {
      this.times = AnimationUtils.arraySlice(times, 0, writeIndex);
      this.values = AnimationUtils.arraySlice(values, 0, writeIndex * stride);
    } else {
      this.times = times;
      this.values = values;
    }
    return this;
  }
  clone() {
    const times = AnimationUtils.arraySlice(this.times, 0);
    const values = AnimationUtils.arraySlice(this.values, 0);
    const TypedKeyframeTrack = this.constructor;
    const track = new TypedKeyframeTrack(this.name, times, values);
    track.createInterpolant = this.createInterpolant;
    return track;
  }
}
KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
class BooleanKeyframeTrack extends KeyframeTrack {
}
BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class ColorKeyframeTrack extends KeyframeTrack {
}
ColorKeyframeTrack.prototype.ValueTypeName = "color";
class NumberKeyframeTrack extends KeyframeTrack {
}
NumberKeyframeTrack.prototype.ValueTypeName = "number";
class QuaternionLinearInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
    let offset = i1 * stride;
    for (let end = offset + stride; offset !== end; offset += 4) {
      Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
    }
    return result;
  }
}
class QuaternionKeyframeTrack extends KeyframeTrack {
  InterpolantFactoryMethodLinear(result) {
    return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
  }
}
QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class StringKeyframeTrack extends KeyframeTrack {
}
StringKeyframeTrack.prototype.ValueTypeName = "string";
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class VectorKeyframeTrack extends KeyframeTrack {
}
VectorKeyframeTrack.prototype.ValueTypeName = "vector";
class AnimationClip {
  constructor(name, duration = -1, tracks, blendMode = NormalAnimationBlendMode) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration;
    this.blendMode = blendMode;
    this.uuid = generateUUID$1();
    if (this.duration < 0) {
      this.resetDuration();
    }
  }
  static parse(json) {
    const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
    for (let i = 0, n = jsonTracks.length; i !== n; ++i) {
      tracks.push(parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
    }
    const clip = new this(json.name, json.duration, tracks, json.blendMode);
    clip.uuid = json.uuid;
    return clip;
  }
  static toJSON(clip) {
    const tracks = [], clipTracks = clip.tracks;
    const json = {
      "name": clip.name,
      "duration": clip.duration,
      "tracks": tracks,
      "uuid": clip.uuid,
      "blendMode": clip.blendMode
    };
    for (let i = 0, n = clipTracks.length; i !== n; ++i) {
      tracks.push(KeyframeTrack.toJSON(clipTracks[i]));
    }
    return json;
  }
  static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
    const numMorphTargets = morphTargetSequence.length;
    const tracks = [];
    for (let i = 0; i < numMorphTargets; i++) {
      let times = [];
      let values = [];
      times.push(
        (i + numMorphTargets - 1) % numMorphTargets,
        i,
        (i + 1) % numMorphTargets
      );
      values.push(0, 1, 0);
      const order = AnimationUtils.getKeyframeOrder(times);
      times = AnimationUtils.sortedArray(times, 1, order);
      values = AnimationUtils.sortedArray(values, 1, order);
      if (!noLoop && times[0] === 0) {
        times.push(numMorphTargets);
        values.push(values[0]);
      }
      tracks.push(
        new NumberKeyframeTrack(
          ".morphTargetInfluences[" + morphTargetSequence[i].name + "]",
          times,
          values
        ).scale(1 / fps)
      );
    }
    return new this(name, -1, tracks);
  }
  static findByName(objectOrClipArray, name) {
    let clipArray = objectOrClipArray;
    if (!Array.isArray(objectOrClipArray)) {
      const o = objectOrClipArray;
      clipArray = o.geometry && o.geometry.animations || o.animations;
    }
    for (let i = 0; i < clipArray.length; i++) {
      if (clipArray[i].name === name) {
        return clipArray[i];
      }
    }
    return null;
  }
  static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
    const animationToMorphTargets = {};
    const pattern = /^([\w-]*?)([\d]+)$/;
    for (let i = 0, il = morphTargets.length; i < il; i++) {
      const morphTarget = morphTargets[i];
      const parts = morphTarget.name.match(pattern);
      if (parts && parts.length > 1) {
        const name = parts[1];
        let animationMorphTargets = animationToMorphTargets[name];
        if (!animationMorphTargets) {
          animationToMorphTargets[name] = animationMorphTargets = [];
        }
        animationMorphTargets.push(morphTarget);
      }
    }
    const clips = [];
    for (const name in animationToMorphTargets) {
      clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
    }
    return clips;
  }
  static parseAnimation(animation, bones) {
    if (!animation) {
      console.error("THREE.AnimationClip: No animation in JSONLoader data.");
      return null;
    }
    const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
      if (animationKeys.length !== 0) {
        const times = [];
        const values = [];
        AnimationUtils.flattenJSON(animationKeys, times, values, propertyName);
        if (times.length !== 0) {
          destTracks.push(new trackType(trackName, times, values));
        }
      }
    };
    const tracks = [];
    const clipName = animation.name || "default";
    const fps = animation.fps || 30;
    const blendMode = animation.blendMode;
    let duration = animation.length || -1;
    const hierarchyTracks = animation.hierarchy || [];
    for (let h = 0; h < hierarchyTracks.length; h++) {
      const animationKeys = hierarchyTracks[h].keys;
      if (!animationKeys || animationKeys.length === 0)
        continue;
      if (animationKeys[0].morphTargets) {
        const morphTargetNames = {};
        let k;
        for (k = 0; k < animationKeys.length; k++) {
          if (animationKeys[k].morphTargets) {
            for (let m = 0; m < animationKeys[k].morphTargets.length; m++) {
              morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
            }
          }
        }
        for (const morphTargetName in morphTargetNames) {
          const times = [];
          const values = [];
          for (let m = 0; m !== animationKeys[k].morphTargets.length; ++m) {
            const animationKey = animationKeys[k];
            times.push(animationKey.time);
            values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
          }
          tracks.push(new NumberKeyframeTrack(".morphTargetInfluence[" + morphTargetName + "]", times, values));
        }
        duration = morphTargetNames.length * (fps || 1);
      } else {
        const boneName = ".bones[" + bones[h].name + "]";
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".position",
          animationKeys,
          "pos",
          tracks
        );
        addNonemptyTrack(
          QuaternionKeyframeTrack,
          boneName + ".quaternion",
          animationKeys,
          "rot",
          tracks
        );
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".scale",
          animationKeys,
          "scl",
          tracks
        );
      }
    }
    if (tracks.length === 0) {
      return null;
    }
    const clip = new this(clipName, duration, tracks, blendMode);
    return clip;
  }
  resetDuration() {
    const tracks = this.tracks;
    let duration = 0;
    for (let i = 0, n = tracks.length; i !== n; ++i) {
      const track = this.tracks[i];
      duration = Math.max(duration, track.times[track.times.length - 1]);
    }
    this.duration = duration;
    return this;
  }
  trim() {
    for (let i = 0; i < this.tracks.length; i++) {
      this.tracks[i].trim(0, this.duration);
    }
    return this;
  }
  validate() {
    let valid = true;
    for (let i = 0; i < this.tracks.length; i++) {
      valid = valid && this.tracks[i].validate();
    }
    return valid;
  }
  optimize() {
    for (let i = 0; i < this.tracks.length; i++) {
      this.tracks[i].optimize();
    }
    return this;
  }
  clone() {
    const tracks = [];
    for (let i = 0; i < this.tracks.length; i++) {
      tracks.push(this.tracks[i].clone());
    }
    return new this.constructor(this.name, this.duration, tracks, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function getTrackTypeForValueTypeName(typeName) {
  switch (typeName.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack;
    case "color":
      return ColorKeyframeTrack;
    case "quaternion":
      return QuaternionKeyframeTrack;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack;
    case "string":
      return StringKeyframeTrack;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function parseKeyframeTrack(json) {
  if (json.type === void 0) {
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  }
  const trackType = getTrackTypeForValueTypeName(json.type);
  if (json.times === void 0) {
    const times = [], values = [];
    AnimationUtils.flattenJSON(json.keys, times, values, "value");
    json.times = times;
    json.values = values;
  }
  if (trackType.parse !== void 0) {
    return trackType.parse(json);
  } else {
    return new trackType(json.name, json.times, json.values, json.interpolation);
  }
}
const Cache$1 = {
  enabled: false,
  files: {},
  add: function(key, file) {
    if (this.enabled === false)
      return;
    this.files[key] = file;
  },
  get: function(key) {
    if (this.enabled === false)
      return;
    return this.files[key];
  },
  remove: function(key) {
    delete this.files[key];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager$2 {
  constructor(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = void 0;
    const handlers = [];
    this.onStart = void 0;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url2) {
      itemsTotal++;
      if (isLoading === false) {
        if (scope.onStart !== void 0) {
          scope.onStart(url2, itemsLoaded, itemsTotal);
        }
      }
      isLoading = true;
    };
    this.itemEnd = function(url2) {
      itemsLoaded++;
      if (scope.onProgress !== void 0) {
        scope.onProgress(url2, itemsLoaded, itemsTotal);
      }
      if (itemsLoaded === itemsTotal) {
        isLoading = false;
        if (scope.onLoad !== void 0) {
          scope.onLoad();
        }
      }
    };
    this.itemError = function(url2) {
      if (scope.onError !== void 0) {
        scope.onError(url2);
      }
    };
    this.resolveURL = function(url2) {
      if (urlModifier) {
        return urlModifier(url2);
      }
      return url2;
    };
    this.setURLModifier = function(transform) {
      urlModifier = transform;
      return this;
    };
    this.addHandler = function(regex, loader2) {
      handlers.push(regex, loader2);
      return this;
    };
    this.removeHandler = function(regex) {
      const index = handlers.indexOf(regex);
      if (index !== -1) {
        handlers.splice(index, 2);
      }
      return this;
    };
    this.getHandler = function(file) {
      for (let i = 0, l = handlers.length; i < l; i += 2) {
        const regex = handlers[i];
        const loader2 = handlers[i + 1];
        if (regex.global)
          regex.lastIndex = 0;
        if (regex.test(file)) {
          return loader2;
        }
      }
      return null;
    };
  }
}
const DefaultLoadingManager$1 = new LoadingManager$2();
class Loader$1 {
  constructor(manager) {
    this.manager = manager !== void 0 ? manager : DefaultLoadingManager$1;
    this.crossOrigin = "anonymous";
    this.withCredentials = false;
    this.path = "";
    this.resourcePath = "";
    this.requestHeader = {};
  }
  load() {
  }
  loadAsync(url2, onProgress) {
    const scope = this;
    return new Promise(function(resolve, reject) {
      scope.load(url2, resolve, onProgress, reject);
    });
  }
  parse() {
  }
  setCrossOrigin(crossOrigin) {
    this.crossOrigin = crossOrigin;
    return this;
  }
  setWithCredentials(value) {
    this.withCredentials = value;
    return this;
  }
  setPath(path) {
    this.path = path;
    return this;
  }
  setResourcePath(resourcePath) {
    this.resourcePath = resourcePath;
    return this;
  }
  setRequestHeader(requestHeader) {
    this.requestHeader = requestHeader;
    return this;
  }
}
const loading = {};
class FileLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    if (url2 === void 0)
      url2 = "";
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const scope = this;
    const cached = Cache$1.get(url2);
    if (cached !== void 0) {
      scope.manager.itemStart(url2);
      setTimeout(function() {
        if (onLoad)
          onLoad(cached);
        scope.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    if (loading[url2] !== void 0) {
      loading[url2].push({
        onLoad,
        onProgress,
        onError
      });
      return;
    }
    const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
    const dataUriRegexResult = url2.match(dataUriRegex);
    let request;
    if (dataUriRegexResult) {
      const mimeType = dataUriRegexResult[1];
      const isBase64 = !!dataUriRegexResult[2];
      let data = dataUriRegexResult[3];
      data = decodeURIComponent(data);
      if (isBase64)
        data = atob(data);
      try {
        let response;
        const responseType = (this.responseType || "").toLowerCase();
        switch (responseType) {
          case "arraybuffer":
          case "blob":
            const view = new Uint8Array(data.length);
            for (let i = 0; i < data.length; i++) {
              view[i] = data.charCodeAt(i);
            }
            if (responseType === "blob") {
              response = new Blob([view.buffer], { type: mimeType });
            } else {
              response = view.buffer;
            }
            break;
          case "document":
            const parser = new DOMParser();
            response = parser.parseFromString(data, mimeType);
            break;
          case "json":
            response = JSON.parse(data);
            break;
          default:
            response = data;
            break;
        }
        setTimeout(function() {
          if (onLoad)
            onLoad(response);
          scope.manager.itemEnd(url2);
        }, 0);
      } catch (error) {
        setTimeout(function() {
          if (onError)
            onError(error);
          scope.manager.itemError(url2);
          scope.manager.itemEnd(url2);
        }, 0);
      }
    } else {
      loading[url2] = [];
      loading[url2].push({
        onLoad,
        onProgress,
        onError
      });
      request = new XMLHttpRequest();
      request.open("GET", url2, true);
      request.addEventListener("load", function(event) {
        const response = this.response;
        const callbacks = loading[url2];
        delete loading[url2];
        if (this.status === 200 || this.status === 0) {
          if (this.status === 0)
            console.warn("THREE.FileLoader: HTTP Status 0 received.");
          Cache$1.add(url2, response);
          for (let i = 0, il = callbacks.length; i < il; i++) {
            const callback = callbacks[i];
            if (callback.onLoad)
              callback.onLoad(response);
          }
          scope.manager.itemEnd(url2);
        } else {
          for (let i = 0, il = callbacks.length; i < il; i++) {
            const callback = callbacks[i];
            if (callback.onError)
              callback.onError(event);
          }
          scope.manager.itemError(url2);
          scope.manager.itemEnd(url2);
        }
      }, false);
      request.addEventListener("progress", function(event) {
        const callbacks = loading[url2];
        for (let i = 0, il = callbacks.length; i < il; i++) {
          const callback = callbacks[i];
          if (callback.onProgress)
            callback.onProgress(event);
        }
      }, false);
      request.addEventListener("error", function(event) {
        const callbacks = loading[url2];
        delete loading[url2];
        for (let i = 0, il = callbacks.length; i < il; i++) {
          const callback = callbacks[i];
          if (callback.onError)
            callback.onError(event);
        }
        scope.manager.itemError(url2);
        scope.manager.itemEnd(url2);
      }, false);
      request.addEventListener("abort", function(event) {
        const callbacks = loading[url2];
        delete loading[url2];
        for (let i = 0, il = callbacks.length; i < il; i++) {
          const callback = callbacks[i];
          if (callback.onError)
            callback.onError(event);
        }
        scope.manager.itemError(url2);
        scope.manager.itemEnd(url2);
      }, false);
      if (this.responseType !== void 0)
        request.responseType = this.responseType;
      if (this.withCredentials !== void 0)
        request.withCredentials = this.withCredentials;
      if (request.overrideMimeType)
        request.overrideMimeType(this.mimeType !== void 0 ? this.mimeType : "text/plain");
      for (const header in this.requestHeader) {
        request.setRequestHeader(header, this.requestHeader[header]);
      }
      request.send(null);
    }
    scope.manager.itemStart(url2);
    return request;
  }
  setResponseType(value) {
    this.responseType = value;
    return this;
  }
  setMimeType(value) {
    this.mimeType = value;
    return this;
  }
}
class ImageLoader$1 extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const scope = this;
    const cached = Cache$1.get(url2);
    if (cached !== void 0) {
      scope.manager.itemStart(url2);
      setTimeout(function() {
        if (onLoad)
          onLoad(cached);
        scope.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    const image = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
    function onImageLoad() {
      image.removeEventListener("load", onImageLoad, false);
      image.removeEventListener("error", onImageError, false);
      Cache$1.add(url2, this);
      if (onLoad)
        onLoad(this);
      scope.manager.itemEnd(url2);
    }
    function onImageError(event) {
      image.removeEventListener("load", onImageLoad, false);
      image.removeEventListener("error", onImageError, false);
      if (onError)
        onError(event);
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    }
    image.addEventListener("load", onImageLoad, false);
    image.addEventListener("error", onImageError, false);
    if (url2.substr(0, 5) !== "data:") {
      if (this.crossOrigin !== void 0)
        image.crossOrigin = this.crossOrigin;
    }
    scope.manager.itemStart(url2);
    image.src = url2;
    return image;
  }
}
class CubeTextureLoader$2 extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(urls, onLoad, onProgress, onError) {
    const texture = new CubeTexture$1();
    const loader2 = new ImageLoader$1(this.manager);
    loader2.setCrossOrigin(this.crossOrigin);
    loader2.setPath(this.path);
    let loaded = 0;
    function loadTexture(i) {
      loader2.load(urls[i], function(image) {
        texture.images[i] = image;
        loaded++;
        if (loaded === 6) {
          texture.needsUpdate = true;
          if (onLoad)
            onLoad(texture);
        }
      }, void 0, onError);
    }
    for (let i = 0; i < urls.length; ++i) {
      loadTexture(i);
    }
    return texture;
  }
}
class TextureLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const texture = new Texture$1();
    const loader2 = new ImageLoader$1(this.manager);
    loader2.setCrossOrigin(this.crossOrigin);
    loader2.setPath(this.path);
    loader2.load(url2, function(image) {
      texture.image = image;
      const isJPEG = url2.search(/\.jpe?g($|\?)/i) > 0 || url2.search(/^data\:image\/jpeg/) === 0;
      texture.format = isJPEG ? RGBFormat$1 : RGBAFormat$1;
      texture.needsUpdate = true;
      if (onLoad !== void 0) {
        onLoad(texture);
      }
    }, onProgress, onError);
    return texture;
  }
}
class Curve {
  constructor() {
    this.type = "Curve";
    this.arcLengthDivisions = 200;
  }
  getPoint() {
    console.warn("THREE.Curve: .getPoint() not implemented.");
    return null;
  }
  getPointAt(u, optionalTarget) {
    const t = this.getUtoTmapping(u);
    return this.getPoint(t, optionalTarget);
  }
  getPoints(divisions = 5) {
    const points = [];
    for (let d = 0; d <= divisions; d++) {
      points.push(this.getPoint(d / divisions));
    }
    return points;
  }
  getSpacedPoints(divisions = 5) {
    const points = [];
    for (let d = 0; d <= divisions; d++) {
      points.push(this.getPointAt(d / divisions));
    }
    return points;
  }
  getLength() {
    const lengths = this.getLengths();
    return lengths[lengths.length - 1];
  }
  getLengths(divisions = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
      return this.cacheArcLengths;
    }
    this.needsUpdate = false;
    const cache = [];
    let current, last = this.getPoint(0);
    let sum = 0;
    cache.push(0);
    for (let p = 1; p <= divisions; p++) {
      current = this.getPoint(p / divisions);
      sum += current.distanceTo(last);
      cache.push(sum);
      last = current;
    }
    this.cacheArcLengths = cache;
    return cache;
  }
  updateArcLengths() {
    this.needsUpdate = true;
    this.getLengths();
  }
  getUtoTmapping(u, distance) {
    const arcLengths = this.getLengths();
    let i = 0;
    const il = arcLengths.length;
    let targetArcLength;
    if (distance) {
      targetArcLength = distance;
    } else {
      targetArcLength = u * arcLengths[il - 1];
    }
    let low = 0, high = il - 1, comparison;
    while (low <= high) {
      i = Math.floor(low + (high - low) / 2);
      comparison = arcLengths[i] - targetArcLength;
      if (comparison < 0) {
        low = i + 1;
      } else if (comparison > 0) {
        high = i - 1;
      } else {
        high = i;
        break;
      }
    }
    i = high;
    if (arcLengths[i] === targetArcLength) {
      return i / (il - 1);
    }
    const lengthBefore = arcLengths[i];
    const lengthAfter = arcLengths[i + 1];
    const segmentLength = lengthAfter - lengthBefore;
    const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
    const t = (i + segmentFraction) / (il - 1);
    return t;
  }
  getTangent(t, optionalTarget) {
    const delta = 1e-4;
    let t1 = t - delta;
    let t2 = t + delta;
    if (t1 < 0)
      t1 = 0;
    if (t2 > 1)
      t2 = 1;
    const pt1 = this.getPoint(t1);
    const pt2 = this.getPoint(t2);
    const tangent = optionalTarget || (pt1.isVector2 ? new Vector2$1() : new Vector3$1());
    tangent.copy(pt2).sub(pt1).normalize();
    return tangent;
  }
  getTangentAt(u, optionalTarget) {
    const t = this.getUtoTmapping(u);
    return this.getTangent(t, optionalTarget);
  }
  computeFrenetFrames(segments, closed) {
    const normal = new Vector3$1();
    const tangents = [];
    const normals = [];
    const binormals = [];
    const vec = new Vector3$1();
    const mat = new Matrix4();
    for (let i = 0; i <= segments; i++) {
      const u = i / segments;
      tangents[i] = this.getTangentAt(u, new Vector3$1());
      tangents[i].normalize();
    }
    normals[0] = new Vector3$1();
    binormals[0] = new Vector3$1();
    let min = Number.MAX_VALUE;
    const tx = Math.abs(tangents[0].x);
    const ty = Math.abs(tangents[0].y);
    const tz = Math.abs(tangents[0].z);
    if (tx <= min) {
      min = tx;
      normal.set(1, 0, 0);
    }
    if (ty <= min) {
      min = ty;
      normal.set(0, 1, 0);
    }
    if (tz <= min) {
      normal.set(0, 0, 1);
    }
    vec.crossVectors(tangents[0], normal).normalize();
    normals[0].crossVectors(tangents[0], vec);
    binormals[0].crossVectors(tangents[0], normals[0]);
    for (let i = 1; i <= segments; i++) {
      normals[i] = normals[i - 1].clone();
      binormals[i] = binormals[i - 1].clone();
      vec.crossVectors(tangents[i - 1], tangents[i]);
      if (vec.length() > Number.EPSILON) {
        vec.normalize();
        const theta = Math.acos(clamp$1(tangents[i - 1].dot(tangents[i]), -1, 1));
        normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
      }
      binormals[i].crossVectors(tangents[i], normals[i]);
    }
    if (closed === true) {
      let theta = Math.acos(clamp$1(normals[0].dot(normals[segments]), -1, 1));
      theta /= segments;
      if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
        theta = -theta;
      }
      for (let i = 1; i <= segments; i++) {
        normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
        binormals[i].crossVectors(tangents[i], normals[i]);
      }
    }
    return {
      tangents,
      normals,
      binormals
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.arcLengthDivisions = source.arcLengthDivisions;
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.5,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    data.arcLengthDivisions = this.arcLengthDivisions;
    data.type = this.type;
    return data;
  }
  fromJSON(json) {
    this.arcLengthDivisions = json.arcLengthDivisions;
    return this;
  }
}
class EllipseCurve extends Curve {
  constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0) {
    super();
    this.type = "EllipseCurve";
    this.aX = aX;
    this.aY = aY;
    this.xRadius = xRadius;
    this.yRadius = yRadius;
    this.aStartAngle = aStartAngle;
    this.aEndAngle = aEndAngle;
    this.aClockwise = aClockwise;
    this.aRotation = aRotation;
  }
  getPoint(t, optionalTarget) {
    const point = optionalTarget || new Vector2$1();
    const twoPi = Math.PI * 2;
    let deltaAngle = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
    while (deltaAngle < 0)
      deltaAngle += twoPi;
    while (deltaAngle > twoPi)
      deltaAngle -= twoPi;
    if (deltaAngle < Number.EPSILON) {
      if (samePoints) {
        deltaAngle = 0;
      } else {
        deltaAngle = twoPi;
      }
    }
    if (this.aClockwise === true && !samePoints) {
      if (deltaAngle === twoPi) {
        deltaAngle = -twoPi;
      } else {
        deltaAngle = deltaAngle - twoPi;
      }
    }
    const angle = this.aStartAngle + t * deltaAngle;
    let x = this.aX + this.xRadius * Math.cos(angle);
    let y = this.aY + this.yRadius * Math.sin(angle);
    if (this.aRotation !== 0) {
      const cos = Math.cos(this.aRotation);
      const sin = Math.sin(this.aRotation);
      const tx = x - this.aX;
      const ty = y - this.aY;
      x = tx * cos - ty * sin + this.aX;
      y = tx * sin + ty * cos + this.aY;
    }
    return point.set(x, y);
  }
  copy(source) {
    super.copy(source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.aX = this.aX;
    data.aY = this.aY;
    data.xRadius = this.xRadius;
    data.yRadius = this.yRadius;
    data.aStartAngle = this.aStartAngle;
    data.aEndAngle = this.aEndAngle;
    data.aClockwise = this.aClockwise;
    data.aRotation = this.aRotation;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
  }
}
EllipseCurve.prototype.isEllipseCurve = true;
class ArcCurve extends EllipseCurve {
  constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.type = "ArcCurve";
  }
}
ArcCurve.prototype.isArcCurve = true;
function CubicPoly() {
  let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
  function init(x0, x1, t0, t1) {
    c0 = x0;
    c1 = t0;
    c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
    c3 = 2 * x0 - 2 * x1 + t0 + t1;
  }
  return {
    initCatmullRom: function(x0, x1, x2, x3, tension) {
      init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
    },
    initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
      let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
      let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
      t1 *= dt1;
      t2 *= dt1;
      init(x1, x2, t1, t2);
    },
    calc: function(t) {
      const t2 = t * t;
      const t3 = t2 * t;
      return c0 + c1 * t + c2 * t2 + c3 * t3;
    }
  };
}
const tmp = new Vector3$1();
const px = new CubicPoly(), py = new CubicPoly(), pz = new CubicPoly();
class CatmullRomCurve3 extends Curve {
  constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5) {
    super();
    this.type = "CatmullRomCurve3";
    this.points = points;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
  }
  getPoint(t, optionalTarget = new Vector3$1()) {
    const point = optionalTarget;
    const points = this.points;
    const l = points.length;
    const p = (l - (this.closed ? 0 : 1)) * t;
    let intPoint = Math.floor(p);
    let weight = p - intPoint;
    if (this.closed) {
      intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
    } else if (weight === 0 && intPoint === l - 1) {
      intPoint = l - 2;
      weight = 1;
    }
    let p0, p3;
    if (this.closed || intPoint > 0) {
      p0 = points[(intPoint - 1) % l];
    } else {
      tmp.subVectors(points[0], points[1]).add(points[0]);
      p0 = tmp;
    }
    const p1 = points[intPoint % l];
    const p2 = points[(intPoint + 1) % l];
    if (this.closed || intPoint + 2 < l) {
      p3 = points[(intPoint + 2) % l];
    } else {
      tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
      p3 = tmp;
    }
    if (this.curveType === "centripetal" || this.curveType === "chordal") {
      const pow = this.curveType === "chordal" ? 0.5 : 0.25;
      let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
      let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
      let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
      if (dt1 < 1e-4)
        dt1 = 1;
      if (dt0 < 1e-4)
        dt0 = dt1;
      if (dt2 < 1e-4)
        dt2 = dt1;
      px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
      py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
      pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
    } else if (this.curveType === "catmullrom") {
      px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
      py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
      pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
    }
    point.set(
      px.calc(weight),
      py.calc(weight),
      pz.calc(weight)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i = 0, l = source.points.length; i < l; i++) {
      const point = source.points[i];
      this.points.push(point.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i = 0, l = this.points.length; i < l; i++) {
      const point = this.points[i];
      data.points.push(point.toArray());
    }
    data.closed = this.closed;
    data.curveType = this.curveType;
    data.tension = this.tension;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i = 0, l = json.points.length; i < l; i++) {
      const point = json.points[i];
      this.points.push(new Vector3$1().fromArray(point));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
  }
}
CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;
function CatmullRom(t, p0, p1, p2, p3) {
  const v0 = (p2 - p0) * 0.5;
  const v1 = (p3 - p1) * 0.5;
  const t2 = t * t;
  const t3 = t * t2;
  return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function QuadraticBezierP0(t, p) {
  const k = 1 - t;
  return k * k * p;
}
function QuadraticBezierP1(t, p) {
  return 2 * (1 - t) * t * p;
}
function QuadraticBezierP2(t, p) {
  return t * t * p;
}
function QuadraticBezier(t, p0, p1, p2) {
  return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
}
function CubicBezierP0(t, p) {
  const k = 1 - t;
  return k * k * k * p;
}
function CubicBezierP1(t, p) {
  const k = 1 - t;
  return 3 * k * k * t * p;
}
function CubicBezierP2(t, p) {
  return 3 * (1 - t) * t * t * p;
}
function CubicBezierP3(t, p) {
  return t * t * t * p;
}
function CubicBezier(t, p0, p1, p2, p3) {
  return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
}
class CubicBezierCurve extends Curve {
  constructor(v0 = new Vector2$1(), v1 = new Vector2$1(), v2 = new Vector2$1(), v3 = new Vector2$1()) {
    super();
    this.type = "CubicBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
  }
  getPoint(t, optionalTarget = new Vector2$1()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point.set(
      CubicBezier(t, v0.x, v1.x, v2.x, v3.x),
      CubicBezier(t, v0.y, v1.y, v2.y, v3.y)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
CubicBezierCurve.prototype.isCubicBezierCurve = true;
class CubicBezierCurve3 extends Curve {
  constructor(v0 = new Vector3$1(), v1 = new Vector3$1(), v2 = new Vector3$1(), v3 = new Vector3$1()) {
    super();
    this.type = "CubicBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
  }
  getPoint(t, optionalTarget = new Vector3$1()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point.set(
      CubicBezier(t, v0.x, v1.x, v2.x, v3.x),
      CubicBezier(t, v0.y, v1.y, v2.y, v3.y),
      CubicBezier(t, v0.z, v1.z, v2.z, v3.z)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;
class LineCurve extends Curve {
  constructor(v1 = new Vector2$1(), v2 = new Vector2$1()) {
    super();
    this.type = "LineCurve";
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t, optionalTarget = new Vector2$1()) {
    const point = optionalTarget;
    if (t === 1) {
      point.copy(this.v2);
    } else {
      point.copy(this.v2).sub(this.v1);
      point.multiplyScalar(t).add(this.v1);
    }
    return point;
  }
  getPointAt(u, optionalTarget) {
    return this.getPoint(u, optionalTarget);
  }
  getTangent(t, optionalTarget) {
    const tangent = optionalTarget || new Vector2$1();
    tangent.copy(this.v2).sub(this.v1).normalize();
    return tangent;
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
LineCurve.prototype.isLineCurve = true;
class LineCurve3 extends Curve {
  constructor(v1 = new Vector3$1(), v2 = new Vector3$1()) {
    super();
    this.type = "LineCurve3";
    this.isLineCurve3 = true;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t, optionalTarget = new Vector3$1()) {
    const point = optionalTarget;
    if (t === 1) {
      point.copy(this.v2);
    } else {
      point.copy(this.v2).sub(this.v1);
      point.multiplyScalar(t).add(this.v1);
    }
    return point;
  }
  getPointAt(u, optionalTarget) {
    return this.getPoint(u, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class QuadraticBezierCurve extends Curve {
  constructor(v0 = new Vector2$1(), v1 = new Vector2$1(), v2 = new Vector2$1()) {
    super();
    this.type = "QuadraticBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t, optionalTarget = new Vector2$1()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point.set(
      QuadraticBezier(t, v0.x, v1.x, v2.x),
      QuadraticBezier(t, v0.y, v1.y, v2.y)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;
class QuadraticBezierCurve3 extends Curve {
  constructor(v0 = new Vector3$1(), v1 = new Vector3$1(), v2 = new Vector3$1()) {
    super();
    this.type = "QuadraticBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t, optionalTarget = new Vector3$1()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point.set(
      QuadraticBezier(t, v0.x, v1.x, v2.x),
      QuadraticBezier(t, v0.y, v1.y, v2.y),
      QuadraticBezier(t, v0.z, v1.z, v2.z)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;
class SplineCurve extends Curve {
  constructor(points = []) {
    super();
    this.type = "SplineCurve";
    this.points = points;
  }
  getPoint(t, optionalTarget = new Vector2$1()) {
    const point = optionalTarget;
    const points = this.points;
    const p = (points.length - 1) * t;
    const intPoint = Math.floor(p);
    const weight = p - intPoint;
    const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points[intPoint];
    const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
    const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
    point.set(
      CatmullRom(weight, p0.x, p1.x, p2.x, p3.x),
      CatmullRom(weight, p0.y, p1.y, p2.y, p3.y)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i = 0, l = source.points.length; i < l; i++) {
      const point = source.points[i];
      this.points.push(point.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i = 0, l = this.points.length; i < l; i++) {
      const point = this.points[i];
      data.points.push(point.toArray());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i = 0, l = json.points.length; i < l; i++) {
      const point = json.points[i];
      this.points.push(new Vector2$1().fromArray(point));
    }
    return this;
  }
}
SplineCurve.prototype.isSplineCurve = true;
var Curves = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve,
  CatmullRomCurve3,
  CubicBezierCurve,
  CubicBezierCurve3,
  EllipseCurve,
  LineCurve,
  LineCurve3,
  QuadraticBezierCurve,
  QuadraticBezierCurve3,
  SplineCurve
});
class CurvePath extends Curve {
  constructor() {
    super();
    this.type = "CurvePath";
    this.curves = [];
    this.autoClose = false;
  }
  add(curve) {
    this.curves.push(curve);
  }
  closePath() {
    const startPoint = this.curves[0].getPoint(0);
    const endPoint = this.curves[this.curves.length - 1].getPoint(1);
    if (!startPoint.equals(endPoint)) {
      this.curves.push(new LineCurve(endPoint, startPoint));
    }
  }
  getPoint(t) {
    const d = t * this.getLength();
    const curveLengths = this.getCurveLengths();
    let i = 0;
    while (i < curveLengths.length) {
      if (curveLengths[i] >= d) {
        const diff = curveLengths[i] - d;
        const curve = this.curves[i];
        const segmentLength = curve.getLength();
        const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
        return curve.getPointAt(u);
      }
      i++;
    }
    return null;
  }
  getLength() {
    const lens = this.getCurveLengths();
    return lens[lens.length - 1];
  }
  updateArcLengths() {
    this.needsUpdate = true;
    this.cacheLengths = null;
    this.getCurveLengths();
  }
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
      return this.cacheLengths;
    }
    const lengths = [];
    let sums = 0;
    for (let i = 0, l = this.curves.length; i < l; i++) {
      sums += this.curves[i].getLength();
      lengths.push(sums);
    }
    this.cacheLengths = lengths;
    return lengths;
  }
  getSpacedPoints(divisions = 40) {
    const points = [];
    for (let i = 0; i <= divisions; i++) {
      points.push(this.getPoint(i / divisions));
    }
    if (this.autoClose) {
      points.push(points[0]);
    }
    return points;
  }
  getPoints(divisions = 12) {
    const points = [];
    let last;
    for (let i = 0, curves = this.curves; i < curves.length; i++) {
      const curve = curves[i];
      const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
      const pts = curve.getPoints(resolution);
      for (let j = 0; j < pts.length; j++) {
        const point = pts[j];
        if (last && last.equals(point))
          continue;
        points.push(point);
        last = point;
      }
    }
    if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
      points.push(points[0]);
    }
    return points;
  }
  copy(source) {
    super.copy(source);
    this.curves = [];
    for (let i = 0, l = source.curves.length; i < l; i++) {
      const curve = source.curves[i];
      this.curves.push(curve.clone());
    }
    this.autoClose = source.autoClose;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.autoClose = this.autoClose;
    data.curves = [];
    for (let i = 0, l = this.curves.length; i < l; i++) {
      const curve = this.curves[i];
      data.curves.push(curve.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.autoClose = json.autoClose;
    this.curves = [];
    for (let i = 0, l = json.curves.length; i < l; i++) {
      const curve = json.curves[i];
      this.curves.push(new Curves[curve.type]().fromJSON(curve));
    }
    return this;
  }
}
class Path extends CurvePath {
  constructor(points) {
    super();
    this.type = "Path";
    this.currentPoint = new Vector2$1();
    if (points) {
      this.setFromPoints(points);
    }
  }
  setFromPoints(points) {
    this.moveTo(points[0].x, points[0].y);
    for (let i = 1, l = points.length; i < l; i++) {
      this.lineTo(points[i].x, points[i].y);
    }
    return this;
  }
  moveTo(x, y) {
    this.currentPoint.set(x, y);
    return this;
  }
  lineTo(x, y) {
    const curve = new LineCurve(this.currentPoint.clone(), new Vector2$1(x, y));
    this.curves.push(curve);
    this.currentPoint.set(x, y);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX, aY) {
    const curve = new QuadraticBezierCurve(
      this.currentPoint.clone(),
      new Vector2$1(aCPx, aCPy),
      new Vector2$1(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
    const curve = new CubicBezierCurve(
      this.currentPoint.clone(),
      new Vector2$1(aCP1x, aCP1y),
      new Vector2$1(aCP2x, aCP2y),
      new Vector2$1(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  splineThru(pts) {
    const npts = [this.currentPoint.clone()].concat(pts);
    const curve = new SplineCurve(npts);
    this.curves.push(curve);
    this.currentPoint.copy(pts[pts.length - 1]);
    return this;
  }
  arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absarc(
      aX + x0,
      aY + y0,
      aRadius,
      aStartAngle,
      aEndAngle,
      aClockwise
    );
    return this;
  }
  absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    return this;
  }
  ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    return this;
  }
  absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    if (this.curves.length > 0) {
      const firstPoint = curve.getPoint(0);
      if (!firstPoint.equals(this.currentPoint)) {
        this.lineTo(firstPoint.x, firstPoint.y);
      }
    }
    this.curves.push(curve);
    const lastPoint = curve.getPoint(1);
    this.currentPoint.copy(lastPoint);
    return this;
  }
  copy(source) {
    super.copy(source);
    this.currentPoint.copy(source.currentPoint);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.currentPoint = this.currentPoint.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.currentPoint.fromArray(json.currentPoint);
    return this;
  }
}
class Shape extends Path {
  constructor(points) {
    super(points);
    this.uuid = generateUUID$1();
    this.type = "Shape";
    this.holes = [];
  }
  getPointsHoles(divisions) {
    const holesPts = [];
    for (let i = 0, l = this.holes.length; i < l; i++) {
      holesPts[i] = this.holes[i].getPoints(divisions);
    }
    return holesPts;
  }
  extractPoints(divisions) {
    return {
      shape: this.getPoints(divisions),
      holes: this.getPointsHoles(divisions)
    };
  }
  copy(source) {
    super.copy(source);
    this.holes = [];
    for (let i = 0, l = source.holes.length; i < l; i++) {
      const hole = source.holes[i];
      this.holes.push(hole.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.uuid = this.uuid;
    data.holes = [];
    for (let i = 0, l = this.holes.length; i < l; i++) {
      const hole = this.holes[i];
      data.holes.push(hole.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.uuid = json.uuid;
    this.holes = [];
    for (let i = 0, l = json.holes.length; i < l; i++) {
      const hole = json.holes[i];
      this.holes.push(new Path().fromJSON(hole));
    }
    return this;
  }
}
class Light extends Object3D {
  constructor(color, intensity = 1) {
    super();
    this.type = "Light";
    this.color = new Color(color);
    this.intensity = intensity;
  }
  dispose() {
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.intensity = source.intensity;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.color = this.color.getHex();
    data.object.intensity = this.intensity;
    if (this.groundColor !== void 0)
      data.object.groundColor = this.groundColor.getHex();
    if (this.distance !== void 0)
      data.object.distance = this.distance;
    if (this.angle !== void 0)
      data.object.angle = this.angle;
    if (this.decay !== void 0)
      data.object.decay = this.decay;
    if (this.penumbra !== void 0)
      data.object.penumbra = this.penumbra;
    if (this.shadow !== void 0)
      data.object.shadow = this.shadow.toJSON();
    return data;
  }
}
Light.prototype.isLight = true;
class HemisphereLight extends Light {
  constructor(skyColor, groundColor, intensity) {
    super(skyColor, intensity);
    this.type = "HemisphereLight";
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.groundColor = new Color(groundColor);
  }
  copy(source) {
    Light.prototype.copy.call(this, source);
    this.groundColor.copy(source.groundColor);
    return this;
  }
}
HemisphereLight.prototype.isHemisphereLight = true;
const _projScreenMatrix$1 = /* @__PURE__ */ new Matrix4();
const _lightPositionWorld$1 = /* @__PURE__ */ new Vector3$1();
const _lookTarget$1 = /* @__PURE__ */ new Vector3$1();
class LightShadow {
  constructor(camera) {
    this.camera = camera;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.mapSize = new Vector2$1(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum();
    this._frameExtents = new Vector2$1(1, 1);
    this._viewportCount = 1;
    this._viewports = [
      new Vector4(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(light) {
    const shadowCamera = this.camera;
    const shadowMatrix = this.matrix;
    _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
    shadowCamera.position.copy(_lightPositionWorld$1);
    _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
    shadowCamera.lookAt(_lookTarget$1);
    shadowCamera.updateMatrixWorld();
    _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);
    shadowMatrix.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    );
    shadowMatrix.multiply(shadowCamera.projectionMatrix);
    shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
  }
  getViewport(viewportIndex) {
    return this._viewports[viewportIndex];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    if (this.map) {
      this.map.dispose();
    }
    if (this.mapPass) {
      this.mapPass.dispose();
    }
  }
  copy(source) {
    this.camera = source.camera.clone();
    this.bias = source.bias;
    this.radius = source.radius;
    this.mapSize.copy(source.mapSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const object = {};
    if (this.bias !== 0)
      object.bias = this.bias;
    if (this.normalBias !== 0)
      object.normalBias = this.normalBias;
    if (this.radius !== 1)
      object.radius = this.radius;
    if (this.mapSize.x !== 512 || this.mapSize.y !== 512)
      object.mapSize = this.mapSize.toArray();
    object.camera = this.camera.toJSON(false).object;
    delete object.camera.matrix;
    return object;
  }
}
class SpotLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera(50, 1, 0.5, 500));
    this.focus = 1;
  }
  updateMatrices(light) {
    const camera = this.camera;
    const fov2 = RAD2DEG * 2 * light.angle * this.focus;
    const aspect2 = this.mapSize.width / this.mapSize.height;
    const far = light.distance || camera.far;
    if (fov2 !== camera.fov || aspect2 !== camera.aspect || far !== camera.far) {
      camera.fov = fov2;
      camera.aspect = aspect2;
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    super.updateMatrices(light);
  }
  copy(source) {
    super.copy(source);
    this.focus = source.focus;
    return this;
  }
}
SpotLightShadow.prototype.isSpotLightShadow = true;
class SpotLight extends Light {
  constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1) {
    super(color, intensity);
    this.type = "SpotLight";
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    this.distance = distance;
    this.angle = angle;
    this.penumbra = penumbra;
    this.decay = decay;
    this.shadow = new SpotLightShadow();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(power) {
    this.intensity = power / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.distance = source.distance;
    this.angle = source.angle;
    this.penumbra = source.penumbra;
    this.decay = source.decay;
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
SpotLight.prototype.isSpotLight = true;
const _projScreenMatrix = /* @__PURE__ */ new Matrix4();
const _lightPositionWorld = /* @__PURE__ */ new Vector3$1();
const _lookTarget = /* @__PURE__ */ new Vector3$1();
class PointLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera(90, 1, 0.5, 500));
    this._frameExtents = new Vector2$1(4, 2);
    this._viewportCount = 6;
    this._viewports = [
      new Vector4(2, 1, 1, 1),
      new Vector4(0, 1, 1, 1),
      new Vector4(3, 1, 1, 1),
      new Vector4(1, 1, 1, 1),
      new Vector4(3, 0, 1, 1),
      new Vector4(1, 0, 1, 1)
    ];
    this._cubeDirections = [
      new Vector3$1(1, 0, 0),
      new Vector3$1(-1, 0, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, -1, 0)
    ];
    this._cubeUps = [
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1)
    ];
  }
  updateMatrices(light, viewportIndex = 0) {
    const camera = this.camera;
    const shadowMatrix = this.matrix;
    const far = light.distance || camera.far;
    if (far !== camera.far) {
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
    camera.position.copy(_lightPositionWorld);
    _lookTarget.copy(camera.position);
    _lookTarget.add(this._cubeDirections[viewportIndex]);
    camera.up.copy(this._cubeUps[viewportIndex]);
    camera.lookAt(_lookTarget);
    camera.updateMatrixWorld();
    shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
    _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix);
  }
}
PointLightShadow.prototype.isPointLightShadow = true;
class PointLight extends Light {
  constructor(color, intensity, distance = 0, decay = 1) {
    super(color, intensity);
    this.type = "PointLight";
    this.distance = distance;
    this.decay = decay;
    this.shadow = new PointLightShadow();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(power) {
    this.intensity = power / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.distance = source.distance;
    this.decay = source.decay;
    this.shadow = source.shadow.clone();
    return this;
  }
}
PointLight.prototype.isPointLight = true;
class OrthographicCamera extends Camera$1 {
  constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
    super();
    this.type = "OrthographicCamera";
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.left = source.left;
    this.right = source.right;
    this.top = source.top;
    this.bottom = source.bottom;
    this.near = source.near;
    this.far = source.far;
    this.zoom = source.zoom;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    return this;
  }
  setViewOffset(fullWidth, fullHeight, x, y, width, height) {
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x;
    this.view.offsetY = y;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const dx = (this.right - this.left) / (2 * this.zoom);
    const dy = (this.top - this.bottom) / (2 * this.zoom);
    const cx = (this.right + this.left) / 2;
    const cy = (this.top + this.bottom) / 2;
    let left = cx - dx;
    let right = cx + dx;
    let top = cy + dy;
    let bottom = cy - dy;
    if (this.view !== null && this.view.enabled) {
      const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
      const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      left += scaleW * this.view.offsetX;
      right = left + scaleW * this.view.width;
      top -= scaleH * this.view.offsetY;
      bottom = top - scaleH * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.zoom = this.zoom;
    data.object.left = this.left;
    data.object.right = this.right;
    data.object.top = this.top;
    data.object.bottom = this.bottom;
    data.object.near = this.near;
    data.object.far = this.far;
    if (this.view !== null)
      data.object.view = Object.assign({}, this.view);
    return data;
  }
}
OrthographicCamera.prototype.isOrthographicCamera = true;
class DirectionalLightShadow extends LightShadow {
  constructor() {
    super(new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
  }
}
DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
class DirectionalLight extends Light {
  constructor(color, intensity) {
    super(color, intensity);
    this.type = "DirectionalLight";
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    this.shadow = new DirectionalLightShadow();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
DirectionalLight.prototype.isDirectionalLight = true;
class AmbientLight extends Light {
  constructor(color, intensity) {
    super(color, intensity);
    this.type = "AmbientLight";
  }
}
AmbientLight.prototype.isAmbientLight = true;
class RectAreaLight extends Light {
  constructor(color, intensity, width = 10, height = 10) {
    super(color, intensity);
    this.type = "RectAreaLight";
    this.width = width;
    this.height = height;
  }
  copy(source) {
    super.copy(source);
    this.width = source.width;
    this.height = source.height;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.width = this.width;
    data.object.height = this.height;
    return data;
  }
}
RectAreaLight.prototype.isRectAreaLight = true;
class SphericalHarmonics3 {
  constructor() {
    this.coefficients = [];
    for (let i = 0; i < 9; i++) {
      this.coefficients.push(new Vector3$1());
    }
  }
  set(coefficients) {
    for (let i = 0; i < 9; i++) {
      this.coefficients[i].copy(coefficients[i]);
    }
    return this;
  }
  zero() {
    for (let i = 0; i < 9; i++) {
      this.coefficients[i].set(0, 0, 0);
    }
    return this;
  }
  getAt(normal, target) {
    const x = normal.x, y = normal.y, z = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.282095);
    target.addScaledVector(coeff[1], 0.488603 * y);
    target.addScaledVector(coeff[2], 0.488603 * z);
    target.addScaledVector(coeff[3], 0.488603 * x);
    target.addScaledVector(coeff[4], 1.092548 * (x * y));
    target.addScaledVector(coeff[5], 1.092548 * (y * z));
    target.addScaledVector(coeff[6], 0.315392 * (3 * z * z - 1));
    target.addScaledVector(coeff[7], 1.092548 * (x * z));
    target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
    return target;
  }
  getIrradianceAt(normal, target) {
    const x = normal.x, y = normal.y, z = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.886227);
    target.addScaledVector(coeff[1], 2 * 0.511664 * y);
    target.addScaledVector(coeff[2], 2 * 0.511664 * z);
    target.addScaledVector(coeff[3], 2 * 0.511664 * x);
    target.addScaledVector(coeff[4], 2 * 0.429043 * x * y);
    target.addScaledVector(coeff[5], 2 * 0.429043 * y * z);
    target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708);
    target.addScaledVector(coeff[7], 2 * 0.429043 * x * z);
    target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y));
    return target;
  }
  add(sh) {
    for (let i = 0; i < 9; i++) {
      this.coefficients[i].add(sh.coefficients[i]);
    }
    return this;
  }
  addScaledSH(sh, s) {
    for (let i = 0; i < 9; i++) {
      this.coefficients[i].addScaledVector(sh.coefficients[i], s);
    }
    return this;
  }
  scale(s) {
    for (let i = 0; i < 9; i++) {
      this.coefficients[i].multiplyScalar(s);
    }
    return this;
  }
  lerp(sh, alpha) {
    for (let i = 0; i < 9; i++) {
      this.coefficients[i].lerp(sh.coefficients[i], alpha);
    }
    return this;
  }
  equals(sh) {
    for (let i = 0; i < 9; i++) {
      if (!this.coefficients[i].equals(sh.coefficients[i])) {
        return false;
      }
    }
    return true;
  }
  copy(sh) {
    return this.set(sh.coefficients);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(array, offset = 0) {
    const coefficients = this.coefficients;
    for (let i = 0; i < 9; i++) {
      coefficients[i].fromArray(array, offset + i * 3);
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const coefficients = this.coefficients;
    for (let i = 0; i < 9; i++) {
      coefficients[i].toArray(array, offset + i * 3);
    }
    return array;
  }
  static getBasisAt(normal, shBasis) {
    const x = normal.x, y = normal.y, z = normal.z;
    shBasis[0] = 0.282095;
    shBasis[1] = 0.488603 * y;
    shBasis[2] = 0.488603 * z;
    shBasis[3] = 0.488603 * x;
    shBasis[4] = 1.092548 * x * y;
    shBasis[5] = 1.092548 * y * z;
    shBasis[6] = 0.315392 * (3 * z * z - 1);
    shBasis[7] = 1.092548 * x * z;
    shBasis[8] = 0.546274 * (x * x - y * y);
  }
}
SphericalHarmonics3.prototype.isSphericalHarmonics3 = true;
class LightProbe extends Light {
  constructor(sh = new SphericalHarmonics3(), intensity = 1) {
    super(void 0, intensity);
    this.sh = sh;
  }
  copy(source) {
    super.copy(source);
    this.sh.copy(source.sh);
    return this;
  }
  fromJSON(json) {
    this.intensity = json.intensity;
    this.sh.fromArray(json.sh);
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.sh = this.sh.toArray();
    return data;
  }
}
LightProbe.prototype.isLightProbe = true;
class LoaderUtils {
  static decodeText(array) {
    if (typeof TextDecoder !== "undefined") {
      return new TextDecoder().decode(array);
    }
    let s = "";
    for (let i = 0, il = array.length; i < il; i++) {
      s += String.fromCharCode(array[i]);
    }
    try {
      return decodeURIComponent(escape(s));
    } catch (e) {
      return s;
    }
  }
  static extractUrlBase(url2) {
    const index = url2.lastIndexOf("/");
    if (index === -1)
      return "./";
    return url2.substr(0, index + 1);
  }
}
class InstancedBufferGeometry extends BufferGeometry {
  constructor() {
    super();
    this.type = "InstancedBufferGeometry";
    this.instanceCount = Infinity;
  }
  copy(source) {
    super.copy(source);
    this.instanceCount = source.instanceCount;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const data = super.toJSON(this);
    data.instanceCount = this.instanceCount;
    data.isInstancedBufferGeometry = true;
    return data;
  }
}
InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;
class InstancedBufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized, meshPerAttribute) {
    if (typeof normalized === "number") {
      meshPerAttribute = normalized;
      normalized = false;
      console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
    }
    super(array, itemSize, normalized);
    this.meshPerAttribute = meshPerAttribute || 1;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.meshPerAttribute = this.meshPerAttribute;
    data.isInstancedBufferAttribute = true;
    return data;
  }
}
InstancedBufferAttribute.prototype.isInstancedBufferAttribute = true;
class ImageBitmapLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    if (typeof createImageBitmap === "undefined") {
      console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
    }
    if (typeof fetch === "undefined") {
      console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
    }
    this.options = { premultiplyAlpha: "none" };
  }
  setOptions(options) {
    this.options = options;
    return this;
  }
  load(url2, onLoad, onProgress, onError) {
    if (url2 === void 0)
      url2 = "";
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const scope = this;
    const cached = Cache$1.get(url2);
    if (cached !== void 0) {
      scope.manager.itemStart(url2);
      setTimeout(function() {
        if (onLoad)
          onLoad(cached);
        scope.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    const fetchOptions = {};
    fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
    fetchOptions.headers = this.requestHeader;
    fetch(url2, fetchOptions).then(function(res) {
      return res.blob();
    }).then(function(blob) {
      return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: "none" }));
    }).then(function(imageBitmap) {
      Cache$1.add(url2, imageBitmap);
      if (onLoad)
        onLoad(imageBitmap);
      scope.manager.itemEnd(url2);
    }).catch(function(e) {
      if (onError)
        onError(e);
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    });
    scope.manager.itemStart(url2);
  }
}
ImageBitmapLoader.prototype.isImageBitmapLoader = true;
let _context;
const AudioContext = {
  getContext: function() {
    if (_context === void 0) {
      _context = new (window.AudioContext || window.webkitAudioContext)();
    }
    return _context;
  },
  setContext: function(value) {
    _context = value;
  }
};
class AudioLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const loader2 = new FileLoader(this.manager);
    loader2.setResponseType("arraybuffer");
    loader2.setPath(this.path);
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(url2, function(buffer) {
      try {
        const bufferCopy = buffer.slice(0);
        const context = AudioContext.getContext();
        context.decodeAudioData(bufferCopy, function(audioBuffer) {
          onLoad(audioBuffer);
        });
      } catch (e) {
        if (onError) {
          onError(e);
        } else {
          console.error(e);
        }
        scope.manager.itemError(url2);
      }
    }, onProgress, onError);
  }
}
class HemisphereLightProbe extends LightProbe {
  constructor(skyColor, groundColor, intensity = 1) {
    super(void 0, intensity);
    const color1 = new Color().set(skyColor);
    const color2 = new Color().set(groundColor);
    const sky = new Vector3$1(color1.r, color1.g, color1.b);
    const ground = new Vector3$1(color2.r, color2.g, color2.b);
    const c0 = Math.sqrt(Math.PI);
    const c1 = c0 * Math.sqrt(0.75);
    this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
    this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
  }
}
HemisphereLightProbe.prototype.isHemisphereLightProbe = true;
class AmbientLightProbe extends LightProbe {
  constructor(color, intensity = 1) {
    super(void 0, intensity);
    const color1 = new Color().set(color);
    this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
  }
}
AmbientLightProbe.prototype.isAmbientLightProbe = true;
class Audio extends Object3D {
  constructor(listener) {
    super();
    this.type = "Audio";
    this.listener = listener;
    this.context = listener.context;
    this.gain = this.context.createGain();
    this.gain.connect(listener.getInput());
    this.autoplay = false;
    this.buffer = null;
    this.detune = 0;
    this.loop = false;
    this.loopStart = 0;
    this.loopEnd = 0;
    this.offset = 0;
    this.duration = void 0;
    this.playbackRate = 1;
    this.isPlaying = false;
    this.hasPlaybackControl = true;
    this.source = null;
    this.sourceType = "empty";
    this._startedAt = 0;
    this._progress = 0;
    this._connected = false;
    this.filters = [];
  }
  getOutput() {
    return this.gain;
  }
  setNodeSource(audioNode) {
    this.hasPlaybackControl = false;
    this.sourceType = "audioNode";
    this.source = audioNode;
    this.connect();
    return this;
  }
  setMediaElementSource(mediaElement) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaNode";
    this.source = this.context.createMediaElementSource(mediaElement);
    this.connect();
    return this;
  }
  setMediaStreamSource(mediaStream) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaStreamNode";
    this.source = this.context.createMediaStreamSource(mediaStream);
    this.connect();
    return this;
  }
  setBuffer(audioBuffer) {
    this.buffer = audioBuffer;
    this.sourceType = "buffer";
    if (this.autoplay)
      this.play();
    return this;
  }
  play(delay = 0) {
    if (this.isPlaying === true) {
      console.warn("THREE.Audio: Audio is already playing.");
      return;
    }
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._startedAt = this.context.currentTime + delay;
    const source = this.context.createBufferSource();
    source.buffer = this.buffer;
    source.loop = this.loop;
    source.loopStart = this.loopStart;
    source.loopEnd = this.loopEnd;
    source.onended = this.onEnded.bind(this);
    source.start(this._startedAt, this._progress + this.offset, this.duration);
    this.isPlaying = true;
    this.source = source;
    this.setDetune(this.detune);
    this.setPlaybackRate(this.playbackRate);
    return this.connect();
  }
  pause() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    if (this.isPlaying === true) {
      this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
      if (this.loop === true) {
        this._progress = this._progress % (this.duration || this.buffer.duration);
      }
      this.source.stop();
      this.source.onended = null;
      this.isPlaying = false;
    }
    return this;
  }
  stop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._progress = 0;
    this.source.stop();
    this.source.onended = null;
    this.isPlaying = false;
    return this;
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0]);
      for (let i = 1, l = this.filters.length; i < l; i++) {
        this.filters[i - 1].connect(this.filters[i]);
      }
      this.filters[this.filters.length - 1].connect(this.getOutput());
    } else {
      this.source.connect(this.getOutput());
    }
    this._connected = true;
    return this;
  }
  disconnect() {
    if (this.filters.length > 0) {
      this.source.disconnect(this.filters[0]);
      for (let i = 1, l = this.filters.length; i < l; i++) {
        this.filters[i - 1].disconnect(this.filters[i]);
      }
      this.filters[this.filters.length - 1].disconnect(this.getOutput());
    } else {
      this.source.disconnect(this.getOutput());
    }
    this._connected = false;
    return this;
  }
  getFilters() {
    return this.filters;
  }
  setFilters(value) {
    if (!value)
      value = [];
    if (this._connected === true) {
      this.disconnect();
      this.filters = value.slice();
      this.connect();
    } else {
      this.filters = value.slice();
    }
    return this;
  }
  setDetune(value) {
    this.detune = value;
    if (this.source.detune === void 0)
      return;
    if (this.isPlaying === true) {
      this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
    }
    return this;
  }
  getDetune() {
    return this.detune;
  }
  getFilter() {
    return this.getFilters()[0];
  }
  setFilter(filter) {
    return this.setFilters(filter ? [filter] : []);
  }
  setPlaybackRate(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.playbackRate = value;
    if (this.isPlaying === true) {
      this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
    }
    return this;
  }
  getPlaybackRate() {
    return this.playbackRate;
  }
  onEnded() {
    this.isPlaying = false;
  }
  getLoop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return false;
    }
    return this.loop;
  }
  setLoop(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.loop = value;
    if (this.isPlaying === true) {
      this.source.loop = this.loop;
    }
    return this;
  }
  setLoopStart(value) {
    this.loopStart = value;
    return this;
  }
  setLoopEnd(value) {
    this.loopEnd = value;
    return this;
  }
  getVolume() {
    return this.gain.gain.value;
  }
  setVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
}
class PropertyMixer {
  constructor(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    switch (typeName) {
      case "quaternion":
        mixFunction = this._slerp;
        mixFunctionAdditive = this._slerpAdditive;
        setIdentity = this._setAdditiveIdentityQuaternion;
        this.buffer = new Float64Array(valueSize * 6);
        this._workIndex = 5;
        break;
      case "string":
      case "bool":
        mixFunction = this._select;
        mixFunctionAdditive = this._select;
        setIdentity = this._setAdditiveIdentityOther;
        this.buffer = new Array(valueSize * 5);
        break;
      default:
        mixFunction = this._lerp;
        mixFunctionAdditive = this._lerpAdditive;
        setIdentity = this._setAdditiveIdentityNumeric;
        this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
  }
  accumulate(accuIndex, weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
    let currentWeight = this.cumulativeWeight;
    if (currentWeight === 0) {
      for (let i = 0; i !== stride; ++i) {
        buffer[offset + i] = buffer[i];
      }
      currentWeight = weight;
    } else {
      currentWeight += weight;
      const mix = weight / currentWeight;
      this._mixBufferRegion(buffer, offset, 0, mix, stride);
    }
    this.cumulativeWeight = currentWeight;
  }
  accumulateAdditive(weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
    if (this.cumulativeWeightAdditive === 0) {
      this._setIdentity();
    }
    this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
    this.cumulativeWeightAdditive += weight;
  }
  apply(accuIndex) {
    const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    if (weight < 1) {
      const originalValueOffset = stride * this._origIndex;
      this._mixBufferRegion(
        buffer,
        offset,
        originalValueOffset,
        1 - weight,
        stride
      );
    }
    if (weightAdditive > 0) {
      this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
    }
    for (let i = stride, e = stride + stride; i !== e; ++i) {
      if (buffer[i] !== buffer[i + stride]) {
        binding.setValue(buffer, offset);
        break;
      }
    }
  }
  saveOriginalState() {
    const binding = this.binding;
    const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
    binding.getValue(buffer, originalValueOffset);
    for (let i = stride, e = originalValueOffset; i !== e; ++i) {
      buffer[i] = buffer[originalValueOffset + i % stride];
    }
    this._setIdentity();
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
  }
  restoreOriginalState() {
    const originalValueOffset = this.valueSize * 3;
    this.binding.setValue(this.buffer, originalValueOffset);
  }
  _setAdditiveIdentityNumeric() {
    const startIndex = this._addIndex * this.valueSize;
    const endIndex = startIndex + this.valueSize;
    for (let i = startIndex; i < endIndex; i++) {
      this.buffer[i] = 0;
    }
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric();
    this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const startIndex = this._origIndex * this.valueSize;
    const targetIndex = this._addIndex * this.valueSize;
    for (let i = 0; i < this.valueSize; i++) {
      this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
  }
  _select(buffer, dstOffset, srcOffset, t, stride) {
    if (t >= 0.5) {
      for (let i = 0; i !== stride; ++i) {
        buffer[dstOffset + i] = buffer[srcOffset + i];
      }
    }
  }
  _slerp(buffer, dstOffset, srcOffset, t) {
    Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
  }
  _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
    const workOffset = this._workIndex * stride;
    Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
    Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
  }
  _lerp(buffer, dstOffset, srcOffset, t, stride) {
    const s = 1 - t;
    for (let i = 0; i !== stride; ++i) {
      const j = dstOffset + i;
      buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
    }
  }
  _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
    for (let i = 0; i !== stride; ++i) {
      const j = dstOffset + i;
      buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
    }
  }
}
const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
const _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
const _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
const _directoryRe = /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
const _nodeRe = /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
const _objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
const _propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
const _trackRe = new RegExp(
  "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
);
const _supportedObjectNames = ["material", "materials", "bones"];
class Composite {
  constructor(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
  }
  getValue(array, offset) {
    this.bind();
    const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
    if (binding !== void 0)
      binding.getValue(array, offset);
  }
  setValue(array, offset) {
    const bindings = this._bindings;
    for (let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
      bindings[i].setValue(array, offset);
    }
  }
  bind() {
    const bindings = this._bindings;
    for (let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
      bindings[i].bind();
    }
  }
  unbind() {
    const bindings = this._bindings;
    for (let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
      bindings[i].unbind();
    }
  }
}
class PropertyBinding {
  constructor(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
    this.rootNode = rootNode;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  static create(root, path, parsedPath) {
    if (!(root && root.isAnimationObjectGroup)) {
      return new PropertyBinding(root, path, parsedPath);
    } else {
      return new PropertyBinding.Composite(root, path, parsedPath);
    }
  }
  static sanitizeNodeName(name) {
    return name.replace(/\s/g, "_").replace(_reservedRe, "");
  }
  static parseTrackName(trackName) {
    const matches = _trackRe.exec(trackName);
    if (!matches) {
      throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
    }
    const results = {
      nodeName: matches[2],
      objectName: matches[3],
      objectIndex: matches[4],
      propertyName: matches[5],
      propertyIndex: matches[6]
    };
    const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
    if (lastDot !== void 0 && lastDot !== -1) {
      const objectName = results.nodeName.substring(lastDot + 1);
      if (_supportedObjectNames.indexOf(objectName) !== -1) {
        results.nodeName = results.nodeName.substring(0, lastDot);
        results.objectName = objectName;
      }
    }
    if (results.propertyName === null || results.propertyName.length === 0) {
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
    }
    return results;
  }
  static findNode(root, nodeName) {
    if (!nodeName || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {
      return root;
    }
    if (root.skeleton) {
      const bone = root.skeleton.getBoneByName(nodeName);
      if (bone !== void 0) {
        return bone;
      }
    }
    if (root.children) {
      const searchNodeSubtree = function(children) {
        for (let i = 0; i < children.length; i++) {
          const childNode = children[i];
          if (childNode.name === nodeName || childNode.uuid === nodeName) {
            return childNode;
          }
          const result = searchNodeSubtree(childNode.children);
          if (result)
            return result;
        }
        return null;
      };
      const subTreeNode = searchNodeSubtree(root.children);
      if (subTreeNode) {
        return subTreeNode;
      }
    }
    return null;
  }
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  _getValue_direct(buffer, offset) {
    buffer[offset] = this.node[this.propertyName];
  }
  _getValue_array(buffer, offset) {
    const source = this.resolvedProperty;
    for (let i = 0, n = source.length; i !== n; ++i) {
      buffer[offset++] = source[i];
    }
  }
  _getValue_arrayElement(buffer, offset) {
    buffer[offset] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(buffer, offset) {
    this.resolvedProperty.toArray(buffer, offset);
  }
  _setValue_direct(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
  }
  _setValue_direct_setNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _setValue_array(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i = 0, n = dest.length; i !== n; ++i) {
      dest[i] = buffer[offset++];
    }
  }
  _setValue_array_setNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i = 0, n = dest.length; i !== n; ++i) {
      dest[i] = buffer[offset++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i = 0, n = dest.length; i !== n; ++i) {
      dest[i] = buffer[offset++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _setValue_arrayElement(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
  }
  _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _setValue_fromArray(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
  }
  _setValue_fromArray_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(targetArray, offset) {
    this.bind();
    this.getValue(targetArray, offset);
  }
  _setValue_unbound(sourceArray, offset) {
    this.bind();
    this.setValue(sourceArray, offset);
  }
  bind() {
    let targetObject = this.node;
    const parsedPath = this.parsedPath;
    const objectName = parsedPath.objectName;
    const propertyName = parsedPath.propertyName;
    let propertyIndex = parsedPath.propertyIndex;
    if (!targetObject) {
      targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
      this.node = targetObject;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!targetObject) {
      console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
      return;
    }
    if (objectName) {
      let objectIndex = parsedPath.objectIndex;
      switch (objectName) {
        case "materials":
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          targetObject = targetObject.material.materials;
          break;
        case "bones":
          if (!targetObject.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          targetObject = targetObject.skeleton.bones;
          for (let i = 0; i < targetObject.length; i++) {
            if (targetObject[i].name === objectIndex) {
              objectIndex = i;
              break;
            }
          }
          break;
        default:
          if (targetObject[objectName] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          targetObject = targetObject[objectName];
      }
      if (objectIndex !== void 0) {
        if (targetObject[objectIndex] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
          return;
        }
        targetObject = targetObject[objectIndex];
      }
    }
    const nodeProperty = targetObject[propertyName];
    if (nodeProperty === void 0) {
      const nodeName = parsedPath.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
      return;
    }
    let versioning = this.Versioning.None;
    this.targetObject = targetObject;
    if (targetObject.needsUpdate !== void 0) {
      versioning = this.Versioning.NeedsUpdate;
    } else if (targetObject.matrixWorldNeedsUpdate !== void 0) {
      versioning = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let bindingType = this.BindingType.Direct;
    if (propertyIndex !== void 0) {
      if (propertyName === "morphTargetInfluences") {
        if (!targetObject.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (targetObject.geometry.isBufferGeometry) {
          if (!targetObject.geometry.morphAttributes) {
            console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
            return;
          }
          if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
            propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
          }
        } else {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
          return;
        }
      }
      bindingType = this.BindingType.ArrayElement;
      this.resolvedProperty = nodeProperty;
      this.propertyIndex = propertyIndex;
    } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
      bindingType = this.BindingType.HasFromToArray;
      this.resolvedProperty = nodeProperty;
    } else if (Array.isArray(nodeProperty)) {
      bindingType = this.BindingType.EntireArray;
      this.resolvedProperty = nodeProperty;
    } else {
      this.propertyName = propertyName;
    }
    this.getValue = this.GetterByBindingType[bindingType];
    this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
  }
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
}
PropertyBinding.Composite = Composite;
PropertyBinding.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding.prototype.GetterByBindingType = [
  PropertyBinding.prototype._getValue_direct,
  PropertyBinding.prototype._getValue_array,
  PropertyBinding.prototype._getValue_arrayElement,
  PropertyBinding.prototype._getValue_toArray
];
PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
  [
    PropertyBinding.prototype._setValue_direct,
    PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    PropertyBinding.prototype._setValue_array,
    PropertyBinding.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    PropertyBinding.prototype._setValue_arrayElement,
    PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    PropertyBinding.prototype._setValue_fromArray,
    PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class AnimationAction {
  constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode) {
    this._mixer = mixer;
    this._clip = clip;
    this._localRoot = localRoot;
    this.blendMode = blendMode;
    const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
    const interpolantSettings = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
    for (let i = 0; i !== nTracks; ++i) {
      const interpolant = tracks[i].createInterpolant(null);
      interpolants[i] = interpolant;
      interpolant.settings = interpolantSettings;
    }
    this._interpolantSettings = interpolantSettings;
    this._interpolants = interpolants;
    this._propertyBindings = new Array(nTracks);
    this._cacheIndex = null;
    this._byClipCacheIndex = null;
    this._timeScaleInterpolant = null;
    this._weightInterpolant = null;
    this.loop = LoopRepeat;
    this._loopCount = -1;
    this._startTime = null;
    this.time = 0;
    this.timeScale = 1;
    this._effectiveTimeScale = 1;
    this.weight = 1;
    this._effectiveWeight = 1;
    this.repetitions = Infinity;
    this.paused = false;
    this.enabled = true;
    this.clampWhenFinished = false;
    this.zeroSlopeAtStart = true;
    this.zeroSlopeAtEnd = true;
  }
  play() {
    this._mixer._activateAction(this);
    return this;
  }
  stop() {
    this._mixer._deactivateAction(this);
    return this.reset();
  }
  reset() {
    this.paused = false;
    this.enabled = true;
    this.time = 0;
    this._loopCount = -1;
    this._startTime = null;
    return this.stopFading().stopWarping();
  }
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  startAt(time) {
    this._startTime = time;
    return this;
  }
  setLoop(mode, repetitions) {
    this.loop = mode;
    this.repetitions = repetitions;
    return this;
  }
  setEffectiveWeight(weight) {
    this.weight = weight;
    this._effectiveWeight = this.enabled ? weight : 0;
    return this.stopFading();
  }
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  fadeIn(duration) {
    return this._scheduleFading(duration, 0, 1);
  }
  fadeOut(duration) {
    return this._scheduleFading(duration, 1, 0);
  }
  crossFadeFrom(fadeOutAction, duration, warp) {
    fadeOutAction.fadeOut(duration);
    this.fadeIn(duration);
    if (warp) {
      const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
      fadeOutAction.warp(1, startEndRatio, duration);
      this.warp(endStartRatio, 1, duration);
    }
    return this;
  }
  crossFadeTo(fadeInAction, duration, warp) {
    return fadeInAction.crossFadeFrom(this, duration, warp);
  }
  stopFading() {
    const weightInterpolant = this._weightInterpolant;
    if (weightInterpolant !== null) {
      this._weightInterpolant = null;
      this._mixer._takeBackControlInterpolant(weightInterpolant);
    }
    return this;
  }
  setEffectiveTimeScale(timeScale) {
    this.timeScale = timeScale;
    this._effectiveTimeScale = this.paused ? 0 : timeScale;
    return this.stopWarping();
  }
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  setDuration(duration) {
    this.timeScale = this._clip.duration / duration;
    return this.stopWarping();
  }
  syncWith(action) {
    this.time = action.time;
    this.timeScale = action.timeScale;
    return this.stopWarping();
  }
  halt(duration) {
    return this.warp(this._effectiveTimeScale, 0, duration);
  }
  warp(startTimeScale, endTimeScale, duration) {
    const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
    let interpolant = this._timeScaleInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._timeScaleInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values = interpolant.sampleValues;
    times[0] = now;
    times[1] = now + duration;
    values[0] = startTimeScale / timeScale;
    values[1] = endTimeScale / timeScale;
    return this;
  }
  stopWarping() {
    const timeScaleInterpolant = this._timeScaleInterpolant;
    if (timeScaleInterpolant !== null) {
      this._timeScaleInterpolant = null;
      this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
    }
    return this;
  }
  getMixer() {
    return this._mixer;
  }
  getClip() {
    return this._clip;
  }
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  _update(time, deltaTime, timeDirection, accuIndex) {
    if (!this.enabled) {
      this._updateWeight(time);
      return;
    }
    const startTime = this._startTime;
    if (startTime !== null) {
      const timeRunning = (time - startTime) * timeDirection;
      if (timeRunning < 0 || timeDirection === 0) {
        return;
      }
      this._startTime = null;
      deltaTime = timeDirection * timeRunning;
    }
    deltaTime *= this._updateTimeScale(time);
    const clipTime = this._updateTime(deltaTime);
    const weight = this._updateWeight(time);
    if (weight > 0) {
      const interpolants = this._interpolants;
      const propertyMixers = this._propertyBindings;
      switch (this.blendMode) {
        case AdditiveAnimationBlendMode:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulateAdditive(weight);
          }
          break;
        case NormalAnimationBlendMode:
        default:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulate(accuIndex, weight);
          }
      }
    }
  }
  _updateWeight(time) {
    let weight = 0;
    if (this.enabled) {
      weight = this.weight;
      const interpolant = this._weightInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time)[0];
        weight *= interpolantValue;
        if (time > interpolant.parameterPositions[1]) {
          this.stopFading();
          if (interpolantValue === 0) {
            this.enabled = false;
          }
        }
      }
    }
    this._effectiveWeight = weight;
    return weight;
  }
  _updateTimeScale(time) {
    let timeScale = 0;
    if (!this.paused) {
      timeScale = this.timeScale;
      const interpolant = this._timeScaleInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time)[0];
        timeScale *= interpolantValue;
        if (time > interpolant.parameterPositions[1]) {
          this.stopWarping();
          if (timeScale === 0) {
            this.paused = true;
          } else {
            this.timeScale = timeScale;
          }
        }
      }
    }
    this._effectiveTimeScale = timeScale;
    return timeScale;
  }
  _updateTime(deltaTime) {
    const duration = this._clip.duration;
    const loop = this.loop;
    let time = this.time + deltaTime;
    let loopCount = this._loopCount;
    const pingPong = loop === LoopPingPong;
    if (deltaTime === 0) {
      if (loopCount === -1)
        return time;
      return pingPong && (loopCount & 1) === 1 ? duration - time : time;
    }
    if (loop === LoopOnce) {
      if (loopCount === -1) {
        this._loopCount = 0;
        this._setEndings(true, true, false);
      }
      handle_stop: {
        if (time >= duration) {
          time = duration;
        } else if (time < 0) {
          time = 0;
        } else {
          this.time = time;
          break handle_stop;
        }
        if (this.clampWhenFinished)
          this.paused = true;
        else
          this.enabled = false;
        this.time = time;
        this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: deltaTime < 0 ? -1 : 1
        });
      }
    } else {
      if (loopCount === -1) {
        if (deltaTime >= 0) {
          loopCount = 0;
          this._setEndings(true, this.repetitions === 0, pingPong);
        } else {
          this._setEndings(this.repetitions === 0, true, pingPong);
        }
      }
      if (time >= duration || time < 0) {
        const loopDelta = Math.floor(time / duration);
        time -= duration * loopDelta;
        loopCount += Math.abs(loopDelta);
        const pending = this.repetitions - loopCount;
        if (pending <= 0) {
          if (this.clampWhenFinished)
            this.paused = true;
          else
            this.enabled = false;
          time = deltaTime > 0 ? duration : 0;
          this.time = time;
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: deltaTime > 0 ? 1 : -1
          });
        } else {
          if (pending === 1) {
            const atStart = deltaTime < 0;
            this._setEndings(atStart, !atStart, pingPong);
          } else {
            this._setEndings(false, false, pingPong);
          }
          this._loopCount = loopCount;
          this.time = time;
          this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta
          });
        }
      } else {
        this.time = time;
      }
      if (pingPong && (loopCount & 1) === 1) {
        return duration - time;
      }
    }
    return time;
  }
  _setEndings(atStart, atEnd, pingPong) {
    const settings2 = this._interpolantSettings;
    if (pingPong) {
      settings2.endingStart = ZeroSlopeEnding;
      settings2.endingEnd = ZeroSlopeEnding;
    } else {
      if (atStart) {
        settings2.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings2.endingStart = WrapAroundEnding;
      }
      if (atEnd) {
        settings2.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings2.endingEnd = WrapAroundEnding;
      }
    }
  }
  _scheduleFading(duration, weightNow, weightThen) {
    const mixer = this._mixer, now = mixer.time;
    let interpolant = this._weightInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._weightInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values = interpolant.sampleValues;
    times[0] = now;
    values[0] = weightNow;
    times[1] = now + duration;
    values[1] = weightThen;
    return this;
  }
}
class AnimationMixer extends EventDispatcher$1 {
  constructor(root) {
    super();
    this._root = root;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1;
  }
  _bindAction(action, prototypeAction) {
    const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
    let bindingsByName = bindingsByRoot[rootUuid];
    if (bindingsByName === void 0) {
      bindingsByName = {};
      bindingsByRoot[rootUuid] = bindingsByName;
    }
    for (let i = 0; i !== nTracks; ++i) {
      const track = tracks[i], trackName = track.name;
      let binding = bindingsByName[trackName];
      if (binding !== void 0) {
        bindings[i] = binding;
      } else {
        binding = bindings[i];
        if (binding !== void 0) {
          if (binding._cacheIndex === null) {
            ++binding.referenceCount;
            this._addInactiveBinding(binding, rootUuid, trackName);
          }
          continue;
        }
        const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
        binding = new PropertyMixer(
          PropertyBinding.create(root, trackName, path),
          track.ValueTypeName,
          track.getValueSize()
        );
        ++binding.referenceCount;
        this._addInactiveBinding(binding, rootUuid, trackName);
        bindings[i] = binding;
      }
      interpolants[i].resultBuffer = binding.buffer;
    }
  }
  _activateAction(action) {
    if (!this._isActiveAction(action)) {
      if (action._cacheIndex === null) {
        const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
        this._bindAction(
          action,
          actionsForClip && actionsForClip.knownActions[0]
        );
        this._addInactiveAction(action, clipUuid, rootUuid);
      }
      const bindings = action._propertyBindings;
      for (let i = 0, n = bindings.length; i !== n; ++i) {
        const binding = bindings[i];
        if (binding.useCount++ === 0) {
          this._lendBinding(binding);
          binding.saveOriginalState();
        }
      }
      this._lendAction(action);
    }
  }
  _deactivateAction(action) {
    if (this._isActiveAction(action)) {
      const bindings = action._propertyBindings;
      for (let i = 0, n = bindings.length; i !== n; ++i) {
        const binding = bindings[i];
        if (--binding.useCount === 0) {
          binding.restoreOriginalState();
          this._takeBackBinding(binding);
        }
      }
      this._takeBackAction(action);
    }
  }
  _initMemoryManager() {
    this._actions = [];
    this._nActiveActions = 0;
    this._actionsByClip = {};
    this._bindings = [];
    this._nActiveBindings = 0;
    this._bindingsByRootAndName = {};
    this._controlInterpolants = [];
    this._nActiveControlInterpolants = 0;
    const scope = this;
    this.stats = {
      actions: {
        get total() {
          return scope._actions.length;
        },
        get inUse() {
          return scope._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return scope._bindings.length;
        },
        get inUse() {
          return scope._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return scope._controlInterpolants.length;
        },
        get inUse() {
          return scope._nActiveControlInterpolants;
        }
      }
    };
  }
  _isActiveAction(action) {
    const index = action._cacheIndex;
    return index !== null && index < this._nActiveActions;
  }
  _addInactiveAction(action, clipUuid, rootUuid) {
    const actions = this._actions, actionsByClip = this._actionsByClip;
    let actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip === void 0) {
      actionsForClip = {
        knownActions: [action],
        actionByRoot: {}
      };
      action._byClipCacheIndex = 0;
      actionsByClip[clipUuid] = actionsForClip;
    } else {
      const knownActions = actionsForClip.knownActions;
      action._byClipCacheIndex = knownActions.length;
      knownActions.push(action);
    }
    action._cacheIndex = actions.length;
    actions.push(action);
    actionsForClip.actionByRoot[rootUuid] = action;
  }
  _removeInactiveAction(action) {
    const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
    lastInactiveAction._cacheIndex = cacheIndex;
    actions[cacheIndex] = lastInactiveAction;
    actions.pop();
    action._cacheIndex = null;
    const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
    lastKnownAction._byClipCacheIndex = byClipCacheIndex;
    knownActionsForClip[byClipCacheIndex] = lastKnownAction;
    knownActionsForClip.pop();
    action._byClipCacheIndex = null;
    const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
    delete actionByRoot[rootUuid];
    if (knownActionsForClip.length === 0) {
      delete actionsByClip[clipUuid];
    }
    this._removeInactiveBindingsForAction(action);
  }
  _removeInactiveBindingsForAction(action) {
    const bindings = action._propertyBindings;
    for (let i = 0, n = bindings.length; i !== n; ++i) {
      const binding = bindings[i];
      if (--binding.referenceCount === 0) {
        this._removeInactiveBinding(binding);
      }
    }
  }
  _lendAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
    action._cacheIndex = lastActiveIndex;
    actions[lastActiveIndex] = action;
    firstInactiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = firstInactiveAction;
  }
  _takeBackAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
    action._cacheIndex = firstInactiveIndex;
    actions[firstInactiveIndex] = action;
    lastActiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = lastActiveAction;
  }
  _addInactiveBinding(binding, rootUuid, trackName) {
    const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
    let bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName === void 0) {
      bindingByName = {};
      bindingsByRoot[rootUuid] = bindingByName;
    }
    bindingByName[trackName] = binding;
    binding._cacheIndex = bindings.length;
    bindings.push(binding);
  }
  _removeInactiveBinding(binding) {
    const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
    lastInactiveBinding._cacheIndex = cacheIndex;
    bindings[cacheIndex] = lastInactiveBinding;
    bindings.pop();
    delete bindingByName[trackName];
    if (Object.keys(bindingByName).length === 0) {
      delete bindingsByRoot[rootUuid];
    }
  }
  _lendBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
    binding._cacheIndex = lastActiveIndex;
    bindings[lastActiveIndex] = binding;
    firstInactiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = firstInactiveBinding;
  }
  _takeBackBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
    binding._cacheIndex = firstInactiveIndex;
    bindings[firstInactiveIndex] = binding;
    lastActiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = lastActiveBinding;
  }
  _lendControlInterpolant() {
    const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
    let interpolant = interpolants[lastActiveIndex];
    if (interpolant === void 0) {
      interpolant = new LinearInterpolant(
        new Float32Array(2),
        new Float32Array(2),
        1,
        this._controlInterpolantsResultBuffer
      );
      interpolant.__cacheIndex = lastActiveIndex;
      interpolants[lastActiveIndex] = interpolant;
    }
    return interpolant;
  }
  _takeBackControlInterpolant(interpolant) {
    const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
    interpolant.__cacheIndex = firstInactiveIndex;
    interpolants[firstInactiveIndex] = interpolant;
    lastActiveInterpolant.__cacheIndex = prevIndex;
    interpolants[prevIndex] = lastActiveInterpolant;
  }
  clipAction(clip, optionalRoot, blendMode) {
    const root = optionalRoot || this._root, rootUuid = root.uuid;
    let clipObject = typeof clip === "string" ? AnimationClip.findByName(root, clip) : clip;
    const clipUuid = clipObject !== null ? clipObject.uuid : clip;
    const actionsForClip = this._actionsByClip[clipUuid];
    let prototypeAction = null;
    if (blendMode === void 0) {
      if (clipObject !== null) {
        blendMode = clipObject.blendMode;
      } else {
        blendMode = NormalAnimationBlendMode;
      }
    }
    if (actionsForClip !== void 0) {
      const existingAction = actionsForClip.actionByRoot[rootUuid];
      if (existingAction !== void 0 && existingAction.blendMode === blendMode) {
        return existingAction;
      }
      prototypeAction = actionsForClip.knownActions[0];
      if (clipObject === null)
        clipObject = prototypeAction._clip;
    }
    if (clipObject === null)
      return null;
    const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
    this._bindAction(newAction, prototypeAction);
    this._addInactiveAction(newAction, clipUuid, rootUuid);
    return newAction;
  }
  existingAction(clip, optionalRoot) {
    const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? AnimationClip.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      return actionsForClip.actionByRoot[rootUuid] || null;
    }
    return null;
  }
  stopAllAction() {
    const actions = this._actions, nActions = this._nActiveActions;
    for (let i = nActions - 1; i >= 0; --i) {
      actions[i].stop();
    }
    return this;
  }
  update(deltaTime) {
    deltaTime *= this.timeScale;
    const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
    for (let i = 0; i !== nActions; ++i) {
      const action = actions[i];
      action._update(time, deltaTime, timeDirection, accuIndex);
    }
    const bindings = this._bindings, nBindings = this._nActiveBindings;
    for (let i = 0; i !== nBindings; ++i) {
      bindings[i].apply(accuIndex);
    }
    return this;
  }
  setTime(timeInSeconds) {
    this.time = 0;
    for (let i = 0; i < this._actions.length; i++) {
      this._actions[i].time = 0;
    }
    return this.update(timeInSeconds);
  }
  getRoot() {
    return this._root;
  }
  uncacheClip(clip) {
    const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      const actionsToRemove = actionsForClip.knownActions;
      for (let i = 0, n = actionsToRemove.length; i !== n; ++i) {
        const action = actionsToRemove[i];
        this._deactivateAction(action);
        const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
        action._cacheIndex = null;
        action._byClipCacheIndex = null;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        this._removeInactiveBindingsForAction(action);
      }
      delete actionsByClip[clipUuid];
    }
  }
  uncacheRoot(root) {
    const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
    for (const clipUuid in actionsByClip) {
      const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
      if (action !== void 0) {
        this._deactivateAction(action);
        this._removeInactiveAction(action);
      }
    }
    const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName !== void 0) {
      for (const trackName in bindingByName) {
        const binding = bindingByName[trackName];
        binding.restoreOriginalState();
        this._removeInactiveBinding(binding);
      }
    }
  }
  uncacheAction(clip, optionalRoot) {
    const action = this.existingAction(clip, optionalRoot);
    if (action !== null) {
      this._deactivateAction(action);
      this._removeInactiveAction(action);
    }
  }
}
AnimationMixer.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class InstancedInterleavedBuffer extends InterleavedBuffer {
  constructor(array, stride, meshPerAttribute = 1) {
    super(array, stride);
    this.meshPerAttribute = meshPerAttribute || 1;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  clone(data) {
    const ib = super.clone(data);
    ib.meshPerAttribute = this.meshPerAttribute;
    return ib;
  }
  toJSON(data) {
    const json = super.toJSON(data);
    json.isInstancedInterleavedBuffer = true;
    json.meshPerAttribute = this.meshPerAttribute;
    return json;
  }
}
InstancedInterleavedBuffer.prototype.isInstancedInterleavedBuffer = true;
class Raycaster {
  constructor(origin, direction, near = 0, far = Infinity) {
    this.ray = new Ray(origin, direction);
    this.near = near;
    this.far = far;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  set(origin, direction) {
    this.ray.set(origin, direction);
  }
  setFromCamera(coords, camera) {
    if (camera && camera.isPerspectiveCamera) {
      this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
      this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
      this.camera = camera;
    } else if (camera && camera.isOrthographicCamera) {
      this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
      this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
      this.camera = camera;
    } else {
      console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
  }
  intersectObject(object, recursive = false, intersects2 = []) {
    intersectObject(object, this, intersects2, recursive);
    intersects2.sort(ascSort);
    return intersects2;
  }
  intersectObjects(objects, recursive = false, intersects2 = []) {
    for (let i = 0, l = objects.length; i < l; i++) {
      intersectObject(objects[i], this, intersects2, recursive);
    }
    intersects2.sort(ascSort);
    return intersects2;
  }
}
function ascSort(a, b) {
  return a.distance - b.distance;
}
function intersectObject(object, raycaster, intersects2, recursive) {
  if (object.layers.test(raycaster.layers)) {
    object.raycast(raycaster, intersects2);
  }
  if (recursive === true) {
    const children = object.children;
    for (let i = 0, l = children.length; i < l; i++) {
      intersectObject(children[i], raycaster, intersects2, true);
    }
  }
}
class Spherical {
  constructor(radius = 1, phi = 0, theta = 0) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  set(radius, phi, theta) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.phi = other.phi;
    this.theta = other.theta;
    return this;
  }
  makeSafe() {
    const EPS = 1e-6;
    this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
    return this;
  }
  setFromVector3(v) {
    return this.setFromCartesianCoords(v.x, v.y, v.z);
  }
  setFromCartesianCoords(x, y, z) {
    this.radius = Math.sqrt(x * x + y * y + z * z);
    if (this.radius === 0) {
      this.theta = 0;
      this.phi = 0;
    } else {
      this.theta = Math.atan2(x, z);
      this.phi = Math.acos(clamp$1(y / this.radius, -1, 1));
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class ImmediateRenderObject extends Object3D {
  constructor(material) {
    super();
    this.material = material;
    this.render = function() {
    };
    this.hasPositions = false;
    this.hasNormals = false;
    this.hasColors = false;
    this.hasUvs = false;
    this.positionArray = null;
    this.normalArray = null;
    this.colorArray = null;
    this.uvArray = null;
    this.count = 0;
  }
}
ImmediateRenderObject.prototype.isImmediateRenderObject = true;
const _vector$2 = /* @__PURE__ */ new Vector3$1();
const _boneMatrix = /* @__PURE__ */ new Matrix4();
const _matrixWorldInv = /* @__PURE__ */ new Matrix4();
class SkeletonHelper extends LineSegments {
  constructor(object) {
    const bones = getBoneList(object);
    const geometry = new BufferGeometry();
    const vertices = [];
    const colors = [];
    const color1 = new Color(0, 0, 1);
    const color2 = new Color(0, 1, 0);
    for (let i = 0; i < bones.length; i++) {
      const bone = bones[i];
      if (bone.parent && bone.parent.isBone) {
        vertices.push(0, 0, 0);
        vertices.push(0, 0, 0);
        colors.push(color1.r, color1.g, color1.b);
        colors.push(color2.r, color2.g, color2.b);
      }
    }
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors, 3));
    const material = new LineBasicMaterial({ vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true });
    super(geometry, material);
    this.type = "SkeletonHelper";
    this.isSkeletonHelper = true;
    this.root = object;
    this.bones = bones;
    this.matrix = object.matrixWorld;
    this.matrixAutoUpdate = false;
  }
  updateMatrixWorld(force) {
    const bones = this.bones;
    const geometry = this.geometry;
    const position = geometry.getAttribute("position");
    _matrixWorldInv.copy(this.root.matrixWorld).invert();
    for (let i = 0, j = 0; i < bones.length; i++) {
      const bone = bones[i];
      if (bone.parent && bone.parent.isBone) {
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position.setXYZ(j, _vector$2.x, _vector$2.y, _vector$2.z);
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position.setXYZ(j + 1, _vector$2.x, _vector$2.y, _vector$2.z);
        j += 2;
      }
    }
    geometry.getAttribute("position").needsUpdate = true;
    super.updateMatrixWorld(force);
  }
}
function getBoneList(object) {
  const boneList = [];
  if (object && object.isBone) {
    boneList.push(object);
  }
  for (let i = 0; i < object.children.length; i++) {
    boneList.push.apply(boneList, getBoneList(object.children[i]));
  }
  return boneList;
}
class GridHelper extends LineSegments {
  constructor(size = 10, divisions = 10, color1 = 4473924, color2 = 8947848) {
    color1 = new Color(color1);
    color2 = new Color(color2);
    const center = divisions / 2;
    const step = size / divisions;
    const halfSize = size / 2;
    const vertices = [], colors = [];
    for (let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step) {
      vertices.push(-halfSize, 0, k, halfSize, 0, k);
      vertices.push(k, 0, -halfSize, k, 0, halfSize);
      const color = i === center ? color1 : color2;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
    }
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "GridHelper";
  }
}
const _vector = /* @__PURE__ */ new Vector3$1();
const _camera = /* @__PURE__ */ new Camera$1();
class CameraHelper extends LineSegments {
  constructor(camera) {
    const geometry = new BufferGeometry();
    const material = new LineBasicMaterial({ color: 16777215, vertexColors: true, toneMapped: false });
    const vertices = [];
    const colors = [];
    const pointMap = {};
    const colorFrustum = new Color(16755200);
    const colorCone = new Color(16711680);
    const colorUp = new Color(43775);
    const colorTarget = new Color(16777215);
    const colorCross = new Color(3355443);
    addLine("n1", "n2", colorFrustum);
    addLine("n2", "n4", colorFrustum);
    addLine("n4", "n3", colorFrustum);
    addLine("n3", "n1", colorFrustum);
    addLine("f1", "f2", colorFrustum);
    addLine("f2", "f4", colorFrustum);
    addLine("f4", "f3", colorFrustum);
    addLine("f3", "f1", colorFrustum);
    addLine("n1", "f1", colorFrustum);
    addLine("n2", "f2", colorFrustum);
    addLine("n3", "f3", colorFrustum);
    addLine("n4", "f4", colorFrustum);
    addLine("p", "n1", colorCone);
    addLine("p", "n2", colorCone);
    addLine("p", "n3", colorCone);
    addLine("p", "n4", colorCone);
    addLine("u1", "u2", colorUp);
    addLine("u2", "u3", colorUp);
    addLine("u3", "u1", colorUp);
    addLine("c", "t", colorTarget);
    addLine("p", "c", colorCross);
    addLine("cn1", "cn2", colorCross);
    addLine("cn3", "cn4", colorCross);
    addLine("cf1", "cf2", colorCross);
    addLine("cf3", "cf4", colorCross);
    function addLine(a, b, color) {
      addPoint(a, color);
      addPoint(b, color);
    }
    function addPoint(id, color) {
      vertices.push(0, 0, 0);
      colors.push(color.r, color.g, color.b);
      if (pointMap[id] === void 0) {
        pointMap[id] = [];
      }
      pointMap[id].push(vertices.length / 3 - 1);
    }
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors, 3));
    super(geometry, material);
    this.type = "CameraHelper";
    this.camera = camera;
    if (this.camera.updateProjectionMatrix)
      this.camera.updateProjectionMatrix();
    this.matrix = camera.matrixWorld;
    this.matrixAutoUpdate = false;
    this.pointMap = pointMap;
    this.update();
  }
  update() {
    const geometry = this.geometry;
    const pointMap = this.pointMap;
    const w = 1, h = 1;
    _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
    setPoint("c", pointMap, geometry, _camera, 0, 0, -1);
    setPoint("t", pointMap, geometry, _camera, 0, 0, 1);
    setPoint("n1", pointMap, geometry, _camera, -w, -h, -1);
    setPoint("n2", pointMap, geometry, _camera, w, -h, -1);
    setPoint("n3", pointMap, geometry, _camera, -w, h, -1);
    setPoint("n4", pointMap, geometry, _camera, w, h, -1);
    setPoint("f1", pointMap, geometry, _camera, -w, -h, 1);
    setPoint("f2", pointMap, geometry, _camera, w, -h, 1);
    setPoint("f3", pointMap, geometry, _camera, -w, h, 1);
    setPoint("f4", pointMap, geometry, _camera, w, h, 1);
    setPoint("u1", pointMap, geometry, _camera, w * 0.7, h * 1.1, -1);
    setPoint("u2", pointMap, geometry, _camera, -w * 0.7, h * 1.1, -1);
    setPoint("u3", pointMap, geometry, _camera, 0, h * 2, -1);
    setPoint("cf1", pointMap, geometry, _camera, -w, 0, 1);
    setPoint("cf2", pointMap, geometry, _camera, w, 0, 1);
    setPoint("cf3", pointMap, geometry, _camera, 0, -h, 1);
    setPoint("cf4", pointMap, geometry, _camera, 0, h, 1);
    setPoint("cn1", pointMap, geometry, _camera, -w, 0, -1);
    setPoint("cn2", pointMap, geometry, _camera, w, 0, -1);
    setPoint("cn3", pointMap, geometry, _camera, 0, -h, -1);
    setPoint("cn4", pointMap, geometry, _camera, 0, h, -1);
    geometry.getAttribute("position").needsUpdate = true;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
function setPoint(point, pointMap, geometry, camera, x, y, z) {
  _vector.set(x, y, z).unproject(camera);
  const points = pointMap[point];
  if (points !== void 0) {
    const position = geometry.getAttribute("position");
    for (let i = 0, l = points.length; i < l; i++) {
      position.setXYZ(points[i], _vector.x, _vector.y, _vector.z);
    }
  }
}
const _floatView = new Float32Array(1);
new Int32Array(_floatView.buffer);
const backgroundMaterial = new MeshBasicMaterial({
  side: BackSide,
  depthWrite: false,
  depthTest: false
});
new Mesh(new BoxGeometry(), backgroundMaterial);
Curve.create = function(construct, getPoint) {
  console.log("THREE.Curve.create() has been deprecated");
  construct.prototype = Object.create(Curve.prototype);
  construct.prototype.constructor = construct;
  construct.prototype.getPoint = getPoint;
  return construct;
};
Path.prototype.fromPoints = function(points) {
  console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
  return this.setFromPoints(points);
};
GridHelper.prototype.setColors = function() {
  console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
};
SkeletonHelper.prototype.update = function() {
  console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
};
Loader$1.prototype.extractUrlBase = function(url2) {
  console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
  return LoaderUtils.extractUrlBase(url2);
};
Loader$1.Handlers = {
  add: function() {
    console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
  },
  get: function() {
    console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
  }
};
Box3.prototype.center = function(optionalTarget) {
  console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
  return this.getCenter(optionalTarget);
};
Box3.prototype.empty = function() {
  console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Box3.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Box3.prototype.isIntersectionSphere = function(sphere) {
  console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
  return this.intersectsSphere(sphere);
};
Box3.prototype.size = function(optionalTarget) {
  console.warn("THREE.Box3: .size() has been renamed to .getSize().");
  return this.getSize(optionalTarget);
};
Sphere.prototype.empty = function() {
  console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Frustum.prototype.setFromMatrix = function(m) {
  console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().");
  return this.setFromProjectionMatrix(m);
};
Matrix3$1.prototype.flattenToArrayOffset = function(array, offset) {
  console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
  return this.toArray(array, offset);
};
Matrix3$1.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
  return vector.applyMatrix3(this);
};
Matrix3$1.prototype.multiplyVector3Array = function() {
  console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
};
Matrix3$1.prototype.applyToBufferAttribute = function(attribute) {
  console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.");
  return attribute.applyMatrix3(this);
};
Matrix3$1.prototype.applyToVector3Array = function() {
  console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
};
Matrix3$1.prototype.getInverse = function(matrix) {
  console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
  return this.copy(matrix).invert();
};
Matrix4.prototype.extractPosition = function(m) {
  console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
  return this.copyPosition(m);
};
Matrix4.prototype.flattenToArrayOffset = function(array, offset) {
  console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
  return this.toArray(array, offset);
};
Matrix4.prototype.getPosition = function() {
  console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
  return new Vector3$1().setFromMatrixColumn(this, 3);
};
Matrix4.prototype.setRotationFromQuaternion = function(q) {
  console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
  return this.makeRotationFromQuaternion(q);
};
Matrix4.prototype.multiplyToArray = function() {
  console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
};
Matrix4.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix4.prototype.multiplyVector4 = function(vector) {
  console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix4.prototype.multiplyVector3Array = function() {
  console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
};
Matrix4.prototype.rotateAxis = function(v) {
  console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
  v.transformDirection(this);
};
Matrix4.prototype.crossVector = function(vector) {
  console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix4.prototype.translate = function() {
  console.error("THREE.Matrix4: .translate() has been removed.");
};
Matrix4.prototype.rotateX = function() {
  console.error("THREE.Matrix4: .rotateX() has been removed.");
};
Matrix4.prototype.rotateY = function() {
  console.error("THREE.Matrix4: .rotateY() has been removed.");
};
Matrix4.prototype.rotateZ = function() {
  console.error("THREE.Matrix4: .rotateZ() has been removed.");
};
Matrix4.prototype.rotateByAxis = function() {
  console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
};
Matrix4.prototype.applyToBufferAttribute = function(attribute) {
  console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.");
  return attribute.applyMatrix4(this);
};
Matrix4.prototype.applyToVector3Array = function() {
  console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
};
Matrix4.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
  console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
  return this.makePerspective(left, right, top, bottom, near, far);
};
Matrix4.prototype.getInverse = function(matrix) {
  console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
  return this.copy(matrix).invert();
};
Plane.prototype.isIntersectionLine = function(line) {
  console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
  return this.intersectsLine(line);
};
Quaternion.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
  return vector.applyQuaternion(this);
};
Quaternion.prototype.inverse = function() {
  console.warn("THREE.Quaternion: .inverse() has been renamed to invert().");
  return this.invert();
};
Ray.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Ray.prototype.isIntersectionPlane = function(plane) {
  console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
  return this.intersectsPlane(plane);
};
Ray.prototype.isIntersectionSphere = function(sphere) {
  console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
  return this.intersectsSphere(sphere);
};
Triangle.prototype.area = function() {
  console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
  return this.getArea();
};
Triangle.prototype.barycoordFromPoint = function(point, target) {
  console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
  return this.getBarycoord(point, target);
};
Triangle.prototype.midpoint = function(target) {
  console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
  return this.getMidpoint(target);
};
Triangle.prototypenormal = function(target) {
  console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
  return this.getNormal(target);
};
Triangle.prototype.plane = function(target) {
  console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
  return this.getPlane(target);
};
Triangle.barycoordFromPoint = function(point, a, b, c, target) {
  console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
  return Triangle.getBarycoord(point, a, b, c, target);
};
Triangle.normal = function(a, b, c, target) {
  console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
  return Triangle.getNormal(a, b, c, target);
};
Shape.prototype.extractAllPoints = function(divisions) {
  console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
  return this.extractPoints(divisions);
};
Shape.prototype.extrude = function(options) {
  console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
  return new ExtrudeGeometry(this, options);
};
Shape.prototype.makeGeometry = function(options) {
  console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
  return new ShapeGeometry(this, options);
};
Vector2$1.prototype.fromAttribute = function(attribute, index, offset) {
  console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index, offset);
};
Vector2$1.prototype.distanceToManhattan = function(v) {
  console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
  return this.manhattanDistanceTo(v);
};
Vector2$1.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Vector3$1.prototype.setEulerFromRotationMatrix = function() {
  console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
};
Vector3$1.prototype.setEulerFromQuaternion = function() {
  console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
};
Vector3$1.prototype.getPositionFromMatrix = function(m) {
  console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
  return this.setFromMatrixPosition(m);
};
Vector3$1.prototype.getScaleFromMatrix = function(m) {
  console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
  return this.setFromMatrixScale(m);
};
Vector3$1.prototype.getColumnFromMatrix = function(index, matrix) {
  console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
  return this.setFromMatrixColumn(matrix, index);
};
Vector3$1.prototype.applyProjection = function(m) {
  console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
  return this.applyMatrix4(m);
};
Vector3$1.prototype.fromAttribute = function(attribute, index, offset) {
  console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index, offset);
};
Vector3$1.prototype.distanceToManhattan = function(v) {
  console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
  return this.manhattanDistanceTo(v);
};
Vector3$1.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Vector4.prototype.fromAttribute = function(attribute, index, offset) {
  console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index, offset);
};
Vector4.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Object3D.prototype.getChildByName = function(name) {
  console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
  return this.getObjectByName(name);
};
Object3D.prototype.renderDepth = function() {
  console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
};
Object3D.prototype.translate = function(distance, axis) {
  console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
  return this.translateOnAxis(axis, distance);
};
Object3D.prototype.getWorldRotation = function() {
  console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
};
Object3D.prototype.applyMatrix = function(matrix) {
  console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().");
  return this.applyMatrix4(matrix);
};
Object.defineProperties(Object3D.prototype, {
  eulerOrder: {
    get: function() {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
      return this.rotation.order;
    },
    set: function(value) {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
      this.rotation.order = value;
    }
  },
  useQuaternion: {
    get: function() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    },
    set: function() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    }
  }
});
Mesh.prototype.setDrawMode = function() {
  console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
};
Object.defineProperties(Mesh.prototype, {
  drawMode: {
    get: function() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.");
      return TrianglesDrawMode;
    },
    set: function() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
    }
  }
});
SkinnedMesh.prototype.initBones = function() {
  console.error("THREE.SkinnedMesh: initBones() has been removed.");
};
PerspectiveCamera.prototype.setLens = function(focalLength, filmGauge) {
  console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
  if (filmGauge !== void 0)
    this.filmGauge = filmGauge;
  this.setFocalLength(focalLength);
};
Object.defineProperties(Light.prototype, {
  onlyShadow: {
    set: function() {
      console.warn("THREE.Light: .onlyShadow has been removed.");
    }
  },
  shadowCameraFov: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
      this.shadow.camera.fov = value;
    }
  },
  shadowCameraLeft: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
      this.shadow.camera.left = value;
    }
  },
  shadowCameraRight: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
      this.shadow.camera.right = value;
    }
  },
  shadowCameraTop: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
      this.shadow.camera.top = value;
    }
  },
  shadowCameraBottom: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
      this.shadow.camera.bottom = value;
    }
  },
  shadowCameraNear: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
      this.shadow.camera.near = value;
    }
  },
  shadowCameraFar: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
      this.shadow.camera.far = value;
    }
  },
  shadowCameraVisible: {
    set: function() {
      console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
    }
  },
  shadowBias: {
    set: function(value) {
      console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
      this.shadow.bias = value;
    }
  },
  shadowDarkness: {
    set: function() {
      console.warn("THREE.Light: .shadowDarkness has been removed.");
    }
  },
  shadowMapWidth: {
    set: function(value) {
      console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
      this.shadow.mapSize.width = value;
    }
  },
  shadowMapHeight: {
    set: function(value) {
      console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
      this.shadow.mapSize.height = value;
    }
  }
});
Object.defineProperties(BufferAttribute.prototype, {
  length: {
    get: function() {
      console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
      return this.array.length;
    }
  },
  dynamic: {
    get: function() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
      return this.usage === DynamicDrawUsage;
    },
    set: function() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
      this.setUsage(DynamicDrawUsage);
    }
  }
});
BufferAttribute.prototype.setDynamic = function(value) {
  console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.");
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};
BufferAttribute.prototype.copyIndicesArray = function() {
  console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, BufferAttribute.prototype.setArray = function() {
  console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
BufferGeometry.prototype.addIndex = function(index) {
  console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
  this.setIndex(index);
};
BufferGeometry.prototype.addAttribute = function(name, attribute) {
  console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().");
  if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
    console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).");
    return this.setAttribute(name, new BufferAttribute(arguments[1], arguments[2]));
  }
  if (name === "index") {
    console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.");
    this.setIndex(attribute);
    return this;
  }
  return this.setAttribute(name, attribute);
};
BufferGeometry.prototype.addDrawCall = function(start, count, indexOffset) {
  if (indexOffset !== void 0) {
    console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
  }
  console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
  this.addGroup(start, count);
};
BufferGeometry.prototype.clearDrawCalls = function() {
  console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
  this.clearGroups();
};
BufferGeometry.prototype.computeOffsets = function() {
  console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
};
BufferGeometry.prototype.removeAttribute = function(name) {
  console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().");
  return this.deleteAttribute(name);
};
BufferGeometry.prototype.applyMatrix = function(matrix) {
  console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().");
  return this.applyMatrix4(matrix);
};
Object.defineProperties(BufferGeometry.prototype, {
  drawcalls: {
    get: function() {
      console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
      return this.groups;
    }
  },
  offsets: {
    get: function() {
      console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
      return this.groups;
    }
  }
});
InterleavedBuffer.prototype.setDynamic = function(value) {
  console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.");
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};
InterleavedBuffer.prototype.setArray = function() {
  console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
ExtrudeGeometry.prototype.getArrays = function() {
  console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
};
ExtrudeGeometry.prototype.addShapeList = function() {
  console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
};
ExtrudeGeometry.prototype.addShape = function() {
  console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
};
Scene$1.prototype.dispose = function() {
  console.error("THREE.Scene: .dispose() has been removed.");
};
Object.defineProperties(Material.prototype, {
  wrapAround: {
    get: function() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    },
    set: function() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    }
  },
  overdraw: {
    get: function() {
      console.warn("THREE.Material: .overdraw has been removed.");
    },
    set: function() {
      console.warn("THREE.Material: .overdraw has been removed.");
    }
  },
  wrapRGB: {
    get: function() {
      console.warn("THREE.Material: .wrapRGB has been removed.");
      return new Color();
    }
  },
  shading: {
    get: function() {
      console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
    },
    set: function(value) {
      console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
      this.flatShading = value === FlatShading;
    }
  },
  stencilMask: {
    get: function() {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
      return this.stencilFuncMask;
    },
    set: function(value) {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
      this.stencilFuncMask = value;
    }
  }
});
Object.defineProperties(ShaderMaterial.prototype, {
  derivatives: {
    get: function() {
      console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
      return this.extensions.derivatives;
    },
    set: function(value) {
      console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
      this.extensions.derivatives = value;
    }
  }
});
WebGLRenderer.prototype.clearTarget = function(renderTarget, color, depth, stencil) {
  console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.");
  this.setRenderTarget(renderTarget);
  this.clear(color, depth, stencil);
};
WebGLRenderer.prototype.animate = function(callback) {
  console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
  this.setAnimationLoop(callback);
};
WebGLRenderer.prototype.getCurrentRenderTarget = function() {
  console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
  return this.getRenderTarget();
};
WebGLRenderer.prototype.getMaxAnisotropy = function() {
  console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
  return this.capabilities.getMaxAnisotropy();
};
WebGLRenderer.prototype.getPrecision = function() {
  console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
  return this.capabilities.precision;
};
WebGLRenderer.prototype.resetGLState = function() {
  console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
  return this.state.reset();
};
WebGLRenderer.prototype.supportsFloatTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
  return this.extensions.get("OES_texture_float");
};
WebGLRenderer.prototype.supportsHalfFloatTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
  return this.extensions.get("OES_texture_half_float");
};
WebGLRenderer.prototype.supportsStandardDerivatives = function() {
  console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
  return this.extensions.get("OES_standard_derivatives");
};
WebGLRenderer.prototype.supportsCompressedTextureS3TC = function() {
  console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
  return this.extensions.get("WEBGL_compressed_texture_s3tc");
};
WebGLRenderer.prototype.supportsCompressedTexturePVRTC = function() {
  console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
  return this.extensions.get("WEBGL_compressed_texture_pvrtc");
};
WebGLRenderer.prototype.supportsBlendMinMax = function() {
  console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
  return this.extensions.get("EXT_blend_minmax");
};
WebGLRenderer.prototype.supportsVertexTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
  return this.capabilities.vertexTextures;
};
WebGLRenderer.prototype.supportsInstancedArrays = function() {
  console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
  return this.extensions.get("ANGLE_instanced_arrays");
};
WebGLRenderer.prototype.enableScissorTest = function(boolean) {
  console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
  this.setScissorTest(boolean);
};
WebGLRenderer.prototype.initMaterial = function() {
  console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
};
WebGLRenderer.prototype.addPrePlugin = function() {
  console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
};
WebGLRenderer.prototype.addPostPlugin = function() {
  console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
};
WebGLRenderer.prototype.updateShadowMap = function() {
  console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
};
WebGLRenderer.prototype.setFaceCulling = function() {
  console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
};
WebGLRenderer.prototype.allocTextureUnit = function() {
  console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
};
WebGLRenderer.prototype.setTexture = function() {
  console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
};
WebGLRenderer.prototype.setTexture2D = function() {
  console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
};
WebGLRenderer.prototype.setTextureCube = function() {
  console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
};
WebGLRenderer.prototype.getActiveMipMapLevel = function() {
  console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().");
  return this.getActiveMipmapLevel();
};
Object.defineProperties(WebGLRenderer.prototype, {
  shadowMapEnabled: {
    get: function() {
      return this.shadowMap.enabled;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
      this.shadowMap.enabled = value;
    }
  },
  shadowMapType: {
    get: function() {
      return this.shadowMap.type;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
      this.shadowMap.type = value;
    }
  },
  shadowMapCullFace: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  context: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.");
      return this.getContext();
    }
  },
  vr: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr");
      return this.xr;
    }
  },
  gammaInput: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
      return false;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
    }
  },
  gammaOutput: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
      return false;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
      this.outputEncoding = value === true ? sRGBEncoding : LinearEncoding$1;
    }
  },
  toneMappingWhitePoint: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
      return 1;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
    }
  }
});
Object.defineProperties(WebGLShadowMap.prototype, {
  cullFace: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  renderReverseSided: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    }
  },
  renderSingleSided: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    }
  }
});
Object.defineProperties(WebGLRenderTarget.prototype, {
  wrapS: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
      return this.texture.wrapS;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
      this.texture.wrapS = value;
    }
  },
  wrapT: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
      return this.texture.wrapT;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
      this.texture.wrapT = value;
    }
  },
  magFilter: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
      return this.texture.magFilter;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
      this.texture.magFilter = value;
    }
  },
  minFilter: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
      return this.texture.minFilter;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
      this.texture.minFilter = value;
    }
  },
  anisotropy: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
      return this.texture.anisotropy;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
      this.texture.anisotropy = value;
    }
  },
  offset: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
      return this.texture.offset;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
      this.texture.offset = value;
    }
  },
  repeat: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
      return this.texture.repeat;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
      this.texture.repeat = value;
    }
  },
  format: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
      return this.texture.format;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
      this.texture.format = value;
    }
  },
  type: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
      return this.texture.type;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
      this.texture.type = value;
    }
  },
  generateMipmaps: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
      return this.texture.generateMipmaps;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
      this.texture.generateMipmaps = value;
    }
  }
});
Audio.prototype.load = function(file) {
  console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
  const scope = this;
  const audioLoader = new AudioLoader();
  audioLoader.load(file, function(buffer) {
    scope.setBuffer(buffer);
  });
  return this;
};
CubeCamera.prototype.updateCubeMap = function(renderer, scene) {
  console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
  return this.update(renderer, scene);
};
CubeCamera.prototype.clear = function(renderer, color, depth, stencil) {
  console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear().");
  return this.renderTarget.clear(renderer, color, depth, stencil);
};
ImageUtils$1.crossOrigin = void 0;
ImageUtils$1.loadTexture = function(url2, mapping, onLoad, onError) {
  console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
  const loader2 = new TextureLoader();
  loader2.setCrossOrigin(this.crossOrigin);
  const texture = loader2.load(url2, onLoad, void 0, onError);
  if (mapping)
    texture.mapping = mapping;
  return texture;
};
ImageUtils$1.loadTextureCube = function(urls, mapping, onLoad, onError) {
  console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
  const loader2 = new CubeTextureLoader$2();
  loader2.setCrossOrigin(this.crossOrigin);
  const texture = loader2.load(urls, onLoad, void 0, onError);
  if (mapping)
    texture.mapping = mapping;
  return texture;
};
ImageUtils$1.loadCompressedTexture = function() {
  console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
};
ImageUtils$1.loadCompressedTextureCube = function() {
  console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
};
if (typeof __THREE_DEVTOOLS__ !== "undefined") {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
    revision: REVISION
  } }));
}
if (typeof window !== "undefined") {
  if (window.__THREE__) {
    console.warn("WARNING: Multiple instances of Three.js being imported.");
  } else {
    window.__THREE__ = REVISION;
  }
}
class EventsPrototype {
  constructor() {
  }
  on(name, callback, ctx) {
    const e = this.e || (this.e = {});
    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx
    });
    return this;
  }
  once(name, callback, ctx) {
    const self2 = this;
    function listener() {
      self2.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  }
  emit(name) {
    const data = [].slice.call(arguments, 1);
    const evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    let i = 0;
    const len = evtArr.length;
    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }
    return this;
  }
  off(name, callback) {
    const e = this.e || (this.e = {});
    const evts = e[name];
    const liveEvents = [];
    if (evts && callback) {
      for (let i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }
    liveEvents.length ? e[name] = liveEvents : delete e[name];
    return this;
  }
}
const Events = new EventsPrototype();
function hexToRgb(hex) {
  if (hex.length != 6) {
    throw "Only six-digit hex colors are allowed.";
  }
  const aRgbHex = hex.match(/.{1,2}/g);
  return {
    r: parseInt(aRgbHex[0], 16),
    g: parseInt(aRgbHex[1], 16),
    b: parseInt(aRgbHex[2], 16)
  };
}
const layers$6 = {
  ONDERGROND: {
    active: null,
    current: null
  },
  ONDERLAAG: {
    active: null,
    current: null
  },
  "ONDERLAAG-BEVESTIGING": {
    active: null,
    current: null
  },
  TOPLAAG: {
    active: null,
    current: null
  },
  DAMPSCHERM: {
    active: null,
    current: null
  },
  ISOLATIE: {
    active: null,
    current: null
  },
  "ISOLATIE-BEVESTIGING": {
    active: null,
    current: null
  },
  "TOPLAAG-BEVESTIGING": {
    active: null,
    current: null
  },
  "DAMPSCHERM-BEVESTIGING": {
    active: null,
    current: null
  },
  DAKBEDEKKING: {
    active: null,
    current: null
  },
  HIDE_ON_PMMA: {
    active: true
  }
};
const layers$5 = {
  BINNENSPOUWBLAD: {
    active: null,
    current: null
  },
  BUITENBLAD: {
    active: null,
    current: null
  },
  GEVELMETSELWERK: {
    active: null,
    current: null
  },
  DAKSYSTEEM: {
    active: null,
    current: null
  },
  HELLEND_DAK: {
    active: null,
    current: null
  },
  HELLEND_DAK_ISOLATIE: {
    active: null,
    current: null
  },
  HELLEND_DAK_DAMPSCHERM: {
    active: null,
    current: null
  },
  HELLEND_DAK_CONSTRUCTIE: {
    active: null,
    current: null
  },
  ISOLATIE: {
    active: null,
    current: null
  },
  "ISOLATIE-BEVESTIGING": {
    active: null,
    current: null
  }
};
const layers$4 = {
  ISOLATIE: {
    active: null,
    current: null
  },
  "ISOLATIE-BEVESTIGING": {
    active: null,
    current: null
  },
  DAKBEDEKKING: {
    active: null,
    current: null
  },
  ISOLATIE_ONDERDAKFOLIE: {
    active: null,
    current: null
  },
  DAKRAAM_GOOTELEMENT: {
    active: null,
    current: null
  },
  DAKRAAM_ONDERDAKKRAAG: {
    active: null,
    current: null
  },
  DAKRAAM: {
    active: null,
    current: null
  },
  SCHOUW_DOORVOERPAN: {
    active: null,
    current: null
  },
  SCHOUW_AFVOERKANAAL: {
    active: null,
    current: null
  },
  VOETBALK_GOOTELEMENT: {
    active: null,
    current: null
  },
  KILGOOT: {
    active: null,
    current: null
  },
  KILGOOT_DAKTIMMER: {
    active: null,
    current: null
  },
  KILGOOT_GOOTELEMENT: {
    active: null,
    current: null
  },
  NOK_PLAAT: {
    active: null,
    current: null
  },
  NOK_BALK: {
    active: null,
    current: null
  },
  DAMPSCHERM: {
    active: null,
    current: null
  },
  DAKCONSTRUCTIE: {
    active: null,
    current: null
  },
  DAKDETAILS: {
    active: null,
    current: null
  }
};
const layers$3 = {
  ISOLATIE: {
    active: null,
    current: null
  },
  "ISOLATIE-BEVESTIGING": {
    active: null,
    current: null
  },
  BINNENSPOUWBLAD: {
    active: null,
    current: null
  },
  GEVELBEKLEDING: {
    active: null,
    current: null
  },
  AANSLUITINGSPROFIEL: {
    active: null,
    current: null
  },
  ACHTERCONSTRUCTIE: {
    active: null,
    current: null
  }
};
const layers$2 = {
  VLOERBEKLEDING: {
    active: null,
    current: null
  },
  DEKVLOER: {
    active: null,
    current: null
  },
  VLOERVERWARMING: {
    active: null,
    current: null
  },
  ISOLATIE_SCHEIDINGSFOLIE: {
    active: null,
    current: null
  },
  ISOLATIE_SCHEIDINGSFOLIE_PROFIEL: {
    active: null,
    current: null
  },
  ISOLATIE: {
    active: null,
    current: null
  },
  RANDISOLATIE: {
    active: null,
    current: null
  },
  "ISOLATIE-BEVESTIGING": {
    active: null,
    current: null
  },
  DRAAGVLOER: {
    active: null,
    current: null
  }
};
const layers$1 = {
  ISOLATIE: {
    active: null,
    current: null
  },
  ONDERGROND: {
    active: null,
    current: null
  },
  TOPLAAG: {
    active: null,
    current: null
  },
  ONDERLAAG: {
    active: null,
    current: null
  },
  BINNENSPOUWBLAD: {
    active: null,
    current: null
  },
  DEKVLOER: {
    active: null,
    current: null
  },
  DRAAGVLOER: {
    active: null,
    current: null
  },
  VLOERVERWARMING: {
    active: null,
    current: null
  },
  RANDISOLATIE: {
    active: null,
    current: null
  },
  AKOESTISCHE_LAAG: {
    active: null,
    current: null
  }
};
const layers = {
  ISOLATIE: {
    active: null,
    current: null
  },
  "ISOLATIE-BEVESTIGING": {
    active: null,
    current: null
  },
  DAKBEDEKKING: {
    active: null,
    current: null
  },
  DAKBEDEKKING_LATTEN: {
    active: null,
    current: null
  },
  ISOLATIE_ONDERDAKFOLIE: {
    active: null,
    current: null
  },
  DAKRAAM_GOOTELEMENT: {
    active: null,
    current: null
  },
  DAKRAAM_ONDERDAKKRAAG: {
    active: null,
    current: null
  },
  DAKRAAM: {
    active: null,
    current: null
  },
  SCHOUW_DOORVOERPAN: {
    active: null,
    current: null
  },
  SCHOUW_AFVOERKANAAL: {
    active: null,
    current: null
  },
  VOETBALK_GOOTELEMENT: {
    active: null,
    current: null
  },
  KILGOOT: {
    active: null,
    current: null
  },
  KILGOOT_DAKTIMMER: {
    active: null,
    current: null
  },
  KILGOOT_GOOTELEMENT: {
    active: null,
    current: null
  },
  NOK_PLAAT: {
    active: null,
    current: null
  },
  NOK_BALK: {
    active: null,
    current: null
  },
  DAMPSCHERM: {
    active: null,
    current: null
  },
  DAKCONSTRUCTIE: {
    active: null,
    current: null
  },
  DAKDETAILS: {
    active: null,
    current: null
  },
  HOUTEN_PLANKEN: {
    active: null,
    current: null
  }
};
const queryString = window.location.search;
const url = new URL(window.location.href);
const urlFirstSegment = url.pathname.split("/")[1];
const urlParams = new URLSearchParams(queryString);
let debug$1 = false;
let preview = false;
if (urlParams.has("debug")) {
  debug$1 = true;
}
if (urlFirstSegment === "preview") {
  preview = true;
}
var Store = {
  loaded: false,
  current: null,
  debug: debug$1,
  preview,
  dir: "./",
  webp: false,
  raf: null,
  layout: null,
  container: null,
  background: hexToRgb("f1f1f4"),
  scene: {},
  state: {
    MARKERS: false,
    ...layers$6,
    ...layers$5,
    ...layers$4,
    ...layers$3,
    ...layers$2,
    ...layers$1,
    ...layers
  },
  ssao: {
    radius: 0.4,
    minDistance: 5e-4,
    maxDistance: 0.01,
    enabled: false,
    opacity: 0.15
  },
  fxaa: {
    enabled: true
  },
  floor: {
    shadow: 0.18
  },
  windows: {
    color: hexToRgb("4d4d4d"),
    reflectivity: 0.98
  },
  directionalLight: {
    position: new Vector3$1(-2.18, 6.59, 3.47),
    color: { r: 255, g: 255, b: 255 },
    intensity: 4,
    shadowScale: 10,
    normalBias: 0.1,
    mapSize: 1024,
    radius: 1
  },
  ambientLight: {
    color: { r: 255, g: 255, b: 255 },
    intensity: 2
  },
  environment: {
    intensity: 1.5,
    toneMapping: ReinhardToneMapping,
    toneMappingExposure: 4
  }
};
class LoadingManager$1 {
  constructor() {
    this.init();
    this.reset = this.reset.bind(this);
    this.totalLoaded = 0;
    this.totalItems = 0;
    Events.on("LOAD_START", this.reset);
  }
  reset() {
    this.isLoaded = false;
    this.progress = 0;
    Events.emit("LOAD_PROGRESS", this.progress);
  }
  init() {
    this.reset();
    DefaultLoadingManager$1.onProgress = (item, loaded, total) => {
      if (this.isLoaded)
        return;
      this.loaded = loaded - this.totalLoaded;
      this.total = total - this.totalItems;
      setTimeout(() => {
        const progress = Math.floor(this.loaded / this.total * 100);
        if (progress > this.progress)
          this.progress = progress;
        Events.emit("LOAD_PROGRESS", this.progress);
        if (this.progress === 100) {
          Events.emit("LOAD_PROGRESS", 100);
          setTimeout(() => {
            this.isLoaded = Store.loaded = true;
            this.totalLoaded = loaded;
            this.totalItems = total;
            Store.renderer.models.forEach((model) => {
              Store.renderer.replaceTextures(Store[model].model);
            });
          }, 10);
        }
      }, 0);
    };
  }
}
function checkWebp(feature) {
  return new Promise((resolve, reject) => {
    var kTestImages = {
      lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
      lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
      alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
      animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    var img = new Image();
    img.onload = function() {
      if (img.width > 0 && img.height > 0) {
        resolve(feature);
      } else {
        reject(feature);
      }
    };
    img.onerror = function() {
      reject(feature);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
  });
}
class GLTFLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.dracoLoader = null;
    this.ktx2Loader = null;
    this.meshoptDecoder = null;
    this.pluginCallbacks = [];
    this.register(function(parser) {
      return new GLTFMaterialsClearcoatExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureBasisUExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureWebPExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsTransmissionExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFLightsExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMeshoptCompression(parser);
    });
  }
  async load(placeholder, url2, onLoad, onProgress, onError) {
    await checkWebp("lossy").then(() => {
      Store.webp = true;
    }).catch(() => {
      Store.webp = false;
    });
    const scope = this;
    let resourcePath;
    if (this.resourcePath !== "") {
      resourcePath = this.resourcePath;
    } else if (this.path !== "") {
      resourcePath = this.path;
    } else {
      resourcePath = LoaderUtils.extractUrlBase(url2);
    }
    scope.placeholder = placeholder;
    this.manager.itemStart(url2);
    const _onError = function(e) {
      if (onError) {
        onError(e);
      } else {
        console.error(e);
      }
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    };
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setResponseType("arraybuffer");
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(
      url2,
      function(data) {
        try {
          scope.parse(
            data,
            resourcePath,
            function(gltf) {
              onLoad(gltf);
              scope.manager.itemEnd(url2);
            },
            _onError,
            placeholder
          );
        } catch (e) {
          _onError(e);
        }
      },
      onProgress,
      _onError
    );
  }
  setDRACOLoader(dracoLoader2) {
    this.dracoLoader = dracoLoader2;
    return this;
  }
  setDDSLoader() {
    throw new Error(
      'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".'
    );
  }
  setKTX2Loader(ktx2Loader) {
    this.ktx2Loader = ktx2Loader;
    return this;
  }
  setMeshoptDecoder(meshoptDecoder) {
    this.meshoptDecoder = meshoptDecoder;
    return this;
  }
  register(callback) {
    if (this.pluginCallbacks.indexOf(callback) === -1) {
      this.pluginCallbacks.push(callback);
    }
    return this;
  }
  unregister(callback) {
    if (this.pluginCallbacks.indexOf(callback) !== -1) {
      this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
    }
    return this;
  }
  parse(data, path, onLoad, onError, placeholder = false) {
    let content;
    const extensions = {};
    const plugins = {};
    if (typeof data === "string") {
      content = data;
    } else {
      const magic = LoaderUtils.decodeText(new Uint8Array(data, 0, 4));
      if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
        try {
          extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
        } catch (error) {
          if (onError)
            onError(error);
          return;
        }
        content = extensions[EXTENSIONS.KHR_BINARY_GLTF].content;
      } else {
        content = LoaderUtils.decodeText(new Uint8Array(data));
      }
    }
    const json = JSON.parse(content);
    if (json.asset === void 0 || json.asset.version[0] < 2) {
      if (onError)
        onError(
          new Error(
            "THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."
          )
        );
      return;
    }
    const parser = new GLTFParser(json, {
      path: path || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder,
      placeholder
    });
    parser.fileLoader.setRequestHeader(this.requestHeader);
    for (let i = 0; i < this.pluginCallbacks.length; i++) {
      const plugin = this.pluginCallbacks[i](parser);
      plugins[plugin.name] = plugin;
      extensions[plugin.name] = true;
    }
    if (json.extensionsUsed) {
      for (let i = 0; i < json.extensionsUsed.length; ++i) {
        const extensionName = json.extensionsUsed[i];
        const extensionsRequired = json.extensionsRequired || [];
        switch (extensionName) {
          case EXTENSIONS.KHR_MATERIALS_UNLIT:
            extensions[extensionName] = new GLTFMaterialsUnlitExtension();
            break;
          case EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
            extensions[extensionName] = new GLTFMaterialsPbrSpecularGlossinessExtension();
            break;
          case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
            extensions[extensionName] = new GLTFDracoMeshCompressionExtension(
              json,
              this.dracoLoader
            );
            break;
          case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
            extensions[extensionName] = new GLTFTextureTransformExtension();
            break;
          case EXTENSIONS.KHR_MESH_QUANTIZATION:
            extensions[extensionName] = new GLTFMeshQuantizationExtension();
            break;
          default:
            if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) {
              console.warn(
                'THREE.GLTFLoader: Unknown extension "' + extensionName + '".'
              );
            }
        }
      }
    }
    parser.setExtensions(extensions);
    parser.setPlugins(plugins);
    parser.parse(onLoad, onError);
  }
}
function GLTFRegistry() {
  let objects = {};
  return {
    get: function(key) {
      return objects[key];
    },
    add: function(key, object) {
      objects[key] = object;
    },
    remove: function(key) {
      delete objects[key];
    },
    removeAll: function() {
      objects = {};
    }
  };
}
const EXTENSIONS = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: "KHR_materials_pbrSpecularGlossiness",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression"
};
class GLTFLightsExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
    this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const parser = this.parser;
    const nodeDefs = this.parser.json.nodes || [];
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) {
        parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
      }
    }
  }
  _loadLight(lightIndex) {
    const parser = this.parser;
    const cacheKey = "light:" + lightIndex;
    let dependency = parser.cache.get(cacheKey);
    if (dependency)
      return dependency;
    const json = parser.json;
    const extensions = json.extensions && json.extensions[this.name] || {};
    const lightDefs = extensions.lights || [];
    const lightDef = lightDefs[lightIndex];
    let lightNode;
    const color = new Color(16777215);
    if (lightDef.color !== void 0)
      color.fromArray(lightDef.color);
    const range = lightDef.range !== void 0 ? lightDef.range : 0;
    switch (lightDef.type) {
      case "directional":
        lightNode = new DirectionalLight(color);
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      case "point":
        lightNode = new PointLight(color);
        lightNode.distance = range;
        break;
      case "spot":
        lightNode = new SpotLight(color);
        lightNode.distance = range;
        lightDef.spot = lightDef.spot || {};
        lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
        lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
        lightNode.angle = lightDef.spot.outerConeAngle;
        lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
    }
    lightNode.position.set(0, 0, 0);
    lightNode.decay = 2;
    if (lightDef.intensity !== void 0)
      lightNode.intensity = lightDef.intensity;
    lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
    dependency = Promise.resolve(lightNode);
    parser.cache.add(cacheKey, dependency);
    return dependency;
  }
  createNodeAttachment(nodeIndex) {
    const self2 = this;
    const parser = this.parser;
    const json = parser.json;
    const nodeDef = json.nodes[nodeIndex];
    const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
    const lightIndex = lightDef.light;
    if (lightIndex === void 0)
      return null;
    return this._loadLight(lightIndex).then(function(light) {
      return parser._getNodeRef(self2.cache, lightIndex, light);
    });
  }
}
class GLTFMaterialsUnlitExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return MeshBasicMaterial;
  }
  extendParams(materialParams, materialDef, parser) {
    const pending = [];
    materialParams.color = new Color(1, 1, 1);
    materialParams.opacity = 1;
    const metallicRoughness = materialDef.pbrMetallicRoughness;
    if (metallicRoughness) {
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array = metallicRoughness.baseColorFactor;
        materialParams.color.fromArray(array);
        materialParams.opacity = array[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(
          parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture)
        );
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsClearcoatExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.clearcoatFactor !== void 0) {
      materialParams.clearcoat = extension.clearcoatFactor;
    }
    if (extension.clearcoatTexture !== void 0) {
      pending.push(
        parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture)
      );
    }
    if (extension.clearcoatRoughnessFactor !== void 0) {
      materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
    }
    if (extension.clearcoatRoughnessTexture !== void 0) {
      pending.push(
        parser.assignTexture(
          materialParams,
          "clearcoatRoughnessMap",
          extension.clearcoatRoughnessTexture
        )
      );
    }
    if (extension.clearcoatNormalTexture !== void 0) {
      pending.push(
        parser.assignTexture(
          materialParams,
          "clearcoatNormalMap",
          extension.clearcoatNormalTexture
        )
      );
      if (extension.clearcoatNormalTexture.scale !== void 0) {
        const scale = extension.clearcoatNormalTexture.scale;
        materialParams.clearcoatNormalScale = new Vector2$1(scale, -scale);
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsTransmissionExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.transmissionFactor !== void 0) {
      materialParams.transmission = extension.transmissionFactor;
    }
    if (extension.transmissionTexture !== void 0) {
      pending.push(
        parser.assignTexture(
          materialParams,
          "transmissionMap",
          extension.transmissionTexture
        )
      );
    }
    return Promise.all(pending);
  }
}
class GLTFTextureBasisUExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
  }
  loadTexture(textureIndex) {
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[this.name]) {
      return null;
    }
    const extension = textureDef.extensions[this.name];
    const source = json.images[extension.source];
    const loader2 = parser.options.ktx2Loader;
    if (!loader2) {
      if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
        throw new Error(
          "THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures"
        );
      } else {
        return null;
      }
    }
    return parser.loadTextureImage(textureIndex, source, loader2);
  }
}
class GLTFTextureWebPExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
    this.isSupported = null;
  }
  loadTexture(textureIndex) {
    const name = this.name;
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[name]) {
      return null;
    }
    const extension = textureDef.extensions[name];
    const source = json.images[extension.source];
    let loader2 = parser.textureLoader;
    if (source.uri) {
      const handler = parser.options.manager.getHandler(source.uri);
      if (handler !== null)
        loader2 = handler;
    }
    return this.detectSupport().then(function(isSupported) {
      if (isSupported)
        return parser.loadTextureImage(textureIndex, source, loader2);
      if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      }
      return parser.loadTexture(textureIndex);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function(resolve) {
        const image = new Image();
        image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        image.onload = image.onerror = function() {
          resolve(image.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class GLTFMeshoptCompression {
  constructor(parser) {
    this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
    this.parser = parser;
  }
  loadBufferView(index) {
    const json = this.parser.json;
    const bufferView = json.bufferViews[index];
    if (bufferView.extensions && bufferView.extensions[this.name]) {
      const extensionDef = bufferView.extensions[this.name];
      const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
      const decoder = this.parser.options.meshoptDecoder;
      if (!decoder || !decoder.supported) {
        if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error(
            "THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files"
          );
        } else {
          return null;
        }
      }
      return Promise.all([buffer, decoder.ready]).then(function(res) {
        const byteOffset = extensionDef.byteOffset || 0;
        const byteLength = extensionDef.byteLength || 0;
        const count = extensionDef.count;
        const stride = extensionDef.byteStride;
        const result = new ArrayBuffer(count * stride);
        const source = new Uint8Array(res[0], byteOffset, byteLength);
        decoder.decodeGltfBuffer(
          new Uint8Array(result),
          count,
          stride,
          source,
          extensionDef.mode,
          extensionDef.filter
        );
        return result;
      });
    } else {
      return null;
    }
  }
}
const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
class GLTFBinaryExtension {
  constructor(data) {
    this.name = EXTENSIONS.KHR_BINARY_GLTF;
    this.content = null;
    this.body = null;
    const headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
    this.header = {
      magic: LoaderUtils.decodeText(new Uint8Array(data.slice(0, 4))),
      version: headerView.getUint32(4, true),
      length: headerView.getUint32(8, true)
    };
    if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    } else if (this.header.version < 2) {
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    }
    const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
    const chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
    let chunkIndex = 0;
    while (chunkIndex < chunkContentsLength) {
      const chunkLength = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      const chunkType = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
        const contentArray = new Uint8Array(
          data,
          BINARY_EXTENSION_HEADER_LENGTH + chunkIndex,
          chunkLength
        );
        this.content = LoaderUtils.decodeText(contentArray);
      } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
        const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
        this.body = data.slice(byteOffset, byteOffset + chunkLength);
      }
      chunkIndex += chunkLength;
    }
    if (this.content === null) {
      throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
  }
}
class GLTFDracoMeshCompressionExtension {
  constructor(json, dracoLoader2) {
    if (!dracoLoader2) {
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    }
    this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
    this.json = json;
    this.dracoLoader = dracoLoader2;
    this.dracoLoader.preload();
  }
  decodePrimitive(primitive, parser) {
    const json = this.json;
    const dracoLoader2 = this.dracoLoader;
    const bufferViewIndex = primitive.extensions[this.name].bufferView;
    const gltfAttributeMap = primitive.extensions[this.name].attributes;
    const threeAttributeMap = {};
    const attributeNormalizedMap = {};
    const attributeTypeMap = {};
    for (const attributeName in gltfAttributeMap) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
    }
    for (const attributeName in primitive.attributes) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      if (gltfAttributeMap[attributeName] !== void 0) {
        const accessorDef = json.accessors[primitive.attributes[attributeName]];
        const componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        attributeTypeMap[threeAttributeName] = componentType;
        attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
      }
    }
    return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
      return new Promise(function(resolve) {
        dracoLoader2.decodeDracoFile(
          bufferView,
          function(geometry) {
            for (const attributeName in geometry.attributes) {
              const attribute = geometry.attributes[attributeName];
              const normalized = attributeNormalizedMap[attributeName];
              if (normalized !== void 0)
                attribute.normalized = normalized;
            }
            resolve(geometry);
          },
          threeAttributeMap,
          attributeTypeMap
        );
      });
    });
  }
}
class GLTFTextureTransformExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(texture, transform) {
    const { sourceUriLarge, srcUri } = texture;
    texture = texture.clone();
    texture.sourceUriLarge = sourceUriLarge;
    texture.srcUri = srcUri;
    if (transform.offset !== void 0) {
      texture.offset.fromArray(transform.offset);
    }
    if (transform.rotation !== void 0) {
      texture.rotation = transform.rotation;
    }
    if (transform.scale !== void 0) {
      texture.repeat.fromArray(transform.scale);
    }
    if (transform.texCoord !== void 0) {
      console.warn(
        'THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.'
      );
    }
    texture.needsUpdate = true;
    return texture;
  }
}
class GLTFMeshStandardSGMaterial extends MeshStandardMaterial {
  constructor(params) {
    super();
    this.isGLTFSpecularGlossinessMaterial = true;
    const specularMapParsFragmentChunk = [
      "#ifdef USE_SPECULARMAP",
      "	uniform sampler2D specularMap;",
      "#endif"
    ].join("\n");
    const glossinessMapParsFragmentChunk = [
      "#ifdef USE_GLOSSINESSMAP",
      "	uniform sampler2D glossinessMap;",
      "#endif"
    ].join("\n");
    const specularMapFragmentChunk = [
      "vec3 specularFactor = specular;",
      "#ifdef USE_SPECULARMAP",
      "	vec4 texelSpecular = texture2D( specularMap, vUv );",
      "	texelSpecular = sRGBToLinear( texelSpecular );",
      "	// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture",
      "	specularFactor *= texelSpecular.rgb;",
      "#endif"
    ].join("\n");
    const glossinessMapFragmentChunk = [
      "float glossinessFactor = glossiness;",
      "#ifdef USE_GLOSSINESSMAP",
      "	vec4 texelGlossiness = texture2D( glossinessMap, vUv );",
      "	// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture",
      "	glossinessFactor *= texelGlossiness.a;",
      "#endif"
    ].join("\n");
    const lightPhysicalFragmentChunk = [
      "PhysicalMaterial material;",
      "material.diffuseColor = diffuseColor.rgb * ( 1. - max( specularFactor.r, max( specularFactor.g, specularFactor.b ) ) );",
      "vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );",
      "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );",
      "material.specularRoughness = max( 1.0 - glossinessFactor, 0.0525 ); // 0.0525 corresponds to the base mip of a 256 cubemap.",
      "material.specularRoughness += geometryRoughness;",
      "material.specularRoughness = min( material.specularRoughness, 1.0 );",
      "material.specularColor = specularFactor;"
    ].join("\n");
    const uniforms = {
      specular: { value: new Color().setHex(16777215) },
      glossiness: { value: 1 },
      specularMap: { value: null },
      glossinessMap: { value: null }
    };
    this._extraUniforms = uniforms;
    this.onBeforeCompile = function(shader) {
      for (const uniformName in uniforms) {
        shader.uniforms[uniformName] = uniforms[uniformName];
      }
      shader.fragmentShader = shader.fragmentShader.replace("uniform float roughness;", "uniform vec3 specular;").replace("uniform float metalness;", "uniform float glossiness;").replace("#include <roughnessmap_pars_fragment>", specularMapParsFragmentChunk).replace("#include <metalnessmap_pars_fragment>", glossinessMapParsFragmentChunk).replace("#include <roughnessmap_fragment>", specularMapFragmentChunk).replace("#include <metalnessmap_fragment>", glossinessMapFragmentChunk).replace("#include <lights_physical_fragment>", lightPhysicalFragmentChunk);
    };
    Object.defineProperties(this, {
      specular: {
        get: function() {
          return uniforms.specular.value;
        },
        set: function(v) {
          uniforms.specular.value = v;
        }
      },
      specularMap: {
        get: function() {
          return uniforms.specularMap.value;
        },
        set: function(v) {
          uniforms.specularMap.value = v;
          if (v) {
            this.defines.USE_SPECULARMAP = "";
          } else {
            delete this.defines.USE_SPECULARMAP;
          }
        }
      },
      glossiness: {
        get: function() {
          return uniforms.glossiness.value;
        },
        set: function(v) {
          uniforms.glossiness.value = v;
        }
      },
      glossinessMap: {
        get: function() {
          return uniforms.glossinessMap.value;
        },
        set: function(v) {
          uniforms.glossinessMap.value = v;
          if (v) {
            this.defines.USE_GLOSSINESSMAP = "";
            this.defines.USE_UV = "";
          } else {
            delete this.defines.USE_GLOSSINESSMAP;
            delete this.defines.USE_UV;
          }
        }
      }
    });
    delete this.metalness;
    delete this.roughness;
    delete this.metalnessMap;
    delete this.roughnessMap;
    this.setValues(params);
  }
  copy(source) {
    super.copy(source);
    this.specularMap = source.specularMap;
    this.specular.copy(source.specular);
    this.glossinessMap = source.glossinessMap;
    this.glossiness = source.glossiness;
    delete this.metalness;
    delete this.roughness;
    delete this.metalnessMap;
    delete this.roughnessMap;
    return this;
  }
}
class GLTFMaterialsPbrSpecularGlossinessExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS;
    this.specularGlossinessParams = [
      "color",
      "map",
      "lightMap",
      "lightMapIntensity",
      "aoMap",
      "aoMapIntensity",
      "emissive",
      "emissiveIntensity",
      "emissiveMap",
      "bumpMap",
      "bumpScale",
      "normalMap",
      "normalMapType",
      "displacementMap",
      "displacementScale",
      "displacementBias",
      "specularMap",
      "specular",
      "glossinessMap",
      "glossiness",
      "alphaMap",
      "envMap",
      "envMapIntensity",
      "refractionRatio"
    ];
  }
  getMaterialType() {
    return GLTFMeshStandardSGMaterial;
  }
  extendParams(materialParams, materialDef, parser) {
    const pbrSpecularGlossiness = materialDef.extensions[this.name];
    materialParams.color = new Color(1, 1, 1);
    materialParams.opacity = 1;
    const pending = [];
    if (Array.isArray(pbrSpecularGlossiness.diffuseFactor)) {
      const array = pbrSpecularGlossiness.diffuseFactor;
      materialParams.color.fromArray(array);
      materialParams.opacity = array[3];
    }
    if (pbrSpecularGlossiness.diffuseTexture !== void 0) {
      pending.push(
        parser.assignTexture(materialParams, "map", pbrSpecularGlossiness.diffuseTexture)
      );
    }
    materialParams.emissive = new Color(0, 0, 0);
    materialParams.glossiness = pbrSpecularGlossiness.glossinessFactor !== void 0 ? pbrSpecularGlossiness.glossinessFactor : 1;
    materialParams.specular = new Color(1, 1, 1);
    if (Array.isArray(pbrSpecularGlossiness.specularFactor)) {
      materialParams.specular.fromArray(pbrSpecularGlossiness.specularFactor);
    }
    if (pbrSpecularGlossiness.specularGlossinessTexture !== void 0) {
      const specGlossMapDef = pbrSpecularGlossiness.specularGlossinessTexture;
      pending.push(parser.assignTexture(materialParams, "glossinessMap", specGlossMapDef));
      pending.push(parser.assignTexture(materialParams, "specularMap", specGlossMapDef));
    }
    return Promise.all(pending);
  }
  createMaterial(materialParams) {
    const material = new GLTFMeshStandardSGMaterial(materialParams);
    material.fog = true;
    material.color = materialParams.color;
    material.map = materialParams.map === void 0 ? null : materialParams.map;
    material.lightMap = null;
    material.lightMapIntensity = 1;
    material.aoMap = materialParams.aoMap === void 0 ? null : materialParams.aoMap;
    material.aoMapIntensity = 1;
    material.emissive = materialParams.emissive;
    material.emissiveIntensity = 1;
    material.emissiveMap = materialParams.emissiveMap === void 0 ? null : materialParams.emissiveMap;
    material.bumpMap = materialParams.bumpMap === void 0 ? null : materialParams.bumpMap;
    material.bumpScale = 1;
    material.normalMap = materialParams.normalMap === void 0 ? null : materialParams.normalMap;
    material.normalMapType = TangentSpaceNormalMap;
    if (materialParams.normalScale)
      material.normalScale = materialParams.normalScale;
    material.displacementMap = null;
    material.displacementScale = 1;
    material.displacementBias = 0;
    material.specularMap = materialParams.specularMap === void 0 ? null : materialParams.specularMap;
    material.specular = materialParams.specular;
    material.glossinessMap = materialParams.glossinessMap === void 0 ? null : materialParams.glossinessMap;
    material.glossiness = materialParams.glossiness;
    material.alphaMap = null;
    material.envMap = materialParams.envMap === void 0 ? null : materialParams.envMap;
    material.envMapIntensity = 1;
    material.refractionRatio = 0.98;
    return material;
  }
}
class GLTFMeshQuantizationExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
  }
}
class GLTFCubicSplineInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  copySampleValue_(index) {
    const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
    for (let i = 0; i !== valueSize; i++) {
      result[i] = values[offset + i];
    }
    return result;
  }
}
GLTFCubicSplineInterpolant.prototype.beforeStart_ = GLTFCubicSplineInterpolant.prototype.copySampleValue_;
GLTFCubicSplineInterpolant.prototype.afterEnd_ = GLTFCubicSplineInterpolant.prototype.copySampleValue_;
GLTFCubicSplineInterpolant.prototype.interpolate_ = function(i1, t0, t, t1) {
  const result = this.resultBuffer;
  const values = this.sampleValues;
  const stride = this.valueSize;
  const stride2 = stride * 2;
  const stride3 = stride * 3;
  const td = t1 - t0;
  const p = (t - t0) / td;
  const pp = p * p;
  const ppp = pp * p;
  const offset1 = i1 * stride3;
  const offset0 = offset1 - stride3;
  const s2 = -2 * ppp + 3 * pp;
  const s3 = ppp - pp;
  const s0 = 1 - s2;
  const s1 = s3 - pp + p;
  for (let i = 0; i !== stride; i++) {
    const p0 = values[offset0 + i + stride];
    const m0 = values[offset0 + i + stride2] * td;
    const p1 = values[offset1 + i + stride];
    const m1 = values[offset1 + i] * td;
    result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
  }
  return result;
};
const WEBGL_CONSTANTS = {
  FLOAT: 5126,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  LINEAR: 9729,
  REPEAT: 10497,
  SAMPLER_2D: 35678,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123
};
const WEBGL_COMPONENT_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
const WEBGL_FILTERS = {
  9728: NearestFilter,
  9729: LinearFilter$1,
  9984: NearestMipmapNearestFilter,
  9985: LinearMipmapNearestFilter,
  9986: NearestMipmapLinearFilter,
  9987: LinearMipmapLinearFilter$1
};
const WEBGL_WRAPPINGS = {
  33071: ClampToEdgeWrapping$1,
  33648: MirroredRepeatWrapping$1,
  10497: RepeatWrapping$1
};
const WEBGL_TYPE_SIZES = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const ATTRIBUTES = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv2",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
};
const PATH_PROPERTIES = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
};
const INTERPOLATION = {
  CUBICSPLINE: void 0,
  LINEAR: InterpolateLinear,
  STEP: InterpolateDiscrete
};
const ALPHA_MODES = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function resolveURL(url2, path) {
  if (typeof url2 !== "string" || url2 === "")
    return "";
  if (/^https?:\/\//i.test(path) && /^\//.test(url2)) {
    path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
  }
  if (/^(https?:)?\/\//i.test(url2))
    return url2;
  if (/^data:.*,.*$/i.test(url2))
    return url2;
  if (/^blob:.*$/i.test(url2))
    return url2;
  return path + url2;
}
function createDefaultMaterial(cache) {
  if (cache["DefaultMaterial"] === void 0) {
    cache["DefaultMaterial"] = new MeshStandardMaterial({
      color: 16777215,
      emissive: 0,
      metalness: 1,
      roughness: 1,
      transparent: false,
      depthTest: true,
      side: FrontSide
    });
  }
  return cache["DefaultMaterial"];
}
function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
  for (const name in objectDef.extensions) {
    if (knownExtensions[name] === void 0) {
      object.userData.gltfExtensions = object.userData.gltfExtensions || {};
      object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
  }
}
function assignExtrasToUserData(object, gltfDef) {
  if (gltfDef.extras !== void 0) {
    if (typeof gltfDef.extras === "object") {
      Object.assign(object.userData, gltfDef.extras);
    } else {
      console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
  }
}
function addMorphTargets(geometry, targets, parser) {
  let hasMorphPosition = false;
  let hasMorphNormal = false;
  for (let i = 0, il = targets.length; i < il; i++) {
    const target = targets[i];
    if (target.POSITION !== void 0)
      hasMorphPosition = true;
    if (target.NORMAL !== void 0)
      hasMorphNormal = true;
    if (hasMorphPosition && hasMorphNormal)
      break;
  }
  if (!hasMorphPosition && !hasMorphNormal)
    return Promise.resolve(geometry);
  const pendingPositionAccessors = [];
  const pendingNormalAccessors = [];
  for (let i = 0, il = targets.length; i < il; i++) {
    const target = targets[i];
    if (hasMorphPosition) {
      const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
      pendingPositionAccessors.push(pendingAccessor);
    }
    if (hasMorphNormal) {
      const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
      pendingNormalAccessors.push(pendingAccessor);
    }
  }
  return Promise.all([
    Promise.all(pendingPositionAccessors),
    Promise.all(pendingNormalAccessors)
  ]).then(function(accessors) {
    const morphPositions = accessors[0];
    const morphNormals = accessors[1];
    if (hasMorphPosition)
      geometry.morphAttributes.position = morphPositions;
    if (hasMorphNormal)
      geometry.morphAttributes.normal = morphNormals;
    geometry.morphTargetsRelative = true;
    return geometry;
  });
}
function updateMorphTargets(mesh, meshDef) {
  mesh.updateMorphTargets();
  if (meshDef.weights !== void 0) {
    for (let i = 0, il = meshDef.weights.length; i < il; i++) {
      mesh.morphTargetInfluences[i] = meshDef.weights[i];
    }
  }
  if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
    const targetNames = meshDef.extras.targetNames;
    if (mesh.morphTargetInfluences.length === targetNames.length) {
      mesh.morphTargetDictionary = {};
      for (let i = 0, il = targetNames.length; i < il; i++) {
        mesh.morphTargetDictionary[targetNames[i]] = i;
      }
    } else {
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
  }
}
function createPrimitiveKey(primitiveDef) {
  const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
  let geometryKey;
  if (dracoExtension) {
    geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + createAttributesKey(dracoExtension.attributes);
  } else {
    geometryKey = primitiveDef.indices + ":" + createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
  }
  return geometryKey;
}
function createAttributesKey(attributes) {
  let attributesKey = "";
  const keys = Object.keys(attributes).sort();
  for (let i = 0, il = keys.length; i < il; i++) {
    attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
  }
  return attributesKey;
}
function getNormalizedComponentScale(constructor) {
  switch (constructor) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
class GLTFParser {
  constructor(json = {}, options = {}) {
    this.json = json;
    this.extensions = {};
    this.plugins = {};
    this.options = options;
    this.cache = new GLTFRegistry();
    this.associations = /* @__PURE__ */ new Map();
    this.primitiveCache = {};
    this.meshCache = { refs: {}, uses: {} };
    this.cameraCache = { refs: {}, uses: {} };
    this.lightCache = { refs: {}, uses: {} };
    this.nodeNamesUsed = {};
    if (typeof createImageBitmap !== "undefined" && /Firefox/.test(navigator.userAgent) === false) {
      this.textureLoader = new ImageBitmapLoader(this.options.manager);
    } else {
      this.textureLoader = new TextureLoader(this.options.manager);
    }
    this.textureLoader.setCrossOrigin(this.options.crossOrigin);
    this.textureLoader.setRequestHeader(this.options.requestHeader);
    this.fileLoader = new FileLoader(this.options.manager);
    this.fileLoader.setResponseType("arraybuffer");
    if (this.options.crossOrigin === "use-credentials") {
      this.fileLoader.setWithCredentials(true);
    }
  }
  setExtensions(extensions) {
    this.extensions = extensions;
  }
  setPlugins(plugins) {
    this.plugins = plugins;
  }
  parse(onLoad, onError) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    this.cache.removeAll();
    this._invokeAll(function(ext) {
      return ext._markDefs && ext._markDefs();
    });
    Promise.all(
      this._invokeAll(function(ext) {
        return ext.beforeRoot && ext.beforeRoot();
      })
    ).then(function() {
      return Promise.all([
        parser.getDependencies("scene"),
        parser.getDependencies("animation"),
        parser.getDependencies("camera")
      ]);
    }).then(function(dependencies) {
      const result = {
        scene: dependencies[0][json.scene || 0],
        scenes: dependencies[0],
        animations: dependencies[1],
        cameras: dependencies[2],
        asset: json.asset,
        parser,
        userData: {}
      };
      addUnknownExtensionsToUserData(extensions, result, json);
      assignExtrasToUserData(result, json);
      Promise.all(
        parser._invokeAll(function(ext) {
          return ext.afterRoot && ext.afterRoot(result);
        })
      ).then(function() {
        onLoad(result);
      });
    }).catch(onError);
  }
  _markDefs() {
    const nodeDefs = this.json.nodes || [];
    const skinDefs = this.json.skins || [];
    const meshDefs = this.json.meshes || [];
    for (let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
      const joints = skinDefs[skinIndex].joints;
      for (let i = 0, il = joints.length; i < il; i++) {
        nodeDefs[joints[i]].isBone = true;
      }
    }
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.mesh !== void 0) {
        this._addNodeRef(this.meshCache, nodeDef.mesh);
        if (nodeDef.skin !== void 0) {
          meshDefs[nodeDef.mesh].isSkinnedMesh = true;
        }
      }
      if (nodeDef.camera !== void 0) {
        this._addNodeRef(this.cameraCache, nodeDef.camera);
      }
    }
  }
  _addNodeRef(cache, index) {
    if (index === void 0)
      return;
    if (cache.refs[index] === void 0) {
      cache.refs[index] = cache.uses[index] = 0;
    }
    cache.refs[index]++;
  }
  _getNodeRef(cache, index, object) {
    if (cache.refs[index] <= 1)
      return object;
    const ref = object.clone();
    ref.name += "_instance_" + cache.uses[index]++;
    return ref;
  }
  _invokeOne(func) {
    const extensions = Object.values(this.plugins);
    extensions.push(this);
    for (let i = 0; i < extensions.length; i++) {
      const result = func(extensions[i]);
      if (result)
        return result;
    }
    return null;
  }
  _invokeAll(func) {
    const extensions = Object.values(this.plugins);
    extensions.unshift(this);
    const pending = [];
    for (let i = 0; i < extensions.length; i++) {
      const result = func(extensions[i]);
      if (result)
        pending.push(result);
    }
    return pending;
  }
  getDependency(type, index, placeholder = false) {
    const cacheKey = type + ":" + index;
    let dependency = this.cache.get(cacheKey);
    if (!dependency) {
      switch (type) {
        case "scene":
          dependency = this.loadScene(index);
          break;
        case "node":
          dependency = this.loadNode(index);
          break;
        case "mesh":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMesh && ext.loadMesh(index);
          });
          break;
        case "accessor":
          dependency = this.loadAccessor(index);
          break;
        case "bufferView":
          dependency = this._invokeOne(function(ext) {
            return ext.loadBufferView && ext.loadBufferView(index);
          });
          break;
        case "buffer":
          dependency = this.loadBuffer(index);
          break;
        case "material":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMaterial && ext.loadMaterial(index);
          });
          break;
        case "texture":
          dependency = this._invokeOne(function(ext) {
            return ext.loadTexture && ext.loadTexture(index);
          });
          break;
        case "skin":
          dependency = this.loadSkin(index);
          break;
        case "animation":
          dependency = this.loadAnimation(index);
          break;
        case "camera":
          dependency = this.loadCamera(index);
          break;
        default:
          throw new Error("Unknown type: " + type);
      }
      this.cache.add(cacheKey, dependency);
    }
    return dependency;
  }
  getDependencies(type) {
    let dependencies = this.cache.get(type);
    if (!dependencies) {
      const parser = this;
      const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
      dependencies = Promise.all(
        defs.map(function(def, index) {
          return parser.getDependency(type, index);
        })
      );
      this.cache.add(type, dependencies);
    }
    return dependencies;
  }
  loadBuffer(bufferIndex) {
    const bufferDef = this.json.buffers[bufferIndex];
    const loader2 = this.fileLoader;
    if (bufferDef.type && bufferDef.type !== "arraybuffer") {
      throw new Error(
        "THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported."
      );
    }
    if (bufferDef.uri === void 0 && bufferIndex === 0) {
      return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
    }
    const options = this.options;
    return new Promise(function(resolve, reject) {
      loader2.load(resolveURL(bufferDef.uri, options.path), resolve, void 0, function() {
        reject(
          new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".')
        );
      });
    });
  }
  loadBufferView(bufferViewIndex) {
    const bufferViewDef = this.json.bufferViews[bufferViewIndex];
    return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
      const byteLength = bufferViewDef.byteLength || 0;
      const byteOffset = bufferViewDef.byteOffset || 0;
      return buffer.slice(byteOffset, byteOffset + byteLength);
    });
  }
  loadAccessor(accessorIndex) {
    const parser = this;
    const json = this.json;
    const accessorDef = this.json.accessors[accessorIndex];
    if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
      return Promise.resolve(null);
    }
    const pendingBufferViews = [];
    if (accessorDef.bufferView !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
    } else {
      pendingBufferViews.push(null);
    }
    if (accessorDef.sparse !== void 0) {
      pendingBufferViews.push(
        this.getDependency("bufferView", accessorDef.sparse.indices.bufferView)
      );
      pendingBufferViews.push(
        this.getDependency("bufferView", accessorDef.sparse.values.bufferView)
      );
    }
    return Promise.all(pendingBufferViews).then(function(bufferViews) {
      const bufferView = bufferViews[0];
      const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
      const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
      const elementBytes = TypedArray.BYTES_PER_ELEMENT;
      const itemBytes = elementBytes * itemSize;
      const byteOffset = accessorDef.byteOffset || 0;
      const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
      const normalized = accessorDef.normalized === true;
      let array, bufferAttribute;
      if (byteStride && byteStride !== itemBytes) {
        const ibSlice = Math.floor(byteOffset / byteStride);
        const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
        let ib = parser.cache.get(ibCacheKey);
        if (!ib) {
          array = new TypedArray(
            bufferView,
            ibSlice * byteStride,
            accessorDef.count * byteStride / elementBytes
          );
          ib = new InterleavedBuffer(array, byteStride / elementBytes);
          parser.cache.add(ibCacheKey, ib);
        }
        bufferAttribute = new InterleavedBufferAttribute(
          ib,
          itemSize,
          byteOffset % byteStride / elementBytes,
          normalized
        );
      } else {
        if (bufferView === null) {
          array = new TypedArray(accessorDef.count * itemSize);
        } else {
          array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
        }
        bufferAttribute = new BufferAttribute(array, itemSize, normalized);
      }
      if (accessorDef.sparse !== void 0) {
        const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
        const TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
        const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
        const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
        const sparseIndices = new TypedArrayIndices(
          bufferViews[1],
          byteOffsetIndices,
          accessorDef.sparse.count * itemSizeIndices
        );
        const sparseValues = new TypedArray(
          bufferViews[2],
          byteOffsetValues,
          accessorDef.sparse.count * itemSize
        );
        if (bufferView !== null) {
          bufferAttribute = new BufferAttribute(
            bufferAttribute.array.slice(),
            bufferAttribute.itemSize,
            bufferAttribute.normalized
          );
        }
        for (let i = 0, il = sparseIndices.length; i < il; i++) {
          const index = sparseIndices[i];
          bufferAttribute.setX(index, sparseValues[i * itemSize]);
          if (itemSize >= 2)
            bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
          if (itemSize >= 3)
            bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
          if (itemSize >= 4)
            bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
          if (itemSize >= 5)
            throw new Error(
              "THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute."
            );
        }
      }
      return bufferAttribute;
    });
  }
  loadTexture(textureIndex) {
    const json = this.json;
    const options = this.options;
    const textureDef = json.textures[textureIndex];
    const source = json.images[textureDef.source];
    const reg = /(\.jpg|\.png|\jpeg)/g;
    if (Store.webp) {
      source.uri = source.uri.replace(reg, ".webp");
    }
    const small = source.uri.startsWith("../textures") ? source.uri.replace("../textures/", "../textures/small/") : source.uri.replace("textures/", "../textures/small/");
    let loader2 = this.textureLoader;
    if (source.uri) {
      const handler = options.manager.getHandler(source.uri);
      if (handler !== null)
        loader2 = handler;
    }
    return this.loadTextureImage(
      textureIndex,
      {
        mimeType: source.mimeType,
        name: source.name,
        uri: options.placeholder ? small : source.uri,
        uriXL: source.uri
      },
      loader2
    );
  }
  loadTextureImage(textureIndex, source, loader2) {
    const parser = this;
    const json = this.json;
    const options = this.options;
    const textureDef = json.textures[textureIndex];
    const URL2 = self.URL || self.webkitURL;
    let sourceURI = source.uri;
    let sourceUriLarge = source.uriXL;
    let isObjectURL = false;
    let hasAlpha = true;
    if (source.mimeType === "image/jpeg")
      hasAlpha = false;
    if (source.bufferView !== void 0) {
      sourceURI = parser.getDependency("bufferView", source.bufferView).then(function(bufferView) {
        if (source.mimeType === "image/png") {
          const colorType = new DataView(bufferView, 25, 1).getUint8(0, false);
          hasAlpha = colorType === 6 || colorType === 4 || colorType === 3;
        }
        isObjectURL = true;
        const blob = new Blob([bufferView], { type: source.mimeType });
        sourceURI = URL2.createObjectURL(blob);
        return sourceURI;
      });
    } else if (source.uri === void 0) {
      throw new Error(
        "THREE.GLTFLoader: Image " + textureIndex + " is missing URI and bufferView"
      );
    }
    return Promise.resolve(sourceURI).then(function(sourceURI2) {
      return new Promise(function(resolve, reject) {
        let onLoad = resolve;
        if (loader2.isImageBitmapLoader === true) {
          onLoad = function(imageBitmap) {
            resolve(new CanvasTexture(imageBitmap));
          };
        }
        loader2.load(resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
      });
    }).then(function(texture) {
      if (isObjectURL === true) {
        URL2.revokeObjectURL(sourceURI);
      }
      texture.flipY = false;
      if (textureDef.name)
        texture.name = textureDef.name;
      texture.srcUri = sourceURI;
      texture.sourceUriLarge = sourceUriLarge;
      if (!hasAlpha)
        texture.format = RGBFormat$1;
      const samplers = json.samplers || {};
      const sampler = samplers[textureDef.sampler] || {};
      texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || LinearFilter$1;
      texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || LinearMipmapLinearFilter$1;
      texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || RepeatWrapping$1;
      texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || RepeatWrapping$1;
      parser.associations.set(texture, {
        type: "textures",
        index: textureIndex
      });
      return texture;
    });
  }
  assignTexture(materialParams, mapName, mapDef) {
    const parser = this;
    return this.getDependency("texture", mapDef.index).then(function(texture) {
      if (mapDef.texCoord !== void 0 && mapDef.texCoord != 0 && !(mapName === "aoMap" && mapDef.texCoord == 1)) {
        console.warn(
          "THREE.GLTFLoader: Custom UV set " + mapDef.texCoord + " for texture " + mapName + " not yet supported."
        );
      }
      if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
        const transform = mapDef.extensions !== void 0 ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
        if (transform) {
          const gltfReference = parser.associations.get(texture);
          texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(
            texture,
            transform
          );
          parser.associations.set(texture, gltfReference);
        }
      }
      materialParams[mapName] = texture;
    });
  }
  assignFinalMaterial(mesh) {
    const geometry = mesh.geometry;
    let material = mesh.material;
    const useVertexTangents = geometry.attributes.tangent !== void 0;
    const useVertexColors = geometry.attributes.color !== void 0;
    const useFlatShading = geometry.attributes.normal === void 0;
    const useSkinning = mesh.isSkinnedMesh === true;
    const useMorphTargets = Object.keys(geometry.morphAttributes).length > 0;
    const useMorphNormals = useMorphTargets && geometry.morphAttributes.normal !== void 0;
    if (mesh.isPoints) {
      const cacheKey = "PointsMaterial:" + material.uuid;
      let pointsMaterial = this.cache.get(cacheKey);
      if (!pointsMaterial) {
        pointsMaterial = new PointsMaterial();
        Material.prototype.copy.call(pointsMaterial, material);
        pointsMaterial.color.copy(material.color);
        pointsMaterial.map = material.map;
        pointsMaterial.sizeAttenuation = false;
        this.cache.add(cacheKey, pointsMaterial);
      }
      material = pointsMaterial;
    } else if (mesh.isLine) {
      const cacheKey = "LineBasicMaterial:" + material.uuid;
      let lineMaterial = this.cache.get(cacheKey);
      if (!lineMaterial) {
        lineMaterial = new LineBasicMaterial();
        Material.prototype.copy.call(lineMaterial, material);
        lineMaterial.color.copy(material.color);
        this.cache.add(cacheKey, lineMaterial);
      }
      material = lineMaterial;
    }
    if (useVertexTangents || useVertexColors || useFlatShading || useSkinning || useMorphTargets) {
      let cacheKey = "ClonedMaterial:" + material.uuid + ":";
      if (material.isGLTFSpecularGlossinessMaterial)
        cacheKey += "specular-glossiness:";
      if (useSkinning)
        cacheKey += "skinning:";
      if (useVertexTangents)
        cacheKey += "vertex-tangents:";
      if (useVertexColors)
        cacheKey += "vertex-colors:";
      if (useFlatShading)
        cacheKey += "flat-shading:";
      if (useMorphTargets)
        cacheKey += "morph-targets:";
      if (useMorphNormals)
        cacheKey += "morph-normals:";
      let cachedMaterial = this.cache.get(cacheKey);
      if (!cachedMaterial) {
        cachedMaterial = material.clone();
        if (useSkinning)
          cachedMaterial.skinning = true;
        if (useVertexColors)
          cachedMaterial.vertexColors = true;
        if (useFlatShading)
          cachedMaterial.flatShading = true;
        if (useMorphTargets)
          cachedMaterial.morphTargets = true;
        if (useMorphNormals)
          cachedMaterial.morphNormals = true;
        if (useVertexTangents) {
          cachedMaterial.vertexTangents = true;
          if (cachedMaterial.normalScale)
            cachedMaterial.normalScale.y *= -1;
          if (cachedMaterial.clearcoatNormalScale)
            cachedMaterial.clearcoatNormalScale.y *= -1;
        }
        this.cache.add(cacheKey, cachedMaterial);
        this.associations.set(cachedMaterial, this.associations.get(material));
      }
      material = cachedMaterial;
    }
    if (material.aoMap && geometry.attributes.uv2 === void 0 && geometry.attributes.uv !== void 0) {
      geometry.setAttribute("uv2", geometry.attributes.uv);
    }
    mesh.material = material;
  }
  getMaterialType() {
    return MeshStandardMaterial;
  }
  loadMaterial(materialIndex) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    const materialDef = json.materials[materialIndex];
    let materialType;
    const materialParams = {};
    const materialExtensions = materialDef.extensions || {};
    const pending = [];
    if (materialExtensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
      const sgExtension = extensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
      materialType = sgExtension.getMaterialType();
      pending.push(sgExtension.extendParams(materialParams, materialDef, parser));
    } else if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
      const kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
      materialType = kmuExtension.getMaterialType();
      pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
    } else {
      const metallicRoughness = materialDef.pbrMetallicRoughness || {};
      materialParams.color = new Color(1, 1, 1);
      materialParams.opacity = 1;
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array = metallicRoughness.baseColorFactor;
        materialParams.color.fromArray(array);
        materialParams.opacity = array[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(
          parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture)
        );
      }
      materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
      materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
      if (metallicRoughness.metallicRoughnessTexture !== void 0) {
        pending.push(
          parser.assignTexture(
            materialParams,
            "metalnessMap",
            metallicRoughness.metallicRoughnessTexture
          )
        );
        pending.push(
          parser.assignTexture(
            materialParams,
            "roughnessMap",
            metallicRoughness.metallicRoughnessTexture
          )
        );
      }
      materialType = this._invokeOne(function(ext) {
        return ext.getMaterialType && ext.getMaterialType(materialIndex);
      });
      pending.push(
        Promise.all(
          this._invokeAll(function(ext) {
            return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
          })
        )
      );
    }
    if (materialDef.doubleSided === true) {
      materialParams.side = DoubleSide;
    }
    const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
    if (alphaMode === ALPHA_MODES.BLEND) {
      materialParams.transparent = true;
      materialParams.depthWrite = false;
    } else {
      materialParams.transparent = false;
      if (alphaMode === ALPHA_MODES.MASK) {
        materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
      }
    }
    if (materialDef.normalTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(
        parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture)
      );
      materialParams.normalScale = new Vector2$1(1, -1);
      if (materialDef.normalTexture.scale !== void 0) {
        materialParams.normalScale.set(
          materialDef.normalTexture.scale,
          -materialDef.normalTexture.scale
        );
      }
    }
    if (materialDef.occlusionTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(
        parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture)
      );
      if (materialDef.occlusionTexture.strength !== void 0) {
        materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
      }
    }
    if (materialDef.emissiveFactor !== void 0 && materialType !== MeshBasicMaterial) {
      materialParams.emissive = new Color().fromArray(materialDef.emissiveFactor);
    }
    if (materialDef.emissiveTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(
        parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture)
      );
    }
    return Promise.all(pending).then(function() {
      let material;
      if (materialType === GLTFMeshStandardSGMaterial) {
        material = extensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(materialParams);
      } else {
        material = new materialType(materialParams);
      }
      if (materialDef.name)
        material.name = materialDef.name;
      if (material.map)
        material.map.encoding = sRGBEncoding;
      if (material.emissiveMap)
        material.emissiveMap.encoding = sRGBEncoding;
      assignExtrasToUserData(material, materialDef);
      parser.associations.set(material, { type: "materials", index: materialIndex });
      if (materialDef.extensions)
        addUnknownExtensionsToUserData(extensions, material, materialDef);
      return material;
    });
  }
  createUniqueName(originalName) {
    const sanitizedName = PropertyBinding.sanitizeNodeName(originalName || "");
    let name = sanitizedName;
    for (let i = 1; this.nodeNamesUsed[name]; ++i) {
      name = sanitizedName + "_" + i;
    }
    this.nodeNamesUsed[name] = true;
    return name;
  }
  loadGeometries(primitives) {
    const parser = this;
    const extensions = this.extensions;
    const cache = this.primitiveCache;
    function createDracoPrimitive(primitive) {
      return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
        return addPrimitiveAttributes(geometry, primitive, parser);
      });
    }
    const pending = [];
    for (let i = 0, il = primitives.length; i < il; i++) {
      const primitive = primitives[i];
      const cacheKey = createPrimitiveKey(primitive);
      const cached = cache[cacheKey];
      if (cached) {
        pending.push(cached.promise);
      } else {
        let geometryPromise;
        if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {
          geometryPromise = createDracoPrimitive(primitive);
        } else {
          geometryPromise = addPrimitiveAttributes(
            new BufferGeometry(),
            primitive,
            parser
          );
        }
        cache[cacheKey] = { primitive, promise: geometryPromise };
        pending.push(geometryPromise);
      }
    }
    return Promise.all(pending);
  }
  loadMesh(meshIndex) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    const meshDef = json.meshes[meshIndex];
    const primitives = meshDef.primitives;
    const pending = [];
    for (let i = 0, il = primitives.length; i < il; i++) {
      const material = primitives[i].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
      pending.push(material);
    }
    pending.push(parser.loadGeometries(primitives));
    return Promise.all(pending).then(function(results) {
      const materials = results.slice(0, results.length - 1);
      const geometries = results[results.length - 1];
      const meshes = [];
      for (let i = 0, il = geometries.length; i < il; i++) {
        const geometry = geometries[i];
        const primitive = primitives[i];
        let mesh;
        const material = materials[i];
        if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
          mesh = meshDef.isSkinnedMesh === true ? new SkinnedMesh(geometry, material) : new Mesh(geometry, material);
          if (mesh.isSkinnedMesh === true && !mesh.geometry.attributes.skinWeight.normalized) {
            mesh.normalizeSkinWeights();
          }
          if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleStripDrawMode);
          } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleFanDrawMode);
          }
        } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
          mesh = new LineSegments(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
          mesh = new Line(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
          mesh = new LineLoop(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
          mesh = new Points(geometry, material);
        } else {
          throw new Error(
            "THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode
          );
        }
        if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
          updateMorphTargets(mesh, meshDef);
        }
        mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
        assignExtrasToUserData(mesh, meshDef);
        if (primitive.extensions)
          addUnknownExtensionsToUserData(extensions, mesh, primitive);
        parser.assignFinalMaterial(mesh);
        meshes.push(mesh);
      }
      if (meshes.length === 1) {
        return meshes[0];
      }
      const group = new Group();
      for (let i = 0, il = meshes.length; i < il; i++) {
        group.add(meshes[i]);
      }
      return group;
    });
  }
  loadCamera(cameraIndex) {
    let camera;
    const cameraDef = this.json.cameras[cameraIndex];
    const params = cameraDef[cameraDef.type];
    if (!params) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    if (cameraDef.type === "perspective") {
      camera = new PerspectiveCamera(
        MathUtils.radToDeg(params.yfov),
        params.aspectRatio || 1,
        params.znear || 1,
        params.zfar || 2e6
      );
    } else if (cameraDef.type === "orthographic") {
      camera = new OrthographicCamera(
        -params.xmag,
        params.xmag,
        params.ymag,
        -params.ymag,
        params.znear,
        params.zfar
      );
    }
    if (cameraDef.name)
      camera.name = this.createUniqueName(cameraDef.name);
    assignExtrasToUserData(camera, cameraDef);
    return Promise.resolve(camera);
  }
  loadSkin(skinIndex) {
    const skinDef = this.json.skins[skinIndex];
    const skinEntry = { joints: skinDef.joints };
    if (skinDef.inverseBindMatrices === void 0) {
      return Promise.resolve(skinEntry);
    }
    return this.getDependency("accessor", skinDef.inverseBindMatrices).then(function(accessor) {
      skinEntry.inverseBindMatrices = accessor;
      return skinEntry;
    });
  }
  loadAnimation(animationIndex) {
    const json = this.json;
    const animationDef = json.animations[animationIndex];
    const pendingNodes = [];
    const pendingInputAccessors = [];
    const pendingOutputAccessors = [];
    const pendingSamplers = [];
    const pendingTargets = [];
    for (let i = 0, il = animationDef.channels.length; i < il; i++) {
      const channel = animationDef.channels[i];
      const sampler = animationDef.samplers[channel.sampler];
      const target = channel.target;
      const name = target.node !== void 0 ? target.node : target.id;
      const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
      const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
      pendingNodes.push(this.getDependency("node", name));
      pendingInputAccessors.push(this.getDependency("accessor", input));
      pendingOutputAccessors.push(this.getDependency("accessor", output));
      pendingSamplers.push(sampler);
      pendingTargets.push(target);
    }
    return Promise.all([
      Promise.all(pendingNodes),
      Promise.all(pendingInputAccessors),
      Promise.all(pendingOutputAccessors),
      Promise.all(pendingSamplers),
      Promise.all(pendingTargets)
    ]).then(function(dependencies) {
      const nodes = dependencies[0];
      const inputAccessors = dependencies[1];
      const outputAccessors = dependencies[2];
      const samplers = dependencies[3];
      const targets = dependencies[4];
      const tracks = [];
      for (let i = 0, il = nodes.length; i < il; i++) {
        const node = nodes[i];
        const inputAccessor = inputAccessors[i];
        const outputAccessor = outputAccessors[i];
        const sampler = samplers[i];
        const target = targets[i];
        if (node === void 0)
          continue;
        node.updateMatrix();
        node.matrixAutoUpdate = true;
        let TypedKeyframeTrack;
        switch (PATH_PROPERTIES[target.path]) {
          case PATH_PROPERTIES.weights:
            TypedKeyframeTrack = NumberKeyframeTrack;
            break;
          case PATH_PROPERTIES.rotation:
            TypedKeyframeTrack = QuaternionKeyframeTrack;
            break;
          case PATH_PROPERTIES.position:
          case PATH_PROPERTIES.scale:
          default:
            TypedKeyframeTrack = VectorKeyframeTrack;
            break;
        }
        const targetName = node.name ? node.name : node.uuid;
        const interpolation = sampler.interpolation !== void 0 ? INTERPOLATION[sampler.interpolation] : InterpolateLinear;
        const targetNames = [];
        if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
          node.traverse(function(object) {
            if (object.isMesh === true && object.morphTargetInfluences) {
              targetNames.push(object.name ? object.name : object.uuid);
            }
          });
        } else {
          targetNames.push(targetName);
        }
        let outputArray = outputAccessor.array;
        if (outputAccessor.normalized) {
          const scale = getNormalizedComponentScale(outputArray.constructor);
          const scaled = new Float32Array(outputArray.length);
          for (let j = 0, jl = outputArray.length; j < jl; j++) {
            scaled[j] = outputArray[j] * scale;
          }
          outputArray = scaled;
        }
        for (let j = 0, jl = targetNames.length; j < jl; j++) {
          const track = new TypedKeyframeTrack(
            targetNames[j] + "." + PATH_PROPERTIES[target.path],
            inputAccessor.array,
            outputArray,
            interpolation
          );
          if (sampler.interpolation === "CUBICSPLINE") {
            track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
              return new GLTFCubicSplineInterpolant(
                this.times,
                this.values,
                this.getValueSize() / 3,
                result
              );
            };
            track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
          }
          tracks.push(track);
        }
      }
      const name = animationDef.name ? animationDef.name : "animation_" + animationIndex;
      return new AnimationClip(name, void 0, tracks);
    });
  }
  createNodeMesh(nodeIndex) {
    const json = this.json;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    if (nodeDef.mesh === void 0)
      return null;
    return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
      const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
      if (nodeDef.weights !== void 0) {
        node.traverse(function(o) {
          if (!o.isMesh)
            return;
          for (let i = 0, il = nodeDef.weights.length; i < il; i++) {
            o.morphTargetInfluences[i] = nodeDef.weights[i];
          }
        });
      }
      return node;
    });
  }
  loadNode(nodeIndex) {
    const json = this.json;
    const extensions = this.extensions;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
    return function() {
      const pending = [];
      const meshPromise = parser._invokeOne(function(ext) {
        return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
      });
      if (meshPromise) {
        pending.push(meshPromise);
      }
      if (nodeDef.camera !== void 0) {
        pending.push(
          parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
          })
        );
      }
      parser._invokeAll(function(ext) {
        return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
      }).forEach(function(promise) {
        pending.push(promise);
      });
      return Promise.all(pending);
    }().then(function(objects) {
      let node;
      if (nodeDef.isBone === true) {
        node = new Bone();
      } else if (objects.length > 1) {
        node = new Group();
      } else if (objects.length === 1) {
        node = objects[0];
      } else {
        node = new Object3D();
      }
      if (node !== objects[0]) {
        for (let i = 0, il = objects.length; i < il; i++) {
          node.add(objects[i]);
        }
      }
      if (nodeDef.name) {
        node.userData.name = nodeDef.name;
        node.name = nodeName;
      }
      assignExtrasToUserData(node, nodeDef);
      if (nodeDef.extensions)
        addUnknownExtensionsToUserData(extensions, node, nodeDef);
      if (nodeDef.matrix !== void 0) {
        const matrix = new Matrix4();
        matrix.fromArray(nodeDef.matrix);
        node.applyMatrix4(matrix);
      } else {
        if (nodeDef.translation !== void 0) {
          node.position.fromArray(nodeDef.translation);
        }
        if (nodeDef.rotation !== void 0) {
          node.quaternion.fromArray(nodeDef.rotation);
        }
        if (nodeDef.scale !== void 0) {
          node.scale.fromArray(nodeDef.scale);
        }
      }
      parser.associations.set(node, { type: "nodes", index: nodeIndex });
      return node;
    });
  }
  loadScene(sceneIndex) {
    const json = this.json;
    const extensions = this.extensions;
    const sceneDef = this.json.scenes[sceneIndex];
    const parser = this;
    const scene = new Group();
    if (sceneDef.name)
      scene.name = parser.createUniqueName(sceneDef.name);
    assignExtrasToUserData(scene, sceneDef);
    if (sceneDef.extensions)
      addUnknownExtensionsToUserData(extensions, scene, sceneDef);
    const nodeIds = sceneDef.nodes || [];
    const pending = [];
    for (let i = 0, il = nodeIds.length; i < il; i++) {
      pending.push(buildNodeHierachy(nodeIds[i], scene, json, parser));
    }
    return Promise.all(pending).then(function() {
      return scene;
    });
  }
}
function buildNodeHierachy(nodeId, parentObject, json, parser) {
  const nodeDef = json.nodes[nodeId];
  return parser.getDependency("node", nodeId).then(function(node) {
    if (nodeDef.skin === void 0)
      return node;
    let skinEntry;
    return parser.getDependency("skin", nodeDef.skin).then(function(skin) {
      skinEntry = skin;
      const pendingJoints = [];
      for (let i = 0, il = skinEntry.joints.length; i < il; i++) {
        pendingJoints.push(parser.getDependency("node", skinEntry.joints[i]));
      }
      return Promise.all(pendingJoints);
    }).then(function(jointNodes) {
      node.traverse(function(mesh) {
        if (!mesh.isMesh)
          return;
        const bones = [];
        const boneInverses = [];
        for (let j = 0, jl = jointNodes.length; j < jl; j++) {
          const jointNode = jointNodes[j];
          if (jointNode) {
            bones.push(jointNode);
            const mat = new Matrix4();
            if (skinEntry.inverseBindMatrices !== void 0) {
              mat.fromArray(skinEntry.inverseBindMatrices.array, j * 16);
            }
            boneInverses.push(mat);
          } else {
            console.warn(
              'THREE.GLTFLoader: Joint "%s" could not be found.',
              skinEntry.joints[j]
            );
          }
        }
        mesh.bind(new Skeleton(bones, boneInverses), mesh.matrixWorld);
      });
      return node;
    });
  }).then(function(node) {
    parentObject.add(node);
    const pending = [];
    if (nodeDef.children) {
      const children = nodeDef.children;
      for (let i = 0, il = children.length; i < il; i++) {
        const child = children[i];
        pending.push(buildNodeHierachy(child, node, json, parser));
      }
    }
    return Promise.all(pending);
  });
}
function computeBounds(geometry, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const box = new Box3();
  if (attributes.POSITION !== void 0) {
    const accessor = parser.json.accessors[attributes.POSITION];
    const min = accessor.min;
    const max = accessor.max;
    if (min !== void 0 && max !== void 0) {
      box.set(new Vector3$1(min[0], min[1], min[2]), new Vector3$1(max[0], max[1], max[2]));
      if (accessor.normalized) {
        const boxScale = getNormalizedComponentScale(
          WEBGL_COMPONENT_TYPES[accessor.componentType]
        );
        box.min.multiplyScalar(boxScale);
        box.max.multiplyScalar(boxScale);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else {
    return;
  }
  const targets = primitiveDef.targets;
  if (targets !== void 0) {
    const maxDisplacement = new Vector3$1();
    const vector = new Vector3$1();
    for (let i = 0, il = targets.length; i < il; i++) {
      const target = targets[i];
      if (target.POSITION !== void 0) {
        const accessor = parser.json.accessors[target.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        if (min !== void 0 && max !== void 0) {
          vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
          vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
          vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
          if (accessor.normalized) {
            const boxScale = getNormalizedComponentScale(
              WEBGL_COMPONENT_TYPES[accessor.componentType]
            );
            vector.multiplyScalar(boxScale);
          }
          maxDisplacement.max(vector);
        } else {
          console.warn(
            "THREE.GLTFLoader: Missing min/max properties for accessor POSITION."
          );
        }
      }
    }
    box.expandByVector(maxDisplacement);
  }
  geometry.boundingBox = box;
  const sphere = new Sphere();
  box.getCenter(sphere.center);
  sphere.radius = box.min.distanceTo(box.max) / 2;
  geometry.boundingSphere = sphere;
}
function addPrimitiveAttributes(geometry, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const pending = [];
  function assignAttributeAccessor(accessorIndex, attributeName) {
    return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
      geometry.setAttribute(attributeName, accessor);
    });
  }
  for (const gltfAttributeName in attributes) {
    const threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
    if (threeAttributeName in geometry.attributes)
      continue;
    pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
  }
  if (primitiveDef.indices !== void 0 && !geometry.index) {
    const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
      geometry.setIndex(accessor2);
    });
    pending.push(accessor);
  }
  assignExtrasToUserData(geometry, primitiveDef);
  computeBounds(geometry, primitiveDef, parser);
  return Promise.all(pending).then(function() {
    return primitiveDef.targets !== void 0 ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
  });
}
function toTrianglesDrawMode(geometry, drawMode) {
  let index = geometry.getIndex();
  if (index === null) {
    const indices = [];
    const position = geometry.getAttribute("position");
    if (position !== void 0) {
      for (let i = 0; i < position.count; i++) {
        indices.push(i);
      }
      geometry.setIndex(indices);
      index = geometry.getIndex();
    } else {
      console.error(
        "THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."
      );
      return geometry;
    }
  }
  const numberOfTriangles = index.count - 2;
  const newIndices = [];
  if (drawMode === TriangleFanDrawMode) {
    for (let i = 1; i <= numberOfTriangles; i++) {
      newIndices.push(index.getX(0));
      newIndices.push(index.getX(i));
      newIndices.push(index.getX(i + 1));
    }
  } else {
    for (let i = 0; i < numberOfTriangles; i++) {
      if (i % 2 === 0) {
        newIndices.push(index.getX(i));
        newIndices.push(index.getX(i + 1));
        newIndices.push(index.getX(i + 2));
      } else {
        newIndices.push(index.getX(i + 2));
        newIndices.push(index.getX(i + 1));
        newIndices.push(index.getX(i));
      }
    }
  }
  if (newIndices.length / 3 !== numberOfTriangles) {
    console.error(
      "THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles."
    );
  }
  const newGeometry = geometry.clone();
  newGeometry.setIndex(newIndices);
  return newGeometry;
}
const _taskCache = /* @__PURE__ */ new WeakMap();
class DRACOLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.decoderPath = "";
    this.decoderConfig = {};
    this.decoderBinary = null;
    this.decoderPending = null;
    this.workerLimit = 4;
    this.workerPool = [];
    this.workerNextTaskID = 1;
    this.workerSourceURL = "";
    this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    };
    this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  setDecoderPath(path) {
    this.decoderPath = path;
    return this;
  }
  setDecoderConfig(config) {
    this.decoderConfig = config;
    return this;
  }
  setWorkerLimit(workerLimit) {
    this.workerLimit = workerLimit;
    return this;
  }
  load(url2, onLoad, onProgress, onError) {
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setResponseType("arraybuffer");
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(
      url2,
      (buffer) => {
        const taskConfig = {
          attributeIDs: this.defaultAttributeIDs,
          attributeTypes: this.defaultAttributeTypes,
          useUniqueIDs: false
        };
        this.decodeGeometry(buffer, taskConfig).then(onLoad).catch(onError);
      },
      onProgress,
      onError
    );
  }
  decodeDracoFile(buffer, callback, attributeIDs, attributeTypes) {
    const taskConfig = {
      attributeIDs: attributeIDs || this.defaultAttributeIDs,
      attributeTypes: attributeTypes || this.defaultAttributeTypes,
      useUniqueIDs: !!attributeIDs
    };
    this.decodeGeometry(buffer, taskConfig).then(callback);
  }
  decodeGeometry(buffer, taskConfig) {
    for (const attribute in taskConfig.attributeTypes) {
      const type = taskConfig.attributeTypes[attribute];
      if (type.BYTES_PER_ELEMENT !== void 0) {
        taskConfig.attributeTypes[attribute] = type.name;
      }
    }
    const taskKey = JSON.stringify(taskConfig);
    if (_taskCache.has(buffer)) {
      const cachedTask = _taskCache.get(buffer);
      if (cachedTask.key === taskKey) {
        return cachedTask.promise;
      } else if (buffer.byteLength === 0) {
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
      }
    }
    let worker;
    const taskID = this.workerNextTaskID++;
    const taskCost = buffer.byteLength;
    const geometryPending = this._getWorker(taskID, taskCost).then((_worker) => {
      worker = _worker;
      return new Promise((resolve, reject) => {
        worker._callbacks[taskID] = { resolve, reject };
        worker.postMessage({ type: "decode", id: taskID, taskConfig, buffer }, [
          buffer
        ]);
      });
    }).then((message) => this._createGeometry(message.geometry));
    geometryPending.catch(() => true).then(() => {
      if (worker && taskID) {
        this._releaseTask(worker, taskID);
      }
    });
    _taskCache.set(buffer, {
      key: taskKey,
      promise: geometryPending
    });
    return geometryPending;
  }
  _createGeometry(geometryData) {
    const geometry = new BufferGeometry();
    if (geometryData.index) {
      geometry.setIndex(new BufferAttribute(geometryData.index.array, 1));
    }
    for (let i = 0; i < geometryData.attributes.length; i++) {
      const attribute = geometryData.attributes[i];
      const name = attribute.name;
      const array = attribute.array;
      const itemSize = attribute.itemSize;
      geometry.setAttribute(name, new BufferAttribute(array, itemSize));
    }
    return geometry;
  }
  _loadLibrary(url2, responseType) {
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.decoderPath);
    loader2.setResponseType(responseType);
    loader2.setWithCredentials(this.withCredentials);
    return new Promise((resolve, reject) => {
      loader2.load(url2, resolve, void 0, reject);
    });
  }
  preload() {
    this._initDecoder();
    return this;
  }
  _initDecoder() {
    if (this.decoderPending)
      return this.decoderPending;
    const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
    const librariesPending = [];
    if (useJS) {
      librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
    } else {
      librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
      librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
    }
    this.decoderPending = Promise.all(librariesPending).then((libraries) => {
      const jsContent = libraries[0];
      if (!useJS) {
        this.decoderConfig.wasmBinary = libraries[1];
      }
      const fn = DRACOWorker.toString();
      const body = [
        "/* draco decoder */",
        jsContent,
        "",
        "/* worker */",
        fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
      ].join("\n");
      this.workerSourceURL = URL.createObjectURL(new Blob([body]));
    });
    return this.decoderPending;
  }
  _getWorker(taskID, taskCost) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const worker2 = new Worker(this.workerSourceURL);
        worker2._callbacks = {};
        worker2._taskCosts = {};
        worker2._taskLoad = 0;
        worker2.postMessage({ type: "init", decoderConfig: this.decoderConfig });
        worker2.onmessage = function(e) {
          const message = e.data;
          switch (message.type) {
            case "decode":
              worker2._callbacks[message.id].resolve(message);
              break;
            case "error":
              worker2._callbacks[message.id].reject(message);
              break;
            default:
              console.error(
                'THREE.DRACOLoader: Unexpected message, "' + message.type + '"'
              );
          }
        };
        this.workerPool.push(worker2);
      } else {
        this.workerPool.sort(function(a, b) {
          return a._taskLoad > b._taskLoad ? -1 : 1;
        });
      }
      const worker = this.workerPool[this.workerPool.length - 1];
      worker._taskCosts[taskID] = taskCost;
      worker._taskLoad += taskCost;
      return worker;
    });
  }
  _releaseTask(worker, taskID) {
    worker._taskLoad -= worker._taskCosts[taskID];
    delete worker._callbacks[taskID];
    delete worker._taskCosts[taskID];
  }
  debug() {
    console.log(
      "Task load: ",
      this.workerPool.map((worker) => worker._taskLoad)
    );
  }
  dispose() {
    for (let i = 0; i < this.workerPool.length; ++i) {
      this.workerPool[i].terminate();
    }
    this.workerPool.length = 0;
    return this;
  }
}
function DRACOWorker() {
  let decoderConfig;
  let decoderPending;
  onmessage = function(e) {
    const message = e.data;
    switch (message.type) {
      case "init":
        decoderConfig = message.decoderConfig;
        decoderPending = new Promise(function(resolve) {
          decoderConfig.onModuleLoaded = function(draco) {
            resolve({ draco });
          };
          DracoDecoderModule(decoderConfig);
        });
        break;
      case "decode":
        const buffer = message.buffer;
        const taskConfig = message.taskConfig;
        decoderPending.then((module) => {
          const draco = module.draco;
          const decoder = new draco.Decoder();
          const decoderBuffer = new draco.DecoderBuffer();
          decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
          try {
            const geometry = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
            const buffers = geometry.attributes.map((attr) => attr.array.buffer);
            if (geometry.index)
              buffers.push(geometry.index.array.buffer);
            self.postMessage({ type: "decode", id: message.id, geometry }, buffers);
          } catch (error) {
            console.error(error);
            self.postMessage({ type: "error", id: message.id, error: error.message });
          } finally {
            draco.destroy(decoderBuffer);
            draco.destroy(decoder);
          }
        });
        break;
    }
  };
  function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
    const attributeIDs = taskConfig.attributeIDs;
    const attributeTypes = taskConfig.attributeTypes;
    let dracoGeometry;
    let decodingStatus;
    const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
    if (geometryType === draco.TRIANGULAR_MESH) {
      dracoGeometry = new draco.Mesh();
      decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
    } else if (geometryType === draco.POINT_CLOUD) {
      dracoGeometry = new draco.PointCloud();
      decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
    } else {
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    }
    if (!decodingStatus.ok() || dracoGeometry.ptr === 0) {
      throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
    }
    const geometry = { index: null, attributes: [] };
    for (const attributeName in attributeIDs) {
      const attributeType = self[attributeTypes[attributeName]];
      let attribute;
      let attributeID;
      if (taskConfig.useUniqueIDs) {
        attributeID = attributeIDs[attributeName];
        attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
      } else {
        attributeID = decoder.GetAttributeId(
          dracoGeometry,
          draco[attributeIDs[attributeName]]
        );
        if (attributeID === -1)
          continue;
        attribute = decoder.GetAttribute(dracoGeometry, attributeID);
      }
      geometry.attributes.push(
        decodeAttribute(
          draco,
          decoder,
          dracoGeometry,
          attributeName,
          attributeType,
          attribute
        )
      );
    }
    if (geometryType === draco.TRIANGULAR_MESH) {
      geometry.index = decodeIndex(draco, decoder, dracoGeometry);
    }
    draco.destroy(dracoGeometry);
    return geometry;
  }
  function decodeIndex(draco, decoder, dracoGeometry) {
    const numFaces = dracoGeometry.num_faces();
    const numIndices = numFaces * 3;
    const byteLength = numIndices * 4;
    const ptr = draco._malloc(byteLength);
    decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
    const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
    draco._free(ptr);
    return { array: index, itemSize: 1 };
  }
  function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
    const numComponents = attribute.num_components();
    const numPoints = dracoGeometry.num_points();
    const numValues = numPoints * numComponents;
    const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
    const dataType = getDracoDataType(draco, attributeType);
    const ptr = draco._malloc(byteLength);
    decoder.GetAttributeDataArrayForAllPoints(
      dracoGeometry,
      attribute,
      dataType,
      byteLength,
      ptr
    );
    const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
    draco._free(ptr);
    return {
      name: attributeName,
      array,
      itemSize: numComponents
    };
  }
  function getDracoDataType(draco, attributeType) {
    switch (attributeType) {
      case Float32Array:
        return draco.DT_FLOAT32;
      case Int8Array:
        return draco.DT_INT8;
      case Int16Array:
        return draco.DT_INT16;
      case Int32Array:
        return draco.DT_INT32;
      case Uint8Array:
        return draco.DT_UINT8;
      case Uint16Array:
        return draco.DT_UINT16;
      case Uint32Array:
        return draco.DT_UINT32;
    }
  }
}
const loader$1 = new GLTFLoader();
const dracoLoader = new DRACOLoader();
var ModelLoader = (url2, dir, placeholder = false) => {
  dracoLoader.setDecoderPath(dir);
  loader$1.setDRACOLoader(dracoLoader);
  return new Promise((resolve, reject) => {
    loader$1.load(placeholder, url2, (gltf) => {
      const result = gltf.scene;
      resolve(result);
    });
  });
};
const Cache = {
  enabled: false,
  files: {},
  add: function(key, file) {
    if (this.enabled === false)
      return;
    this.files[key] = file;
  },
  get: function(key) {
    if (this.enabled === false)
      return;
    return this.files[key];
  },
  remove: function(key) {
    delete this.files[key];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager {
  constructor(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = void 0;
    const handlers = [];
    this.onStart = void 0;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url2) {
      itemsTotal++;
      if (isLoading === false) {
        if (scope.onStart !== void 0) {
          scope.onStart(url2, itemsLoaded, itemsTotal);
        }
      }
      isLoading = true;
    };
    this.itemEnd = function(url2) {
      itemsLoaded++;
      if (scope.onProgress !== void 0) {
        scope.onProgress(url2, itemsLoaded, itemsTotal);
      }
      if (itemsLoaded === itemsTotal) {
        isLoading = false;
        if (scope.onLoad !== void 0) {
          scope.onLoad();
        }
      }
    };
    this.itemError = function(url2) {
      if (scope.onError !== void 0) {
        scope.onError(url2);
      }
    };
    this.resolveURL = function(url2) {
      if (urlModifier) {
        return urlModifier(url2);
      }
      return url2;
    };
    this.setURLModifier = function(transform) {
      urlModifier = transform;
      return this;
    };
    this.addHandler = function(regex, loader2) {
      handlers.push(regex, loader2);
      return this;
    };
    this.removeHandler = function(regex) {
      const index = handlers.indexOf(regex);
      if (index !== -1) {
        handlers.splice(index, 2);
      }
      return this;
    };
    this.getHandler = function(file) {
      for (let i = 0, l = handlers.length; i < l; i += 2) {
        const regex = handlers[i];
        const loader2 = handlers[i + 1];
        if (regex.global)
          regex.lastIndex = 0;
        if (regex.test(file)) {
          return loader2;
        }
      }
      return null;
    };
  }
}
const DefaultLoadingManager = new LoadingManager();
class Loader {
  constructor(manager) {
    this.manager = manager !== void 0 ? manager : DefaultLoadingManager;
    this.crossOrigin = "anonymous";
    this.withCredentials = false;
    this.path = "";
    this.resourcePath = "";
    this.requestHeader = {};
  }
  load() {
  }
  loadAsync(url2, onProgress) {
    const scope = this;
    return new Promise(function(resolve, reject) {
      scope.load(url2, resolve, onProgress, reject);
    });
  }
  parse() {
  }
  setCrossOrigin(crossOrigin) {
    this.crossOrigin = crossOrigin;
    return this;
  }
  setWithCredentials(value) {
    this.withCredentials = value;
    return this;
  }
  setPath(path) {
    this.path = path;
    return this;
  }
  setResourcePath(resourcePath) {
    this.resourcePath = resourcePath;
    return this;
  }
  setRequestHeader(requestHeader) {
    this.requestHeader = requestHeader;
    return this;
  }
}
class ImageLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const scope = this;
    const cached = Cache.get(url2);
    if (cached !== void 0) {
      scope.manager.itemStart(url2);
      setTimeout(function() {
        if (onLoad)
          onLoad(cached);
        scope.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    const image = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
    function onImageLoad() {
      image.removeEventListener("load", onImageLoad, false);
      image.removeEventListener("error", onImageError, false);
      Cache.add(url2, this);
      if (onLoad)
        onLoad(this);
      scope.manager.itemEnd(url2);
    }
    function onImageError(event) {
      image.removeEventListener("load", onImageLoad, false);
      image.removeEventListener("error", onImageError, false);
      if (onError)
        onError(event);
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    }
    image.addEventListener("load", onImageLoad, false);
    image.addEventListener("error", onImageError, false);
    if (url2.substr(0, 5) !== "data:") {
      if (this.crossOrigin !== void 0)
        image.crossOrigin = this.crossOrigin;
    }
    scope.manager.itemStart(url2);
    image.src = url2;
    return image;
  }
}
class EventDispatcher {
  addEventListener(type, listener) {
    if (this._listeners === void 0)
      this._listeners = {};
    const listeners = this._listeners;
    if (listeners[type] === void 0) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }
  hasEventListener(type, listener) {
    if (this._listeners === void 0)
      return false;
    const listeners = this._listeners;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  removeEventListener(type, listener) {
    if (this._listeners === void 0)
      return;
    const listeners = this._listeners;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index = listenerArray.indexOf(listener);
      if (index !== -1) {
        listenerArray.splice(index, 1);
      }
    }
  }
  dispatchEvent(event) {
    if (this._listeners === void 0)
      return;
    const listeners = this._listeners;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i = 0, l = array.length; i < l; i++) {
        array[i].call(this, event);
      }
      event.target = null;
    }
  }
}
const UVMapping = 300;
const CubeReflectionMapping = 301;
const RepeatWrapping = 1e3;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const LinearFilter = 1006;
const LinearMipmapLinearFilter = 1008;
const UnsignedByteType = 1009;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LinearEncoding = 3e3;
const _lut = [];
for (let i = 0; i < 256; i++) {
  _lut[i] = (i < 16 ? "0" : "") + i.toString(16);
}
function generateUUID() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
  return uuid.toUpperCase();
}
class Vector2 {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  set(x, y) {
    this.x = x;
    this.y = y;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    return this;
  }
  addScalar(s) {
    this.x += s;
    this.y += s;
    return this;
  }
  addVectors(a, b) {
    this.x = a.x + b.x;
    this.y = a.y + b.y;
    return this;
  }
  addScaledVector(v, s) {
    this.x += v.x * s;
    this.y += v.y * s;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    return this;
  }
  subScalar(s) {
    this.x -= s;
    this.y -= s;
    return this;
  }
  subVectors(a, b) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y;
    const e = m.elements;
    this.x = e[0] * x + e[3] * y + e[6];
    this.y = e[1] * x + e[4] * y + e[7];
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    return this;
  }
  clamp(min, max) {
    this.x = Math.max(min.x, Math.min(max.x, this.x));
    this.y = Math.max(min.y, Math.min(max.y, this.y));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    return this;
  }
  clampLength(min, max) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y;
  }
  cross(v) {
    return this.x * v.y - this.y * v.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    const angle = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle;
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y;
    return dx * dx + dy * dy;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    return array;
  }
  fromBufferAttribute(attribute, index, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    return this;
  }
  rotateAround(center, angle) {
    const c = Math.cos(angle), s = Math.sin(angle);
    const x = this.x - center.x;
    const y = this.y - center.y;
    this.x = x * c - y * s + center.x;
    this.y = x * s + y * c + center.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
}
Vector2.prototype.isVector2 = true;
class Matrix3 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te = this.elements;
    te[0] = n11;
    te[1] = n21;
    te[2] = n31;
    te[3] = n12;
    te[4] = n22;
    te[5] = n32;
    te[6] = n13;
    te[7] = n23;
    te[8] = n33;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  copy(m) {
    const te = this.elements;
    const me = m.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a, b) {
    const ae = a.elements;
    const be = b.elements;
    const te = this.elements;
    const a11 = ae[0], a12 = ae[3], a13 = ae[6];
    const a21 = ae[1], a22 = ae[4], a23 = ae[7];
    const a31 = ae[2], a32 = ae[5], a33 = ae[8];
    const b11 = be[0], b12 = be[3], b13 = be[6];
    const b21 = be[1], b22 = be[4], b23 = be[7];
    const b31 = be[2], b32 = be[5], b33 = be[8];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  multiplyScalar(s) {
    const te = this.elements;
    te[0] *= s;
    te[3] *= s;
    te[6] *= s;
    te[1] *= s;
    te[4] *= s;
    te[7] *= s;
    te[2] *= s;
    te[5] *= s;
    te[8] *= s;
    return this;
  }
  determinant() {
    const te = this.elements;
    const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
    return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te[0] = t11 * detInv;
    te[1] = (n31 * n23 - n33 * n21) * detInv;
    te[2] = (n32 * n21 - n31 * n22) * detInv;
    te[3] = t12 * detInv;
    te[4] = (n33 * n11 - n31 * n13) * detInv;
    te[5] = (n31 * n12 - n32 * n11) * detInv;
    te[6] = t13 * detInv;
    te[7] = (n21 * n13 - n23 * n11) * detInv;
    te[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  transpose() {
    let tmp2;
    const m = this.elements;
    tmp2 = m[1];
    m[1] = m[3];
    m[3] = tmp2;
    tmp2 = m[2];
    m[2] = m[6];
    m[6] = tmp2;
    tmp2 = m[5];
    m[5] = m[7];
    m[7] = tmp2;
    return this;
  }
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  transposeIntoArray(r) {
    const m = this.elements;
    r[0] = m[0];
    r[1] = m[3];
    r[2] = m[6];
    r[3] = m[1];
    r[4] = m[4];
    r[5] = m[7];
    r[6] = m[2];
    r[7] = m[5];
    r[8] = m[8];
    return this;
  }
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c = Math.cos(rotation);
    const s = Math.sin(rotation);
    this.set(
      sx * c,
      sx * s,
      -sx * (c * cx + s * cy) + cx + tx,
      -sy * s,
      sy * c,
      -sy * (-s * cx + c * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  scale(sx, sy) {
    const te = this.elements;
    te[0] *= sx;
    te[3] *= sx;
    te[6] *= sx;
    te[1] *= sy;
    te[4] *= sy;
    te[7] *= sy;
    return this;
  }
  rotate(theta) {
    const c = Math.cos(theta);
    const s = Math.sin(theta);
    const te = this.elements;
    const a11 = te[0], a12 = te[3], a13 = te[6];
    const a21 = te[1], a22 = te[4], a23 = te[7];
    te[0] = c * a11 + s * a21;
    te[3] = c * a12 + s * a22;
    te[6] = c * a13 + s * a23;
    te[1] = -s * a11 + c * a21;
    te[4] = -s * a12 + c * a22;
    te[7] = -s * a13 + c * a23;
    return this;
  }
  translate(tx, ty) {
    const te = this.elements;
    te[0] += tx * te[2];
    te[3] += tx * te[5];
    te[6] += tx * te[8];
    te[1] += ty * te[2];
    te[4] += ty * te[5];
    te[7] += ty * te[8];
    return this;
  }
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i = 0; i < 9; i++) {
      if (te[i] !== me[i])
        return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i = 0; i < 9; i++) {
      this.elements[i] = array[i + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te = this.elements;
    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];
    array[offset + 3] = te[3];
    array[offset + 4] = te[4];
    array[offset + 5] = te[5];
    array[offset + 6] = te[6];
    array[offset + 7] = te[7];
    array[offset + 8] = te[8];
    return array;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
Matrix3.prototype.isMatrix3 = true;
let _canvas;
class ImageUtils {
  static getDataURL(image) {
    if (/^data:/i.test(image.src)) {
      return image.src;
    }
    if (typeof HTMLCanvasElement == "undefined") {
      return image.src;
    }
    let canvas;
    if (image instanceof HTMLCanvasElement) {
      canvas = image;
    } else {
      if (_canvas === void 0)
        _canvas = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
      _canvas.width = image.width;
      _canvas.height = image.height;
      const context = _canvas.getContext("2d");
      if (image instanceof ImageData) {
        context.putImageData(image, 0, 0);
      } else {
        context.drawImage(image, 0, 0, image.width, image.height);
      }
      canvas = _canvas;
    }
    if (canvas.width > 2048 || canvas.height > 2048) {
      console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
      return canvas.toDataURL("image/jpeg", 0.6);
    } else {
      return canvas.toDataURL("image/png");
    }
  }
}
let textureId = 0;
class Texture extends EventDispatcher {
  constructor(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = 1, encoding = LinearEncoding) {
    super();
    Object.defineProperty(this, "id", { value: textureId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.image = image;
    this.mipmaps = [];
    this.mapping = mapping;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2(0, 0);
    this.repeat = new Vector2(1, 1);
    this.center = new Vector2(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.encoding = encoding;
    this.version = 0;
    this.onUpdate = null;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.image = source.image;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.encoding = source.encoding;
    return this;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.textures[this.uuid] !== void 0) {
      return meta.textures[this.uuid];
    }
    const output = {
      metadata: {
        version: 4.5,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      mapping: this.mapping,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      type: this.type,
      encoding: this.encoding,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (this.image !== void 0) {
      const image = this.image;
      if (image.uuid === void 0) {
        image.uuid = generateUUID();
      }
      if (!isRootObject && meta.images[image.uuid] === void 0) {
        let url2;
        if (Array.isArray(image)) {
          url2 = [];
          for (let i = 0, l = image.length; i < l; i++) {
            if (image[i].isDataTexture) {
              url2.push(serializeImage(image[i].image));
            } else {
              url2.push(serializeImage(image[i]));
            }
          }
        } else {
          url2 = serializeImage(image);
        }
        meta.images[image.uuid] = {
          uuid: image.uuid,
          url: url2
        };
      }
      output.image = image.uuid;
    }
    if (!isRootObject) {
      meta.textures[this.uuid] = output;
    }
    return output;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(uv) {
    if (this.mapping !== UVMapping)
      return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
}
Texture.DEFAULT_IMAGE = void 0;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.prototype.isTexture = true;
function serializeImage(image) {
  if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return ImageUtils.getDataURL(image);
  } else {
    if (image.data) {
      return {
        data: Array.prototype.slice.call(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
class CubeTexture extends Texture {
  constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    images = images !== void 0 ? images : [];
    mapping = mapping !== void 0 ? mapping : CubeReflectionMapping;
    format = format !== void 0 ? format : RGBFormat;
    super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this._needsFlipEnvMap = true;
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(value) {
    this.image = value;
  }
}
CubeTexture.prototype.isCubeTexture = true;
class CubeTextureLoader$1 extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(urls, onLoad, onProgress, onError) {
    const texture = new CubeTexture();
    const loader2 = new ImageLoader(this.manager);
    loader2.setCrossOrigin(this.crossOrigin);
    loader2.setPath(this.path);
    let loaded = 0;
    function loadTexture(i) {
      loader2.load(urls[i], function(image) {
        texture.images[i] = image;
        loaded++;
        if (loaded === 6) {
          texture.needsUpdate = true;
          if (onLoad)
            onLoad(texture);
        }
      }, void 0, onError);
    }
    for (let i = 0; i < urls.length; ++i) {
      loadTexture(i);
    }
    return texture;
  }
}
const loader = new CubeTextureLoader$1();
var CubeTextureLoader = (url2, name = "", ext = "png") => new Promise((resolve, reject) => {
  const urls = [
    `${url2}${name}px.${ext}`,
    `${url2}${name}nx.${ext}`,
    `${url2}${name}ny.${ext}`,
    `${url2}${name}py.${ext}`,
    `${url2}${name}pz.${ext}`,
    `${url2}${name}nz.${ext}`
  ];
  loader.load(urls, (r) => {
    resolve(r);
  });
});
function Load(slug, dir, placeholder = false) {
  return Promise.all([
    ModelLoader(`${dir}models/${Store.country}/${slug}.gltf`, dir, placeholder),
    CubeTextureLoader(`${dir}cubemaps/01/`)
  ]).then(([model, env]) => {
    Object.assign(Store[slug], {
      model,
      env
    });
    Object.assign(Store.scene, {
      model,
      env
    });
    Store[slug].model.visible = false;
    Store[slug].env.mapping = CubeRefractionMapping;
    Store.scene.env.mapping = CubeRefractionMapping;
    Store[slug].env.encoding = sRGBEncoding;
    Store.scene.env.encoding = sRGBEncoding;
    Store.renderer.scene.add(Store[slug].model);
  });
}
class Raf {
  constructor() {
    this.frames = [];
    this.render = (t) => this.frame(t);
  }
  start() {
    this.stopped = false;
    this.now = performance.now();
    this.id = window.requestAnimationFrame(this.render);
  }
  stop(force = false) {
    if (force) {
      window.cancelAnimationFrame(this.id);
    }
    this.stopped = true;
  }
  frame(t) {
    if (this.frames.length < 1)
      return false;
    for (let index = 0; index < this.frames.length && this.frames.length > 0; index++) {
      if (this.frames.length)
        this.frames[index].handler(t);
    }
    if (!this.stopped) {
      this.id = window.requestAnimationFrame(this.render);
    }
  }
  add(handler, id) {
    if (typeof handler !== "function")
      throw new Error("Expected function as handler");
    if (typeof id === "undefined")
      id = `h_${++this.uidCounter}`;
    this.frames.push({
      id,
      handler
    });
    if (this.frames.length === 1)
      this.start();
    return id;
  }
  moveToFirst(id) {
    if (typeof id === "undefined")
      throw new Error("Expected id");
    const index = this.frames.findIndex((object) => object.id === id);
    if (index < 0)
      return;
    else
      this.frames.unshift(this.frames.splice(index, 1)[0]);
  }
  remove(id) {
    if (typeof id === "undefined")
      throw new Error("Expected id");
    const index = this.frames.findIndex((object) => object.id === id);
    if (index < 0)
      return;
    else
      this.frames.splice(index, 1);
    if (this.frames.length <= 0)
      this.stop();
  }
}
var prism$1 = "";
var debug = "";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var prism = { exports: {} };
(function(module) {
  var _self = typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var Prism2 = function(_self2) {
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    var plainTextGrammar = {};
    var _ = {
      manual: _self2.Prism && _self2.Prism.manual,
      disableWorkerMessageHandler: _self2.Prism && _self2.Prism.disableWorkerMessageHandler,
      util: {
        encode: function encode(tokens) {
          if (tokens instanceof Token) {
            return new Token(tokens.type, encode(tokens.content), tokens.alias);
          } else if (Array.isArray(tokens)) {
            return tokens.map(encode);
          } else {
            return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          }
        },
        type: function(o) {
          return Object.prototype.toString.call(o).slice(8, -1);
        },
        objId: function(obj) {
          if (!obj["__id"]) {
            Object.defineProperty(obj, "__id", { value: ++uniqueId });
          }
          return obj["__id"];
        },
        clone: function deepClone(o, visited) {
          visited = visited || {};
          var clone;
          var id;
          switch (_.util.type(o)) {
            case "Object":
              id = _.util.objId(o);
              if (visited[id]) {
                return visited[id];
              }
              clone = {};
              visited[id] = clone;
              for (var key in o) {
                if (o.hasOwnProperty(key)) {
                  clone[key] = deepClone(o[key], visited);
                }
              }
              return clone;
            case "Array":
              id = _.util.objId(o);
              if (visited[id]) {
                return visited[id];
              }
              clone = [];
              visited[id] = clone;
              o.forEach(function(v, i) {
                clone[i] = deepClone(v, visited);
              });
              return clone;
            default:
              return o;
          }
        },
        getLanguage: function(element) {
          while (element) {
            var m = lang.exec(element.className);
            if (m) {
              return m[1].toLowerCase();
            }
            element = element.parentElement;
          }
          return "none";
        },
        setLanguage: function(element, language) {
          element.className = element.className.replace(RegExp(lang, "gi"), "");
          element.classList.add("language-" + language);
        },
        currentScript: function() {
          if (typeof document === "undefined") {
            return null;
          }
          if (document.currentScript && document.currentScript.tagName === "SCRIPT" && 1 < 2) {
            return document.currentScript;
          }
          try {
            throw new Error();
          } catch (err) {
            var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
            if (src) {
              var scripts = document.getElementsByTagName("script");
              for (var i in scripts) {
                if (scripts[i].src == src) {
                  return scripts[i];
                }
              }
            }
            return null;
          }
        },
        isActive: function(element, className, defaultActivation) {
          var no = "no-" + className;
          while (element) {
            var classList = element.classList;
            if (classList.contains(className)) {
              return true;
            }
            if (classList.contains(no)) {
              return false;
            }
            element = element.parentElement;
          }
          return !!defaultActivation;
        }
      },
      languages: {
        plain: plainTextGrammar,
        plaintext: plainTextGrammar,
        text: plainTextGrammar,
        txt: plainTextGrammar,
        extend: function(id, redef) {
          var lang2 = _.util.clone(_.languages[id]);
          for (var key in redef) {
            lang2[key] = redef[key];
          }
          return lang2;
        },
        insertBefore: function(inside, before, insert, root) {
          root = root || _.languages;
          var grammar = root[inside];
          var ret = {};
          for (var token in grammar) {
            if (grammar.hasOwnProperty(token)) {
              if (token == before) {
                for (var newToken in insert) {
                  if (insert.hasOwnProperty(newToken)) {
                    ret[newToken] = insert[newToken];
                  }
                }
              }
              if (!insert.hasOwnProperty(token)) {
                ret[token] = grammar[token];
              }
            }
          }
          var old = root[inside];
          root[inside] = ret;
          _.languages.DFS(_.languages, function(key, value) {
            if (value === old && key != inside) {
              this[key] = ret;
            }
          });
          return ret;
        },
        DFS: function DFS(o, callback, type, visited) {
          visited = visited || {};
          var objId = _.util.objId;
          for (var i in o) {
            if (o.hasOwnProperty(i)) {
              callback.call(o, i, o[i], type || i);
              var property = o[i];
              var propertyType = _.util.type(property);
              if (propertyType === "Object" && !visited[objId(property)]) {
                visited[objId(property)] = true;
                DFS(property, callback, null, visited);
              } else if (propertyType === "Array" && !visited[objId(property)]) {
                visited[objId(property)] = true;
                DFS(property, callback, i, visited);
              }
            }
          }
        }
      },
      plugins: {},
      highlightAll: function(async, callback) {
        _.highlightAllUnder(document, async, callback);
      },
      highlightAllUnder: function(container, async, callback) {
        var env = {
          callback,
          container,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        _.hooks.run("before-highlightall", env);
        env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
        _.hooks.run("before-all-elements-highlight", env);
        for (var i = 0, element; element = env.elements[i++]; ) {
          _.highlightElement(element, async === true, env.callback);
        }
      },
      highlightElement: function(element, async, callback) {
        var language = _.util.getLanguage(element);
        var grammar = _.languages[language];
        _.util.setLanguage(element, language);
        var parent = element.parentElement;
        if (parent && parent.nodeName.toLowerCase() === "pre") {
          _.util.setLanguage(parent, language);
        }
        var code = element.textContent;
        var env = {
          element,
          language,
          grammar,
          code
        };
        function insertHighlightedCode(highlightedCode) {
          env.highlightedCode = highlightedCode;
          _.hooks.run("before-insert", env);
          env.element.innerHTML = env.highlightedCode;
          _.hooks.run("after-highlight", env);
          _.hooks.run("complete", env);
          callback && callback.call(env.element);
        }
        _.hooks.run("before-sanity-check", env);
        parent = env.element.parentElement;
        if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) {
          parent.setAttribute("tabindex", "0");
        }
        if (!env.code) {
          _.hooks.run("complete", env);
          callback && callback.call(env.element);
          return;
        }
        _.hooks.run("before-highlight", env);
        if (!env.grammar) {
          insertHighlightedCode(_.util.encode(env.code));
          return;
        }
        if (async && _self2.Worker) {
          var worker = new Worker(_.filename);
          worker.onmessage = function(evt) {
            insertHighlightedCode(evt.data);
          };
          worker.postMessage(JSON.stringify({
            language: env.language,
            code: env.code,
            immediateClose: true
          }));
        } else {
          insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        }
      },
      highlight: function(text, grammar, language) {
        var env = {
          code: text,
          grammar,
          language
        };
        _.hooks.run("before-tokenize", env);
        if (!env.grammar) {
          throw new Error('The language "' + env.language + '" has no grammar.');
        }
        env.tokens = _.tokenize(env.code, env.grammar);
        _.hooks.run("after-tokenize", env);
        return Token.stringify(_.util.encode(env.tokens), env.language);
      },
      tokenize: function(text, grammar) {
        var rest = grammar.rest;
        if (rest) {
          for (var token in rest) {
            grammar[token] = rest[token];
          }
          delete grammar.rest;
        }
        var tokenList = new LinkedList();
        addAfter(tokenList, tokenList.head, text);
        matchGrammar(text, tokenList, grammar, tokenList.head, 0);
        return toArray(tokenList);
      },
      hooks: {
        all: {},
        add: function(name, callback) {
          var hooks = _.hooks.all;
          hooks[name] = hooks[name] || [];
          hooks[name].push(callback);
        },
        run: function(name, env) {
          var callbacks = _.hooks.all[name];
          if (!callbacks || !callbacks.length) {
            return;
          }
          for (var i = 0, callback; callback = callbacks[i++]; ) {
            callback(env);
          }
        }
      },
      Token
    };
    _self2.Prism = _;
    function Token(type, content, alias, matchedStr) {
      this.type = type;
      this.content = content;
      this.alias = alias;
      this.length = (matchedStr || "").length | 0;
    }
    Token.stringify = function stringify(o, language) {
      if (typeof o == "string") {
        return o;
      }
      if (Array.isArray(o)) {
        var s = "";
        o.forEach(function(e) {
          s += stringify(e, language);
        });
        return s;
      }
      var env = {
        type: o.type,
        content: stringify(o.content, language),
        tag: "span",
        classes: ["token", o.type],
        attributes: {},
        language
      };
      var aliases = o.alias;
      if (aliases) {
        if (Array.isArray(aliases)) {
          Array.prototype.push.apply(env.classes, aliases);
        } else {
          env.classes.push(aliases);
        }
      }
      _.hooks.run("wrap", env);
      var attributes = "";
      for (var name in env.attributes) {
        attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
      }
      return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    function matchPattern(pattern, pos, text, lookbehind) {
      pattern.lastIndex = pos;
      var match = pattern.exec(text);
      if (match && lookbehind && match[1]) {
        var lookbehindLength = match[1].length;
        match.index += lookbehindLength;
        match[0] = match[0].slice(lookbehindLength);
      }
      return match;
    }
    function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
      for (var token in grammar) {
        if (!grammar.hasOwnProperty(token) || !grammar[token]) {
          continue;
        }
        var patterns = grammar[token];
        patterns = Array.isArray(patterns) ? patterns : [patterns];
        for (var j = 0; j < patterns.length; ++j) {
          if (rematch && rematch.cause == token + "," + j) {
            return;
          }
          var patternObj = patterns[j];
          var inside = patternObj.inside;
          var lookbehind = !!patternObj.lookbehind;
          var greedy = !!patternObj.greedy;
          var alias = patternObj.alias;
          if (greedy && !patternObj.pattern.global) {
            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
          }
          var pattern = patternObj.pattern || patternObj;
          for (var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next) {
            if (rematch && pos >= rematch.reach) {
              break;
            }
            var str = currentNode.value;
            if (tokenList.length > text.length) {
              return;
            }
            if (str instanceof Token) {
              continue;
            }
            var removeCount = 1;
            var match;
            if (greedy) {
              match = matchPattern(pattern, pos, text, lookbehind);
              if (!match || match.index >= text.length) {
                break;
              }
              var from = match.index;
              var to = match.index + match[0].length;
              var p = pos;
              p += currentNode.value.length;
              while (from >= p) {
                currentNode = currentNode.next;
                p += currentNode.value.length;
              }
              p -= currentNode.value.length;
              pos = p;
              if (currentNode.value instanceof Token) {
                continue;
              }
              for (var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next) {
                removeCount++;
                p += k.value.length;
              }
              removeCount--;
              str = text.slice(pos, p);
              match.index -= pos;
            } else {
              match = matchPattern(pattern, 0, str, lookbehind);
              if (!match) {
                continue;
              }
            }
            var from = match.index;
            var matchStr = match[0];
            var before = str.slice(0, from);
            var after = str.slice(from + matchStr.length);
            var reach = pos + str.length;
            if (rematch && reach > rematch.reach) {
              rematch.reach = reach;
            }
            var removeFrom = currentNode.prev;
            if (before) {
              removeFrom = addAfter(tokenList, removeFrom, before);
              pos += before.length;
            }
            removeRange(tokenList, removeFrom, removeCount);
            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
            currentNode = addAfter(tokenList, removeFrom, wrapped);
            if (after) {
              addAfter(tokenList, currentNode, after);
            }
            if (removeCount > 1) {
              var nestedRematch = {
                cause: token + "," + j,
                reach
              };
              matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
              if (rematch && nestedRematch.reach > rematch.reach) {
                rematch.reach = nestedRematch.reach;
              }
            }
          }
        }
      }
    }
    function LinkedList() {
      var head = { value: null, prev: null, next: null };
      var tail = { value: null, prev: head, next: null };
      head.next = tail;
      this.head = head;
      this.tail = tail;
      this.length = 0;
    }
    function addAfter(list, node, value) {
      var next2 = node.next;
      var newNode = { value, prev: node, next: next2 };
      node.next = newNode;
      next2.prev = newNode;
      list.length++;
      return newNode;
    }
    function removeRange(list, node, count) {
      var next2 = node.next;
      for (var i = 0; i < count && next2 !== list.tail; i++) {
        next2 = next2.next;
      }
      node.next = next2;
      next2.prev = node;
      list.length -= i;
    }
    function toArray(list) {
      var array = [];
      var node = list.head.next;
      while (node !== list.tail) {
        array.push(node.value);
        node = node.next;
      }
      return array;
    }
    if (!_self2.document) {
      if (!_self2.addEventListener) {
        return _;
      }
      if (!_.disableWorkerMessageHandler) {
        _self2.addEventListener("message", function(evt) {
          var message = JSON.parse(evt.data);
          var lang2 = message.language;
          var code = message.code;
          var immediateClose = message.immediateClose;
          _self2.postMessage(_.highlight(code, _.languages[lang2], lang2));
          if (immediateClose) {
            _self2.close();
          }
        }, false);
      }
      return _;
    }
    var script = _.util.currentScript();
    if (script) {
      _.filename = script.src;
      if (script.hasAttribute("data-manual")) {
        _.manual = true;
      }
    }
    function highlightAutomaticallyCallback() {
      if (!_.manual) {
        _.highlightAll();
      }
    }
    if (!_.manual) {
      var readyState = document.readyState;
      if (readyState === "loading" || readyState === "interactive" && script && script.defer) {
        document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
      } else {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(highlightAutomaticallyCallback);
        } else {
          window.setTimeout(highlightAutomaticallyCallback, 16);
        }
      }
    }
    return _;
  }(_self);
  if (module.exports) {
    module.exports = Prism2;
  }
  if (typeof commonjsGlobal !== "undefined") {
    commonjsGlobal.Prism = Prism2;
  }
  Prism2.languages.markup = {
    "comment": {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: true
    },
    "prolog": {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: true
    },
    "doctype": {
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: true,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: true,
          greedy: true,
          inside: null
        },
        "string": {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: true
        },
        "punctuation": /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        "name": /[^\s<>'"]+/
      }
    },
    "cdata": {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: true
    },
    "tag": {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: true,
      inside: {
        "tag": {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            "punctuation": /^<\/?/,
            "namespace": /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            "punctuation": [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              {
                pattern: /^(\s*)["']|["']$/,
                lookbehind: true
              }
            ]
          }
        },
        "punctuation": /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            "namespace": /^[^\s>\/:]+:/
          }
        }
      }
    },
    "entity": [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  };
  Prism2.languages.markup["tag"].inside["attr-value"].inside["entity"] = Prism2.languages.markup["entity"];
  Prism2.languages.markup["doctype"].inside["internal-subset"].inside = Prism2.languages.markup;
  Prism2.hooks.add("wrap", function(env) {
    if (env.type === "entity") {
      env.attributes["title"] = env.content.replace(/&amp;/, "&");
    }
  });
  Object.defineProperty(Prism2.languages.markup.tag, "addInlined", {
    value: function addInlined(tagName, lang) {
      var includedCdataInside = {};
      includedCdataInside["language-" + lang] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: true,
        inside: Prism2.languages[lang]
      };
      includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
      var inside = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: includedCdataInside
        }
      };
      inside["language-" + lang] = {
        pattern: /[\s\S]+/,
        inside: Prism2.languages[lang]
      };
      var def = {};
      def[tagName] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
          return tagName;
        }), "i"),
        lookbehind: true,
        greedy: true,
        inside
      };
      Prism2.languages.insertBefore("markup", "cdata", def);
    }
  });
  Object.defineProperty(Prism2.languages.markup.tag, "addAttribute", {
    value: function(attrName, lang) {
      Prism2.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: true,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              "value": {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: true,
                alias: [lang, "language-" + lang],
                inside: Prism2.languages[lang]
              },
              "punctuation": [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  });
  Prism2.languages.html = Prism2.languages.markup;
  Prism2.languages.mathml = Prism2.languages.markup;
  Prism2.languages.svg = Prism2.languages.markup;
  Prism2.languages.xml = Prism2.languages.extend("markup", {});
  Prism2.languages.ssml = Prism2.languages.xml;
  Prism2.languages.atom = Prism2.languages.xml;
  Prism2.languages.rss = Prism2.languages.xml;
  (function(Prism3) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism3.languages.css = {
      "comment": /\/\*[\s\S]*?\*\//,
      "atrule": {
        pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
        inside: {
          "rule": /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: true,
            alias: "selector"
          },
          "keyword": {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: true
          }
        }
      },
      "url": {
        pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: true,
        inside: {
          "function": /^url/i,
          "punctuation": /^\(|\)$/,
          "string": {
            pattern: RegExp("^" + string.source + "$"),
            alias: "url"
          }
        }
      },
      "selector": {
        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + string.source + ")*(?=\\s*\\{)"),
        lookbehind: true
      },
      "string": {
        pattern: string,
        greedy: true
      },
      "property": {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: true
      },
      "important": /!important\b/i,
      "function": {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: true
      },
      "punctuation": /[(){};:,]/
    };
    Prism3.languages.css["atrule"].inside.rest = Prism3.languages.css;
    var markup = Prism3.languages.markup;
    if (markup) {
      markup.tag.addInlined("style", "css");
      markup.tag.addAttribute("style", "css");
    }
  })(Prism2);
  Prism2.languages.clike = {
    "comment": [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: true,
        greedy: true
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true,
        greedy: true
      }
    ],
    "string": {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: true,
      inside: {
        "punctuation": /[.\\]/
      }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
  };
  Prism2.languages.javascript = Prism2.languages.extend("clike", {
    "class-name": [
      Prism2.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: true
      }
    ],
    "keyword": [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: true
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: true
      }
    ],
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + (/NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  });
  Prism2.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
  Prism2.languages.insertBefore("javascript", "keyword", {
    "regex": {
      pattern: RegExp(
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
      ),
      lookbehind: true,
      greedy: true,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: true,
          alias: "language-regex",
          inside: Prism2.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    "parameter": [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: true,
        inside: Prism2.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: true,
        inside: Prism2.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: true,
        inside: Prism2.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: true,
        inside: Prism2.languages.javascript
      }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  });
  Prism2.languages.insertBefore("javascript", "string", {
    "hashbang": {
      pattern: /^#!.*/,
      greedy: true,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: true,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        "interpolation": {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: true,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: Prism2.languages.javascript
          }
        },
        "string": /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: true,
      greedy: true,
      alias: "property"
    }
  });
  Prism2.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: true,
      alias: "property"
    }
  });
  if (Prism2.languages.markup) {
    Prism2.languages.markup.tag.addInlined("script", "javascript");
    Prism2.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
      "javascript"
    );
  }
  Prism2.languages.js = Prism2.languages.javascript;
  (function() {
    if (typeof Prism2 === "undefined" || typeof document === "undefined") {
      return;
    }
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
      return "\u2716 Error " + status + " while fetching file: " + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS2 = {
      "js": "javascript",
      "py": "python",
      "rb": "ruby",
      "ps1": "powershell",
      "psm1": "powershell",
      "sh": "bash",
      "bat": "batch",
      "h": "c",
      "tex": "latex"
    };
    var STATUS_ATTR = "data-src-status";
    var STATUS_LOADING = "loading";
    var STATUS_LOADED = "loaded";
    var STATUS_FAILED = "failed";
    var SELECTOR = "pre[data-src]:not([" + STATUS_ATTR + '="' + STATUS_LOADED + '"]):not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    function loadFile(src, success, error) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", src, true);
      xhr.onreadystatechange = function() {
        if (xhr.readyState == 4) {
          if (xhr.status < 400 && xhr.responseText) {
            success(xhr.responseText);
          } else {
            if (xhr.status >= 400) {
              error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
            } else {
              error(FAILURE_EMPTY_MESSAGE);
            }
          }
        }
      };
      xhr.send(null);
    }
    function parseRange(range) {
      var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || "");
      if (m) {
        var start = Number(m[1]);
        var comma = m[2];
        var end = m[3];
        if (!comma) {
          return [start, start];
        }
        if (!end) {
          return [start, void 0];
        }
        return [start, Number(end)];
      }
      return void 0;
    }
    Prism2.hooks.add("before-highlightall", function(env) {
      env.selector += ", " + SELECTOR;
    });
    Prism2.hooks.add("before-sanity-check", function(env) {
      var pre = env.element;
      if (pre.matches(SELECTOR)) {
        env.code = "";
        pre.setAttribute(STATUS_ATTR, STATUS_LOADING);
        var code = pre.appendChild(document.createElement("CODE"));
        code.textContent = LOADING_MESSAGE;
        var src = pre.getAttribute("data-src");
        var language = env.language;
        if (language === "none") {
          var extension = (/\.(\w+)$/.exec(src) || [, "none"])[1];
          language = EXTENSIONS2[extension] || extension;
        }
        Prism2.util.setLanguage(code, language);
        Prism2.util.setLanguage(pre, language);
        var autoloader = Prism2.plugins.autoloader;
        if (autoloader) {
          autoloader.loadLanguages(language);
        }
        loadFile(
          src,
          function(text) {
            pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
            var range = parseRange(pre.getAttribute("data-range"));
            if (range) {
              var lines = text.split(/\r\n?|\n/g);
              var start = range[0];
              var end = range[1] == null ? lines.length : range[1];
              if (start < 0) {
                start += lines.length;
              }
              start = Math.max(0, Math.min(start - 1, lines.length));
              if (end < 0) {
                end += lines.length;
              }
              end = Math.max(0, Math.min(end, lines.length));
              text = lines.slice(start, end).join("\n");
              if (!pre.hasAttribute("data-start")) {
                pre.setAttribute("data-start", String(start + 1));
              }
            }
            code.textContent = text;
            Prism2.highlightElement(code);
          },
          function(error) {
            pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
            code.textContent = error;
          }
        );
      }
    });
    Prism2.plugins.fileHighlight = {
      highlight: function highlight(container) {
        var elements = (container || document).querySelectorAll(SELECTOR);
        for (var i = 0, element; element = elements[i++]; ) {
          Prism2.highlightElement(element);
        }
      }
    };
    var logged = false;
    Prism2.fileHighlight = function() {
      if (!logged) {
        console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.");
        logged = true;
      }
      Prism2.plugins.fileHighlight.highlight.apply(this, arguments);
    };
  })();
})(prism);
var Prism = prism.exports;
var tweakpane = { exports: {} };
/*! Tweakpane 1.6.1 (c) 2016 cocopon, licensed under the MIT license. */
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var extendStatics = function(d, b) {
      extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p in b2)
          if (Object.prototype.hasOwnProperty.call(b2, p))
            d2[p] = b2[p];
      };
      return extendStatics(d, b);
    };
    function __extends(d, b) {
      if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
      __assign = Object.assign || function __assign2(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
        s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
      return r;
    }
    var Plugins = {
      inputs: [],
      monitors: []
    };
    function getAllPlugins() {
      return __spreadArrays(Plugins.inputs, Plugins.monitors);
    }
    function forceCast(v) {
      return v;
    }
    function isEmpty(value) {
      return value === null || value === void 0;
    }
    function deepEqualsArray(a1, a2) {
      if (a1.length !== a2.length) {
        return false;
      }
      for (var i = 0; i < a1.length; i++) {
        if (a1[i] !== a2[i]) {
          return false;
        }
      }
      return true;
    }
    function disposeElement(elem) {
      if (elem && elem.parentElement) {
        elem.parentElement.removeChild(elem);
      }
      return null;
    }
    var PREFIX = "tp";
    function ClassName(viewName) {
      return function(opt_elementName, opt_modifier) {
        return [
          PREFIX,
          "-",
          viewName,
          "v",
          opt_elementName ? "_" + opt_elementName : "",
          opt_modifier ? "-" + opt_modifier : ""
        ].join("");
      };
    }
    function getAllBladePositions() {
      return ["first", "last"];
    }
    var className = ClassName("");
    function setUpBladeView(view, model) {
      var elem = view.element;
      model.emitter.on("change", function(ev) {
        if (ev.propertyName === "hidden") {
          var hiddenClass = className(void 0, "hidden");
          if (model.hidden) {
            elem.classList.add(hiddenClass);
          } else {
            elem.classList.remove(hiddenClass);
          }
        } else if (ev.propertyName === "positions") {
          getAllBladePositions().forEach(function(pos) {
            elem.classList.remove(className(void 0, pos));
          });
          model.positions.forEach(function(pos) {
            elem.classList.add(className(void 0, pos));
          });
        }
      });
      model.emitter.on("dispose", function() {
        if (view.onDispose) {
          view.onDispose();
        }
        disposeElement(elem);
      });
    }
    var Emitter = function() {
      function Emitter2() {
        this.observers_ = {};
      }
      Emitter2.prototype.on = function(eventName, handler) {
        var observers = this.observers_[eventName];
        if (!observers) {
          observers = this.observers_[eventName] = [];
        }
        observers.push({
          handler
        });
        return this;
      };
      Emitter2.prototype.off = function(eventName, handler) {
        var observers = this.observers_[eventName];
        if (observers) {
          this.observers_[eventName] = observers.filter(function(observer) {
            return observer.handler !== handler;
          });
        }
        return this;
      };
      Emitter2.prototype.emit = function(eventName, event) {
        var observers = this.observers_[eventName];
        if (!observers) {
          return;
        }
        observers.forEach(function(observer) {
          observer.handler(event);
        });
      };
      return Emitter2;
    }();
    var Button = function() {
      function Button2(title) {
        this.emitter = new Emitter();
        this.title = title;
      }
      Button2.prototype.click = function() {
        this.emitter.emit("click", {
          sender: this
        });
      };
      return Button2;
    }();
    var className$1 = ClassName("btn");
    var ButtonView = function() {
      function ButtonView2(doc, config) {
        this.button = config.button;
        this.element = doc.createElement("div");
        this.element.classList.add(className$1());
        var buttonElem = doc.createElement("button");
        buttonElem.classList.add(className$1("b"));
        buttonElem.textContent = this.button.title;
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
      }
      return ButtonView2;
    }();
    var ButtonController = function() {
      function ButtonController2(doc, config) {
        this.onButtonClick_ = this.onButtonClick_.bind(this);
        this.button = new Button(config.title);
        this.blade = config.blade;
        this.view = new ButtonView(doc, {
          button: this.button
        });
        this.view.buttonElement.addEventListener("click", this.onButtonClick_);
        setUpBladeView(this.view, this.blade);
      }
      ButtonController2.prototype.onButtonClick_ = function() {
        this.button.click();
      };
      return ButtonController2;
    }();
    var className$2 = ClassName("lbl");
    function createLabelNode(doc, label) {
      var frag = doc.createDocumentFragment();
      var lineNodes = label.split("\n").map(function(line) {
        return doc.createTextNode(line);
      });
      lineNodes.forEach(function(lineNode, index) {
        if (index > 0) {
          frag.appendChild(doc.createElement("br"));
        }
        frag.appendChild(lineNode);
      });
      return frag;
    }
    var LabeledView = function() {
      function LabeledView2(doc, config) {
        this.label = config.label;
        this.elem_ = doc.createElement("div");
        this.elem_.classList.add(className$2());
        var labelElem = doc.createElement("div");
        labelElem.classList.add(className$2("l"));
        labelElem.appendChild(createLabelNode(doc, this.label));
        this.elem_.appendChild(labelElem);
        var viewElem = doc.createElement("div");
        viewElem.classList.add(className$2("v"));
        viewElem.appendChild(config.view.element);
        this.elem_.appendChild(viewElem);
      }
      Object.defineProperty(LabeledView2.prototype, "element", {
        get: function() {
          return this.elem_;
        },
        enumerable: false,
        configurable: true
      });
      return LabeledView2;
    }();
    var InputBindingController = function() {
      function InputBindingController2(doc, config) {
        this.binding = config.binding;
        this.controller = config.controller;
        this.view = new LabeledView(doc, {
          label: config.label,
          view: this.controller.view
        });
        this.blade = config.blade;
        setUpBladeView(this.view, this.blade);
      }
      return InputBindingController2;
    }();
    var MonitorBindingController = function() {
      function MonitorBindingController2(doc, config) {
        var _this = this;
        this.binding = config.binding;
        this.controller = config.controller;
        this.view = new LabeledView(doc, {
          label: config.label,
          view: this.controller.view
        });
        this.blade = config.blade;
        this.blade.emitter.on("dispose", function() {
          _this.binding.dispose();
        });
        setUpBladeView(this.view, this.blade);
      }
      return MonitorBindingController2;
    }();
    var Disposable = function() {
      function Disposable2() {
        this.emitter = new Emitter();
        this.disposed_ = false;
      }
      Object.defineProperty(Disposable2.prototype, "disposed", {
        get: function() {
          return this.disposed_;
        },
        enumerable: false,
        configurable: true
      });
      Disposable2.prototype.dispose = function() {
        if (this.disposed_) {
          return false;
        }
        this.disposed_ = true;
        this.emitter.emit("dispose", {
          sender: this
        });
        return true;
      };
      return Disposable2;
    }();
    var Blade = function() {
      function Blade2() {
        this.onDispose_ = this.onDispose_.bind(this);
        this.emitter = new Emitter();
        this.positions_ = [];
        this.hidden_ = false;
        this.disposable_ = new Disposable();
        this.disposable_.emitter.on("dispose", this.onDispose_);
      }
      Object.defineProperty(Blade2.prototype, "hidden", {
        get: function() {
          return this.hidden_;
        },
        set: function(hidden) {
          if (this.hidden_ === hidden) {
            return;
          }
          this.hidden_ = hidden;
          this.emitter.emit("change", {
            propertyName: "hidden",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Blade2.prototype, "positions", {
        get: function() {
          return this.positions_;
        },
        set: function(positions) {
          if (deepEqualsArray(positions, this.positions_)) {
            return;
          }
          this.positions_ = positions;
          this.emitter.emit("change", {
            propertyName: "positions",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Blade2.prototype, "disposed", {
        get: function() {
          return this.disposable_.disposed;
        },
        enumerable: false,
        configurable: true
      });
      Blade2.prototype.dispose = function() {
        this.disposable_.dispose();
      };
      Blade2.prototype.onDispose_ = function() {
        this.emitter.emit("dispose", {
          sender: this
        });
      };
      return Blade2;
    }();
    var SVG_NS = "http://www.w3.org/2000/svg";
    function forceReflow(element) {
      element.offsetHeight;
    }
    function disableTransitionTemporarily(element, callback) {
      var t = element.style.transition;
      element.style.transition = "none";
      callback();
      element.style.transition = t;
    }
    function supportsTouch(doc) {
      return doc.ontouchstart !== void 0;
    }
    function getGlobalObject() {
      return new Function("return this")();
    }
    function getWindowDocument() {
      var globalObj = forceCast(getGlobalObject());
      return globalObj.document;
    }
    function isBrowser() {
      return "document" in getGlobalObject();
    }
    function getCanvasContext(canvasElement) {
      return isBrowser() ? canvasElement.getContext("2d") : null;
    }
    var ICON_ID_TO_INNER_HTML_MAP = {
      p2dpad: '<path d="M8 2V14" stroke="currentColor" stroke-width="1.5"/><path d="M2 8H14" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="8" r="2" fill="currentColor"/>'
    };
    function createSvgIconElement(document2, iconId) {
      var elem = document2.createElementNS(SVG_NS, "svg");
      elem.innerHTML = ICON_ID_TO_INNER_HTML_MAP[iconId];
      return elem;
    }
    function insertElementAt(parentElement, element, index) {
      parentElement.insertBefore(element, parentElement.children[index]);
    }
    function findNextTarget(ev) {
      if (ev.relatedTarget) {
        return forceCast(ev.relatedTarget);
      }
      if ("explicitOriginalTarget" in ev) {
        return ev.explicitOriginalTarget;
      }
      return null;
    }
    function updateAllItemsPositions(bladeRack) {
      var visibleItems = bladeRack.items.filter(function(bc) {
        return !bc.blade.hidden;
      });
      var firstVisibleItem = visibleItems[0];
      var lastVisibleItem = visibleItems[visibleItems.length - 1];
      bladeRack.items.forEach(function(bc) {
        var ps = [];
        if (bc === firstVisibleItem) {
          ps.push("first");
        }
        if (bc === lastVisibleItem) {
          ps.push("last");
        }
        bc.blade.positions = ps;
      });
    }
    function computeExpandedFolderHeight(folder, containerElement) {
      var height = 0;
      disableTransitionTemporarily(containerElement, function() {
        folder.expandedHeight = null;
        folder.temporaryExpanded = true;
        forceReflow(containerElement);
        height = containerElement.clientHeight;
        folder.temporaryExpanded = null;
        forceReflow(containerElement);
      });
      return height;
    }
    var List = function() {
      function List2() {
        this.emitter = new Emitter();
        this.items_ = [];
      }
      Object.defineProperty(List2.prototype, "items", {
        get: function() {
          return this.items_;
        },
        enumerable: false,
        configurable: true
      });
      List2.prototype.add = function(item, opt_index) {
        var index = opt_index !== void 0 ? opt_index : this.items_.length;
        this.items_.splice(index, 0, item);
        this.emitter.emit("add", {
          index,
          item,
          sender: this
        });
      };
      List2.prototype.remove = function(item) {
        var index = this.items_.indexOf(item);
        if (index < 0) {
          return;
        }
        this.items_.splice(index, 1);
        this.emitter.emit("remove", {
          sender: this
        });
      };
      return List2;
    }();
    var BladeRack = function() {
      function BladeRack2() {
        this.onItemFolderFold_ = this.onItemFolderFold_.bind(this);
        this.onListItemLayout_ = this.onListItemLayout_.bind(this);
        this.onSubitemLayout_ = this.onSubitemLayout_.bind(this);
        this.onSubitemFolderFold_ = this.onSubitemFolderFold_.bind(this);
        this.onSubitemInputChange_ = this.onSubitemInputChange_.bind(this);
        this.onSubitemMonitorUpdate_ = this.onSubitemMonitorUpdate_.bind(this);
        this.onItemInputChange_ = this.onItemInputChange_.bind(this);
        this.onListAdd_ = this.onListAdd_.bind(this);
        this.onListItemDispose_ = this.onListItemDispose_.bind(this);
        this.onListRemove_ = this.onListRemove_.bind(this);
        this.onItemMonitorUpdate_ = this.onItemMonitorUpdate_.bind(this);
        this.blades_ = new List();
        this.emitter = new Emitter();
        this.blades_.emitter.on("add", this.onListAdd_);
        this.blades_.emitter.on("remove", this.onListRemove_);
      }
      Object.defineProperty(BladeRack2.prototype, "items", {
        get: function() {
          return this.blades_.items;
        },
        enumerable: false,
        configurable: true
      });
      BladeRack2.prototype.add = function(bc, opt_index) {
        this.blades_.add(bc, opt_index);
      };
      BladeRack2.prototype.find = function(controllerClass) {
        return this.items.reduce(function(results, bc) {
          if (bc instanceof FolderController) {
            results.push.apply(results, bc.bladeRack.find(controllerClass));
          }
          if (bc instanceof controllerClass) {
            results.push(bc);
          }
          return results;
        }, []);
      };
      BladeRack2.prototype.onListAdd_ = function(ev) {
        var bc = ev.item;
        this.emitter.emit("add", {
          blade: bc,
          index: ev.index,
          sender: this
        });
        bc.blade.emitter.on("dispose", this.onListItemDispose_);
        bc.blade.emitter.on("change", this.onListItemLayout_);
        if (bc instanceof InputBindingController) {
          bc.binding.emitter.on("change", this.onItemInputChange_);
        } else if (bc instanceof MonitorBindingController) {
          bc.binding.emitter.on("update", this.onItemMonitorUpdate_);
        } else if (bc instanceof FolderController) {
          bc.folder.emitter.on("change", this.onItemFolderFold_);
          var emitter = bc.bladeRack.emitter;
          emitter.on("itemfold", this.onSubitemFolderFold_);
          emitter.on("itemlayout", this.onSubitemLayout_);
          emitter.on("inputchange", this.onSubitemInputChange_);
          emitter.on("monitorupdate", this.onSubitemMonitorUpdate_);
        }
      };
      BladeRack2.prototype.onListRemove_ = function(_) {
        this.emitter.emit("remove", {
          sender: this
        });
      };
      BladeRack2.prototype.onListItemLayout_ = function(ev) {
        if (ev.propertyName === "hidden" || ev.propertyName === "positions") {
          this.emitter.emit("itemlayout", {
            sender: this
          });
        }
      };
      BladeRack2.prototype.onListItemDispose_ = function(_) {
        var _this = this;
        var disposedUcs = this.blades_.items.filter(function(bc) {
          return bc.blade.disposed;
        });
        disposedUcs.forEach(function(bc) {
          _this.blades_.remove(bc);
        });
      };
      BladeRack2.prototype.onItemInputChange_ = function(ev) {
        this.emitter.emit("inputchange", {
          inputBinding: ev.sender,
          sender: this,
          value: ev.rawValue
        });
      };
      BladeRack2.prototype.onItemMonitorUpdate_ = function(ev) {
        this.emitter.emit("monitorupdate", {
          monitorBinding: ev.sender,
          sender: this,
          value: ev.rawValue
        });
      };
      BladeRack2.prototype.onItemFolderFold_ = function(ev) {
        if (ev.propertyName !== "expanded") {
          return;
        }
        this.emitter.emit("itemfold", {
          expanded: ev.sender.expanded,
          sender: this
        });
      };
      BladeRack2.prototype.onSubitemLayout_ = function(_) {
        this.emitter.emit("itemlayout", {
          sender: this
        });
      };
      BladeRack2.prototype.onSubitemInputChange_ = function(ev) {
        this.emitter.emit("inputchange", {
          inputBinding: ev.inputBinding,
          sender: this,
          value: ev.value
        });
      };
      BladeRack2.prototype.onSubitemMonitorUpdate_ = function(ev) {
        this.emitter.emit("monitorupdate", {
          monitorBinding: ev.monitorBinding,
          sender: this,
          value: ev.value
        });
      };
      BladeRack2.prototype.onSubitemFolderFold_ = function(ev) {
        this.emitter.emit("itemfold", {
          expanded: ev.expanded,
          sender: this
        });
      };
      return BladeRack2;
    }();
    var Folder = function() {
      function Folder2(title, expanded) {
        this.emitter = new Emitter();
        this.expanded_ = expanded;
        this.expandedHeight_ = null;
        this.temporaryExpanded_ = null;
        this.shouldFixHeight_ = false;
        this.title = title;
      }
      Object.defineProperty(Folder2.prototype, "expanded", {
        get: function() {
          return this.expanded_;
        },
        set: function(expanded) {
          var changed = this.expanded_ !== expanded;
          if (!changed) {
            return;
          }
          this.emitter.emit("beforechange", {
            propertyName: "expanded",
            sender: this
          });
          this.expanded_ = expanded;
          this.emitter.emit("change", {
            propertyName: "expanded",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Folder2.prototype, "temporaryExpanded", {
        get: function() {
          return this.temporaryExpanded_;
        },
        set: function(expanded) {
          var changed = this.temporaryExpanded_ !== expanded;
          if (!changed) {
            return;
          }
          this.emitter.emit("beforechange", {
            propertyName: "temporaryExpanded",
            sender: this
          });
          this.temporaryExpanded_ = expanded;
          this.emitter.emit("change", {
            propertyName: "temporaryExpanded",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Folder2.prototype, "expandedHeight", {
        get: function() {
          return this.expandedHeight_;
        },
        set: function(expandedHeight) {
          var changed = this.expandedHeight_ !== expandedHeight;
          if (!changed) {
            return;
          }
          this.emitter.emit("beforechange", {
            propertyName: "expandedHeight",
            sender: this
          });
          this.expandedHeight_ = expandedHeight;
          this.emitter.emit("change", {
            propertyName: "expandedHeight",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Folder2.prototype, "shouldFixHeight", {
        get: function() {
          return this.shouldFixHeight_;
        },
        set: function(shouldFixHeight) {
          var changed = this.shouldFixHeight_ !== shouldFixHeight;
          if (!changed) {
            return;
          }
          this.emitter.emit("beforechange", {
            propertyName: "shouldFixHeight",
            sender: this
          });
          this.shouldFixHeight_ = shouldFixHeight;
          this.emitter.emit("change", {
            propertyName: "shouldFixHeight",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Folder2.prototype, "styleExpanded", {
        get: function() {
          var _a;
          return (_a = this.temporaryExpanded) !== null && _a !== void 0 ? _a : this.expanded;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Folder2.prototype, "styleHeight", {
        get: function() {
          if (!this.styleExpanded) {
            return "0";
          }
          if (this.shouldFixHeight && !isEmpty(this.expandedHeight)) {
            return this.expandedHeight + "px";
          }
          return "auto";
        },
        enumerable: false,
        configurable: true
      });
      return Folder2;
    }();
    var className$3 = ClassName("fld");
    var FolderView = function() {
      function FolderView2(doc, config) {
        this.onFolderChange_ = this.onFolderChange_.bind(this);
        this.folder_ = config.folder;
        this.folder_.emitter.on("change", this.onFolderChange_);
        this.element = doc.createElement("div");
        this.element.classList.add(className$3());
        var titleElem = doc.createElement("button");
        titleElem.classList.add(className$3("t"));
        titleElem.textContent = this.folder_.title;
        this.element.appendChild(titleElem);
        this.titleElement = titleElem;
        var markElem = doc.createElement("div");
        markElem.classList.add(className$3("m"));
        this.titleElement.appendChild(markElem);
        var containerElem = doc.createElement("div");
        containerElem.classList.add(className$3("c"));
        this.element.appendChild(containerElem);
        this.containerElement = containerElem;
        this.applyModel_();
      }
      FolderView2.prototype.applyModel_ = function() {
        var expanded = this.folder_.styleExpanded;
        var expandedClass = className$3(void 0, "expanded");
        if (expanded) {
          this.element.classList.add(expandedClass);
        } else {
          this.element.classList.remove(expandedClass);
        }
        this.containerElement.style.height = this.folder_.styleHeight;
      };
      FolderView2.prototype.onFolderChange_ = function() {
        this.applyModel_();
      };
      return FolderView2;
    }();
    var FolderController = function() {
      function FolderController2(doc, config) {
        var _a;
        this.onContainerTransitionEnd_ = this.onContainerTransitionEnd_.bind(this);
        this.onFolderBeforeChange_ = this.onFolderBeforeChange_.bind(this);
        this.onTitleClick_ = this.onTitleClick_.bind(this);
        this.onRackAdd_ = this.onRackAdd_.bind(this);
        this.onRackItemLayout_ = this.onRackItemLayout_.bind(this);
        this.onRackRemove_ = this.onRackRemove_.bind(this);
        this.blade = config.blade;
        this.folder = new Folder(config.title, (_a = config.expanded) !== null && _a !== void 0 ? _a : true);
        this.folder.emitter.on("beforechange", this.onFolderBeforeChange_);
        this.rack_ = new BladeRack();
        this.rack_.emitter.on("add", this.onRackAdd_);
        this.rack_.emitter.on("itemlayout", this.onRackItemLayout_);
        this.rack_.emitter.on("remove", this.onRackRemove_);
        this.doc_ = doc;
        this.view = new FolderView(this.doc_, {
          folder: this.folder
        });
        this.view.titleElement.addEventListener("click", this.onTitleClick_);
        this.view.containerElement.addEventListener("transitionend", this.onContainerTransitionEnd_);
        setUpBladeView(this.view, this.blade);
      }
      Object.defineProperty(FolderController2.prototype, "document", {
        get: function() {
          return this.doc_;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(FolderController2.prototype, "bladeRack", {
        get: function() {
          return this.rack_;
        },
        enumerable: false,
        configurable: true
      });
      FolderController2.prototype.onFolderBeforeChange_ = function(ev) {
        if (ev.propertyName !== "expanded") {
          return;
        }
        if (isEmpty(this.folder.expandedHeight)) {
          this.folder.expandedHeight = computeExpandedFolderHeight(this.folder, this.view.containerElement);
        }
        this.folder.shouldFixHeight = true;
        forceReflow(this.view.containerElement);
      };
      FolderController2.prototype.onTitleClick_ = function() {
        this.folder.expanded = !this.folder.expanded;
      };
      FolderController2.prototype.applyRackChange_ = function() {
        updateAllItemsPositions(this.bladeRack);
      };
      FolderController2.prototype.onRackAdd_ = function(ev) {
        insertElementAt(this.view.containerElement, ev.blade.view.element, ev.index);
        this.applyRackChange_();
      };
      FolderController2.prototype.onRackRemove_ = function(_) {
        this.applyRackChange_();
      };
      FolderController2.prototype.onRackItemLayout_ = function(_) {
        this.applyRackChange_();
      };
      FolderController2.prototype.onContainerTransitionEnd_ = function(ev) {
        if (ev.propertyName !== "height") {
          return;
        }
        this.folder.shouldFixHeight = false;
        this.folder.expandedHeight = null;
      };
      return FolderController2;
    }();
    var className$4 = ClassName("spt");
    var SeparatorView = function() {
      function SeparatorView2(doc) {
        this.element = doc.createElement("div");
        this.element.classList.add(className$4());
        var hrElem = doc.createElement("hr");
        hrElem.classList.add(className$4("r"));
        this.element.appendChild(hrElem);
      }
      return SeparatorView2;
    }();
    var SeparatorController = function() {
      function SeparatorController2(doc, config) {
        this.blade = config.blade;
        this.view = new SeparatorView(doc);
        setUpBladeView(this.view, this.blade);
      }
      return SeparatorController2;
    }();
    var ButtonApi = function() {
      function ButtonApi2(buttonController) {
        this.controller = buttonController;
      }
      Object.defineProperty(ButtonApi2.prototype, "hidden", {
        get: function() {
          return this.controller.blade.hidden;
        },
        set: function(hidden) {
          this.controller.blade.hidden = hidden;
        },
        enumerable: false,
        configurable: true
      });
      ButtonApi2.prototype.dispose = function() {
        this.controller.blade.dispose();
      };
      ButtonApi2.prototype.on = function(eventName, handler) {
        var emitter = this.controller.button.emitter;
        emitter.on(eventName, forceCast(handler.bind(this)));
        return this;
      };
      return ButtonApi2;
    }();
    function handleInputBinding(_a) {
      var binding = _a.binding, eventName = _a.eventName, handler = _a.handler;
      if (eventName === "change") {
        var emitter = binding.emitter;
        emitter.on("change", function(ev) {
          handler(forceCast(ev.sender.target.read()));
        });
      }
    }
    function handleMonitorBinding(_a) {
      var binding = _a.binding, eventName = _a.eventName, handler = _a.handler;
      if (eventName === "update") {
        var emitter = binding.emitter;
        emitter.on("update", function(ev) {
          handler(ev.sender.target.read());
        });
      }
    }
    function handleFolder(_a) {
      var bladeRack = _a.bladeRack, eventName = _a.eventName, folder = _a.folder, handler = _a.handler;
      if (eventName === "change") {
        var emitter = bladeRack.emitter;
        emitter.on("inputchange", function(ev) {
          handler(ev.inputBinding.target.read());
        });
      }
      if (eventName === "update") {
        var emitter = bladeRack.emitter;
        emitter.on("monitorupdate", function(ev) {
          handler(ev.monitorBinding.target.read());
        });
      }
      if (eventName === "fold") {
        bladeRack.emitter.on("itemfold", function(ev) {
          handler(ev.expanded);
        });
        folder === null || folder === void 0 ? void 0 : folder.emitter.on("change", function(ev) {
          if (ev.propertyName !== "expanded") {
            return;
          }
          handler(ev.sender.expanded);
        });
      }
    }
    var InputBindingApi = function() {
      function InputBindingApi2(bindingController) {
        this.controller = bindingController;
      }
      Object.defineProperty(InputBindingApi2.prototype, "hidden", {
        get: function() {
          return this.controller.blade.hidden;
        },
        set: function(hidden) {
          this.controller.blade.hidden = hidden;
        },
        enumerable: false,
        configurable: true
      });
      InputBindingApi2.prototype.dispose = function() {
        this.controller.blade.dispose();
      };
      InputBindingApi2.prototype.on = function(eventName, handler) {
        handleInputBinding({
          binding: this.controller.binding,
          eventName,
          handler: handler.bind(this)
        });
        return this;
      };
      InputBindingApi2.prototype.refresh = function() {
        this.controller.binding.read();
      };
      return InputBindingApi2;
    }();
    var CREATE_MESSAGE_MAP = {
      alreadydisposed: function() {
        return "View has been already disposed";
      },
      invalidparams: function(context) {
        return "Invalid parameters for '" + context.name + "'";
      },
      nomatchingcontroller: function(context) {
        return "No matching controller for '" + context.key + "'";
      },
      notbindable: function() {
        return "Value is not bindable";
      },
      propertynotfound: function(context) {
        return "Property '" + context.name + "' not found";
      },
      shouldneverhappen: function() {
        return "This error should never happen";
      }
    };
    var TpError = function() {
      function TpError2(config) {
        var _a;
        this.message = (_a = CREATE_MESSAGE_MAP[config.type](forceCast(config.context))) !== null && _a !== void 0 ? _a : "Unexpected error";
        this.name = this.constructor.name;
        this.stack = new Error(this.message).stack;
        this.type = config.type;
      }
      TpError2.alreadyDisposed = function() {
        return new TpError2({ context: {}, type: "alreadydisposed" });
      };
      TpError2.notBindable = function() {
        return new TpError2({
          context: {},
          type: "notbindable"
        });
      };
      TpError2.propertyNotFound = function(name) {
        return new TpError2({
          type: "propertynotfound",
          context: {
            name
          }
        });
      };
      TpError2.shouldNeverHappen = function() {
        return new TpError2({ context: {}, type: "shouldneverhappen" });
      };
      return TpError2;
    }();
    TpError.prototype = Object.create(Error.prototype);
    TpError.prototype.constructor = TpError;
    var InputBinding = function() {
      function InputBinding2(config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.reader = config.reader;
        this.writer = config.writer;
        this.emitter = new Emitter();
        this.value = config.value;
        this.value.emitter.on("change", this.onValueChange_);
        this.target = config.target;
        this.read();
      }
      InputBinding2.prototype.read = function() {
        var targetValue = this.target.read();
        if (targetValue !== void 0) {
          this.value.rawValue = this.reader(targetValue);
        }
      };
      InputBinding2.prototype.write_ = function(rawValue) {
        this.writer(this.target, rawValue);
      };
      InputBinding2.prototype.onValueChange_ = function(ev) {
        this.write_(ev.rawValue);
        this.emitter.emit("change", {
          rawValue: ev.rawValue,
          sender: this
        });
      };
      return InputBinding2;
    }();
    var Value = function() {
      function Value2(initialValue, config) {
        var _a;
        this.constraint_ = config === null || config === void 0 ? void 0 : config.constraint;
        this.equals_ = (_a = config === null || config === void 0 ? void 0 : config.equals) !== null && _a !== void 0 ? _a : function(v1, v2) {
          return v1 === v2;
        };
        this.emitter = new Emitter();
        this.rawValue_ = initialValue;
      }
      Object.defineProperty(Value2.prototype, "constraint", {
        get: function() {
          return this.constraint_;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Value2.prototype, "rawValue", {
        get: function() {
          return this.rawValue_;
        },
        set: function(rawValue) {
          var constrainedValue = this.constraint_ ? this.constraint_.constrain(rawValue) : rawValue;
          var changed = !this.equals_(this.rawValue_, constrainedValue);
          if (changed) {
            this.rawValue_ = constrainedValue;
            this.emitter.emit("change", {
              rawValue: constrainedValue,
              sender: this
            });
          }
        },
        enumerable: false,
        configurable: true
      });
      return Value2;
    }();
    function createController(plugin, args) {
      var initialValue = plugin.binding.accept(args.target.read(), args.params);
      if (initialValue === null) {
        return null;
      }
      var valueArgs = {
        target: args.target,
        initialValue,
        params: args.params
      };
      var reader = plugin.binding.reader(valueArgs);
      var constraint = plugin.binding.constraint ? plugin.binding.constraint(valueArgs) : void 0;
      var value = new Value(reader(initialValue), {
        constraint,
        equals: plugin.binding.equals
      });
      var binding = new InputBinding({
        reader,
        target: args.target,
        value,
        writer: plugin.binding.writer(valueArgs)
      });
      var controller = plugin.controller({
        binding,
        document: args.document,
        initialValue,
        params: args.params
      });
      return new InputBindingController(args.document, {
        binding,
        controller,
        label: args.params.label || args.target.key,
        blade: new Blade()
      });
    }
    function createInputBindingController(document2, target, params) {
      var initialValue = target.read();
      if (isEmpty(initialValue)) {
        throw new TpError({
          context: {
            key: target.key
          },
          type: "nomatchingcontroller"
        });
      }
      var bc = Plugins.inputs.reduce(function(result, plugin) {
        return result || createController(plugin, {
          document: document2,
          target,
          params
        });
      }, null);
      if (bc) {
        return bc;
      }
      throw new TpError({
        context: {
          key: target.key
        },
        type: "nomatchingcontroller"
      });
    }
    var MonitorBindingApi = function() {
      function MonitorBindingApi2(bindingController) {
        this.controller = bindingController;
      }
      Object.defineProperty(MonitorBindingApi2.prototype, "hidden", {
        get: function() {
          return this.controller.blade.hidden;
        },
        set: function(hidden) {
          this.controller.blade.hidden = hidden;
        },
        enumerable: false,
        configurable: true
      });
      MonitorBindingApi2.prototype.dispose = function() {
        this.controller.blade.dispose();
      };
      MonitorBindingApi2.prototype.on = function(eventName, handler) {
        handleMonitorBinding({
          binding: this.controller.binding,
          eventName,
          handler: forceCast(handler.bind(this))
        });
        return this;
      };
      MonitorBindingApi2.prototype.refresh = function() {
        this.controller.binding.read();
      };
      return MonitorBindingApi2;
    }();
    var Constants = {
      monitor: {
        defaultInterval: 200,
        defaultLineCount: 3
      }
    };
    function fillBuffer(buffer, bufferSize) {
      while (buffer.length < bufferSize) {
        buffer.push(void 0);
      }
    }
    function initializeBuffer(initialValue, bufferSize) {
      var buffer = [initialValue];
      fillBuffer(buffer, bufferSize);
      return new Value(buffer);
    }
    function createTrimmedBuffer(buffer) {
      var index = buffer.indexOf(void 0);
      return forceCast(index < 0 ? buffer : buffer.slice(0, index));
    }
    function createPushedBuffer(buffer, newValue) {
      var newBuffer = __spreadArrays(createTrimmedBuffer(buffer), [newValue]);
      if (newBuffer.length > buffer.length) {
        newBuffer.splice(0, newBuffer.length - buffer.length);
      } else {
        fillBuffer(newBuffer, buffer.length);
      }
      return newBuffer;
    }
    var MonitorBinding = function() {
      function MonitorBinding2(config) {
        this.onTick_ = this.onTick_.bind(this);
        this.reader_ = config.reader;
        this.target = config.target;
        this.emitter = new Emitter();
        this.value = config.value;
        this.ticker = config.ticker;
        this.ticker.emitter.on("tick", this.onTick_);
        this.read();
      }
      MonitorBinding2.prototype.dispose = function() {
        this.ticker.disposable.dispose();
      };
      MonitorBinding2.prototype.read = function() {
        var targetValue = this.target.read();
        if (targetValue === void 0) {
          return;
        }
        var buffer = this.value.rawValue;
        var newValue = this.reader_(targetValue);
        this.value.rawValue = createPushedBuffer(buffer, newValue);
        this.emitter.emit("update", {
          rawValue: newValue,
          sender: this
        });
      };
      MonitorBinding2.prototype.onTick_ = function(_) {
        this.read();
      };
      return MonitorBinding2;
    }();
    var IntervalTicker = function() {
      function IntervalTicker2(doc, interval) {
        var _this = this;
        this.id_ = null;
        this.onTick_ = this.onTick_.bind(this);
        this.doc_ = doc;
        this.emitter = new Emitter();
        if (interval <= 0) {
          this.id_ = null;
        } else {
          var win = this.doc_.defaultView;
          if (win) {
            this.id_ = win.setInterval(this.onTick_, interval);
          }
        }
        this.disposable = new Disposable();
        this.disposable.emitter.on("dispose", function() {
          if (_this.id_ !== null) {
            var win2 = _this.doc_.defaultView;
            if (win2) {
              win2.clearInterval(_this.id_);
            }
          }
          _this.id_ = null;
        });
      }
      IntervalTicker2.prototype.onTick_ = function() {
        this.emitter.emit("tick", {
          sender: this
        });
      };
      return IntervalTicker2;
    }();
    var ManualTicker = function() {
      function ManualTicker2() {
        this.disposable = new Disposable();
        this.emitter = new Emitter();
      }
      ManualTicker2.prototype.tick = function() {
        this.emitter.emit("tick", {
          sender: this
        });
      };
      return ManualTicker2;
    }();
    function createTicker(document2, interval) {
      return interval === 0 ? new ManualTicker() : new IntervalTicker(document2, interval !== null && interval !== void 0 ? interval : Constants.monitor.defaultInterval);
    }
    function createController$1(plugin, args) {
      var _a, _b, _c;
      var initialValue = plugin.binding.accept(args.target.read(), args.params);
      if (initialValue === null) {
        return null;
      }
      var valueArgs = {
        target: args.target,
        initialValue,
        params: args.params
      };
      var reader = plugin.binding.reader(valueArgs);
      var bufferSize = (_c = (_b = (_a = args.params.bufferSize) !== null && _a !== void 0 ? _a : args.params.count) !== null && _b !== void 0 ? _b : plugin.binding.defaultBufferSize && plugin.binding.defaultBufferSize(args.params)) !== null && _c !== void 0 ? _c : 1;
      var binding = new MonitorBinding({
        reader,
        target: args.target,
        ticker: createTicker(args.document, args.params.interval),
        value: initializeBuffer(reader(initialValue), bufferSize)
      });
      return new MonitorBindingController(args.document, {
        binding,
        controller: plugin.controller({
          binding,
          document: args.document,
          params: args.params
        }),
        label: args.params.label || args.target.key,
        blade: new Blade()
      });
    }
    function createMonitorBindingController(document2, target, params) {
      var bc = Plugins.monitors.reduce(function(result, plugin) {
        return result || createController$1(plugin, {
          document: document2,
          params,
          target
        });
      }, null);
      if (bc) {
        return bc;
      }
      throw new TpError({
        context: {
          key: target.key
        },
        type: "nomatchingcontroller"
      });
    }
    var SeparatorApi = function() {
      function SeparatorApi2(controller) {
        this.controller = controller;
      }
      Object.defineProperty(SeparatorApi2.prototype, "hidden", {
        get: function() {
          return this.controller.blade.hidden;
        },
        set: function(hidden) {
          this.controller.blade.hidden = hidden;
        },
        enumerable: false,
        configurable: true
      });
      SeparatorApi2.prototype.dispose = function() {
        this.controller.blade.dispose();
      };
      return SeparatorApi2;
    }();
    var BindingTarget = function() {
      function BindingTarget2(obj, key, opt_id) {
        this.obj_ = obj;
        this.key_ = key;
        this.presetKey_ = opt_id !== null && opt_id !== void 0 ? opt_id : key;
      }
      BindingTarget2.isBindable = function(obj) {
        if (obj === null) {
          return false;
        }
        if (typeof obj !== "object") {
          return false;
        }
        return true;
      };
      Object.defineProperty(BindingTarget2.prototype, "key", {
        get: function() {
          return this.key_;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BindingTarget2.prototype, "presetKey", {
        get: function() {
          return this.presetKey_;
        },
        enumerable: false,
        configurable: true
      });
      BindingTarget2.prototype.read = function() {
        return this.obj_[this.key_];
      };
      BindingTarget2.prototype.write = function(value) {
        this.obj_[this.key_] = value;
      };
      BindingTarget2.prototype.writeProperty = function(name, value) {
        var valueObj = this.read();
        if (!BindingTarget2.isBindable(valueObj)) {
          throw TpError.notBindable();
        }
        if (!(name in valueObj)) {
          throw TpError.propertyNotFound(name);
        }
        valueObj[name] = value;
      };
      return BindingTarget2;
    }();
    function createBindingTarget(obj, key, opt_id) {
      if (!BindingTarget.isBindable(obj)) {
        throw TpError.notBindable();
      }
      return new BindingTarget(obj, key, opt_id);
    }
    var FolderApi = function() {
      function FolderApi2(folderController) {
        this.controller = folderController;
      }
      Object.defineProperty(FolderApi2.prototype, "expanded", {
        get: function() {
          return this.controller.folder.expanded;
        },
        set: function(expanded) {
          this.controller.folder.expanded = expanded;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(FolderApi2.prototype, "hidden", {
        get: function() {
          return this.controller.blade.hidden;
        },
        set: function(hidden) {
          this.controller.blade.hidden = hidden;
        },
        enumerable: false,
        configurable: true
      });
      FolderApi2.prototype.dispose = function() {
        this.controller.blade.dispose();
      };
      FolderApi2.prototype.addInput = function(object, key, opt_params) {
        var params = opt_params || {};
        var bc = createInputBindingController(this.controller.document, createBindingTarget(object, key, params.presetKey), params);
        this.controller.bladeRack.add(bc, params.index);
        return new InputBindingApi(forceCast(bc));
      };
      FolderApi2.prototype.addMonitor = function(object, key, opt_params) {
        var params = opt_params || {};
        var bc = createMonitorBindingController(this.controller.document, createBindingTarget(object, key), params);
        this.controller.bladeRack.add(bc, params.index);
        return new MonitorBindingApi(forceCast(bc));
      };
      FolderApi2.prototype.addFolder = function(params) {
        var bc = new FolderController(this.controller.document, __assign(__assign({}, params), { blade: new Blade() }));
        this.controller.bladeRack.add(bc, params.index);
        return new FolderApi2(bc);
      };
      FolderApi2.prototype.addButton = function(params) {
        var bc = new ButtonController(this.controller.document, __assign(__assign({}, params), { blade: new Blade() }));
        this.controller.bladeRack.add(bc, params.index);
        return new ButtonApi(bc);
      };
      FolderApi2.prototype.addSeparator = function(opt_params) {
        var params = opt_params || {};
        var bc = new SeparatorController(this.controller.document, {
          blade: new Blade()
        });
        this.controller.bladeRack.add(bc, params.index);
        return new SeparatorApi(bc);
      };
      FolderApi2.prototype.on = function(eventName, handler) {
        handleFolder({
          eventName,
          folder: this.controller.folder,
          handler: forceCast(handler.bind(this)),
          bladeRack: this.controller.bladeRack
        });
        return this;
      };
      return FolderApi2;
    }();
    function exportPresetJson(targets) {
      return targets.reduce(function(result, target) {
        var _a;
        return Object.assign(result, (_a = {}, _a[target.presetKey] = target.read(), _a));
      }, {});
    }
    function importPresetJson(targets, preset) {
      targets.forEach(function(target) {
        var value = preset[target.presetKey];
        if (value !== void 0) {
          target.write(value);
        }
      });
    }
    var RootApi = function() {
      function RootApi2(rootController) {
        this.controller = rootController;
      }
      RootApi2.registerPlugin = function(r) {
        if (r.type === "input") {
          Plugins.inputs.unshift(r.plugin);
        } else if (r.type === "monitor") {
          Plugins.monitors.unshift(r.plugin);
        }
      };
      Object.defineProperty(RootApi2.prototype, "element", {
        get: function() {
          return this.controller.view.element;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(RootApi2.prototype, "expanded", {
        get: function() {
          var folder = this.controller.folder;
          return folder ? folder.expanded : true;
        },
        set: function(expanded) {
          var folder = this.controller.folder;
          if (folder) {
            folder.expanded = expanded;
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(RootApi2.prototype, "hidden", {
        get: function() {
          return this.controller.blade.hidden;
        },
        set: function(hidden) {
          this.controller.blade.hidden = hidden;
        },
        enumerable: false,
        configurable: true
      });
      RootApi2.prototype.dispose = function() {
        this.controller.blade.dispose();
      };
      RootApi2.prototype.addInput = function(object, key, opt_params) {
        var params = opt_params || {};
        var bc = createInputBindingController(this.controller.document, createBindingTarget(object, key, params.presetKey), params);
        this.controller.bladeRack.add(bc, params.index);
        return new InputBindingApi(forceCast(bc));
      };
      RootApi2.prototype.addMonitor = function(object, key, opt_params) {
        var params = opt_params || {};
        var bc = createMonitorBindingController(this.controller.document, createBindingTarget(object, key), params);
        this.controller.bladeRack.add(bc, params.index);
        return new MonitorBindingApi(forceCast(bc));
      };
      RootApi2.prototype.addButton = function(params) {
        var bc = new ButtonController(this.controller.document, __assign(__assign({}, params), { blade: new Blade() }));
        this.controller.bladeRack.add(bc, params.index);
        return new ButtonApi(bc);
      };
      RootApi2.prototype.addFolder = function(params) {
        var bc = new FolderController(this.controller.document, __assign(__assign({}, params), { blade: new Blade() }));
        this.controller.bladeRack.add(bc, params.index);
        return new FolderApi(bc);
      };
      RootApi2.prototype.addSeparator = function(opt_params) {
        var params = opt_params || {};
        var bc = new SeparatorController(this.controller.document, {
          blade: new Blade()
        });
        this.controller.bladeRack.add(bc, params.index);
        return new SeparatorApi(bc);
      };
      RootApi2.prototype.importPreset = function(preset) {
        var targets = this.controller.bladeRack.find(InputBindingController).map(function(ibc) {
          return ibc.binding.target;
        });
        importPresetJson(targets, preset);
        this.refresh();
      };
      RootApi2.prototype.exportPreset = function() {
        var targets = this.controller.bladeRack.find(InputBindingController).map(function(ibc) {
          return ibc.binding.target;
        });
        return exportPresetJson(targets);
      };
      RootApi2.prototype.on = function(eventName, handler) {
        handleFolder({
          eventName,
          folder: this.controller.folder,
          handler: forceCast(handler.bind(this)),
          bladeRack: this.controller.bladeRack
        });
        return this;
      };
      RootApi2.prototype.refresh = function() {
        this.controller.bladeRack.find(InputBindingController).forEach(function(ibc) {
          ibc.binding.read();
        });
        this.controller.bladeRack.find(MonitorBindingController).forEach(function(mbc) {
          mbc.binding.read();
        });
      };
      return RootApi2;
    }();
    var className$5 = ClassName("rot");
    var RootView = function() {
      function RootView2(doc, config) {
        this.titleElem_ = null;
        this.onFolderChange_ = this.onFolderChange_.bind(this);
        this.folder_ = config.folder;
        if (this.folder_) {
          this.folder_.emitter.on("change", this.onFolderChange_);
        }
        this.element = doc.createElement("div");
        this.element.classList.add(className$5());
        var folder = this.folder_;
        if (folder) {
          var titleElem = doc.createElement("button");
          titleElem.classList.add(className$5("t"));
          titleElem.textContent = folder.title;
          this.element.appendChild(titleElem);
          var markElem = doc.createElement("div");
          markElem.classList.add(className$5("m"));
          titleElem.appendChild(markElem);
          this.titleElem_ = titleElem;
        }
        var containerElem = doc.createElement("div");
        containerElem.classList.add(className$5("c"));
        this.element.appendChild(containerElem);
        this.containerElement = containerElem;
        this.applyModel_();
      }
      Object.defineProperty(RootView2.prototype, "titleElement", {
        get: function() {
          return this.titleElem_;
        },
        enumerable: false,
        configurable: true
      });
      RootView2.prototype.applyModel_ = function() {
        var expanded = this.folder_ ? this.folder_.styleExpanded : true;
        var expandedClass = className$5(void 0, "expanded");
        if (expanded) {
          this.element.classList.add(expandedClass);
        } else {
          this.element.classList.remove(expandedClass);
        }
        this.containerElement.style.height = this.folder_ ? this.folder_.styleHeight : "auto";
      };
      RootView2.prototype.onFolderChange_ = function() {
        this.applyModel_();
      };
      return RootView2;
    }();
    function createFolder(config) {
      var _a;
      if (!config.title) {
        return null;
      }
      return new Folder(config.title, (_a = config.expanded) !== null && _a !== void 0 ? _a : true);
    }
    var RootController = function() {
      function RootController2(doc, config) {
        this.onContainerTransitionEnd_ = this.onContainerTransitionEnd_.bind(this);
        this.onFolderBeforeChange_ = this.onFolderBeforeChange_.bind(this);
        this.onTitleClick_ = this.onTitleClick_.bind(this);
        this.onRackAdd_ = this.onRackAdd_.bind(this);
        this.onRackItemLayout_ = this.onRackItemLayout_.bind(this);
        this.onRackRemove_ = this.onRackRemove_.bind(this);
        this.folder = createFolder(config);
        if (this.folder) {
          this.folder.emitter.on("beforechange", this.onFolderBeforeChange_);
        }
        this.bladeRack = new BladeRack();
        this.bladeRack.emitter.on("add", this.onRackAdd_);
        this.bladeRack.emitter.on("itemlayout", this.onRackItemLayout_);
        this.bladeRack.emitter.on("remove", this.onRackRemove_);
        this.doc_ = doc;
        this.blade = config.blade;
        this.view = new RootView(this.doc_, {
          folder: this.folder
        });
        if (this.view.titleElement) {
          this.view.titleElement.addEventListener("click", this.onTitleClick_);
        }
        this.view.containerElement.addEventListener("transitionend", this.onContainerTransitionEnd_);
        setUpBladeView(this.view, this.blade);
      }
      Object.defineProperty(RootController2.prototype, "document", {
        get: function() {
          return this.doc_;
        },
        enumerable: false,
        configurable: true
      });
      RootController2.prototype.onFolderBeforeChange_ = function(ev) {
        if (ev.propertyName !== "expanded") {
          return;
        }
        var folder = this.folder;
        if (!folder) {
          return;
        }
        if (isEmpty(folder.expandedHeight)) {
          folder.expandedHeight = computeExpandedFolderHeight(folder, this.view.containerElement);
        }
        folder.shouldFixHeight = true;
        forceReflow(this.view.containerElement);
      };
      RootController2.prototype.applyRackChange_ = function() {
        updateAllItemsPositions(this.bladeRack);
      };
      RootController2.prototype.onRackAdd_ = function(ev) {
        insertElementAt(this.view.containerElement, ev.blade.view.element, ev.index);
        this.applyRackChange_();
      };
      RootController2.prototype.onRackRemove_ = function(_) {
        this.applyRackChange_();
      };
      RootController2.prototype.onRackItemLayout_ = function(_) {
        this.applyRackChange_();
      };
      RootController2.prototype.onTitleClick_ = function() {
        if (this.folder) {
          this.folder.expanded = !this.folder.expanded;
        }
      };
      RootController2.prototype.onContainerTransitionEnd_ = function(ev) {
        if (ev.propertyName !== "height") {
          return;
        }
        if (this.folder) {
          this.folder.shouldFixHeight = false;
          this.folder.expandedHeight = null;
        }
      };
      return RootController2;
    }();
    var CompositeConstraint = function() {
      function CompositeConstraint2(config) {
        this.constraints_ = config.constraints;
      }
      Object.defineProperty(CompositeConstraint2.prototype, "constraints", {
        get: function() {
          return this.constraints_;
        },
        enumerable: false,
        configurable: true
      });
      CompositeConstraint2.prototype.constrain = function(value) {
        return this.constraints_.reduce(function(result, c) {
          return c.constrain(result);
        }, value);
      };
      return CompositeConstraint2;
    }();
    function findConstraint(c, constraintClass) {
      if (c instanceof constraintClass) {
        return c;
      }
      if (c instanceof CompositeConstraint) {
        var result = c.constraints.reduce(function(tmpResult, sc) {
          if (tmpResult) {
            return tmpResult;
          }
          return sc instanceof constraintClass ? sc : null;
        }, null);
        if (result) {
          return result;
        }
      }
      return null;
    }
    var ListConstraint = function() {
      function ListConstraint2(config) {
        this.opts_ = config.options;
      }
      Object.defineProperty(ListConstraint2.prototype, "options", {
        get: function() {
          return this.opts_;
        },
        enumerable: false,
        configurable: true
      });
      ListConstraint2.prototype.constrain = function(value) {
        var opts = this.opts_;
        if (opts.length === 0) {
          return value;
        }
        var matched = opts.filter(function(item) {
          return item.value === value;
        }).length > 0;
        return matched ? value : opts[0].value;
      };
      return ListConstraint2;
    }();
    function boolToString(value) {
      return String(value);
    }
    function boolFromUnknown(value) {
      if (value === "false") {
        return false;
      }
      return !!value;
    }
    function BooleanFormatter(value) {
      return boolToString(value);
    }
    function writePrimitive(target, value) {
      target.write(value);
    }
    var StepConstraint = function() {
      function StepConstraint2(config) {
        this.step = config.step;
      }
      StepConstraint2.prototype.constrain = function(value) {
        var r = value < 0 ? -Math.round(-value / this.step) : Math.round(value / this.step);
        return r * this.step;
      };
      return StepConstraint2;
    }();
    function mapRange(value, start1, end1, start2, end2) {
      var p = (value - start1) / (end1 - start1);
      return start2 + p * (end2 - start2);
    }
    function getDecimalDigits(value) {
      var text = String(value.toFixed(10));
      var frac = text.split(".")[1];
      return frac.replace(/0+$/, "").length;
    }
    function constrainRange(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
    function loopRange(value, max) {
      return (value % max + max) % max;
    }
    function normalizeInputParamsOptions(options, convert) {
      if (Array.isArray(options)) {
        return options.map(function(item) {
          return {
            text: item.text,
            value: convert(item.value)
          };
        });
      }
      var textToValueMap = options;
      var texts = Object.keys(textToValueMap);
      return texts.reduce(function(result, text) {
        return result.concat({
          text,
          value: convert(textToValueMap[text])
        });
      }, []);
    }
    function findListItems(constraint) {
      var c = constraint ? findConstraint(constraint, ListConstraint) : null;
      if (!c) {
        return null;
      }
      return c.options;
    }
    function findStep(constraint) {
      var c = constraint ? findConstraint(constraint, StepConstraint) : null;
      if (!c) {
        return null;
      }
      return c.step;
    }
    function getSuitableDecimalDigits(constraint, rawValue) {
      var sc = constraint && findConstraint(constraint, StepConstraint);
      if (sc) {
        return getDecimalDigits(sc.step);
      }
      return Math.max(getDecimalDigits(rawValue), 2);
    }
    function getBaseStep(constraint) {
      var step = findStep(constraint);
      return step !== null && step !== void 0 ? step : 1;
    }
    var className$6 = ClassName("lst");
    var ListView = function() {
      function ListView2(doc, config) {
        var _this = this;
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.element = doc.createElement("div");
        this.element.classList.add(className$6());
        this.stringifyValue_ = config.stringifyValue;
        var selectElem = doc.createElement("select");
        selectElem.classList.add(className$6("s"));
        config.options.forEach(function(item, index) {
          var optionElem = doc.createElement("option");
          optionElem.dataset.index = String(index);
          optionElem.textContent = item.text;
          optionElem.value = _this.stringifyValue_(item.value);
          selectElem.appendChild(optionElem);
        });
        this.element.appendChild(selectElem);
        this.selectElement = selectElem;
        var markElem = doc.createElement("div");
        markElem.classList.add(className$6("m"));
        this.element.appendChild(markElem);
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      ListView2.prototype.update = function() {
        this.selectElement.value = this.stringifyValue_(this.value.rawValue);
      };
      ListView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return ListView2;
    }();
    var ListController = function() {
      function ListController2(doc, config) {
        this.onSelectChange_ = this.onSelectChange_.bind(this);
        this.value = config.value;
        this.listItems_ = config.listItems;
        this.view = new ListView(doc, {
          options: this.listItems_,
          stringifyValue: config.stringifyValue,
          value: this.value
        });
        this.view.selectElement.addEventListener("change", this.onSelectChange_);
      }
      ListController2.prototype.onSelectChange_ = function(e) {
        var selectElem = forceCast(e.currentTarget);
        var optElem = selectElem.selectedOptions.item(0);
        if (!optElem) {
          return;
        }
        var itemIndex = Number(optElem.dataset.index);
        this.value.rawValue = this.listItems_[itemIndex].value;
        this.view.update();
      };
      return ListController2;
    }();
    var className$7 = ClassName("ckb");
    var CheckboxView = function() {
      function CheckboxView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.element = doc.createElement("div");
        this.element.classList.add(className$7());
        var labelElem = doc.createElement("label");
        labelElem.classList.add(className$7("l"));
        this.element.appendChild(labelElem);
        var inputElem = doc.createElement("input");
        inputElem.classList.add(className$7("i"));
        inputElem.type = "checkbox";
        labelElem.appendChild(inputElem);
        this.inputElement = inputElem;
        var markElem = doc.createElement("div");
        markElem.classList.add(className$7("m"));
        labelElem.appendChild(markElem);
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      CheckboxView2.prototype.update = function() {
        this.inputElement.checked = this.value.rawValue;
      };
      CheckboxView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return CheckboxView2;
    }();
    var CheckboxController = function() {
      function CheckboxController2(doc, config) {
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.value = config.value;
        this.view = new CheckboxView(doc, {
          value: this.value
        });
        this.view.inputElement.addEventListener("change", this.onInputChange_);
      }
      CheckboxController2.prototype.onInputChange_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        this.value.rawValue = inputElem.checked;
        this.view.update();
      };
      return CheckboxController2;
    }();
    function createConstraint(params) {
      var constraints = [];
      if ("options" in params && params.options !== void 0) {
        constraints.push(new ListConstraint({
          options: normalizeInputParamsOptions(params.options, boolFromUnknown)
        }));
      }
      return new CompositeConstraint({
        constraints
      });
    }
    function createController$2(doc, value) {
      var _a;
      var c = value.constraint;
      if (c && findConstraint(c, ListConstraint)) {
        return new ListController(doc, {
          listItems: (_a = findListItems(c)) !== null && _a !== void 0 ? _a : [],
          stringifyValue: boolToString,
          value
        });
      }
      return new CheckboxController(doc, {
        value
      });
    }
    var BooleanInputPlugin = {
      id: "input-bool",
      binding: {
        accept: function(value) {
          return typeof value === "boolean" ? value : null;
        },
        constraint: function(args) {
          return createConstraint(args.params);
        },
        reader: function(_args) {
          return boolFromUnknown;
        },
        writer: function(_args) {
          return writePrimitive;
        }
      },
      controller: function(args) {
        return createController$2(args.document, args.binding.value);
      }
    };
    var className$8 = ClassName("txt");
    var TextView = function() {
      function TextView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.formatter_ = config.formatter;
        this.element = doc.createElement("div");
        this.element.classList.add(className$8());
        var inputElem = doc.createElement("input");
        inputElem.classList.add(className$8("i"));
        inputElem.type = "text";
        this.element.appendChild(inputElem);
        this.inputElement = inputElem;
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      TextView2.prototype.update = function() {
        this.inputElement.value = this.formatter_(this.value.rawValue);
      };
      TextView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return TextView2;
    }();
    var TextController = function() {
      function TextController2(doc, config) {
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.parser_ = config.parser;
        this.value = config.value;
        this.view = new TextView(doc, {
          formatter: config.formatter,
          value: this.value
        });
        this.view.inputElement.addEventListener("change", this.onInputChange_);
      }
      TextController2.prototype.onInputChange_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        var value = inputElem.value;
        var parsedValue = this.parser_(value);
        if (!isEmpty(parsedValue)) {
          this.value.rawValue = parsedValue;
        }
        this.view.update();
      };
      return TextController2;
    }();
    var className$9 = ClassName("cswtxt");
    var ColorSwatchTextView = function() {
      function ColorSwatchTextView2(doc, config) {
        this.element = doc.createElement("div");
        this.element.classList.add(className$9());
        var swatchElem = doc.createElement("div");
        swatchElem.classList.add(className$9("s"));
        this.swatchView_ = config.swatchView;
        swatchElem.appendChild(this.swatchView_.element);
        this.element.appendChild(swatchElem);
        var textElem = doc.createElement("div");
        textElem.classList.add(className$9("t"));
        this.textView = config.textView;
        textElem.appendChild(this.textView.element);
        this.element.appendChild(textElem);
      }
      Object.defineProperty(ColorSwatchTextView2.prototype, "value", {
        get: function() {
          return this.textView.value;
        },
        enumerable: false,
        configurable: true
      });
      ColorSwatchTextView2.prototype.update = function() {
        this.swatchView_.update();
        this.textView.update();
      };
      return ColorSwatchTextView2;
    }();
    var PickedColor = function() {
      function PickedColor2(value) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.mode_ = value.rawValue.mode;
        this.value = value;
        this.value.emitter.on("change", this.onValueChange_);
        this.emitter = new Emitter();
      }
      Object.defineProperty(PickedColor2.prototype, "mode", {
        get: function() {
          return this.mode_;
        },
        set: function(mode) {
          if (this.mode_ === mode) {
            return;
          }
          this.mode_ = mode;
          this.emitter.emit("change", {
            propertyName: "mode",
            sender: this
          });
        },
        enumerable: false,
        configurable: true
      });
      PickedColor2.prototype.onValueChange_ = function() {
        this.emitter.emit("change", {
          propertyName: "value",
          sender: this
        });
      };
      return PickedColor2;
    }();
    function parseNumber(text) {
      var num = parseFloat(text);
      if (isNaN(num)) {
        return null;
      }
      return num;
    }
    function numberFromUnknown(value) {
      if (typeof value === "number") {
        return value;
      }
      if (typeof value === "string") {
        var pv = parseNumber(value);
        if (!isEmpty(pv)) {
          return pv;
        }
      }
      return 0;
    }
    function numberToString(value) {
      return String(value);
    }
    function createNumberFormatter(digits) {
      return function(value) {
        return value.toFixed(Math.max(Math.min(digits, 20), 0));
      };
    }
    var innerFormatter = createNumberFormatter(0);
    function formatPercentage(value) {
      return innerFormatter(value) + "%";
    }
    function rgbToHsl(r, g, b) {
      var rp = constrainRange(r / 255, 0, 1);
      var gp = constrainRange(g / 255, 0, 1);
      var bp = constrainRange(b / 255, 0, 1);
      var cmax = Math.max(rp, gp, bp);
      var cmin = Math.min(rp, gp, bp);
      var c = cmax - cmin;
      var h = 0;
      var s = 0;
      var l = (cmin + cmax) / 2;
      if (c !== 0) {
        s = l > 0.5 ? c / (2 - cmin - cmax) : c / (cmax + cmin);
        if (rp === cmax) {
          h = (gp - bp) / c;
        } else if (gp === cmax) {
          h = 2 + (bp - rp) / c;
        } else {
          h = 4 + (rp - gp) / c;
        }
        h = h / 6 + (h < 0 ? 1 : 0);
      }
      return [h * 360, s * 100, l * 100];
    }
    function hslToRgb(h, s, l) {
      var _a, _b, _c, _d, _e, _f;
      var hp = (h % 360 + 360) % 360;
      var sp = constrainRange(s / 100, 0, 1);
      var lp = constrainRange(l / 100, 0, 1);
      var c = (1 - Math.abs(2 * lp - 1)) * sp;
      var x = c * (1 - Math.abs(hp / 60 % 2 - 1));
      var m = lp - c / 2;
      var rp, gp, bp;
      if (hp >= 0 && hp < 60) {
        _a = [c, x, 0], rp = _a[0], gp = _a[1], bp = _a[2];
      } else if (hp >= 60 && hp < 120) {
        _b = [x, c, 0], rp = _b[0], gp = _b[1], bp = _b[2];
      } else if (hp >= 120 && hp < 180) {
        _c = [0, c, x], rp = _c[0], gp = _c[1], bp = _c[2];
      } else if (hp >= 180 && hp < 240) {
        _d = [0, x, c], rp = _d[0], gp = _d[1], bp = _d[2];
      } else if (hp >= 240 && hp < 300) {
        _e = [x, 0, c], rp = _e[0], gp = _e[1], bp = _e[2];
      } else {
        _f = [c, 0, x], rp = _f[0], gp = _f[1], bp = _f[2];
      }
      return [(rp + m) * 255, (gp + m) * 255, (bp + m) * 255];
    }
    function rgbToHsv(r, g, b) {
      var rp = constrainRange(r / 255, 0, 1);
      var gp = constrainRange(g / 255, 0, 1);
      var bp = constrainRange(b / 255, 0, 1);
      var cmax = Math.max(rp, gp, bp);
      var cmin = Math.min(rp, gp, bp);
      var d = cmax - cmin;
      var h;
      if (d === 0) {
        h = 0;
      } else if (cmax === rp) {
        h = 60 * (((gp - bp) / d % 6 + 6) % 6);
      } else if (cmax === gp) {
        h = 60 * ((bp - rp) / d + 2);
      } else {
        h = 60 * ((rp - gp) / d + 4);
      }
      var s = cmax === 0 ? 0 : d / cmax;
      var v = cmax;
      return [h, s * 100, v * 100];
    }
    function hsvToRgb(h, s, v) {
      var _a, _b, _c, _d, _e, _f;
      var hp = loopRange(h, 360);
      var sp = constrainRange(s / 100, 0, 1);
      var vp = constrainRange(v / 100, 0, 1);
      var c = vp * sp;
      var x = c * (1 - Math.abs(hp / 60 % 2 - 1));
      var m = vp - c;
      var rp, gp, bp;
      if (hp >= 0 && hp < 60) {
        _a = [c, x, 0], rp = _a[0], gp = _a[1], bp = _a[2];
      } else if (hp >= 60 && hp < 120) {
        _b = [x, c, 0], rp = _b[0], gp = _b[1], bp = _b[2];
      } else if (hp >= 120 && hp < 180) {
        _c = [0, c, x], rp = _c[0], gp = _c[1], bp = _c[2];
      } else if (hp >= 180 && hp < 240) {
        _d = [0, x, c], rp = _d[0], gp = _d[1], bp = _d[2];
      } else if (hp >= 240 && hp < 300) {
        _e = [x, 0, c], rp = _e[0], gp = _e[1], bp = _e[2];
      } else {
        _f = [c, 0, x], rp = _f[0], gp = _f[1], bp = _f[2];
      }
      return [(rp + m) * 255, (gp + m) * 255, (bp + m) * 255];
    }
    function removeAlphaComponent(comps) {
      return [comps[0], comps[1], comps[2]];
    }
    function appendAlphaComponent(comps, alpha) {
      return [comps[0], comps[1], comps[2], alpha];
    }
    var MODE_CONVERTER_MAP = {
      hsl: {
        hsl: function(h, s, l) {
          return [h, s, l];
        },
        hsv: function(h, s, l) {
          var _a = hslToRgb(h, s, l), r = _a[0], g = _a[1], b = _a[2];
          return rgbToHsv(r, g, b);
        },
        rgb: hslToRgb
      },
      hsv: {
        hsl: function(h, s, v) {
          var _a = hsvToRgb(h, s, v), r = _a[0], g = _a[1], b = _a[2];
          return rgbToHsl(r, g, b);
        },
        hsv: function(h, s, v) {
          return [h, s, v];
        },
        rgb: hsvToRgb
      },
      rgb: {
        hsl: rgbToHsl,
        hsv: rgbToHsv,
        rgb: function(r, g, b) {
          return [r, g, b];
        }
      }
    };
    function convertColorMode(components, fromMode, toMode) {
      var _a;
      return (_a = MODE_CONVERTER_MAP[fromMode])[toMode].apply(_a, components);
    }
    var CONSTRAINT_MAP = {
      hsl: function(comps) {
        var _a;
        return [
          loopRange(comps[0], 360),
          constrainRange(comps[1], 0, 100),
          constrainRange(comps[2], 0, 100),
          constrainRange((_a = comps[3]) !== null && _a !== void 0 ? _a : 1, 0, 1)
        ];
      },
      hsv: function(comps) {
        var _a;
        return [
          loopRange(comps[0], 360),
          constrainRange(comps[1], 0, 100),
          constrainRange(comps[2], 0, 100),
          constrainRange((_a = comps[3]) !== null && _a !== void 0 ? _a : 1, 0, 1)
        ];
      },
      rgb: function(comps) {
        var _a;
        return [
          constrainRange(comps[0], 0, 255),
          constrainRange(comps[1], 0, 255),
          constrainRange(comps[2], 0, 255),
          constrainRange((_a = comps[3]) !== null && _a !== void 0 ? _a : 1, 0, 1)
        ];
      }
    };
    function isRgbColorComponent(obj, key) {
      if (typeof obj !== "object" || isEmpty(obj)) {
        return false;
      }
      return key in obj && typeof obj[key] === "number";
    }
    var Color2 = function() {
      function Color3(comps, mode) {
        this.mode_ = mode;
        this.comps_ = CONSTRAINT_MAP[mode](comps);
      }
      Color3.black = function() {
        return new Color3([0, 0, 0], "rgb");
      };
      Color3.fromObject = function(obj) {
        var comps = "a" in obj ? [obj.r, obj.g, obj.b, obj.a] : [obj.r, obj.g, obj.b];
        return new Color3(comps, "rgb");
      };
      Color3.toRgbaObject = function(color) {
        return color.toRgbaObject();
      };
      Color3.isRgbColorObject = function(obj) {
        return isRgbColorComponent(obj, "r") && isRgbColorComponent(obj, "g") && isRgbColorComponent(obj, "b");
      };
      Color3.isRgbaColorObject = function(obj) {
        return this.isRgbColorObject(obj) && isRgbColorComponent(obj, "a");
      };
      Color3.isColorObject = function(obj) {
        return this.isRgbColorObject(obj);
      };
      Color3.equals = function(v1, v2) {
        if (v1.mode_ !== v2.mode_) {
          return false;
        }
        var comps1 = v1.comps_;
        var comps2 = v2.comps_;
        for (var i = 0; i < comps1.length; i++) {
          if (comps1[i] !== comps2[i]) {
            return false;
          }
        }
        return true;
      };
      Object.defineProperty(Color3.prototype, "mode", {
        get: function() {
          return this.mode_;
        },
        enumerable: false,
        configurable: true
      });
      Color3.prototype.getComponents = function(opt_mode) {
        return appendAlphaComponent(convertColorMode(removeAlphaComponent(this.comps_), this.mode_, opt_mode || this.mode_), this.comps_[3]);
      };
      Color3.prototype.toRgbaObject = function() {
        var rgbComps = this.getComponents("rgb");
        return {
          r: rgbComps[0],
          g: rgbComps[1],
          b: rgbComps[2],
          a: rgbComps[3]
        };
      };
      return Color3;
    }();
    function parseCssNumberOrPercentage(text, maxValue) {
      var m = text.match(/^(.+)%$/);
      if (!m) {
        return Math.min(parseFloat(text), maxValue);
      }
      return Math.min(parseFloat(m[1]) * 0.01 * maxValue, maxValue);
    }
    var ANGLE_TO_DEG_MAP = {
      deg: function(angle) {
        return angle;
      },
      grad: function(angle) {
        return angle * 360 / 400;
      },
      rad: function(angle) {
        return angle * 360 / (2 * Math.PI);
      },
      turn: function(angle) {
        return angle * 360;
      }
    };
    function parseCssNumberOrAngle(text) {
      var m = text.match(/^([0-9.]+?)(deg|grad|rad|turn)$/);
      if (!m) {
        return parseFloat(text);
      }
      var angle = parseFloat(m[1]);
      var unit = m[2];
      return ANGLE_TO_DEG_MAP[unit](angle);
    }
    var NOTATION_TO_PARSER_MAP = {
      "func.rgb": function(text) {
        var m = text.match(/^rgb\(\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) {
          return null;
        }
        var comps = [
          parseCssNumberOrPercentage(m[1], 255),
          parseCssNumberOrPercentage(m[2], 255),
          parseCssNumberOrPercentage(m[3], 255)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) {
          return null;
        }
        return new Color2(comps, "rgb");
      },
      "func.rgba": function(text) {
        var m = text.match(/^rgba\(\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) {
          return null;
        }
        var comps = [
          parseCssNumberOrPercentage(m[1], 255),
          parseCssNumberOrPercentage(m[2], 255),
          parseCssNumberOrPercentage(m[3], 255),
          parseCssNumberOrPercentage(m[4], 1)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) {
          return null;
        }
        return new Color2(comps, "rgb");
      },
      "func.hsl": function(text) {
        var m = text.match(/^hsl\(\s*([0-9A-Fa-f.]+(?:deg|grad|rad|turn)?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) {
          return null;
        }
        var comps = [
          parseCssNumberOrAngle(m[1]),
          parseCssNumberOrPercentage(m[2], 100),
          parseCssNumberOrPercentage(m[3], 100)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) {
          return null;
        }
        return new Color2(comps, "hsl");
      },
      "func.hsla": function(text) {
        var m = text.match(/^hsla\(\s*([0-9A-Fa-f.]+(?:deg|grad|rad|turn)?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) {
          return null;
        }
        var comps = [
          parseCssNumberOrAngle(m[1]),
          parseCssNumberOrPercentage(m[2], 100),
          parseCssNumberOrPercentage(m[3], 100),
          parseCssNumberOrPercentage(m[4], 1)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) {
          return null;
        }
        return new Color2(comps, "hsl");
      },
      "hex.rgb": function(text) {
        var mRrggbb = text.match(/^#([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])$/);
        if (mRrggbb) {
          return new Color2([
            parseInt(mRrggbb[1] + mRrggbb[1], 16),
            parseInt(mRrggbb[2] + mRrggbb[2], 16),
            parseInt(mRrggbb[3] + mRrggbb[3], 16)
          ], "rgb");
        }
        var mRgb = text.match(/^#([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
        if (mRgb) {
          return new Color2([parseInt(mRgb[1], 16), parseInt(mRgb[2], 16), parseInt(mRgb[3], 16)], "rgb");
        }
        return null;
      },
      "hex.rgba": function(text) {
        var mRrggbb = text.match(/^#?([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])$/);
        if (mRrggbb) {
          return new Color2([
            parseInt(mRrggbb[1] + mRrggbb[1], 16),
            parseInt(mRrggbb[2] + mRrggbb[2], 16),
            parseInt(mRrggbb[3] + mRrggbb[3], 16),
            mapRange(parseInt(mRrggbb[4] + mRrggbb[4], 16), 0, 255, 0, 1)
          ], "rgb");
        }
        var mRgb = text.match(/^#?([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
        if (mRgb) {
          return new Color2([
            parseInt(mRgb[1], 16),
            parseInt(mRgb[2], 16),
            parseInt(mRgb[3], 16),
            mapRange(parseInt(mRgb[4], 16), 0, 255, 0, 1)
          ], "rgb");
        }
        return null;
      }
    };
    function getColorNotation(text) {
      var notations = Object.keys(NOTATION_TO_PARSER_MAP);
      return notations.reduce(function(result, notation) {
        if (result) {
          return result;
        }
        var subparser = NOTATION_TO_PARSER_MAP[notation];
        return subparser(text) ? notation : null;
      }, null);
    }
    var CompositeColorParser = function(text) {
      var notation = getColorNotation(text);
      return notation ? NOTATION_TO_PARSER_MAP[notation](text) : null;
    };
    function hasAlphaComponent(notation) {
      return notation === "func.hsla" || notation === "func.rgba" || notation === "hex.rgba";
    }
    function colorFromString(value) {
      if (typeof value === "string") {
        var cv = CompositeColorParser(value);
        if (cv) {
          return cv;
        }
      }
      return Color2.black();
    }
    function zerofill(comp) {
      var hex = constrainRange(Math.floor(comp), 0, 255).toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    }
    function colorToHexRgbString(value) {
      var hexes = removeAlphaComponent(value.getComponents("rgb")).map(zerofill).join("");
      return "#" + hexes;
    }
    function colorToHexRgbaString(value) {
      var rgbaComps = value.getComponents("rgb");
      var hexes = [rgbaComps[0], rgbaComps[1], rgbaComps[2], rgbaComps[3] * 255].map(zerofill).join("");
      return "#" + hexes;
    }
    function colorToFunctionalRgbString(value) {
      var formatter = createNumberFormatter(0);
      var comps = removeAlphaComponent(value.getComponents("rgb")).map(function(comp) {
        return formatter(comp);
      });
      return "rgb(" + comps.join(", ") + ")";
    }
    function colorToFunctionalRgbaString(value) {
      var aFormatter = createNumberFormatter(2);
      var rgbFormatter = createNumberFormatter(0);
      var comps = value.getComponents("rgb").map(function(comp, index) {
        var formatter = index === 3 ? aFormatter : rgbFormatter;
        return formatter(comp);
      });
      return "rgba(" + comps.join(", ") + ")";
    }
    function colorToFunctionalHslString(value) {
      var formatters = [
        createNumberFormatter(0),
        formatPercentage,
        formatPercentage
      ];
      var comps = removeAlphaComponent(value.getComponents("hsl")).map(function(comp, index) {
        return formatters[index](comp);
      });
      return "hsl(" + comps.join(", ") + ")";
    }
    function colorToFunctionalHslaString(value) {
      var formatters = [
        createNumberFormatter(0),
        formatPercentage,
        formatPercentage,
        createNumberFormatter(2)
      ];
      var comps = value.getComponents("hsl").map(function(comp, index) {
        return formatters[index](comp);
      });
      return "hsla(" + comps.join(", ") + ")";
    }
    var NOTATION_TO_STRINGIFIER_MAP = {
      "func.hsl": colorToFunctionalHslString,
      "func.hsla": colorToFunctionalHslaString,
      "func.rgb": colorToFunctionalRgbString,
      "func.rgba": colorToFunctionalRgbaString,
      "hex.rgb": colorToHexRgbString,
      "hex.rgba": colorToHexRgbaString
    };
    function getColorStringifier(notation) {
      return NOTATION_TO_STRINGIFIER_MAP[notation];
    }
    var className$a = ClassName("csw");
    var ColorSwatchView = function() {
      function ColorSwatchView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.element = doc.createElement("div");
        this.element.classList.add(className$a());
        var swatchElem = doc.createElement("div");
        swatchElem.classList.add(className$a("sw"));
        this.element.appendChild(swatchElem);
        this.swatchElem_ = swatchElem;
        var buttonElem = doc.createElement("button");
        buttonElem.classList.add(className$a("b"));
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        var pickerElem = doc.createElement("div");
        pickerElem.classList.add(className$a("p"));
        this.pickerView_ = config.pickerView;
        pickerElem.appendChild(this.pickerView_.element);
        this.element.appendChild(pickerElem);
        this.update();
      }
      ColorSwatchView2.prototype.update = function() {
        var value = this.value.rawValue;
        this.swatchElem_.style.backgroundColor = colorToHexRgbaString(value);
      };
      ColorSwatchView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return ColorSwatchView2;
    }();
    var Foldable = function() {
      function Foldable2() {
        this.emitter = new Emitter();
        this.expanded_ = false;
      }
      Object.defineProperty(Foldable2.prototype, "expanded", {
        get: function() {
          return this.expanded_;
        },
        set: function(expanded) {
          var changed = this.expanded_ !== expanded;
          if (changed) {
            this.expanded_ = expanded;
            this.emitter.emit("change", {
              sender: this
            });
          }
        },
        enumerable: false,
        configurable: true
      });
      return Foldable2;
    }();
    function connect(_a) {
      var primary = _a.primary, secondary = _a.secondary, forward = _a.forward, backward = _a.backward;
      primary.emitter.on("change", function() {
        secondary.rawValue = forward(primary, secondary);
      });
      secondary.emitter.on("change", function() {
        primary.rawValue = backward(primary, secondary);
      });
      secondary.rawValue = forward(primary, secondary);
    }
    function getStepForKey(baseStep, keys) {
      var step = baseStep * (keys.altKey ? 0.1 : 1) * (keys.shiftKey ? 10 : 1);
      if (keys.upKey) {
        return +step;
      } else if (keys.downKey) {
        return -step;
      }
      return 0;
    }
    function getVerticalStepKeys(ev) {
      return {
        altKey: ev.altKey,
        downKey: ev.keyCode === 40,
        shiftKey: ev.shiftKey,
        upKey: ev.keyCode === 38
      };
    }
    function getHorizontalStepKeys(ev) {
      return {
        altKey: ev.altKey,
        downKey: ev.keyCode === 37,
        shiftKey: ev.shiftKey,
        upKey: ev.keyCode === 39
      };
    }
    function isVerticalArrowKey(keyCode) {
      return keyCode === 38 || keyCode === 40;
    }
    function isArrowKey(keyCode) {
      return isVerticalArrowKey(keyCode) || keyCode === 37 || keyCode === 39;
    }
    var NumberTextController = function(_super) {
      __extends(NumberTextController2, _super);
      function NumberTextController2(doc, config) {
        var _this = _super.call(this, doc, config) || this;
        _this.onInputKeyDown_ = _this.onInputKeyDown_.bind(_this);
        _this.baseStep_ = config.baseStep;
        _this.view.inputElement.addEventListener("keydown", _this.onInputKeyDown_);
        return _this;
      }
      NumberTextController2.prototype.onInputKeyDown_ = function(e) {
        var step = getStepForKey(this.baseStep_, getVerticalStepKeys(e));
        if (step !== 0) {
          this.value.rawValue += step;
          this.view.update();
        }
      };
      return NumberTextController2;
    }(TextController);
    var className$b = ClassName("clp");
    var ColorPickerView = function() {
      function ColorPickerView2(doc, config) {
        this.alphaViews_ = null;
        this.onFoldableChange_ = this.onFoldableChange_.bind(this);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.pickedColor = config.pickedColor;
        this.pickedColor.value.emitter.on("change", this.onValueChange_);
        this.foldable = config.foldable;
        this.foldable.emitter.on("change", this.onFoldableChange_);
        this.element = doc.createElement("div");
        this.element.classList.add(className$b());
        var hsvElem = doc.createElement("div");
        hsvElem.classList.add(className$b("hsv"));
        var svElem = doc.createElement("div");
        svElem.classList.add(className$b("sv"));
        this.svPaletteView_ = config.svPaletteView;
        svElem.appendChild(this.svPaletteView_.element);
        hsvElem.appendChild(svElem);
        var hElem = doc.createElement("div");
        hElem.classList.add(className$b("h"));
        this.hPaletteView_ = config.hPaletteView;
        hElem.appendChild(this.hPaletteView_.element);
        hsvElem.appendChild(hElem);
        this.element.appendChild(hsvElem);
        var rgbElem = doc.createElement("div");
        rgbElem.classList.add(className$b("rgb"));
        this.compTextsView_ = config.componentTextsView;
        rgbElem.appendChild(this.compTextsView_.element);
        this.element.appendChild(rgbElem);
        if (config.alphaViews) {
          this.alphaViews_ = {
            palette: config.alphaViews.palette,
            text: config.alphaViews.text
          };
          var aElem = doc.createElement("div");
          aElem.classList.add(className$b("a"));
          var apElem = doc.createElement("div");
          apElem.classList.add(className$b("ap"));
          apElem.appendChild(this.alphaViews_.palette.element);
          aElem.appendChild(apElem);
          var atElem = doc.createElement("div");
          atElem.classList.add(className$b("at"));
          atElem.appendChild(this.alphaViews_.text.element);
          aElem.appendChild(atElem);
          this.element.appendChild(aElem);
        }
        this.update();
      }
      Object.defineProperty(ColorPickerView2.prototype, "allFocusableElements", {
        get: function() {
          var elems = __spreadArrays([
            this.svPaletteView_.element,
            this.hPaletteView_.element
          ], this.compTextsView_.inputElements);
          if (this.alphaViews_) {
            elems.push(this.alphaViews_.palette.element, this.alphaViews_.text.inputElement);
          }
          return forceCast(elems);
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(ColorPickerView2.prototype, "value", {
        get: function() {
          return this.pickedColor.value;
        },
        enumerable: false,
        configurable: true
      });
      ColorPickerView2.prototype.update = function() {
        if (this.foldable.expanded) {
          this.element.classList.add(className$b(void 0, "expanded"));
        } else {
          this.element.classList.remove(className$b(void 0, "expanded"));
        }
      };
      ColorPickerView2.prototype.onValueChange_ = function() {
        this.update();
      };
      ColorPickerView2.prototype.onFoldableChange_ = function() {
        this.update();
      };
      return ColorPickerView2;
    }();
    function computeOffset(ev, elem) {
      var win = elem.ownerDocument.defaultView;
      var rect = elem.getBoundingClientRect();
      return [
        ev.pageX - ((win && win.scrollX || 0) + rect.left),
        ev.pageY - ((win && win.scrollY || 0) + rect.top)
      ];
    }
    var PointerHandler = function() {
      function PointerHandler2(doc, element) {
        this.onDocumentMouseMove_ = this.onDocumentMouseMove_.bind(this);
        this.onDocumentMouseUp_ = this.onDocumentMouseUp_.bind(this);
        this.onMouseDown_ = this.onMouseDown_.bind(this);
        this.onTouchMove_ = this.onTouchMove_.bind(this);
        this.onTouchStart_ = this.onTouchStart_.bind(this);
        this.document = doc;
        this.element = element;
        this.emitter = new Emitter();
        this.pressed_ = false;
        if (supportsTouch(this.document)) {
          element.addEventListener("touchstart", this.onTouchStart_);
          element.addEventListener("touchmove", this.onTouchMove_);
        } else {
          element.addEventListener("mousedown", this.onMouseDown_);
          this.document.addEventListener("mousemove", this.onDocumentMouseMove_);
          this.document.addEventListener("mouseup", this.onDocumentMouseUp_);
        }
      }
      PointerHandler2.prototype.computePosition_ = function(offsetX, offsetY) {
        var rect = this.element.getBoundingClientRect();
        return {
          px: offsetX / rect.width,
          py: offsetY / rect.height
        };
      };
      PointerHandler2.prototype.onMouseDown_ = function(e) {
        var _a;
        e.preventDefault();
        (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.focus();
        this.pressed_ = true;
        this.emitter.emit("down", {
          data: this.computePosition_.apply(this, computeOffset(e, this.element)),
          sender: this
        });
      };
      PointerHandler2.prototype.onDocumentMouseMove_ = function(e) {
        if (!this.pressed_) {
          return;
        }
        this.emitter.emit("move", {
          data: this.computePosition_.apply(this, computeOffset(e, this.element)),
          sender: this
        });
      };
      PointerHandler2.prototype.onDocumentMouseUp_ = function(e) {
        if (!this.pressed_) {
          return;
        }
        this.pressed_ = false;
        this.emitter.emit("up", {
          data: this.computePosition_.apply(this, computeOffset(e, this.element)),
          sender: this
        });
      };
      PointerHandler2.prototype.onTouchStart_ = function(e) {
        e.preventDefault();
        var touch = e.targetTouches[0];
        var rect = this.element.getBoundingClientRect();
        this.emitter.emit("down", {
          data: this.computePosition_(touch.clientX - rect.left, touch.clientY - rect.top),
          sender: this
        });
      };
      PointerHandler2.prototype.onTouchMove_ = function(e) {
        var touch = e.targetTouches[0];
        var rect = this.element.getBoundingClientRect();
        this.emitter.emit("move", {
          data: this.computePosition_(touch.clientX - rect.left, touch.clientY - rect.top),
          sender: this
        });
      };
      return PointerHandler2;
    }();
    function getBaseStepForColor(forAlpha) {
      return forAlpha ? 0.1 : 1;
    }
    var className$c = ClassName("apl");
    var APaletteView = function() {
      function APaletteView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value = config.value;
        this.value.emitter.on("change", this.onValueChange_);
        this.element = doc.createElement("div");
        this.element.classList.add(className$c());
        this.element.tabIndex = 0;
        var barElem = doc.createElement("div");
        barElem.classList.add(className$c("b"));
        this.element.appendChild(barElem);
        var colorElem = doc.createElement("div");
        colorElem.classList.add(className$c("c"));
        barElem.appendChild(colorElem);
        this.colorElem_ = colorElem;
        var markerElem = doc.createElement("div");
        markerElem.classList.add(className$c("m"));
        this.element.appendChild(markerElem);
        this.markerElem_ = markerElem;
        var previewElem = doc.createElement("div");
        previewElem.classList.add(className$c("p"));
        this.markerElem_.appendChild(previewElem);
        this.previewElem_ = previewElem;
        this.update();
      }
      APaletteView2.prototype.update = function() {
        var c = this.value.rawValue;
        var rgbaComps = c.getComponents("rgb");
        var leftColor = new Color2([rgbaComps[0], rgbaComps[1], rgbaComps[2], 0], "rgb");
        var rightColor = new Color2([rgbaComps[0], rgbaComps[1], rgbaComps[2], 255], "rgb");
        var gradientComps = [
          "to right",
          colorToFunctionalRgbaString(leftColor),
          colorToFunctionalRgbaString(rightColor)
        ];
        this.colorElem_.style.background = "linear-gradient(" + gradientComps.join(",") + ")";
        this.previewElem_.style.backgroundColor = colorToFunctionalRgbaString(c);
        var left = mapRange(rgbaComps[3], 0, 1, 0, 100);
        this.markerElem_.style.left = left + "%";
      };
      APaletteView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return APaletteView2;
    }();
    var APaletteController = function() {
      function APaletteController2(doc, config) {
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.view = new APaletteView(doc, {
          value: this.value
        });
        this.ptHandler_ = new PointerHandler(doc, this.view.element);
        this.ptHandler_.emitter.on("down", this.onPointerDown_);
        this.ptHandler_.emitter.on("move", this.onPointerMove_);
        this.ptHandler_.emitter.on("up", this.onPointerUp_);
        this.view.element.addEventListener("keydown", this.onKeyDown_);
      }
      APaletteController2.prototype.handlePointerEvent_ = function(d) {
        var alpha = d.px;
        var c = this.value.rawValue;
        var _a = c.getComponents("hsv"), h = _a[0], s = _a[1], v = _a[2];
        this.value.rawValue = new Color2([h, s, v, alpha], "hsv");
        this.view.update();
      };
      APaletteController2.prototype.onPointerDown_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      APaletteController2.prototype.onPointerMove_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      APaletteController2.prototype.onPointerUp_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      APaletteController2.prototype.onKeyDown_ = function(ev) {
        var step = getStepForKey(getBaseStepForColor(true), getHorizontalStepKeys(ev));
        var c = this.value.rawValue;
        var _a = c.getComponents("hsv"), h = _a[0], s = _a[1], v = _a[2], a = _a[3];
        this.value.rawValue = new Color2([h, s, v, a + step], "hsv");
      };
      return APaletteController2;
    }();
    var className$d = ClassName("cctxts");
    var FORMATTER = createNumberFormatter(0);
    function createModeSelectElement(doc) {
      var selectElem = doc.createElement("select");
      var items = [
        { text: "RGB", value: "rgb" },
        { text: "HSL", value: "hsl" },
        { text: "HSV", value: "hsv" }
      ];
      selectElem.appendChild(items.reduce(function(frag, item) {
        var optElem = doc.createElement("option");
        optElem.textContent = item.text;
        optElem.value = item.value;
        frag.appendChild(optElem);
        return frag;
      }, doc.createDocumentFragment()));
      return selectElem;
    }
    var ColorComponentTextsView = function() {
      function ColorComponentTextsView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.element = doc.createElement("div");
        this.element.classList.add(className$d());
        var modeElem = doc.createElement("div");
        modeElem.classList.add(className$d("m"));
        this.modeElem_ = createModeSelectElement(doc);
        this.modeElem_.classList.add(className$d("ms"));
        modeElem.appendChild(this.modeSelectElement);
        var modeMarkerElem = doc.createElement("div");
        modeMarkerElem.classList.add(className$d("mm"));
        modeElem.appendChild(modeMarkerElem);
        this.element.appendChild(modeElem);
        var wrapperElem = doc.createElement("div");
        wrapperElem.classList.add(className$d("w"));
        this.element.appendChild(wrapperElem);
        var inputElems = [0, 1, 2].map(function() {
          var inputElem = doc.createElement("input");
          inputElem.classList.add(className$d("i"));
          inputElem.type = "text";
          return inputElem;
        });
        inputElems.forEach(function(elem) {
          wrapperElem.appendChild(elem);
        });
        this.inputElems_ = [inputElems[0], inputElems[1], inputElems[2]];
        this.pickedColor = config.pickedColor;
        this.pickedColor.emitter.on("change", this.onValueChange_);
        this.update();
      }
      Object.defineProperty(ColorComponentTextsView2.prototype, "modeSelectElement", {
        get: function() {
          return this.modeElem_;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(ColorComponentTextsView2.prototype, "inputElements", {
        get: function() {
          return this.inputElems_;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(ColorComponentTextsView2.prototype, "value", {
        get: function() {
          return this.pickedColor.value;
        },
        enumerable: false,
        configurable: true
      });
      ColorComponentTextsView2.prototype.update = function() {
        var _this = this;
        this.modeElem_.value = this.pickedColor.mode;
        var comps = this.pickedColor.value.rawValue.getComponents(this.pickedColor.mode);
        comps.forEach(function(comp, index) {
          var inputElem = _this.inputElems_[index];
          if (!inputElem) {
            return;
          }
          inputElem.value = FORMATTER(comp);
        });
      };
      ColorComponentTextsView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return ColorComponentTextsView2;
    }();
    var ColorComponentTextsController = function() {
      function ColorComponentTextsController2(doc, config) {
        var _this = this;
        this.onModeSelectChange_ = this.onModeSelectChange_.bind(this);
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.onInputKeyDown_ = this.onInputKeyDown_.bind(this);
        this.parser_ = config.parser;
        this.pickedColor = config.pickedColor;
        this.view = new ColorComponentTextsView(doc, {
          pickedColor: this.pickedColor
        });
        this.view.inputElements.forEach(function(inputElem) {
          inputElem.addEventListener("change", _this.onInputChange_);
          inputElem.addEventListener("keydown", _this.onInputKeyDown_);
        });
        this.view.modeSelectElement.addEventListener("change", this.onModeSelectChange_);
      }
      Object.defineProperty(ColorComponentTextsController2.prototype, "value", {
        get: function() {
          return this.pickedColor.value;
        },
        enumerable: false,
        configurable: true
      });
      ColorComponentTextsController2.prototype.findIndexOfInputElem_ = function(inputElem) {
        var inputElems = this.view.inputElements;
        for (var i = 0; i < inputElems.length; i++) {
          if (inputElems[i] === inputElem) {
            return i;
          }
        }
        return null;
      };
      ColorComponentTextsController2.prototype.updateComponent_ = function(index, newValue) {
        var mode = this.pickedColor.mode;
        var comps = this.value.rawValue.getComponents(mode);
        var newComps = comps.map(function(comp, i) {
          return i === index ? newValue : comp;
        });
        this.value.rawValue = new Color2(newComps, mode);
        this.view.update();
      };
      ColorComponentTextsController2.prototype.onInputChange_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        var parsedValue = this.parser_(inputElem.value);
        if (isEmpty(parsedValue)) {
          return;
        }
        var compIndex = this.findIndexOfInputElem_(inputElem);
        if (isEmpty(compIndex)) {
          return;
        }
        this.updateComponent_(compIndex, parsedValue);
      };
      ColorComponentTextsController2.prototype.onInputKeyDown_ = function(e) {
        var compIndex = this.findIndexOfInputElem_(e.currentTarget);
        var step = getStepForKey(getBaseStepForColor(compIndex === 3), getVerticalStepKeys(e));
        if (step === 0) {
          return;
        }
        var inputElem = forceCast(e.currentTarget);
        var parsedValue = this.parser_(inputElem.value);
        if (isEmpty(parsedValue)) {
          return;
        }
        if (isEmpty(compIndex)) {
          return;
        }
        this.updateComponent_(compIndex, parsedValue + step);
      };
      ColorComponentTextsController2.prototype.onModeSelectChange_ = function(ev) {
        var selectElem = ev.currentTarget;
        this.pickedColor.mode = selectElem.value;
      };
      return ColorComponentTextsController2;
    }();
    var className$e = ClassName("hpl");
    var HPaletteView = function() {
      function HPaletteView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value = config.value;
        this.value.emitter.on("change", this.onValueChange_);
        this.element = doc.createElement("div");
        this.element.classList.add(className$e());
        this.element.tabIndex = 0;
        var colorElem = doc.createElement("div");
        colorElem.classList.add(className$e("c"));
        this.element.appendChild(colorElem);
        var markerElem = doc.createElement("div");
        markerElem.classList.add(className$e("m"));
        this.element.appendChild(markerElem);
        this.markerElem_ = markerElem;
        this.update();
      }
      HPaletteView2.prototype.update = function() {
        var c = this.value.rawValue;
        var h = c.getComponents("hsv")[0];
        this.markerElem_.style.backgroundColor = colorToFunctionalRgbString(new Color2([h, 100, 100], "hsv"));
        var left = mapRange(h, 0, 360, 0, 100);
        this.markerElem_.style.left = left + "%";
      };
      HPaletteView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return HPaletteView2;
    }();
    var HPaletteController = function() {
      function HPaletteController2(doc, config) {
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.view = new HPaletteView(doc, {
          value: this.value
        });
        this.ptHandler_ = new PointerHandler(doc, this.view.element);
        this.ptHandler_.emitter.on("down", this.onPointerDown_);
        this.ptHandler_.emitter.on("move", this.onPointerMove_);
        this.ptHandler_.emitter.on("up", this.onPointerUp_);
        this.view.element.addEventListener("keydown", this.onKeyDown_);
      }
      HPaletteController2.prototype.handlePointerEvent_ = function(d) {
        var hue = mapRange(d.px, 0, 1, 0, 360);
        var c = this.value.rawValue;
        var _a = c.getComponents("hsv"), s = _a[1], v = _a[2], a = _a[3];
        this.value.rawValue = new Color2([hue, s, v, a], "hsv");
        this.view.update();
      };
      HPaletteController2.prototype.onPointerDown_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      HPaletteController2.prototype.onPointerMove_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      HPaletteController2.prototype.onPointerUp_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      HPaletteController2.prototype.onKeyDown_ = function(ev) {
        var step = getStepForKey(getBaseStepForColor(false), getHorizontalStepKeys(ev));
        var c = this.value.rawValue;
        var _a = c.getComponents("hsv"), h = _a[0], s = _a[1], v = _a[2], a = _a[3];
        this.value.rawValue = new Color2([h + step, s, v, a], "hsv");
      };
      return HPaletteController2;
    }();
    var className$f = ClassName("svp");
    var CANVAS_RESOL = 64;
    var SvPaletteView = function() {
      function SvPaletteView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value = config.value;
        this.value.emitter.on("change", this.onValueChange_);
        this.element = doc.createElement("div");
        this.element.classList.add(className$f());
        this.element.tabIndex = 0;
        var canvasElem = doc.createElement("canvas");
        canvasElem.height = CANVAS_RESOL;
        canvasElem.width = CANVAS_RESOL;
        canvasElem.classList.add(className$f("c"));
        this.element.appendChild(canvasElem);
        this.canvasElement = canvasElem;
        var markerElem = doc.createElement("div");
        markerElem.classList.add(className$f("m"));
        this.element.appendChild(markerElem);
        this.markerElem_ = markerElem;
        this.update();
      }
      SvPaletteView2.prototype.update = function() {
        var ctx = getCanvasContext(this.canvasElement);
        if (!ctx) {
          return;
        }
        var c = this.value.rawValue;
        var hsvComps = c.getComponents("hsv");
        var width = this.canvasElement.width;
        var height = this.canvasElement.height;
        var imgData = ctx.getImageData(0, 0, width, height);
        var data = imgData.data;
        for (var iy = 0; iy < height; iy++) {
          for (var ix = 0; ix < width; ix++) {
            var s = mapRange(ix, 0, width, 0, 100);
            var v = mapRange(iy, 0, height, 100, 0);
            var rgbComps = hsvToRgb(hsvComps[0], s, v);
            var i = (iy * width + ix) * 4;
            data[i] = rgbComps[0];
            data[i + 1] = rgbComps[1];
            data[i + 2] = rgbComps[2];
            data[i + 3] = 255;
          }
        }
        ctx.putImageData(imgData, 0, 0);
        var left = mapRange(hsvComps[1], 0, 100, 0, 100);
        this.markerElem_.style.left = left + "%";
        var top = mapRange(hsvComps[2], 0, 100, 100, 0);
        this.markerElem_.style.top = top + "%";
      };
      SvPaletteView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return SvPaletteView2;
    }();
    var SvPaletteController = function() {
      function SvPaletteController2(doc, config) {
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.view = new SvPaletteView(doc, {
          value: this.value
        });
        this.ptHandler_ = new PointerHandler(doc, this.view.element);
        this.ptHandler_.emitter.on("down", this.onPointerDown_);
        this.ptHandler_.emitter.on("move", this.onPointerMove_);
        this.ptHandler_.emitter.on("up", this.onPointerUp_);
        this.view.element.addEventListener("keydown", this.onKeyDown_);
      }
      SvPaletteController2.prototype.handlePointerEvent_ = function(d) {
        var saturation = mapRange(d.px, 0, 1, 0, 100);
        var value = mapRange(d.py, 0, 1, 100, 0);
        var _a = this.value.rawValue.getComponents("hsv"), h = _a[0], a = _a[3];
        this.value.rawValue = new Color2([h, saturation, value, a], "hsv");
        this.view.update();
      };
      SvPaletteController2.prototype.onPointerDown_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      SvPaletteController2.prototype.onPointerMove_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      SvPaletteController2.prototype.onPointerUp_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      SvPaletteController2.prototype.onKeyDown_ = function(ev) {
        if (isArrowKey(ev.keyCode)) {
          ev.preventDefault();
        }
        var _a = this.value.rawValue.getComponents("hsv"), h = _a[0], s = _a[1], v = _a[2], a = _a[3];
        var baseStep = getBaseStepForColor(false);
        this.value.rawValue = new Color2([
          h,
          s + getStepForKey(baseStep, getHorizontalStepKeys(ev)),
          v + getStepForKey(baseStep, getVerticalStepKeys(ev)),
          a
        ], "hsv");
      };
      return SvPaletteController2;
    }();
    var ColorPickerController = function() {
      function ColorPickerController2(doc, config) {
        var _this = this;
        this.triggerElement = null;
        this.onFocusableElementBlur_ = this.onFocusableElementBlur_.bind(this);
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.pickedColor = config.pickedColor;
        this.foldable = new Foldable();
        this.hPaletteIc_ = new HPaletteController(doc, {
          value: this.pickedColor.value
        });
        this.svPaletteIc_ = new SvPaletteController(doc, {
          value: this.pickedColor.value
        });
        this.alphaIcs_ = config.supportsAlpha ? {
          palette: new APaletteController(doc, {
            value: this.pickedColor.value
          }),
          text: new NumberTextController(doc, {
            formatter: createNumberFormatter(2),
            parser: parseNumber,
            baseStep: 0.1,
            value: new Value(0)
          })
        } : null;
        if (this.alphaIcs_) {
          connect({
            primary: this.pickedColor.value,
            secondary: this.alphaIcs_.text.value,
            forward: function(p) {
              return p.rawValue.getComponents()[3];
            },
            backward: function(p, s) {
              var comps = p.rawValue.getComponents();
              comps[3] = s.rawValue;
              return new Color2(comps, p.rawValue.mode);
            }
          });
        }
        this.compTextsIc_ = new ColorComponentTextsController(doc, {
          parser: parseNumber,
          pickedColor: this.pickedColor
        });
        this.view = new ColorPickerView(doc, {
          alphaViews: this.alphaIcs_ ? {
            palette: this.alphaIcs_.palette.view,
            text: this.alphaIcs_.text.view
          } : null,
          componentTextsView: this.compTextsIc_.view,
          foldable: this.foldable,
          hPaletteView: this.hPaletteIc_.view,
          pickedColor: this.pickedColor,
          supportsAlpha: config.supportsAlpha,
          svPaletteView: this.svPaletteIc_.view
        });
        this.view.element.addEventListener("keydown", this.onKeyDown_);
        this.view.allFocusableElements.forEach(function(elem) {
          elem.addEventListener("blur", _this.onFocusableElementBlur_);
        });
      }
      Object.defineProperty(ColorPickerController2.prototype, "value", {
        get: function() {
          return this.pickedColor.value;
        },
        enumerable: false,
        configurable: true
      });
      ColorPickerController2.prototype.onFocusableElementBlur_ = function(ev) {
        var elem = this.view.element;
        var nextTarget = findNextTarget(ev);
        if (nextTarget && elem.contains(nextTarget)) {
          return;
        }
        if (nextTarget && nextTarget === this.triggerElement && !supportsTouch(elem.ownerDocument)) {
          return;
        }
        this.foldable.expanded = false;
      };
      ColorPickerController2.prototype.onKeyDown_ = function(ev) {
        if (ev.keyCode === 27) {
          this.foldable.expanded = false;
        }
      };
      return ColorPickerController2;
    }();
    var ColorSwatchController = function() {
      function ColorSwatchController2(doc, config) {
        this.onButtonBlur_ = this.onButtonBlur_.bind(this);
        this.onButtonClick_ = this.onButtonClick_.bind(this);
        this.value = config.value;
        this.pickerIc_ = new ColorPickerController(doc, {
          pickedColor: new PickedColor(this.value),
          supportsAlpha: config.supportsAlpha
        });
        this.view = new ColorSwatchView(doc, {
          pickerView: this.pickerIc_.view,
          value: this.value
        });
        this.view.buttonElement.addEventListener("blur", this.onButtonBlur_);
        this.view.buttonElement.addEventListener("click", this.onButtonClick_);
        this.pickerIc_.triggerElement = this.view.buttonElement;
      }
      ColorSwatchController2.prototype.onButtonBlur_ = function(e) {
        var elem = this.view.element;
        var nextTarget = forceCast(e.relatedTarget);
        if (!nextTarget || !elem.contains(nextTarget)) {
          this.pickerIc_.foldable.expanded = false;
        }
      };
      ColorSwatchController2.prototype.onButtonClick_ = function() {
        this.pickerIc_.foldable.expanded = !this.pickerIc_.foldable.expanded;
        if (this.pickerIc_.foldable.expanded) {
          this.pickerIc_.view.allFocusableElements[0].focus();
        }
      };
      return ColorSwatchController2;
    }();
    var ColorSwatchTextController = function() {
      function ColorSwatchTextController2(doc, config) {
        this.value = config.value;
        this.swatchIc_ = new ColorSwatchController(doc, {
          supportsAlpha: config.supportsAlpha,
          value: this.value
        });
        this.textIc_ = new TextController(doc, {
          formatter: config.formatter,
          parser: config.parser,
          value: this.value
        });
        this.view = new ColorSwatchTextView(doc, {
          swatchView: this.swatchIc_.view,
          textView: this.textIc_.view
        });
      }
      return ColorSwatchTextController2;
    }();
    function colorFromObject(value) {
      if (Color2.isColorObject(value)) {
        return Color2.fromObject(value);
      }
      return Color2.black();
    }
    function colorToRgbNumber(value) {
      return removeAlphaComponent(value.getComponents("rgb")).reduce(function(result, comp) {
        return result << 8 | Math.floor(comp) & 255;
      }, 0);
    }
    function colorToRgbaNumber(value) {
      return value.getComponents("rgb").reduce(function(result, comp, index) {
        var hex = Math.floor(index === 3 ? comp * 255 : comp) & 255;
        return result << 8 | hex;
      }, 0) >>> 0;
    }
    function numberToRgbColor(num) {
      return new Color2([num >> 16 & 255, num >> 8 & 255, num & 255], "rgb");
    }
    function numberToRgbaColor(num) {
      return new Color2([
        num >> 24 & 255,
        num >> 16 & 255,
        num >> 8 & 255,
        mapRange(num & 255, 0, 255, 0, 1)
      ], "rgb");
    }
    function colorFromRgbNumber(value) {
      if (typeof value !== "number") {
        return Color2.black();
      }
      return numberToRgbColor(value);
    }
    function colorFromRgbaNumber(value) {
      if (typeof value !== "number") {
        return Color2.black();
      }
      return numberToRgbaColor(value);
    }
    function createColorStringWriter(notation) {
      var stringify = getColorStringifier(notation);
      return function(target, value) {
        writePrimitive(target, stringify(value));
      };
    }
    function createColorNumberWriter(supportsAlpha) {
      var colorToNumber = supportsAlpha ? colorToRgbaNumber : colorToRgbNumber;
      return function(target, value) {
        writePrimitive(target, colorToNumber(value));
      };
    }
    function writeRgbaColorObject(target, value) {
      var obj = value.toRgbaObject();
      target.writeProperty("r", obj.r);
      target.writeProperty("g", obj.g);
      target.writeProperty("b", obj.b);
      target.writeProperty("a", obj.a);
    }
    function writeRgbColorObject(target, value) {
      var obj = value.toRgbaObject();
      target.writeProperty("r", obj.r);
      target.writeProperty("g", obj.g);
      target.writeProperty("b", obj.b);
    }
    function createColorObjectWriter(supportsAlpha) {
      return supportsAlpha ? writeRgbaColorObject : writeRgbColorObject;
    }
    function shouldSupportAlpha(inputParams) {
      return "input" in inputParams && inputParams.input === "color.rgba";
    }
    var NumberColorInputPlugin = {
      id: "input-color-number",
      binding: {
        accept: function(value, params) {
          if (typeof value !== "number") {
            return null;
          }
          if (!("input" in params)) {
            return null;
          }
          if (params.input !== "color" && params.input !== "color.rgb" && params.input !== "color.rgba") {
            return null;
          }
          return value;
        },
        reader: function(args) {
          return shouldSupportAlpha(args.params) ? colorFromRgbaNumber : colorFromRgbNumber;
        },
        writer: function(args) {
          return createColorNumberWriter(shouldSupportAlpha(args.params));
        },
        equals: Color2.equals
      },
      controller: function(args) {
        var supportsAlpha = shouldSupportAlpha(args.params);
        var formatter = supportsAlpha ? colorToHexRgbaString : colorToHexRgbString;
        return new ColorSwatchTextController(args.document, {
          formatter,
          parser: CompositeColorParser,
          supportsAlpha,
          value: args.binding.value
        });
      }
    };
    function shouldSupportAlpha$1(initialValue) {
      return Color2.isRgbaColorObject(initialValue);
    }
    var ObjectColorInputPlugin = {
      id: "input-color-object",
      binding: {
        accept: function(value, _params) {
          return Color2.isColorObject(value) ? value : null;
        },
        reader: function(_args) {
          return colorFromObject;
        },
        writer: function(args) {
          return createColorObjectWriter(shouldSupportAlpha$1(args.initialValue));
        },
        equals: Color2.equals
      },
      controller: function(args) {
        var supportsAlpha = Color2.isRgbaColorObject(args.initialValue);
        var formatter = supportsAlpha ? colorToHexRgbaString : colorToHexRgbString;
        return new ColorSwatchTextController(args.document, {
          formatter,
          parser: CompositeColorParser,
          supportsAlpha,
          value: args.binding.value
        });
      }
    };
    var StringColorInputPlugin = {
      id: "input-color-string",
      binding: {
        accept: function(value, params) {
          if (typeof value !== "string") {
            return null;
          }
          if ("input" in params && params.input === "string") {
            return null;
          }
          var notation = getColorNotation(value);
          if (!notation) {
            return null;
          }
          return value;
        },
        reader: function(_args) {
          return colorFromString;
        },
        writer: function(args) {
          var notation = getColorNotation(args.initialValue);
          if (!notation) {
            throw TpError.shouldNeverHappen();
          }
          return createColorStringWriter(notation);
        },
        equals: Color2.equals
      },
      controller: function(args) {
        var notation = getColorNotation(args.initialValue);
        if (!notation) {
          throw TpError.shouldNeverHappen();
        }
        var stringifier = getColorStringifier(notation);
        return new ColorSwatchTextController(args.document, {
          formatter: stringifier,
          parser: CompositeColorParser,
          supportsAlpha: hasAlphaComponent(notation),
          value: args.binding.value
        });
      }
    };
    var RangeConstraint = function() {
      function RangeConstraint2(config) {
        this.maxValue = config.max;
        this.minValue = config.min;
      }
      RangeConstraint2.prototype.constrain = function(value) {
        var result = value;
        if (!isEmpty(this.minValue)) {
          result = Math.max(result, this.minValue);
        }
        if (!isEmpty(this.maxValue)) {
          result = Math.min(result, this.maxValue);
        }
        return result;
      };
      return RangeConstraint2;
    }();
    var className$g = ClassName("sldtxt");
    var SliderTextView = function() {
      function SliderTextView2(doc, config) {
        this.element = doc.createElement("div");
        this.element.classList.add(className$g());
        var sliderElem = doc.createElement("div");
        sliderElem.classList.add(className$g("s"));
        this.sliderView_ = config.sliderView;
        sliderElem.appendChild(this.sliderView_.element);
        this.element.appendChild(sliderElem);
        var textElem = doc.createElement("div");
        textElem.classList.add(className$g("t"));
        this.textView_ = config.textView;
        textElem.appendChild(this.textView_.element);
        this.element.appendChild(textElem);
      }
      Object.defineProperty(SliderTextView2.prototype, "value", {
        get: function() {
          return this.sliderView_.value;
        },
        enumerable: false,
        configurable: true
      });
      SliderTextView2.prototype.update = function() {
        this.sliderView_.update();
        this.textView_.update();
      };
      return SliderTextView2;
    }();
    var className$h = ClassName("sld");
    var SliderView = function() {
      function SliderView2(doc, config) {
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.minValue_ = config.minValue;
        this.maxValue_ = config.maxValue;
        this.element = doc.createElement("div");
        this.element.classList.add(className$h());
        var outerElem = doc.createElement("div");
        outerElem.classList.add(className$h("o"));
        outerElem.tabIndex = 0;
        this.element.appendChild(outerElem);
        this.outerElement = outerElem;
        var innerElem = doc.createElement("div");
        innerElem.classList.add(className$h("i"));
        this.outerElement.appendChild(innerElem);
        this.innerElement = innerElem;
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      SliderView2.prototype.update = function() {
        var p = constrainRange(mapRange(this.value.rawValue, this.minValue_, this.maxValue_, 0, 100), 0, 100);
        this.innerElement.style.width = p + "%";
      };
      SliderView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return SliderView2;
    }();
    function findRange(value) {
      var c = value.constraint ? findConstraint(value.constraint, RangeConstraint) : null;
      if (!c) {
        return [void 0, void 0];
      }
      return [c.minValue, c.maxValue];
    }
    function estimateSuitableRange(value) {
      var _a = findRange(value), min = _a[0], max = _a[1];
      return [min !== null && min !== void 0 ? min : 0, max !== null && max !== void 0 ? max : 100];
    }
    var SliderController = function() {
      function SliderController2(doc, config) {
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.baseStep_ = config.baseStep;
        var _a = estimateSuitableRange(this.value), min = _a[0], max = _a[1];
        this.minValue_ = min;
        this.maxValue_ = max;
        this.view = new SliderView(doc, {
          maxValue: this.maxValue_,
          minValue: this.minValue_,
          value: this.value
        });
        this.ptHandler_ = new PointerHandler(doc, this.view.outerElement);
        this.ptHandler_.emitter.on("down", this.onPointerDown_);
        this.ptHandler_.emitter.on("move", this.onPointerMove_);
        this.ptHandler_.emitter.on("up", this.onPointerUp_);
        this.view.outerElement.addEventListener("keydown", this.onKeyDown_);
      }
      SliderController2.prototype.handlePointerEvent_ = function(d) {
        this.value.rawValue = mapRange(d.px, 0, 1, this.minValue_, this.maxValue_);
      };
      SliderController2.prototype.onPointerDown_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      SliderController2.prototype.onPointerMove_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      SliderController2.prototype.onPointerUp_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      SliderController2.prototype.onKeyDown_ = function(ev) {
        this.value.rawValue += getStepForKey(this.baseStep_, getHorizontalStepKeys(ev));
      };
      return SliderController2;
    }();
    var SliderTextController = function() {
      function SliderTextController2(doc, config) {
        this.value = config.value;
        this.sliderIc_ = new SliderController(doc, {
          baseStep: config.baseStep,
          value: config.value
        });
        this.textIc_ = new NumberTextController(doc, {
          baseStep: config.baseStep,
          formatter: config.formatter,
          parser: config.parser,
          value: config.value
        });
        this.view = new SliderTextView(doc, {
          sliderView: this.sliderIc_.view,
          textView: this.textIc_.view
        });
      }
      return SliderTextController2;
    }();
    function createConstraint$1(params) {
      var constraints = [];
      if ("step" in params && !isEmpty(params.step)) {
        constraints.push(new StepConstraint({
          step: params.step
        }));
      }
      if ("max" in params && !isEmpty(params.max) || "min" in params && !isEmpty(params.min)) {
        constraints.push(new RangeConstraint({
          max: params.max,
          min: params.min
        }));
      }
      if ("options" in params && params.options !== void 0) {
        constraints.push(new ListConstraint({
          options: normalizeInputParamsOptions(params.options, numberFromUnknown)
        }));
      }
      return new CompositeConstraint({
        constraints
      });
    }
    function createController$3(doc, value) {
      var _a;
      var c = value.constraint;
      if (c && findConstraint(c, ListConstraint)) {
        return new ListController(doc, {
          listItems: (_a = findListItems(c)) !== null && _a !== void 0 ? _a : [],
          stringifyValue: numberToString,
          value
        });
      }
      if (c && findConstraint(c, RangeConstraint)) {
        return new SliderTextController(doc, {
          baseStep: getBaseStep(c),
          formatter: createNumberFormatter(getSuitableDecimalDigits(value.constraint, value.rawValue)),
          parser: parseNumber,
          value
        });
      }
      return new NumberTextController(doc, {
        baseStep: getBaseStep(c),
        formatter: createNumberFormatter(getSuitableDecimalDigits(value.constraint, value.rawValue)),
        parser: parseNumber,
        value
      });
    }
    var NumberInputPlugin = {
      id: "input-number",
      binding: {
        accept: function(value) {
          return typeof value === "number" ? value : null;
        },
        constraint: function(args) {
          return createConstraint$1(args.params);
        },
        reader: function(_args) {
          return numberFromUnknown;
        },
        writer: function(_args) {
          return writePrimitive;
        }
      },
      controller: function(args) {
        return createController$3(args.document, args.binding.value);
      }
    };
    var Point2d = function() {
      function Point2d2(x, y) {
        if (x === void 0) {
          x = 0;
        }
        if (y === void 0) {
          y = 0;
        }
        this.x = x;
        this.y = y;
      }
      Point2d2.prototype.getComponents = function() {
        return [this.x, this.y];
      };
      Point2d2.isObject = function(obj) {
        if (isEmpty(obj)) {
          return false;
        }
        var x = obj.x;
        var y = obj.y;
        if (typeof x !== "number" || typeof y !== "number") {
          return false;
        }
        return true;
      };
      Point2d2.equals = function(v1, v2) {
        return v1.x === v2.x && v1.y === v2.y;
      };
      Point2d2.prototype.toObject = function() {
        return {
          x: this.x,
          y: this.y
        };
      };
      return Point2d2;
    }();
    var Point2dConstraint = function() {
      function Point2dConstraint2(config) {
        this.x = config.x;
        this.y = config.y;
      }
      Point2dConstraint2.prototype.constrain = function(value) {
        return new Point2d(this.x ? this.x.constrain(value.x) : value.x, this.y ? this.y.constrain(value.y) : value.y);
      };
      return Point2dConstraint2;
    }();
    var className$i = ClassName("p2dpadtxt");
    var Point2dPadTextView = function() {
      function Point2dPadTextView2(doc, config) {
        this.element = doc.createElement("div");
        this.element.classList.add(className$i());
        var padWrapperElem = doc.createElement("div");
        padWrapperElem.classList.add(className$i("w"));
        this.element.appendChild(padWrapperElem);
        var buttonElem = doc.createElement("button");
        buttonElem.classList.add(className$i("b"));
        buttonElem.appendChild(createSvgIconElement(doc, "p2dpad"));
        padWrapperElem.appendChild(buttonElem);
        this.padButtonElem_ = buttonElem;
        var padElem = doc.createElement("div");
        padElem.classList.add(className$i("p"));
        padWrapperElem.appendChild(padElem);
        this.padView_ = config.padView;
        padElem.appendChild(this.padView_.element);
        var textElem = doc.createElement("div");
        textElem.classList.add(className$i("t"));
        this.textView_ = config.textView;
        textElem.appendChild(this.textView_.element);
        this.element.appendChild(textElem);
      }
      Object.defineProperty(Point2dPadTextView2.prototype, "value", {
        get: function() {
          return this.textView_.value;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Point2dPadTextView2.prototype, "padButtonElement", {
        get: function() {
          return this.padButtonElem_;
        },
        enumerable: false,
        configurable: true
      });
      Point2dPadTextView2.prototype.update = function() {
        this.padView_.update();
        this.textView_.update();
      };
      return Point2dPadTextView2;
    }();
    var className$j = ClassName("p2dpad");
    var Point2dPadView = function() {
      function Point2dPadView2(doc, config) {
        this.onFoldableChange_ = this.onFoldableChange_.bind(this);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.foldable = config.foldable;
        this.foldable.emitter.on("change", this.onFoldableChange_);
        this.invertsY_ = config.invertsY;
        this.maxValue_ = config.maxValue;
        this.element = doc.createElement("div");
        this.element.classList.add(className$j());
        var padElem = doc.createElement("div");
        padElem.tabIndex = 0;
        padElem.classList.add(className$j("p"));
        this.element.appendChild(padElem);
        this.padElement = padElem;
        var svgElem = doc.createElementNS(SVG_NS, "svg");
        svgElem.classList.add(className$j("g"));
        this.padElement.appendChild(svgElem);
        this.svgElem_ = svgElem;
        var xAxisElem = doc.createElementNS(SVG_NS, "line");
        xAxisElem.classList.add(className$j("ax"));
        xAxisElem.setAttributeNS(null, "x1", "0");
        xAxisElem.setAttributeNS(null, "y1", "50%");
        xAxisElem.setAttributeNS(null, "x2", "100%");
        xAxisElem.setAttributeNS(null, "y2", "50%");
        this.svgElem_.appendChild(xAxisElem);
        var yAxisElem = doc.createElementNS(SVG_NS, "line");
        yAxisElem.classList.add(className$j("ax"));
        yAxisElem.setAttributeNS(null, "x1", "50%");
        yAxisElem.setAttributeNS(null, "y1", "0");
        yAxisElem.setAttributeNS(null, "x2", "50%");
        yAxisElem.setAttributeNS(null, "y2", "100%");
        this.svgElem_.appendChild(yAxisElem);
        var lineElem = doc.createElementNS(SVG_NS, "line");
        lineElem.classList.add(className$j("l"));
        lineElem.setAttributeNS(null, "x1", "50%");
        lineElem.setAttributeNS(null, "y1", "50%");
        this.svgElem_.appendChild(lineElem);
        this.lineElem_ = lineElem;
        var markerElem = doc.createElementNS(SVG_NS, "circle");
        markerElem.classList.add(className$j("m"));
        markerElem.setAttributeNS(null, "r", "2px");
        this.svgElem_.appendChild(markerElem);
        this.markerElem_ = markerElem;
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      Object.defineProperty(Point2dPadView2.prototype, "allFocusableElements", {
        get: function() {
          return [this.padElement];
        },
        enumerable: false,
        configurable: true
      });
      Point2dPadView2.prototype.update = function() {
        if (this.foldable.expanded) {
          this.element.classList.add(className$j(void 0, "expanded"));
        } else {
          this.element.classList.remove(className$j(void 0, "expanded"));
        }
        var _a = this.value.rawValue.getComponents(), x = _a[0], y = _a[1];
        var max = this.maxValue_;
        var px2 = mapRange(x, -max, +max, 0, 100);
        var py2 = mapRange(y, -max, +max, 0, 100);
        var ipy = this.invertsY_ ? 100 - py2 : py2;
        this.lineElem_.setAttributeNS(null, "x2", px2 + "%");
        this.lineElem_.setAttributeNS(null, "y2", ipy + "%");
        this.markerElem_.setAttributeNS(null, "cx", px2 + "%");
        this.markerElem_.setAttributeNS(null, "cy", ipy + "%");
      };
      Point2dPadView2.prototype.onValueChange_ = function() {
        this.update();
      };
      Point2dPadView2.prototype.onFoldableChange_ = function() {
        this.update();
      };
      return Point2dPadView2;
    }();
    var Point2dPadController = function() {
      function Point2dPadController2(doc, config) {
        var _this = this;
        this.triggerElement = null;
        this.onFocusableElementBlur_ = this.onFocusableElementBlur_.bind(this);
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onPadKeyDown_ = this.onPadKeyDown_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.foldable = new Foldable();
        this.baseSteps_ = config.baseSteps;
        this.maxValue_ = config.maxValue;
        this.invertsY_ = config.invertsY;
        this.view = new Point2dPadView(doc, {
          foldable: this.foldable,
          invertsY: this.invertsY_,
          maxValue: this.maxValue_,
          value: this.value
        });
        this.ptHandler_ = new PointerHandler(doc, this.view.padElement);
        this.ptHandler_.emitter.on("down", this.onPointerDown_);
        this.ptHandler_.emitter.on("move", this.onPointerMove_);
        this.ptHandler_.emitter.on("up", this.onPointerUp_);
        this.view.padElement.addEventListener("keydown", this.onPadKeyDown_);
        this.view.element.addEventListener("keydown", this.onKeyDown_);
        this.view.allFocusableElements.forEach(function(elem) {
          elem.addEventListener("blur", _this.onFocusableElementBlur_);
        });
      }
      Point2dPadController2.prototype.handlePointerEvent_ = function(d) {
        var max = this.maxValue_;
        var px2 = mapRange(d.px, 0, 1, -max, +max);
        var py2 = mapRange(this.invertsY_ ? 1 - d.py : d.py, 0, 1, -max, +max);
        this.value.rawValue = new Point2d(px2, py2);
        this.view.update();
      };
      Point2dPadController2.prototype.onPointerDown_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      Point2dPadController2.prototype.onPointerMove_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      Point2dPadController2.prototype.onPointerUp_ = function(ev) {
        this.handlePointerEvent_(ev.data);
      };
      Point2dPadController2.prototype.onPadKeyDown_ = function(ev) {
        if (isArrowKey(ev.keyCode)) {
          ev.preventDefault();
        }
        this.value.rawValue = new Point2d(this.value.rawValue.x + getStepForKey(this.baseSteps_[0], getHorizontalStepKeys(ev)), this.value.rawValue.y + getStepForKey(this.baseSteps_[1], getVerticalStepKeys(ev)) * (this.invertsY_ ? 1 : -1));
      };
      Point2dPadController2.prototype.onFocusableElementBlur_ = function(ev) {
        var elem = this.view.element;
        var nextTarget = findNextTarget(ev);
        if (nextTarget && elem.contains(nextTarget)) {
          return;
        }
        if (nextTarget && nextTarget === this.triggerElement && !supportsTouch(elem.ownerDocument)) {
          return;
        }
        this.foldable.expanded = false;
      };
      Point2dPadController2.prototype.onKeyDown_ = function(ev) {
        if (ev.keyCode === 27) {
          this.foldable.expanded = false;
        }
      };
      return Point2dPadController2;
    }();
    var className$k = ClassName("p2dtxt");
    var Point2dTextView = function() {
      function Point2dTextView2(doc, config) {
        var _this = this;
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.formatters_ = config.formatters;
        this.element = doc.createElement("div");
        this.element.classList.add(className$k());
        var inputElems = [0, 1].map(function() {
          var inputElem = doc.createElement("input");
          inputElem.classList.add(className$k("i"));
          inputElem.type = "text";
          return inputElem;
        });
        [0, 1].forEach(function(_, index) {
          var elem = doc.createElement("div");
          elem.classList.add(className$k("w"));
          elem.appendChild(inputElems[index]);
          _this.element.appendChild(elem);
        });
        this.inputElems_ = [inputElems[0], inputElems[1]];
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      Object.defineProperty(Point2dTextView2.prototype, "inputElements", {
        get: function() {
          return this.inputElems_;
        },
        enumerable: false,
        configurable: true
      });
      Point2dTextView2.prototype.update = function() {
        var _this = this;
        var xyComps = this.value.rawValue.getComponents();
        xyComps.forEach(function(comp, index) {
          var inputElem = _this.inputElems_[index];
          inputElem.value = _this.formatters_[index](comp);
        });
      };
      Point2dTextView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return Point2dTextView2;
    }();
    var Point2dTextController = function() {
      function Point2dTextController2(doc, config) {
        var _this = this;
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.onInputKeyDown_ = this.onInputKeyDown_.bind(this);
        this.parser_ = config.parser;
        this.value = config.value;
        this.baseSteps_ = [config.axes[0].baseStep, config.axes[1].baseStep];
        this.view = new Point2dTextView(doc, {
          formatters: [config.axes[0].formatter, config.axes[1].formatter],
          value: this.value
        });
        this.view.inputElements.forEach(function(inputElem) {
          inputElem.addEventListener("change", _this.onInputChange_);
          inputElem.addEventListener("keydown", _this.onInputKeyDown_);
        });
      }
      Point2dTextController2.prototype.findIndexOfInputElem_ = function(inputElem) {
        var inputElems = this.view.inputElements;
        for (var i = 0; i < inputElems.length; i++) {
          if (inputElems[i] === inputElem) {
            return i;
          }
        }
        return null;
      };
      Point2dTextController2.prototype.updateComponent_ = function(index, newValue) {
        var comps = this.value.rawValue.getComponents();
        var newComps = comps.map(function(comp, i) {
          return i === index ? newValue : comp;
        });
        this.value.rawValue = new Point2d(newComps[0], newComps[1]);
        this.view.update();
      };
      Point2dTextController2.prototype.onInputChange_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        var parsedValue = this.parser_(inputElem.value);
        if (isEmpty(parsedValue)) {
          return;
        }
        var compIndex = this.findIndexOfInputElem_(inputElem);
        if (isEmpty(compIndex)) {
          return;
        }
        this.updateComponent_(compIndex, parsedValue);
      };
      Point2dTextController2.prototype.onInputKeyDown_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        var parsedValue = this.parser_(inputElem.value);
        if (isEmpty(parsedValue)) {
          return;
        }
        var compIndex = this.findIndexOfInputElem_(inputElem);
        if (isEmpty(compIndex)) {
          return;
        }
        var step = getStepForKey(this.baseSteps_[compIndex], getVerticalStepKeys(e));
        if (step === 0) {
          return;
        }
        this.updateComponent_(compIndex, parsedValue + step);
      };
      return Point2dTextController2;
    }();
    var Point2dPadTextController = function() {
      function Point2dPadTextController2(doc, config) {
        this.onPadButtonBlur_ = this.onPadButtonBlur_.bind(this);
        this.onPadButtonClick_ = this.onPadButtonClick_.bind(this);
        this.value = config.value;
        this.padIc_ = new Point2dPadController(doc, {
          baseSteps: [config.axes[0].baseStep, config.axes[1].baseStep],
          invertsY: config.invertsY,
          maxValue: config.maxValue,
          value: this.value
        });
        this.textIc_ = new Point2dTextController(doc, {
          axes: config.axes,
          parser: config.parser,
          value: this.value
        });
        this.view = new Point2dPadTextView(doc, {
          padView: this.padIc_.view,
          textView: this.textIc_.view
        });
        this.view.padButtonElement.addEventListener("blur", this.onPadButtonBlur_);
        this.view.padButtonElement.addEventListener("click", this.onPadButtonClick_);
        this.padIc_.triggerElement = this.view.padButtonElement;
      }
      Point2dPadTextController2.prototype.onPadButtonBlur_ = function(e) {
        var elem = this.view.element;
        var nextTarget = forceCast(e.relatedTarget);
        if (!nextTarget || !elem.contains(nextTarget)) {
          this.padIc_.foldable.expanded = false;
        }
      };
      Point2dPadTextController2.prototype.onPadButtonClick_ = function() {
        this.padIc_.foldable.expanded = !this.padIc_.foldable.expanded;
        if (this.padIc_.foldable.expanded) {
          this.padIc_.view.allFocusableElements[0].focus();
        }
      };
      return Point2dPadTextController2;
    }();
    function point2dFromUnknown(value) {
      return Point2d.isObject(value) ? new Point2d(value.x, value.y) : new Point2d();
    }
    function writePoint2d(target, value) {
      target.writeProperty("x", value.x);
      target.writeProperty("y", value.y);
    }
    function createDimensionConstraint(params) {
      if (!params) {
        return void 0;
      }
      var constraints = [];
      if (!isEmpty(params.step)) {
        constraints.push(new StepConstraint({
          step: params.step
        }));
      }
      if (!isEmpty(params.max) || !isEmpty(params.min)) {
        constraints.push(new RangeConstraint({
          max: params.max,
          min: params.min
        }));
      }
      return new CompositeConstraint({
        constraints
      });
    }
    function createConstraint$2(params) {
      return new Point2dConstraint({
        x: createDimensionConstraint("x" in params ? params.x : void 0),
        y: createDimensionConstraint("y" in params ? params.y : void 0)
      });
    }
    function getSuitableMaxDimensionValue(constraint, rawValue) {
      var rc = constraint && findConstraint(constraint, RangeConstraint);
      if (rc) {
        return Math.max(Math.abs(rc.minValue || 0), Math.abs(rc.maxValue || 0));
      }
      var step = getBaseStep(constraint);
      return Math.max(Math.abs(step) * 10, Math.abs(rawValue) * 10);
    }
    function getSuitableMaxValue(initialValue, constraint) {
      var xc = constraint instanceof Point2dConstraint ? constraint.x : void 0;
      var yc = constraint instanceof Point2dConstraint ? constraint.y : void 0;
      var xr = getSuitableMaxDimensionValue(xc, initialValue.x);
      var yr = getSuitableMaxDimensionValue(yc, initialValue.y);
      return Math.max(xr, yr);
    }
    function createController$4(document2, value, invertsY) {
      var c = value.constraint;
      if (!(c instanceof Point2dConstraint)) {
        throw TpError.shouldNeverHappen();
      }
      return new Point2dPadTextController(document2, {
        axes: [
          {
            baseStep: getBaseStep(c.x),
            formatter: createNumberFormatter(getSuitableDecimalDigits(c.x, value.rawValue.x))
          },
          {
            baseStep: getBaseStep(c.y),
            formatter: createNumberFormatter(getSuitableDecimalDigits(c.y, value.rawValue.y))
          }
        ],
        invertsY,
        maxValue: getSuitableMaxValue(value.rawValue, value.constraint),
        parser: parseNumber,
        value
      });
    }
    function shouldInvertY(params) {
      if (!("y" in params)) {
        return false;
      }
      var yParams = params.y;
      if (!yParams) {
        return false;
      }
      return "inverted" in yParams ? !!yParams.inverted : false;
    }
    var Point2dInputPlugin = {
      id: "input-point2d",
      binding: {
        accept: function(value, _params) {
          return Point2d.isObject(value) ? value : null;
        },
        reader: function(_args) {
          return point2dFromUnknown;
        },
        writer: function(_args) {
          return writePoint2d;
        },
        constraint: function(args) {
          return createConstraint$2(args.params);
        },
        equals: Point2d.equals
      },
      controller: function(args) {
        return createController$4(args.document, args.binding.value, shouldInvertY(args.params));
      }
    };
    var Point3d = function() {
      function Point3d2(x, y, z) {
        if (x === void 0) {
          x = 0;
        }
        if (y === void 0) {
          y = 0;
        }
        if (z === void 0) {
          z = 0;
        }
        this.x = x;
        this.y = y;
        this.z = z;
      }
      Point3d2.prototype.getComponents = function() {
        return [this.x, this.y, this.z];
      };
      Point3d2.isObject = function(obj) {
        if (isEmpty(obj)) {
          return false;
        }
        var x = obj.x;
        var y = obj.y;
        var z = obj.z;
        if (typeof x !== "number" || typeof y !== "number" || typeof z !== "number") {
          return false;
        }
        return true;
      };
      Point3d2.equals = function(v1, v2) {
        return v1.x === v2.x && v1.y === v2.y && v1.z === v2.z;
      };
      Point3d2.prototype.toObject = function() {
        return {
          x: this.x,
          y: this.y,
          z: this.z
        };
      };
      return Point3d2;
    }();
    var Point3dConstraint = function() {
      function Point3dConstraint2(config) {
        this.x = config.x;
        this.y = config.y;
        this.z = config.z;
      }
      Point3dConstraint2.prototype.constrain = function(value) {
        return new Point3d(this.x ? this.x.constrain(value.x) : value.x, this.y ? this.y.constrain(value.y) : value.y, this.z ? this.z.constrain(value.z) : value.z);
      };
      return Point3dConstraint2;
    }();
    var className$l = ClassName("p3dtxt");
    var Point3dTextView = function() {
      function Point3dTextView2(doc, config) {
        var _this = this;
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.formatters_ = config.formatters;
        this.element = doc.createElement("div");
        this.element.classList.add(className$l());
        var inputElems = [0, 1, 2].map(function() {
          var inputElem = doc.createElement("input");
          inputElem.classList.add(className$l("i"));
          inputElem.type = "text";
          return inputElem;
        });
        [0, 1, 2].forEach(function(_, index) {
          var elem = doc.createElement("div");
          elem.classList.add(className$l("w"));
          elem.appendChild(inputElems[index]);
          _this.element.appendChild(elem);
        });
        this.inputElems_ = [inputElems[0], inputElems[1], inputElems[2]];
        config.value.emitter.on("change", this.onValueChange_);
        this.value = config.value;
        this.update();
      }
      Object.defineProperty(Point3dTextView2.prototype, "inputElements", {
        get: function() {
          return this.inputElems_;
        },
        enumerable: false,
        configurable: true
      });
      Point3dTextView2.prototype.update = function() {
        var _this = this;
        var comps = this.value.rawValue.getComponents();
        comps.forEach(function(comp, index) {
          var inputElem = _this.inputElems_[index];
          inputElem.value = _this.formatters_[index](comp);
        });
      };
      Point3dTextView2.prototype.onValueChange_ = function() {
        this.update();
      };
      return Point3dTextView2;
    }();
    var Point3dTextController = function() {
      function Point3dTextController2(doc, config) {
        var _this = this;
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.onInputKeyDown_ = this.onInputKeyDown_.bind(this);
        this.parser_ = config.parser;
        this.value = config.value;
        var axes = config.axes;
        this.baseSteps_ = [axes[0].baseStep, axes[1].baseStep, axes[2].baseStep];
        this.view = new Point3dTextView(doc, {
          formatters: [axes[0].formatter, axes[1].formatter, axes[2].formatter],
          value: this.value
        });
        this.view.inputElements.forEach(function(inputElem) {
          inputElem.addEventListener("change", _this.onInputChange_);
          inputElem.addEventListener("keydown", _this.onInputKeyDown_);
        });
      }
      Point3dTextController2.prototype.findIndexOfInputElem_ = function(inputElem) {
        var inputElems = this.view.inputElements;
        for (var i = 0; i < inputElems.length; i++) {
          if (inputElems[i] === inputElem) {
            return i;
          }
        }
        return null;
      };
      Point3dTextController2.prototype.updateComponent_ = function(index, newValue) {
        var comps = this.value.rawValue.getComponents();
        var newComps = comps.map(function(comp, i) {
          return i === index ? newValue : comp;
        });
        this.value.rawValue = new Point3d(newComps[0], newComps[1], newComps[2]);
        this.view.update();
      };
      Point3dTextController2.prototype.onInputChange_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        var parsedValue = this.parser_(inputElem.value);
        if (isEmpty(parsedValue)) {
          return;
        }
        var compIndex = this.findIndexOfInputElem_(inputElem);
        if (isEmpty(compIndex)) {
          return;
        }
        this.updateComponent_(compIndex, parsedValue);
      };
      Point3dTextController2.prototype.onInputKeyDown_ = function(e) {
        var inputElem = forceCast(e.currentTarget);
        var parsedValue = this.parser_(inputElem.value);
        if (isEmpty(parsedValue)) {
          return;
        }
        var compIndex = this.findIndexOfInputElem_(inputElem);
        if (isEmpty(compIndex)) {
          return;
        }
        var step = getStepForKey(this.baseSteps_[compIndex], getVerticalStepKeys(e));
        if (step === 0) {
          return;
        }
        this.updateComponent_(compIndex, parsedValue + step);
      };
      return Point3dTextController2;
    }();
    function point3dFromUnknown(value) {
      return Point3d.isObject(value) ? new Point3d(value.x, value.y, value.z) : new Point3d();
    }
    function writePoint3d(target, value) {
      target.writeProperty("x", value.x);
      target.writeProperty("y", value.y);
      target.writeProperty("z", value.z);
    }
    function createDimensionConstraint$1(params) {
      if (!params) {
        return void 0;
      }
      var constraints = [];
      if (!isEmpty(params.step)) {
        constraints.push(new StepConstraint({
          step: params.step
        }));
      }
      if (!isEmpty(params.max) || !isEmpty(params.min)) {
        constraints.push(new RangeConstraint({
          max: params.max,
          min: params.min
        }));
      }
      return new CompositeConstraint({
        constraints
      });
    }
    function createConstraint$3(params) {
      return new Point3dConstraint({
        x: createDimensionConstraint$1("x" in params ? params.x : void 0),
        y: createDimensionConstraint$1("y" in params ? params.y : void 0),
        z: createDimensionConstraint$1("z" in params ? params.z : void 0)
      });
    }
    function getAxis(initialValue, constraint) {
      return {
        baseStep: getBaseStep(constraint),
        formatter: createNumberFormatter(getSuitableDecimalDigits(constraint, initialValue))
      };
    }
    function createController$5(document2, value) {
      var c = value.constraint;
      if (!(c instanceof Point3dConstraint)) {
        throw TpError.shouldNeverHappen();
      }
      return new Point3dTextController(document2, {
        axes: [
          getAxis(value.rawValue.x, c.x),
          getAxis(value.rawValue.y, c.y),
          getAxis(value.rawValue.z, c.z)
        ],
        parser: parseNumber,
        value
      });
    }
    var Point3dInputPlugin = {
      id: "input-point3d",
      binding: {
        accept: function(value, _params) {
          return Point3d.isObject(value) ? value : null;
        },
        reader: function(_args) {
          return point3dFromUnknown;
        },
        writer: function(_args) {
          return writePoint3d;
        },
        constraint: function(args) {
          return createConstraint$3(args.params);
        },
        equals: Point3d.equals
      },
      controller: function(args) {
        return createController$5(args.document, args.binding.value);
      }
    };
    function stringFromUnknown(value) {
      return String(value);
    }
    function formatString(value) {
      return value;
    }
    function createConstraint$4(params) {
      var constraints = [];
      if ("options" in params && params.options !== void 0) {
        constraints.push(new ListConstraint({
          options: normalizeInputParamsOptions(params.options, stringFromUnknown)
        }));
      }
      return new CompositeConstraint({
        constraints
      });
    }
    function createController$6(doc, value) {
      var _a;
      var c = value.constraint;
      if (c && findConstraint(c, ListConstraint)) {
        return new ListController(doc, {
          listItems: (_a = findListItems(c)) !== null && _a !== void 0 ? _a : [],
          stringifyValue: function(v) {
            return v;
          },
          value
        });
      }
      return new TextController(doc, {
        formatter: formatString,
        parser: function(v) {
          return v;
        },
        value
      });
    }
    var StringInputPlugin = {
      id: "input-string",
      binding: {
        accept: function(value, _params) {
          return typeof value === "string" ? value : null;
        },
        constraint: function(args) {
          return createConstraint$4(args.params);
        },
        reader: function(_args) {
          return stringFromUnknown;
        },
        writer: function(_args) {
          return writePrimitive;
        }
      },
      controller: function(params) {
        return createController$6(params.document, params.binding.value);
      }
    };
    var className$m = ClassName("mll");
    var MultiLogView = function() {
      function MultiLogView2(doc, config) {
        this.onValueUpdate_ = this.onValueUpdate_.bind(this);
        this.formatter_ = config.formatter;
        this.element = doc.createElement("div");
        this.element.classList.add(className$m());
        var textareaElem = doc.createElement("textarea");
        textareaElem.classList.add(className$m("i"));
        textareaElem.style.height = "calc(var(--unit-size) * " + config.lineCount + ")";
        textareaElem.readOnly = true;
        this.element.appendChild(textareaElem);
        this.textareaElem_ = textareaElem;
        config.value.emitter.on("change", this.onValueUpdate_);
        this.value = config.value;
        this.update();
      }
      MultiLogView2.prototype.update = function() {
        var _this = this;
        var elem = this.textareaElem_;
        var shouldScroll = elem.scrollTop === elem.scrollHeight - elem.clientHeight;
        elem.textContent = this.value.rawValue.map(function(value) {
          return value !== void 0 ? _this.formatter_(value) : "";
        }).join("\n");
        if (shouldScroll) {
          elem.scrollTop = elem.scrollHeight;
        }
      };
      MultiLogView2.prototype.onValueUpdate_ = function() {
        this.update();
      };
      return MultiLogView2;
    }();
    var MultiLogController = function() {
      function MultiLogController2(doc, config) {
        this.value = config.value;
        this.view = new MultiLogView(doc, {
          formatter: config.formatter,
          lineCount: config.lineCount,
          value: this.value
        });
      }
      return MultiLogController2;
    }();
    var className$n = ClassName("sgl");
    var SingleLogView = function() {
      function SingleLogView2(doc, config) {
        this.onValueUpdate_ = this.onValueUpdate_.bind(this);
        this.formatter_ = config.formatter;
        this.element = doc.createElement("div");
        this.element.classList.add(className$n());
        var inputElem = doc.createElement("input");
        inputElem.classList.add(className$n("i"));
        inputElem.readOnly = true;
        inputElem.type = "text";
        this.element.appendChild(inputElem);
        this.inputElem_ = inputElem;
        config.value.emitter.on("change", this.onValueUpdate_);
        this.value = config.value;
        this.update();
      }
      SingleLogView2.prototype.update = function() {
        var values = this.value.rawValue;
        var lastValue = values[values.length - 1];
        this.inputElem_.value = lastValue !== void 0 ? this.formatter_(lastValue) : "";
      };
      SingleLogView2.prototype.onValueUpdate_ = function() {
        this.update();
      };
      return SingleLogView2;
    }();
    var SingleLogMonitorController = function() {
      function SingleLogMonitorController2(doc, config) {
        this.value = config.value;
        this.view = new SingleLogView(doc, {
          formatter: config.formatter,
          value: this.value
        });
      }
      return SingleLogMonitorController2;
    }();
    var BooleanMonitorPlugin = {
      id: "monitor-bool",
      binding: {
        accept: function(value, _params) {
          return typeof value === "boolean" ? value : null;
        },
        reader: function(_args) {
          return boolFromUnknown;
        }
      },
      controller: function(args) {
        var _a;
        if (args.binding.value.rawValue.length === 1) {
          return new SingleLogMonitorController(args.document, {
            formatter: BooleanFormatter,
            value: args.binding.value
          });
        }
        return new MultiLogController(args.document, {
          formatter: BooleanFormatter,
          lineCount: (_a = args.params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
          value: args.binding.value
        });
      }
    };
    var GraphCursor = function() {
      function GraphCursor2() {
        this.emitter = new Emitter();
        this.index_ = -1;
      }
      Object.defineProperty(GraphCursor2.prototype, "index", {
        get: function() {
          return this.index_;
        },
        set: function(index) {
          var changed = this.index_ !== index;
          if (changed) {
            this.index_ = index;
            this.emitter.emit("change", {
              index,
              sender: this
            });
          }
        },
        enumerable: false,
        configurable: true
      });
      return GraphCursor2;
    }();
    var className$o = ClassName("grl");
    var GraphLogView = function() {
      function GraphLogView2(doc, config) {
        this.onCursorChange_ = this.onCursorChange_.bind(this);
        this.onValueUpdate_ = this.onValueUpdate_.bind(this);
        this.element = doc.createElement("div");
        this.element.classList.add(className$o());
        this.formatter_ = config.formatter;
        this.minValue_ = config.minValue;
        this.maxValue_ = config.maxValue;
        this.cursor_ = config.cursor;
        this.cursor_.emitter.on("change", this.onCursorChange_);
        var svgElem = doc.createElementNS(SVG_NS, "svg");
        svgElem.classList.add(className$o("g"));
        svgElem.style.height = "calc(var(--unit-size) * " + config.lineCount + ")";
        this.element.appendChild(svgElem);
        this.svgElem_ = svgElem;
        var lineElem = doc.createElementNS(SVG_NS, "polyline");
        this.svgElem_.appendChild(lineElem);
        this.lineElem_ = lineElem;
        var tooltipElem = doc.createElement("div");
        tooltipElem.classList.add(className$o("t"));
        this.element.appendChild(tooltipElem);
        this.tooltipElem_ = tooltipElem;
        config.value.emitter.on("change", this.onValueUpdate_);
        this.value = config.value;
        this.update();
      }
      Object.defineProperty(GraphLogView2.prototype, "graphElement", {
        get: function() {
          return this.svgElem_;
        },
        enumerable: false,
        configurable: true
      });
      GraphLogView2.prototype.update = function() {
        var bounds = this.svgElem_.getBoundingClientRect();
        var maxIndex = this.value.rawValue.length - 1;
        var min = this.minValue_;
        var max = this.maxValue_;
        var points = [];
        this.value.rawValue.forEach(function(v, index) {
          if (v === void 0) {
            return;
          }
          var x = mapRange(index, 0, maxIndex, 0, bounds.width);
          var y = mapRange(v, min, max, bounds.height, 0);
          points.push([x, y].join(","));
        });
        this.lineElem_.setAttributeNS(null, "points", points.join(" "));
        var tooltipElem = this.tooltipElem_;
        var value = this.value.rawValue[this.cursor_.index];
        if (value === void 0) {
          tooltipElem.classList.remove(className$o("t", "valid"));
          return;
        }
        tooltipElem.classList.add(className$o("t", "valid"));
        var tx = mapRange(this.cursor_.index, 0, maxIndex, 0, bounds.width);
        var ty = mapRange(value, min, max, bounds.height, 0);
        tooltipElem.style.left = tx + "px";
        tooltipElem.style.top = ty + "px";
        tooltipElem.textContent = "" + this.formatter_(value);
      };
      GraphLogView2.prototype.onValueUpdate_ = function() {
        this.update();
      };
      GraphLogView2.prototype.onCursorChange_ = function() {
        this.update();
      };
      return GraphLogView2;
    }();
    var GraphLogController = function() {
      function GraphLogController2(doc, config) {
        this.onGraphMouseLeave_ = this.onGraphMouseLeave_.bind(this);
        this.onGraphMouseMove_ = this.onGraphMouseMove_.bind(this);
        this.value = config.value;
        this.cursor_ = new GraphCursor();
        this.view = new GraphLogView(doc, {
          cursor: this.cursor_,
          formatter: config.formatter,
          lineCount: config.lineCount,
          maxValue: config.maxValue,
          minValue: config.minValue,
          value: this.value
        });
        this.view.element.addEventListener("mouseleave", this.onGraphMouseLeave_);
        this.view.element.addEventListener("mousemove", this.onGraphMouseMove_);
      }
      GraphLogController2.prototype.onGraphMouseLeave_ = function() {
        this.cursor_.index = -1;
      };
      GraphLogController2.prototype.onGraphMouseMove_ = function(e) {
        var bounds = this.view.graphElement.getBoundingClientRect();
        var x = e.offsetX;
        this.cursor_.index = Math.floor(mapRange(x, 0, bounds.width, 0, this.value.rawValue.length));
      };
      return GraphLogController2;
    }();
    function createFormatter() {
      return createNumberFormatter(2);
    }
    function createTextMonitor(document2, binding, params) {
      var _a;
      if (binding.value.rawValue.length === 1) {
        return new SingleLogMonitorController(document2, {
          formatter: createFormatter(),
          value: binding.value
        });
      }
      return new MultiLogController(document2, {
        formatter: createFormatter(),
        lineCount: (_a = params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
        value: binding.value
      });
    }
    function createGraphMonitor(_a) {
      var _b, _c, _d;
      var document2 = _a.document, binding = _a.binding, params = _a.params;
      return new GraphLogController(document2, {
        formatter: createFormatter(),
        lineCount: (_b = params.lineCount) !== null && _b !== void 0 ? _b : Constants.monitor.defaultLineCount,
        maxValue: (_c = "max" in params ? params.max : null) !== null && _c !== void 0 ? _c : 100,
        minValue: (_d = "min" in params ? params.min : null) !== null && _d !== void 0 ? _d : 0,
        value: binding.value
      });
    }
    function shouldShowGraph(params) {
      return "view" in params && params.view === "graph";
    }
    var NumberMonitorPlugin = {
      id: "monitor-number",
      binding: {
        accept: function(value, _params) {
          return typeof value === "number" ? value : null;
        },
        defaultBufferSize: function(params) {
          return shouldShowGraph(params) ? 64 : 1;
        },
        reader: function(_args) {
          return numberFromUnknown;
        }
      },
      controller: function(args) {
        if (shouldShowGraph(args.params)) {
          return createGraphMonitor({
            document: args.document,
            binding: args.binding,
            params: args.params
          });
        }
        return createTextMonitor(args.document, args.binding, args.params);
      }
    };
    var StringMonitorPlugin = {
      id: "monitor-string",
      binding: {
        accept: function(value, _params) {
          return typeof value === "string" ? value : null;
        },
        reader: function(_args) {
          return stringFromUnknown;
        }
      },
      controller: function(args) {
        var _a;
        var value = args.binding.value;
        var multiline = value.rawValue.length > 1 || "multiline" in args.params && args.params.multiline;
        if (multiline) {
          return new MultiLogController(args.document, {
            formatter: formatString,
            lineCount: (_a = args.params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
            value
          });
        }
        return new SingleLogMonitorController(args.document, {
          formatter: formatString,
          value
        });
      }
    };
    function createDefaultWrapperElement(doc) {
      var elem = doc.createElement("div");
      elem.classList.add(ClassName("dfw")());
      if (doc.body) {
        doc.body.appendChild(elem);
      }
      return elem;
    }
    function embedStyle(doc, id, css) {
      if (doc.querySelector("style[data-tp-style=" + id + "]")) {
        return;
      }
      var styleElem = doc.createElement("style");
      styleElem.dataset.tpStyle = id;
      styleElem.textContent = css;
      doc.head.appendChild(styleElem);
    }
    function embedDefaultStyleIfNeeded(doc) {
      embedStyle(doc, "default", ".tp-btnv_b,.tp-lstv_s,.tp-p2dpadtxtv_b,.tp-fldv_t,.tp-rotv_t,.tp-cctxtsv_i,.tp-cswv_sw,.tp-p2dpadv_p,.tp-p2dtxtv_i,.tp-p3dtxtv_i,.tp-txtv_i,.tp-grlv_g,.tp-sglv_i,.tp-mllv_i,.tp-ckbv_i,.tp-cctxtsv_ms{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border-width:0;font-family:inherit;font-size:inherit;font-weight:inherit;margin:0;outline:none;padding:0}.tp-btnv_b,.tp-lstv_s,.tp-p2dpadtxtv_b{background-color:var(--button-background-color);border-radius:2px;color:var(--button-foreground-color);cursor:pointer;display:block;font-weight:bold;height:var(--unit-size);line-height:var(--unit-size);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tp-btnv_b:hover,.tp-lstv_s:hover,.tp-p2dpadtxtv_b:hover{background-color:var(--button-background-color-hover)}.tp-btnv_b:focus,.tp-lstv_s:focus,.tp-p2dpadtxtv_b:focus{background-color:var(--button-background-color-focus)}.tp-btnv_b:active,.tp-lstv_s:active,.tp-p2dpadtxtv_b:active{background-color:var(--button-background-color-active)}.tp-fldv_t,.tp-rotv_t{background-color:var(--folder-background-color);color:var(--folder-foreground-color);cursor:pointer;display:block;height:calc(var(--unit-size) + 4px);line-height:calc(var(--unit-size) + 4px);overflow:hidden;padding-left:28px;position:relative;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%;transition:border-radius .2s ease-in-out .2s}.tp-fldv_t:hover,.tp-rotv_t:hover{background-color:var(--folder-background-color-hover)}.tp-fldv_t:focus,.tp-rotv_t:focus{background-color:var(--folder-background-color-focus)}.tp-fldv_t:active,.tp-rotv_t:active{background-color:var(--folder-background-color-active)}.tp-fldv_m,.tp-rotv_m{background:linear-gradient(to left, var(--folder-foreground-color), var(--folder-foreground-color) 2px, transparent 2px, transparent 4px, var(--folder-foreground-color) 4px);border-radius:2px;bottom:0;content:'';display:block;height:6px;left:13px;margin:auto;opacity:0.5;position:absolute;top:0;transform:rotate(90deg);transition:transform .2s ease-in-out;width:6px}.tp-fldv.tp-fldv-expanded>.tp-fldv_t>.tp-fldv_m,.tp-rotv.tp-rotv-expanded .tp-rotv_m{transform:none}.tp-fldv_c,.tp-rotv_c{box-sizing:border-box;height:0;opacity:0;overflow:hidden;padding-bottom:0;padding-top:0;position:relative;transition:height .2s ease-in-out,opacity .2s linear,padding .2s ease-in-out}.tp-fldv_c>.tp-fldv.tp-v-first,.tp-rotv_c>.tp-fldv.tp-v-first{margin-top:-4px}.tp-fldv_c>.tp-fldv.tp-v-last,.tp-rotv_c>.tp-fldv.tp-v-last{margin-bottom:-4px}.tp-fldv_c>*:not(.tp-v-first),.tp-rotv_c>*:not(.tp-v-first){margin-top:4px}.tp-fldv_c>.tp-fldv:not(.tp-v-hidden)+.tp-fldv,.tp-rotv_c>.tp-fldv:not(.tp-v-hidden)+.tp-fldv{margin-top:0}.tp-fldv_c>.tp-sptv:not(.tp-v-hidden)+.tp-sptv,.tp-rotv_c>.tp-sptv:not(.tp-v-hidden)+.tp-sptv{margin-top:0}.tp-fldv.tp-fldv-expanded>.tp-fldv_c,.tp-rotv.tp-rotv-expanded .tp-rotv_c{opacity:1;padding-bottom:4px;padding-top:4px;transform:none;overflow:visible;transition:height .2s ease-in-out,opacity .2s linear .2s,padding .2s ease-in-out}.tp-cctxtsv_i,.tp-cswv_sw,.tp-p2dpadv_p,.tp-p2dtxtv_i,.tp-p3dtxtv_i,.tp-txtv_i{background-color:var(--input-background-color);border-radius:2px;box-sizing:border-box;color:var(--input-foreground-color);font-family:inherit;height:var(--unit-size);line-height:var(--unit-size);min-width:0;width:100%}.tp-cctxtsv_i:hover,.tp-cswv_sw:hover,.tp-p2dpadv_p:hover,.tp-p2dtxtv_i:hover,.tp-p3dtxtv_i:hover,.tp-txtv_i:hover{background-color:var(--input-background-color-hover)}.tp-cctxtsv_i:focus,.tp-cswv_sw:focus,.tp-p2dpadv_p:focus,.tp-p2dtxtv_i:focus,.tp-p3dtxtv_i:focus,.tp-txtv_i:focus{background-color:var(--input-background-color-focus)}.tp-cctxtsv_i:active,.tp-cswv_sw:active,.tp-p2dpadv_p:active,.tp-p2dtxtv_i:active,.tp-p3dtxtv_i:active,.tp-txtv_i:active{background-color:var(--input-background-color-active)}.tp-grlv_g,.tp-sglv_i,.tp-mllv_i{background-color:var(--monitor-background-color);border-radius:2px;box-sizing:border-box;color:var(--monitor-foreground-color);height:var(--unit-size);width:100%}.tp-btnv{padding:0 4px}.tp-btnv_b{width:100%}.tp-ckbv_l{display:block;position:relative}.tp-ckbv_i{left:0;opacity:0;position:absolute;top:0}.tp-ckbv_m{background-color:var(--input-background-color);border-radius:2px;cursor:pointer;display:block;height:var(--unit-size);position:relative;width:var(--unit-size)}.tp-ckbv_m::before{background-color:var(--input-foreground-color);border-radius:2px;bottom:4px;content:'';display:block;left:4px;opacity:0;position:absolute;right:4px;top:4px}.tp-ckbv_i:hover+.tp-ckbv_m{background-color:var(--input-background-color-hover)}.tp-ckbv_i:focus+.tp-ckbv_m{background-color:var(--input-background-color-focus)}.tp-ckbv_i:active+.tp-ckbv_m{background-color:var(--input-background-color-active)}.tp-ckbv_i:checked+.tp-ckbv_m::before{opacity:1}.tp-cctxtsv{display:flex;width:100%}.tp-cctxtsv_m{margin-right:4px;position:relative}.tp-cctxtsv_ms{border-radius:2px;color:var(--label-foreground-color);cursor:pointer;height:var(--unit-size);line-height:var(--unit-size);padding:0 18px 0 4px}.tp-cctxtsv_ms:hover{background-color:var(--input-background-color-hover)}.tp-cctxtsv_ms:focus{background-color:var(--input-background-color-focus)}.tp-cctxtsv_ms:active{background-color:var(--input-background-color-active)}.tp-cctxtsv_mm{border-color:var(--label-foreground-color) transparent transparent;border-style:solid;border-width:3px;box-sizing:border-box;height:6px;pointer-events:none;width:6px;bottom:0;margin:auto;position:absolute;right:6px;top:3px}.tp-cctxtsv_w{display:flex;flex:1}.tp-cctxtsv_i{border-radius:0;flex:1;padding:0 4px}.tp-cctxtsv_i:first-child{border-bottom-left-radius:2px;border-top-left-radius:2px}.tp-cctxtsv_i:last-child{border-bottom-right-radius:2px;border-top-right-radius:2px}.tp-cctxtsv_i+.tp-cctxtsv_i{margin-left:2px}.tp-clpv{background-color:var(--base-background-color);border-radius:6px;box-shadow:0 2px 4px var(--base-shadow-color);display:none;padding:4px;position:relative;visibility:hidden;z-index:1000}.tp-clpv.tp-clpv-expanded{display:block;visibility:visible}.tp-clpv_h,.tp-clpv_ap{margin-left:6px;margin-right:6px}.tp-clpv_h{margin-top:4px}.tp-clpv_rgb{display:flex;margin-top:4px;width:100%}.tp-clpv_a{display:flex;margin-top:4px;padding-top:8px;position:relative}.tp-clpv_a:before{background-color:var(--separator-color);content:'';height:4px;left:-4px;position:absolute;right:-4px;top:0}.tp-clpv_ap{align-items:center;display:flex;flex:3}.tp-clpv_at{flex:1;margin-left:4px}.tp-svpv{border-radius:2px;outline:none;overflow:hidden;position:relative}.tp-svpv_c{cursor:crosshair;display:block;height:80px;width:100%}.tp-svpv_m{border-radius:100%;border:rgba(255,255,255,0.75) solid 2px;box-sizing:border-box;filter:drop-shadow(0 0 1px rgba(0,0,0,0.3));height:12px;margin-left:-6px;margin-top:-6px;pointer-events:none;position:absolute;width:12px}.tp-svpv:focus .tp-svpv_m{border-color:#fff}.tp-hplv{cursor:pointer;height:var(--unit-size);outline:none;position:relative}.tp-hplv_c{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAABCAYAAABubagXAAAAQ0lEQVQoU2P8z8Dwn0GCgQEDi2OK/RBgYHjBgIpfovFh8j8YBIgzFGQxuqEgPhaDOT5gOhPkdCxOZeBg+IDFZZiGAgCaSSMYtcRHLgAAAABJRU5ErkJggg==);background-position:left top;background-repeat:no-repeat;background-size:100% 100%;border-radius:2px;display:block;height:4px;left:0;margin-top:-2px;position:absolute;top:50%;width:100%}.tp-hplv_m{border-radius:2px;border:rgba(255,255,255,0.75) solid 2px;box-shadow:0 0 2px rgba(0,0,0,0.1);box-sizing:border-box;height:12px;left:50%;margin-left:-6px;margin-top:-6px;pointer-events:none;position:absolute;top:50%;width:12px}.tp-hplv:focus .tp-hplv_m{border-color:#fff}.tp-aplv{cursor:pointer;height:var(--unit-size);outline:none;position:relative;width:100%}.tp-aplv_b{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:4px 4px;background-position:0 0,2px 2px;border-radius:2px;display:block;height:4px;left:0;margin-top:-2px;overflow:hidden;position:absolute;top:50%;width:100%}.tp-aplv_c{bottom:0;left:0;position:absolute;right:0;top:0}.tp-aplv_m{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:12px 12px;background-position:0 0,6px 6px;border-radius:2px;box-shadow:0 0 2px rgba(0,0,0,0.1);height:12px;left:50%;margin-left:-6px;margin-top:-6px;overflow:hidden;pointer-events:none;position:absolute;top:50%;width:12px}.tp-aplv_p{border-radius:2px;border:rgba(255,255,255,0.75) solid 2px;box-sizing:border-box;bottom:0;left:0;position:absolute;right:0;top:0}.tp-aplv:focus .tp-aplv_p{border-color:#fff}.tp-cswv{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:10px 10px;background-position:0 0,5px 5px;border-radius:2px}.tp-cswv_b{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border-width:0;cursor:pointer;display:block;height:var(--unit-size);left:0;margin:0;outline:none;padding:0;position:absolute;top:0;width:var(--unit-size)}.tp-cswv_b:focus::after{border:rgba(255,255,255,0.75) solid 2px;border-radius:2px;bottom:0;content:'';display:block;left:0;position:absolute;right:0;top:0}.tp-cswv_p{left:-4px;position:absolute;right:-4px;top:var(--unit-size)}.tp-cswtxtv{display:flex;position:relative}.tp-cswtxtv_s{flex-grow:0;flex-shrink:0;width:var(--unit-size)}.tp-cswtxtv_t{flex:1;margin-left:4px}.tp-dfwv{position:absolute;top:8px;right:8px;width:256px}.tp-fldv.tp-fldv-expanded .tp-fldv_t{transition:border-radius 0s}.tp-fldv_c{border-left:var(--folder-background-color) solid 4px}.tp-fldv_t:hover+.tp-fldv_c{border-left-color:var(--folder-background-color-hover)}.tp-fldv_t:focus+.tp-fldv_c{border-left-color:var(--folder-background-color-focus)}.tp-fldv_t:active+.tp-fldv_c{border-left-color:var(--folder-background-color-active)}.tp-fldv_c>.tp-fldv{margin-left:4px}.tp-fldv_c>.tp-fldv>.tp-fldv_t{border-top-left-radius:2px;border-bottom-left-radius:2px}.tp-fldv_c>.tp-fldv.tp-fldv-expanded>.tp-fldv_t{border-bottom-left-radius:0}.tp-fldv_c .tp-fldv>.tp-fldv_c{border-bottom-left-radius:2px}.tp-grlv{position:relative}.tp-grlv_g{display:block;height:calc(var(--unit-size) * 3)}.tp-grlv_g polyline{fill:none;stroke:var(--monitor-foreground-color);stroke-linejoin:round}.tp-grlv_t{color:var(--monitor-foreground-color);font-size:0.9em;left:0;pointer-events:none;position:absolute;text-indent:4px;top:0;visibility:hidden}.tp-grlv_t.tp-grlv_t-valid{visibility:visible}.tp-grlv_t::before{background-color:var(--monitor-foreground-color);border-radius:100%;content:'';display:block;height:4px;left:-2px;position:absolute;top:-2px;width:4px}.tp-lblv{align-items:center;display:flex;line-height:1.3;padding-left:4px;padding-right:4px}.tp-lblv_l{color:var(--label-foreground-color);flex:1;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto;overflow:hidden;padding-left:4px;padding-right:16px}.tp-lblv_v{align-self:flex-start;flex-grow:0;flex-shrink:0;width:160px}.tp-lstv{position:relative}.tp-lstv_s{padding:0 18px 0 4px;width:100%}.tp-lstv_m{border-color:var(--button-foreground-color) transparent transparent;border-style:solid;border-width:3px;box-sizing:border-box;height:6px;pointer-events:none;width:6px;bottom:0;margin:auto;position:absolute;right:6px;top:3px}.tp-sglv_i{padding:0 4px}.tp-mllv_i{display:block;height:calc(var(--unit-size) * 3);line-height:var(--unit-size);padding:0 4px;resize:none;white-space:pre}.tp-p2dpadv{background-color:var(--base-background-color);border-radius:6px;box-shadow:0 2px 4px var(--base-shadow-color);display:none;padding:4px 4px 4px calc(4px * 2 + var(--unit-size));position:relative;visibility:hidden;z-index:1000}.tp-p2dpadv.tp-p2dpadv-expanded{display:block;visibility:visible}.tp-p2dpadv_p{cursor:crosshair;height:0;overflow:hidden;padding-bottom:100%;position:relative}.tp-p2dpadv_g{display:block;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.tp-p2dpadv_ax{stroke:var(--input-guide-color)}.tp-p2dpadv_l{stroke:var(--input-foreground-color);stroke-linecap:round;stroke-dasharray:1px 3px}.tp-p2dpadv_m{fill:var(--input-foreground-color)}.tp-p2dpadtxtv{display:flex;position:relative}.tp-p2dpadtxtv_b{height:var(--unit-size);position:relative;width:var(--unit-size)}.tp-p2dpadtxtv_b svg{display:block;height:16px;left:50%;margin-left:-8px;margin-top:-8px;position:absolute;top:50%;width:16px}.tp-p2dpadtxtv_p{left:-4px;position:absolute;right:-4px;top:var(--unit-size)}.tp-p2dpadtxtv_t{margin-left:4px}.tp-p2dtxtv{display:flex}.tp-p2dtxtv_w{align-items:center;display:flex}.tp-p2dtxtv_w+.tp-p2dtxtv_w{margin-left:2px}.tp-p2dtxtv_i{padding:0 4px;width:100%}.tp-p2dtxtv_w:nth-child(1) .tp-p2dtxtv_i{border-top-right-radius:0;border-bottom-right-radius:0}.tp-p2dtxtv_w:nth-child(2) .tp-p2dtxtv_i{border-top-left-radius:0;border-bottom-left-radius:0}.tp-p3dtxtv{display:flex}.tp-p3dtxtv_w{align-items:center;display:flex}.tp-p3dtxtv_w+.tp-p3dtxtv_w{margin-left:2px}.tp-p3dtxtv_i{padding:0 4px;width:100%}.tp-p3dtxtv_w:first-child .tp-p3dtxtv_i{border-top-right-radius:0;border-bottom-right-radius:0}.tp-p3dtxtv_w:not(:first-child):not(:last-child) .tp-p3dtxtv_i{border-radius:0}.tp-p3dtxtv_w:last-child .tp-p3dtxtv_i{border-top-left-radius:0;border-bottom-left-radius:0}.tp-rotv{--font-family: var(--tp-font-family, Roboto Mono,Source Code Pro,Menlo,Courier,monospace);--unit-size: var(--tp-unit-size, 20px);--base-background-color: var(--tp-base-background-color, #2f3137);--base-shadow-color: var(--tp-base-shadow-color, rgba(0,0,0,0.2));--button-background-color: var(--tp-button-background-color, #adafb8);--button-background-color-active: var(--tp-button-background-color-active, #d6d7db);--button-background-color-focus: var(--tp-button-background-color-focus, #c8cad0);--button-background-color-hover: var(--tp-button-background-color-hover, #bbbcc4);--button-foreground-color: var(--tp-button-foreground-color, #2f3137);--folder-background-color: var(--tp-folder-background-color, rgba(200,202,208,0.1));--folder-background-color-active: var(--tp-folder-background-color-active, rgba(200,202,208,0.25));--folder-background-color-focus: var(--tp-folder-background-color-focus, rgba(200,202,208,0.2));--folder-background-color-hover: var(--tp-folder-background-color-hover, rgba(200,202,208,0.15));--folder-foreground-color: var(--tp-folder-foreground-color, #c8cad0);--input-background-color: var(--tp-input-background-color, rgba(200,202,208,0.1));--input-background-color-active: var(--tp-input-background-color-active, rgba(200,202,208,0.25));--input-background-color-focus: var(--tp-input-background-color-focus, rgba(200,202,208,0.2));--input-background-color-hover: var(--tp-input-background-color-hover, rgba(200,202,208,0.15));--input-foreground-color: var(--tp-input-foreground-color, #c8cad0);--input-guide-color: var(--tp-input-guide-color, rgba(47,49,55,0.5));--label-foreground-color: var(--tp-label-foreground-color, rgba(200,202,208,0.7));--monitor-background-color: var(--tp-monitor-background-color, #26272c);--monitor-foreground-color: var(--tp-monitor-foreground-color, rgba(200,202,208,0.7));--separator-color: var(--tp-separator-color, #26272c)}.tp-rotv{background-color:var(--base-background-color);border-radius:6px;box-shadow:0 2px 4px var(--base-shadow-color);font-family:var(--font-family);font-size:11px;font-weight:500;line-height:1;text-align:left}.tp-rotv_t{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top-left-radius:6px;border-top-right-radius:6px}.tp-rotv.tp-rotv-expanded .tp-rotv_t{border-bottom-left-radius:0;border-bottom-right-radius:0}.tp-rotv_m{transition:none}.tp-rotv_c>.tp-fldv:last-child>.tp-fldv_c{border-bottom-left-radius:6px;border-bottom-right-radius:6px}.tp-rotv_c>.tp-fldv:last-child:not(.tp-fldv-expanded)>.tp-fldv_t{border-bottom-left-radius:6px;border-bottom-right-radius:6px}.tp-rotv_c>.tp-fldv:first-child>.tp-fldv_t{border-top-left-radius:6px;border-top-right-radius:6px}.tp-sptv_r{background-color:var(--separator-color);border-width:0;display:block;height:4px;margin:0;width:100%}.tp-sldv_o{box-sizing:border-box;cursor:pointer;height:var(--unit-size);margin:0 6px;outline:none;position:relative}.tp-sldv_o::before{background-color:var(--input-background-color);border-radius:1px;bottom:0;content:'';display:block;height:2px;left:0;margin:auto;position:absolute;right:0;top:0}.tp-sldv_i{height:100%;left:0;position:absolute;top:0}.tp-sldv_i::before{background-color:var(--button-background-color);border-radius:2px;bottom:0;content:'';display:block;height:12px;margin:auto;position:absolute;right:-6px;top:0;width:12px}.tp-sldv_o:hover .tp-sldv_i::before{background-color:var(--button-background-color-hover)}.tp-sldv_o:focus .tp-sldv_i::before{background-color:var(--button-background-color-focus)}.tp-sldv_o:active .tp-sldv_i::before{background-color:var(--button-background-color-active)}.tp-sldtxtv{display:flex}.tp-sldtxtv_s{flex:2}.tp-sldtxtv_t{flex:1;margin-left:4px}.tp-txtv_i{padding:0 4px}.tp-v-hidden{display:none}");
      getAllPlugins().forEach(function(plugin) {
        if (plugin.css) {
          embedStyle(doc, "plugin-" + plugin.id, plugin.css);
        }
      });
    }
    var Tweakpane2 = function(_super) {
      __extends(Tweakpane3, _super);
      function Tweakpane3(opt_config) {
        var _a;
        var _this = this;
        var config = opt_config || {};
        var doc = (_a = config.document) !== null && _a !== void 0 ? _a : getWindowDocument();
        var rootController = new RootController(doc, {
          expanded: config.expanded,
          blade: new Blade(),
          title: config.title
        });
        _this = _super.call(this, rootController) || this;
        _this.containerElem_ = config.container || createDefaultWrapperElement(doc);
        _this.containerElem_.appendChild(_this.element);
        _this.doc_ = doc;
        _this.usesDefaultWrapper_ = !config.container;
        embedDefaultStyleIfNeeded(_this.document);
        return _this;
      }
      Object.defineProperty(Tweakpane3.prototype, "document", {
        get: function() {
          if (!this.doc_) {
            throw TpError.alreadyDisposed();
          }
          return this.doc_;
        },
        enumerable: false,
        configurable: true
      });
      Tweakpane3.prototype.dispose = function() {
        var containerElem = this.containerElem_;
        if (!containerElem) {
          throw TpError.alreadyDisposed();
        }
        if (this.usesDefaultWrapper_) {
          var parentElem = containerElem.parentElement;
          if (parentElem) {
            parentElem.removeChild(containerElem);
          }
        }
        this.containerElem_ = null;
        this.doc_ = null;
        _super.prototype.dispose.call(this);
      };
      return Tweakpane3;
    }(RootApi);
    function registerDefaultPlugins() {
      [
        Point2dInputPlugin,
        Point3dInputPlugin,
        StringInputPlugin,
        NumberInputPlugin,
        StringColorInputPlugin,
        ObjectColorInputPlugin,
        NumberColorInputPlugin,
        BooleanInputPlugin
      ].forEach(function(p) {
        RootApi.registerPlugin({
          type: "input",
          plugin: p
        });
      });
      [BooleanMonitorPlugin, StringMonitorPlugin, NumberMonitorPlugin].forEach(function(p) {
        RootApi.registerPlugin({
          type: "monitor",
          plugin: p
        });
      });
    }
    registerDefaultPlugins();
    return Tweakpane2;
  });
})(tweakpane);
var Tweakpane = tweakpane.exports;
var stats_min = { exports: {} };
(function(module, exports) {
  (function(f, e) {
    module.exports = e();
  })(commonjsGlobal, function() {
    var f = function() {
      function e(a2) {
        c.appendChild(a2.dom);
        return a2;
      }
      function u(a2) {
        for (var d = 0; d < c.children.length; d++)
          c.children[d].style.display = d === a2 ? "block" : "none";
        l = a2;
      }
      var l = 0, c = document.createElement("div");
      c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
      c.addEventListener("click", function(a2) {
        a2.preventDefault();
        u(++l % c.children.length);
      }, false);
      var k = (performance || Date).now(), g = k, a = 0, r = e(new f.Panel("FPS", "#0ff", "#002")), h = e(new f.Panel("MS", "#0f0", "#020"));
      if (self.performance && self.performance.memory)
        var t = e(new f.Panel("MB", "#f08", "#201"));
      u(0);
      return { REVISION: 16, dom: c, addPanel: e, showPanel: u, begin: function() {
        k = (performance || Date).now();
      }, end: function() {
        a++;
        var c2 = (performance || Date).now();
        h.update(c2 - k, 200);
        if (c2 > g + 1e3 && (r.update(1e3 * a / (c2 - g), 100), g = c2, a = 0, t)) {
          var d = performance.memory;
          t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576);
        }
        return c2;
      }, update: function() {
        k = this.end();
      }, domElement: c, setMode: u };
    };
    f.Panel = function(e, f2, l) {
      var c = Infinity, k = 0, g = Math.round, a = g(window.devicePixelRatio || 1), r = 80 * a, h = 48 * a, t = 3 * a, v = 2 * a, d = 3 * a, m = 15 * a, n = 74 * a, p = 30 * a, q = document.createElement("canvas");
      q.width = r;
      q.height = h;
      q.style.cssText = "width:80px;height:48px";
      var b = q.getContext("2d");
      b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
      b.textBaseline = "top";
      b.fillStyle = l;
      b.fillRect(0, 0, r, h);
      b.fillStyle = f2;
      b.fillText(e, t, v);
      b.fillRect(d, m, n, p);
      b.fillStyle = l;
      b.globalAlpha = 0.9;
      b.fillRect(d, m, n, p);
      return { dom: q, update: function(h2, w) {
        c = Math.min(c, h2);
        k = Math.max(k, h2);
        b.fillStyle = l;
        b.globalAlpha = 1;
        b.fillRect(0, 0, r, m);
        b.fillStyle = f2;
        b.fillText(g(h2) + " " + e + " (" + g(c) + "-" + g(k) + ")", t, v);
        b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
        b.fillRect(d + n - a, m, a, p);
        b.fillStyle = l;
        b.globalAlpha = 0.9;
        b.fillRect(d + n - a, m, a, g((1 - h2 / w) * p));
      } };
    };
    return f;
  });
})(stats_min);
var Stats = stats_min.exports;
class Debug {
  constructor(renderer) {
    this.pane = new Tweakpane();
    this.init();
    this.layers = [];
    this.configLayers = [];
    this.renderer = renderer;
    this.sectionLayerTitle = null;
  }
  init() {
    this.stats = new Stats();
    this.stats.domElement.style.cssText = "position: fixed; bottom: 0px; left: 0px; cursor: pointer; opacity: 0.9; z-index: 10000;";
    this.sidebar = document.createElement("div");
    this.sidebar.classList.add("debug-sidebar");
    document.body.classList.add("is-debug");
    document.body.appendChild(this.sidebar);
    document.body.appendChild(this.stats.dom);
    this.stats.showPanel(0);
    this.toggles = [];
    this.layers = [];
    this.buttonClass = "debug-sidebar-button";
    this.buttonHTML = "\u2192";
    this.createIntro();
    this.createEventsInfo();
    this.createMarkerInfo();
    this.createDebugPanel();
  }
  createText(string, tag, append = true) {
    const node = document.createElement(tag);
    node.innerHTML = string;
    if (append)
      this.sidebar.appendChild(node);
    return node;
  }
  createCodeBlock(code, lang = "javascript", append = true) {
    const html = Prism.highlight(code, Prism.languages[lang], lang);
    const node = document.createElement("div");
    node.innerHTML = `
            <div class="debug-sidebar-layer-code">
                <pre class="language-${lang}"><code class="language-${lang}">${html}</code></pre>
            </div>
        `;
    if (append)
      this.sidebar.appendChild(node);
    return node;
  }
  loadBlock(slug) {
    const codeBlock = this.createCodeBlock(`renderer.load('${slug}');`);
    codeBlock.addEventListener("click", () => this.renderer.load(slug));
  }
  createIntro() {
    this.createText("Renderer Documentation", "h1");
    this.createText("init", "h2");
    this.createText(
      "The renderer component needs 2 arguments. The argument <strong>container</strong> requires a dom element and <strong>dir</strong> is the directory of the assets (models & draco loader).",
      "p"
    );
    this.createCodeBlock(`import { Renderer } from './renderer/js/';

const container = document.querySelector('.container');
const renderer = new Renderer({
    container: container,
    dir: './',
    lang: nl,
    country: 'nl',
});`);
    this.createText("load", "h2");
    this.createText("Load model with slug.", "p");
    this.createText("general", "h3");
    this.loadBlock("dollhouse");
    this.createText("toit en pente", "h3");
    this.loadBlock("hellend-dak-overview_fr");
    this.loadBlock("hellend-dak-dakvlak_fr");
    this.loadBlock("hellend-dak-kilgoot_fr");
    this.loadBlock("hellend-dak-voetbalk_fr");
    this.loadBlock("hellend-dak-schouw_fr");
    this.loadBlock("hellend-dak-dakraam_fr");
    this.loadBlock("hellend-dak-nok_fr");
    this.createText("sol", "h3");
    this.loadBlock("vloer_overview_dalleportee_fr");
    this.loadBlock("vloer_overview_souschape_fr");
    this.loadBlock("vloer_overview_sousdallage_fr");
    this.loadBlock("vloer_vloervlak_dalleportee_fr");
    this.loadBlock("vloer_vloervlak_souschape_fr");
    this.loadBlock("vloer_vloervlak_sousdallage_fr");
    this.loadBlock("vloer_muuraansluiting_dalleportee_fr");
    this.loadBlock("vloer_muuraansluiting_souschape_fr");
    this.loadBlock("vloer_muuraansluiting_sousdallage_fr");
    this.createText("floor", "h3");
    this.loadBlock("vloer-overview");
    this.loadBlock("vloer-vloervlak");
    this.loadBlock("vloer-muuraansluiting");
    this.createText("ventilated wall", "h3");
    this.loadBlock("ventgevel-overview");
    this.loadBlock("ventgevel-gevelvlak");
    this.loadBlock("ventgevel-raamaansluiting");
    this.loadBlock("ventgevel-muurvoet");
    this.loadBlock("ventgevel-muuraansluiting");
    this.createText("sloped roof", "h3");
    this.loadBlock("hellend-dak-overview");
    this.loadBlock("hellend-dak-dakvlak");
    this.loadBlock("hellend-dak-kilgoot");
    this.loadBlock("hellend-dak-voetbalk");
    this.loadBlock("hellend-dak-schouw");
    this.loadBlock("hellend-dak-dakraam");
    this.loadBlock("hellend-dak-nok");
    this.createText("cavity wall", "h3");
    this.loadBlock("spouwmuur-overview");
    this.loadBlock("spouwmuur-plat-dak");
    this.loadBlock("spouwmuur-raamaansluiting");
    this.loadBlock("spouwmuur-muurvoet");
    this.loadBlock("spouwmuur-hellend-dak");
    this.loadBlock("spouwmuur-gevelvlak");
    this.createText("flat roof", "h3");
    this.loadBlock("platdak-overview");
    this.loadBlock("platdak-binnenhoek");
    this.loadBlock("platdak-buitenhoek");
    this.loadBlock("platdak-dakdoorvoer");
    this.loadBlock("platdak-dakopstand");
    this.loadBlock("platdak-dakopstand-horizontal");
    this.loadBlock("platdak-dakopstand-vertical");
    this.loadBlock("platdak-dakvlak");
    this.loadBlock("platdak-koepel");
    this.loadBlock("platdak-opgaandeMuur-brick");
    this.loadBlock("platdak-opgaandeMuur-concrete");
    this.loadBlock("platdak-waterafvoer-horizontal");
    this.loadBlock("platdak-waterafvoer-vertical");
    this.loadBlock("platdak-zettingsvoeg");
    this.createText("Load function returns a promise.", "p");
    this.createCodeBlock(`async function testLoad() {
    await renderer.load('platdak');
    // when model is loaded
    console.log('loaded');
}`);
  }
  createLayers(layers2, layerType) {
    if (this.sectionLayerTitle === null) {
      this.sectionLayerTitle = this.createText("setLayer", "h2");
      const sectionLayerText = this.createText(
        "Set layer and hide all other layers in the same layer group.",
        "p"
      );
      this.configLayers.push(this.sectionLayerTitle);
      this.configLayers.push(sectionLayerText);
    }
    const sidebarPart = document.createElement("div");
    sidebarPart.classList.add("debug-sidebar-part");
    const partTitle = this.createText(layerType, "h3", false);
    sidebarPart.appendChild(partTitle);
    this.configLayers.push(sidebarPart);
    layers2.forEach((layer) => {
      const sidebarLayer = this.createCodeBlock(
        `renderer.setLayer('${layerType}', '${layer}')`,
        "javascript",
        false
      );
      sidebarLayer.classList.add("debug-sidebar-layer");
      sidebarLayer.addEventListener("click", () => this.renderer.setLayer(layerType, layer));
      this.layers.push(sidebarLayer);
      sidebarPart.appendChild(sidebarLayer);
    });
    this.sidebar.appendChild(sidebarPart);
  }
  clear() {
    this.configLayers.forEach((node) => {
      node.remove();
    });
    this.sectionLayerTitle = null;
    this.toggles = [];
    this.layers = [];
  }
  createConfigInfo(settings2) {
    this.createText("Config", "h2");
    this.createText(
      "The config for each model should have the exact same name and location as the models. So if you are loading <strong>platdak.gltf</strong>, there should be a <strong>platdak.json</strong> in the same directory.",
      "p"
    );
    this.createCodeBlock(`${JSON.stringify(settings2, null, 2)}`);
  }
  createEventsInfo() {
    this.createText("renderer.events", "h2");
    this.createCodeBlock(`renderer.events.on('LOAD', (id) => console.log(id))`);
    this.createCodeBlock(`renderer.events.on('MARKER_CLICK', (id) => console.log(id))`);
    this.createCodeBlock(
      `renderer.events.on('MARKER_TOGGLE', ({ toggle, layerType }) => console.log({ toggle, layerType }))`
    );
  }
  createMarkerInfo() {
    this.createText("markers.toggle", "h2");
    const codeBlock = this.createCodeBlock(`renderer.markers.toggle();`);
    codeBlock.addEventListener("click", () => this.renderer.markers.toggle());
    const codeBlock2 = this.createCodeBlock(`renderer.markers.toggle(true);`);
    codeBlock2.addEventListener("click", () => this.renderer.markers.toggle(true));
    const codeBlock3 = this.createCodeBlock(`renderer.markers.toggle(false);`);
    codeBlock3.addEventListener("click", () => this.renderer.markers.toggle(false));
    this.createText("onMarkerClick", "h2");
    this.createText(
      "Run function on marker click event. Does not apply for 'layer' makers. Use 'all' to target all markers or use slug to overwrite specific marker.",
      "p"
    );
    this.createCodeBlock(`renderer.onMarkerClick('all', (markerInfo) => {
    console.dir(markerInfo);
});
`);
    this.createText("setMarkerLayer", "h2");
    this.createText(
      "Add layer to layer marker by slug and run function on marker layer click",
      "p"
    );
    this.createCodeBlock(`renderer.setMarkerLayer('Koepel', {
    label: 'Toplaag 1',
    onClick: (layerInfo) => {
        console.log(layerInfo);
    },
});`);
  }
  createToggles(toggles) {
    if (!toggles.length)
      return;
    const sidebarPart = document.createElement("div");
    sidebarPart.classList.add("debug-sidebar-part");
    const title = this.createText("toggle", "h2");
    const text = this.createText("Toggle visibility of layers with no layer group.", "p");
    this.configLayers.push(title);
    this.configLayers.push(text);
    toggles.forEach((layer) => {
      this.createCodeBlock(`renderer.toggle('${layer}')`, "javascript", false);
      const sidebarLayer = this.createCodeBlock(`renderer.toggle('${layer}')`);
      sidebarLayer.classList.add("debug-sidebar-layer");
      sidebarLayer.classList.add("debug-sidebar-toggle");
      sidebarLayer.addEventListener("click", () => this.renderer.toggle(layer));
      sidebarLayer.toggleID = layer;
      this.toggles.push(sidebarLayer);
      this.configLayers.push(sidebarLayer);
      sidebarPart.appendChild(sidebarLayer);
    });
    this.configLayers.push(sidebarPart);
    this.sidebar.appendChild(sidebarPart);
  }
  updateGUI(type, options) {
    if (type === "toggle") {
      this.toggles.forEach((toggle2) => {
        if (toggle2.toggleID === options.id)
          toggle2.classList.toggle("is-visible", options.visible);
      });
    }
  }
  createDebugPanel() {
    const sceneFolder = this.pane.addFolder({
      title: "Scene",
      expanded: false
    });
    sceneFolder.addInput(Store, "background", { label: "Background Color" }).on("change", (value) => {
      this.renderer.renderer.setClearColor(
        new Color(
          `rgb(${parseInt(value.r)}, ${parseInt(value.g)}, ${parseInt(value.b)})`
        )
      );
    });
    const ambientLightF = this.pane.addFolder({
      title: "Ambient light",
      expanded: false
    });
    const directionalLightF = this.pane.addFolder({
      title: "Directional light",
      expanded: false
    });
    const environmentF = this.pane.addFolder({
      title: "Environment",
      expanded: false
    });
    const floorF = this.pane.addFolder({ title: "Floor", expanded: false });
    const windowsF = this.pane.addFolder({ title: "Windows", expanded: false });
    directionalLightF.addInput(Store.directionalLight, "color", { label: "Color" }).on("change", (value) => {
      this.renderer.directionalLight.color = new Color(
        `rgb(${parseInt(value.r)}, ${parseInt(value.g)}, ${parseInt(value.b)})`
      );
    });
    directionalLightF.addInput(Store.directionalLight, "radius", {
      min: 0,
      max: 1e3
    }).on("change", (value) => {
      this.renderer.directionalLight.shadow.radius = value;
    });
    directionalLightF.addInput(Store.directionalLight, "intensity", {
      label: "Intensity",
      min: 0,
      max: 100
    }).on("change", (value) => {
      this.renderer.directionalLight.intensity = value;
    });
    directionalLightF.addInput(Store.directionalLight.position, "x", {
      min: -20,
      max: 20
    }).on("change", (value) => {
      this.renderer.directionalLight.position.x = value;
    });
    directionalLightF.addInput(Store.directionalLight.position, "y", {
      min: -20,
      max: 20
    }).on("change", (value) => {
      this.renderer.directionalLight.position.y = value;
    });
    directionalLightF.addInput(Store.directionalLight.position, "z", {
      min: -20,
      max: 20
    }).on("change", (value) => {
      this.renderer.directionalLight.position.z = value;
    });
    directionalLightF.addInput(Store.directionalLight, "shadowScale", {
      min: 0,
      max: 100
    }).on("change", (value) => {
      this.renderer.directionalLight.shadow.camera.left = -value;
      this.renderer.directionalLight.shadow.camera.bottom = -value;
      this.renderer.directionalLight.shadow.camera.top = value;
      this.renderer.directionalLight.shadow.camera.right = value;
      this.renderer.directionalLight.shadow.camera.updateProjectionMatrix();
    });
    directionalLightF.addInput(Store.directionalLight, "normalBias", {
      min: 0,
      max: 0.25,
      step: 0.01
    }).on("change", (value) => {
      this.renderer.directionalLight.shadow.normalBias;
      this.renderer.directionalLight.shadow.camera.updateProjectionMatrix();
    });
    ambientLightF.addInput(Store.ambientLight, "color", { label: "Ambient Color" }).on("change", (value) => {
      this.renderer.ambientLight.color = new Color(
        `rgb(${parseInt(value.r)}, ${parseInt(value.g)}, ${parseInt(value.b)})`
      );
    });
    ambientLightF.addInput(Store.ambientLight, "intensity", {
      label: "Ambient Intensity",
      min: 0,
      max: 10
    }).on("change", (value) => {
      this.renderer.ambientLight.intensity = value;
    });
    environmentF.addInput(Store.environment, "intensity", {
      label: "Environment Intensity",
      min: 0,
      max: 10
    }).on("change", (value) => {
      this.renderer.updateAllEnvIntensity(value);
    });
    environmentF.addInput(Store.environment, "toneMappingExposure", {
      label: "ToneMapping Exposure",
      min: 0,
      max: 10
    }).on("change", (value) => {
      this.renderer.renderer.toneMappingExposure = value;
      this.renderer.updateAllMaterials();
    });
    environmentF.addInput(Store.environment, "toneMapping", {
      view: "list",
      options: {
        No: NoToneMapping,
        Linear: LinearToneMapping,
        Reinhard: ReinhardToneMapping,
        Cineon: CineonToneMapping,
        ACESFilmic: ACESFilmicToneMapping
      }
    }).on("change", (value) => {
      this.renderer.renderer.toneMapping = Number(value);
      this.renderer.updateAllMaterials();
    });
    floorF.addInput(Store.floor, "shadow", {
      min: 0,
      max: 1
    }).on("change", (value) => {
      this.renderer.scene.floor.material.opacity = value;
      this.renderer.scene.floor.material.needsUpdate = true;
    });
    windowsF.addInput(Store.windows, "reflectivity", {
      min: 0,
      max: 1
    }).on("change", (value) => {
      this.renderer.updateAllMaterials();
    });
    windowsF.addInput(Store.windows, "color", {
      min: 0,
      max: 1
    }).on("change", (value) => {
      this.renderer.updateAllMaterials();
    });
  }
}
function overwriteShadowMap(shader) {
  shader.fragmentShader = shader.fragmentShader.replace(
    "#include <shadowmap_pars_fragment>",
    `
            #ifdef USE_SHADOWMAP
            #define LIGHT_WORLD_SIZE 0.005
            #define LIGHT_FRUSTUM_WIDTH 3.75
            #define LIGHT_SIZE_UV (LIGHT_WORLD_SIZE / LIGHT_FRUSTUM_WIDTH)
            #define NEAR_PLANE 9.5

            #define NUM_SAMPLES 17
            #define NUM_RINGS 11
            #define BLOCKER_SEARCH_NUM_SAMPLES NUM_SAMPLES
            #define PCF_NUM_SAMPLES NUM_SAMPLES

            vec2 poissonDisk[NUM_SAMPLES];

            void initPoissonSamples( const in vec2 randomSeed ) {
                float ANGLE_STEP = PI2 * float( NUM_RINGS ) / float( NUM_SAMPLES );
                float INV_NUM_SAMPLES = 1.0 / float( NUM_SAMPLES );

                float angle = rand( randomSeed ) * PI2;
                float radius = INV_NUM_SAMPLES;
                float radiusStep = radius;

                for( int i = 0; i < NUM_SAMPLES; i ++ ) {
                    poissonDisk[i] = vec2( cos( angle ), sin( angle ) ) * pow( radius, 0.75 );
                    radius += radiusStep;
                    angle += ANGLE_STEP;
                }
            }

            float penumbraSize( const in float zReceiver, const in float zBlocker ) { // Parallel plane estimation
                return (zReceiver - zBlocker) / zBlocker;
            }

            float findBlocker( sampler2D shadowMap, const in vec2 uv, const in float zReceiver ) {
                // This uses similar triangles to compute what
                // area of the shadow map we should search
                float searchRadius = LIGHT_SIZE_UV * ( zReceiver - NEAR_PLANE ) / zReceiver;
                float blockerDepthSum = 0.0;
                int numBlockers = 0;

                for( int i = 0; i < BLOCKER_SEARCH_NUM_SAMPLES; i++ ) {
                    float shadowMapDepth = unpackRGBAToDepth(texture2D(shadowMap, uv + poissonDisk[i] * searchRadius));
                    if ( shadowMapDepth < zReceiver ) {
                        blockerDepthSum += shadowMapDepth;
                        numBlockers ++;
                    }
                }

                if( numBlockers == 0 ) return -1.0;

                return blockerDepthSum / float( numBlockers );
            }

            float PCF_Filter(sampler2D shadowMap, vec2 uv, float zReceiver, float filterRadius ) {
                float sum = 0.0;
                for( int i = 0; i < PCF_NUM_SAMPLES; i ++ ) {
                    float depth = unpackRGBAToDepth( texture2D( shadowMap, uv + poissonDisk[ i ] * filterRadius ) );
                    if( zReceiver <= depth ) sum += 1.0;
                }
                for( int i = 0; i < PCF_NUM_SAMPLES; i ++ ) {
                    float depth = unpackRGBAToDepth( texture2D( shadowMap, uv + -poissonDisk[ i ].yx * filterRadius ) );
                    if( zReceiver <= depth ) sum += 1.0;
                }
                return sum / ( 2.0 * float( PCF_NUM_SAMPLES ) );
            }

            float PCSS ( sampler2D shadowMap, vec4 coords ) {
                vec2 uv = coords.xy;
                float zReceiver = coords.z; // Assumed to be eye-space z in this code

                initPoissonSamples( uv );
                // STEP 1: blocker search
                float avgBlockerDepth = findBlocker( shadowMap, uv, zReceiver );

                //There are no occluders so early out (this saves filtering)
                if( avgBlockerDepth == -1.0 ) return 1.0;

                // STEP 2: penumbra size
                float penumbraRatio = penumbraSize( zReceiver, avgBlockerDepth );
                float filterRadius = penumbraRatio * LIGHT_SIZE_UV * NEAR_PLANE / zReceiver;

                // STEP 3: filtering
                //return avgBlockerDepth;
                return PCF_Filter( shadowMap, uv, zReceiver, filterRadius );
            }

#if NUM_DIR_LIGHT_SHADOWS > 0
    uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
    varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
    struct DirectionalLightShadow {
        float shadowBias;
        float shadowNormalBias;
        float shadowRadius;
        vec2 shadowMapSize;
    };
    uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
#endif
#if NUM_SPOT_LIGHT_SHADOWS > 0
    uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
    varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];
    struct SpotLightShadow {
        float shadowBias;
        float shadowNormalBias;
        float shadowRadius;
        vec2 shadowMapSize;
    };
    uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
#endif
#if NUM_POINT_LIGHT_SHADOWS > 0
    uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
    varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
    struct PointLightShadow {
        float shadowBias;
        float shadowNormalBias;
        float shadowRadius;
        vec2 shadowMapSize;
        float shadowCameraNear;
        float shadowCameraFar;
    };
    uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
#endif
float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
    return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
}
vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
    return unpackRGBATo2Half( texture2D( shadow, uv ) );
}
float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
    float occlusion = 1.0;
    vec2 distribution = texture2DDistribution( shadow, uv );
    float hard_shadow = step( compare , distribution.x );
    if (hard_shadow != 1.0 ) {
        float distance = compare - distribution.x ;
        float variance = max( 0.00000, distribution.y * distribution.y );
        float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
    }
    return occlusion;
}
float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
    float shadow = 1.0;
    shadowCoord.xyz /= shadowCoord.w;
    shadowCoord.z += shadowBias;
    bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );
    bool inFrustum = all( inFrustumVec );
    bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );
    bool frustumTest = all( frustumTestVec );
    if ( frustumTest ) {
    return PCSS( shadowMap, shadowCoord );
    #if defined( SHADOWMAP_TYPE_PCF )
        vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
        float dx0 = - texelSize.x * shadowRadius;
        float dy0 = - texelSize.y * shadowRadius;
        float dx1 = + texelSize.x * shadowRadius;
        float dy1 = + texelSize.y * shadowRadius;
        float dx2 = dx0 / 2.0;
        float dy2 = dy0 / 2.0;
        float dx3 = dx1 / 2.0;
        float dy3 = dy1 / 2.0;
        shadow = (
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
        ) * ( 1.0 / 17.0 );
    #elif defined( SHADOWMAP_TYPE_PCF_SOFT )
        vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
        float dx = texelSize.x;
        float dy = texelSize.y;
        vec2 uv = shadowCoord.xy;
        vec2 f = fract( uv * shadowMapSize + 0.5 );
        uv -= f * texelSize;
        shadow = (
            texture2DCompare( shadowMap, uv, shadowCoord.z ) +
            texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
            texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
            texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
            mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
                    texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
                    f.x ) +
            mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
                    texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
                    f.x ) +
            mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
                    texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
                    f.y ) +
            mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
                    texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
                    f.y ) +
            mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
                        texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
                        f.x ),
                    mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
                        texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
                        f.x ),
                    f.y )
        ) * ( 1.0 / 9.0 );
    #elif defined( SHADOWMAP_TYPE_VSM )
        shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
    #else
        shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
    #endif
    }
    return shadow;
}
vec2 cubeToUV( vec3 v, float texelSizeY ) {
    vec3 absV = abs( v );
    float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
    absV *= scaleToCube;
    v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
    vec2 planar = v.xy;
    float almostATexel = 1.5 * texelSizeY;
    float almostOne = 1.0 - almostATexel;
    if ( absV.z >= almostOne ) {
        if ( v.z > 0.0 )
            planar.x = 4.0 - v.x;
    } else if ( absV.x >= almostOne ) {
        float signX = sign( v.x );
        planar.x = v.z * signX + 2.0 * signX;
    } else if ( absV.y >= almostOne ) {
        float signY = sign( v.y );
        planar.x = v.x + 2.0 * signY + 2.0;
        planar.y = v.z * signY - 2.0;
    }
    return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
}
float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
    vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
    vec3 lightToPosition = shadowCoord.xyz;
    float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
    vec3 bd3D = normalize( lightToPosition );
    #if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
        vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
        return (
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
            texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
        ) * ( 1.0 / 9.0 );
    #else
        return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
    #endif
}
#endif
            `
  );
}
class Floor extends Mesh {
  constructor() {
    const geometry = new PlaneGeometry(35, 35, 32);
    const material = new ShadowMaterial();
    material.onBeforeCompile = (shader) => {
      overwriteShadowMap(shader);
    };
    material.opacity = Store.floor.shadow;
    super(geometry, material);
    this.rotation.x = -Math.PI / 2;
    this.position.y = -1;
    this.receiveShadow = true;
  }
}
class Scene extends Scene$1 {
  constructor() {
    super();
    this.environment = Store.env;
    this.floor = new Floor();
    this.add(this.floor);
  }
}
function lerp(s, e, t) {
  return (1 - t) * s + t * e;
}
function clamp(val, min, max) {
  return Math.min(Math.max(min, val), max);
}
const isMobile = () => {
  const touch = window.matchMedia("(pointer:coarse)");
  return touch && touch.matches || window.innerWidth < 1024;
};
class Camera extends PerspectiveCamera {
  constructor(instance) {
    super(60, Store.container.clientWidth / Store.container.clientHeight, 0.1, 100);
    __publicField(this, "onPointerDown", (e) => {
      this.onPointerMove(e);
    });
    __publicField(this, "onPointerMove", ({ clientX, clientY }) => {
      this.mouse.x = clientX - this.width / 2;
      this.mouse.y = clientY - this.height / 2;
      this.distance.x = (this.mouse.x - this.mouseLast.x) * 15e-5;
      this.distance.y = (this.mouse.y - this.mouseLast.y) * 15e-5;
      Store.controls.controls.sphericalDelta.theta -= this.distance.x;
      Store.controls.controls.sphericalDelta.phi -= this.distance.y;
      this.mouseLast.x = this.mouse.x;
      this.mouseLast.y = this.mouse.y;
    });
    __publicField(this, "onPointerUp", (e) => {
      this.onPointerMove(e);
    });
    this.scene = instance.scene;
    this.position.set(4, 2, 4);
    this.mouse = new Vector2$1();
    this.distance = new Vector2$1();
    this.mouseLast = new Vector2$1();
    this.rotationWrap = new Vector2$1();
    this.rotationLerp = new Vector2$1();
    this.width = Store.container.clientWidth;
    this.height = Store.container.clientHeight;
    this.settings = {
      mouseFxSmooth: 0.025,
      maxRotation: {
        x: 0.05,
        y: 0.15
      }
    };
    this.addEvents();
  }
  resize() {
    this.width = Store.container.clientWidth;
    this.height = Store.container.clientHeight;
    this.aspect = this.width / this.height;
    this.updateProjectionMatrix();
  }
  onReset() {
    this.fov = 60;
    this.zoom = 1;
    this.near = 0.1;
    this.far = 100;
    this.focus = 10;
    this.aspect = Store.container.clientWidth / Store.container.clientHeight;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  addEvents() {
    if (!isMobile()) {
      addEventListener("pointerdown", this.onPointerDown);
      addEventListener("pointermove", this.onPointerMove);
      addEventListener("pointerup", this.onPointerUp);
    }
  }
}
class GlRenderer extends WebGLRenderer {
  constructor() {
    super({
      antialias: true
    });
    Store.container.appendChild(this.domElement);
    this.setSize(Store.container.clientWidth, Store.container.clientHeight);
    this.setPixelRatio(Math.min(1.5, window.devicePixelRatio));
    const { r, g, b } = Store.background;
    this.setClearColor(new Color(`rgb(${r}, ${g}, ${b})`));
    this.physicallyCorrectLights = true;
    this.outputEncoding = sRGBEncoding;
    this.toneMapping = Store.environment.toneMapping;
    this.toneMappingExposure = Store.environment.toneMappingExposure;
    this.shadowMap.enabled = true;
    this.shadowMap.type = PCFSoftShadowMap;
  }
  onResize() {
    this.setSize(Store.container.clientWidth, Store.container.clientHeight);
  }
}
class Lights {
  constructor(instance) {
    instance.ambientLight = new AmbientLight(16777215);
    instance.ambientLight.intensity = Store.ambientLight.intensity;
    instance.scene.add(instance.ambientLight);
    instance.directionalLight = new DirectionalLight(
      16777215,
      Store.directionalLight.intensity
    );
    instance.directionalLight.position.copy(Store.directionalLight.position);
    instance.directionalLight.castShadow = true;
    instance.directionalLight.shadow.camera.far = 30;
    instance.directionalLight.shadow.camera.left = -Store.directionalLight.shadowScale;
    instance.directionalLight.shadow.camera.bottom = -Store.directionalLight.shadowScale;
    instance.directionalLight.shadow.camera.top = Store.directionalLight.shadowScale;
    instance.directionalLight.shadow.camera.right = Store.directionalLight.shadowScale;
    instance.directionalLight.shadow.mapSize.set(
      Store.directionalLight.mapSize,
      Store.directionalLight.mapSize
    );
    instance.directionalLight.shadow.normalBias = Store.directionalLight.normalBias;
    instance.directionalLight.shadow.radius = Store.directionalLight.radius;
    instance.scene.add(instance.directionalLight);
    if (Store.debug) {
      instance.directionalLightHelper = new CameraHelper(
        instance.directionalLight.shadow.camera
      );
      instance.scene.add(instance.directionalLightHelper);
    }
  }
}
const _changeEvent$1 = { type: "change" };
const _startEvent = { type: "start" };
const _endEvent = { type: "end" };
class OrbitControls extends EventDispatcher$1 {
  constructor(object, domElement) {
    super();
    if (domElement === void 0)
      console.warn(
        'THREE.OrbitControls: The second parameter "domElement" is now mandatory.'
      );
    if (domElement === document)
      console.error(
        'THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.'
      );
    this.object = object;
    this.domElement = domElement;
    this.enabled = true;
    this.target = new Vector3$1();
    this.minDistance = 0;
    this.maxDistance = Infinity;
    this.minZoom = 0;
    this.maxZoom = Infinity;
    this.minPolarAngle = 0;
    this.maxPolarAngle = Math.PI;
    this.minAzimuthAngle = -Infinity;
    this.maxAzimuthAngle = Infinity;
    this.enableDamping = false;
    this.dampingFactor = 0.05;
    this.enableZoom = true;
    this.zoomSpeed = 1;
    this.enableRotate = true;
    this.rotateSpeed = 1;
    this.enablePan = true;
    this.panSpeed = 1;
    this.screenSpacePanning = true;
    this.keyPanSpeed = 7;
    this.autoRotate = false;
    this.autoRotateSpeed = 2;
    this.keys = { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" };
    this.mouseButtons = { LEFT: MOUSE.ROTATE, MIDDLE: MOUSE.DOLLY, RIGHT: MOUSE.PAN };
    this.touches = { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN };
    this.target0 = this.target.clone();
    this.position0 = this.object.position.clone();
    this.zoom0 = this.object.zoom;
    this.lastPosition = new Vector3$1();
    this._domElementKeyEvents = null;
    this.getPolarAngle = function() {
      return spherical.phi;
    };
    this.getAzimuthalAngle = function() {
      return spherical.theta;
    };
    this.listenToKeyEvents = function(domElement2) {
      domElement2.addEventListener("keydown", onKeyDown);
      this._domElementKeyEvents = domElement2;
    };
    this.saveState = function() {
      scope.target0.copy(scope.target);
      scope.position0.copy(scope.object.position);
      scope.zoom0 = scope.object.zoom;
    };
    this.reset = function() {
      scope.target.copy(scope.target0);
      scope.object.position.copy(scope.position0);
      scope.object.zoom = scope.zoom0;
      scope.object.updateProjectionMatrix();
      scope.dispatchEvent(_changeEvent$1);
      Events.emit("ORBIT_CHANGE");
      scope.update();
      state = STATE.NONE;
    };
    this.update = function() {
      const offset = new Vector3$1();
      const quat = new Quaternion().setFromUnitVectors(object.up, new Vector3$1(0, 1, 0));
      const quatInverse = quat.clone().invert();
      const lastQuaternion = new Quaternion();
      const twoPI = 2 * Math.PI;
      const position = scope.object.position;
      offset.copy(position).sub(scope.target);
      offset.applyQuaternion(quat);
      spherical.setFromVector3(offset);
      if (scope.autoRotate && state === STATE.NONE) {
        rotateLeft(getAutoRotationAngle());
      }
      if (scope.enableDamping) {
        spherical.theta += scope.sphericalDelta.theta * scope.dampingFactor;
        spherical.phi += scope.sphericalDelta.phi * scope.dampingFactor;
      } else {
        spherical.theta += scope.sphericalDelta.theta;
        spherical.phi += scope.sphericalDelta.phi;
      }
      let min = scope.minAzimuthAngle;
      let max = scope.maxAzimuthAngle;
      if (isFinite(min) && isFinite(max)) {
        if (min < -Math.PI)
          min += twoPI;
        else if (min > Math.PI)
          min -= twoPI;
        if (max < -Math.PI)
          max += twoPI;
        else if (max > Math.PI)
          max -= twoPI;
        if (min <= max) {
          spherical.theta = Math.max(min, Math.min(max, spherical.theta));
        } else {
          spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
        }
      }
      spherical.phi = Math.max(
        scope.minPolarAngle,
        Math.min(scope.maxPolarAngle, spherical.phi)
      );
      spherical.makeSafe();
      spherical.radius *= scale;
      spherical.radius = Math.max(
        scope.minDistance,
        Math.min(scope.maxDistance, spherical.radius)
      );
      if (scope.enableDamping === true) {
        scope.target.addScaledVector(panOffset, scope.dampingFactor);
      } else {
        scope.target.add(panOffset);
      }
      offset.setFromSpherical(spherical);
      offset.applyQuaternion(quatInverse);
      position.copy(scope.target).add(offset);
      scope.object.lookAt(scope.target);
      if (scope.enableDamping === true) {
        scope.sphericalDelta.theta *= 1 - scope.dampingFactor;
        scope.sphericalDelta.phi *= 1 - scope.dampingFactor;
        panOffset.multiplyScalar(1 - scope.dampingFactor);
      } else {
        scope.sphericalDelta.set(0, 0, 0);
        panOffset.set(0, 0, 0);
      }
      scale = 1;
      if (zoomChanged || scope.lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
        scope.dispatchEvent(_changeEvent$1);
        Events.emit("ORBIT_CHANGE");
        scope.lastPosition.copy(scope.object.position);
        lastQuaternion.copy(scope.object.quaternion);
        zoomChanged = false;
        return true;
      }
      return false;
    };
    this.dispose = function() {
      scope.domElement.removeEventListener("contextmenu", onContextMenu);
      scope.domElement.removeEventListener("pointerdown", onPointerDown2);
      scope.domElement.removeEventListener("wheel", onMouseWheel);
      scope.domElement.removeEventListener("touchstart", onTouchStart);
      scope.domElement.removeEventListener("touchend", onTouchEnd);
      scope.domElement.removeEventListener("touchmove", onTouchMove);
      scope.domElement.ownerDocument.removeEventListener("pointermove", onPointerMove2);
      scope.domElement.ownerDocument.removeEventListener("pointerup", onPointerUp2);
      if (scope._domElementKeyEvents !== null) {
        scope._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
      }
    };
    this.sphericalDelta = new Spherical();
    const scope = this;
    const STATE = {
      NONE: -1,
      ROTATE: 0,
      DOLLY: 1,
      PAN: 2,
      TOUCH_ROTATE: 3,
      TOUCH_PAN: 4,
      TOUCH_DOLLY_PAN: 5,
      TOUCH_DOLLY_ROTATE: 6
    };
    let state = STATE.NONE;
    const EPS = 1e-6;
    const spherical = new Spherical();
    let scale = 1;
    const panOffset = new Vector3$1();
    let zoomChanged = false;
    const rotateStart = new Vector2$1();
    const rotateEnd = new Vector2$1();
    const rotateDelta = new Vector2$1();
    const panStart = new Vector2$1();
    const panEnd = new Vector2$1();
    const panDelta = new Vector2$1();
    const dollyStart = new Vector2$1();
    const dollyEnd = new Vector2$1();
    const dollyDelta = new Vector2$1();
    function getAutoRotationAngle() {
      return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
    }
    function getZoomScale() {
      return Math.pow(0.95, scope.zoomSpeed);
    }
    function rotateLeft(angle) {
      scope.sphericalDelta.theta -= angle;
    }
    function rotateUp(angle) {
      scope.sphericalDelta.phi -= angle;
    }
    const panLeft = function() {
      const v = new Vector3$1();
      return function panLeft2(distance, objectMatrix) {
        v.setFromMatrixColumn(objectMatrix, 0);
        v.multiplyScalar(-distance);
        panOffset.add(v);
      };
    }();
    const panUp = function() {
      const v = new Vector3$1();
      return function panUp2(distance, objectMatrix) {
        if (scope.screenSpacePanning === true) {
          v.setFromMatrixColumn(objectMatrix, 1);
        } else {
          v.setFromMatrixColumn(objectMatrix, 0);
          v.crossVectors(scope.object.up, v);
        }
        v.multiplyScalar(distance);
        panOffset.add(v);
      };
    }();
    const pan = function() {
      const offset = new Vector3$1();
      return function pan2(deltaX, deltaY) {
        const element = scope.domElement;
        if (scope.object.isPerspectiveCamera) {
          const position = scope.object.position;
          offset.copy(position).sub(scope.target);
          let targetDistance = offset.length();
          targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180);
          panLeft(
            2 * deltaX * targetDistance / element.clientHeight,
            scope.object.matrix
          );
          panUp(
            2 * deltaY * targetDistance / element.clientHeight,
            scope.object.matrix
          );
        } else if (scope.object.isOrthographicCamera) {
          panLeft(
            deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth,
            scope.object.matrix
          );
          panUp(
            deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight,
            scope.object.matrix
          );
        } else {
          console.warn(
            "WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."
          );
          scope.enablePan = false;
        }
      };
    }();
    function dollyOut(dollyScale) {
      if (scope.object.isPerspectiveCamera) {
        scale /= dollyScale;
      } else if (scope.object.isOrthographicCamera) {
        scope.object.zoom = Math.max(
          scope.minZoom,
          Math.min(scope.maxZoom, scope.object.zoom * dollyScale)
        );
        scope.object.updateProjectionMatrix();
        zoomChanged = true;
      } else {
        console.warn(
          "WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."
        );
        scope.enableZoom = false;
      }
    }
    function dollyIn(dollyScale) {
      if (scope.object.isPerspectiveCamera) {
        scale *= dollyScale;
      } else if (scope.object.isOrthographicCamera) {
        scope.object.zoom = Math.max(
          scope.minZoom,
          Math.min(scope.maxZoom, scope.object.zoom / dollyScale)
        );
        scope.object.updateProjectionMatrix();
        zoomChanged = true;
      } else {
        console.warn(
          "WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."
        );
        scope.enableZoom = false;
      }
    }
    function handleMouseDownRotate(event) {
      rotateStart.set(event.clientX, event.clientY);
    }
    function handleMouseDownDolly(event) {
      dollyStart.set(event.clientX, event.clientY);
    }
    function handleMouseDownPan(event) {
      panStart.set(event.clientX, event.clientY);
    }
    function handleMouseMoveRotate(event) {
      rotateEnd.set(event.clientX, event.clientY);
      rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
      const element = scope.domElement;
      rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight);
      rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
      rotateStart.copy(rotateEnd);
      scope.update();
    }
    function handleMouseMoveDolly(event) {
      dollyEnd.set(event.clientX, event.clientY);
      dollyDelta.subVectors(dollyEnd, dollyStart);
      if (dollyDelta.y > 0) {
        dollyOut(getZoomScale());
      } else if (dollyDelta.y < 0) {
        dollyIn(getZoomScale());
      }
      dollyStart.copy(dollyEnd);
      scope.update();
    }
    function handleMouseMovePan(event) {
      panEnd.set(event.clientX, event.clientY);
      panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
      pan(panDelta.x, panDelta.y);
      panStart.copy(panEnd);
      scope.update();
    }
    function handleMouseWheel(event) {
      if (event.deltaY < 0) {
        dollyIn(getZoomScale());
      } else if (event.deltaY > 0) {
        dollyOut(getZoomScale());
      }
      scope.update();
    }
    function handleKeyDown(event) {
      let needsUpdate = false;
      switch (event.code) {
        case scope.keys.UP:
          pan(0, scope.keyPanSpeed);
          needsUpdate = true;
          break;
        case scope.keys.BOTTOM:
          pan(0, -scope.keyPanSpeed);
          needsUpdate = true;
          break;
        case scope.keys.LEFT:
          pan(scope.keyPanSpeed, 0);
          needsUpdate = true;
          break;
        case scope.keys.RIGHT:
          pan(-scope.keyPanSpeed, 0);
          needsUpdate = true;
          break;
      }
      if (needsUpdate) {
        event.preventDefault();
        scope.update();
      }
    }
    function handleTouchStartRotate(event) {
      if (event.touches.length == 1) {
        rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
      } else {
        const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
        const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
        rotateStart.set(x, y);
      }
    }
    function handleTouchStartPan(event) {
      if (event.touches.length == 1) {
        panStart.set(event.touches[0].pageX, event.touches[0].pageY);
      } else {
        const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
        const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
        panStart.set(x, y);
      }
    }
    function handleTouchStartDolly(event) {
      const dx = event.touches[0].pageX - event.touches[1].pageX;
      const dy = event.touches[0].pageY - event.touches[1].pageY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      dollyStart.set(0, distance);
    }
    function handleTouchStartDollyPan(event) {
      if (scope.enableZoom)
        handleTouchStartDolly(event);
      if (scope.enablePan)
        handleTouchStartPan(event);
    }
    function handleTouchStartDollyRotate(event) {
      if (scope.enableZoom)
        handleTouchStartDolly(event);
      if (scope.enableRotate)
        handleTouchStartRotate(event);
    }
    function handleTouchMoveRotate(event) {
      if (event.touches.length == 1) {
        rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
      } else {
        const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
        const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
        rotateEnd.set(x, y);
      }
      rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
      const element = scope.domElement;
      rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight);
      rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
      rotateStart.copy(rotateEnd);
    }
    function handleTouchMovePan(event) {
      if (event.touches.length == 1) {
        panEnd.set(event.touches[0].pageX, event.touches[0].pageY);
      } else {
        const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
        const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
        panEnd.set(x, y);
      }
      panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
      pan(panDelta.x, panDelta.y);
      panStart.copy(panEnd);
    }
    function handleTouchMoveDolly(event) {
      const dx = event.touches[0].pageX - event.touches[1].pageX;
      const dy = event.touches[0].pageY - event.touches[1].pageY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      dollyEnd.set(0, distance);
      dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
      dollyOut(dollyDelta.y);
      dollyStart.copy(dollyEnd);
    }
    function handleTouchMoveDollyPan(event) {
      if (scope.enableZoom)
        handleTouchMoveDolly(event);
      if (scope.enablePan)
        handleTouchMovePan(event);
    }
    function handleTouchMoveDollyRotate(event) {
      if (scope.enableZoom)
        handleTouchMoveDolly(event);
      if (scope.enableRotate)
        handleTouchMoveRotate(event);
    }
    function onPointerDown2(event) {
      switch (event.pointerType) {
        case "mouse":
        case "pen":
          onMouseDown(event);
          break;
      }
    }
    function onPointerMove2(event) {
      if (scope.enabled === false)
        return;
      Events.emit("ORBIT_POINTER_MOVE");
      switch (event.pointerType) {
        case "mouse":
        case "pen":
          onMouseMove(event);
          break;
      }
    }
    function onPointerUp2(event) {
      Events.emit("ORBIT_UP");
      switch (event.pointerType) {
        case "mouse":
        case "pen":
          onMouseUp();
          break;
      }
    }
    function onMouseDown(event) {
      event.preventDefault();
      scope.domElement.focus ? scope.domElement.focus() : window.focus();
      let mouseAction;
      switch (event.button) {
        case 0:
          mouseAction = scope.mouseButtons.LEFT;
          break;
        case 1:
          mouseAction = scope.mouseButtons.MIDDLE;
          break;
        case 2:
          mouseAction = scope.mouseButtons.RIGHT;
          break;
        default:
          mouseAction = -1;
      }
      switch (mouseAction) {
        case MOUSE.DOLLY:
          if (scope.enableZoom === false)
            return;
          handleMouseDownDolly(event);
          state = STATE.DOLLY;
          break;
        case MOUSE.ROTATE:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (scope.enablePan === false)
              return;
            handleMouseDownPan(event);
            state = STATE.PAN;
          } else {
            if (scope.enableRotate === false)
              return;
            handleMouseDownRotate(event);
            state = STATE.ROTATE;
          }
          break;
        case MOUSE.PAN:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (scope.enableRotate === false)
              return;
            handleMouseDownRotate(event);
            state = STATE.ROTATE;
          } else {
            if (scope.enablePan === false)
              return;
            handleMouseDownPan(event);
            state = STATE.PAN;
          }
          break;
        default:
          state = STATE.NONE;
      }
      if (state !== STATE.NONE) {
        scope.domElement.ownerDocument.addEventListener("pointermove", onPointerMove2);
        scope.domElement.ownerDocument.addEventListener("pointerup", onPointerUp2);
        scope.dispatchEvent(_startEvent);
      }
    }
    function onMouseMove(event) {
      if (scope.enabled === false)
        return;
      event.preventDefault();
      switch (state) {
        case STATE.ROTATE:
          if (scope.enableRotate === false)
            return;
          handleMouseMoveRotate(event);
          break;
        case STATE.DOLLY:
          if (scope.enableZoom === false)
            return;
          handleMouseMoveDolly(event);
          break;
        case STATE.PAN:
          if (scope.enablePan === false)
            return;
          handleMouseMovePan(event);
          break;
      }
    }
    function onMouseUp(event) {
      scope.domElement.ownerDocument.removeEventListener("pointermove", onPointerMove2);
      scope.domElement.ownerDocument.removeEventListener("pointerup", onPointerUp2);
      scope.dispatchEvent(_endEvent);
      state = STATE.NONE;
    }
    function onMouseWheel(event) {
      if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE && state !== STATE.ROTATE)
        return;
      event.preventDefault();
      scope.dispatchEvent(_startEvent);
      handleMouseWheel(event);
      scope.dispatchEvent(_endEvent);
    }
    function onKeyDown(event) {
      if (scope.enabled === false || scope.enablePan === false)
        return;
      handleKeyDown(event);
    }
    function onTouchStart(event) {
      if (scope.enabled === false)
        return;
      event.preventDefault();
      switch (event.touches.length) {
        case 1:
          switch (scope.touches.ONE) {
            case TOUCH.ROTATE:
              if (scope.enableRotate === false)
                return;
              handleTouchStartRotate(event);
              state = STATE.TOUCH_ROTATE;
              break;
            case TOUCH.PAN:
              if (scope.enablePan === false)
                return;
              handleTouchStartPan(event);
              state = STATE.TOUCH_PAN;
              break;
            default:
              state = STATE.NONE;
          }
          break;
        case 2:
          switch (scope.touches.TWO) {
            case TOUCH.DOLLY_PAN:
              if (scope.enableZoom === false && scope.enablePan === false)
                return;
              handleTouchStartDollyPan(event);
              state = STATE.TOUCH_DOLLY_PAN;
              break;
            case TOUCH.DOLLY_ROTATE:
              if (scope.enableZoom === false && scope.enableRotate === false)
                return;
              handleTouchStartDollyRotate(event);
              state = STATE.TOUCH_DOLLY_ROTATE;
              break;
            default:
              state = STATE.NONE;
          }
          break;
        default:
          state = STATE.NONE;
      }
      if (state !== STATE.NONE) {
        scope.dispatchEvent(_startEvent);
      }
    }
    function onTouchMove(event) {
      if (scope.enabled === false)
        return;
      event.preventDefault();
      Events.emit("ORBIT_TOUCH_MOVE");
      switch (state) {
        case STATE.TOUCH_ROTATE:
          if (scope.enableRotate === false)
            return;
          handleTouchMoveRotate(event);
          scope.update();
          break;
        case STATE.TOUCH_PAN:
          if (scope.enablePan === false)
            return;
          handleTouchMovePan(event);
          scope.update();
          break;
        case STATE.TOUCH_DOLLY_PAN:
          if (scope.enableZoom === false && scope.enablePan === false)
            return;
          handleTouchMoveDollyPan(event);
          scope.update();
          break;
        case STATE.TOUCH_DOLLY_ROTATE:
          if (scope.enableZoom === false && scope.enableRotate === false)
            return;
          handleTouchMoveDollyRotate(event);
          scope.update();
          break;
        default:
          state = STATE.NONE;
      }
    }
    function onTouchEnd(event) {
      if (scope.enabled === false)
        return;
      scope.dispatchEvent(_endEvent);
      state = STATE.NONE;
    }
    function onContextMenu(event) {
      if (scope.enabled === false)
        return;
      event.preventDefault();
    }
    scope.domElement.addEventListener("contextmenu", onContextMenu);
    scope.domElement.addEventListener("pointerdown", onPointerDown2);
    scope.domElement.addEventListener("wheel", onMouseWheel, { passive: false });
    scope.domElement.addEventListener("touchstart", onTouchStart, { passive: false });
    scope.domElement.addEventListener("touchend", onTouchEnd);
    scope.domElement.addEventListener("touchmove", onTouchMove, { passive: false });
    this.update();
  }
}
const _raycaster = new Raycaster();
const _tempVector = new Vector3$1();
const _tempVector2 = new Vector3$1();
const _tempQuaternion = new Quaternion();
const _unit = {
  X: new Vector3$1(1, 0, 0),
  Y: new Vector3$1(0, 1, 0),
  Z: new Vector3$1(0, 0, 1)
};
const _changeEvent = { type: "change" };
const _mouseDownEvent = { type: "mouseDown" };
const _mouseUpEvent = { type: "mouseUp", mode: null };
const _objectChangeEvent = { type: "objectChange" };
class TransformControls extends Object3D {
  constructor(camera, domElement) {
    super();
    if (domElement === void 0) {
      console.warn('THREE.TransformControls: The second parameter "domElement" is now mandatory.');
      domElement = document;
    }
    this.visible = false;
    this.domElement = domElement;
    const _gizmo = new TransformControlsGizmo();
    this._gizmo = _gizmo;
    this.add(_gizmo);
    const _plane = new TransformControlsPlane();
    this._plane = _plane;
    this.add(_plane);
    const scope = this;
    function defineProperty(propName, defaultValue) {
      let propValue = defaultValue;
      Object.defineProperty(scope, propName, {
        get: function() {
          return propValue !== void 0 ? propValue : defaultValue;
        },
        set: function(value) {
          if (propValue !== value) {
            propValue = value;
            _plane[propName] = value;
            _gizmo[propName] = value;
            scope.dispatchEvent({ type: propName + "-changed", value });
            scope.dispatchEvent(_changeEvent);
          }
        }
      });
      scope[propName] = defaultValue;
      _plane[propName] = defaultValue;
      _gizmo[propName] = defaultValue;
    }
    defineProperty("camera", camera);
    defineProperty("object", void 0);
    defineProperty("enabled", true);
    defineProperty("axis", null);
    defineProperty("mode", "translate");
    defineProperty("translationSnap", null);
    defineProperty("rotationSnap", null);
    defineProperty("scaleSnap", null);
    defineProperty("space", "world");
    defineProperty("size", 1);
    defineProperty("dragging", false);
    defineProperty("showX", true);
    defineProperty("showY", true);
    defineProperty("showZ", true);
    const worldPosition = new Vector3$1();
    const worldPositionStart = new Vector3$1();
    const worldQuaternion = new Quaternion();
    const worldQuaternionStart = new Quaternion();
    const cameraPosition = new Vector3$1();
    const cameraQuaternion = new Quaternion();
    const pointStart = new Vector3$1();
    const pointEnd = new Vector3$1();
    const rotationAxis = new Vector3$1();
    const rotationAngle = 0;
    const eye2 = new Vector3$1();
    defineProperty("worldPosition", worldPosition);
    defineProperty("worldPositionStart", worldPositionStart);
    defineProperty("worldQuaternion", worldQuaternion);
    defineProperty("worldQuaternionStart", worldQuaternionStart);
    defineProperty("cameraPosition", cameraPosition);
    defineProperty("cameraQuaternion", cameraQuaternion);
    defineProperty("pointStart", pointStart);
    defineProperty("pointEnd", pointEnd);
    defineProperty("rotationAxis", rotationAxis);
    defineProperty("rotationAngle", rotationAngle);
    defineProperty("eye", eye2);
    this._offset = new Vector3$1();
    this._startNorm = new Vector3$1();
    this._endNorm = new Vector3$1();
    this._cameraScale = new Vector3$1();
    this._parentPosition = new Vector3$1();
    this._parentQuaternion = new Quaternion();
    this._parentQuaternionInv = new Quaternion();
    this._parentScale = new Vector3$1();
    this._worldScaleStart = new Vector3$1();
    this._worldQuaternionInv = new Quaternion();
    this._worldScale = new Vector3$1();
    this._positionStart = new Vector3$1();
    this._quaternionStart = new Quaternion();
    this._scaleStart = new Vector3$1();
    this._getPointer = getPointer.bind(this);
    this._onPointerDown = onPointerDown.bind(this);
    this._onPointerHover = onPointerHover.bind(this);
    this._onPointerMove = onPointerMove.bind(this);
    this._onPointerUp = onPointerUp.bind(this);
    this.domElement.addEventListener("pointerdown", this._onPointerDown);
    this.domElement.addEventListener("pointermove", this._onPointerHover);
    this.domElement.ownerDocument.addEventListener("pointerup", this._onPointerUp);
  }
  updateMatrixWorld() {
    if (this.object !== void 0) {
      this.object.updateMatrixWorld();
      if (this.object.parent === null) {
        console.error("TransformControls: The attached 3D object must be a part of the scene graph.");
      } else {
        this.object.parent.matrixWorld.decompose(this._parentPosition, this._parentQuaternion, this._parentScale);
      }
      this.object.matrixWorld.decompose(this.worldPosition, this.worldQuaternion, this._worldScale);
      this._parentQuaternionInv.copy(this._parentQuaternion).invert();
      this._worldQuaternionInv.copy(this.worldQuaternion).invert();
    }
    this.camera.updateMatrixWorld();
    this.camera.matrixWorld.decompose(this.cameraPosition, this.cameraQuaternion, this._cameraScale);
    this.eye.copy(this.cameraPosition).sub(this.worldPosition).normalize();
    super.updateMatrixWorld(this);
  }
  pointerHover(pointer) {
    if (this.object === void 0 || this.dragging === true)
      return;
    _raycaster.setFromCamera(pointer, this.camera);
    const intersect = intersectObjectWithRay(this._gizmo.picker[this.mode], _raycaster);
    if (intersect) {
      this.axis = intersect.object.name;
    } else {
      this.axis = null;
    }
  }
  pointerDown(pointer) {
    if (this.object === void 0 || this.dragging === true || pointer.button !== 0)
      return;
    if (this.axis !== null) {
      _raycaster.setFromCamera(pointer, this.camera);
      const planeIntersect = intersectObjectWithRay(this._plane, _raycaster, true);
      if (planeIntersect) {
        let space = this.space;
        if (this.mode === "scale") {
          space = "local";
        } else if (this.axis === "E" || this.axis === "XYZE" || this.axis === "XYZ") {
          space = "world";
        }
        if (space === "local" && this.mode === "rotate") {
          const snap = this.rotationSnap;
          if (this.axis === "X" && snap)
            this.object.rotation.x = Math.round(this.object.rotation.x / snap) * snap;
          if (this.axis === "Y" && snap)
            this.object.rotation.y = Math.round(this.object.rotation.y / snap) * snap;
          if (this.axis === "Z" && snap)
            this.object.rotation.z = Math.round(this.object.rotation.z / snap) * snap;
        }
        this.object.updateMatrixWorld();
        this.object.parent.updateMatrixWorld();
        this._positionStart.copy(this.object.position);
        this._quaternionStart.copy(this.object.quaternion);
        this._scaleStart.copy(this.object.scale);
        this.object.matrixWorld.decompose(this.worldPositionStart, this.worldQuaternionStart, this._worldScaleStart);
        this.pointStart.copy(planeIntersect.point).sub(this.worldPositionStart);
      }
      this.dragging = true;
      _mouseDownEvent.mode = this.mode;
      this.dispatchEvent(_mouseDownEvent);
    }
  }
  pointerMove(pointer) {
    const axis = this.axis;
    const mode = this.mode;
    const object = this.object;
    let space = this.space;
    if (mode === "scale") {
      space = "local";
    } else if (axis === "E" || axis === "XYZE" || axis === "XYZ") {
      space = "world";
    }
    if (object === void 0 || axis === null || this.dragging === false || pointer.button !== -1)
      return;
    _raycaster.setFromCamera(pointer, this.camera);
    const planeIntersect = intersectObjectWithRay(this._plane, _raycaster, true);
    if (!planeIntersect)
      return;
    this.pointEnd.copy(planeIntersect.point).sub(this.worldPositionStart);
    if (mode === "translate") {
      this._offset.copy(this.pointEnd).sub(this.pointStart);
      if (space === "local" && axis !== "XYZ") {
        this._offset.applyQuaternion(this._worldQuaternionInv);
      }
      if (axis.indexOf("X") === -1)
        this._offset.x = 0;
      if (axis.indexOf("Y") === -1)
        this._offset.y = 0;
      if (axis.indexOf("Z") === -1)
        this._offset.z = 0;
      if (space === "local" && axis !== "XYZ") {
        this._offset.applyQuaternion(this._quaternionStart).divide(this._parentScale);
      } else {
        this._offset.applyQuaternion(this._parentQuaternionInv).divide(this._parentScale);
      }
      object.position.copy(this._offset).add(this._positionStart);
      if (this.translationSnap) {
        if (space === "local") {
          object.position.applyQuaternion(_tempQuaternion.copy(this._quaternionStart).invert());
          if (axis.search("X") !== -1) {
            object.position.x = Math.round(object.position.x / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Y") !== -1) {
            object.position.y = Math.round(object.position.y / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Z") !== -1) {
            object.position.z = Math.round(object.position.z / this.translationSnap) * this.translationSnap;
          }
          object.position.applyQuaternion(this._quaternionStart);
        }
        if (space === "world") {
          if (object.parent) {
            object.position.add(_tempVector.setFromMatrixPosition(object.parent.matrixWorld));
          }
          if (axis.search("X") !== -1) {
            object.position.x = Math.round(object.position.x / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Y") !== -1) {
            object.position.y = Math.round(object.position.y / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Z") !== -1) {
            object.position.z = Math.round(object.position.z / this.translationSnap) * this.translationSnap;
          }
          if (object.parent) {
            object.position.sub(_tempVector.setFromMatrixPosition(object.parent.matrixWorld));
          }
        }
      }
    } else if (mode === "scale") {
      if (axis.search("XYZ") !== -1) {
        let d = this.pointEnd.length() / this.pointStart.length();
        if (this.pointEnd.dot(this.pointStart) < 0)
          d *= -1;
        _tempVector2.set(d, d, d);
      } else {
        _tempVector.copy(this.pointStart);
        _tempVector2.copy(this.pointEnd);
        _tempVector.applyQuaternion(this._worldQuaternionInv);
        _tempVector2.applyQuaternion(this._worldQuaternionInv);
        _tempVector2.divide(_tempVector);
        if (axis.search("X") === -1) {
          _tempVector2.x = 1;
        }
        if (axis.search("Y") === -1) {
          _tempVector2.y = 1;
        }
        if (axis.search("Z") === -1) {
          _tempVector2.z = 1;
        }
      }
      object.scale.copy(this._scaleStart).multiply(_tempVector2);
      if (this.scaleSnap) {
        if (axis.search("X") !== -1) {
          object.scale.x = Math.round(object.scale.x / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
        }
        if (axis.search("Y") !== -1) {
          object.scale.y = Math.round(object.scale.y / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
        }
        if (axis.search("Z") !== -1) {
          object.scale.z = Math.round(object.scale.z / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
        }
      }
    } else if (mode === "rotate") {
      this._offset.copy(this.pointEnd).sub(this.pointStart);
      const ROTATION_SPEED = 20 / this.worldPosition.distanceTo(_tempVector.setFromMatrixPosition(this.camera.matrixWorld));
      if (axis === "E") {
        this.rotationAxis.copy(this.eye);
        this.rotationAngle = this.pointEnd.angleTo(this.pointStart);
        this._startNorm.copy(this.pointStart).normalize();
        this._endNorm.copy(this.pointEnd).normalize();
        this.rotationAngle *= this._endNorm.cross(this._startNorm).dot(this.eye) < 0 ? 1 : -1;
      } else if (axis === "XYZE") {
        this.rotationAxis.copy(this._offset).cross(this.eye).normalize();
        this.rotationAngle = this._offset.dot(_tempVector.copy(this.rotationAxis).cross(this.eye)) * ROTATION_SPEED;
      } else if (axis === "X" || axis === "Y" || axis === "Z") {
        this.rotationAxis.copy(_unit[axis]);
        _tempVector.copy(_unit[axis]);
        if (space === "local") {
          _tempVector.applyQuaternion(this.worldQuaternion);
        }
        this.rotationAngle = this._offset.dot(_tempVector.cross(this.eye).normalize()) * ROTATION_SPEED;
      }
      if (this.rotationSnap)
        this.rotationAngle = Math.round(this.rotationAngle / this.rotationSnap) * this.rotationSnap;
      if (space === "local" && axis !== "E" && axis !== "XYZE") {
        object.quaternion.copy(this._quaternionStart);
        object.quaternion.multiply(_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle)).normalize();
      } else {
        this.rotationAxis.applyQuaternion(this._parentQuaternionInv);
        object.quaternion.copy(_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle));
        object.quaternion.multiply(this._quaternionStart).normalize();
      }
    }
    this.dispatchEvent(_changeEvent);
    this.dispatchEvent(_objectChangeEvent);
  }
  pointerUp(pointer) {
    if (pointer.button !== 0)
      return;
    if (this.dragging && this.axis !== null) {
      _mouseUpEvent.mode = this.mode;
      this.dispatchEvent(_mouseUpEvent);
    }
    this.dragging = false;
    this.axis = null;
  }
  dispose() {
    this.domElement.removeEventListener("pointerdown", this._onPointerDown);
    this.domElement.removeEventListener("pointermove", this._onPointerHover);
    this.domElement.ownerDocument.removeEventListener("pointermove", this._onPointerMove);
    this.domElement.ownerDocument.removeEventListener("pointerup", this._onPointerUp);
    this.traverse(function(child) {
      if (child.geometry)
        child.geometry.dispose();
      if (child.material)
        child.material.dispose();
    });
  }
  attach(object) {
    this.object = object;
    this.visible = true;
    return this;
  }
  detach() {
    this.object = void 0;
    this.visible = false;
    this.axis = null;
    return this;
  }
  getMode() {
    return this.mode;
  }
  setMode(mode) {
    this.mode = mode;
  }
  setTranslationSnap(translationSnap) {
    this.translationSnap = translationSnap;
  }
  setRotationSnap(rotationSnap) {
    this.rotationSnap = rotationSnap;
  }
  setScaleSnap(scaleSnap) {
    this.scaleSnap = scaleSnap;
  }
  setSize(size) {
    this.size = size;
  }
  setSpace(space) {
    this.space = space;
  }
  update() {
    console.warn("THREE.TransformControls: update function has no more functionality and therefore has been deprecated.");
  }
}
TransformControls.prototype.isTransformControls = true;
function getPointer(event) {
  if (this.domElement.ownerDocument.pointerLockElement) {
    return {
      x: 0,
      y: 0,
      button: event.button
    };
  } else {
    const pointer = event.changedTouches ? event.changedTouches[0] : event;
    const rect = this.domElement.getBoundingClientRect();
    return {
      x: (pointer.clientX - rect.left) / rect.width * 2 - 1,
      y: -(pointer.clientY - rect.top) / rect.height * 2 + 1,
      button: event.button
    };
  }
}
function onPointerHover(event) {
  if (!this.enabled)
    return;
  switch (event.pointerType) {
    case "mouse":
    case "pen":
      this.pointerHover(this._getPointer(event));
      break;
  }
}
function onPointerDown(event) {
  if (!this.enabled)
    return;
  this.domElement.style.touchAction = "none";
  this.domElement.ownerDocument.addEventListener("pointermove", this._onPointerMove);
  this.pointerHover(this._getPointer(event));
  this.pointerDown(this._getPointer(event));
}
function onPointerMove(event) {
  if (!this.enabled)
    return;
  this.pointerMove(this._getPointer(event));
}
function onPointerUp(event) {
  if (!this.enabled)
    return;
  this.domElement.style.touchAction = "";
  this.domElement.ownerDocument.removeEventListener("pointermove", this._onPointerMove);
  this.pointerUp(this._getPointer(event));
}
function intersectObjectWithRay(object, raycaster, includeInvisible) {
  const allIntersections = raycaster.intersectObject(object, true);
  for (let i = 0; i < allIntersections.length; i++) {
    if (allIntersections[i].object.visible || includeInvisible) {
      return allIntersections[i];
    }
  }
  return false;
}
const _tempEuler = new Euler();
const _alignVector = new Vector3$1(0, 1, 0);
const _zeroVector = new Vector3$1(0, 0, 0);
const _lookAtMatrix = new Matrix4();
const _tempQuaternion2 = new Quaternion();
const _identityQuaternion = new Quaternion();
const _dirVector = new Vector3$1();
const _tempMatrix = new Matrix4();
const _unitX = new Vector3$1(1, 0, 0);
const _unitY = new Vector3$1(0, 1, 0);
const _unitZ = new Vector3$1(0, 0, 1);
const _v1 = new Vector3$1();
const _v2 = new Vector3$1();
const _v3 = new Vector3$1();
class TransformControlsGizmo extends Object3D {
  constructor() {
    super();
    this.type = "TransformControlsGizmo";
    const gizmoMaterial = new MeshBasicMaterial({
      depthTest: false,
      depthWrite: false,
      transparent: true,
      side: DoubleSide,
      fog: false,
      toneMapped: false
    });
    const gizmoLineMaterial = new LineBasicMaterial({
      depthTest: false,
      depthWrite: false,
      transparent: true,
      linewidth: 1,
      fog: false,
      toneMapped: false
    });
    const matInvisible = gizmoMaterial.clone();
    matInvisible.opacity = 0.15;
    const matHelper = gizmoMaterial.clone();
    matHelper.opacity = 0.33;
    const matRed = gizmoMaterial.clone();
    matRed.color.set(16711680);
    const matGreen = gizmoMaterial.clone();
    matGreen.color.set(65280);
    const matBlue = gizmoMaterial.clone();
    matBlue.color.set(255);
    const matWhiteTransparent = gizmoMaterial.clone();
    matWhiteTransparent.opacity = 0.25;
    const matYellowTransparent = matWhiteTransparent.clone();
    matYellowTransparent.color.set(16776960);
    const matCyanTransparent = matWhiteTransparent.clone();
    matCyanTransparent.color.set(65535);
    const matMagentaTransparent = matWhiteTransparent.clone();
    matMagentaTransparent.color.set(16711935);
    const matYellow = gizmoMaterial.clone();
    matYellow.color.set(16776960);
    const matLineRed = gizmoLineMaterial.clone();
    matLineRed.color.set(16711680);
    const matLineGreen = gizmoLineMaterial.clone();
    matLineGreen.color.set(65280);
    const matLineBlue = gizmoLineMaterial.clone();
    matLineBlue.color.set(255);
    const matLineCyan = gizmoLineMaterial.clone();
    matLineCyan.color.set(65535);
    const matLineMagenta = gizmoLineMaterial.clone();
    matLineMagenta.color.set(16711935);
    const matLineYellow = gizmoLineMaterial.clone();
    matLineYellow.color.set(16776960);
    const matLineGray = gizmoLineMaterial.clone();
    matLineGray.color.set(7895160);
    const matLineYellowTransparent = matLineYellow.clone();
    matLineYellowTransparent.opacity = 0.25;
    const arrowGeometry = new CylinderGeometry(0, 0.05, 0.2, 12, 1, false);
    const scaleHandleGeometry = new BoxGeometry(0.125, 0.125, 0.125);
    const lineGeometry = new BufferGeometry();
    lineGeometry.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 1, 0, 0], 3));
    function CircleGeometry(radius, arc) {
      const geometry = new BufferGeometry();
      const vertices = [];
      for (let i = 0; i <= 64 * arc; ++i) {
        vertices.push(0, Math.cos(i / 32 * Math.PI) * radius, Math.sin(i / 32 * Math.PI) * radius);
      }
      geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      return geometry;
    }
    function TranslateHelperGeometry() {
      const geometry = new BufferGeometry();
      geometry.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 1, 1, 1], 3));
      return geometry;
    }
    const gizmoTranslate = {
      X: [
        [new Mesh(arrowGeometry, matRed), [1, 0, 0], [0, 0, -Math.PI / 2], null, "fwd"],
        [new Mesh(arrowGeometry, matRed), [1, 0, 0], [0, 0, Math.PI / 2], null, "bwd"],
        [new Line(lineGeometry, matLineRed)]
      ],
      Y: [
        [new Mesh(arrowGeometry, matGreen), [0, 1, 0], null, null, "fwd"],
        [new Mesh(arrowGeometry, matGreen), [0, 1, 0], [Math.PI, 0, 0], null, "bwd"],
        [new Line(lineGeometry, matLineGreen), null, [0, 0, Math.PI / 2]]
      ],
      Z: [
        [new Mesh(arrowGeometry, matBlue), [0, 0, 1], [Math.PI / 2, 0, 0], null, "fwd"],
        [new Mesh(arrowGeometry, matBlue), [0, 0, 1], [-Math.PI / 2, 0, 0], null, "bwd"],
        [new Line(lineGeometry, matLineBlue), null, [0, -Math.PI / 2, 0]]
      ],
      XYZ: [
        [new Mesh(new OctahedronGeometry(0.1, 0), matWhiteTransparent.clone()), [0, 0, 0], [0, 0, 0]]
      ],
      XY: [
        [new Mesh(new PlaneGeometry(0.295, 0.295), matYellowTransparent.clone()), [0.15, 0.15, 0]],
        [new Line(lineGeometry, matLineYellow), [0.18, 0.3, 0], null, [0.125, 1, 1]],
        [new Line(lineGeometry, matLineYellow), [0.3, 0.18, 0], [0, 0, Math.PI / 2], [0.125, 1, 1]]
      ],
      YZ: [
        [new Mesh(new PlaneGeometry(0.295, 0.295), matCyanTransparent.clone()), [0, 0.15, 0.15], [0, Math.PI / 2, 0]],
        [new Line(lineGeometry, matLineCyan), [0, 0.18, 0.3], [0, 0, Math.PI / 2], [0.125, 1, 1]],
        [new Line(lineGeometry, matLineCyan), [0, 0.3, 0.18], [0, -Math.PI / 2, 0], [0.125, 1, 1]]
      ],
      XZ: [
        [new Mesh(new PlaneGeometry(0.295, 0.295), matMagentaTransparent.clone()), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]],
        [new Line(lineGeometry, matLineMagenta), [0.18, 0, 0.3], null, [0.125, 1, 1]],
        [new Line(lineGeometry, matLineMagenta), [0.3, 0, 0.18], [0, -Math.PI / 2, 0], [0.125, 1, 1]]
      ]
    };
    const pickerTranslate = {
      X: [
        [new Mesh(new CylinderGeometry(0.2, 0, 1, 4, 1, false), matInvisible), [0.6, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      Y: [
        [new Mesh(new CylinderGeometry(0.2, 0, 1, 4, 1, false), matInvisible), [0, 0.6, 0]]
      ],
      Z: [
        [new Mesh(new CylinderGeometry(0.2, 0, 1, 4, 1, false), matInvisible), [0, 0, 0.6], [Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new Mesh(new OctahedronGeometry(0.2, 0), matInvisible)]
      ],
      XY: [
        [new Mesh(new PlaneGeometry(0.4, 0.4), matInvisible), [0.2, 0.2, 0]]
      ],
      YZ: [
        [new Mesh(new PlaneGeometry(0.4, 0.4), matInvisible), [0, 0.2, 0.2], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new Mesh(new PlaneGeometry(0.4, 0.4), matInvisible), [0.2, 0, 0.2], [-Math.PI / 2, 0, 0]]
      ]
    };
    const helperTranslate = {
      START: [
        [new Mesh(new OctahedronGeometry(0.01, 2), matHelper), null, null, null, "helper"]
      ],
      END: [
        [new Mesh(new OctahedronGeometry(0.01, 2), matHelper), null, null, null, "helper"]
      ],
      DELTA: [
        [new Line(TranslateHelperGeometry(), matHelper), null, null, null, "helper"]
      ],
      X: [
        [new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ],
      Y: [
        [new Line(lineGeometry, matHelper.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], "helper"]
      ],
      Z: [
        [new Line(lineGeometry, matHelper.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], "helper"]
      ]
    };
    const gizmoRotate = {
      X: [
        [new Line(CircleGeometry(1, 0.5), matLineRed)],
        [new Mesh(new OctahedronGeometry(0.04, 0), matRed), [0, 0, 0.99], null, [1, 3, 1]]
      ],
      Y: [
        [new Line(CircleGeometry(1, 0.5), matLineGreen), null, [0, 0, -Math.PI / 2]],
        [new Mesh(new OctahedronGeometry(0.04, 0), matGreen), [0, 0, 0.99], null, [3, 1, 1]]
      ],
      Z: [
        [new Line(CircleGeometry(1, 0.5), matLineBlue), null, [0, Math.PI / 2, 0]],
        [new Mesh(new OctahedronGeometry(0.04, 0), matBlue), [0.99, 0, 0], null, [1, 3, 1]]
      ],
      E: [
        [new Line(CircleGeometry(1.25, 1), matLineYellowTransparent), null, [0, Math.PI / 2, 0]],
        [new Mesh(new CylinderGeometry(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent), [1.17, 0, 0], [0, 0, -Math.PI / 2], [1, 1, 1e-3]],
        [new Mesh(new CylinderGeometry(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent), [-1.17, 0, 0], [0, 0, Math.PI / 2], [1, 1, 1e-3]],
        [new Mesh(new CylinderGeometry(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent), [0, -1.17, 0], [Math.PI, 0, 0], [1, 1, 1e-3]],
        [new Mesh(new CylinderGeometry(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent), [0, 1.17, 0], [0, 0, 0], [1, 1, 1e-3]]
      ],
      XYZE: [
        [new Line(CircleGeometry(1, 1), matLineGray), null, [0, Math.PI / 2, 0]]
      ]
    };
    const helperRotate = {
      AXIS: [
        [new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ]
    };
    const pickerRotate = {
      X: [
        [new Mesh(new TorusGeometry(1, 0.1, 4, 24), matInvisible), [0, 0, 0], [0, -Math.PI / 2, -Math.PI / 2]]
      ],
      Y: [
        [new Mesh(new TorusGeometry(1, 0.1, 4, 24), matInvisible), [0, 0, 0], [Math.PI / 2, 0, 0]]
      ],
      Z: [
        [new Mesh(new TorusGeometry(1, 0.1, 4, 24), matInvisible), [0, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      E: [
        [new Mesh(new TorusGeometry(1.25, 0.1, 2, 24), matInvisible)]
      ],
      XYZE: [
        [new Mesh(new SphereGeometry(0.7, 10, 8), matInvisible)]
      ]
    };
    const gizmoScale = {
      X: [
        [new Mesh(scaleHandleGeometry, matRed), [0.8, 0, 0], [0, 0, -Math.PI / 2]],
        [new Line(lineGeometry, matLineRed), null, null, [0.8, 1, 1]]
      ],
      Y: [
        [new Mesh(scaleHandleGeometry, matGreen), [0, 0.8, 0]],
        [new Line(lineGeometry, matLineGreen), null, [0, 0, Math.PI / 2], [0.8, 1, 1]]
      ],
      Z: [
        [new Mesh(scaleHandleGeometry, matBlue), [0, 0, 0.8], [Math.PI / 2, 0, 0]],
        [new Line(lineGeometry, matLineBlue), null, [0, -Math.PI / 2, 0], [0.8, 1, 1]]
      ],
      XY: [
        [new Mesh(scaleHandleGeometry, matYellowTransparent), [0.85, 0.85, 0], null, [2, 2, 0.2]],
        [new Line(lineGeometry, matLineYellow), [0.855, 0.98, 0], null, [0.125, 1, 1]],
        [new Line(lineGeometry, matLineYellow), [0.98, 0.855, 0], [0, 0, Math.PI / 2], [0.125, 1, 1]]
      ],
      YZ: [
        [new Mesh(scaleHandleGeometry, matCyanTransparent), [0, 0.85, 0.85], null, [0.2, 2, 2]],
        [new Line(lineGeometry, matLineCyan), [0, 0.855, 0.98], [0, 0, Math.PI / 2], [0.125, 1, 1]],
        [new Line(lineGeometry, matLineCyan), [0, 0.98, 0.855], [0, -Math.PI / 2, 0], [0.125, 1, 1]]
      ],
      XZ: [
        [new Mesh(scaleHandleGeometry, matMagentaTransparent), [0.85, 0, 0.85], null, [2, 0.2, 2]],
        [new Line(lineGeometry, matLineMagenta), [0.855, 0, 0.98], null, [0.125, 1, 1]],
        [new Line(lineGeometry, matLineMagenta), [0.98, 0, 0.855], [0, -Math.PI / 2, 0], [0.125, 1, 1]]
      ],
      XYZX: [
        [new Mesh(new BoxGeometry(0.125, 0.125, 0.125), matWhiteTransparent.clone()), [1.1, 0, 0]]
      ],
      XYZY: [
        [new Mesh(new BoxGeometry(0.125, 0.125, 0.125), matWhiteTransparent.clone()), [0, 1.1, 0]]
      ],
      XYZZ: [
        [new Mesh(new BoxGeometry(0.125, 0.125, 0.125), matWhiteTransparent.clone()), [0, 0, 1.1]]
      ]
    };
    const pickerScale = {
      X: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.8, 4, 1, false), matInvisible), [0.5, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      Y: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.8, 4, 1, false), matInvisible), [0, 0.5, 0]]
      ],
      Z: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.8, 4, 1, false), matInvisible), [0, 0, 0.5], [Math.PI / 2, 0, 0]]
      ],
      XY: [
        [new Mesh(scaleHandleGeometry, matInvisible), [0.85, 0.85, 0], null, [3, 3, 0.2]]
      ],
      YZ: [
        [new Mesh(scaleHandleGeometry, matInvisible), [0, 0.85, 0.85], null, [0.2, 3, 3]]
      ],
      XZ: [
        [new Mesh(scaleHandleGeometry, matInvisible), [0.85, 0, 0.85], null, [3, 0.2, 3]]
      ],
      XYZX: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.2), matInvisible), [1.1, 0, 0]]
      ],
      XYZY: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.2), matInvisible), [0, 1.1, 0]]
      ],
      XYZZ: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.2), matInvisible), [0, 0, 1.1]]
      ]
    };
    const helperScale = {
      X: [
        [new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ],
      Y: [
        [new Line(lineGeometry, matHelper.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], "helper"]
      ],
      Z: [
        [new Line(lineGeometry, matHelper.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], "helper"]
      ]
    };
    function setupGizmo(gizmoMap) {
      const gizmo = new Object3D();
      for (const name in gizmoMap) {
        for (let i = gizmoMap[name].length; i--; ) {
          const object = gizmoMap[name][i][0].clone();
          const position = gizmoMap[name][i][1];
          const rotation = gizmoMap[name][i][2];
          const scale = gizmoMap[name][i][3];
          const tag = gizmoMap[name][i][4];
          object.name = name;
          object.tag = tag;
          if (position) {
            object.position.set(position[0], position[1], position[2]);
          }
          if (rotation) {
            object.rotation.set(rotation[0], rotation[1], rotation[2]);
          }
          if (scale) {
            object.scale.set(scale[0], scale[1], scale[2]);
          }
          object.updateMatrix();
          const tempGeometry = object.geometry.clone();
          tempGeometry.applyMatrix4(object.matrix);
          object.geometry = tempGeometry;
          object.renderOrder = Infinity;
          object.position.set(0, 0, 0);
          object.rotation.set(0, 0, 0);
          object.scale.set(1, 1, 1);
          gizmo.add(object);
        }
      }
      return gizmo;
    }
    this.gizmo = {};
    this.picker = {};
    this.helper = {};
    this.add(this.gizmo["translate"] = setupGizmo(gizmoTranslate));
    this.add(this.gizmo["rotate"] = setupGizmo(gizmoRotate));
    this.add(this.gizmo["scale"] = setupGizmo(gizmoScale));
    this.add(this.picker["translate"] = setupGizmo(pickerTranslate));
    this.add(this.picker["rotate"] = setupGizmo(pickerRotate));
    this.add(this.picker["scale"] = setupGizmo(pickerScale));
    this.add(this.helper["translate"] = setupGizmo(helperTranslate));
    this.add(this.helper["rotate"] = setupGizmo(helperRotate));
    this.add(this.helper["scale"] = setupGizmo(helperScale));
    this.picker["translate"].visible = false;
    this.picker["rotate"].visible = false;
    this.picker["scale"].visible = false;
  }
  updateMatrixWorld(force) {
    const space = this.mode === "scale" ? "local" : this.space;
    const quaternion = space === "local" ? this.worldQuaternion : _identityQuaternion;
    this.gizmo["translate"].visible = this.mode === "translate";
    this.gizmo["rotate"].visible = this.mode === "rotate";
    this.gizmo["scale"].visible = this.mode === "scale";
    this.helper["translate"].visible = this.mode === "translate";
    this.helper["rotate"].visible = this.mode === "rotate";
    this.helper["scale"].visible = this.mode === "scale";
    let handles = [];
    handles = handles.concat(this.picker[this.mode].children);
    handles = handles.concat(this.gizmo[this.mode].children);
    handles = handles.concat(this.helper[this.mode].children);
    for (let i = 0; i < handles.length; i++) {
      const handle = handles[i];
      handle.visible = true;
      handle.rotation.set(0, 0, 0);
      handle.position.copy(this.worldPosition);
      let factor;
      if (this.camera.isOrthographicCamera) {
        factor = (this.camera.top - this.camera.bottom) / this.camera.zoom;
      } else {
        factor = this.worldPosition.distanceTo(this.cameraPosition) * Math.min(1.9 * Math.tan(Math.PI * this.camera.fov / 360) / this.camera.zoom, 7);
      }
      handle.scale.set(1, 1, 1).multiplyScalar(factor * this.size / 7);
      if (handle.tag === "helper") {
        handle.visible = false;
        if (handle.name === "AXIS") {
          handle.position.copy(this.worldPositionStart);
          handle.visible = !!this.axis;
          if (this.axis === "X") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, 0, 0));
            handle.quaternion.copy(quaternion).multiply(_tempQuaternion);
            if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(this.eye)) > 0.9) {
              handle.visible = false;
            }
          }
          if (this.axis === "Y") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, 0, Math.PI / 2));
            handle.quaternion.copy(quaternion).multiply(_tempQuaternion);
            if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(this.eye)) > 0.9) {
              handle.visible = false;
            }
          }
          if (this.axis === "Z") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, Math.PI / 2, 0));
            handle.quaternion.copy(quaternion).multiply(_tempQuaternion);
            if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(this.eye)) > 0.9) {
              handle.visible = false;
            }
          }
          if (this.axis === "XYZE") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, Math.PI / 2, 0));
            _alignVector.copy(this.rotationAxis);
            handle.quaternion.setFromRotationMatrix(_lookAtMatrix.lookAt(_zeroVector, _alignVector, _unitY));
            handle.quaternion.multiply(_tempQuaternion);
            handle.visible = this.dragging;
          }
          if (this.axis === "E") {
            handle.visible = false;
          }
        } else if (handle.name === "START") {
          handle.position.copy(this.worldPositionStart);
          handle.visible = this.dragging;
        } else if (handle.name === "END") {
          handle.position.copy(this.worldPosition);
          handle.visible = this.dragging;
        } else if (handle.name === "DELTA") {
          handle.position.copy(this.worldPositionStart);
          handle.quaternion.copy(this.worldQuaternionStart);
          _tempVector.set(1e-10, 1e-10, 1e-10).add(this.worldPositionStart).sub(this.worldPosition).multiplyScalar(-1);
          _tempVector.applyQuaternion(this.worldQuaternionStart.clone().invert());
          handle.scale.copy(_tempVector);
          handle.visible = this.dragging;
        } else {
          handle.quaternion.copy(quaternion);
          if (this.dragging) {
            handle.position.copy(this.worldPositionStart);
          } else {
            handle.position.copy(this.worldPosition);
          }
          if (this.axis) {
            handle.visible = this.axis.search(handle.name) !== -1;
          }
        }
        continue;
      }
      handle.quaternion.copy(quaternion);
      if (this.mode === "translate" || this.mode === "scale") {
        const AXIS_HIDE_TRESHOLD = 0.99;
        const PLANE_HIDE_TRESHOLD = 0.2;
        const AXIS_FLIP_TRESHOLD = 0;
        if (handle.name === "X" || handle.name === "XYZX") {
          if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "Y" || handle.name === "XYZY") {
          if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "Z" || handle.name === "XYZZ") {
          if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "XY") {
          if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "YZ") {
          if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "XZ") {
          if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name.search("X") !== -1) {
          if (_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(this.eye) < AXIS_FLIP_TRESHOLD) {
            if (handle.tag === "fwd") {
              handle.visible = false;
            } else {
              handle.scale.x *= -1;
            }
          } else if (handle.tag === "bwd") {
            handle.visible = false;
          }
        }
        if (handle.name.search("Y") !== -1) {
          if (_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(this.eye) < AXIS_FLIP_TRESHOLD) {
            if (handle.tag === "fwd") {
              handle.visible = false;
            } else {
              handle.scale.y *= -1;
            }
          } else if (handle.tag === "bwd") {
            handle.visible = false;
          }
        }
        if (handle.name.search("Z") !== -1) {
          if (_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(this.eye) < AXIS_FLIP_TRESHOLD) {
            if (handle.tag === "fwd") {
              handle.visible = false;
            } else {
              handle.scale.z *= -1;
            }
          } else if (handle.tag === "bwd") {
            handle.visible = false;
          }
        }
      } else if (this.mode === "rotate") {
        _tempQuaternion2.copy(quaternion);
        _alignVector.copy(this.eye).applyQuaternion(_tempQuaternion.copy(quaternion).invert());
        if (handle.name.search("E") !== -1) {
          handle.quaternion.setFromRotationMatrix(_lookAtMatrix.lookAt(this.eye, _zeroVector, _unitY));
        }
        if (handle.name === "X") {
          _tempQuaternion.setFromAxisAngle(_unitX, Math.atan2(-_alignVector.y, _alignVector.z));
          _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);
          handle.quaternion.copy(_tempQuaternion);
        }
        if (handle.name === "Y") {
          _tempQuaternion.setFromAxisAngle(_unitY, Math.atan2(_alignVector.x, _alignVector.z));
          _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);
          handle.quaternion.copy(_tempQuaternion);
        }
        if (handle.name === "Z") {
          _tempQuaternion.setFromAxisAngle(_unitZ, Math.atan2(_alignVector.y, _alignVector.x));
          _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);
          handle.quaternion.copy(_tempQuaternion);
        }
      }
      handle.visible = handle.visible && (handle.name.indexOf("X") === -1 || this.showX);
      handle.visible = handle.visible && (handle.name.indexOf("Y") === -1 || this.showY);
      handle.visible = handle.visible && (handle.name.indexOf("Z") === -1 || this.showZ);
      handle.visible = handle.visible && (handle.name.indexOf("E") === -1 || this.showX && this.showY && this.showZ);
      handle.material._opacity = handle.material._opacity || handle.material.opacity;
      handle.material._color = handle.material._color || handle.material.color.clone();
      handle.material.color.copy(handle.material._color);
      handle.material.opacity = handle.material._opacity;
      if (!this.enabled) {
        handle.material.opacity *= 0.5;
        handle.material.color.lerp(new Color(1, 1, 1), 0.5);
      } else if (this.axis) {
        if (handle.name === this.axis) {
          handle.material.opacity = 1;
          handle.material.color.lerp(new Color(1, 1, 1), 0.5);
        } else if (this.axis.split("").some(function(a) {
          return handle.name === a;
        })) {
          handle.material.opacity = 1;
          handle.material.color.lerp(new Color(1, 1, 1), 0.5);
        } else {
          handle.material.opacity *= 0.25;
          handle.material.color.lerp(new Color(1, 1, 1), 0.5);
        }
      }
    }
    super.updateMatrixWorld(force);
  }
}
TransformControlsGizmo.prototype.isTransformControlsGizmo = true;
class TransformControlsPlane extends Mesh {
  constructor() {
    super(
      new PlaneGeometry(1e5, 1e5, 2, 2),
      new MeshBasicMaterial({ visible: false, wireframe: true, side: DoubleSide, transparent: true, opacity: 0.1, toneMapped: false })
    );
    this.type = "TransformControlsPlane";
  }
  updateMatrixWorld(force) {
    let space = this.space;
    this.position.copy(this.worldPosition);
    if (this.mode === "scale")
      space = "local";
    _v1.copy(_unitX).applyQuaternion(space === "local" ? this.worldQuaternion : _identityQuaternion);
    _v2.copy(_unitY).applyQuaternion(space === "local" ? this.worldQuaternion : _identityQuaternion);
    _v3.copy(_unitZ).applyQuaternion(space === "local" ? this.worldQuaternion : _identityQuaternion);
    _alignVector.copy(_v2);
    switch (this.mode) {
      case "translate":
      case "scale":
        switch (this.axis) {
          case "X":
            _alignVector.copy(this.eye).cross(_v1);
            _dirVector.copy(_v1).cross(_alignVector);
            break;
          case "Y":
            _alignVector.copy(this.eye).cross(_v2);
            _dirVector.copy(_v2).cross(_alignVector);
            break;
          case "Z":
            _alignVector.copy(this.eye).cross(_v3);
            _dirVector.copy(_v3).cross(_alignVector);
            break;
          case "XY":
            _dirVector.copy(_v3);
            break;
          case "YZ":
            _dirVector.copy(_v1);
            break;
          case "XZ":
            _alignVector.copy(_v3);
            _dirVector.copy(_v2);
            break;
          case "XYZ":
          case "E":
            _dirVector.set(0, 0, 0);
            break;
        }
        break;
      case "rotate":
      default:
        _dirVector.set(0, 0, 0);
    }
    if (_dirVector.length() === 0) {
      this.quaternion.copy(this.cameraQuaternion);
    } else {
      _tempMatrix.lookAt(_tempVector.set(0, 0, 0), _dirVector, _alignVector);
      this.quaternion.setFromRotationMatrix(_tempMatrix);
    }
    super.updateMatrixWorld(force);
  }
}
TransformControlsPlane.prototype.isTransformControlsPlane = true;
class Controls {
  constructor(instance) {
    this.onDraggingChanged = this.onDraggingChanged.bind(this);
    this.transformLoaded = false;
    this.controls = new OrbitControls(instance.camera, instance.renderer.domElement);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.05;
    this.camera = instance.camera;
    this.controls.maxPan = new Vector3$1(2, 2, 2);
    this.controls.minPan = new Vector3$1(-2, -2, -2);
    this.controls._v = new Vector3$1();
    this.controls.enablePan = true;
    this.controls.maxDistance = 6;
    this.controls.minDistance = 3;
    this.controls.maxPolarAngle = Math.PI / 2;
    this.controls.addEventListener("change", () => Events.emit("orbitChange"));
    this.transform = new TransformControls(instance.camera, instance.renderer.domElement);
    this.transform.addEventListener("dragging-changed", this.onDraggingChanged);
  }
  update() {
    this.controls.update();
    this.controls._v.copy(this.controls.target);
    this.controls.target.clamp(this.controls.minPan, this.controls.maxPan);
    this.controls._v.sub(this.controls.target);
    this.camera.position.sub(this.controls._v);
  }
  onDraggingChanged({ value }) {
    this.controls.enabled = !value;
  }
  onReset() {
    this.controls.reset();
  }
}
var markers = "";
function next() {
  return new Promise(function(resolve) {
    setTimeout(resolve, 0);
  });
}
function sleep(delay = 0) {
  return new Promise(function(resolve) {
    setTimeout(resolve, delay);
  });
}
var basement = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 25.02C27.5523 25.02 28 24.5723 28 24.02C28 23.4677 27.5523 23.02 27 23.02C26.4477 23.02 26 23.4677 26 24.02C26 24.5723 26.4477 25.02 27 25.02Z" fill="#D4D4DB"/>
<path d="M27 21.02C27.5523 21.02 28 20.5723 28 20.02C28 19.4677 27.5523 19.02 27 19.02C26.4477 19.02 26 19.4677 26 20.02C26 20.5723 26.4477 21.02 27 21.02Z" fill="#D4D4DB"/>
<path d="M27 17.02C27.5523 17.02 28 16.5723 28 16.02C28 15.4677 27.5523 15.02 27 15.02C26.4477 15.02 26 15.4677 26 16.02C26 16.5723 26.4477 17.02 27 17.02Z" fill="#D4D4DB"/>
<path d="M27 13.02C27.5523 13.02 28 12.5723 28 12.02C28 11.4677 27.5523 11.02 27 11.02C26.4477 11.02 26 11.4677 26 12.02C26 12.5723 26.4477 13.02 27 13.02Z" fill="#D4D4DB"/>
<path d="M27 29.02C27.5523 29.02 28 28.5723 28 28.02C28 27.4677 27.5523 27.02 27 27.02C26.4477 27.02 26 27.4677 26 28.02C26 28.5723 26.4477 29.02 27 29.02Z" fill="#D4D4DB"/>
<path d="M3 23.02C2.80222 23.02 2.60888 23.0787 2.44443 23.1885C2.27998 23.2984 2.15181 23.4546 2.07612 23.6373C2.00043 23.8201 1.98063 24.0211 2.01922 24.2151C2.0578 24.4091 2.15304 24.5873 2.29289 24.7271C2.43275 24.867 2.61093 24.9622 2.80491 25.0008C2.99889 25.0394 3.19996 25.0196 3.38268 24.9439C3.56541 24.8682 3.72159 24.74 3.83147 24.5756C3.94135 24.4111 4 24.2178 4 24.02C4 23.7548 3.89464 23.5004 3.70711 23.3129C3.51957 23.1254 3.26522 23.02 3 23.02Z" fill="#D4D4DB"/>
<path d="M3 21.02C3.55228 21.02 4 20.5723 4 20.02C4 19.4677 3.55228 19.02 3 19.02C2.44772 19.02 2 19.4677 2 20.02C2 20.5723 2.44772 21.02 3 21.02Z" fill="#D4D4DB"/>
<path d="M3 17.02C3.55228 17.02 4 16.5723 4 16.02C4 15.4677 3.55228 15.02 3 15.02C2.44772 15.02 2 15.4677 2 16.02C2 16.5723 2.44772 17.02 3 17.02Z" fill="#D4D4DB"/>
<path d="M3 13.02C3.55228 13.02 4 12.5723 4 12.02C4 11.4677 3.55228 11.02 3 11.02C2.44772 11.02 2 11.4677 2 12.02C2 12.5723 2.44772 13.02 3 13.02Z" fill="#D4D4DB"/>
<path d="M3 29.02C3.55228 29.02 4 28.5723 4 28.02C4 27.4677 3.55228 27.02 3 27.02C2.44772 27.02 2 27.4677 2 28.02C2 28.5723 2.44772 29.02 3 29.02Z" fill="#D4D4DB"/>
<path d="M28 12.02C28.2191 12.0199 28.4321 11.9479 28.6063 11.815C28.7805 11.6821 28.9062 11.4957 28.9641 11.2844C29.0221 11.0731 29.009 10.8487 28.927 10.6455C28.8449 10.4424 28.6984 10.2718 28.51 10.16L15.58 1.2C15.4069 1.07018 15.1964 1 14.98 1C14.7636 1 14.5531 1.07018 14.38 1.2L9.00001 4.96V4.02C9.00001 3.75478 8.89465 3.50043 8.70712 3.31289C8.51958 3.12536 8.26523 3.02 8.00001 3.02H7.00001C6.7348 3.02 6.48044 3.12536 6.2929 3.31289C6.10537 3.50043 6.00001 3.75478 6.00001 4.02V7.02L1.49001 10.16C1.3016 10.2718 1.15511 10.4424 1.07307 10.6455C0.991025 10.8487 0.977967 11.0731 1.0359 11.2844C1.09384 11.4957 1.21956 11.6821 1.39374 11.815C1.56792 11.9479 1.78092 12.0199 2.00001 12.02H28Z" fill="#D4D4DB"/>
<path d="M6.96002 24.98C7.51231 24.98 7.96002 24.5323 7.96002 23.98C7.96002 23.4277 7.51231 22.98 6.96002 22.98C6.40774 22.98 5.96002 23.4277 5.96002 23.98C5.96002 24.5323 6.40774 24.98 6.96002 24.98Z" fill="#D4D4DB"/>
<path d="M10.96 24.98C11.5123 24.98 11.96 24.5323 11.96 23.98C11.96 23.4277 11.5123 22.98 10.96 22.98C10.4077 22.98 9.96002 23.4277 9.96002 23.98C9.96002 24.5323 10.4077 24.98 10.96 24.98Z" fill="#D4D4DB"/>
<path d="M14.96 24.98C15.5123 24.98 15.96 24.5323 15.96 23.98C15.96 23.4277 15.5123 22.98 14.96 22.98C14.4077 22.98 13.96 23.4277 13.96 23.98C13.96 24.5323 14.4077 24.98 14.96 24.98Z" fill="#D4D4DB"/>
<path d="M19.01 24.98C19.5623 24.98 20.01 24.5323 20.01 23.98C20.01 23.4277 19.5623 22.98 19.01 22.98C18.4577 22.98 18.01 23.4277 18.01 23.98C18.01 24.5323 18.4577 24.98 19.01 24.98Z" fill="#D4D4DB"/>
<path d="M23.01 24.98C23.5623 24.98 24.01 24.5323 24.01 23.98C24.01 23.4277 23.5623 22.98 23.01 22.98C22.4577 22.98 22.01 23.4277 22.01 23.98C22.01 24.5323 22.4577 24.98 23.01 24.98Z" fill="#D4D4DB"/>
<path d="M27 27.02H3C2.73478 27.02 2.48043 27.1254 2.29289 27.3129C2.10536 27.5004 2 27.7548 2 28.02C2 28.2852 2.10536 28.5396 2.29289 28.7271C2.48043 28.9147 2.73478 29.02 3 29.02H27C27.2652 29.02 27.5196 28.9147 27.7071 28.7271C27.8946 28.5396 28 28.2852 28 28.02C28 27.7548 27.8946 27.5004 27.7071 27.3129C27.5196 27.1254 27.2652 27.02 27 27.02Z" fill="#2E3341"/>
</svg>

`;
var basementfloor = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 26.02C27.5523 26.02 28 25.5723 28 25.02C28 24.4677 27.5523 24.02 27 24.02C26.4477 24.02 26 24.4677 26 25.02C26 25.5723 26.4477 26.02 27 26.02Z" fill="#D4D4DB"/>
<path d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z" fill="#D4D4DB"/>
<path d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z" fill="#D4D4DB"/>
<path d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z" fill="#D4D4DB"/>
<path d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z" fill="#D4D4DB"/>
<path d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z" fill="#D4D4DB"/>
<path d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z" fill="#D4D4DB"/>
<path d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z" fill="#D4D4DB"/>
<path d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z" fill="#D4D4DB"/>
<path d="M28 11.02H2C1.73478 11.02 1.48043 11.1254 1.29289 11.3129C1.10536 11.5004 1 11.7548 1 12.02C1 12.2852 1.10536 12.5396 1.29289 12.7271C1.48043 12.9147 1.73478 13.02 2 13.02H28C28.2652 13.02 28.5196 12.9147 28.7071 12.7271C28.8946 12.5396 29 12.2852 29 12.02C29 11.7548 28.8946 11.5004 28.7071 11.3129C28.5196 11.1254 28.2652 11.02 28 11.02Z" fill="#2E3341"/>
</svg>

`;
var cavitywall = `
<svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26 24.02C26.5523 24.02 27 23.5723 27 23.02C27 22.4677 26.5523 22.02 26 22.02C25.4477 22.02 25 22.4677 25 23.02C25 23.5723 25.4477 24.02 26 24.02Z" fill="#D4D4DB"/>
<path d="M26 20.02C26.5523 20.02 27 19.5723 27 19.02C27 18.4677 26.5523 18.02 26 18.02C25.4477 18.02 25 18.4677 25 19.02C25 19.5723 25.4477 20.02 26 20.02Z" fill="#D4D4DB"/>
<path d="M26 16.02C26.5523 16.02 27 15.5723 27 15.02C27 14.4677 26.5523 14.02 26 14.02C25.4477 14.02 25 14.4677 25 15.02C25 15.5723 25.4477 16.02 26 16.02Z" fill="#D4D4DB"/>
<path d="M26 12.02C26.5523 12.02 27 11.5723 27 11.02C27 10.4677 26.5523 10.02 26 10.02C25.4477 10.02 25 10.4677 25 11.02C25 11.5723 25.4477 12.02 26 12.02Z" fill="#D4D4DB"/>
<path d="M18 24.02C18.5523 24.02 19 23.5723 19 23.02C19 22.4677 18.5523 22.02 18 22.02C17.4477 22.02 17 22.4677 17 23.02C17 23.5723 17.4477 24.02 18 24.02Z" fill="#D4D4DB"/>
<path d="M18 20.02C18.5523 20.02 19 19.5723 19 19.02C19 18.4677 18.5523 18.02 18 18.02C17.4477 18.02 17 18.4677 17 19.02C17 19.5723 17.4477 20.02 18 20.02Z" fill="#D4D4DB"/>
<path d="M18 16.02C18.5523 16.02 19 15.5723 19 15.02C19 14.4677 18.5523 14.02 18 14.02C17.4477 14.02 17 14.4677 17 15.02C17 15.5723 17.4477 16.02 18 16.02Z" fill="#D4D4DB"/>
<path d="M18 12.02C18.5523 12.02 19 11.5723 19 11.02C19 10.4677 18.5523 10.02 18 10.02C17.4477 10.02 17 10.4677 17 11.02C17 11.5723 17.4477 12.02 18 12.02Z" fill="#D4D4DB"/>
<path d="M2 22.02C1.80222 22.02 1.60888 22.0787 1.44443 22.1885C1.27998 22.2984 1.15181 22.4546 1.07612 22.6373C1.00043 22.8201 0.98063 23.0211 1.01922 23.2151C1.0578 23.4091 1.15304 23.5873 1.29289 23.7271C1.43275 23.867 1.61093 23.9622 1.80491 24.0008C1.99889 24.0394 2.19996 24.0196 2.38268 23.9439C2.56541 23.8682 2.72159 23.74 2.83147 23.5756C2.94135 23.4111 3 23.2178 3 23.02C3 22.7548 2.89464 22.5004 2.70711 22.3129C2.51957 22.1254 2.26522 22.02 2 22.02Z" fill="#D4D4DB"/>
<path d="M2 20.02C2.55228 20.02 3 19.5723 3 19.02C3 18.4677 2.55228 18.02 2 18.02C1.44772 18.02 1 18.4677 1 19.02C1 19.5723 1.44772 20.02 2 20.02Z" fill="#D4D4DB"/>
<path d="M2 16.02C2.55228 16.02 3 15.5723 3 15.02C3 14.4677 2.55228 14.02 2 14.02C1.44772 14.02 1 14.4677 1 15.02C1 15.5723 1.44772 16.02 2 16.02Z" fill="#D4D4DB"/>
<path d="M2 12.02C2.55228 12.02 3 11.5723 3 11.02C3 10.4677 2.55228 10.02 2 10.02C1.44772 10.02 1 10.4677 1 11.02C1 11.5723 1.44772 12.02 2 12.02Z" fill="#D4D4DB"/>
<path d="M23.05 23.02V11.02C23.05 10.7548 22.9447 10.5004 22.7571 10.3129C22.5696 10.1254 22.3152 10.02 22.05 10.02C21.7848 10.02 21.5304 10.1254 21.3429 10.3129C21.1554 10.5004 21.05 10.7548 21.05 11.02V23.02C21.05 23.2852 21.1554 23.5396 21.3429 23.7271C21.5304 23.9147 21.7848 24.02 22.05 24.02C22.3152 24.02 22.5696 23.9147 22.7571 23.7271C22.9447 23.5396 23.05 23.2852 23.05 23.02Z" fill="#2E3341"/>
<path d="M27 11.02C27.2191 11.0199 27.4321 10.9479 27.6063 10.815C27.7805 10.6821 27.9062 10.4957 27.9641 10.2844C28.0221 10.0731 28.009 9.84868 27.927 9.64553C27.8449 9.44238 27.6984 9.2718 27.51 9.16L14.58 0.2C14.4069 0.0701779 14.1964 0 13.98 0C13.7636 0 13.5531 0.0701779 13.38 0.2L8.00001 3.96V3.02C8.00001 2.75478 7.89465 2.50043 7.70712 2.31289C7.51958 2.12536 7.26523 2.02 7.00001 2.02H6.00001C5.7348 2.02 5.48044 2.12536 5.2929 2.31289C5.10537 2.50043 5.00001 2.75478 5.00001 3.02V6.02L0.490012 9.16C0.301596 9.2718 0.155109 9.44238 0.073067 9.64553C-0.00897523 9.84868 -0.0220327 10.0731 0.0359015 10.2844C0.0938357 10.4957 0.219555 10.6821 0.393737 10.815C0.567919 10.9479 0.780923 11.0199 1.00001 11.02H27Z" fill="#D4D4DB"/>
</svg>

`;
var toggle = `
<svg class="icon-eye-open" width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" d="M15 5C6.0817 5 0.320988 14.2112 0.216797 14.3789C0.0765534 14.5556 0.000151623 14.7744 0 15C0.000177403 15.1935 0.05649 15.3828 0.162109 15.5449C0.163405 15.5469 0.164707 15.5488 0.166016 15.5508C0.183209 15.5863 5.01883 25 15 25C24.9388 25 29.7673 15.6787 29.8262 15.5645C29.8302 15.558 29.8341 15.5515 29.8379 15.5449C29.9435 15.3828 29.9998 15.1935 30 15C30 14.7753 29.9243 14.5572 29.7852 14.3809C29.7845 14.3802 29.7839 14.3796 29.7832 14.3789C29.679 14.2112 23.9183 5 15 5ZM15 8C18.866 8 22 11.134 22 15C22 18.866 18.866 22 15 22C11.134 22 8 18.866 8 15C8 11.134 11.134 8 15 8ZM15 12C14.2044 12 13.4413 12.3161 12.8787 12.8787C12.3161 13.4413 12 14.2044 12 15C12 15.7956 12.3161 16.5587 12.8787 17.1213C13.4413 17.6839 14.2044 18 15 18C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15C18 14.2044 17.6839 13.4413 17.1213 12.8787C16.5587 12.3161 15.7956 12 15 12Z" fill="black"/>
</svg>
<svg class="icon-eye-closed" width="20" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.002 0C6.69567 0 1.32722 8.20874 1.2168 8.37891C1.21564 8.38068 1.19531 8.4082 1.19531 8.4082C1.06883 8.57963 1.00041 8.78697 1 9C1.00018 9.1935 1.05649 9.38279 1.16211 9.54492C1.16594 9.55148 1.16985 9.55799 1.17383 9.56445C1.19443 9.60279 1.75918 10.5977 2.82031 11.8867L1.32422 13.2637C1.22685 13.3524 1.14796 13.4594 1.09207 13.5787C1.03619 13.698 1.00441 13.8271 0.998571 13.9587C0.99273 14.0903 1.01294 14.2217 1.05803 14.3454C1.10313 14.4692 1.17222 14.5828 1.26135 14.6798C1.35048 14.7768 1.45789 14.8552 1.5774 14.9105C1.69692 14.9659 1.82619 14.9971 1.9578 15.0023C2.0894 15.0076 2.22075 14.9868 2.3443 14.9411C2.46785 14.8955 2.58116 14.8259 2.67773 14.7363L4.16797 13.3652C4.66055 13.849 5.21418 14.3341 5.83008 14.8066L4.81445 16.3965C4.74066 16.5071 4.68968 16.6314 4.6645 16.762C4.63932 16.8926 4.64044 17.0269 4.66781 17.1571C4.69517 17.2873 4.74823 17.4107 4.82387 17.5201C4.89951 17.6295 4.99621 17.7227 5.10832 17.7943C5.22043 17.8659 5.34569 17.9144 5.47677 17.9369C5.60785 17.9595 5.74212 17.9557 5.87171 17.9258C6.00131 17.8958 6.12363 17.8403 6.23151 17.7625C6.33939 17.6847 6.43067 17.5862 6.5 17.4727L7.48633 15.9297C8.15181 16.3224 8.87784 16.6723 9.65039 16.9766L9.05664 18.6699C9.0133 18.7939 8.9948 18.9253 9.00221 19.0564C9.00962 19.1876 9.04279 19.316 9.09983 19.4343C9.15687 19.5527 9.23666 19.6586 9.33464 19.7461C9.43263 19.8336 9.54689 19.901 9.6709 19.9443C9.79491 19.9877 9.92625 20.0062 10.0574 19.9988C10.1886 19.9914 10.317 19.9582 10.4353 19.9011C10.5537 19.8441 10.6596 19.7643 10.7471 19.6663C10.8346 19.5683 10.902 19.4541 10.9453 19.3301L11.5547 17.5879C12.3234 17.7733 13.1441 17.8859 14 17.9434V20C13.9981 20.1325 14.0226 20.2641 14.072 20.387C14.1214 20.51 14.1948 20.6219 14.2878 20.7163C14.3809 20.8107 14.4918 20.8856 14.614 20.9368C14.7363 20.9879 14.8675 21.0142 15 21.0142C15.1325 21.0142 15.2637 20.9879 15.386 20.9368C15.5082 20.8856 15.6191 20.8107 15.7122 20.7163C15.8052 20.6219 15.8786 20.51 15.928 20.387C15.9774 20.2641 16.0019 20.1325 16 20V17.9434C16.8569 17.886 17.6777 17.7735 18.4473 17.5879L19.0566 19.3301C19.0964 19.4585 19.1616 19.5775 19.2484 19.6801C19.3352 19.7828 19.4418 19.8668 19.5618 19.9273C19.6818 19.9878 19.8127 20.0235 19.9468 20.0323C20.0809 20.0411 20.2155 20.0227 20.3423 19.9783C20.4692 19.9339 20.5858 19.8644 20.6852 19.774C20.7846 19.6835 20.8647 19.5739 20.9208 19.4518C20.9769 19.3297 21.0078 19.1975 21.0117 19.0632C21.0156 18.9288 20.9923 18.7951 20.9434 18.6699L20.3516 16.9766C21.1241 16.6723 21.8502 16.3224 22.5156 15.9297L23.502 17.4727C23.5713 17.5862 23.6626 17.6847 23.7704 17.7625C23.8783 17.8403 24.0006 17.8958 24.1302 17.9258C24.2598 17.9557 24.3941 17.9595 24.5252 17.9369C24.6563 17.9144 24.7815 17.8659 24.8936 17.7943C25.0057 17.7227 25.1024 17.6295 25.1781 17.5201C25.2537 17.4107 25.3068 17.2873 25.3341 17.1571C25.3615 17.0269 25.3626 16.8926 25.3375 16.762C25.3123 16.6314 25.2613 16.5071 25.1875 16.3965L24.1719 14.8066C24.7878 14.3341 25.3414 13.849 25.834 13.3652L27.3223 14.7363C27.419 14.8254 27.5322 14.8945 27.6556 14.9397C27.779 14.985 27.9102 15.0055 28.0415 15.0001C28.1728 14.9946 28.3018 14.9634 28.4211 14.9081C28.5403 14.8528 28.6475 14.7746 28.7365 14.6779C28.8255 14.5812 28.8946 14.4679 28.9398 14.3445C28.9851 14.2211 29.0055 14.0899 29.0001 13.9586C28.9946 13.8273 28.9633 13.6983 28.908 13.5791C28.8527 13.4598 28.7745 13.3527 28.6777 13.2637L27.1816 11.8867C28.2557 10.5818 28.8263 9.56769 28.834 9.55273C28.834 9.55262 28.8379 9.54492 28.8379 9.54492C28.9435 9.38279 28.9998 9.1935 29 9C28.9997 8.78785 28.932 8.58128 28.8066 8.41016C28.8066 8.4095 28.8066 8.40885 28.8066 8.4082C28.8066 8.4082 23.395 0 15.002 0Z" fill="black"/>
</svg>
`;
var eye = `
<svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" d="M15 5C6.0817 5 0.320988 14.2112 0.216797 14.3789C0.0765534 14.5556 0.000151623 14.7744 0 15C0.000177403 15.1935 0.05649 15.3828 0.162109 15.5449C0.163405 15.5469 0.164707 15.5488 0.166016 15.5508C0.183209 15.5863 5.01883 25 15 25C24.9388 25 29.7673 15.6787 29.8262 15.5645C29.8302 15.558 29.8341 15.5515 29.8379 15.5449C29.9435 15.3828 29.9998 15.1935 30 15C30 14.7753 29.9243 14.5572 29.7852 14.3809C29.7845 14.3802 29.7839 14.3796 29.7832 14.3789C29.679 14.2112 23.9183 5 15 5ZM15 8C18.866 8 22 11.134 22 15C22 18.866 18.866 22 15 22C11.134 22 8 18.866 8 15C8 11.134 11.134 8 15 8ZM15 12C14.2044 12 13.4413 12.3161 12.8787 12.8787C12.3161 13.4413 12 14.2044 12 15C12 15.7956 12.3161 16.5587 12.8787 17.1213C13.4413 17.6839 14.2044 18 15 18C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15C18 14.2044 17.6839 13.4413 17.1213 12.8787C16.5587 12.3161 15.7956 12 15 12Z" fill="black"/>
</svg>
`;
var eyeClosed = `
<svg width="20" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.002 0C6.69567 0 1.32722 8.20874 1.2168 8.37891C1.21564 8.38068 1.19531 8.4082 1.19531 8.4082C1.06883 8.57963 1.00041 8.78697 1 9C1.00018 9.1935 1.05649 9.38279 1.16211 9.54492C1.16594 9.55148 1.16985 9.55799 1.17383 9.56445C1.19443 9.60279 1.75918 10.5977 2.82031 11.8867L1.32422 13.2637C1.22685 13.3524 1.14796 13.4594 1.09207 13.5787C1.03619 13.698 1.00441 13.8271 0.998571 13.9587C0.99273 14.0903 1.01294 14.2217 1.05803 14.3454C1.10313 14.4692 1.17222 14.5828 1.26135 14.6798C1.35048 14.7768 1.45789 14.8552 1.5774 14.9105C1.69692 14.9659 1.82619 14.9971 1.9578 15.0023C2.0894 15.0076 2.22075 14.9868 2.3443 14.9411C2.46785 14.8955 2.58116 14.8259 2.67773 14.7363L4.16797 13.3652C4.66055 13.849 5.21418 14.3341 5.83008 14.8066L4.81445 16.3965C4.74066 16.5071 4.68968 16.6314 4.6645 16.762C4.63932 16.8926 4.64044 17.0269 4.66781 17.1571C4.69517 17.2873 4.74823 17.4107 4.82387 17.5201C4.89951 17.6295 4.99621 17.7227 5.10832 17.7943C5.22043 17.8659 5.34569 17.9144 5.47677 17.9369C5.60785 17.9595 5.74212 17.9557 5.87171 17.9258C6.00131 17.8958 6.12363 17.8403 6.23151 17.7625C6.33939 17.6847 6.43067 17.5862 6.5 17.4727L7.48633 15.9297C8.15181 16.3224 8.87784 16.6723 9.65039 16.9766L9.05664 18.6699C9.0133 18.7939 8.9948 18.9253 9.00221 19.0564C9.00962 19.1876 9.04279 19.316 9.09983 19.4343C9.15687 19.5527 9.23666 19.6586 9.33464 19.7461C9.43263 19.8336 9.54689 19.901 9.6709 19.9443C9.79491 19.9877 9.92625 20.0062 10.0574 19.9988C10.1886 19.9914 10.317 19.9582 10.4353 19.9011C10.5537 19.8441 10.6596 19.7643 10.7471 19.6663C10.8346 19.5683 10.902 19.4541 10.9453 19.3301L11.5547 17.5879C12.3234 17.7733 13.1441 17.8859 14 17.9434V20C13.9981 20.1325 14.0226 20.2641 14.072 20.387C14.1214 20.51 14.1948 20.6219 14.2878 20.7163C14.3809 20.8107 14.4918 20.8856 14.614 20.9368C14.7363 20.9879 14.8675 21.0142 15 21.0142C15.1325 21.0142 15.2637 20.9879 15.386 20.9368C15.5082 20.8856 15.6191 20.8107 15.7122 20.7163C15.8052 20.6219 15.8786 20.51 15.928 20.387C15.9774 20.2641 16.0019 20.1325 16 20V17.9434C16.8569 17.886 17.6777 17.7735 18.4473 17.5879L19.0566 19.3301C19.0964 19.4585 19.1616 19.5775 19.2484 19.6801C19.3352 19.7828 19.4418 19.8668 19.5618 19.9273C19.6818 19.9878 19.8127 20.0235 19.9468 20.0323C20.0809 20.0411 20.2155 20.0227 20.3423 19.9783C20.4692 19.9339 20.5858 19.8644 20.6852 19.774C20.7846 19.6835 20.8647 19.5739 20.9208 19.4518C20.9769 19.3297 21.0078 19.1975 21.0117 19.0632C21.0156 18.9288 20.9923 18.7951 20.9434 18.6699L20.3516 16.9766C21.1241 16.6723 21.8502 16.3224 22.5156 15.9297L23.502 17.4727C23.5713 17.5862 23.6626 17.6847 23.7704 17.7625C23.8783 17.8403 24.0006 17.8958 24.1302 17.9258C24.2598 17.9557 24.3941 17.9595 24.5252 17.9369C24.6563 17.9144 24.7815 17.8659 24.8936 17.7943C25.0057 17.7227 25.1024 17.6295 25.1781 17.5201C25.2537 17.4107 25.3068 17.2873 25.3341 17.1571C25.3615 17.0269 25.3626 16.8926 25.3375 16.762C25.3123 16.6314 25.2613 16.5071 25.1875 16.3965L24.1719 14.8066C24.7878 14.3341 25.3414 13.849 25.834 13.3652L27.3223 14.7363C27.419 14.8254 27.5322 14.8945 27.6556 14.9397C27.779 14.985 27.9102 15.0055 28.0415 15.0001C28.1728 14.9946 28.3018 14.9634 28.4211 14.9081C28.5403 14.8528 28.6475 14.7746 28.7365 14.6779C28.8255 14.5812 28.8946 14.4679 28.9398 14.3445C28.9851 14.2211 29.0055 14.0899 29.0001 13.9586C28.9946 13.8273 28.9633 13.6983 28.908 13.5791C28.8527 13.4598 28.7745 13.3527 28.6777 13.2637L27.1816 11.8867C28.2557 10.5818 28.8263 9.56769 28.834 9.55273C28.834 9.55262 28.8379 9.54492 28.8379 9.54492C28.9435 9.38279 28.9998 9.1935 29 9C28.9997 8.78785 28.932 8.58128 28.8066 8.41016C28.8066 8.4095 28.8066 8.40885 28.8066 8.4082C28.8066 8.4082 23.395 0 15.002 0Z" fill="black"/>
</svg>
`;
var flatroof = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27.09 22C27.6423 22 28.09 21.5523 28.09 21C28.09 20.4477 27.6423 20 27.09 20C26.5377 20 26.09 20.4477 26.09 21C26.09 21.5523 26.5377 22 27.09 22Z" fill="#D4D4DB"/>
<path d="M27.09 18C27.6423 18 28.09 17.5523 28.09 17C28.09 16.4477 27.6423 16 27.09 16C26.5377 16 26.09 16.4477 26.09 17C26.09 17.5523 26.5377 18 27.09 18Z" fill="#D4D4DB"/>
<path d="M27.09 14C27.6423 14 28.09 13.5523 28.09 13C28.09 12.4477 27.6423 12 27.09 12C26.5377 12 26.09 12.4477 26.09 13C26.09 13.5523 26.5377 14 27.09 14Z" fill="#D4D4DB"/>
<path d="M27.09 10C27.6423 10 28.09 9.55228 28.09 9C28.09 8.44772 27.6423 8 27.09 8C26.5377 8 26.09 8.44772 26.09 9C26.09 9.55228 26.5377 10 27.09 10Z" fill="#D4D4DB"/>
<path d="M3.09 20C2.89222 20 2.69888 20.0586 2.53443 20.1685C2.36998 20.2784 2.2418 20.4346 2.16612 20.6173C2.09043 20.8 2.07063 21.0011 2.10921 21.1951C2.1478 21.3891 2.24304 21.5673 2.38289 21.7071C2.52274 21.847 2.70093 21.9422 2.89491 21.9808C3.08889 22.0194 3.28995 21.9996 3.47268 21.9239C3.65541 21.8482 3.81158 21.72 3.92147 21.5556C4.03135 21.3911 4.09 21.1978 4.09 21C4.09 20.7348 3.98464 20.4804 3.7971 20.2929C3.60957 20.1054 3.35521 20 3.09 20Z" fill="#D4D4DB"/>
<path d="M3.09 18C3.64228 18 4.09 17.5523 4.09 17C4.09 16.4477 3.64228 16 3.09 16C2.53771 16 2.09 16.4477 2.09 17C2.09 17.5523 2.53771 18 3.09 18Z" fill="#D4D4DB"/>
<path d="M3.09 14C3.64228 14 4.09 13.5523 4.09 13C4.09 12.4477 3.64228 12 3.09 12C2.53771 12 2.09 12.4477 2.09 13C2.09 13.5523 2.53771 14 3.09 14Z" fill="#D4D4DB"/>
<path d="M3.09 10C3.64228 10 4.09 9.55228 4.09 9C4.09 8.44772 3.64228 8 3.09 8C2.53771 8 2.09 8.44772 2.09 9C2.09 9.55228 2.53771 10 3.09 10Z" fill="#D4D4DB"/>
<path d="M28.09 7H2.09C1.82478 7 1.57043 7.10536 1.38289 7.29289C1.19535 7.48043 1.09 7.73478 1.09 8C1.09 8.26522 1.19535 8.51957 1.38289 8.70711C1.57043 8.89464 1.82478 9 2.09 9H28.09C28.3552 9 28.6096 8.89464 28.7971 8.70711C28.9846 8.51957 29.09 8.26522 29.09 8C29.09 7.73478 28.9846 7.48043 28.7971 7.29289C28.6096 7.10536 28.3552 7 28.09 7V7Z" fill="#2E3341"/>
</svg>

`;
var floor = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 26.02C27.5523 26.02 28 25.5723 28 25.02C28 24.4677 27.5523 24.02 27 24.02C26.4477 24.02 26 24.4677 26 25.02C26 25.5723 26.4477 26.02 27 26.02Z" fill="#D4D4DB"/>
<path d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z" fill="#D4D4DB"/>
<path d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z" fill="#D4D4DB"/>
<path d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z" fill="#D4D4DB"/>
<path d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z" fill="#D4D4DB"/>
<path d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z" fill="#D4D4DB"/>
<path d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z" fill="#D4D4DB"/>
<path d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z" fill="#D4D4DB"/>
<path d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z" fill="#D4D4DB"/>
<path d="M27 24.02H3C2.73478 24.02 2.48043 24.1254 2.29289 24.3129C2.10536 24.5004 2 24.7548 2 25.02C2 25.2852 2.10536 25.5396 2.29289 25.7271C2.48043 25.9147 2.73478 26.02 3 26.02H27C27.2652 26.02 27.5196 25.9147 27.7071 25.7271C27.8946 25.5396 28 25.2852 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z" fill="#2E3341"/>
</svg>

`;
var insidewall = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z" fill="#D4D4DB"/>
<path d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z" fill="#D4D4DB"/>
<path d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z" fill="#D4D4DB"/>
<path d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z" fill="#D4D4DB"/>
<path d="M27 24.02C26.8022 24.02 26.6089 24.0787 26.4444 24.1885C26.28 24.2984 26.1518 24.4546 26.0761 24.6373C26.0004 24.8201 25.9806 25.0211 26.0192 25.2151C26.0578 25.4091 26.153 25.5873 26.2929 25.7271C26.4327 25.867 26.6109 25.9622 26.8049 26.0008C26.9989 26.0394 27.2 26.0196 27.3827 25.9439C27.5654 25.8682 27.7216 25.74 27.8315 25.5756C27.9414 25.4111 28 25.2178 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z" fill="#D4D4DB"/>
<path d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z" fill="#D4D4DB"/>
<path d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z" fill="#D4D4DB"/>
<path d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z" fill="#D4D4DB"/>
<path d="M27 26.02V13.02C27 12.7548 26.8946 12.5004 26.7071 12.3129C26.5196 12.1254 26.2652 12.02 26 12.02C25.7348 12.02 25.4804 12.1254 25.2929 12.3129C25.1054 12.5004 25 12.7548 25 13.02V25.02C25 25.2852 25.1054 25.5396 25.2929 25.7271C25.4804 25.9147 25.7348 26.02 26 26.02H27Z" fill="#2E3341"/>
<path d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z" fill="#D4D4DB"/>
</svg>

`;
var layerIcon = `
<svg width="20" height="20" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" d="M11 0C10.675 0 10.3726 0.0856563 10.1016 0.222656H10.084L0.625 5.07617C0.259 5.22417 0 5.581 0 6C0 6.416 0.255188 6.77283 0.617188 6.92383V6.94336L10.0918 11.7812L10.0996 11.7773C10.3716 11.9153 10.674 12 11 12C11.326 12 11.6284 11.9153 11.9004 11.7773L11.9082 11.7812L21.3828 6.94336V6.92383C21.7448 6.77283 22 6.416 22 6C22 5.581 21.741 5.22417 21.375 5.07617L11.916 0.222656H11.8984C11.6274 0.0856563 11.325 0 11 0ZM2.47656 10.127L0.625 11.0762C0.259 11.2242 0 11.581 0 12C0 12.416 0.255188 12.7728 0.617188 12.9238V12.9434L10.0918 17.7812L10.0996 17.7773C10.3716 17.9153 10.674 18 11 18C11.326 18 11.6284 17.9153 11.9004 17.7773L11.9082 17.7812L21.3828 12.9434V12.9238C21.7448 12.7728 22 12.416 22 12C22 11.581 21.741 11.2242 21.375 11.0762L19.5234 10.127C16.6184 11.614 12.6534 13.6373 12.6074 13.6543C12.0924 13.8843 11.553 14 11 14C10.445 14 9.90372 13.8833 9.38672 13.6523C9.34272 13.6363 5.38256 11.615 2.47656 10.127ZM2.47656 16.127L0.625 17.0762C0.259 17.2242 0 17.581 0 18C0 18.416 0.255188 18.7728 0.617188 18.9238V18.9434L10.0918 23.7812L10.0996 23.7773C10.3716 23.9153 10.674 24 11 24C11.326 24 11.6284 23.9153 11.9004 23.7773L11.9082 23.7812L21.3828 18.9434V18.9238C21.7448 18.7728 22 18.416 22 18C22 17.581 21.741 17.2242 21.375 17.0762L19.5234 16.127C16.6184 17.614 12.6534 19.6373 12.6074 19.6543C12.0924 19.8843 11.553 20 11 20C10.445 20 9.90372 19.8833 9.38672 19.6523C9.34272 19.6363 5.38256 17.615 2.47656 16.127Z" fill="black"/>
</svg>`;
var outsidewall = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z" fill="#D4D4DB"/>
<path d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z" fill="#D4D4DB"/>
<path d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z" fill="#D4D4DB"/>
<path d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z" fill="#D4D4DB"/>
<path d="M27 24.02C26.8022 24.02 26.6089 24.0787 26.4444 24.1885C26.28 24.2984 26.1518 24.4546 26.0761 24.6373C26.0004 24.8201 25.9806 25.0211 26.0192 25.2151C26.0578 25.4091 26.153 25.5873 26.2929 25.7271C26.4327 25.867 26.6109 25.9622 26.8049 26.0008C26.9989 26.0394 27.2 26.0196 27.3827 25.9439C27.5654 25.8682 27.7216 25.74 27.8315 25.5756C27.9414 25.4111 28 25.2178 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z" fill="#D4D4DB"/>
<path d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z" fill="#D4D4DB"/>
<path d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z" fill="#D4D4DB"/>
<path d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z" fill="#D4D4DB"/>
<path d="M29 25.02V12.02H28C27.7348 12.02 27.4804 12.1254 27.2929 12.3129C27.1054 12.5004 27 12.7548 27 13.02V26.02H28C28.2652 26.02 28.5196 25.9147 28.7071 25.7271C28.8946 25.5396 29 25.2852 29 25.02Z" fill="#2E3341"/>
<path d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z" fill="#D4D4DB"/>
</svg>

`;
var search = `<svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M13 3C7.489 3 3 7.489 3 13C3 18.511 7.489 23 13 23C15.3965 23 17.5974 22.149 19.3223 20.7363L25.293 26.707C25.3851 26.803 25.4955 26.8796 25.6176 26.9324C25.7397 26.9852 25.8712 27.0131 26.0042 27.0144C26.1373 27.0158 26.2692 26.9906 26.3924 26.9403C26.5156 26.89 26.6275 26.8157 26.7216 26.7216C26.8157 26.6275 26.89 26.5156 26.9403 26.3924C26.9906 26.2692 27.0158 26.1373 27.0144 26.0042C27.0131 25.8712 26.9852 25.7397 26.9324 25.6176C26.8796 25.4955 26.803 25.3851 26.707 25.293L20.7363 19.3223C22.149 17.5974 23 15.3965 23 13C23 7.489 18.511 3 13 3ZM13 5C17.4301 5 21 8.56988 21 13C21 17.4301 17.4301 21 13 21C8.56988 21 5 17.4301 5 13C5 8.56988 8.56988 5 13 5Z"
        fill="currentColor"
        stroke="currentColor"
    />
</svg>`;
var sloperoof = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27.09 25.9C27.6423 25.9 28.09 25.4523 28.09 24.9C28.09 24.3477 27.6423 23.9 27.09 23.9C26.5377 23.9 26.09 24.3477 26.09 24.9C26.09 25.4523 26.5377 25.9 27.09 25.9Z" fill="#D4D4DB"/>
<path d="M27.09 21.9C27.6423 21.9 28.09 21.4523 28.09 20.9C28.09 20.3477 27.6423 19.9 27.09 19.9C26.5377 19.9 26.09 20.3477 26.09 20.9C26.09 21.4523 26.5377 21.9 27.09 21.9Z" fill="#D4D4DB"/>
<path d="M27.09 17.9C27.6423 17.9 28.09 17.4523 28.09 16.9C28.09 16.3477 27.6423 15.9 27.09 15.9C26.5377 15.9 26.09 16.3477 26.09 16.9C26.09 17.4523 26.5377 17.9 27.09 17.9Z" fill="#D4D4DB"/>
<path d="M27.09 13.9C27.6423 13.9 28.09 13.4523 28.09 12.9C28.09 12.3477 27.6423 11.9 27.09 11.9C26.5377 11.9 26.09 12.3477 26.09 12.9C26.09 13.4523 26.5377 13.9 27.09 13.9Z" fill="#D4D4DB"/>
<path d="M3.09 23.9C2.89222 23.9 2.69888 23.9587 2.53443 24.0686C2.36998 24.1784 2.2418 24.3346 2.16612 24.5173C2.09043 24.7001 2.07063 24.9011 2.10921 25.0951C2.1478 25.2891 2.24304 25.4673 2.38289 25.6071C2.52274 25.747 2.70093 25.8422 2.89491 25.8808C3.08889 25.9194 3.28995 25.8996 3.47268 25.8239C3.65541 25.7482 3.81158 25.62 3.92147 25.4556C4.03135 25.2911 4.09 25.0978 4.09 24.9C4.09 24.6348 3.98464 24.3805 3.7971 24.1929C3.60957 24.0054 3.35521 23.9 3.09 23.9Z" fill="#D4D4DB"/>
<path d="M3.09 21.9C3.64228 21.9 4.09 21.4523 4.09 20.9C4.09 20.3477 3.64228 19.9 3.09 19.9C2.53771 19.9 2.09 20.3477 2.09 20.9C2.09 21.4523 2.53771 21.9 3.09 21.9Z" fill="#D4D4DB"/>
<path d="M3.09 17.9C3.64228 17.9 4.09 17.4523 4.09 16.9C4.09 16.3477 3.64228 15.9 3.09 15.9C2.53771 15.9 2.09 16.3477 2.09 16.9C2.09 17.4523 2.53771 17.9 3.09 17.9Z" fill="#D4D4DB"/>
<path d="M3.09 13.9C3.64228 13.9 4.09 13.4523 4.09 12.9C4.09 12.3477 3.64228 11.9 3.09 11.9C2.53771 11.9 2.09 12.3477 2.09 12.9C2.09 13.4523 2.53771 13.9 3.09 13.9Z" fill="#D4D4DB"/>
<path d="M27.9997 13.02C28.2188 13.0199 28.4318 12.9479 28.606 12.815C28.7802 12.6821 28.9059 12.4957 28.9638 12.2844C29.0217 12.0731 29.0087 11.8487 28.9267 11.6455C28.8446 11.4424 28.6981 11.2718 28.5097 11.16L15.5797 2.2C15.4066 2.07018 15.1961 2 14.9797 2C14.7633 2 14.5528 2.07018 14.3797 2.2L8.99971 5.96V5.02C8.99971 4.75478 8.89435 4.50043 8.70681 4.31289C8.51928 4.12536 8.26492 4.02 7.99971 4.02H6.99971C6.73449 4.02 6.48014 4.12536 6.2926 4.31289C6.10506 4.50043 5.99971 4.75478 5.99971 5.02V8.02L1.48971 11.16C1.30129 11.2718 1.1548 11.4424 1.07276 11.6455C0.99072 11.8487 0.977662 12.0731 1.0356 12.2844C1.09353 12.4957 1.21925 12.6821 1.39343 12.815C1.56761 12.9479 1.78062 13.0199 1.99971 13.02H27.9997Z" fill="#D4D4DB"/>
<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="1" y="2" width="28" height="12">
<path d="M27.9997 13.02C28.2188 13.0199 28.4318 12.9479 28.606 12.815C28.7802 12.6821 28.9059 12.4957 28.9638 12.2844C29.0217 12.0731 29.0087 11.8487 28.9267 11.6455C28.8446 11.4424 28.6981 11.2718 28.5097 11.16L15.5797 2.2C15.4066 2.07018 15.1961 2 14.9797 2C14.7633 2 14.5528 2.07018 14.3797 2.2L8.99971 5.96V5.02C8.99971 4.75478 8.89435 4.50043 8.70681 4.31289C8.51928 4.12536 8.26492 4.02 7.99971 4.02H6.99971C6.73449 4.02 6.48014 4.12536 6.2926 4.31289C6.10506 4.50043 5.99971 4.75478 5.99971 5.02V8.02L1.48971 11.16C1.30129 11.2718 1.1548 11.4424 1.07276 11.6455C0.99072 11.8487 0.977662 12.0731 1.0356 12.2844C1.09353 12.4957 1.21925 12.6821 1.39343 12.815C1.56761 12.9479 1.78062 13.0199 1.99971 13.02H27.9997Z" fill="black"/>
</mask>
<g mask="url(#mask0)">
<path d="M32.85 14L11.49 -0.830049C11.3813 -0.905801 11.2586 -0.9592 11.1291 -0.987145C10.9996 -1.01509 10.8659 -1.01702 10.7356 -0.992832C10.6054 -0.968642 10.4812 -0.91881 10.3704 -0.846232C10.2595 -0.773653 10.1642 -0.679774 10.09 -0.570049C9.93917 -0.352458 9.8808 -0.0839393 9.92766 0.176628C9.97453 0.437196 10.1228 0.668546 10.34 0.819951L31.71 15.6399C31.9268 15.7876 32.193 15.8442 32.4512 15.7974C32.7093 15.7507 32.9387 15.6043 33.09 15.3899C33.2418 15.1736 33.3018 14.9059 33.2568 14.6454C33.2118 14.385 33.0656 14.1529 32.85 14Z" fill="#2E3341"/>
</g>
</svg>

`;
class Markers {
  constructor(camera, scene) {
    this.loaded = false;
    this.center = new Vector3$1(0, 0, 0);
    this.raycaster = new Raycaster();
    this.intersectingObjects = [];
    this.instances = [];
    this.redMaterial = new MeshBasicMaterial({ color: "red" });
    this.blueMaterial = new MeshBasicMaterial({ color: "blue" });
    this.damping = 0;
    this.createContainer();
    this.onOrbitChange = this.onOrbitChange.bind(this);
    this.onOrbitMove = this.onOrbitMove.bind(this);
    this.camera = camera;
    this.scene = scene;
    Events.on("ORBIT_CHANGE", this.onOrbitChange);
    this.damping = 1;
    this.eventCount = 0;
  }
  async initMarkers(model) {
    var _a;
    this.loaded = false;
    this.model = model;
    this.clear();
    (_a = this.model) == null ? void 0 : _a.traverse((child) => {
      var _a2;
      if (child.userData.marker) {
        const marker = {
          markerLayerName: child.name,
          markerType: child.userData.markerType,
          markerLayer: (_a2 = child.userData.markerLayer) != null ? _a2 : child.userData.makerLayer,
          position: child.getWorldPosition(this.center).clone()
        };
        this.instances.push(marker);
      }
      const regx = /(gras|Plane|Scene)/g;
      if (!child.name.match(regx)) {
        this.intersectingObjects.push(child);
      }
    });
    await sleep(20);
    if (!this.instances.length)
      return;
    this.createMarkers();
    await next;
    this.checkMarkerClickEvents();
    this.checkMarkerLayers();
    await next;
    this.loaded = true;
    this.onOrbitChange();
    this.update();
    this.toggle(Store.state["MARKERS"]);
  }
  createContainer() {
    this.container = document.createElement("div");
    this.container.classList.add("markers");
    Store.container.appendChild(this.container);
  }
  hide() {
    if (this.container)
      this.container.style.display = "none";
  }
  clear() {
    this.instances.forEach((marker) => {
      if (marker.markerNode !== void 0)
        marker.markerNode.remove();
    });
    this.instances = [];
    this.intersectingObjects = [];
  }
  createMarkers() {
    this.instances.forEach((instance, index) => {
      this.createMarker(instance, index);
    });
    if (this.container)
      this.container.style.display = "";
  }
  getTranslation(label) {
    const splitLabel = label.split(".");
    let check = Store.lang;
    for (let index = 0; index < splitLabel.length; index++) {
      if (check !== void 0) {
        check = check[splitLabel[index]];
      }
    }
    return check || label;
  }
  checkMarkerLayers() {
    this.instances.forEach((marker) => {
      if (marker.width && marker.markerNode) {
        marker.markerNode.style.setProperty("--options-width", `${marker.width}px`);
        marker.markerNode.style.setProperty("--options-width-neg", `-${marker.width}px`);
      }
      if (marker.layers !== void 0) {
        this.prepLayers(marker, marker.layers);
      }
    });
  }
  toggle(visible = "auto") {
    if (visible === "auto") {
      Store.state["MARKERS"] = !Store.state["MARKERS"];
      this.container.classList.toggle("is-loaded");
    } else {
      Store.state["MARKERS"] = visible;
      const action = visible ? "add" : "remove";
      this.container.classList[action]("is-loaded");
    }
  }
  prepLayers(marker) {
    const layers2 = Store.state.TOPLAAG.current.includes("PMMA") && marker.pmmaLayers !== void 0 ? marker.pmmaLayers : marker.layers;
    layers2.forEach((layer, index) => {
      if (Store.state.TOPLAAG.current !== null && Store.state.TOPLAAG.current.includes("PMMA") && marker.layerType === "TOPLAAG" && index > 0)
        return;
      if (layer.detail) {
        this.setMarkerLayerOnce(marker, {
          layer: layer.label,
          label: `${this.getTranslation(layer.label)} ${layer.unique === void 0 ? index + 1 : ""}`,
          onClick: () => {
            Store.renderer.load(layer.detail).then(() => {
              Events.emit("MARKER_CLICK", layer.detail);
            });
          }
        });
      } else {
        this.setMarkerLayerOnce(marker, {
          toggle: layer.toggle,
          label: `${this.getTranslation(layer.label)} ${layer.unique === void 0 ? index + 1 : ""}`,
          type: "toggle",
          onClick: () => {
            Events.emit("MARKER_TOGGLE", {
              toggle: layer.toggle,
              layerType: marker.layerType,
              marker,
              layer,
              label: `${this.getTranslation(layer.label)} ${layer.unique === void 0 ? index + 1 : ""}`
            });
          }
        });
      }
    });
  }
  checkMarkerClickEvents() {
    this.instances.forEach((marker, index) => {
      if (marker.detail !== void 0) {
        this.onMarkerClickOnce(marker, marker.slug, () => {
          Store.renderer.load(marker.detail).then(() => {
            Events.emit("MARKER_CLICK", marker.detail);
          });
        });
      } else {
        if (marker.type !== "layers" && marker.type !== "toggle" && marker.markerNode) {
          marker.markerNode.classList.add("disabled");
        }
      }
      if (marker.type == "toggle" && marker.markerNode) {
        marker.markerNode.removeEventListener("click", marker.clickEvent);
        marker.clickEvent = () => Events.emit("TOGGLE_MARKER_CLICK", marker);
        marker.markerNode.addEventListener("click", marker.clickEvent);
      }
    });
  }
  onMarkerClickOnce(marker, slug, fn) {
    if (marker.type !== "layers") {
      if (marker.clickEvent || marker.slug === slug && marker.detail) {
        marker.markerNode.removeEventListener("click", marker.clickEvent);
        marker.clickEvent = () => {
          fn({ el: marker.markerNode, name: marker.object });
        };
        marker.markerNode.addEventListener("click", marker.clickEvent);
      } else {
        marker.markerNode.classList.add("disabled");
      }
    }
  }
  onMarkerClick(slug, fn) {
    this.instances.forEach((marker) => {
      this.onMarkerClickOnce(marker, slug, fn);
    });
  }
  setMarkerLayerOnce(instance, options) {
    const node = document.createElement("div");
    if (options.toggle)
      node.setAttribute("data-toggle", options.toggle);
    const layer = {};
    node.classList.add("marker-layer");
    node.innerHTML = `
                        ${options.type === "toggle" ? `<div class="marker-layer-icon -open">${eye}</div><div class="marker-layer-icon -closed">${eyeClosed}</div>` : ``}
                        ${options.label}
                `;
    if (options.type)
      node.classList.add(`marker-layer-${options.type}`);
    if (options.type === "toggle") {
      layer.toggleStatus = options.default === void 0 ? true : options.default;
      if (layer.toggleStatus) {
        node.classList.add("is-active");
      }
    }
    const layerEvent = (e) => {
      e.stopPropagation();
      const callBackObject = {
        el: node,
        name: options.label
      };
      if (options.type === "toggle") {
        callBackObject.toggleStatus = layer.toggleStatus;
      }
      options.onClick(callBackObject);
    };
    node.addEventListener("click", layerEvent);
    instance.layerEvents.push(layerEvent);
    const layerContainer = instance.markerNode.querySelector(".marker-layers");
    layerContainer.appendChild(node);
  }
  setMarkerLayer(slug, options) {
    this.instances.forEach((instance) => {
      if (instance.slug === slug) {
        this.setMarkerLayerOnce(instance, options);
      }
    });
  }
  onLayerMarkerClick(clickedInstance) {
    var _a;
    this.instances.forEach((instance) => {
      var _a2;
      if (clickedInstance.markerNode !== instance.markerNode)
        (_a2 = instance == null ? void 0 : instance.markerNode) == null ? void 0 : _a2.classList.remove("is-open");
    });
    (_a = clickedInstance == null ? void 0 : clickedInstance.markerNode) == null ? void 0 : _a.classList.toggle("is-open");
  }
  setIcon(type) {
    let icon;
    switch (type) {
      case "basement":
        icon = basement;
        break;
      case "basementfloor":
        icon = basementfloor;
        break;
      case "cavitywall":
        icon = cavitywall;
        break;
      case "eye":
        icon = eye;
        break;
      case "toggle":
        icon = toggle;
        break;
      case "flatroof":
        icon = flatroof;
        break;
      case "floor":
        icon = floor;
        break;
      case "insidewall":
        icon = insidewall;
        break;
      case "outsidewall":
        icon = outsidewall;
        break;
      case "sloperoof":
        icon = sloperoof;
        break;
      case "search":
        icon = search;
        break;
      case "layers":
        icon = layerIcon;
        break;
      default:
        icon = "";
        break;
    }
    return icon;
  }
  createMarker(instance, index) {
    let markerSettings = Store[Store.current.slug].markers[index];
    if (markerSettings && markerSettings.layerType) {
      if (!markerSettings.layerType.includes(instance.markerLayer))
        markerSettings = null;
    }
    if (!markerSettings && Store.preview) {
      const defaultMarkerSettings = {
        active: true,
        offset: { x: 0, y: -25 },
        arrow: "down",
        type: "search",
        label: instance.markerLayerName,
        detail: instance.markerLayer,
        slug: instance.markerLayer
      };
      markerSettings = defaultMarkerSettings;
    }
    if (!markerSettings)
      return;
    if (markerSettings.hidden)
      return;
    const {
      offset,
      object,
      type,
      arrow,
      label,
      detail,
      slug,
      layers: layers2,
      pmmaLayers,
      width,
      icon,
      active,
      layerType
    } = markerSettings;
    const node = document.createElement("div");
    let markerIcon = this.setIcon(type);
    if (icon)
      markerIcon = this.setIcon(icon);
    node.classList.add("marker", `marker-type-${type}`, "visible", `arrow-${arrow}`);
    node.setAttribute("data-layertype", layerType);
    node.innerHTML = `
            <div class="marker-icon-arrow"></div>
            <div class="marker-icon marker-icon-${type}">
                <div class="marker-icon-label">
                    <div class="marker-icon-label-inner"> ${this.getTranslation(label)}</div>
                </div>
                <div class="marker-icon-svg">
                    ${markerIcon}
                </div>
                ${type === "layers" ? `<div class="marker-icon-close"></div>` : ``}
            </div>
            ${type === "layers" ? `<div class="marker-layers"></div>` : ``}
        `;
    instance.markerNode = node;
    instance.label = label;
    instance.type = type;
    instance.slug = slug;
    instance.detail = detail;
    instance.active = active;
    instance.isOpen = false;
    instance.layers = layers2;
    instance.pmmaLayers = pmmaLayers;
    instance.layerType = layerType;
    instance.layerEvents = [];
    instance.screenPosition = 0;
    instance.distanceToCamera = 0;
    if (layerType !== void 0 && type === "layers") {
      let layerTypesCheck = false;
      if (Array.isArray(layerType)) {
        layerType.forEach((layersplit) => {
          if (Store.state[layersplit].active) {
            layerTypesCheck = true;
          }
        });
      } else {
        if (Store.state[layerType].active) {
          layerTypesCheck = true;
        }
      }
      if (!layerTypesCheck && !Store.preview)
        return;
    }
    if (type === "layers") {
      if (width !== void 0)
        instance.width = width;
      instance.clickEvent = () => this.onLayerMarkerClick(instance);
      instance.markerElement = node;
      instance.markerIcon = node.querySelector(".marker-icon");
      instance.markerIcon.addEventListener("click", instance.clickEvent);
      instance.close = instance.markerNode.querySelector(".marker-icon-close");
      instance.closeEvent = (e) => {
        e.stopPropagation();
        instance.markerNode.classList.add("is-closed");
        instance.markerNode.classList.remove("is-open");
        setTimeout(() => {
          instance.markerNode.classList.remove("is-closed");
        }, 100);
      };
      instance.close.addEventListener("click", instance.closeEvent);
    }
    if (markerSettings != void 0) {
      instance.offset = offset;
      instance.object = object;
    }
    instance.tX = instance.tXLerp = 0;
    instance.tY = instance.tYLerp = 0;
    instance.scale = instance.scaleLerp = 0;
    if (active || active === void 0)
      this.container.appendChild(node);
  }
  onOrbitMove() {
    clearInterval(this.checkMovesInterval);
    clearTimeout(this.checkMovesTimeout);
    clearTimeout(this.clearCheckMovesTimeout);
    if (Store.current.slug === "dollhouse")
      return;
    for (let index = 0; index < this.instances.length; index++) {
      const marker = this.instances[index];
      const screenPosition = marker.position.clone();
      screenPosition.project(this.camera);
      marker.screenPosition = screenPosition;
      this.raycaster.setFromCamera(marker.screenPosition, this.camera);
      const intersects2 = this.raycaster.intersectObjects(this.intersectingObjects);
      if (intersects2.length === 0) {
        marker.markerNode.classList.add("visible");
      } else {
        let firstObject = null;
        if (marker.object) {
          for (let index2 = 0; index2 < intersects2.length && firstObject == null; index2++) {
            if (!marker.object.includes(intersects2[index2].object.name)) {
              firstObject = intersects2[index2];
            }
          }
        } else {
          firstObject = intersects2[0];
        }
        if (firstObject === null) {
          marker.markerNode.classList.add("visible");
        } else {
          const intersectionDistance = firstObject.distance;
          const markerDistance = marker.position.distanceTo(this.camera.position);
          if (intersectionDistance < markerDistance) {
            marker.markerNode.classList.remove("visible");
          } else {
            marker.markerNode.classList.add("visible");
          }
        }
      }
      marker.tX = marker.screenPosition.x * Store.layout.w * 0.5;
      marker.tY = -marker.screenPosition.y * Store.layout.h * 0.5;
      marker.scale = clamp(marker.distanceToCamera * 0.05, 0, 1);
      if (marker.offset) {
        marker.tX += marker.offset.x * marker.scale;
        marker.tY += marker.offset.y * marker.scale;
      }
    }
    this.clearCheckMovesTimeout = setTimeout(() => {
      clearInterval(this.checkMovesInterval);
    }, 2e3);
    this.checkMovesTimeout = setTimeout(() => {
      this.checkMovesInterval = setInterval(() => {
        this.onOrbitMove();
      }, 60);
    }, 100);
  }
  onOrbitChange() {
    for (let index = 0; index < this.instances.length; index++) {
      const marker = this.instances[index];
      const screenPosition = marker.position.clone();
      screenPosition.project(this.camera);
      marker.screenPosition = screenPosition;
      marker.tX = marker.screenPosition.x * Store.layout.w * 0.5;
      marker.tY = -marker.screenPosition.y * Store.layout.h * 0.5;
      marker.distanceToCamera = 20 - this.camera.position.distanceTo(marker.screenPosition);
      marker.scale = clamp(marker.distanceToCamera * 0.05, 0, 1);
      if (marker.offset) {
        marker.tX += marker.offset.x * marker.scale;
        marker.tY += marker.offset.y * marker.scale;
      }
    }
  }
  update() {
    if (!this.loaded)
      return;
    for (let index = 0; index < this.instances.length; index++) {
      const marker = this.instances[index];
      marker.tXLerp = lerp(marker.tXLerp, marker.tX, this.damping);
      marker.tYLerp = lerp(marker.tYLerp, marker.tY, this.damping);
      marker.scaleLerp = lerp(marker.scaleLerp, marker.scale + 0.3, 1);
      if (marker.markerNode) {
        marker.markerNode.style.transform = `translateX(${marker.tXLerp}px) translateY(${marker.tYLerp}px)`;
      }
    }
  }
  printMarkerSettings() {
    let instanceSettings = "";
    this.instances.forEach((marker) => {
      var _a;
      let key = "";
      switch (marker.markerLayer) {
        case "TOPLAAG":
          key = "topLayer";
          break;
        case "ONDERGROND":
          key = "roofFloor";
          break;
        case "ISOLATIE":
          key = "insulation";
          break;
        case "DAMPSCHERM":
          key = "vaporShield";
          break;
        case "ONDERLAAG":
          key = "bottomLayer";
          break;
      }
      let layerHighest = 0;
      (_a = this.model) == null ? void 0 : _a.traverse((child) => {
        if (child.userData && child.userData.subLayer) {
          const childKey = child.userData.subLayer.split("_")[0];
          const index = child.userData.subLayer.split("_")[1];
          if (index > layerHighest && childKey === marker.markerLayer) {
            layerHighest = index;
          }
        }
      });
      console.log(marker.markerLayer, layerHighest);
      let layers2 = "";
      for (let i = 1; i <= layerHighest; i++) {
        layers2 += `
                    {
                        label: 'flatRoof.overview.${key}',
                        toggle: '${marker.markerLayer}_${i}',
                    },
                `;
      }
      if (marker.markerType === "layers" && layerHighest > 1) {
        instanceSettings += `
                    {
                        offset: { x: 0, y: -25 },
                        type: 'layers',
                        arrow: 'down',
                        label: 'flatRoof.overview.${key}',
                        layerType: '${marker.markerLayer}',
                        layers: [
                            ${layers2}
                        ],
                    },
                `;
      }
      if (layerHighest < 2) {
        instanceSettings += `
                    {
                        offset: { x: 0, y: -25 },
                        arrow: 'down',
                        type: 'toggle',
                        icon: 'toggle',
                        label: 'flatRoof.overview.${key}',
                        layerType: '${marker.markerLayer === "ONDERLAAG" ? "['ONDERLAAG', 'ONDERLAAG-BEVESTIGING']" : marker.markerLayer}',
                        slug: '${key}',
                    },
                `;
      }
    });
    console.log(instanceSettings);
  }
}
class Layout {
  constructor() {
    this.onResize = this.onResize.bind(this);
    window.addEventListener("resize", this.onResize);
    Store.layout = {
      w: Store.container.clientWidth,
      h: Store.container.clientHeight
    };
    this.onResize();
  }
  onResize() {
    Store.layout.w = Store.container.clientWidth;
    Store.layout.h = Store.container.clientHeight;
    Store.layout.aspect = Store.layout.w / Store.layout.h;
  }
}
function dispose(node) {
  if (node instanceof Mesh) {
    if (node.geometry) {
      node.geometry.dispose();
    }
    if (node.material) {
      if (node.material.map)
        node.material.map.dispose();
      if (node.material.lightMap)
        node.material.lightMap.dispose();
      if (node.material.bumpMap)
        node.material.bumpMap.dispose();
      if (node.material.normalMap)
        node.material.normalMap.dispose();
      if (node.material.specularMap)
        node.material.specularMap.dispose();
      if (node.material.envMap)
        node.material.envMap.dispose();
      if (node.material.alphaMap)
        node.material.alphaMap.dispose();
      if (node.material.aoMap)
        node.material.aoMap.dispose();
      if (node.material.displacementMap)
        node.material.displacementMap.dispose();
      if (node.material.emissiveMap)
        node.material.emissiveMap.dispose();
      if (node.material.gradientMap)
        node.material.gradientMap.dispose();
      if (node.material.metalnessMap)
        node.material.metalnessMap.dispose();
      if (node.material.roughnessMap)
        node.material.roughnessMap.dispose();
      node.material.dispose();
    }
  }
}
function disposeChildren(node) {
  for (var i = node.children.length - 1; i >= 0; i--) {
    dispose(node.children[i]);
  }
}
const settings$5B = {
  layers: [
    {
      name: "DAKBEDEKKING",
      default: "ZONNEPANELEN"
    },
    {
      name: "ONDERGROND",
      default: "BETON"
    },
    {
      name: "TOPLAAG",
      default: "CARBON-PANTERA"
    },
    {
      name: "ONDERLAAG",
      default: "BASE-P3-FT"
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "ISOLATIE",
      default: "ISOLATIE-ALU"
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "DAMPSCHERM",
      default: "DAMP-BASE-P3-TF"
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "BINNENSPOUWBLAD",
      default: "BETON"
    },
    {
      name: "GEVELBEKLEDING",
      default: ""
    },
    {
      name: "AANSLUITINGSPROFIEL",
      default: ""
    },
    {
      name: "DEKVLOER",
      default: "CHAPE"
    }
  ],
  toggles: [
    {
      name: "DAMPSCHERM",
      default: true
    },
    {
      name: "PROFIEL",
      default: true
    },
    {
      name: "TOPLAAG",
      default: false
    },
    {
      name: "KOEPEL",
      default: true
    },
    {
      name: "VENTILATIE",
      default: true
    },
    {
      name: "MUUR",
      default: true
    },
    {
      name: "AFVOER",
      default: true
    },
    {
      name: "ZETTINGSVOEG",
      default: true
    },
    {
      name: "ISOLATIE",
      default: true
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: true
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERLAAG",
      default: true
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERGROND",
      default: true
    },
    {
      name: "DAKBEDEKKING",
      default: true
    }
  ]
};
const settings$5A = {
  position: { x: 0, y: 1.2630926240141078, z: 0 },
  scale: 0.25,
  settings: {
    environment: {
      toneMappingExposure: 6.63
    },
    camera: {
      position: {
        x: 6.067824863992895,
        y: 2.5000691520141145,
        z: 0.011966211714026925
      },
      controls: {
        maxDistance: 6,
        minDistance: 6
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -35 },
      type: "flatroof",
      arrow: "down",
      label: "home.flatRoof",
      detail: "platdak-overview",
      slug: "flatroof",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "sloperoof",
      arrow: "down",
      label: "home.slopedRoof",
      detail: "hellend-dak-overview",
      slug: "sloperoof",
      active: true
    },
    {
      offset: { x: -30, y: 0 },
      type: "outsidewall",
      arrow: "right",
      label: "home.outerWall",
      detail: "ventgevel-overview",
      slug: "outsidewall",
      active: true
    },
    {
      offset: { x: -30, y: 0 },
      type: "cavitywall",
      arrow: "right",
      label: "home.cavityWall",
      detail: "spouwmuur-overview",
      slug: "cavitywall",
      active: true
    },
    {
      offset: { x: 0, y: 0 },
      type: "insidewall",
      arrow: "right",
      label: "home.innerWall",
      slug: "insidewall",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "floor",
      arrow: "down",
      label: "home.floor",
      detail: "vloer-overview",
      slug: "floor",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "basement",
      arrow: "down",
      label: "home.basement",
      slug: "basement",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "basementfloor",
      arrow: "down",
      label: "home.atticFloor",
      slug: "basementfloor",
      active: false
    }
  ]
};
const settings$5z = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg",
      slug: "zettingsvoeg"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  }
};
const settings$5y = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  }
};
const settings$5x = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  }
};
const settings$5w = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  }
};
const settings$5v = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$5u = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$5t = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$5s = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$5r = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$5q = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$5p = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$5o = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$5n = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$5m = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$5l = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_RAAMAANSLUITING"],
      label: "cavityWall.detail.windowConnection",
      detail: "spouwmuur-raamaansluiting",
      slug: "raamaansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_GEVELVLAK"],
      label: "cavityWall.detail.facade",
      detail: "spouwmuur-gevelvlak",
      slug: "gevelvlak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_MUURVOET"],
      label: "cavityWall.detail.footing",
      detail: "spouwmuur-muurvoet",
      slug: "muurvoet"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_MUURAANSLUITING"],
      label: "cavityWall.detail.flatRoof",
      detail: "spouwmuur-plat-dak",
      slug: "plat-dak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_HELLEND_DAK"],
      label: "cavityWall.detail.slopedRoof",
      detail: "spouwmuur-hellend-dak",
      slug: "hellend-dak"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 5
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    },
    layers: [
      { name: "BINNENSPOUWBLAD", default: "BETON" },
      { name: "ISOLATIE", default: "ISOLATIE-ALUTG" }
    ],
    toggles: [
      { name: "BINNENSPOUWBLAD", default: true },
      { name: "ISOLATIE", default: true },
      { name: "Buitensteen", default: true }
    ]
  }
};
const settings$5k = {
  position: { x: 0, y: -0.36415480767947805, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$5j = {
  position: { x: 1, y: -0.45, z: 1 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$5i = {
  position: { x: 1, y: -0.36415480767947805, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$5h = {
  position: { x: 0.5, y: 1, z: 1 },
  scale: 0.75,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$5g = {
  position: { x: 1, y: 0, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$5f = {
  position: { x: -2.3136449965377253, y: 1, z: -0.24890090226608064 },
  scale: 0.7,
  markers: [
    {
      offset: { x: 50, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_KILGOOT"],
      label: "slopedRoof.detail.valleyGutter",
      detail: "hellend-dak-kilgoot",
      slug: "kilgoot"
    },
    {
      offset: { x: 100, y: 35 },
      type: "search",
      arrow: "left",
      object: ["MARKER_NOK"],
      label: "slopedRoof.detail.ridge",
      detail: "hellend-dak-nok",
      slug: "nok"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "right",
      object: ["MARKER_GEVELVLAK"],
      label: "slopedRoof.detail.roofSurface",
      detail: "hellend-dak-dakvlak",
      slug: "dakvlak"
    },
    {
      offset: { x: 35, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_DAKRAAM"],
      label: "slopedRoof.detail.skylight",
      detail: "hellend-dak-dakraam",
      slug: "dakraam"
    },
    {
      offset: { x: 100, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_SCHOUW"],
      label: "slopedRoof.detail.chimney",
      detail: "hellend-dak-schouw",
      slug: "schouw"
    },
    {
      offset: { x: -50, y: 0 },
      type: "search",
      arrow: "right",
      object: ["MARKER_VOETBALK"],
      label: "slopedRoof.detail.footingBeam",
      detail: "hellend-dak-voetbalk",
      slug: "voetbalk"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: -4.066936332977327, y: 4.948226727165518, z: 6.358121272834756 },
      rotation: {
        x: -0.661339178354238,
        y: -0.46747100146479287,
        z: -0.3373020165750601
      },
      controls: {
        maxDistance: 10,
        minDistance: 3
      }
    }
  }
};
const settings$5e = {
  position: { x: 0.2744155542553337, y: -0.36, z: 0.85 },
  scale: 0.8,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 1.0842079587037994,
        y: 3.158236564109041,
        z: 3.721563503073412
      },
      rotation: {
        x: -0.703699128074302,
        y: 0.2185779129328259,
        z: 0.18198271266859475
      }
    }
  }
};
const settings$5d = {
  position: { x: 0.6060810109336121, y: 0.32599593624057394, z: -0.1835008849801516 },
  scale: 0.6,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.8658904717779086,
        y: 1.8780875953607676,
        z: 2.5549320625740077
      },
      rotation: {
        x: -0.12501431450437972,
        y: -0.7419119963703968,
        z: 1.2090944248929767
      }
    }
  }
};
const settings$5c = {
  position: { x: 0.5232659027078644, y: 0.6449855505674533, z: 1.1380277716094656 },
  scale: 0.75,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 2.9366909678275066, y: 2.6276646127608854, z: 3.0775355143888 },
      rotation: {
        x: -0.7067082036967897,
        y: 0.6277660465978301,
        z: 0.4648322781083648
      }
    }
  }
};
const settings$5b = {
  position: { x: 0.17050872929950156, y: -0.45, z: 1.0448670825108564 },
  scale: 0.9,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 1.9091695265256408, y: 3.02203949267553, z: 3.496047628922585 },
      rotation: {
        x: -0.7128039844760681,
        y: 0.39177973515181996,
        z: 0.31880467495558035
      }
    }
  }
};
const settings$5a = {
  position: { x: -0.12501431450437972, y: -0.7419119963703968, z: 1.2090944248929767 },
  scale: 0.6,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 2.4528315292286997,
        y: 2.8661589444351137,
        z: 3.2815774247236607
      },
      rotation: {
        x: -0.7179281374584179,
        y: 0.5127395117334126,
        z: 0.40480185204850366
      }
    }
  }
};
const settings$59 = {
  position: { x: 0.2727204433744578, y: 0.4572273686465473, z: 0.296808151708734 },
  scale: 0.9,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.8081846812766926,
        y: 2.413144301889822,
        z: 2.1620508808874344
      },
      rotation: { x: 2.7208880722985596, y: 2.8442405555599013, z: 3.083352681762437 }
    }
  }
};
const settings$58 = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_GEVELVLAK"],
      label: "ventilatedWall.detail.facade",
      detail: "ventgevel-gevelvlak",
      slug: "gevelvlak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_MUURAANSLUITING"],
      label: "ventilatedWall.detail.wallConnection",
      detail: "ventgevel-muuraansluiting",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_MUURVOET"],
      label: "ventilatedWall.detail.footing",
      detail: "ventgevel-muurvoet",
      slug: "muurvoet"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_RAAMAANSLUITING"],
      label: "ventilatedWall.detail.windowConnection",
      detail: "ventgevel-raamaansluiting",
      slug: "raamaansluiting"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 5
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  }
};
const settings$57 = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.213428501815209,
        y: 2.257357847174118,
        z: 3.0948687877716297
      },
      rotation: {
        x: -0.6301779107566367,
        y: 0.6979986750478864,
        z: 0.4383502991533371
      }
    }
  }
};
const settings$56 = {
  position: { x: 1.1678783963543178, y: -0.45, z: 1.0693694777489677 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 2.0648210685220274,
        y: 2.1047746188667316,
        z: 4.038123048987207
      },
      rotation: {
        x: -0.4804838374889825,
        y: 0.42570637488630914,
        z: 0.21201287951806666
      }
    }
  }
};
const settings$55 = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 4.08344610859198, y: 2.0463216482189353, z: 2.0342162103020294 },
      rotation: {
        x: -0.7883647827069522,
        y: 0.955650360528131,
        z: 0.6877433191533768
      }
    }
  }
};
const settings$54 = {
  position: { x: 0.5, y: 1.2186519093795245, z: 1 },
  scale: 0.7,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 2.639863971892351, y: 2.1280274840429674, z: 3.674590757766432 },
      rotation: {
        x: -0.5249247477121552,
        y: 0.5562117669960757,
        z: 0.296732224308962
      }
    }
  }
};
const settings$53 = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "floor.detail.wallConnection",
      detail: "vloer-muuraansluiting",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "floor.detail.floorPlane",
      detail: "vloer-vloervlak",
      slug: "vloervlak"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.0796418007387834,
        y: 1.7319750317472646,
        z: 3.5378056572607566
      },
      rotation: {
        x: -0.45526235339685306,
        y: 0.6635638422855563,
        z: 0.29286453663092876
      }
    }
  }
};
const settings$52 = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  }
};
const settings$51 = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 1.0245238792807212, y: 1.858220590883928, z: 4.527401799752076 },
      rotation: {
        x: -0.38947268022888926,
        y: 0.20636641785209067,
        z: 0.08390339230474775
      }
    }
  }
};
const settings$50 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4$ = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$4_ = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4Z = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4Y = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4X = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4W = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$4V = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4U = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$4T = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$4S = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$4R = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$4Q = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4P = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4O = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4N = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4M = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4L = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4K = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$4J = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4I = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4H = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4G = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4F = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4E = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$4D = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$4C = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$4B = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4A = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4z = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4y = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4x = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4w = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4v = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4u = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4t = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4s = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4r = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4q = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4p = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4o = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_e-circulair",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-e-circulair",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_e-circulair",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_e-circulair",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_e-circulair",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_e-circulair",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$4n = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_flamefree",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_flamefree",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_flamefree",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_flamefree",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_flamefree",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_flamefree",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_flamefree",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$4m = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_retention",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_retention",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_retention",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_retention",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_retention",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_retention",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_retention",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$4l = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer-atelia",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-atelia",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek-atelia",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick-atelia",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel-atelia",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak-atelia",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg-atelia",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$4k = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4j = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4i = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4h = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4g = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4f = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4e = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4d = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4c = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$4b = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$4a = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$49 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$48 = {
  position: { x: 0, y: 1.25, z: 0 },
  scale: 0.5,
  settings: {
    camera: {
      position: { x: 1.167, y: 2.91, z: 1.91 }
    }
  },
  markers: []
};
const Settings$5 = {
  "test-model": settings$48,
  "platdak-zettingsvoeg-atelia": settings$49,
  "platdak-zettingsvoeg_retention": settings$4a,
  "platdak-zettingsvoeg_flamefree": settings$4b,
  "platdak-zettingsvoeg_e-circulair": settings$4c,
  "platdak-waterafvoer-vertical-atelia": settings$4d,
  "platdak-waterafvoer-vertical_retention": settings$4e,
  "platdak-waterafvoer-vertical_flamefree": settings$4f,
  "platdak-waterafvoer-vertical_e-circulair": settings$4g,
  "platdak-waterafvoer-horizontal-atelia": settings$4h,
  "platdak-waterafvoer-horizontal_retention": settings$4i,
  "platdak-waterafvoer-horizontal_flamefree": settings$4j,
  "platdak-waterafvoer-horizontal_e-circulair": settings$4k,
  "platdak-overview-atelia": settings$4l,
  "platdak-overview_retention": settings$4m,
  "platdak-overview_flamefree": settings$4n,
  "platdak-overview_e-circulair": settings$4o,
  "platdak-opgaandeMuur-concrete-atelia": settings$4p,
  "platdak-opgaandeMuur-concrete_retention": settings$4q,
  "platdak-opgaandeMuur-concrete_flamefree": settings$4r,
  "platdak-opgaandeMuur-concrete_e-circulair": settings$4s,
  "platdak-opgaandeMuur-brick-atelia": settings$4t,
  "platdak-opgaandeMuur-brick_retention": settings$4u,
  "platdak-opgaandeMuur-brick_flamefree": settings$4v,
  "platdak-opgaandeMuur-brick_e-circulair": settings$4w,
  "platdak-koepel-atelia": settings$4x,
  "platdak-koepel_retention": settings$4y,
  "platdak-koepel_flamefree": settings$4z,
  "platdak-koepel_e-circulair": settings$4A,
  "platdak-dakvlak-atelia": settings$4B,
  "platdak-dakvlak_retention": settings$4C,
  "platdak-dakvlak_flamefree": settings$4D,
  "platdak-dakvlak_e-circulair": settings$4E,
  "platdak-dakopstand-vertical-atelia": settings$4F,
  "platdak-dakopstand-vertical_retention": settings$4G,
  "platdak-dakopstand-vertical_flamefree": settings$4H,
  "platdak-dakopstand-vertical_e-circulair": settings$4I,
  "platdak-dakopstand-horizontal-atelia": settings$4J,
  "platdak-dakopstand-horizontal_retention": settings$4K,
  "platdak-dakopstand-horizontal_flamefree": settings$4L,
  "platdak-dakopstand-horizontal_e-circulair": settings$4M,
  "platdak-dakopstand-atelia": settings$4N,
  "platdak-dakopstand_retention": settings$4O,
  "platdak-dakopstand_flamefree": settings$4P,
  "platdak-dakopstand_e-circulair": settings$4Q,
  "platdak-dakdoorvoer-atelia": settings$4R,
  "platdak-dakdoorvoer_retention": settings$4S,
  "platdak-dakdoorvoer_flamefree": settings$4T,
  "platdak-dakdoorvoer_e-circulair": settings$4U,
  "platdak-buitenhoek-atelia": settings$4V,
  "platdak-buitenhoek_retention": settings$4W,
  "platdak-buitenhoek_flamefree": settings$4X,
  "platdak-buitenhoek_e-circulair": settings$4Y,
  "platdak-binnenhoek-e-circulair": settings$4Z,
  "platdak-binnenhoek-atelia": settings$4_,
  "platdak-binnenhoek_retention": settings$4$,
  "platdak-binnenhoek_flamefree": settings$50,
  default: settings$5B,
  dollhouse: settings$5A,
  "platdak-overview": settings$5z,
  "platdak-binnenhoek": settings$5y,
  "platdak-buitenhoek": settings$5x,
  "platdak-dakdoorvoer": settings$5w,
  "platdak-dakopstand": settings$5v,
  "platdak-dakopstand-horizontal": settings$5u,
  "platdak-dakopstand-vertical": settings$5t,
  "platdak-dakvlak": settings$5s,
  "platdak-koepel": settings$5r,
  "platdak-opgaandeMuur-brick": settings$5q,
  "platdak-opgaandeMuur-concrete": settings$5p,
  "platdak-waterafvoer-horizontal": settings$5o,
  "platdak-waterafvoer-vertical": settings$5n,
  "platdak-zettingsvoeg": settings$5m,
  "spouwmuur-overview": settings$5l,
  "spouwmuur-plat-dak": settings$5k,
  "spouwmuur-raamaansluiting": settings$5j,
  "spouwmuur-muurvoet": settings$5i,
  "spouwmuur-hellend-dak": settings$5h,
  "spouwmuur-gevelvlak": settings$5g,
  "hellend-dak-overview": settings$5f,
  "hellend-dak-dakvlak": settings$5e,
  "hellend-dak-kilgoot": settings$5d,
  "hellend-dak-voetbalk": settings$5c,
  "hellend-dak-schouw": settings$5b,
  "hellend-dak-dakraam": settings$5a,
  "hellend-dak-nok": settings$59,
  "ventgevel-overview": settings$58,
  "ventgevel-gevelvlak": settings$57,
  "ventgevel-raamaansluiting": settings$56,
  "ventgevel-muurvoet": settings$55,
  "ventgevel-muuraansluiting": settings$54,
  "vloer-overview": settings$53,
  "vloer-vloervlak": settings$52,
  "vloer-muuraansluiting": settings$51
};
const settings$47 = {
  layers: [
    {
      name: "DAKBEDEKKING",
      default: "ZONNEPANELEN"
    },
    {
      name: "ONDERGROND",
      default: "BETON"
    },
    {
      name: "TOPLAAG",
      default: "CARBON-PANTERA"
    },
    {
      name: "ONDERLAAG",
      default: "BASE-P3-FT"
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "ISOLATIE",
      default: "ISOLATIE-ALU"
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "DAMPSCHERM",
      default: "DAMP-BASE-P3-TF"
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "BINNENSPOUWBLAD",
      default: "BETON"
    },
    {
      name: "GEVELBEKLEDING",
      default: ""
    },
    {
      name: "AANSLUITINGSPROFIEL",
      default: ""
    },
    {
      name: "DEKVLOER",
      default: "CHAPE"
    }
  ],
  toggles: [
    {
      name: "DAMPSCHERM",
      default: true
    },
    {
      name: "PROFIEL",
      default: true
    },
    {
      name: "TOPLAAG",
      default: false
    },
    {
      name: "KOEPEL",
      default: true
    },
    {
      name: "VENTILATIE",
      default: true
    },
    {
      name: "MUUR",
      default: true
    },
    {
      name: "AFVOER",
      default: true
    },
    {
      name: "ZETTINGSVOEG",
      default: true
    },
    {
      name: "ISOLATIE",
      default: true
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: true
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERLAAG",
      default: true
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERGROND",
      default: true
    },
    {
      name: "DAKBEDEKKING",
      default: true
    }
  ]
};
const settings$46 = {
  position: { x: 0, y: 1.2630926240141078, z: 0 },
  scale: 0.25,
  settings: {
    environment: {
      toneMappingExposure: 6.63
    },
    camera: {
      position: {
        x: 6.067824863992895,
        y: 2.5000691520141145,
        z: 0.011966211714026925
      },
      controls: {
        maxDistance: 6,
        minDistance: 6
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -35 },
      type: "flatroof",
      arrow: "down",
      label: "home.flatRoof",
      detail: "platdak-overview",
      slug: "flatroof",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "sloperoof",
      arrow: "down",
      label: "home.slopedRoof",
      detail: "hellend-dak-overview",
      slug: "sloperoof",
      active: true
    },
    {
      offset: { x: -30, y: 0 },
      type: "outsidewall",
      arrow: "right",
      label: "home.outerWall",
      detail: "ventgevel-overview",
      slug: "outsidewall",
      active: true
    },
    {
      offset: { x: -30, y: 0 },
      type: "cavitywall",
      arrow: "right",
      label: "home.cavityWall",
      detail: "spouwmuur-overview",
      slug: "cavitywall",
      active: true
    },
    {
      offset: { x: 0, y: 0 },
      type: "insidewall",
      arrow: "right",
      label: "home.innerWall",
      slug: "insidewall",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "floor",
      arrow: "down",
      label: "home.floor",
      detail: "vloer-overview",
      slug: "floor",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "basement",
      arrow: "down",
      label: "home.basement",
      slug: "basement",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "basementfloor",
      arrow: "down",
      label: "home.atticFloor",
      slug: "basementfloor",
      active: false
    }
  ]
};
const settings$45 = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg",
      slug: "zettingsvoeg"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  }
};
const settings$44 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  }
};
const settings$43 = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  }
};
const settings$42 = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  }
};
const settings$41 = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$40 = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    }
  ]
};
const settings$3$ = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ]
};
const settings$3_ = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$3Z = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    }
  ]
};
const settings$3Y = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.topLayer",
      layerType: ["TOPLAAG", "PROFIEL"],
      slug: "topLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3X = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3W = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_6"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_7"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    }
  ]
};
const settings$3V = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    }
  ]
};
const settings$3U = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$3T = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_RAAMAANSLUITING"],
      label: "cavityWall.detail.windowConnection",
      detail: "spouwmuur-raamaansluiting",
      slug: "raamaansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_GEVELVLAK"],
      label: "cavityWall.detail.facade",
      detail: "spouwmuur-gevelvlak",
      slug: "gevelvlak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_MUURVOET"],
      label: "cavityWall.detail.footing",
      detail: "spouwmuur-muurvoet",
      slug: "muurvoet"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_MUURAANSLUITING"],
      label: "cavityWall.detail.flatRoof",
      detail: "spouwmuur-plat-dak",
      slug: "plat-dak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_HELLEND_DAK"],
      label: "cavityWall.detail.slopedRoof",
      detail: "spouwmuur-hellend-dak",
      slug: "hellend-dak"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 5
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    },
    layers: [
      { name: "BINNENSPOUWBLAD", default: "BETON" },
      { name: "ISOLATIE", default: "ISOLATIE-ALUTG" }
    ],
    toggles: [
      { name: "BINNENSPOUWBLAD", default: true },
      { name: "ISOLATIE", default: true },
      { name: "Buitensteen", default: true }
    ]
  }
};
const settings$3S = {
  position: { x: 0, y: -0.36415480767947805, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$3R = {
  position: { x: 1, y: -0.45, z: 1 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$3Q = {
  position: { x: 1, y: -0.36415480767947805, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$3P = {
  position: { x: 0.5, y: 1, z: 1 },
  scale: 0.75,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$3O = {
  position: { x: 1, y: 0, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$3N = {
  position: { x: -2.3136449965377253, y: 1, z: -0.24890090226608064 },
  scale: 0.7,
  markers: [
    {
      offset: { x: 50, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_KILGOOT"],
      label: "slopedRoof.detail.valleyGutter",
      detail: "hellend-dak-kilgoot",
      slug: "kilgoot"
    },
    {
      offset: { x: 100, y: 35 },
      type: "search",
      arrow: "left",
      object: ["MARKER_NOK"],
      label: "slopedRoof.detail.ridge",
      detail: "hellend-dak-nok",
      slug: "nok"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "right",
      object: ["MARKER_GEVELVLAK"],
      label: "slopedRoof.detail.roofSurface",
      detail: "hellend-dak-dakvlak",
      slug: "dakvlak"
    },
    {
      offset: { x: 35, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_DAKRAAM"],
      label: "slopedRoof.detail.skylight",
      detail: "hellend-dak-dakraam",
      slug: "dakraam"
    },
    {
      offset: { x: 100, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_SCHOUW"],
      label: "slopedRoof.detail.chimney",
      detail: "hellend-dak-schouw",
      slug: "schouw"
    },
    {
      offset: { x: -50, y: 0 },
      type: "search",
      arrow: "right",
      object: ["MARKER_VOETBALK"],
      label: "slopedRoof.detail.footingBeam",
      detail: "hellend-dak-voetbalk",
      slug: "voetbalk"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: -4.066936332977327, y: 4.948226727165518, z: 6.358121272834756 },
      rotation: {
        x: -0.661339178354238,
        y: -0.46747100146479287,
        z: -0.3373020165750601
      },
      controls: {
        maxDistance: 10,
        minDistance: 3
      }
    }
  }
};
const settings$3M = {
  position: { x: 0.2744155542553337, y: -0.36, z: 0.85 },
  scale: 0.8,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 1.0842079587037994,
        y: 3.158236564109041,
        z: 3.721563503073412
      },
      rotation: {
        x: -0.703699128074302,
        y: 0.2185779129328259,
        z: 0.18198271266859475
      }
    }
  }
};
const settings$3L = {
  position: { x: 0.6060810109336121, y: 0.32599593624057394, z: -0.1835008849801516 },
  scale: 0.6,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.8658904717779086,
        y: 1.8780875953607676,
        z: 2.5549320625740077
      },
      rotation: {
        x: -0.12501431450437972,
        y: -0.7419119963703968,
        z: 1.2090944248929767
      }
    }
  }
};
const settings$3K = {
  position: { x: 0.5232659027078644, y: 0.6449855505674533, z: 1.1380277716094656 },
  scale: 0.75,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 2.9366909678275066, y: 2.6276646127608854, z: 3.0775355143888 },
      rotation: {
        x: -0.7067082036967897,
        y: 0.6277660465978301,
        z: 0.4648322781083648
      }
    }
  }
};
const settings$3J = {
  position: { x: 0.17050872929950156, y: -0.45, z: 1.0448670825108564 },
  scale: 0.9,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 1.9091695265256408, y: 3.02203949267553, z: 3.496047628922585 },
      rotation: {
        x: -0.7128039844760681,
        y: 0.39177973515181996,
        z: 0.31880467495558035
      }
    }
  }
};
const settings$3I = {
  position: { x: -0.12501431450437972, y: -0.7419119963703968, z: 1.2090944248929767 },
  scale: 0.6,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 2.4528315292286997,
        y: 2.8661589444351137,
        z: 3.2815774247236607
      },
      rotation: {
        x: -0.7179281374584179,
        y: 0.5127395117334126,
        z: 0.40480185204850366
      }
    }
  }
};
const settings$3H = {
  position: { x: 0.2727204433744578, y: 0.4572273686465473, z: 0.296808151708734 },
  scale: 0.9,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.8081846812766926,
        y: 2.413144301889822,
        z: 2.1620508808874344
      },
      rotation: { x: 2.7208880722985596, y: 2.8442405555599013, z: 3.083352681762437 }
    }
  }
};
const settings$3G = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_GEVELVLAK"],
      label: "ventilatedWall.detail.facade",
      detail: "ventgevel-gevelvlak",
      slug: "gevelvlak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_MUURAANSLUITING"],
      label: "ventilatedWall.detail.wallConnection",
      detail: "ventgevel-muuraansluiting",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_MUURVOET"],
      label: "ventilatedWall.detail.footing",
      detail: "ventgevel-muurvoet",
      slug: "muurvoet"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTMUUR_RAAMAANSLUITING"],
      label: "ventilatedWall.detail.windowConnection",
      detail: "ventgevel-raamaansluiting",
      slug: "raamaansluiting"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 5
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  }
};
const settings$3F = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.213428501815209,
        y: 2.257357847174118,
        z: 3.0948687877716297
      },
      rotation: {
        x: -0.6301779107566367,
        y: 0.6979986750478864,
        z: 0.4383502991533371
      }
    }
  }
};
const settings$3E = {
  position: { x: 1.1678783963543178, y: -0.45, z: 1.0693694777489677 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 2.0648210685220274,
        y: 2.1047746188667316,
        z: 4.038123048987207
      },
      rotation: {
        x: -0.4804838374889825,
        y: 0.42570637488630914,
        z: 0.21201287951806666
      }
    }
  }
};
const settings$3D = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 4.08344610859198, y: 2.0463216482189353, z: 2.0342162103020294 },
      rotation: {
        x: -0.7883647827069522,
        y: 0.955650360528131,
        z: 0.6877433191533768
      }
    }
  }
};
const settings$3C = {
  position: { x: 0.5, y: 1.2186519093795245, z: 1 },
  scale: 0.7,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 2.639863971892351, y: 2.1280274840429674, z: 3.674590757766432 },
      rotation: {
        x: -0.5249247477121552,
        y: 0.5562117669960757,
        z: 0.296732224308962
      }
    }
  }
};
const settings$3B = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "floor.detail.wallConnection",
      detail: "vloer-muuraansluiting",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "floor.detail.floorPlane",
      detail: "vloer-vloervlak",
      slug: "vloervlak"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.0796418007387834,
        y: 1.7319750317472646,
        z: 3.5378056572607566
      },
      rotation: {
        x: -0.45526235339685306,
        y: 0.6635638422855563,
        z: 0.29286453663092876
      }
    }
  }
};
const settings$3A = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  }
};
const settings$3z = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 1.0245238792807212, y: 1.858220590883928, z: 4.527401799752076 },
      rotation: {
        x: -0.38947268022888926,
        y: 0.20636641785209067,
        z: 0.08390339230474775
      }
    }
  }
};
const settings$3y = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3x = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$3w = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3v = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$3u = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3t = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3s = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$3r = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3q = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$3p = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$3o = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$3n = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$3m = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3l = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3k = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3j = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$3i = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3h = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3g = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$3f = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3e = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3d = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$3c = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3b = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$3a = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$39 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$38 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$37 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$36 = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$35 = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$34 = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$33 = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$32 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$31 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$30 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2$ = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$2_ = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2Z = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2Y = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2X = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2W = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_e-circulair",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-e-circulair",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_e-circulair",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_e-circulair",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_e-circulair",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_e-circulair",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$2V = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_flamefree",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_flamefree",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_flamefree",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_flamefree",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_flamefree",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_flamefree",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_flamefree",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$2U = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_retention",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_retention",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_retention",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_retention",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_retention",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_retention",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_retention",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$2T = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer-atelia",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-atelia",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek-atelia",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick-atelia",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel-atelia",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak-atelia",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg-atelia",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$2S = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2R = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2Q = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2P = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2O = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2N = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2M = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2L = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2K = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$2J = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$2I = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$2H = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const Settings$4 = {
  "platdak-zettingsvoeg-atelia": settings$2H,
  "platdak-zettingsvoeg_retention": settings$2I,
  "platdak-zettingsvoeg_flamefree": settings$2J,
  "platdak-zettingsvoeg_e-circulair": settings$2K,
  "platdak-waterafvoer-vertical-atelia": settings$2L,
  "platdak-waterafvoer-vertical_retention": settings$2M,
  "platdak-waterafvoer-vertical_flamefree": settings$2N,
  "platdak-waterafvoer-vertical_e-circulair": settings$2O,
  "platdak-waterafvoer-horizontal-atelia": settings$2P,
  "platdak-waterafvoer-horizontal_retention": settings$2Q,
  "platdak-waterafvoer-horizontal_flamefree": settings$2R,
  "platdak-waterafvoer-horizontal_e-circulair": settings$2S,
  "platdak-overview-atelia": settings$2T,
  "platdak-overview_retention": settings$2U,
  "platdak-overview_flamefree": settings$2V,
  "platdak-overview_e-circulair": settings$2W,
  "platdak-opgaandeMuur-concrete-atelia": settings$2X,
  "platdak-opgaandeMuur-concrete_retention": settings$2Y,
  "platdak-opgaandeMuur-concrete_flamefree": settings$2Z,
  "platdak-opgaandeMuur-concrete_e-circulair": settings$2_,
  "platdak-opgaandeMuur-brick-atelia": settings$2$,
  "platdak-opgaandeMuur-brick_retention": settings$30,
  "platdak-opgaandeMuur-brick_flamefree": settings$31,
  "platdak-opgaandeMuur-brick_e-circulair": settings$32,
  "platdak-koepel-atelia": settings$33,
  "platdak-koepel_retention": settings$34,
  "platdak-koepel_flamefree": settings$35,
  "platdak-koepel_e-circulair": settings$36,
  "platdak-dakvlak-atelia": settings$37,
  "platdak-dakvlak_retention": settings$38,
  "platdak-dakvlak_flamefree": settings$39,
  "platdak-dakvlak_e-circulair": settings$3a,
  "platdak-dakopstand-vertical-atelia": settings$3b,
  "platdak-dakopstand-vertical_retention": settings$3c,
  "platdak-dakopstand-vertical_flamefree": settings$3d,
  "platdak-dakopstand-vertical_e-circulair": settings$3e,
  "platdak-dakopstand-horizontal-atelia": settings$3f,
  "platdak-dakopstand-horizontal_retention": settings$3g,
  "platdak-dakopstand-horizontal_flamefree": settings$3h,
  "platdak-dakopstand-horizontal_e-circulair": settings$3i,
  "platdak-dakopstand-atelia": settings$3j,
  "platdak-dakopstand_retention": settings$3k,
  "platdak-dakopstand_flamefree": settings$3l,
  "platdak-dakopstand_e-circulair": settings$3m,
  "platdak-dakdoorvoer-atelia": settings$3n,
  "platdak-dakdoorvoer_retention": settings$3o,
  "platdak-dakdoorvoer_flamefree": settings$3p,
  "platdak-dakdoorvoer_e-circulair": settings$3q,
  "platdak-buitenhoek-atelia": settings$3r,
  "platdak-buitenhoek_retention": settings$3s,
  "platdak-buitenhoek_flamefree": settings$3t,
  "platdak-buitenhoek_e-circulair": settings$3u,
  "platdak-binnenhoek-e-circulair": settings$3v,
  "platdak-binnenhoek-atelia": settings$3w,
  "platdak-binnenhoek_retention": settings$3x,
  "platdak-binnenhoek_flamefree": settings$3y,
  default: settings$47,
  dollhouse: settings$46,
  "platdak-overview": settings$45,
  "platdak-binnenhoek": settings$44,
  "platdak-buitenhoek": settings$43,
  "platdak-dakdoorvoer": settings$42,
  "platdak-dakopstand": settings$41,
  "platdak-dakopstand-horizontal": settings$40,
  "platdak-dakopstand-vertical": settings$3$,
  "platdak-dakvlak": settings$3_,
  "platdak-koepel": settings$3Z,
  "platdak-opgaandeMuur-brick": settings$3Y,
  "platdak-opgaandeMuur-concrete": settings$3X,
  "platdak-waterafvoer-horizontal": settings$3W,
  "platdak-waterafvoer-vertical": settings$3V,
  "platdak-zettingsvoeg": settings$3U,
  "spouwmuur-overview": settings$3T,
  "spouwmuur-plat-dak": settings$3S,
  "spouwmuur-raamaansluiting": settings$3R,
  "spouwmuur-muurvoet": settings$3Q,
  "spouwmuur-hellend-dak": settings$3P,
  "spouwmuur-gevelvlak": settings$3O,
  "hellend-dak-overview": settings$3N,
  "hellend-dak-dakvlak": settings$3M,
  "hellend-dak-kilgoot": settings$3L,
  "hellend-dak-voetbalk": settings$3K,
  "hellend-dak-schouw": settings$3J,
  "hellend-dak-dakraam": settings$3I,
  "hellend-dak-nok": settings$3H,
  "ventgevel-overview": settings$3G,
  "ventgevel-gevelvlak": settings$3F,
  "ventgevel-raamaansluiting": settings$3E,
  "ventgevel-muurvoet": settings$3D,
  "ventgevel-muuraansluiting": settings$3C,
  "vloer-overview": settings$3B,
  "vloer-vloervlak": settings$3A,
  "vloer-muuraansluiting": settings$3z
};
const settings$2G = {
  layers: [
    {
      name: "DAKBEDEKKING",
      default: "PANNENDAK"
    },
    {
      name: "DAKBEDEKKING_LATTEN",
      default: "PANNENDAK"
    },
    {
      name: "HOUTEN_PLANKEN",
      default: ""
    },
    {
      name: "NOK_PLAAT",
      default: "PANNENDAK"
    },
    {
      name: "NOK_BALK",
      default: "PANNENDAK"
    },
    {
      name: "SCHOUW_AFVOERKANAAL",
      default: "PANNENDAK"
    },
    {
      name: "SCHOUW_DOORVOERPAN",
      default: "PANNENDAK"
    },
    {
      name: "DAKRAAM_GOOTELEMENT",
      default: "PANNENDAK"
    },
    {
      name: "KILGOOT_DAKTIMMER",
      default: "PANNENDAK"
    },
    {
      name: "KILGOOT_GOOTELEMENT",
      default: "PANNENDAK"
    },
    {
      name: "ONDERGROND",
      default: "ONDERGROND"
    },
    {
      name: "TOPLAAG",
      default: "POLYETHYLEENFOLIE"
    },
    {
      name: "ONDERLAAG",
      default: "POLYETHYLEENFOLIE"
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "ISOLATIE",
      default: "ISOLATIE_KRALU"
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "DAMPSCHERM",
      default: "DAMP-BASE-P3-TF"
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "BINNENSPOUWBLAD",
      default: "KALKZANDSTEEN"
    },
    {
      name: "GEVELBEKLEDING",
      default: ""
    },
    {
      name: "AANSLUITINGSPROFIEL",
      default: ""
    },
    {
      name: "DEKVLOER",
      default: "GEWAPEND"
    },
    {
      name: "DRAAGVLOER",
      default: "CHAPE"
    },
    {
      name: "VLOERVERWARMING",
      default: "TEST"
    },
    {
      name: "RANDISOLATIE",
      default: "TEST"
    },
    {
      name: "AKOESTISCHE_LAAG",
      default: ""
    },
    {
      name: "ISOLATIE_ONDERDAKFOLIE",
      default: ""
    }
  ],
  toggles: [
    {
      name: "HOUTEN_PLANKEN",
      default: false
    },
    {
      name: "DAMPSCHERM",
      default: true
    },
    {
      name: "PROFIEL",
      default: true
    },
    {
      name: "TOPLAAG",
      default: true
    },
    {
      name: "KOEPEL",
      default: true
    },
    {
      name: "VENTILATIE",
      default: true
    },
    {
      name: "MUUR",
      default: true
    },
    {
      name: "AFVOER",
      default: true
    },
    {
      name: "ZETTINGSVOEG",
      default: true
    },
    {
      name: "ISOLATIE",
      default: true
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: true
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERLAAG",
      default: true
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERGROND",
      default: true
    },
    {
      name: "DAKBEDEKKING",
      default: true
    },
    {
      name: "BINNENSPOUWBLAD",
      default: true
    },
    {
      name: "DEKVLOER",
      default: true
    },
    {
      name: "DRAAGVLOER",
      default: true
    },
    {
      name: "VLOERVERWARMING",
      default: true
    },
    {
      name: "RANDISOLATIE",
      default: true
    },
    {
      name: "AKOESTISCHE_LAAG",
      default: true
    },
    {
      name: "ISOLATIE_ONDERDAKFOLIE",
      default: false
    }
  ]
};
const settings$2F = {
  position: { x: 0, y: 1.2630926240141078, z: 0 },
  scale: 0.25,
  settings: {
    environment: {
      toneMappingExposure: 6.63
    },
    camera: {
      position: {
        x: 6.067824863992895,
        y: 2.5000691520141145,
        z: 0.011966211714026925
      },
      controls: {
        maxDistance: 6,
        minDistance: 6
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -35 },
      type: "flatroof",
      arrow: "down",
      label: "home.flatRoof",
      detail: "platdak-overview",
      slug: "flatroof",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "sloperoof",
      arrow: "down",
      label: "home.toitEnPente",
      detail: "hellend-dak-overview_fr",
      slug: "sloperoof",
      active: true
    },
    {
      offset: { x: -30, y: 0 },
      type: "outsidewall",
      arrow: "right",
      label: "home.outerWall",
      detail: "ventgevel-overview",
      slug: "outsidewall",
      active: false
    },
    {
      offset: { x: -30, y: 0 },
      type: "cavitywall",
      arrow: "right",
      label: "home.cavityWall",
      detail: "spouwmuur-overview",
      slug: "cavitywall",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "insidewall",
      arrow: "right",
      label: "home.innerWall",
      slug: "insidewall",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "floor",
      arrow: "down",
      label: "home.floor",
      detail: "vloer_overview_sousdallage_fr",
      slug: "floor",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "basement",
      arrow: "down",
      label: "home.basement",
      slug: "basement",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "basementfloor",
      arrow: "down",
      label: "home.atticFloor",
      slug: "basementfloor",
      active: false
    }
  ]
};
const settings$2E = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_dalleportee_fr",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_dalleportee_fr",
      slug: "vloervlak"
    }
  ]
};
const settings$2D = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_souschape_fr",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_souschape_fr",
      slug: "vloervlak"
    }
  ]
};
const settings$2C = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_sousdallage_fr",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_sousdallage_fr",
      slug: "vloervlak"
    }
  ]
};
const settings$2B = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_dalleportee_fr",
      slug: "muuraansluiting",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_dalleportee_fr",
      slug: "vloervlak",
      active: false
    }
  ]
};
const settings$2A = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_souschape_fr",
      slug: "muuraansluiting",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_souschape_fr",
      slug: "vloervlak",
      active: false
    }
  ]
};
const settings$2z = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_sousdallage_fr",
      slug: "muuraansluiting",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_sousdallage_fr",
      slug: "vloervlak",
      active: false
    }
  ]
};
const settings$2y = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_dalleportee_fr",
      slug: "muuraansluiting",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_dalleportee_fr",
      slug: "vloervlak",
      active: false
    }
  ]
};
const settings$2x = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_souschape_fr",
      slug: "muuraansluiting",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_souschape_fr",
      slug: "vloervlak",
      active: false
    }
  ]
};
const settings$2w = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "sol.detail.wallConnection",
      detail: "vloer_muuraansluiting_sousdallage_fr",
      slug: "muuraansluiting",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "sol.detail.solPlane",
      detail: "vloer_vloervlak_sousdallage_fr",
      slug: "vloervlak",
      active: false
    }
  ]
};
const settings$2v = {
  position: { x: -2.3136449965377253, y: 1, z: -0.24890090226608064 },
  scale: 0.7,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: -4.066936332977327, y: 4.948226727165518, z: 6.358121272834756 },
      rotation: {
        x: -0.661339178354238,
        y: -0.46747100146479287,
        z: -0.3373020165750601
      },
      controls: {
        maxDistance: 10,
        minDistance: 3
      }
    }
  },
  markers: [
    {
      offset: { x: 50, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_KILGOOT"],
      label: "slopedRoof.detail.valleyGutter",
      detail: "hellend-dak-kilgoot_fr",
      slug: "kilgoot"
    },
    {
      offset: { x: 100, y: 35 },
      type: "search",
      arrow: "left",
      object: ["MARKER_NOK"],
      label: "slopedRoof.detail.ridge",
      detail: "hellend-dak-nok_fr",
      slug: "nok"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "right",
      object: ["MARKER_GEVELVLAK"],
      label: "slopedRoof.detail.roofSurface",
      detail: "hellend-dak-dakvlak_fr",
      slug: "dakvlak"
    },
    {
      offset: { x: 35, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_DAKRAAM"],
      label: "slopedRoof.detail.skylight",
      detail: "hellend-dak-dakraam_fr",
      slug: "dakraam"
    },
    {
      offset: { x: 100, y: 0 },
      type: "search",
      arrow: "left",
      object: ["MARKER_SCHOUW"],
      label: "slopedRoof.detail.chimney",
      detail: "hellend-dak-schouw_fr",
      slug: "schouw"
    },
    {
      offset: { x: -50, y: 0 },
      type: "search",
      arrow: "right",
      object: ["MARKER_VOETBALK"],
      label: "slopedRoof.detail.footingBeam",
      detail: "hellend-dak-voetbalk_fr",
      slug: "voetbalk"
    }
  ]
};
const settings$2u = {
  position: { x: -0.12501431450437972, y: -0.7419119963703968, z: 1.2090944248929767 },
  scale: 0.6,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 2.4528315292286997,
        y: 2.8661589444351137,
        z: 3.2815774247236607
      },
      rotation: {
        x: -0.7179281374584179,
        y: 0.5127395117334126,
        z: 0.40480185204850366
      }
    }
  }
};
const settings$2t = {
  position: { x: 0.2744155542553337, y: -0.36, z: 0.85 },
  scale: 0.8,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 1.0842079587037994,
        y: 3.158236564109041,
        z: 3.721563503073412
      },
      rotation: {
        x: -0.703699128074302,
        y: 0.2185779129328259,
        z: 0.18198271266859475
      }
    }
  }
};
const settings$2s = {
  position: { x: 0.6060810109336121, y: 0.32599593624057394, z: -0.1835008849801516 },
  scale: 0.6,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.8658904717779086,
        y: 1.8780875953607676,
        z: 2.5549320625740077
      },
      rotation: {
        x: -0.12501431450437972,
        y: -0.7419119963703968,
        z: 1.2090944248929767
      }
    }
  }
};
const settings$2r = {
  position: { x: 0.2727204433744578, y: 0.4572273686465473, z: 0.296808151708734 },
  scale: 0.9,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.8081846812766926,
        y: 2.413144301889822,
        z: 2.1620508808874344
      },
      rotation: { x: 2.7208880722985596, y: 2.8442405555599013, z: 3.083352681762437 }
    }
  }
};
const settings$2q = {
  position: { x: 0.17050872929950156, y: -0.45, z: 1.0448670825108564 },
  scale: 0.9,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 1.9091695265256408, y: 3.02203949267553, z: 3.496047628922585 },
      rotation: {
        x: -0.7128039844760681,
        y: 0.39177973515181996,
        z: 0.31880467495558035
      }
    }
  }
};
const settings$2p = {
  position: { x: 0.5232659027078644, y: 0.6449855505674533, z: 1.1380277716094656 },
  scale: 0.75,
  markers: [],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 2.9366909678275066, y: 2.6276646127608854, z: 3.0775355143888 },
      rotation: {
        x: -0.7067082036967897,
        y: 0.6277660465978301,
        z: 0.4648322781083648
      }
    }
  }
};
const Settings$3 = {
  default: settings$2G,
  dollhouse: settings$2F,
  vloer_overview_dalleportee_fr: settings$2E,
  vloer_overview_souschape_fr: settings$2D,
  vloer_overview_sousdallage_fr: settings$2C,
  vloer_vloervlak_dalleportee_fr: settings$2B,
  vloer_vloervlak_souschape_fr: settings$2A,
  vloer_vloervlak_sousdallage_fr: settings$2z,
  vloer_muuraansluiting_dalleportee_fr: settings$2y,
  vloer_muuraansluiting_souschape_fr: settings$2x,
  vloer_muuraansluiting_sousdallage_fr: settings$2w,
  "hellend-dak-voetbalk_fr": settings$2p,
  "hellend-dak-schouw_fr": settings$2q,
  "hellend-dak-nok_fr": settings$2r,
  "hellend-dak-kilgoot_fr": settings$2s,
  "hellend-dak-dakvlak_fr": settings$2t,
  "hellend-dak-dakraam_fr": settings$2u,
  "hellend-dak-overview_fr": settings$2v
};
const settings$2o = {
  layers: [
    {
      name: "DAKBEDEKKING",
      default: "ZONNEPANELEN"
    },
    {
      name: "ONDERGROND",
      default: "BETON"
    },
    {
      name: "TOPLAAG",
      default: "CARBON-PANTERA"
    },
    {
      name: "ONDERLAAG",
      default: "BASE-P3-FT"
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "ISOLATIE",
      default: "ISOLATIE-ALU"
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "DAMPSCHERM",
      default: "DAMP-BASE-P3-TF"
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "BINNENSPOUWBLAD",
      default: "BETON"
    },
    {
      name: "GEVELBEKLEDING",
      default: ""
    },
    {
      name: "AANSLUITINGSPROFIEL",
      default: ""
    },
    {
      name: "ISOLATIE_SCHEIDINGSFOLIE_PROFIEL",
      default: "ISOLATIE_ALU"
    },
    {
      name: "DEKVLOER",
      default: "CHAPE"
    }
  ],
  toggles: [
    {
      name: "DAMPSCHERM",
      default: true
    },
    {
      name: "PROFIEL",
      default: true
    },
    {
      name: "ISOLATIE_SCHEIDINGSFOLIE_PROFIEL",
      default: true
    },
    {
      name: "TOPLAAG",
      default: false
    },
    {
      name: "KOEPEL",
      default: true
    },
    {
      name: "VENTILATIE",
      default: true
    },
    {
      name: "MUUR",
      default: true
    },
    {
      name: "AFVOER",
      default: true
    },
    {
      name: "ZETTINGSVOEG",
      default: true
    },
    {
      name: "ISOLATIE",
      default: true
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: true
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERLAAG",
      default: true
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERGROND",
      default: true
    },
    {
      name: "DAKBEDEKKING",
      default: true
    }
  ]
};
const settings$2n = {
  position: { x: 0, y: 1.2630926240141078, z: 0 },
  scale: 0.25,
  settings: {
    environment: {
      toneMappingExposure: 6.63
    },
    camera: {
      position: {
        x: 6.067824863992895,
        y: 2.5000691520141145,
        z: 0.011966211714026925
      },
      controls: {
        maxDistance: 6,
        minDistance: 6
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -35 },
      type: "flatroof",
      arrow: "down",
      label: "home.flatRoof",
      detail: "platdak-overview",
      slug: "flatroof",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "sloperoof",
      arrow: "down",
      label: "home.slopedRoof",
      detail: "hellend-dak-overview",
      slug: "sloperoof",
      active: false
    },
    {
      offset: { x: -30, y: 0 },
      type: "outsidewall",
      arrow: "right",
      label: "home.outerWall",
      detail: "ventgevel-overview",
      slug: "outsidewall",
      active: false
    },
    {
      offset: { x: -30, y: 0 },
      type: "cavitywall",
      arrow: "right",
      label: "home.cavityWall",
      detail: "spouwmuur-overview",
      slug: "cavitywall",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "insidewall",
      arrow: "right",
      label: "home.innerWall",
      slug: "insidewall",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "floor",
      arrow: "down",
      label: "home.floor",
      detail: "vloer-overview",
      slug: "floor",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "basement",
      arrow: "down",
      label: "home.basement",
      slug: "basement",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "basementfloor",
      arrow: "down",
      label: "home.atticFloor",
      slug: "basementfloor",
      active: false
    }
  ]
};
const settings$2m = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  }
};
const settings$2l = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2k = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$2j = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2i = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$2h = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  }
};
const settings$2g = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2f = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2e = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$2d = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$2c = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  }
};
const settings$2b = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$2a = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$29 = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$28 = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$27 = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$26 = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$25 = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$24 = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$23 = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$22 = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$21 = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$20 = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1$ = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$1_ = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1Z = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1Y = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1X = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1W = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1V = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1U = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$1T = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$1S = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$1R = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$1Q = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1P = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1O = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1N = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1M = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1L = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1K = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$1J = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1I = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1H = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1G = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1F = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1E = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1D = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1C = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1B = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1A = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg",
      slug: "zettingsvoeg"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  }
};
const settings$1z = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_e-circulair",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-e-circulair",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_e-circulair",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_e-circulair",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_e-circulair",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_e-circulair",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$1y = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_flamefree",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_flamefree",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_flamefree",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_flamefree",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_flamefree",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_flamefree",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_flamefree",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$1x = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_retention",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_retention",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_retention",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_retention",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_retention",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_retention",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_retention",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$1w = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer-atelia",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-atelia",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek-atelia",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick-atelia",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel-atelia",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak-atelia",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg-atelia",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$1v = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1u = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1t = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1s = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1r = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1q = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1p = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1o = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1n = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1m = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$1l = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$1k = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$1j = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1i = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$1h = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$1g = {
  position: { x: 1, y: 0, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$1f = {
  position: { x: 0.5, y: 1, z: 1 },
  scale: 0.75,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$1e = {
  position: { x: 1, y: -0.36415480767947805, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$1d = {
  position: { x: 1, y: -0.45, z: 1.5 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_RAAMAANSLUITING"],
      label: "cavityWall.detail.windowConnection",
      detail: "spouwmuur-raamaansluiting",
      slug: "raamaansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_GEVELVLAK"],
      label: "cavityWall.detail.facade",
      detail: "spouwmuur-gevelvlak",
      slug: "gevelvlak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_MUURVOET"],
      label: "cavityWall.detail.footing",
      detail: "spouwmuur-muurvoet",
      slug: "muurvoet"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_MUURAANSLUITING"],
      label: "cavityWall.detail.flatRoof",
      detail: "spouwmuur-plat-dak",
      slug: "plat-dak"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["SPOUWMUUR_HELLEND_DAK"],
      label: "cavityWall.detail.slopedRoof",
      detail: "spouwmuur-hellend-dak",
      slug: "hellend-dak"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3,
        y: 3,
        z: 5
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    },
    layers: [
      { name: "BINNENSPOUWBLAD", default: "BETON" },
      { name: "ISOLATIE", default: "ISOLATIE-ALUTG" }
    ],
    toggles: [
      { name: "BINNENSPOUWBLAD", default: true },
      { name: "ISOLATIE", default: true },
      { name: "Buitensteen", default: true }
    ]
  }
};
const settings$1c = {
  position: { x: 0, y: -0.36415480767947805, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$1b = {
  position: { x: 1, y: -0.45, z: 1 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: 3
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  }
};
const settings$1a = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: { x: 1.0245238792807212, y: 1.858220590883928, z: 4.527401799752076 },
      rotation: {
        x: -0.38947268022888926,
        y: 0.20636641785209067,
        z: 0.08390339230474775
      }
    }
  }
};
const settings$19 = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  markers: [
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_MUURAANSLUITING"],
      label: "floor.detail.wallConnection",
      detail: "vloer-muuraansluiting",
      slug: "muuraansluiting"
    },
    {
      offset: { x: 0, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VLOER_VLOERVLAK"],
      label: "floor.detail.floorPlane",
      detail: "vloer-vloervlak",
      slug: "vloervlak"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.0796418007387834,
        y: 1.7319750317472646,
        z: 3.5378056572607566
      },
      rotation: {
        x: -0.45526235339685306,
        y: 0.6635638422855563,
        z: 0.29286453663092876
      }
    }
  }
};
const settings$18 = {
  position: { x: 1.2273173703768159, y: -0.45, z: 1.846469640848679 },
  scale: 1,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.7039218156092852,
        y: 2.4081773284278127,
        z: 2.3412913399873094
      },
      rotation: {
        x: -0.7994800685296647,
        y: 0.8342372615530843,
        z: 0.6511034983705325
      }
    }
  }
};
const Settings$2 = {
  "vloer-vloervlak": settings$18,
  "vloer-overview": settings$19,
  "vloer-muuraansluiting": settings$1a,
  "spouwmuur-raamaansluiting": settings$1b,
  "spouwmuur-plat-dak": settings$1c,
  "spouwmuur-overview": settings$1d,
  "spouwmuur-muurvoet": settings$1e,
  "spouwmuur-hellend-dak": settings$1f,
  "spouwmuur-gevelvlak": settings$1g,
  "platdak-zettingsvoeg-atelia": settings$1h,
  "platdak-zettingsvoeg_retention": settings$1i,
  "platdak-zettingsvoeg_flamefree": settings$1j,
  "platdak-zettingsvoeg_e-circulair": settings$1k,
  "platdak-zettingsvoeg": settings$1l,
  "platdak-waterafvoer-vertical-atelia": settings$1m,
  "platdak-waterafvoer-vertical_retention": settings$1n,
  "platdak-waterafvoer-vertical_flamefree": settings$1o,
  "platdak-waterafvoer-vertical_e-circulair": settings$1p,
  "platdak-waterafvoer-vertical": settings$1q,
  "platdak-waterafvoer-horizontal-atelia": settings$1r,
  "platdak-waterafvoer-horizontal_retention": settings$1s,
  "platdak-waterafvoer-horizontal_flamefree": settings$1t,
  "platdak-waterafvoer-horizontal_e-circulair": settings$1u,
  "platdak-waterafvoer-horizontal": settings$1v,
  "platdak-overview-atelia": settings$1w,
  "platdak-overview_retention": settings$1x,
  "platdak-overview_flamefree": settings$1y,
  "platdak-overview_e-circulair": settings$1z,
  "platdak-overview": settings$1A,
  "platdak-opgaandeMuur-concrete-atelia": settings$1B,
  "platdak-opgaandeMuur-concrete_retention": settings$1C,
  "platdak-opgaandeMuur-concrete_flamefree": settings$1D,
  "platdak-opgaandeMuur-concrete_e-circulair": settings$1E,
  "platdak-opgaandeMuur-concrete": settings$1F,
  "platdak-opgaandeMuur-brick-atelia": settings$1G,
  "platdak-opgaandeMuur-brick_retention": settings$1H,
  "platdak-opgaandeMuur-brick_flamefree": settings$1I,
  "platdak-opgaandeMuur-brick_e-circulair": settings$1J,
  "platdak-opgaandeMuur-brick": settings$1K,
  "platdak-koepel-atelia": settings$1L,
  "platdak-koepel_retention": settings$1M,
  "platdak-koepel_flamefree": settings$1N,
  "platdak-koepel_e-circulair": settings$1O,
  "platdak-koepel": settings$1P,
  "platdak-dakvlak-atelia": settings$1Q,
  "platdak-dakvlak_retention": settings$1R,
  "platdak-dakvlak_flamefree": settings$1S,
  "platdak-dakvlak_e-circulair": settings$1T,
  "platdak-dakvlak": settings$1U,
  "platdak-dakopstand-vertical-atelia": settings$1V,
  "platdak-dakopstand-vertical_retention": settings$1W,
  "platdak-dakopstand-vertical_flamefree": settings$1X,
  "platdak-dakopstand-vertical_e-circulair": settings$1Y,
  "platdak-dakopstand-vertical": settings$1Z,
  "platdak-dakopstand-horizontal-atelia": settings$1_,
  "platdak-dakopstand-horizontal_retention": settings$1$,
  "platdak-dakopstand-horizontal_flamefree": settings$20,
  "platdak-dakopstand-horizontal_e-circulair": settings$21,
  "platdak-dakopstand-horizontal": settings$22,
  "platdak-dakopstand-atelia": settings$23,
  "platdak-dakopstand_retention": settings$24,
  "platdak-dakopstand_flamefree": settings$25,
  "platdak-dakopstand_e-circulair": settings$26,
  "platdak-dakopstand": settings$27,
  "platdak-dakdoorvoer-atelia": settings$28,
  "platdak-dakdoorvoer_retention": settings$29,
  "platdak-dakdoorvoer_flamefree": settings$2a,
  "platdak-dakdoorvoer_e-circulair": settings$2b,
  "platdak-dakdoorvoer": settings$2c,
  "platdak-buitenhoek-atelia": settings$2d,
  "platdak-buitenhoek_retention": settings$2e,
  "platdak-buitenhoek_flamefree": settings$2f,
  "platdak-buitenhoek_e-circulair": settings$2g,
  "platdak-buitenhoek": settings$2h,
  "platdak-binnenhoek-e-circulair": settings$2i,
  "platdak-binnenhoek-atelia": settings$2j,
  "platdak-binnenhoek_retention": settings$2k,
  "platdak-binnenhoek_flamefree": settings$2l,
  "platdak-binnenhoek": settings$2m,
  default: settings$2o,
  dollhouse: settings$2n
};
const settings$17 = {
  layers: [
    {
      name: "DAKBEDEKKING",
      default: "ZONNEPANELEN"
    },
    {
      name: "ONDERGROND",
      default: "BETON"
    },
    {
      name: "TOPLAAG",
      default: "CARBON-PANTERA"
    },
    {
      name: "ONDERLAAG",
      default: "BASE-P3-FT"
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "ISOLATIE",
      default: "ISOLATIE-ALU"
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "DAMPSCHERM",
      default: "DAMP-BASE-P3-TF"
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: "SCHROEF"
    },
    {
      name: "BINNENSPOUWBLAD",
      default: "BETON"
    },
    {
      name: "GEVELBEKLEDING",
      default: ""
    },
    {
      name: "AANSLUITINGSPROFIEL",
      default: ""
    },
    {
      name: "DEKVLOER",
      default: "CHAPE"
    }
  ],
  toggles: [
    {
      name: "DAMPSCHERM",
      default: true
    },
    {
      name: "PROFIEL",
      default: true
    },
    {
      name: "TOPLAAG",
      default: false
    },
    {
      name: "KOEPEL",
      default: true
    },
    {
      name: "VENTILATIE",
      default: true
    },
    {
      name: "MUUR",
      default: true
    },
    {
      name: "AFVOER",
      default: true
    },
    {
      name: "ZETTINGSVOEG",
      default: true
    },
    {
      name: "ISOLATIE",
      default: true
    },
    {
      name: "ISOLATIE-BEVESTIGING",
      default: true
    },
    {
      name: "TOPLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "DAMPSCHERM-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERLAAG",
      default: true
    },
    {
      name: "ONDERLAAG-BEVESTIGING",
      default: true
    },
    {
      name: "ONDERGROND",
      default: true
    },
    {
      name: "DAKBEDEKKING",
      default: true
    }
  ]
};
const settings$16 = {
  position: { x: 0, y: 1.2630926240141078, z: 0 },
  scale: 0.25,
  settings: {
    environment: {
      toneMappingExposure: 6.63
    },
    camera: {
      position: {
        x: 6.067824863992895,
        y: 2.5000691520141145,
        z: 0.011966211714026925
      },
      controls: {
        maxDistance: 6,
        minDistance: 6
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -35 },
      type: "flatroof",
      arrow: "down",
      label: "home.flatRoof",
      detail: "platdak-overview",
      slug: "flatroof",
      active: true
    },
    {
      offset: { x: 0, y: -35 },
      type: "sloperoof",
      arrow: "down",
      label: "home.slopedRoof",
      detail: "hellend-dak-overview",
      slug: "sloperoof",
      active: false
    },
    {
      offset: { x: -30, y: 0 },
      type: "outsidewall",
      arrow: "right",
      label: "home.outerWall",
      detail: "ventgevel-overview",
      slug: "outsidewall",
      active: false
    },
    {
      offset: { x: -30, y: 0 },
      type: "cavitywall",
      arrow: "right",
      label: "home.cavityWall",
      detail: "spouwmuur-overview",
      slug: "cavitywall",
      active: false
    },
    {
      offset: { x: 0, y: 0 },
      type: "insidewall",
      arrow: "right",
      label: "home.innerWall",
      slug: "insidewall",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "floor",
      arrow: "down",
      label: "home.floor",
      detail: "vloer-overview",
      slug: "floor",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "basement",
      arrow: "down",
      label: "home.basement",
      slug: "basement",
      active: false
    },
    {
      offset: { x: 0, y: -35 },
      type: "basementfloor",
      arrow: "down",
      label: "home.atticFloor",
      slug: "basementfloor",
      active: false
    }
  ]
};
const settings$15 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  }
};
const settings$14 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$13 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$12 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$11 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2,
  settings: {
    camera: {
      position: {
        x: 5.991337067705878,
        y: 3.008404199744376,
        z: -3.584107947843827
      },
      rotation: {
        x: -0.09965630533508422,
        y: 0.8519383764794283,
        z: 0.17574270564971536
      }
    },
    directionalLight: {
      position: { x: 2.56, y: 11.26, z: -2.22 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$10 = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  }
};
const settings$$ = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$_ = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$Z = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$Y = {
  position: { x: 0, y: 0.25, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$X = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ],
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  }
};
const settings$W = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$V = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$U = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$T = {
  position: { x: 1.2010073348243444, y: 0, z: 0 },
  scale: 3,
  settings: {
    directionalLight: {
      position: { x: 2.56, y: 5.17, z: 4.3 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 5.956931400503907,
        y: 3.3340203458388373,
        z: 3.3454031286119545
      },
      rotation: {
        x: -0.19423106125718975,
        y: 0.4921826630848033,
        z: 0.11368486490802993
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "VENTILATIE"],
      slug: "roofFloor"
    }
  ]
};
const settings$S = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$R = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$Q = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$P = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$O = {
  position: { x: 1, y: 0, z: 0 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ],
      toggles: [
        { name: "ONDERLAAG", default: true },
        { name: "DAMPSCHERM", default: true },
        { name: "PROFIEL", default: true },
        { name: "TOPLAAG", default: true },
        { name: "ISOLATIE", default: true }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$N = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$M = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$L = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$K = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$J = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$I = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$H = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$G = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$F = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$E = {
  position: { x: 1, y: 0, z: 0.25 },
  scale: 2.25,
  settings: {
    camera: {
      position: {
        x: 3.917165394777748,
        y: 2.363844186708644,
        z: 2.1023647891801502
      },
      rotation: {
        x: -0.2076115731434187,
        y: 0.498121556927349,
        z: 0.12419709590514637
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$D = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$C = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$B = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$A = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    }
  ]
};
const settings$z = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: -5.491776001133163,
        y: 4.933422233339936,
        z: 1.8149895015312134
      },
      rotation: {
        x: -1.2182677496065637,
        y: -0.8072657924881532,
        z: -1.0997598226751102
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: "ONDERGROND",
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$y = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$x = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$w = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$v = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$u = {
  position: { x: -0.6565126276025577, y: -0.36415480767947805, z: 1.4773446667921295 },
  scale: 2.5,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 3.6847638236238502,
        y: 3.309143721082648,
        z: -5.767540972289235
      },
      rotation: {
        x: -2.6206960603296614,
        y: 0.5060215577009691,
        z: 2.870347832947992
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "KOEPEL", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$t = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    }
  ]
};
const settings$s = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$r = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$q = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$p = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$o = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$n = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$m = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$l = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: ["DAMPSCHERM", "DAMPSCHERM-BEVESTIGING"],
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$k = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    camera: {
      position: {
        x: 4.563658356415679,
        y: 3.1989724702749247,
        z: 5.170303957219912
      },
      rotation: {
        x: -0.20152851532945565,
        y: 0.34544200331751906,
        z: 0.07621920190025025
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      slug: "vaporShield"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$j = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg",
      slug: "zettingsvoeg"
    }
  ],
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  }
};
const settings$i = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_e-circulair",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-e-circulair",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_e-circulair",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_e-circulair",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_e-circulair",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_e-circulair",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_e-circulair",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_e-circulair",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$h = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_flamefree",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_flamefree",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_flamefree",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_flamefree",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_flamefree",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_flamefree",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_flamefree",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_flamefree",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_flamefree",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$g = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer_retention",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek_retention",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek_retention",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick_retention",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel_retention",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak_retention",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal_retention",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical_retention",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg_retention",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$f = {
  position: { x: 2.421426215397801, y: 0.4027354771692119, z: -1.9008370449875112 },
  scale: 0.5,
  settings: {
    camera: {
      position: {
        x: 4.288001075830628,
        y: 1.5121203509027514,
        z: 0.21051589135571863
      },
      rotation: {
        x: -0.10482713160278063,
        y: 0.6982255638108843,
        z: 0.10450042858075063
      }
    }
  },
  markers: [
    {
      offset: { x: 70, y: 0 },
      type: "search",
      arrow: "left",
      object: ["VENTILATIE"],
      label: "roofDetails.roofTerminal",
      detail: "platdak-dakdoorvoer-atelia",
      slug: "dakdoorvoer"
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.angleConnectionInside",
      offset: { x: 0, y: -35 },
      detail: "platdak-binnenhoek-atelia",
      slug: "binnenhoek"
    },
    {
      type: "search",
      arrow: "right",
      label: "roofDetails.angleConnectionOutside",
      offset: { x: -50, y: 0 },
      detail: "platdak-buitenhoek-atelia",
      slug: "buitenhoek"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.verticalWall",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.verticalWallBrick",
          detail: "platdak-opgaandeMuur-brick-atelia",
          unique: true
        },
        {
          label: "roofDetails.verticalWallConcrete",
          detail: "platdak-opgaandeMuur-concrete-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.dome",
      offset: { x: 0, y: -45 },
      detail: "platdak-koepel-atelia",
      slug: "koepel"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "left",
      label: "roofDetails.roofUpstand",
      offset: { x: 50, y: 0 },
      width: "250",
      slug: "dakopstand",
      layers: [
        {
          label: "roofDetails.roofUpstandBoth",
          detail: "platdak-dakopstand-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandHorizontal",
          detail: "platdak-dakopstand-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.roofUpstandVertical",
          detail: "platdak-dakopstand-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.roofSurface",
      offset: { x: 0, y: -25 },
      detail: "platdak-dakvlak-atelia",
      slug: "dakvlak"
    },
    {
      type: "layers",
      icon: "search",
      arrow: "right",
      label: "roofDetails.drainagePipe",
      offset: { x: -50, y: 0 },
      width: "250",
      slug: "opgaandeMuur",
      layers: [
        {
          label: "roofDetails.drainagePipeHorizontal",
          detail: "platdak-waterafvoer-horizontal-atelia",
          unique: true
        },
        {
          label: "roofDetails.drainagePipeVertical",
          detail: "platdak-waterafvoer-vertical-atelia",
          unique: true
        }
      ]
    },
    {
      type: "search",
      arrow: "down",
      label: "roofDetails.settlementJoint",
      offset: { x: 0, y: -25 },
      detail: "platdak-zettingsvoeg-atelia",
      slug: "zettingsvoeg"
    }
  ]
};
const settings$e = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$d = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$c = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_5"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$b = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$a = {
  position: { x: 1.7763248115027737, y: 0, z: 0.21202960258197323 },
  scale: 2,
  settings: {
    directionalLight: {
      position: { x: 3.23, y: 6.59, z: 3.47 },
      color: { r: 255, g: 255, b: 255 },
      intensity: 4,
      shadowScale: 10,
      normalBias: 0.1,
      mapSize: 1024,
      radius: 1
    },
    camera: {
      position: {
        x: 4.511575972451586,
        y: 1.4994178003329466,
        z: -1.5483631695574354
      },
      rotation: {
        x: -0.08815349304316603,
        y: 0.8044036788951384,
        z: 0.1234546699312177
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_5"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$9 = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$8 = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$7 = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$6 = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$5 = {
  position: { x: 0, y: 0, z: 2 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 1.9512365248652033,
        y: 2.0209779950481237,
        z: 4.136220976635948
      },
      rotation: {
        x: -0.20155575269065443,
        y: 0.21389993196284338,
        z: 0.04515519379087251
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "MUUR"],
      slug: "roofFloor"
    }
  ]
};
const settings$4 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$3 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings$2 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_3"
        }
      ]
    },
    {
      hidden: true,
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.bottomLayer",
      layerType: ["ONDERLAAG", "ONDERLAAG-BEVESTIGING"],
      slug: "bottomLayer"
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    }
  ]
};
const settings$1 = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const settings = {
  position: { x: 0, y: 0, z: 0 },
  scale: 2.5,
  settings: {
    layers: [
      { name: "DAKBEDEKKING", default: "ZONNEPANELEN" },
      { name: "ONDERGROND", default: "HOUT" },
      { name: "TOPLAAG", default: "CARBON" },
      { name: "ONDERLAAG", default: "BASE-P3-FT" },
      { name: "ONDERLAAG-BEVESTIGING", default: "SCHROEF" },
      { name: "ISOLATIE", default: "ISOLATIE-MG" },
      { name: "ISOLATIE-BEVESTIGING", default: "SCHROEF" },
      { name: "DAMPSCHERM", default: "DAMP-BASE-P3-TF" }
    ],
    toggles: [
      { name: "DAMPSCHERM", default: false },
      { name: "PROFIEL", default: false },
      { name: "TOPLAAG", default: false },
      { name: "KOEPEL", default: true },
      { name: "VENTILATIE", default: true },
      { name: "ISOLATIE", default: false },
      { name: "ISOLATIE-BEVESTIGING", default: false },
      { name: "ONDERLAAG", default: true },
      { name: "ONDERLAAG-BEVESTIGING", default: false },
      { name: "ONDERGROND", default: true },
      { name: "DAKBEDEKKING", default: false }
    ],
    camera: {
      position: {
        x: 4.225458146743344,
        y: 2.3772928323018956,
        z: -1.2222856620308902
      },
      rotation: {
        x: -0.14734663776137027,
        y: 0.7749306643458553,
        z: 0.19600997594801062
      }
    }
  },
  markers: [
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.topLayer",
      layerType: "TOPLAAG",
      layers: [
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_1"
        },
        {
          label: "flatRoof.overview.topLayer",
          toggle: "TOPLAAG_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.bottomLayer",
      layerType: "ONDERLAAG",
      layers: [
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_1"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_2"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_3"
        },
        {
          label: "flatRoof.overview.bottomLayer",
          toggle: "ONDERLAAG_4"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      type: "layers",
      arrow: "down",
      label: "flatRoof.overview.vaporShield",
      layerType: "DAMPSCHERM",
      layers: [
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_1"
        },
        {
          label: "flatRoof.overview.vaporShield",
          toggle: "DAMPSCHERM_2"
        }
      ]
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.insulation",
      layerType: "ISOLATIE",
      slug: "insulation"
    },
    {
      offset: { x: 0, y: -25 },
      arrow: "down",
      type: "toggle",
      icon: "toggle",
      label: "flatRoof.overview.roofFloor",
      layerType: ["ONDERGROND", "ZETTINGSVOEG"],
      slug: "roofFloor"
    }
  ]
};
const Settings$1 = {
  "platdak-zettingsvoeg-atelia": settings,
  "platdak-zettingsvoeg_retention": settings$1,
  "platdak-zettingsvoeg_flamefree": settings$2,
  "platdak-zettingsvoeg_e-circulair": settings$3,
  "platdak-zettingsvoeg": settings$4,
  "platdak-waterafvoer-vertical-atelia": settings$5,
  "platdak-waterafvoer-vertical_retention": settings$6,
  "platdak-waterafvoer-vertical_flamefree": settings$7,
  "platdak-waterafvoer-vertical_e-circulair": settings$8,
  "platdak-waterafvoer-vertical": settings$9,
  "platdak-waterafvoer-horizontal-atelia": settings$a,
  "platdak-waterafvoer-horizontal_retention": settings$b,
  "platdak-waterafvoer-horizontal_flamefree": settings$c,
  "platdak-waterafvoer-horizontal_e-circulair": settings$d,
  "platdak-waterafvoer-horizontal": settings$e,
  "platdak-overview-atelia": settings$f,
  "platdak-overview_retention": settings$g,
  "platdak-overview_flamefree": settings$h,
  "platdak-overview_e-circulair": settings$i,
  "platdak-overview": settings$j,
  "platdak-opgaandeMuur-concrete-atelia": settings$k,
  "platdak-opgaandeMuur-concrete_retention": settings$l,
  "platdak-opgaandeMuur-concrete_flamefree": settings$m,
  "platdak-opgaandeMuur-concrete_e-circulair": settings$n,
  "platdak-opgaandeMuur-concrete": settings$o,
  "platdak-opgaandeMuur-brick-atelia": settings$p,
  "platdak-opgaandeMuur-brick_retention": settings$q,
  "platdak-opgaandeMuur-brick_flamefree": settings$r,
  "platdak-opgaandeMuur-brick_e-circulair": settings$s,
  "platdak-opgaandeMuur-brick": settings$t,
  "platdak-koepel-atelia": settings$u,
  "platdak-koepel_retention": settings$v,
  "platdak-koepel_flamefree": settings$w,
  "platdak-koepel_e-circulair": settings$x,
  "platdak-koepel": settings$y,
  "platdak-dakvlak-atelia": settings$z,
  "platdak-dakvlak_retention": settings$A,
  "platdak-dakvlak_flamefree": settings$B,
  "platdak-dakvlak_e-circulair": settings$C,
  "platdak-dakvlak": settings$D,
  "platdak-dakopstand-vertical-atelia": settings$E,
  "platdak-dakopstand-vertical_retention": settings$F,
  "platdak-dakopstand-vertical_flamefree": settings$G,
  "platdak-dakopstand-vertical_e-circulair": settings$H,
  "platdak-dakopstand-vertical": settings$I,
  "platdak-dakopstand-horizontal-atelia": settings$J,
  "platdak-dakopstand-horizontal_retention": settings$K,
  "platdak-dakopstand-horizontal_flamefree": settings$L,
  "platdak-dakopstand-horizontal_e-circulair": settings$M,
  "platdak-dakopstand-horizontal": settings$N,
  "platdak-dakopstand-atelia": settings$O,
  "platdak-dakopstand_retention": settings$P,
  "platdak-dakopstand_flamefree": settings$Q,
  "platdak-dakopstand_e-circulair": settings$R,
  "platdak-dakopstand": settings$S,
  "platdak-dakdoorvoer-atelia": settings$T,
  "platdak-dakdoorvoer_retention": settings$U,
  "platdak-dakdoorvoer_flamefree": settings$V,
  "platdak-dakdoorvoer_e-circulair": settings$W,
  "platdak-dakdoorvoer": settings$X,
  "platdak-buitenhoek-atelia": settings$Y,
  "platdak-buitenhoek_retention": settings$Z,
  "platdak-buitenhoek_flamefree": settings$_,
  "platdak-buitenhoek_e-circulair": settings$$,
  "platdak-buitenhoek": settings$10,
  "platdak-binnenhoek-e-circulair": settings$11,
  "platdak-binnenhoek-atelia": settings$12,
  "platdak-binnenhoek_retention": settings$13,
  "platdak-binnenhoek_flamefree": settings$14,
  "platdak-binnenhoek": settings$15,
  default: settings$17,
  dollhouse: settings$16
};
class Renderer {
  constructor(options) {
    __publicField(this, "cleanMaterial", (material) => {
      material.dispose();
      for (const key of Object.keys(material)) {
        const value = material[key];
        if (value && typeof value === "object" && "minFilter" in value) {
          value.dispose();
        }
      }
    });
    Store.dir = options.dir;
    Store.lang = options.lang;
    Store.country = options.country || "be";
    Store.renderer = this;
    switch (Store.country) {
      case "be":
        window.Settings = Settings$5;
        break;
      case "nl":
        window.Settings = Settings$4;
        break;
      case "fr":
        window.Settings = Settings$3;
        break;
      case "de":
        window.Settings = Settings$2;
        break;
      case "en":
        window.Settings = Settings$1;
        break;
    }
    this.defaultState = JSON.parse(JSON.stringify(Store.state));
    this.firstLoad = true;
    this.loadingManager = new LoadingManager$1();
    this.container = Store.container = options.container;
    this.container.classList.add("renderer");
    this.loader = new TextureLoader();
    this.layout = new Layout();
    this.resizeCb = () => this.onResize();
    this.init();
    window.renderer = this;
    window.store = Store;
    this.defaultSettings = this.settings = Settings.default;
    setTimeout(() => {
      Promise.all(this.promises).then(() => {
        this.loaded = true;
        this.readyResolve();
      });
    }, 300);
  }
  async init() {
    this.render = this.render.bind(this);
    this.events = Events;
    const { debug: debug2 } = Store;
    if (debug2) {
      this.debug = new Debug(this);
    }
    this.loadAllModels();
    this.toggles = [];
    this.promises = [];
    this.layersTypes = {};
    this.windows = [];
    this.scene = new Scene();
    this.camera = new Camera(this);
    this.renderer = new GlRenderer();
    this.lights = new Lights(this);
    this.controls = new Controls(this);
    Store.controls = this.controls;
    this.markers = new Markers(this.camera, this.scene);
    this.addListeners();
    this.render();
    this.onResize();
    this.ready = new Promise((resolve, reject) => {
      this.readyResolve = resolve;
    });
    Store.raf = new Raf();
    Store.raf.add(this.render, "renderer_main");
  }
  destroy() {
    this.renderer.dispose();
    this.removeListeners();
  }
  update() {
    this.controls.update();
    if (this.markers.loaded)
      this.markers.update();
  }
  render() {
    if (Store.debug)
      this.debug.stats.begin();
    this.update();
    this.renderer.render(this.scene, this.camera);
    if (Store.debug)
      this.debug.stats.end();
  }
  fetchModelSettings(model) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 0);
    }).then(() => {
      Store[model] = Settings[model];
      if (Store.debug && Store[model] === Store.current)
        this.debug.createConfigInfo(Settings[model]);
    });
  }
  async loadAllModels() {
    this.models = ["dollhouse"];
    this.models.forEach((model) => {
      this.loadModelInBackground(model);
    });
  }
  async loadModelInBackground(model) {
    await this.fetchModelSettings(model);
    const promise = Load(model, Store.dir, true);
    this.promises.push(promise);
    await promise;
    this.updateAllMaterials();
  }
  async load(id) {
    if (Store.current === Store[id])
      return;
    this.events.emit("LOAD_START");
    if (this.model) {
      this.model.visible = false;
      disposeChildren(this.model);
      this.scene.remove(this.model);
    }
    await this.ready;
    if (this.loadingModel)
      return;
    this.loadingModel = true;
    this.markers.hide();
    this.toggles = [];
    this.layersTypes = {};
    this.windows = [];
    await next();
    await this.fetchModelSettings(id);
    await Load(id, Store.dir, true);
    await this.awaitLoad(id);
    this.events.emit("LOADED", id);
  }
  async showCurrent() {
    this.scene.children.forEach((child) => {
      if (child.slug)
        child.visible = false;
    });
    await next();
    Store.current.model.visible = true;
  }
  async awaitLoad(id) {
    await this.loadModel(id);
    await next();
    this.showCurrent();
    Store.current.model.visible = true;
    this.events.emit("LOAD", id);
    this.loadingModel = false;
  }
  loadBakedTextures(id) {
    var _a;
    (_a = Store[`${id}`].model) == null ? void 0 : _a.traverse((child) => {
      if (child.isMesh && child.name === "Mesh028_1") {
        let params = {
          brightness: { value: -0.022 },
          contrast: { value: 3.261 },
          grayscale: { value: 0.1 },
          multiplyF: { value: 0.815 }
        };
        this.addContrast(child, params, "Grass");
      }
      if (child.isMesh && child.name === "Mesh028") {
        this.loader.load(
          `${Store.dir}models/textures/medium/dollhouse_baked.${Store.webp ? "webp" : "jpg"}`,
          (texture) => {
            texture.encoding = sRGBEncoding;
            let newMat = new MeshBasicMaterial({
              map: texture
            });
            child.material = newMat;
            child.material.map.flipY = false;
            let params = {
              brightness: { value: 0.043 },
              contrast: { value: 6.957 },
              grayscale: { value: 0.1 },
              multiplyF: { value: 0.35 }
            };
            this.addContrast(child, params, "Dollhouse");
          }
        );
      }
    });
  }
  addContrast(child, params, folderName) {
    if (Store.debug) {
      const DollhouseF = this.debug.pane.addFolder({
        title: folderName,
        expanded: false
      });
      DollhouseF.addInput(params.brightness, "value", {
        label: "Brightness",
        step: 1e-3,
        min: -1,
        max: 1
      });
      DollhouseF.addInput(params.contrast, "value", {
        label: "Contrast",
        step: 1e-3,
        min: 0,
        max: 10
      });
      DollhouseF.addInput(params.grayscale, "value", {
        label: "Grayscale",
        step: 1e-3,
        min: 0,
        max: 1
      });
      DollhouseF.addInput(params.multiplyF, "value", {
        label: "multiply",
        step: 1e-3,
        min: 0,
        max: 5
      });
    }
    child.material.onBeforeCompile = (shader) => {
      shader.uniforms.contrast = params.contrast;
      shader.uniforms.brightness = params.brightness;
      shader.uniforms.grayscale = params.grayscale;
      shader.uniforms.multiplyF = params.multiplyF;
      shader.fragmentShader = shader.fragmentShader.replace(
        "#include <common>",
        `#include <common>
                uniform float contrast;
                uniform float brightness;
                uniform float grayscale;
                uniform float multiplyF;`
      );
      shader.fragmentShader = shader.fragmentShader.replace(
        "gl_FragColor = vec4( outgoingLight, diffuseColor.a );",
        `
                vec3 a = outgoingLight.rgb / 5.;
                vec3 colorContrasted = (a) * contrast;
                vec3 bright = colorContrasted + vec3(brightness,brightness,brightness);
                vec3 mixed = max(bright, vec3(.0,.0,.0));

                float bw = (min(mixed.r, min(mixed.g, mixed.b)) + max(mixed.r, max(mixed.g, mixed.b))) * 0.5;
                vec3 gray = vec3(bw, bw, bw);
                vec3 mixedgray = mix(mixed, gray, grayscale);
                gl_FragColor = vec4( mixedgray * vec3(pow(texelColor.r, multiplyF), pow(texelColor.g, multiplyF), pow(texelColor.b, multiplyF)), diffuseColor.a );`
      );
    };
    child.material.needsUpdate = true;
  }
  clear() {
    if (Store.current.model)
      this.hide(Store.current.id);
  }
  checkForLayers(model) {
    model == null ? void 0 : model.traverse((child) => {
      if (child.userData.layerType) {
        this.toggles.push(child.userData.layerType);
        this.layersTypes[child.userData.layerType] = [];
      } else if (child.userData.layer) {
        this.toggles.push(child.userData.layer);
      }
    });
    this.toggles = [...new Set(this.toggles)];
    model == null ? void 0 : model.traverse((child) => {
      if (child.userData.layer) {
        const layers2 = child.userData.layer.split(", ");
        if (child.userData.layerType) {
          layers2.forEach(
            (layer) => this.layersTypes[child.userData.layerType].push(layer)
          );
        }
      }
    });
    for (const layer in this.layersTypes) {
      this.layersTypes[layer] = [...new Set(this.layersTypes[layer])];
    }
    if (Store.debug) {
      this.debug.clear();
      for (const layer in this.layersTypes) {
        this.debug.createLayers(this.layersTypes[layer], layer);
      }
      this.debug.createToggles(this.toggles);
    }
  }
  checkForMarkers(model) {
    this.markers.initMarkers(model);
  }
  async setMarkerLayer(slug, options) {
    await this.ready;
    this.markers.setMarkerLayer(slug, options);
  }
  async onMarkerClick(slug, fn) {
    await this.ready;
    this.markers.onMarkerClick(slug, fn);
  }
  updateAllMaterials() {
    const { env, model } = Store.scene;
    model == null ? void 0 : model.traverse((child) => {
      if (child instanceof Mesh && (child.material instanceof MeshStandardMaterial || child.material instanceof MeshLambertMaterial)) {
        child.material.envMap = env;
        child.material.envMapIntensityOriginal = child.material.envMapIntensity;
        child.material.envMapIntensity = child.material.envMapIntensityOriginal;
        child.castShadow = true;
        child.receiveShadow = true;
        child.material.needsUpdate = true;
        if (child.material.name === "Windows") {
          child.material = new MeshPhongMaterial({
            color: "white",
            emissive: "white",
            emissiveIntensity: 3.5,
            envMap: env,
            opacity: 0.15,
            refractionRatio: 0.75,
            shininess: 100,
            transparent: true,
            reflectivity: 1
          });
          child.material.needsUpdate = true;
          child.material.name = "Windows";
          this.windows.push(child);
        }
        if (child.material.name === "PLASTIEK_2" || child.material.name === "GLAS") {
          child.material = new MeshPhongMaterial({
            color: "black",
            emissive: "white",
            emissiveIntensity: 1,
            envMap: env,
            side: DoubleSide,
            refractionRatio: 0.7,
            shininess: 0.5,
            reflectivity: 0.65
          });
          child.material.needsUpdate = true;
        }
        if (child.material.name.includes("Druklaag")) {
          child.material.color = new Color("#BCBB87");
        }
        if (child.material.name.includes("SCHROEF") || child.material.name.includes("Vijs") || child.material.name.includes("PLASTIEK_blauw") || child.material.name.includes("PLASTIEK_Blauw")) {
          child.material.color = new Color(0.063, 0.223, 0.947);
          child.material.onBeforeCompile = (shader) => {
            shader.fragmentShader = shader.fragmentShader.replace(
              "gl_FragColor = vec4( outgoingLight, diffuseColor.a );",
              `vec3 blue = vec3(0.278,0.51,0.976);gl_FragColor = vec4( outgoingLight * blue, diffuseColor.a );`
            );
          };
        }
      }
    });
    this.windows.forEach((window2) => {
      window2.material.color = new Color(
        `rgb(${parseInt(Store.windows.color.r)}, ${parseInt(
          Store.windows.color.g
        )}, ${parseInt(Store.windows.color.b)})`
      );
      window2.material.reflectivity = Store.windows.reflectivity;
      window2.material.needsUpdate = true;
    });
  }
  replaceTextures(model = Store.scene.model) {
    if (!Store.loaded)
      return;
    const textureTypes = ["map", "normalMap", "metalnessMap", "roughnessMap"];
    textureTypes.forEach((textureType) => {
      model == null ? void 0 : model.traverse((child) => {
        if (child.material && child.material[textureType]) {
          const {
            wrapS,
            wrapT,
            repeat,
            mapping,
            encoding,
            flipY,
            offset
          } = child.material[textureType];
          const { normalScale } = child.material;
          const higres = child.material[textureType].sourceUriLarge;
          if (higres !== void 0) {
            const touch = window.matchMedia("(pointer:coarse)");
            const sm = touch && touch.matches || window.innerWidth < 1024;
            const medium = higres.startsWith("../textures") ? higres.replace("../textures/", `textures/${sm ? "small" : "medium"}/`) : higres.replace("textures/", `textures/${sm ? "small" : "medium"}/`);
            this.loader.load(`${Store.dir}/models/${medium}`, (texture) => {
              texture.encoding = sRGBEncoding;
              child.material[textureType] = texture;
              child.material[textureType].encoding = encoding;
              child.material[textureType].wrapS = wrapS;
              child.material[textureType].wrapT = wrapT;
              child.material[textureType].repeat = repeat;
              child.material[textureType].mapping = mapping;
              child.material[textureType].flipY = flipY;
              child.material[textureType].offset = offset;
              child.material.normalScale = normalScale;
              child.material[textureType].needsUpdate = true;
            });
          }
        }
      });
    });
    if (model) {
      model.loaded = true;
    }
  }
  updateAllEnvIntensity(value) {
    var _a;
    (_a = Store.scene.model) == null ? void 0 : _a.traverse((child) => {
      if (child instanceof Mesh && child.material instanceof MeshStandardMaterial) {
        child.material.envMapIntensity = child.material.envMapIntensityOriginal * value;
      }
    });
  }
  hide(id) {
    this.scene.children.forEach((child) => {
      if (child.slug === id)
        child.visible = false;
    });
  }
  hideAll() {
    this.scene.children.forEach((child) => {
      child.visible = false;
    });
  }
  loadModel(id) {
    return new Promise((resolve, reject) => {
      Store.current = Store[id];
      Store.current.slug = id;
      const {
        position = new Vector3(0, 0, 0),
        scale = 1,
        model,
        env,
        settings: settings2 = {}
      } = Store.current;
      this.model = model;
      if (model === void 0)
        return;
      model.scale.set(scale, scale, scale);
      model.position.copy(position);
      model.slug = id;
      this.updateAllMaterials(model, env);
      this.applyModelSettings(settings2);
      this.checkForLayers(model);
      setTimeout(() => {
        this.applyDefaultSettings(this.settings);
      }, 0);
      if (id === "dollhouse") {
        this.loadBakedTextures(id);
        this.controls.controls.maxAzimuthAngle = 2.5;
        this.controls.controls.minAzimuthAngle = 0.5;
        this.controls.controls.minPolarAngle = -2;
        this.scene.floor.position.y = -1;
      } else {
        this.controls.controls.maxAzimuthAngle = Infinity;
        this.controls.controls.minAzimuthAngle = Infinity;
        this.controls.controls.minPolarAngle = 0;
        this.scene.floor.position.y = -0.5;
      }
      if (Store[id].model !== void 0) {
        if (Store.debug || Store.preview) {
          this.controls.transform.attach(this.model);
          if (!this.controls.transformLoaded) {
            this.scene.add(this.controls.transform);
            this.controls.transformLoaded = true;
          }
        }
      }
      if (Store.preview) {
        this.controls.transform.visible = false;
        this.controls.controls.maxAzimuthAngle = Infinity;
        this.controls.controls.minAzimuthAngle = Infinity;
        this.controls.controls.maxPolarAngle = Math.PI * 2;
        this.controls.controls.minPolarAngle = 0;
        this.controls.controls.maxDistance = 100;
        this.controls.controls.minDistance = 0;
        this.scene.remove(this.scene.floor);
      }
      this.isLoaded = true;
      setTimeout(() => {
        this.checkForMarkers(model);
        this.firstLoad = false;
        resolve();
      }, 60);
    });
  }
  checkLayerType(layerType, child, visible) {
    if (layerType) {
      if (Store.state[layerType].current === child.userData.layer || child.userData.layer === void 0) {
        child.visible = visible === "auto" ? !child.visible : visible;
      }
    }
  }
  toggle(id, visible = "auto", layerType = null) {
    var _a;
    if (Store.state[id]) {
      Store.state[id].active = visible === "auto" ? !Store.state[id].active : visible;
    }
    if (id === "VLOERVERWARMING" && Store.state[id].current === "GEEN_VLOERVERWARMING") {
      Store.state[id].active = false;
      visible = false;
    }
    (_a = this.model) == null ? void 0 : _a.traverse((child) => {
      var _a2;
      if (Store.state.HIDE_ON_PMMA.visible === false && child.userData.HIDE_ON_PMMA) {
        return;
      }
      if (child.userData.layerType && child.userData.layerType === id) {
        if (((_a2 = Store.state[child.userData.layerType]) == null ? void 0 : _a2.current) === child.userData.layer) {
          child.visible = visible === "auto" ? !child.visible : visible;
          const layers2 = child.userData.layer.split(", ");
          if (child.userData.checkMaterial) {
            const similarMaterials = this.checkSimilarMaterials(child.material);
            similarMaterials.forEach((similarMaterial) => {
              var _a3;
              if (child.userData.layer && layers2.includes((_a3 = Store.state[child.userData.layerType]) == null ? void 0 : _a3.current)) {
                similarMaterial.visible = Store.state[id].active;
              }
            });
          }
        } else {
          child.visible = false;
        }
        if (!child.userData.layer) {
          child.visible = Store.state[id].active;
        }
        if (Store.debug) {
          this.debug.updateGUI("toggle", { id, visible: child.visible });
        }
      }
      if (child.userData.layer && child.userData.layer === id || child.userData.subLayer && child.userData.subLayer === id) {
        if (child.userData.layerType !== void 0) {
          if (Array.isArray(layerType)) {
            layerType.forEach((type) => {
              this.checkLayerType(type, child, visible);
            });
          } else {
            this.checkLayerType(layerType, child, visible);
          }
        } else {
          child.visible = visible === "auto" ? !child.visible : visible;
        }
        if (Store.debug) {
          this.debug.updateGUI("toggle", { id, visible: child.visible });
        }
      }
    });
  }
  setLayerForProp(propName, propValue, visible = "auto") {
    var _a;
    if (Store.state[propName]) {
      Store.state[propName].active = visible;
    }
    (_a = this.model) == null ? void 0 : _a.traverse((child) => {
      if (child.userData[propName] && child.userData[propName] === propValue) {
        if (visible === "auto") {
          child.visible = !child.visible;
        } else {
          child.visible = visible;
        }
        if (Store.debug) {
          this.debug.updateGUI("setLayerForProp", {
            propName,
            propValue,
            visible: child.visible
          });
        }
      }
    });
  }
  setLayer(layerType, id, setActive = true) {
    var _a;
    if (id === "") {
      this.toggle(layerType, false);
      return;
    }
    if (Store.state[layerType]) {
      Store.state[layerType].current = id;
      if (setActive)
        Store.state[layerType].active = true;
    }
    (_a = this.model) == null ? void 0 : _a.traverse((child) => {
      if (child.userData.layerType && child.userData.layerType === layerType && child.userData.layer) {
        const layers2 = child.userData.layer.split(", ");
        if (child.userData.checkMaterial) {
          const similarMaterials = this.checkSimilarMaterials(child.material);
          similarMaterials.forEach((similarMaterial) => {
            similarMaterial.visible = child.userData.layer && layers2.includes(id);
          });
        }
        child.visible = child.userData.layer && layers2.includes(id);
        if (Store.debug)
          this.debug.updateGUI("setLayer", { layerType, id });
      }
    });
    this.events.emit("SETLAYER", id);
  }
  checkSimilarMaterials(material) {
    var _a;
    let models = [];
    (_a = this.model) == null ? void 0 : _a.traverse((child) => {
      if (child.material === material) {
        models.push(child);
      }
    });
    return models;
  }
  applyModelSettings(settings2) {
    this.camera.onReset();
    this.controls.onReset();
    if (Store.current.slug === "dollhouse") {
      this.controls.controls.enablePan = false;
    } else {
      this.controls.controls.enablePan = true;
    }
    let { directionalLight, environment, camera } = settings2;
    if (directionalLight === void 0)
      directionalLight = Store.directionalLight;
    if (environment === void 0)
      environment = Store.environment;
    if (directionalLight) {
      this.directionalLight.position.x = directionalLight.position.x;
      this.directionalLight.position.y = directionalLight.position.y;
      this.directionalLight.intensity = directionalLight.intensity;
    }
    if (environment) {
      this.renderer.toneMappingExposure = environment.toneMappingExposure;
      this.updateAllMaterials();
    }
    if (camera) {
      if (camera.position) {
        this.camera.position.set(camera.position.x, camera.position.y, camera.position.z);
      }
      if (camera.rotation) {
        this.camera.quaternion.set(camera.rotation.x, camera.rotation.y, camera.rotation.z);
      }
      if (camera.controls) {
        this.controls.controls.maxDistance = camera.controls.maxDistance;
        this.controls.controls.minDistance = camera.controls.minDistance;
      } else {
        this.controls.controls.maxDistance = 5;
        this.controls.controls.minDistance = 3;
      }
    }
  }
  applySettings(obj, settings2) {
    if (settings2) {
      for (const [key, value] of Object.entries(settings2)) {
        this.applySetting(obj, key, value);
      }
    }
  }
  applySetting(obj, key, value) {
    if (value !== void 0)
      obj[key] = value;
  }
  async reset() {
    Store.state = JSON.parse(JSON.stringify(this.defaultState));
    await next();
    this.applyDefaultSettings(this.defaultSettings, true);
  }
  async applyDefaultSettings(settings2, reset = false) {
    if (this.model === void 0)
      return;
    if (settings2.layers) {
      settings2.layers.forEach((layer) => {
        if (Store.state[layer.name].current === null) {
          this.setLayer(layer.name, layer.default);
        } else {
          this.setLayer(layer.name, Store.state[layer.name].current, false);
        }
      });
    }
    await next;
    if (settings2.toggles) {
      settings2.toggles.forEach((toggle2) => {
        var _a;
        if (this.firstLoad || reset) {
          if (Store.state[toggle2.name]) {
            Store.state[toggle2.name].active = toggle2.default;
          }
        }
        (_a = this.model) == null ? void 0 : _a.traverse((child) => {
          if (child.userData.layerType && child.userData.layerType === toggle2.name) {
            if (this.firstLoad) {
              if (Store.state[child.userData.layerType]) {
                Store.state[child.userData.layerType].active = toggle2.default;
                if (Store.state[child.userData.layerType].current === child.userData.layer) {
                  child.visible = toggle2.default;
                }
              }
            } else {
              if (Store.state[child.userData.layerType].current === child.userData.layer) {
                child.visible = Store.state[child.userData.layerType].active;
              }
            }
          }
          if (child.userData.layer && child.userData.layer === toggle2.name) {
            child.visible = toggle2.default;
            if (Store.debug) {
              this.debug.updateGUI("toggle", {
                id: toggle2.name,
                visible: toggle2.default
              });
            }
          }
        });
      });
    }
  }
  addListeners() {
    window.addEventListener("resize", this.resizeCb, { passive: true });
    this.events.on("LOADED", () => {
      Store.container.classList.add("is-loaded");
    });
  }
  removeListeners() {
    window.removeEventListener("resize", this.resizeCb, { passive: true });
  }
  onResize() {
    this.camera.resize();
    this.renderer.onResize();
  }
  changeLang(lang) {
    Store.lang = lang;
    if (this.model) {
      this.markers.initMarkers(this.model);
    }
  }
  createScreenshot() {
    this.render();
    return this.renderer.domElement.toDataURL();
  }
}
export { Renderer };
